
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3435"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3435"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "ViewTransition", () => $72b03fdf46effee2$export$8cdaa4703948c5e9, (v) => $72b03fdf46effee2$export$8cdaa4703948c5e9 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "addTransitionType", () => $72b03fdf46effee2$export$87c99536b1b8cdd8, (v) => $72b03fdf46effee2$export$87c99536b1b8cdd8 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$8cdaa4703948c5e9;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$87c99536b1b8cdd8;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$startTransition(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
}
function $72b03fdf46effee2$var$addTransitionType(type) {
    var transition = $72b03fdf46effee2$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $72b03fdf46effee2$var$startTransition($72b03fdf46effee2$var$addTransitionType.bind(null, type));
}
var $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$8cdaa4703948c5e9 = $72b03fdf46effee2$var$REACT_VIEW_TRANSITION_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$87c99536b1b8cdd8 = $72b03fdf46effee2$var$addTransitionType;
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = $72b03fdf46effee2$var$startTransition;
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.3.0";

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $dca0ddb82b882518$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $dca0ddb82b882518$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(559));
    }
}
var $dca0ddb82b882518$var$searchTarget = null, $dca0ddb82b882518$var$searchBoundary = null;
function $dca0ddb82b882518$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($dca0ddb82b882518$var$searchTarget = child, !0) : !1;
}
function $dca0ddb82b882518$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($dca0ddb82b882518$var$searchBoundary = child, !1) : child === target ? (null !== $dca0ddb82b882518$var$searchBoundary && ($dca0ddb82b882518$var$searchTarget = child), !0) : !1;
}
function $dca0ddb82b882518$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $dca0ddb82b882518$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $dca0ddb82b882518$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($dca0ddb82b882518$var$HostTransitionContext._currentValue = stateHook.memoizedState, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber));
    stateHook = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalLoadPendingKey = "__reactLoad$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
function $dca0ddb82b882518$var$clearPendingLoadOnNode(node) {
    node[$dca0ddb82b882518$var$internalLoadPendingKey] = void 0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
function $dca0ddb82b882518$var$pushMutationContext() {
    var prev = $dca0ddb82b882518$var$viewTransitionMutationContext;
    $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
    return prev;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(element.value)) : $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $dca0ddb82b882518$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName), $dca0ddb82b882518$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$SubmitEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    submitter: 0
}), $dca0ddb82b882518$var$SyntheticSubmitEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$SubmitEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_474) {
            var $dca0ddb82b882518$var$element$jscomp$inline_475 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_474 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_475.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 = $dca0ddb82b882518$var$isSupported$jscomp$inline_474;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$globalClientIdCounter$1 = 0;
function $dca0ddb82b882518$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $dca0ddb82b882518$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $dca0ddb82b882518$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $dca0ddb82b882518$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $dca0ddb82b882518$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $dca0ddb82b882518$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $dca0ddb82b882518$var$getClassNameByType(defaultClass);
    eventClass = $dca0ddb82b882518$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $dca0ddb82b882518$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_LEGACY_HIDDEN_TYPE:
        case $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $dca0ddb82b882518$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $dca0ddb82b882518$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $dca0ddb82b882518$var$entangledTransitionTypes = null;
function $dca0ddb82b882518$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && ($dca0ddb82b882518$var$entangledTransitionTypes = null, null !== $dca0ddb82b882518$var$currentEntangledListeners)) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    if (null !== $dca0ddb82b882518$var$entangledTransitionTypes) for(var root$28 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$28;)$dca0ddb82b882518$var$queueTransitionTypes(root$28, $dca0ddb82b882518$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$29;)$dca0ddb82b882518$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $dca0ddb82b882518$var$currentEntangledLane) {
            root$29 = $dca0ddb82b882518$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $dca0ddb82b882518$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $dca0ddb82b882518$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushSuspenseListContext(fiber, newContext) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newContext);
}
function $dca0ddb82b882518$var$popSuspenseListContext(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
}
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && 0 !== ($dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1);
    $dca0ddb82b882518$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$70);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 106) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$73 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$73, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffectEvent: $dca0ddb82b882518$var$throwInvalidHookError
}, $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh,
    useEffectEvent: $dca0ddb82b882518$var$updateEvent
}, $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh,
    useEffectEvent: $dca0ddb82b882518$var$updateEvent
};
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack());
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            if (null === $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) {
                nextProps = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
                $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $dca0ddb82b882518$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $dca0ddb82b882518$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $dca0ddb82b882518$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER;
        return $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
    }
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($dca0ddb82b882518$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $dca0ddb82b882518$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($dca0ddb82b882518$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $dca0ddb82b882518$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
        $dca0ddb82b882518$var$isSuspenseInstancePending(suspenseInstance) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($dca0ddb82b882518$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(suspenseInstance.nextSibling);
    $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
    $dca0ddb82b882518$var$isHydrating = !0;
    $dca0ddb82b882518$var$hydrationErrors = null;
    $dca0ddb82b882518$var$rootOrSingletonContext = !1;
    null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $dca0ddb82b882518$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($dca0ddb82b882518$var$reverseChildren(current), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $dca0ddb82b882518$var$reverseChildren(current)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $dca0ddb82b882518$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $dca0ddb82b882518$var$reverseChildren(workInProgress));
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $dca0ddb82b882518$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $dca0ddb82b882518$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (workInProgress.stateNode = $dca0ddb82b882518$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$markRef(current, workInProgress), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $dca0ddb82b882518$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $dca0ddb82b882518$var$markRef(current, workInProgress), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $dca0ddb82b882518$var$maySuspendCommit(type, newProps) : $dca0ddb82b882518$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $dca0ddb82b882518$var$now();
                current.sibling = null;
                nextResource = $dca0ddb82b882518$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, workInProgress), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, renderLanes), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = workInProgress));
                $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $dca0ddb82b882518$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $dca0ddb82b882518$var$FragmentInstance(current);
                        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $dca0ddb82b882518$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$dca0ddb82b882518$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $dca0ddb82b882518$var$isFragmentInstanceParent(parent) && $dca0ddb82b882518$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $dca0ddb82b882518$var$isFragmentInstanceParent(parent) && $dca0ddb82b882518$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $dca0ddb82b882518$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1)), $dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$shouldStartViewTransition = !1, $dca0ddb82b882518$var$appearingViewTransitions = null;
function $dca0ddb82b882518$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $dca0ddb82b882518$var$shouldStartViewTransition = !0;
}
var $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
function $dca0ddb82b882518$var$pushViewTransitionCancelableScope() {
    var prevChildren = $dca0ddb82b882518$var$viewTransitionCancelableChildren;
    $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
function $dca0ddb82b882518$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
    return $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $dca0ddb82b882518$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $dca0ddb82b882518$var$measureInstance(instance).view && (inViewport = !0);
            $dca0ddb82b882518$var$shouldStartViewTransition = !0;
            $dca0ddb82b882518$var$applyViewTransitionName(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? name : name + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, className);
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $dca0ddb82b882518$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $dca0ddb82b882518$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, state), className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $dca0ddb82b882518$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $dca0ddb82b882518$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$dca0ddb82b882518$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement);
}
function $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $dca0ddb82b882518$var$appearingViewTransitions && 0 !== $dca0ddb82b882518$var$appearingViewTransitions.size) {
        var pairs = $dca0ddb82b882518$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $dca0ddb82b882518$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $dca0ddb82b882518$var$appearingViewTransitions ? $dca0ddb82b882518$var$appearingViewTransitions.get(name) : void 0, className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $dca0ddb82b882518$var$appearingViewTransitions.delete(name), $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onExit) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $dca0ddb82b882518$var$appearingViewTransitions && $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$dca0ddb82b882518$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $dca0ddb82b882518$var$appearingViewTransitions && $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
}
function $dca0ddb82b882518$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, changedParent.stateNode);
            props = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $dca0ddb82b882518$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $dca0ddb82b882518$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $dca0ddb82b882518$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $dca0ddb82b882518$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $dca0ddb82b882518$var$restorePairedViewTransitions(fiber);
}
function $dca0ddb82b882518$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $dca0ddb82b882518$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$dca0ddb82b882518$var$viewTransitionHostInstanceIdx], nextMeasurement = $dca0ddb82b882518$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $dca0ddb82b882518$var$applyViewTransitionName(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $dca0ddb82b882518$var$viewTransitionCancelableChildren && ($dca0ddb82b882518$var$viewTransitionCancelableChildren = []), $dca0ddb82b882518$var$viewTransitionCancelableChildren.push(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $dca0ddb82b882518$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $dca0ddb82b882518$var$getViewTransitionName(props, state), className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($dca0ddb82b882518$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
            name = $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $dca0ddb82b882518$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$offscreenDirectParentIsHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null, $dca0ddb82b882518$var$viewTransitionContextChanged = !1, $dca0ddb82b882518$var$inUpdateViewTransition = !1, $dca0ddb82b882518$var$rootViewTransitionAffected = !1, $dca0ddb82b882518$var$rootViewTransitionNameCanceled = !1;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $dca0ddb82b882518$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $dca0ddb82b882518$var$nextEffect;){
        root = $dca0ddb82b882518$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $dca0ddb82b882518$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $dca0ddb82b882518$var$trackEnterViewTransitions(root), $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $dca0ddb82b882518$var$commitExitViewTransitions(JSCompiler_temp);
                    $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $dca0ddb82b882518$var$trackEnterViewTransitions(root);
                    $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $dca0ddb82b882518$var$nextEffect = JSCompiler_temp) : (committedLanes && $dca0ddb82b882518$var$commitNestedViewTransitions(root), $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $dca0ddb82b882518$var$appearingViewTransitions = null;
}
function $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $dca0ddb82b882518$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $dca0ddb82b882518$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $dca0ddb82b882518$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $dca0ddb82b882518$var$nextEffect = current;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = fiber.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                current = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = current;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $dca0ddb82b882518$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $dca0ddb82b882518$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $dca0ddb82b882518$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$dca0ddb82b882518$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($dca0ddb82b882518$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $dca0ddb82b882518$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$dca0ddb82b882518$var$internalHoistableMarker] || current[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            current[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                            $dca0ddb82b882518$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                    $dca0ddb82b882518$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = !1;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = ii;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(root, ""), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
            $dca0ddb82b882518$var$tagCaches = null;
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$currentHoistableRoot = ii;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            current = $dca0ddb82b882518$var$pushMutationContext();
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = ii;
            $dca0ddb82b882518$var$viewTransitionMutationContext && $dca0ddb82b882518$var$inUpdateViewTransition && ($dca0ddb82b882518$var$rootViewTransitionAffected = !0);
            $dca0ddb82b882518$var$viewTransitionMutationContext = current;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $dca0ddb82b882518$var$offscreenSubtreeWasHidden, lanes = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, current = $dca0ddb82b882518$var$offscreenSubtreeWasHidden, $dca0ddb82b882518$var$offscreenSubtreeIsHidden = ii || $dca0ddb82b882518$var$offscreenSubtreeIsHidden, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = root, $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $dca0ddb82b882518$var$offscreenSubtreeIsHidden = lanes, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = current), !ii && $dca0ddb82b882518$var$offscreenDirectParentIsHidden || $dca0ddb82b882518$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags = $dca0ddb82b882518$var$pushMutationContext();
            ii = $dca0ddb82b882518$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $dca0ddb82b882518$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $dca0ddb82b882518$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $dca0ddb82b882518$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $dca0ddb82b882518$var$inUpdateViewTransition = ii;
            $dca0ddb82b882518$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($dca0ddb82b882518$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $dca0ddb82b882518$var$_enabled = !0, fiber.reset(), $dca0ddb82b882518$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $dca0ddb82b882518$var$measureNestedViewTransitions(parentFiber, !1);
}
function $dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $dca0ddb82b882518$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $dca0ddb82b882518$var$rootViewTransitionNameCanceled = $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$pushViewTransitionCancelableScope();
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$dca0ddb82b882518$var$viewTransitionContextChanged && !$dca0ddb82b882518$var$rootViewTransitionAffected) {
                finishedWork = $dca0ddb82b882518$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $dca0ddb82b882518$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $dca0ddb82b882518$var$rootViewTransitionNameCanceled = !0;
            }
            $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $dca0ddb82b882518$var$viewTransitionContextChanged;
            $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$viewTransitionContextChanged && ($dca0ddb82b882518$var$rootViewTransitionAffected = !0);
            $dca0ddb82b882518$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $dca0ddb82b882518$var$commitEnterViewTransitions(finishedWork, !1) : $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $dca0ddb82b882518$var$viewTransitionContextChanged;
            oldName = $dca0ddb82b882518$var$pushViewTransitionCancelableScope();
            $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $dca0ddb82b882518$var$getViewTransitionName(props, state);
            state = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, state);
            var className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0, root = $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $dca0ddb82b882518$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($dca0ddb82b882518$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $dca0ddb82b882518$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $dca0ddb82b882518$var$viewTransitionCancelableChildren), $dca0ddb82b882518$var$viewTransitionCancelableChildren = oldName);
            $dca0ddb82b882518$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable($dca0ddb82b882518$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $dca0ddb82b882518$var$restoreNestedViewTransitions(parentFiber);
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $dca0ddb82b882518$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $dca0ddb82b882518$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(flags.child, !0), $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $dca0ddb82b882518$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $dca0ddb82b882518$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $dca0ddb82b882518$var$appearingViewTransitions && ($dca0ddb82b882518$var$appearingViewTransitions = new Map());
                $dca0ddb82b882518$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$pendingViewTransition = null, $dca0ddb82b882518$var$pendingViewTransitionEvents = null, $dca0ddb82b882518$var$pendingTransitionTypes = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $dca0ddb82b882518$var$createViewTransitionInstance($dca0ddb82b882518$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $dca0ddb82b882518$var$pendingViewTransitionEvents && ($dca0ddb82b882518$var$pendingViewTransitionEvents = []);
        $dca0ddb82b882518$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$completeRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        }, $dca0ddb82b882518$var$appearingViewTransitions = null, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $dca0ddb82b882518$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0, subtreeFlags = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($dca0ddb82b882518$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $dca0ddb82b882518$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$getEntangledLanes(root, lanes);
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $dca0ddb82b882518$var$hydrationParentFiber && ($dca0ddb82b882518$var$isHydrating ? ($dca0ddb82b882518$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($dca0ddb82b882518$var$nextHydratableInstance = fiber.stateNode)) : ($dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0));
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
    $dca0ddb82b882518$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $dca0ddb82b882518$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($dca0ddb82b882518$var$pendingTransitionTypes = $dca0ddb82b882518$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($dca0ddb82b882518$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
        $dca0ddb82b882518$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $dca0ddb82b882518$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $dca0ddb82b882518$var$ReactSharedInternals.T;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        updatedLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        try {
            $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $dca0ddb82b882518$var$executionContext = suspendedRetryLanes, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = updatedLanes, $dca0ddb82b882518$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $dca0ddb82b882518$var$pendingEffectsStatus = 1;
    $dca0ddb82b882518$var$shouldStartViewTransition ? $dca0ddb82b882518$var$pendingViewTransition = $dca0ddb82b882518$var$startViewTransition(suspendedState, root.containerInfo, $dca0ddb82b882518$var$pendingTransitionTypes, $dca0ddb82b882518$var$flushMutationEffects, $dca0ddb82b882518$var$flushLayoutEffects, $dca0ddb82b882518$var$flushAfterMutationEffects, $dca0ddb82b882518$var$flushSpawnedWork, $dca0ddb82b882518$var$flushPassiveEffects, $dca0ddb82b882518$var$reportViewTransitionError, null, null) : ($dca0ddb82b882518$var$flushMutationEffects(), $dca0ddb82b882518$var$flushLayoutEffects(), $dca0ddb82b882518$var$flushSpawnedWork());
}
function $dca0ddb82b882518$var$reportViewTransitionError(error) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus) {
        var onRecoverableError = $dca0ddb82b882518$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $dca0ddb82b882518$var$flushAfterMutationEffects() {
    3 === $dca0ddb82b882518$var$pendingEffectsStatus && ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber($dca0ddb82b882518$var$pendingFinishedWork, $dca0ddb82b882518$var$pendingEffectsRoot), $dca0ddb82b882518$var$pendingEffectsStatus = 4);
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$inUpdateViewTransition = $dca0ddb82b882518$var$rootViewTransitionAffected = !1;
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $dca0ddb82b882518$var$selectionInformation;
                var curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var committedViewTransition = $dca0ddb82b882518$var$pendingViewTransition;
        $dca0ddb82b882518$var$pendingViewTransition = null;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            passiveSubtreeMask = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $dca0ddb82b882518$var$pendingViewTransitionEvents;
        onRecoverableError = $dca0ddb82b882518$var$pendingTransitionTypes;
        $dca0ddb82b882518$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($dca0ddb82b882518$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null);
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    null !== $dca0ddb82b882518$var$pendingViewTransition && ($dca0ddb82b882518$var$pendingViewTransition.skipTransition(), $dca0ddb82b882518$var$pendingViewTransition = null);
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) ? $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$190, root$190 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL(actionProp);
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1667 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1667 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1667++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1668 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1667], $dca0ddb82b882518$var$domEventName$jscomp$inline_1669 = $dca0ddb82b882518$var$eventName$jscomp$inline_1668.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1670 = $dca0ddb82b882518$var$eventName$jscomp$inline_1668[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1668.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1669, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1670);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $dca0ddb82b882518$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $dca0ddb82b882518$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $dca0ddb82b882518$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $dca0ddb82b882518$var$getParent) : null;
                        null !== reactName && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            return;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $dca0ddb82b882518$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $dca0ddb82b882518$var$emptyProps = {};
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$dca0ddb82b882518$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$dca0ddb82b882518$var$internalPropsKey] = props;
    $dca0ddb82b882518$var$setInitialProperties(rootContainerInstance, type, props);
    $dca0ddb82b882518$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $dca0ddb82b882518$var$scheduleTimeout, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $dca0ddb82b882518$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $dca0ddb82b882518$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $dca0ddb82b882518$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $dca0ddb82b882518$var$createMeasurement(rect, computedStyle, instance);
}
function $dca0ddb82b882518$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $dca0ddb82b882518$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $dca0ddb82b882518$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $dca0ddb82b882518$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $dca0ddb82b882518$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($dca0ddb82b882518$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $dca0ddb82b882518$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($dca0ddb82b882518$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $dca0ddb82b882518$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $dca0ddb82b882518$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $dca0ddb82b882518$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("old", name),
        new: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("new", name)
    };
}
function $dca0ddb82b882518$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $dca0ddb82b882518$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $dca0ddb82b882518$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $dca0ddb82b882518$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $dca0ddb82b882518$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $dca0ddb82b882518$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $dca0ddb82b882518$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $dca0ddb82b882518$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $dca0ddb82b882518$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $dca0ddb82b882518$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $dca0ddb82b882518$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $dca0ddb82b882518$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $dca0ddb82b882518$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $dca0ddb82b882518$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$dca0ddb82b882518$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $dca0ddb82b882518$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $dca0ddb82b882518$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(fiber);
    return $dca0ddb82b882518$var$setFocusIfFocusable(fiber, focusOptions);
}
$dca0ddb82b882518$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$dca0ddb82b882518$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $dca0ddb82b882518$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $dca0ddb82b882518$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$observeChild, observer, void 0, void 0);
};
function $dca0ddb82b882518$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $dca0ddb82b882518$var$pendingIntersectionUnobserves.length; i++){
            var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $dca0ddb82b882518$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $dca0ddb82b882518$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $dca0ddb82b882518$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $dca0ddb82b882518$var$pendingIntersectionUnobserves = [], $dca0ddb82b882518$var$intersectionUnobserveScheduled = !1;
function $dca0ddb82b882518$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $dca0ddb82b882518$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $dca0ddb82b882518$var$intersectionUnobserveScheduled || ($dca0ddb82b882518$var$intersectionUnobserveScheduled = !0, $dca0ddb82b882518$var$requestPostPaintCallback(function() {
        $dca0ddb82b882518$var$intersectionUnobserveScheduled = !1;
        var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves;
        $dca0ddb82b882518$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$dca0ddb82b882518$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $dca0ddb82b882518$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$dca0ddb82b882518$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($dca0ddb82b882518$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $dca0ddb82b882518$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(children[0]);
    result = $dca0ddb82b882518$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $dca0ddb82b882518$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $dca0ddb82b882518$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $dca0ddb82b882518$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $dca0ddb82b882518$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $dca0ddb82b882518$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $dca0ddb82b882518$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $dca0ddb82b882518$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $dca0ddb82b882518$var$searchTarget, $dca0ddb82b882518$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $dca0ddb82b882518$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $dca0ddb82b882518$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $dca0ddb82b882518$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $dca0ddb82b882518$var$searchTarget, $dca0ddb82b882518$var$searchBoundary = $dca0ddb82b882518$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $dca0ddb82b882518$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$dca0ddb82b882518$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(566));
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $dca0ddb82b882518$var$getInstanceFromHostFiber(hostSiblings);
            $dca0ddb82b882518$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $dca0ddb82b882518$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child), $dca0ddb82b882518$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $dca0ddb82b882518$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $dca0ddb82b882518$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    $dca0ddb82b882518$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $dca0ddb82b882518$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $dca0ddb82b882518$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $dca0ddb82b882518$var$pendingIntersectionUnobserves.length; i++){
            var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $dca0ddb82b882518$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $dca0ddb82b882518$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $dca0ddb82b882518$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $dca0ddb82b882518$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $dca0ddb82b882518$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $dca0ddb82b882518$var$requestPostPaintCallback(callback) {
    $dca0ddb82b882518$var$localRequestAnimationFrame(function() {
        $dca0ddb82b882518$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $dca0ddb82b882518$var$setProp(instance, type, propKey, null, $dca0ddb82b882518$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $dca0ddb82b882518$var$noop$1 && (instance.onclick = null);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
function $dca0ddb82b882518$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!($dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$dca0ddb82b882518$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $dca0ddb82b882518$var$clearPendingLoadOnNode(instance);
            });
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), currentProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$268 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $dca0ddb82b882518$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, styles$268)), $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), currentProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$dca0ddb82b882518$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$dca0ddb82b882518$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $dca0ddb82b882518$var$clearPendingLoadOnNode.bind(null, key), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $dca0ddb82b882518$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$274)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $dca0ddb82b882518$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $dca0ddb82b882518$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $dca0ddb82b882518$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    $dca0ddb82b882518$var$checkIfFullyUnsuspended(this);
}
function $dca0ddb82b882518$var$onUnsuspendImg() {
    this.imgCount--;
    $dca0ddb82b882518$var$checkIfFullyUnsuspended(this);
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $acw62.version;
if ("19.3.0" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.0"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.3.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2587.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2587.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2587.inject($dca0ddb82b882518$var$internals$jscomp$inline_2586), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.3.0";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "browser", () => $4433d39f12c5883f$export$3f2684e5d7cb1006, (v) => $4433d39f12c5883f$export$3f2684e5d7cb1006 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$3f2684e5d7cb1006;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $4433d39f12c5883f$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY ? $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.3.0";

});



var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));


/**
 * React Router DOM v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * @remix-run/router v1.23.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    return $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1d34d5c4a288b213$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $1d34d5c4a288b213$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $1d34d5c4a288b213$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>$1d34d5c4a288b213$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $1d34d5c4a288b213$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    return $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7939e29d663dd3ed$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    return $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $040dbb9c344a508d$var$_extends.apply(null, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


// ─────────────────────────────────────────────────────────────────────────────
// @parsina/ui — the unified Parsina UI kit for all three web clients
// (doctor, clinic, patient).
//
// Canonical copy: /packages/ui (monorepo root). Each client app receives a
// synced copy at src/shared/ui via `python dev/sync_shared.py` — edit HERE,
// never in the synced copies.
//
// Import everything from the barrel:
//   import { Button, TextInput, useToast } from '@parsina/ui';
// Design tokens live in the sibling package:
//   import { C, CT, statusColors } from '@parsina/tokens';
// ─────────────────────────────────────────────────────────────────────────────
// Form primitives

var $acw62 = parcelRequire("acw62");
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


var $85fc2fe65ff21506$exports = {};
'use strict';
Object.defineProperty($85fc2fe65ff21506$exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Concatenates two arrays faster than the array spread operator.
 */ const $85fc2fe65ff21506$var$concatArrays = (array1, array2)=>{
    // Pre-allocate for better V8 optimization
    const combinedArray = new Array(array1.length + array2.length);
    for(let i = 0; i < array1.length; i++)combinedArray[i] = array1[i];
    for(let i = 0; i < array2.length; i++)combinedArray[array1.length + i] = array2[i];
    return combinedArray;
};
// Factory function ensures consistent object shapes
const $85fc2fe65ff21506$var$createClassValidatorObject = (classGroupId, validator)=>({
        classGroupId: classGroupId,
        validator: validator
    });
// Factory ensures consistent ClassPartObject shape
const $85fc2fe65ff21506$var$createClassPartObject = (nextPart = new Map(), validators = null, classGroupId)=>({
        nextPart: nextPart,
        validators: validators,
        classGroupId: classGroupId
    });
const $85fc2fe65ff21506$var$CLASS_PART_SEPARATOR = '-';
const $85fc2fe65ff21506$var$EMPTY_CONFLICTS = [];
// I use two dots here because one dot is used as prefix for class groups in plugins
const $85fc2fe65ff21506$var$ARBITRARY_PROPERTY_PREFIX = 'arbitrary..';
const $85fc2fe65ff21506$var$createClassGroupUtils = (config)=>{
    const classMap = $85fc2fe65ff21506$var$createClassMap(config);
    const { conflictingClassGroups: conflictingClassGroups, conflictingClassGroupModifiers: conflictingClassGroupModifiers } = config;
    const getClassGroupId = (className)=>{
        if (className.startsWith('[') && className.endsWith(']')) return $85fc2fe65ff21506$var$getGroupIdForArbitraryProperty(className);
        const classParts = className.split($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and skip it.
        const startIndex = classParts[0] === '' && classParts.length > 1 ? 1 : 0;
        return $85fc2fe65ff21506$var$getGroupRecursive(classParts, startIndex, classMap);
    };
    const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier)=>{
        if (hasPostfixModifier) {
            const modifierConflicts = conflictingClassGroupModifiers[classGroupId];
            const baseConflicts = conflictingClassGroups[classGroupId];
            if (modifierConflicts) {
                if (baseConflicts) // Merge base conflicts with modifier conflicts
                return $85fc2fe65ff21506$var$concatArrays(baseConflicts, modifierConflicts);
                // Only modifier conflicts
                return modifierConflicts;
            }
            // Fall back to without postfix if no modifier conflicts
            return baseConflicts || $85fc2fe65ff21506$var$EMPTY_CONFLICTS;
        }
        return conflictingClassGroups[classGroupId] || $85fc2fe65ff21506$var$EMPTY_CONFLICTS;
    };
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
};
const $85fc2fe65ff21506$var$getGroupRecursive = (classParts, startIndex, classPartObject)=>{
    const classPathsLength = classParts.length - startIndex;
    if (classPathsLength === 0) return classPartObject.classGroupId;
    const currentClassPart = classParts[startIndex];
    const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    if (nextClassPartObject) {
        const result = $85fc2fe65ff21506$var$getGroupRecursive(classParts, startIndex + 1, nextClassPartObject);
        if (result) return result;
    }
    const validators = classPartObject.validators;
    if (validators === null) return undefined;
    // Build classRest string efficiently by joining from startIndex onwards
    const classRest = startIndex === 0 ? classParts.join($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR) : classParts.slice(startIndex).join($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
    const validatorsLength = validators.length;
    for(let i = 0; i < validatorsLength; i++){
        const validatorObj = validators[i];
        if (validatorObj.validator(classRest)) return validatorObj.classGroupId;
    }
    return undefined;
};
/**
 * Get the class group ID for an arbitrary property.
 *
 * @param className - The class name to get the group ID for. Is expected to be string starting with `[` and ending with `]`.
 */ const $85fc2fe65ff21506$var$getGroupIdForArbitraryProperty = (className)=>className.slice(1, -1).indexOf(':') === -1 ? undefined : (()=>{
        const content = className.slice(1, -1);
        const colonIndex = content.indexOf(':');
        const property = content.slice(0, colonIndex);
        return property ? $85fc2fe65ff21506$var$ARBITRARY_PROPERTY_PREFIX + property : undefined;
    })();
/**
 * Exported for testing only
 */ const $85fc2fe65ff21506$var$createClassMap = (config)=>{
    const { theme: theme, classGroups: classGroups } = config;
    return $85fc2fe65ff21506$var$processClassGroups(classGroups, theme);
};
// Split into separate functions to maintain monomorphic call sites
const $85fc2fe65ff21506$var$processClassGroups = (classGroups, theme)=>{
    const classMap = $85fc2fe65ff21506$var$createClassPartObject();
    for(const classGroupId in classGroups){
        const group = classGroups[classGroupId];
        $85fc2fe65ff21506$var$processClassesRecursively(group, classMap, classGroupId, theme);
    }
    return classMap;
};
const $85fc2fe65ff21506$var$processClassesRecursively = (classGroup, classPartObject, classGroupId, theme)=>{
    const len = classGroup.length;
    for(let i = 0; i < len; i++){
        const classDefinition = classGroup[i];
        $85fc2fe65ff21506$var$processClassDefinition(classDefinition, classPartObject, classGroupId, theme);
    }
};
// Split into separate functions for each type to maintain monomorphic call sites
const $85fc2fe65ff21506$var$processClassDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    if (typeof classDefinition === 'string') {
        $85fc2fe65ff21506$var$processStringDefinition(classDefinition, classPartObject, classGroupId);
        return;
    }
    if (typeof classDefinition === 'function') {
        $85fc2fe65ff21506$var$processFunctionDefinition(classDefinition, classPartObject, classGroupId, theme);
        return;
    }
    $85fc2fe65ff21506$var$processObjectDefinition(classDefinition, classPartObject, classGroupId, theme);
};
const $85fc2fe65ff21506$var$processStringDefinition = (classDefinition, classPartObject, classGroupId)=>{
    const classPartObjectToEdit = classDefinition === '' ? classPartObject : $85fc2fe65ff21506$var$getPart(classPartObject, classDefinition);
    classPartObjectToEdit.classGroupId = classGroupId;
};
const $85fc2fe65ff21506$var$processFunctionDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    if ($85fc2fe65ff21506$var$isThemeGetter(classDefinition)) {
        $85fc2fe65ff21506$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
    }
    if (classPartObject.validators === null) classPartObject.validators = [];
    classPartObject.validators.push($85fc2fe65ff21506$var$createClassValidatorObject(classGroupId, classDefinition));
};
const $85fc2fe65ff21506$var$processObjectDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    const entries = Object.entries(classDefinition);
    const len = entries.length;
    for(let i = 0; i < len; i++){
        const [key, value] = entries[i];
        $85fc2fe65ff21506$var$processClassesRecursively(value, $85fc2fe65ff21506$var$getPart(classPartObject, key), classGroupId, theme);
    }
};
const $85fc2fe65ff21506$var$getPart = (classPartObject, path)=>{
    let current = classPartObject;
    const parts = path.split($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
    const len = parts.length;
    for(let i = 0; i < len; i++){
        const part = parts[i];
        let next = current.nextPart.get(part);
        if (!next) {
            next = $85fc2fe65ff21506$var$createClassPartObject();
            current.nextPart.set(part, next);
        }
        current = next;
    }
    return current;
};
// Type guard maintains monomorphic check
const $85fc2fe65ff21506$var$isThemeGetter = (func)=>'isThemeGetter' in func && func.isThemeGetter === true;
// LRU cache implementation using plain objects for simplicity
const $85fc2fe65ff21506$var$createLruCache = (maxCacheSize)=>{
    if (maxCacheSize < 1) return {
        get: ()=>undefined,
        set: ()=>{}
    };
    let cacheSize = 0;
    let cache = Object.create(null);
    let previousCache = Object.create(null);
    const update = (key, value)=>{
        cache[key] = value;
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = Object.create(null);
        }
    };
    return {
        get (key) {
            let value = cache[key];
            if (value !== undefined) return value;
            if ((value = previousCache[key]) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set (key, value) {
            if (key in cache) cache[key] = value;
            else update(key, value);
        }
    };
};
const $85fc2fe65ff21506$var$IMPORTANT_MODIFIER = '!';
const $85fc2fe65ff21506$var$MODIFIER_SEPARATOR = ':';
const $85fc2fe65ff21506$var$EMPTY_MODIFIERS = [];
// Pre-allocated result object shape for consistency
const $85fc2fe65ff21506$var$createResultObject = (modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition, isExternal)=>({
        modifiers: modifiers,
        hasImportantModifier: hasImportantModifier,
        baseClassName: baseClassName,
        maybePostfixModifierPosition: maybePostfixModifierPosition,
        isExternal: isExternal
    });
const $85fc2fe65ff21506$var$createParseClassName = (config)=>{
    const { prefix: prefix, experimentalParseClassName: experimentalParseClassName } = config;
    /**
   * Parse class name into parts.
   *
   * Inspired by `splitAtTopLevelOnly` used in Tailwind CSS
   * @see https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
   */ let parseClassName = (className)=>{
        // Use simple array with push for better performance
        const modifiers = [];
        let bracketDepth = 0;
        let parenDepth = 0;
        let modifierStart = 0;
        let postfixModifierPosition;
        const len = className.length;
        for(let index = 0; index < len; index++){
            const currentCharacter = className[index];
            if (bracketDepth === 0 && parenDepth === 0) {
                if (currentCharacter === $85fc2fe65ff21506$var$MODIFIER_SEPARATOR) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + 1;
                    continue;
                }
                if (currentCharacter === '/') {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === '[') bracketDepth++;
            else if (currentCharacter === ']') bracketDepth--;
            else if (currentCharacter === '(') parenDepth++;
            else if (currentCharacter === ')') parenDepth--;
        }
        const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.slice(modifierStart);
        // Inline important modifier check
        let baseClassName = baseClassNameWithImportantModifier;
        let hasImportantModifier = false;
        if (baseClassNameWithImportantModifier.endsWith($85fc2fe65ff21506$var$IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(0, -1);
            hasImportantModifier = true;
        } else if (/**
     * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
     * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
     */ baseClassNameWithImportantModifier.startsWith($85fc2fe65ff21506$var$IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(1);
            hasImportantModifier = true;
        }
        const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return $85fc2fe65ff21506$var$createResultObject(modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition);
    };
    if (prefix) {
        const fullPrefix = prefix + $85fc2fe65ff21506$var$MODIFIER_SEPARATOR;
        const parseClassNameOriginal = parseClassName;
        parseClassName = (className)=>className.startsWith(fullPrefix) ? parseClassNameOriginal(className.slice(fullPrefix.length)) : $85fc2fe65ff21506$var$createResultObject($85fc2fe65ff21506$var$EMPTY_MODIFIERS, false, className, undefined, true);
    }
    if (experimentalParseClassName) {
        const parseClassNameOriginal = parseClassName;
        parseClassName = (className)=>experimentalParseClassName({
                className: className,
                parseClassName: parseClassNameOriginal
            });
    }
    return parseClassName;
};
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ const $85fc2fe65ff21506$var$createSortModifiers = (config)=>{
    // Pre-compute weights for all known modifiers for O(1) comparison
    const modifierWeights = new Map();
    // Assign weights to sensitive modifiers (highest priority, but preserve order)
    config.orderSensitiveModifiers.forEach((mod, index)=>{
        modifierWeights.set(mod, 1000000 + index); // High weights for sensitive mods
    });
    return (modifiers)=>{
        const result = [];
        let currentSegment = [];
        // Process modifiers in one pass
        for(let i = 0; i < modifiers.length; i++){
            const modifier = modifiers[i];
            // Check if modifier is sensitive (starts with '[' or in orderSensitiveModifiers)
            const isArbitrary = modifier[0] === '[';
            const isOrderSensitive = modifierWeights.has(modifier);
            if (isArbitrary || isOrderSensitive) {
                // Sort and flush current segment alphabetically
                if (currentSegment.length > 0) {
                    currentSegment.sort();
                    result.push(...currentSegment);
                    currentSegment = [];
                }
                result.push(modifier);
            } else // Regular modifier - add to current segment for batch sorting
            currentSegment.push(modifier);
        }
        // Sort and add any remaining segment items
        if (currentSegment.length > 0) {
            currentSegment.sort();
            result.push(...currentSegment);
        }
        return result;
    };
};
const $85fc2fe65ff21506$var$createConfigUtils = (config)=>({
        cache: $85fc2fe65ff21506$var$createLruCache(config.cacheSize),
        parseClassName: $85fc2fe65ff21506$var$createParseClassName(config),
        sortModifiers: $85fc2fe65ff21506$var$createSortModifiers(config),
        postfixLookupClassGroupIds: $85fc2fe65ff21506$var$createPostfixLookupClassGroupIds(config),
        ...$85fc2fe65ff21506$var$createClassGroupUtils(config)
    });
const $85fc2fe65ff21506$var$createPostfixLookupClassGroupIds = (config)=>{
    const lookup = Object.create(null);
    const classGroupIds = config.postfixLookupClassGroups;
    if (classGroupIds) for(let i = 0; i < classGroupIds.length; i++)lookup[classGroupIds[i]] = true;
    return lookup;
};
const $85fc2fe65ff21506$var$SPLIT_CLASSES_REGEX = /\s+/;
const $85fc2fe65ff21506$var$mergeClassList = (classList, configUtils)=>{
    const { parseClassName: parseClassName, getClassGroupId: getClassGroupId, getConflictingClassGroupIds: getConflictingClassGroupIds, sortModifiers: sortModifiers, postfixLookupClassGroupIds: postfixLookupClassGroupIds } = configUtils;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ const classGroupsInConflict = [];
    const classNames = classList.trim().split($85fc2fe65ff21506$var$SPLIT_CLASSES_REGEX);
    let result = '';
    for(let index = classNames.length - 1; index >= 0; index -= 1){
        const originalClassName = classNames[index];
        const { isExternal: isExternal, modifiers: modifiers, hasImportantModifier: hasImportantModifier, baseClassName: baseClassName, maybePostfixModifierPosition: maybePostfixModifierPosition } = parseClassName(originalClassName);
        if (isExternal) {
            result = originalClassName + (result.length > 0 ? ' ' + result : result);
            continue;
        }
        let hasPostfixModifier = !!maybePostfixModifierPosition;
        let classGroupId;
        if (hasPostfixModifier) {
            const baseClassNameWithoutPostfix = baseClassName.substring(0, maybePostfixModifierPosition);
            classGroupId = getClassGroupId(baseClassNameWithoutPostfix);
            const classGroupIdWithPostfix = classGroupId && postfixLookupClassGroupIds[classGroupId] ? getClassGroupId(baseClassName) : undefined;
            if (classGroupIdWithPostfix && classGroupIdWithPostfix !== classGroupId) {
                classGroupId = classGroupIdWithPostfix;
                hasPostfixModifier = false;
            }
        } else classGroupId = getClassGroupId(baseClassName);
        if (!classGroupId) {
            if (!hasPostfixModifier) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            hasPostfixModifier = false;
        }
        // Fast path: skip sorting for empty or single modifier
        const variantModifier = modifiers.length === 0 ? '' : modifiers.length === 1 ? modifiers[0] : sortModifiers(modifiers).join(':');
        const modifierId = hasImportantModifier ? variantModifier + $85fc2fe65ff21506$var$IMPORTANT_MODIFIER : variantModifier;
        const classId = modifierId + classGroupId;
        if (classGroupsInConflict.indexOf(classId) > -1) continue;
        classGroupsInConflict.push(classId);
        const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
        for(let i = 0; i < conflictGroups.length; ++i){
            const group = conflictGroups[i];
            classGroupsInConflict.push(modifierId + group);
        }
        // Tailwind class not in conflict
        result = originalClassName + (result.length > 0 ? ' ' + result : result);
    }
    return result;
};
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ const $85fc2fe65ff21506$var$twJoin = (...classLists)=>{
    let index = 0;
    let argument;
    let resolvedValue;
    let string = '';
    while(index < classLists.length){
        if (argument = classLists[index++]) {
            if (resolvedValue = $85fc2fe65ff21506$var$toValue(argument)) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
const $85fc2fe65ff21506$var$toValue = (mix)=>{
    // Fast path for strings
    if (typeof mix === 'string') return mix;
    let resolvedValue;
    let string = '';
    for(let k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $85fc2fe65ff21506$var$toValue(mix[k])) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
const $85fc2fe65ff21506$var$createTailwindMerge = (createConfigFirst, ...createConfigRest)=>{
    let configUtils;
    let cacheGet;
    let cacheSet;
    let functionToCall;
    const initTailwindMerge = (classList)=>{
        const config = createConfigRest.reduce((previousConfig, createConfigCurrent)=>createConfigCurrent(previousConfig), createConfigFirst());
        configUtils = $85fc2fe65ff21506$var$createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    };
    const tailwindMerge = (classList)=>{
        const cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        const result = $85fc2fe65ff21506$var$mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    };
    functionToCall = initTailwindMerge;
    return (...args)=>functionToCall($85fc2fe65ff21506$var$twJoin(...args));
};
const $85fc2fe65ff21506$var$fallbackThemeArr = [];
const $85fc2fe65ff21506$var$fromTheme = (key)=>{
    const themeGetter = (theme)=>theme[key] || $85fc2fe65ff21506$var$fallbackThemeArr;
    themeGetter.isThemeGetter = true;
    themeGetter.themeKey = key;
    return themeGetter;
};
const $85fc2fe65ff21506$var$arbitraryValueRegex = /^\[(?:(\w[\w-]*):)?(.+)\]$/i;
const $85fc2fe65ff21506$var$arbitraryVariableRegex = /^\((?:(\w[\w-]*):)?(.+)\)$/i;
const $85fc2fe65ff21506$var$fractionRegex = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/;
const $85fc2fe65ff21506$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const $85fc2fe65ff21506$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const $85fc2fe65ff21506$var$colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix|color|light-dark)\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const $85fc2fe65ff21506$var$shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const $85fc2fe65ff21506$var$imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const $85fc2fe65ff21506$var$isFraction = (value)=>$85fc2fe65ff21506$var$fractionRegex.test(value);
const $85fc2fe65ff21506$var$isNumber = (value)=>!!value && !Number.isNaN(Number(value));
const $85fc2fe65ff21506$var$isInteger = (value)=>!!value && Number.isInteger(Number(value));
const $85fc2fe65ff21506$var$isPercent = (value)=>value.endsWith('%') && $85fc2fe65ff21506$var$isNumber(value.slice(0, -1));
const $85fc2fe65ff21506$var$isTshirtSize = (value)=>$85fc2fe65ff21506$var$tshirtUnitRegex.test(value);
const $85fc2fe65ff21506$var$isAny = ()=>true;
const $85fc2fe65ff21506$var$isLengthOnly = (value)=>// `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    $85fc2fe65ff21506$var$lengthUnitRegex.test(value) && !$85fc2fe65ff21506$var$colorFunctionRegex.test(value);
const $85fc2fe65ff21506$var$isNever = ()=>false;
const $85fc2fe65ff21506$var$isShadow = (value)=>$85fc2fe65ff21506$var$shadowRegex.test(value);
const $85fc2fe65ff21506$var$isImage = (value)=>$85fc2fe65ff21506$var$imageRegex.test(value);
const $85fc2fe65ff21506$var$isAnyNonArbitrary = (value)=>!$85fc2fe65ff21506$var$isArbitraryValue(value) && !$85fc2fe65ff21506$var$isArbitraryVariable(value);
const $85fc2fe65ff21506$var$isNamedContainerQuery = (value)=>value.startsWith('@container') && (value[10] === '/' && value[11] !== undefined || value[11] === 's' && value[16] !== undefined && value.startsWith('-size/', 10) || value[11] === 'n' && value[18] !== undefined && value.startsWith('-normal/', 10));
const $85fc2fe65ff21506$var$isArbitrarySize = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelSize, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryValue = (value)=>$85fc2fe65ff21506$var$arbitraryValueRegex.test(value);
const $85fc2fe65ff21506$var$isArbitraryLength = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelLength, $85fc2fe65ff21506$var$isLengthOnly);
const $85fc2fe65ff21506$var$isArbitraryNumber = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelNumber, $85fc2fe65ff21506$var$isNumber);
const $85fc2fe65ff21506$var$isArbitraryWeight = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelWeight, $85fc2fe65ff21506$var$isAny);
const $85fc2fe65ff21506$var$isArbitraryFamilyName = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelFamilyName, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryPosition = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelPosition, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryImage = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelImage, $85fc2fe65ff21506$var$isImage);
const $85fc2fe65ff21506$var$isArbitraryShadow = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelShadow, $85fc2fe65ff21506$var$isShadow);
const $85fc2fe65ff21506$var$isArbitraryVariable = (value)=>$85fc2fe65ff21506$var$arbitraryVariableRegex.test(value);
const $85fc2fe65ff21506$var$isArbitraryVariableLength = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelLength);
const $85fc2fe65ff21506$var$isArbitraryVariableFamilyName = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelFamilyName);
const $85fc2fe65ff21506$var$isArbitraryVariablePosition = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelPosition);
const $85fc2fe65ff21506$var$isArbitraryVariableSize = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelSize);
const $85fc2fe65ff21506$var$isArbitraryVariableImage = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelImage);
const $85fc2fe65ff21506$var$isArbitraryVariableShadow = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelShadow, true);
const $85fc2fe65ff21506$var$isArbitraryVariableWeight = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelWeight, true);
// Helpers
const $85fc2fe65ff21506$var$getIsArbitraryValue = (value, testLabel, testValue)=>{
    const result = $85fc2fe65ff21506$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return testValue(result[2]);
    }
    return false;
};
const $85fc2fe65ff21506$var$getIsArbitraryVariable = (value, testLabel, shouldMatchNoLabel = false)=>{
    const result = $85fc2fe65ff21506$var$arbitraryVariableRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return shouldMatchNoLabel;
    }
    return false;
};
// Labels
const $85fc2fe65ff21506$var$isLabelPosition = (label)=>label === 'position' || label === 'percentage';
const $85fc2fe65ff21506$var$isLabelImage = (label)=>label === 'image' || label === 'url';
const $85fc2fe65ff21506$var$isLabelSize = (label)=>label === 'length' || label === 'size' || label === 'bg-size';
const $85fc2fe65ff21506$var$isLabelLength = (label)=>label === 'length';
const $85fc2fe65ff21506$var$isLabelNumber = (label)=>label === 'number';
const $85fc2fe65ff21506$var$isLabelFamilyName = (label)=>label === 'family-name';
const $85fc2fe65ff21506$var$isLabelWeight = (label)=>label === 'number' || label === 'weight';
const $85fc2fe65ff21506$var$isLabelShadow = (label)=>label === 'shadow';
const $85fc2fe65ff21506$var$validators = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny: $85fc2fe65ff21506$var$isAny,
    isAnyNonArbitrary: $85fc2fe65ff21506$var$isAnyNonArbitrary,
    isArbitraryFamilyName: $85fc2fe65ff21506$var$isArbitraryFamilyName,
    isArbitraryImage: $85fc2fe65ff21506$var$isArbitraryImage,
    isArbitraryLength: $85fc2fe65ff21506$var$isArbitraryLength,
    isArbitraryNumber: $85fc2fe65ff21506$var$isArbitraryNumber,
    isArbitraryPosition: $85fc2fe65ff21506$var$isArbitraryPosition,
    isArbitraryShadow: $85fc2fe65ff21506$var$isArbitraryShadow,
    isArbitrarySize: $85fc2fe65ff21506$var$isArbitrarySize,
    isArbitraryValue: $85fc2fe65ff21506$var$isArbitraryValue,
    isArbitraryVariable: $85fc2fe65ff21506$var$isArbitraryVariable,
    isArbitraryVariableFamilyName: $85fc2fe65ff21506$var$isArbitraryVariableFamilyName,
    isArbitraryVariableImage: $85fc2fe65ff21506$var$isArbitraryVariableImage,
    isArbitraryVariableLength: $85fc2fe65ff21506$var$isArbitraryVariableLength,
    isArbitraryVariablePosition: $85fc2fe65ff21506$var$isArbitraryVariablePosition,
    isArbitraryVariableShadow: $85fc2fe65ff21506$var$isArbitraryVariableShadow,
    isArbitraryVariableSize: $85fc2fe65ff21506$var$isArbitraryVariableSize,
    isArbitraryVariableWeight: $85fc2fe65ff21506$var$isArbitraryVariableWeight,
    isArbitraryWeight: $85fc2fe65ff21506$var$isArbitraryWeight,
    isFraction: $85fc2fe65ff21506$var$isFraction,
    isInteger: $85fc2fe65ff21506$var$isInteger,
    isNamedContainerQuery: $85fc2fe65ff21506$var$isNamedContainerQuery,
    isNumber: $85fc2fe65ff21506$var$isNumber,
    isPercent: $85fc2fe65ff21506$var$isPercent,
    isTshirtSize: $85fc2fe65ff21506$var$isTshirtSize
}, Symbol.toStringTag, {
    value: 'Module'
});
const $85fc2fe65ff21506$var$getDefaultConfig = ()=>{
    /**
   * Theme getters for theme variable namespaces
   * @see https://tailwindcss.com/docs/theme#theme-variable-namespaces
   */ /***/ const themeColor = $85fc2fe65ff21506$var$fromTheme('color');
    const themeFont = $85fc2fe65ff21506$var$fromTheme('font');
    const themeText = $85fc2fe65ff21506$var$fromTheme('text');
    const themeFontWeight = $85fc2fe65ff21506$var$fromTheme('font-weight');
    const themeTracking = $85fc2fe65ff21506$var$fromTheme('tracking');
    const themeLeading = $85fc2fe65ff21506$var$fromTheme('leading');
    const themeBreakpoint = $85fc2fe65ff21506$var$fromTheme('breakpoint');
    const themeContainer = $85fc2fe65ff21506$var$fromTheme('container');
    const themeSpacing = $85fc2fe65ff21506$var$fromTheme('spacing');
    const themeRadius = $85fc2fe65ff21506$var$fromTheme('radius');
    const themeShadow = $85fc2fe65ff21506$var$fromTheme('shadow');
    const themeInsetShadow = $85fc2fe65ff21506$var$fromTheme('inset-shadow');
    const themeTextShadow = $85fc2fe65ff21506$var$fromTheme('text-shadow');
    const themeDropShadow = $85fc2fe65ff21506$var$fromTheme('drop-shadow');
    const themeBlur = $85fc2fe65ff21506$var$fromTheme('blur');
    const themePerspective = $85fc2fe65ff21506$var$fromTheme('perspective');
    const themeAspect = $85fc2fe65ff21506$var$fromTheme('aspect');
    const themeEase = $85fc2fe65ff21506$var$fromTheme('ease');
    const themeAnimate = $85fc2fe65ff21506$var$fromTheme('animate');
    /**
   * Helpers to avoid repeating the same scales
   *
   * We use functions that create a new array every time they're called instead of static arrays.
   * This ensures that users who modify any scale by mutating the array (e.g. with `array.push(element)`) don't accidentally mutate arrays in other parts of the config.
   */ /***/ const scaleBreak = ()=>[
            'auto',
            'avoid',
            'all',
            'avoid-page',
            'page',
            'left',
            'right',
            'column'
        ];
    const scalePosition = ()=>[
            'center',
            'top',
            'bottom',
            'left',
            'right',
            'top-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-top',
            'top-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-top',
            'bottom-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-bottom',
            'bottom-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-bottom'
        ];
    const scalePositionWithArbitrary = ()=>[
            ...scalePosition(),
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleOverflow = ()=>[
            'auto',
            'hidden',
            'clip',
            'visible',
            'scroll'
        ];
    const scaleOverscroll = ()=>[
            'auto',
            'contain',
            'none'
        ];
    const scaleUnambiguousSpacing = ()=>[
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue,
            themeSpacing
        ];
    const scaleInset = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'full',
            'auto',
            ...scaleUnambiguousSpacing()
        ];
    const scaleGridTemplateColsRows = ()=>[
            $85fc2fe65ff21506$var$isInteger,
            'none',
            'subgrid',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridColRowStartAndEnd = ()=>[
            'auto',
            {
                span: [
                    'full',
                    $85fc2fe65ff21506$var$isInteger,
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            },
            $85fc2fe65ff21506$var$isInteger,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridColRowStartOrEnd = ()=>[
            $85fc2fe65ff21506$var$isInteger,
            'auto',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridAutoColsRows = ()=>[
            'auto',
            'min',
            'max',
            'fr',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleAlignPrimaryAxis = ()=>[
            'start',
            'end',
            'center',
            'between',
            'around',
            'evenly',
            'stretch',
            'baseline',
            'center-safe',
            'end-safe'
        ];
    const scaleAlignSecondaryAxis = ()=>[
            'start',
            'end',
            'center',
            'stretch',
            'center-safe',
            'end-safe'
        ];
    const scaleMargin = ()=>[
            'auto',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizing = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'auto',
            'full',
            'dvw',
            'dvh',
            'lvw',
            'lvh',
            'svw',
            'svh',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizingInline = ()=>[
            themeContainer,
            $85fc2fe65ff21506$var$isFraction,
            'screen',
            'full',
            'dvw',
            'lvw',
            'svw',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizingBlock = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'screen',
            'full',
            'lh',
            'dvh',
            'lvh',
            'svh',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleColor = ()=>[
            themeColor,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleBgPosition = ()=>[
            ...scalePosition(),
            $85fc2fe65ff21506$var$isArbitraryVariablePosition,
            $85fc2fe65ff21506$var$isArbitraryPosition,
            {
                position: [
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            }
        ];
    const scaleBgRepeat = ()=>[
            'no-repeat',
            {
                repeat: [
                    '',
                    'x',
                    'y',
                    'space',
                    'round'
                ]
            }
        ];
    const scaleBgSize = ()=>[
            'auto',
            'cover',
            'contain',
            $85fc2fe65ff21506$var$isArbitraryVariableSize,
            $85fc2fe65ff21506$var$isArbitrarySize,
            {
                size: [
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            }
        ];
    const scaleGradientStopPosition = ()=>[
            $85fc2fe65ff21506$var$isPercent,
            $85fc2fe65ff21506$var$isArbitraryVariableLength,
            $85fc2fe65ff21506$var$isArbitraryLength
        ];
    const scaleRadius = ()=>[
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            'full',
            themeRadius,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleBorderWidth = ()=>[
            '',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariableLength,
            $85fc2fe65ff21506$var$isArbitraryLength
        ];
    const scaleLineStyle = ()=>[
            'solid',
            'dashed',
            'dotted',
            'double'
        ];
    const scaleBlendMode = ()=>[
            'normal',
            'multiply',
            'screen',
            'overlay',
            'darken',
            'lighten',
            'color-dodge',
            'color-burn',
            'hard-light',
            'soft-light',
            'difference',
            'exclusion',
            'hue',
            'saturation',
            'color',
            'luminosity'
        ];
    const scaleMaskImagePosition = ()=>[
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isPercent,
            $85fc2fe65ff21506$var$isArbitraryVariablePosition,
            $85fc2fe65ff21506$var$isArbitraryPosition
        ];
    const scaleBlur = ()=>[
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            themeBlur,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleRotate = ()=>[
            'none',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleScale = ()=>[
            'none',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleSkew = ()=>[
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleTranslate = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'full',
            ...scaleUnambiguousSpacing()
        ];
    return {
        cacheSize: 500,
        theme: {
            animate: [
                'spin',
                'ping',
                'pulse',
                'bounce'
            ],
            aspect: [
                'video'
            ],
            blur: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            breakpoint: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            color: [
                $85fc2fe65ff21506$var$isAny
            ],
            container: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            'drop-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            ease: [
                'in',
                'out',
                'in-out'
            ],
            font: [
                $85fc2fe65ff21506$var$isAnyNonArbitrary
            ],
            'font-weight': [
                'thin',
                'extralight',
                'light',
                'normal',
                'medium',
                'semibold',
                'bold',
                'extrabold',
                'black'
            ],
            'inset-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            leading: [
                'none',
                'tight',
                'snug',
                'normal',
                'relaxed',
                'loose'
            ],
            perspective: [
                'dramatic',
                'near',
                'normal',
                'midrange',
                'distant',
                'none'
            ],
            radius: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            shadow: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            spacing: [
                'px',
                $85fc2fe65ff21506$var$isNumber
            ],
            text: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            'text-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            tracking: [
                'tighter',
                'tight',
                'normal',
                'wide',
                'wider',
                'widest'
            ]
        },
        classGroups: {
            // --------------
            // --- Layout ---
            // --------------
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        'auto',
                        'square',
                        $85fc2fe65ff21506$var$isFraction,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        themeAspect
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */ container: [
                'container'
            ],
            /**
       * Container Type
       * @see https://tailwindcss.com/docs/responsive-design#container-queries
       */ 'container-type': [
                {
                    '@container': [
                        '',
                        'normal',
                        'size',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Container Name
       * @see https://tailwindcss.com/docs/responsive-design#named-containers
       */ 'container-named': [
                $85fc2fe65ff21506$var$isNamedContainerQuery
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $85fc2fe65ff21506$var$isNumber,
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        themeContainer
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ 'break-after': [
                {
                    'break-after': scaleBreak()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ 'break-before': [
                {
                    'break-before': scaleBreak()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ 'break-inside': [
                {
                    'break-inside': [
                        'auto',
                        'avoid',
                        'avoid-page',
                        'avoid-column'
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ 'box-decoration': [
                {
                    'box-decoration': [
                        'slice',
                        'clone'
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        'border',
                        'content'
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                'block',
                'inline-block',
                'inline',
                'flex',
                'inline-flex',
                'table',
                'inline-table',
                'table-caption',
                'table-cell',
                'table-column',
                'table-column-group',
                'table-footer-group',
                'table-header-group',
                'table-row-group',
                'table-row',
                'flow-root',
                'grid',
                'inline-grid',
                'contents',
                'list-item',
                'hidden'
            ],
            /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */ sr: [
                'sr-only',
                'not-sr-only'
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        'right',
                        'left',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        'left',
                        'right',
                        'both',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                'isolate',
                'isolation-auto'
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ 'object-fit': [
                {
                    object: [
                        'contain',
                        'cover',
                        'fill',
                        'none',
                        'scale-down'
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ 'object-position': [
                {
                    object: scalePositionWithArbitrary()
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: scaleOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-x': [
                {
                    'overflow-x': scaleOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-y': [
                {
                    'overflow-y': scaleOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-x': [
                {
                    'overscroll-x': scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-y': [
                {
                    'overscroll-y': scaleOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                'static',
                'fixed',
                'absolute',
                'relative',
                'sticky'
            ],
            /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: scaleInset()
                }
            ],
            /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-x': [
                {
                    'inset-x': scaleInset()
                }
            ],
            /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-y': [
                {
                    'inset-y': scaleInset()
                }
            ],
            /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */ start: [
                {
                    'inset-s': scaleInset(),
                    /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */ start: scaleInset()
                }
            ],
            /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */ end: [
                {
                    'inset-e': scaleInset(),
                    /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */ end: scaleInset()
                }
            ],
            /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-bs': [
                {
                    'inset-bs': scaleInset()
                }
            ],
            /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-be': [
                {
                    'inset-be': scaleInset()
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: scaleInset()
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: scaleInset()
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: scaleInset()
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: scaleInset()
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                'visible',
                'invisible',
                'collapse'
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        $85fc2fe65ff21506$var$isInteger,
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ------------------------
            // --- Flexbox and Grid ---
            // ------------------------
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: [
                        $85fc2fe65ff21506$var$isFraction,
                        'full',
                        'auto',
                        themeContainer,
                        ...scaleUnambiguousSpacing()
                    ]
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ 'flex-direction': [
                {
                    flex: [
                        'row',
                        'row-reverse',
                        'col',
                        'col-reverse'
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ 'flex-wrap': [
                {
                    flex: [
                        'nowrap',
                        'wrap',
                        'wrap-reverse'
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isFraction,
                        'auto',
                        'initial',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        $85fc2fe65ff21506$var$isInteger,
                        'first',
                        'last',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ 'grid-cols': [
                {
                    'grid-cols': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start-end': [
                {
                    col: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start': [
                {
                    'col-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-end': [
                {
                    'col-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ 'grid-rows': [
                {
                    'grid-rows': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start-end': [
                {
                    row: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start': [
                {
                    'row-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-end': [
                {
                    'row-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ 'grid-flow': [
                {
                    'grid-flow': [
                        'row',
                        'col',
                        'dense',
                        'row-dense',
                        'col-dense'
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ 'auto-cols': [
                {
                    'auto-cols': scaleGridAutoColsRows()
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ 'auto-rows': [
                {
                    'auto-rows': scaleGridAutoColsRows()
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-x': [
                {
                    'gap-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-y': [
                {
                    'gap-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ 'justify-content': [
                {
                    justify: [
                        ...scaleAlignPrimaryAxis(),
                        'normal'
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ 'justify-items': [
                {
                    'justify-items': [
                        ...scaleAlignSecondaryAxis(),
                        'normal'
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ 'justify-self': [
                {
                    'justify-self': [
                        'auto',
                        ...scaleAlignSecondaryAxis()
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ 'align-content': [
                {
                    content: [
                        'normal',
                        ...scaleAlignPrimaryAxis()
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ 'align-items': [
                {
                    items: [
                        ...scaleAlignSecondaryAxis(),
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ 'align-self': [
                {
                    self: [
                        'auto',
                        ...scaleAlignSecondaryAxis(),
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ 'place-content': [
                {
                    'place-content': scaleAlignPrimaryAxis()
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ 'place-items': [
                {
                    'place-items': [
                        ...scaleAlignSecondaryAxis(),
                        'baseline'
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ 'place-self': [
                {
                    'place-self': [
                        'auto',
                        ...scaleAlignSecondaryAxis()
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */ pbs: [
                {
                    pbs: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */ pbe: [
                {
                    pbe: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: scaleMargin()
                }
            ],
            /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: scaleMargin()
                }
            ],
            /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: scaleMargin()
                }
            ],
            /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: scaleMargin()
                }
            ],
            /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: scaleMargin()
                }
            ],
            /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */ mbs: [
                {
                    mbs: scaleMargin()
                }
            ],
            /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */ mbe: [
                {
                    mbe: scaleMargin()
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: scaleMargin()
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: scaleMargin()
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: scaleMargin()
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: scaleMargin()
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x': [
                {
                    'space-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x-reverse': [
                'space-x-reverse'
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y': [
                {
                    'space-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y-reverse': [
                'space-y-reverse'
            ],
            // --------------
            // --- Sizing ---
            // --------------
            /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */ size: [
                {
                    size: scaleSizing()
                }
            ],
            /**
       * Inline Size
       * @see https://tailwindcss.com/docs/inline-size
       */ 'inline-size': [
                {
                    inline: [
                        'auto',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-inline-size
       */ 'min-inline-size': [
                {
                    'min-inline': [
                        'auto',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-inline-size
       */ 'max-inline-size': [
                {
                    'max-inline': [
                        'none',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Block Size
       * @see https://tailwindcss.com/docs/block-size
       */ 'block-size': [
                {
                    block: [
                        'auto',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-block-size
       */ 'min-block-size': [
                {
                    'min-block': [
                        'auto',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-block-size
       */ 'max-block-size': [
                {
                    'max-block': [
                        'none',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        themeContainer,
                        'screen',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ 'min-w': [
                {
                    'min-w': [
                        themeContainer,
                        'screen',
                        /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'none',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ 'max-w': [
                {
                    'max-w': [
                        themeContainer,
                        'screen',
                        'none',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'prose',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ {
                            screen: [
                                themeBreakpoint
                            ]
                        },
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        'screen',
                        'lh',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ 'min-h': [
                {
                    'min-h': [
                        'screen',
                        'lh',
                        'none',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ 'max-h': [
                {
                    'max-h': [
                        'screen',
                        'lh',
                        'none',
                        ...scaleSizing()
                    ]
                }
            ],
            // ------------------
            // --- Typography ---
            // ------------------
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ 'font-size': [
                {
                    text: [
                        'base',
                        themeText,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ 'font-smoothing': [
                'antialiased',
                'subpixel-antialiased'
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ 'font-style': [
                'italic',
                'not-italic'
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ 'font-weight': [
                {
                    font: [
                        themeFontWeight,
                        $85fc2fe65ff21506$var$isArbitraryVariableWeight,
                        $85fc2fe65ff21506$var$isArbitraryWeight
                    ]
                }
            ],
            /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */ 'font-stretch': [
                {
                    'font-stretch': [
                        'ultra-condensed',
                        'extra-condensed',
                        'condensed',
                        'semi-condensed',
                        'normal',
                        'semi-expanded',
                        'expanded',
                        'extra-expanded',
                        'ultra-expanded',
                        $85fc2fe65ff21506$var$isPercent,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ 'font-family': [
                {
                    font: [
                        $85fc2fe65ff21506$var$isArbitraryVariableFamilyName,
                        $85fc2fe65ff21506$var$isArbitraryFamilyName,
                        themeFont
                    ]
                }
            ],
            /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */ 'font-features': [
                {
                    'font-features': [
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-normal': [
                'normal-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-ordinal': [
                'ordinal'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-slashed-zero': [
                'slashed-zero'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-figure': [
                'lining-nums',
                'oldstyle-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-spacing': [
                'proportional-nums',
                'tabular-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-fraction': [
                'diagonal-fractions',
                'stacked-fractions'
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        themeTracking,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ 'line-clamp': [
                {
                    'line-clamp': [
                        $85fc2fe65ff21506$var$isNumber,
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        'none',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ themeLeading,
                        ...scaleUnambiguousSpacing()
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ 'list-image': [
                {
                    'list-image': [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ 'list-style-position': [
                {
                    list: [
                        'inside',
                        'outside'
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ 'list-style-type': [
                {
                    list: [
                        'disc',
                        'decimal',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ 'text-alignment': [
                {
                    text: [
                        'left',
                        'center',
                        'right',
                        'justify',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */ 'placeholder-color': [
                {
                    placeholder: scaleColor()
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ 'text-color': [
                {
                    text: scaleColor()
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ 'text-decoration': [
                'underline',
                'overline',
                'line-through',
                'no-underline'
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ 'text-decoration-style': [
                {
                    decoration: [
                        ...scaleLineStyle(),
                        'wavy'
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ 'text-decoration-thickness': [
                {
                    decoration: [
                        $85fc2fe65ff21506$var$isNumber,
                        'from-font',
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ 'text-decoration-color': [
                {
                    decoration: scaleColor()
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ 'underline-offset': [
                {
                    'underline-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ 'text-transform': [
                'uppercase',
                'lowercase',
                'capitalize',
                'normal-case'
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ 'text-overflow': [
                'truncate',
                'text-ellipsis',
                'text-clip'
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ 'text-wrap': [
                {
                    text: [
                        'wrap',
                        'nowrap',
                        'balance',
                        'pretty'
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Tab Size
       * @see https://tailwindcss.com/docs/tab-size
       */ 'tab-size': [
                {
                    tab: [
                        $85fc2fe65ff21506$var$isInteger,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ 'vertical-align': [
                {
                    align: [
                        'baseline',
                        'top',
                        'middle',
                        'bottom',
                        'text-top',
                        'text-bottom',
                        'sub',
                        'super',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        'normal',
                        'nowrap',
                        'pre',
                        'pre-line',
                        'pre-wrap',
                        'break-spaces'
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        'normal',
                        'words',
                        'all',
                        'keep'
                    ]
                }
            ],
            /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */ wrap: [
                {
                    wrap: [
                        'break-word',
                        'anywhere',
                        'normal'
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        'none',
                        'manual',
                        'auto'
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // -------------------
            // --- Backgrounds ---
            // -------------------
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ 'bg-attachment': [
                {
                    bg: [
                        'fixed',
                        'local',
                        'scroll'
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ 'bg-clip': [
                {
                    'bg-clip': [
                        'border',
                        'padding',
                        'content',
                        'text'
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ 'bg-origin': [
                {
                    'bg-origin': [
                        'border',
                        'padding',
                        'content'
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ 'bg-position': [
                {
                    bg: scaleBgPosition()
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ 'bg-repeat': [
                {
                    bg: scaleBgRepeat()
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ 'bg-size': [
                {
                    bg: scaleBgSize()
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ 'bg-image': [
                {
                    bg: [
                        'none',
                        {
                            linear: [
                                {
                                    to: [
                                        't',
                                        'tr',
                                        'r',
                                        'br',
                                        'b',
                                        'bl',
                                        'l',
                                        'tl'
                                    ]
                                },
                                $85fc2fe65ff21506$var$isInteger,
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ],
                            radial: [
                                '',
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ],
                            conic: [
                                '',
                                $85fc2fe65ff21506$var$isInteger,
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ]
                        },
                        $85fc2fe65ff21506$var$isArbitraryVariableImage,
                        $85fc2fe65ff21506$var$isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ 'bg-color': [
                {
                    bg: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from-pos': [
                {
                    from: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via-pos': [
                {
                    via: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to-pos': [
                {
                    to: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from': [
                {
                    from: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via': [
                {
                    via: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to': [
                {
                    to: scaleColor()
                }
            ],
            // ---------------
            // --- Borders ---
            // ---------------
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: scaleRadius()
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-s': [
                {
                    'rounded-s': scaleRadius()
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-e': [
                {
                    'rounded-e': scaleRadius()
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-t': [
                {
                    'rounded-t': scaleRadius()
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-r': [
                {
                    'rounded-r': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-b': [
                {
                    'rounded-b': scaleRadius()
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-l': [
                {
                    'rounded-l': scaleRadius()
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ss': [
                {
                    'rounded-ss': scaleRadius()
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-se': [
                {
                    'rounded-se': scaleRadius()
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ee': [
                {
                    'rounded-ee': scaleRadius()
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-es': [
                {
                    'rounded-es': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tl': [
                {
                    'rounded-tl': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tr': [
                {
                    'rounded-tr': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-br': [
                {
                    'rounded-br': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-bl': [
                {
                    'rounded-bl': scaleRadius()
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w': [
                {
                    border: scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-x': [
                {
                    'border-x': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-y': [
                {
                    'border-y': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-s': [
                {
                    'border-s': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-e': [
                {
                    'border-e': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-bs': [
                {
                    'border-bs': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-be': [
                {
                    'border-be': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-t': [
                {
                    'border-t': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-r': [
                {
                    'border-r': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-b': [
                {
                    'border-b': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-l': [
                {
                    'border-l': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x': [
                {
                    'divide-x': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x-reverse': [
                'divide-x-reverse'
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y': [
                {
                    'divide-y': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y-reverse': [
                'divide-y-reverse'
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ 'border-style': [
                {
                    border: [
                        ...scaleLineStyle(),
                        'hidden',
                        'none'
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */ 'divide-style': [
                {
                    divide: [
                        ...scaleLineStyle(),
                        'hidden',
                        'none'
                    ]
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color': [
                {
                    border: scaleColor()
                }
            ],
            /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-x': [
                {
                    'border-x': scaleColor()
                }
            ],
            /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-y': [
                {
                    'border-y': scaleColor()
                }
            ],
            /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-s': [
                {
                    'border-s': scaleColor()
                }
            ],
            /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-e': [
                {
                    'border-e': scaleColor()
                }
            ],
            /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-bs': [
                {
                    'border-bs': scaleColor()
                }
            ],
            /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-be': [
                {
                    'border-be': scaleColor()
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-t': [
                {
                    'border-t': scaleColor()
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-r': [
                {
                    'border-r': scaleColor()
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-b': [
                {
                    'border-b': scaleColor()
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-l': [
                {
                    'border-l': scaleColor()
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ 'divide-color': [
                {
                    divide: scaleColor()
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ 'outline-style': [
                {
                    outline: [
                        ...scaleLineStyle(),
                        'none',
                        'hidden'
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ 'outline-offset': [
                {
                    'outline-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ 'outline-w': [
                {
                    outline: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ 'outline-color': [
                {
                    outline: scaleColor()
                }
            ],
            // ---------------
            // --- Effects ---
            // ---------------
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        // Deprecated since Tailwind CSS v4.0.0
                        'inner',
                        'none',
                        themeShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */ 'shadow-color': [
                {
                    shadow: scaleColor()
                }
            ],
            /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */ 'inset-shadow': [
                {
                    'inset-shadow': [
                        'none',
                        themeInsetShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */ 'inset-shadow-color': [
                {
                    'inset-shadow': scaleColor()
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */ 'ring-w': [
                {
                    ring: scaleBorderWidth()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-w-inset': [
                'ring-inset'
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */ 'ring-color': [
                {
                    ring: scaleColor()
                }
            ],
            /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-w': [
                {
                    'ring-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-color': [
                {
                    'ring-offset': scaleColor()
                }
            ],
            /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */ 'inset-ring-w': [
                {
                    'inset-ring': scaleBorderWidth()
                }
            ],
            /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */ 'inset-ring-color': [
                {
                    'inset-ring': scaleColor()
                }
            ],
            /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */ 'text-shadow': [
                {
                    'text-shadow': [
                        'none',
                        themeTextShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */ 'text-shadow-color': [
                {
                    'text-shadow': scaleColor()
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ 'mix-blend': [
                {
                    'mix-blend': [
                        ...scaleBlendMode(),
                        'plus-darker',
                        'plus-lighter'
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ 'bg-blend': [
                {
                    'bg-blend': scaleBlendMode()
                }
            ],
            /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */ 'mask-clip': [
                {
                    'mask-clip': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                },
                'mask-no-clip'
            ],
            /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */ 'mask-composite': [
                {
                    mask: [
                        'add',
                        'subtract',
                        'intersect',
                        'exclude'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image-linear-pos': [
                {
                    'mask-linear': [
                        $85fc2fe65ff21506$var$isNumber
                    ]
                }
            ],
            'mask-image-linear-from-pos': [
                {
                    'mask-linear-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-to-pos': [
                {
                    'mask-linear-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-from-color': [
                {
                    'mask-linear-from': scaleColor()
                }
            ],
            'mask-image-linear-to-color': [
                {
                    'mask-linear-to': scaleColor()
                }
            ],
            'mask-image-t-from-pos': [
                {
                    'mask-t-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-to-pos': [
                {
                    'mask-t-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-from-color': [
                {
                    'mask-t-from': scaleColor()
                }
            ],
            'mask-image-t-to-color': [
                {
                    'mask-t-to': scaleColor()
                }
            ],
            'mask-image-r-from-pos': [
                {
                    'mask-r-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-to-pos': [
                {
                    'mask-r-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-from-color': [
                {
                    'mask-r-from': scaleColor()
                }
            ],
            'mask-image-r-to-color': [
                {
                    'mask-r-to': scaleColor()
                }
            ],
            'mask-image-b-from-pos': [
                {
                    'mask-b-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-to-pos': [
                {
                    'mask-b-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-from-color': [
                {
                    'mask-b-from': scaleColor()
                }
            ],
            'mask-image-b-to-color': [
                {
                    'mask-b-to': scaleColor()
                }
            ],
            'mask-image-l-from-pos': [
                {
                    'mask-l-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-to-pos': [
                {
                    'mask-l-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-from-color': [
                {
                    'mask-l-from': scaleColor()
                }
            ],
            'mask-image-l-to-color': [
                {
                    'mask-l-to': scaleColor()
                }
            ],
            'mask-image-x-from-pos': [
                {
                    'mask-x-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-to-pos': [
                {
                    'mask-x-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-from-color': [
                {
                    'mask-x-from': scaleColor()
                }
            ],
            'mask-image-x-to-color': [
                {
                    'mask-x-to': scaleColor()
                }
            ],
            'mask-image-y-from-pos': [
                {
                    'mask-y-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-to-pos': [
                {
                    'mask-y-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-from-color': [
                {
                    'mask-y-from': scaleColor()
                }
            ],
            'mask-image-y-to-color': [
                {
                    'mask-y-to': scaleColor()
                }
            ],
            'mask-image-radial': [
                {
                    'mask-radial': [
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            'mask-image-radial-from-pos': [
                {
                    'mask-radial-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-to-pos': [
                {
                    'mask-radial-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-from-color': [
                {
                    'mask-radial-from': scaleColor()
                }
            ],
            'mask-image-radial-to-color': [
                {
                    'mask-radial-to': scaleColor()
                }
            ],
            'mask-image-radial-shape': [
                {
                    'mask-radial': [
                        'circle',
                        'ellipse'
                    ]
                }
            ],
            'mask-image-radial-size': [
                {
                    'mask-radial': [
                        {
                            closest: [
                                'side',
                                'corner'
                            ],
                            farthest: [
                                'side',
                                'corner'
                            ]
                        }
                    ]
                }
            ],
            'mask-image-radial-pos': [
                {
                    'mask-radial-at': scalePosition()
                }
            ],
            'mask-image-conic-pos': [
                {
                    'mask-conic': [
                        $85fc2fe65ff21506$var$isNumber
                    ]
                }
            ],
            'mask-image-conic-from-pos': [
                {
                    'mask-conic-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-to-pos': [
                {
                    'mask-conic-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-from-color': [
                {
                    'mask-conic-from': scaleColor()
                }
            ],
            'mask-image-conic-to-color': [
                {
                    'mask-conic-to': scaleColor()
                }
            ],
            /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */ 'mask-mode': [
                {
                    mask: [
                        'alpha',
                        'luminance',
                        'match'
                    ]
                }
            ],
            /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */ 'mask-origin': [
                {
                    'mask-origin': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                }
            ],
            /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */ 'mask-position': [
                {
                    mask: scaleBgPosition()
                }
            ],
            /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */ 'mask-repeat': [
                {
                    mask: scaleBgRepeat()
                }
            ],
            /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */ 'mask-size': [
                {
                    mask: scaleBgSize()
                }
            ],
            /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */ 'mask-type': [
                {
                    'mask-type': [
                        'alpha',
                        'luminance'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image': [
                {
                    mask: [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ---------------
            // --- Filters ---
            // ---------------
            /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: scaleBlur()
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ 'drop-shadow': [
                {
                    'drop-shadow': [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        'none',
                        themeDropShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */ 'drop-shadow-color': [
                {
                    'drop-shadow': scaleColor()
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ 'hue-rotate': [
                {
                    'hue-rotate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ 'backdrop-filter': [
                {
                    'backdrop-filter': [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ 'backdrop-blur': [
                {
                    'backdrop-blur': scaleBlur()
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ 'backdrop-brightness': [
                {
                    'backdrop-brightness': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ 'backdrop-contrast': [
                {
                    'backdrop-contrast': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ 'backdrop-grayscale': [
                {
                    'backdrop-grayscale': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ 'backdrop-hue-rotate': [
                {
                    'backdrop-hue-rotate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ 'backdrop-invert': [
                {
                    'backdrop-invert': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ 'backdrop-opacity': [
                {
                    'backdrop-opacity': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ 'backdrop-saturate': [
                {
                    'backdrop-saturate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ 'backdrop-sepia': [
                {
                    'backdrop-sepia': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // --------------
            // --- Tables ---
            // --------------
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ 'border-collapse': [
                {
                    border: [
                        'collapse',
                        'separate'
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing': [
                {
                    'border-spacing': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-x': [
                {
                    'border-spacing-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-y': [
                {
                    'border-spacing-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ 'table-layout': [
                {
                    table: [
                        'auto',
                        'fixed'
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        'top',
                        'bottom'
                    ]
                }
            ],
            // ---------------------------------
            // --- Transitions and Animation ---
            // ---------------------------------
            /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        '',
                        'all',
                        'colors',
                        'opacity',
                        'shadow',
                        'transform',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */ 'transition-behavior': [
                {
                    transition: [
                        'normal',
                        'discrete'
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: [
                        $85fc2fe65ff21506$var$isNumber,
                        'initial',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        'linear',
                        'initial',
                        themeEase,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        'none',
                        themeAnimate,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ------------------
            // --- Transforms ---
            // ------------------
            /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */ backface: [
                {
                    backface: [
                        'hidden',
                        'visible'
                    ]
                }
            ],
            /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */ perspective: [
                {
                    perspective: [
                        themePerspective,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */ 'perspective-origin': [
                {
                    'perspective-origin': scalePositionWithArbitrary()
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: scaleRotate()
                }
            ],
            /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-x': [
                {
                    'rotate-x': scaleRotate()
                }
            ],
            /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-y': [
                {
                    'rotate-y': scaleRotate()
                }
            ],
            /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-z': [
                {
                    'rotate-z': scaleRotate()
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: scaleScale()
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-x': [
                {
                    'scale-x': scaleScale()
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-y': [
                {
                    'scale-y': scaleScale()
                }
            ],
            /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-z': [
                {
                    'scale-z': scaleScale()
                }
            ],
            /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-3d': [
                'scale-3d'
            ],
            /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */ skew: [
                {
                    skew: scaleSkew()
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-x': [
                {
                    'skew-x': scaleSkew()
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-y': [
                {
                    'skew-y': scaleSkew()
                }
            ],
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        '',
                        'none',
                        'gpu',
                        'cpu'
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ 'transform-origin': [
                {
                    origin: scalePositionWithArbitrary()
                }
            ],
            /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */ 'transform-style': [
                {
                    transform: [
                        '3d',
                        'flat'
                    ]
                }
            ],
            /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */ translate: [
                {
                    translate: scaleTranslate()
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-x': [
                {
                    'translate-x': scaleTranslate()
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-y': [
                {
                    'translate-y': scaleTranslate()
                }
            ],
            /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-z': [
                {
                    'translate-z': scaleTranslate()
                }
            ],
            /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-none': [
                'translate-none'
            ],
            /**
       * Zoom
       * @see https://tailwindcss.com/docs/zoom
       */ zoom: [
                {
                    zoom: [
                        $85fc2fe65ff21506$var$isInteger,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ---------------------
            // --- Interactivity ---
            // ---------------------
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: scaleColor()
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        'none',
                        'auto'
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ 'caret-color': [
                {
                    caret: scaleColor()
                }
            ],
            /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */ 'color-scheme': [
                {
                    scheme: [
                        'normal',
                        'dark',
                        'light',
                        'light-dark',
                        'only-dark',
                        'only-light'
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        'auto',
                        'default',
                        'pointer',
                        'wait',
                        'text',
                        'move',
                        'help',
                        'not-allowed',
                        'none',
                        'context-menu',
                        'progress',
                        'cell',
                        'crosshair',
                        'vertical-text',
                        'alias',
                        'copy',
                        'no-drop',
                        'grab',
                        'grabbing',
                        'all-scroll',
                        'col-resize',
                        'row-resize',
                        'n-resize',
                        'e-resize',
                        's-resize',
                        'w-resize',
                        'ne-resize',
                        'nw-resize',
                        'se-resize',
                        'sw-resize',
                        'ew-resize',
                        'ns-resize',
                        'nesw-resize',
                        'nwse-resize',
                        'zoom-in',
                        'zoom-out',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */ 'field-sizing': [
                {
                    'field-sizing': [
                        'fixed',
                        'content'
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ 'pointer-events': [
                {
                    'pointer-events': [
                        'auto',
                        'none'
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        'none',
                        '',
                        'y',
                        'x'
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ 'scroll-behavior': [
                {
                    scroll: [
                        'auto',
                        'smooth'
                    ]
                }
            ],
            /**
       * Scrollbar Thumb Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */ 'scrollbar-thumb-color': [
                {
                    'scrollbar-thumb': scaleColor()
                }
            ],
            /**
       * Scrollbar Track Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */ 'scrollbar-track-color': [
                {
                    'scrollbar-track': scaleColor()
                }
            ],
            /**
       * Scrollbar Gutter
       * @see https://tailwindcss.com/docs/scrollbar-gutter
       */ 'scrollbar-gutter': [
                {
                    'scrollbar-gutter': [
                        'auto',
                        'stable',
                        'both'
                    ]
                }
            ],
            /**
       * Scrollbar Width
       * @see https://tailwindcss.com/docs/scrollbar-width
       */ 'scrollbar-w': [
                {
                    scrollbar: [
                        'auto',
                        'thin',
                        'none'
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-m': [
                {
                    'scroll-m': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mx': [
                {
                    'scroll-mx': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-my': [
                {
                    'scroll-my': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ms': [
                {
                    'scroll-ms': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-me': [
                {
                    'scroll-me': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mbs': [
                {
                    'scroll-mbs': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mbe': [
                {
                    'scroll-mbe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mt': [
                {
                    'scroll-mt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mr': [
                {
                    'scroll-mr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mb': [
                {
                    'scroll-mb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ml': [
                {
                    'scroll-ml': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-p': [
                {
                    'scroll-p': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-px': [
                {
                    'scroll-px': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-py': [
                {
                    'scroll-py': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-ps': [
                {
                    'scroll-ps': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pe': [
                {
                    'scroll-pe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pbs': [
                {
                    'scroll-pbs': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pbe': [
                {
                    'scroll-pbe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pt': [
                {
                    'scroll-pt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pr': [
                {
                    'scroll-pr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pb': [
                {
                    'scroll-pb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pl': [
                {
                    'scroll-pl': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ 'snap-align': [
                {
                    snap: [
                        'start',
                        'end',
                        'center',
                        'align-none'
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ 'snap-stop': [
                {
                    snap: [
                        'normal',
                        'always'
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-type': [
                {
                    snap: [
                        'none',
                        'x',
                        'y',
                        'both'
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-strictness': [
                {
                    snap: [
                        'mandatory',
                        'proximity'
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        'auto',
                        'none',
                        'manipulation'
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-x': [
                {
                    'touch-pan': [
                        'x',
                        'left',
                        'right'
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-y': [
                {
                    'touch-pan': [
                        'y',
                        'up',
                        'down'
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-pz': [
                'touch-pinch-zoom'
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        'none',
                        'text',
                        'all',
                        'auto'
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ 'will-change': [
                {
                    'will-change': [
                        'auto',
                        'scroll',
                        'contents',
                        'transform',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // -----------
            // --- SVG ---
            // -----------
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        'none',
                        ...scaleColor()
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ 'stroke-w': [
                {
                    stroke: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength,
                        $85fc2fe65ff21506$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        'none',
                        ...scaleColor()
                    ]
                }
            ],
            // ---------------------
            // --- Accessibility ---
            // ---------------------
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ 'forced-color-adjust': [
                {
                    'forced-color-adjust': [
                        'auto',
                        'none'
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            'container-named': [
                'container-type'
            ],
            overflow: [
                'overflow-x',
                'overflow-y'
            ],
            overscroll: [
                'overscroll-x',
                'overscroll-y'
            ],
            inset: [
                'inset-x',
                'inset-y',
                'inset-bs',
                'inset-be',
                'start',
                'end',
                'top',
                'right',
                'bottom',
                'left'
            ],
            'inset-x': [
                'start',
                'end',
                'right',
                'left'
            ],
            'inset-y': [
                'inset-bs',
                'inset-be',
                'top',
                'bottom'
            ],
            flex: [
                'basis',
                'grow',
                'shrink'
            ],
            gap: [
                'gap-x',
                'gap-y'
            ],
            p: [
                'px',
                'py',
                'ps',
                'pe',
                'pbs',
                'pbe',
                'pt',
                'pr',
                'pb',
                'pl'
            ],
            px: [
                'ps',
                'pe',
                'pr',
                'pl'
            ],
            py: [
                'pbs',
                'pbe',
                'pt',
                'pb'
            ],
            m: [
                'mx',
                'my',
                'ms',
                'me',
                'mbs',
                'mbe',
                'mt',
                'mr',
                'mb',
                'ml'
            ],
            mx: [
                'ms',
                'me',
                'mr',
                'ml'
            ],
            my: [
                'mbs',
                'mbe',
                'mt',
                'mb'
            ],
            size: [
                'w',
                'h'
            ],
            'font-size': [
                'leading'
            ],
            'fvn-normal': [
                'fvn-ordinal',
                'fvn-slashed-zero',
                'fvn-figure',
                'fvn-spacing',
                'fvn-fraction'
            ],
            'fvn-ordinal': [
                'fvn-normal'
            ],
            'fvn-slashed-zero': [
                'fvn-normal'
            ],
            'fvn-figure': [
                'fvn-normal'
            ],
            'fvn-spacing': [
                'fvn-normal'
            ],
            'fvn-fraction': [
                'fvn-normal'
            ],
            'line-clamp': [
                'display',
                'overflow'
            ],
            rounded: [
                'rounded-s',
                'rounded-e',
                'rounded-t',
                'rounded-r',
                'rounded-b',
                'rounded-l',
                'rounded-ss',
                'rounded-se',
                'rounded-ee',
                'rounded-es',
                'rounded-tl',
                'rounded-tr',
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-s': [
                'rounded-ss',
                'rounded-es'
            ],
            'rounded-e': [
                'rounded-se',
                'rounded-ee'
            ],
            'rounded-t': [
                'rounded-tl',
                'rounded-tr'
            ],
            'rounded-r': [
                'rounded-tr',
                'rounded-br'
            ],
            'rounded-b': [
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-l': [
                'rounded-tl',
                'rounded-bl'
            ],
            'border-spacing': [
                'border-spacing-x',
                'border-spacing-y'
            ],
            'border-w': [
                'border-w-x',
                'border-w-y',
                'border-w-s',
                'border-w-e',
                'border-w-bs',
                'border-w-be',
                'border-w-t',
                'border-w-r',
                'border-w-b',
                'border-w-l'
            ],
            'border-w-x': [
                'border-w-s',
                'border-w-e',
                'border-w-r',
                'border-w-l'
            ],
            'border-w-y': [
                'border-w-bs',
                'border-w-be',
                'border-w-t',
                'border-w-b'
            ],
            'border-color': [
                'border-color-x',
                'border-color-y',
                'border-color-s',
                'border-color-e',
                'border-color-bs',
                'border-color-be',
                'border-color-t',
                'border-color-r',
                'border-color-b',
                'border-color-l'
            ],
            'border-color-x': [
                'border-color-s',
                'border-color-e',
                'border-color-r',
                'border-color-l'
            ],
            'border-color-y': [
                'border-color-bs',
                'border-color-be',
                'border-color-t',
                'border-color-b'
            ],
            translate: [
                'translate-x',
                'translate-y',
                'translate-none'
            ],
            'translate-none': [
                'translate',
                'translate-x',
                'translate-y',
                'translate-z'
            ],
            'scroll-m': [
                'scroll-mx',
                'scroll-my',
                'scroll-ms',
                'scroll-me',
                'scroll-mbs',
                'scroll-mbe',
                'scroll-mt',
                'scroll-mr',
                'scroll-mb',
                'scroll-ml'
            ],
            'scroll-mx': [
                'scroll-ms',
                'scroll-me',
                'scroll-mr',
                'scroll-ml'
            ],
            'scroll-my': [
                'scroll-mbs',
                'scroll-mbe',
                'scroll-mt',
                'scroll-mb'
            ],
            'scroll-p': [
                'scroll-px',
                'scroll-py',
                'scroll-ps',
                'scroll-pe',
                'scroll-pbs',
                'scroll-pbe',
                'scroll-pt',
                'scroll-pr',
                'scroll-pb',
                'scroll-pl'
            ],
            'scroll-px': [
                'scroll-ps',
                'scroll-pe',
                'scroll-pr',
                'scroll-pl'
            ],
            'scroll-py': [
                'scroll-pbs',
                'scroll-pbe',
                'scroll-pt',
                'scroll-pb'
            ],
            touch: [
                'touch-x',
                'touch-y',
                'touch-pz'
            ],
            'touch-x': [
                'touch'
            ],
            'touch-y': [
                'touch'
            ],
            'touch-pz': [
                'touch'
            ]
        },
        conflictingClassGroupModifiers: {
            'font-size': [
                'leading'
            ]
        },
        postfixLookupClassGroups: [
            'container-type'
        ],
        orderSensitiveModifiers: [
            '*',
            '**',
            'after',
            'backdrop',
            'before',
            'details-content',
            'file',
            'first-letter',
            'first-line',
            'marker',
            'placeholder',
            'selection'
        ]
    };
};
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ const $85fc2fe65ff21506$var$mergeConfigs = (baseConfig, { cacheSize: cacheSize, prefix: prefix, experimentalParseClassName: experimentalParseClassName, extend: extend = {}, override: override = {} })=>{
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'cacheSize', cacheSize);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'prefix', prefix);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'experimentalParseClassName', experimentalParseClassName);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.theme, override.theme);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.classGroups, override.classGroups);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.conflictingClassGroups, override.conflictingClassGroups);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.conflictingClassGroupModifiers, override.conflictingClassGroupModifiers);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'postfixLookupClassGroups', override.postfixLookupClassGroups);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'orderSensitiveModifiers', override.orderSensitiveModifiers);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.theme, extend.theme);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.classGroups, extend.classGroups);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.conflictingClassGroups, extend.conflictingClassGroups);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.conflictingClassGroupModifiers, extend.conflictingClassGroupModifiers);
    $85fc2fe65ff21506$var$mergeArrayProperties(baseConfig, extend, 'postfixLookupClassGroups');
    $85fc2fe65ff21506$var$mergeArrayProperties(baseConfig, extend, 'orderSensitiveModifiers');
    return baseConfig;
};
const $85fc2fe65ff21506$var$overrideProperty = (baseObject, overrideKey, overrideValue)=>{
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
};
const $85fc2fe65ff21506$var$overrideConfigProperties = (baseObject, overrideObject)=>{
    if (overrideObject) for(const key in overrideObject)$85fc2fe65ff21506$var$overrideProperty(baseObject, key, overrideObject[key]);
};
const $85fc2fe65ff21506$var$mergeConfigProperties = (baseObject, mergeObject)=>{
    if (mergeObject) for(const key in mergeObject)$85fc2fe65ff21506$var$mergeArrayProperties(baseObject, mergeObject, key);
};
const $85fc2fe65ff21506$var$mergeArrayProperties = (baseObject, mergeObject, key)=>{
    const mergeValue = mergeObject[key];
    if (mergeValue !== undefined) baseObject[key] = baseObject[key] ? baseObject[key].concat(mergeValue) : mergeValue;
};
const $85fc2fe65ff21506$var$extendTailwindMerge = (configExtension, ...createConfig)=>typeof configExtension === 'function' ? $85fc2fe65ff21506$var$createTailwindMerge($85fc2fe65ff21506$var$getDefaultConfig, configExtension, ...createConfig) : $85fc2fe65ff21506$var$createTailwindMerge(()=>$85fc2fe65ff21506$var$mergeConfigs($85fc2fe65ff21506$var$getDefaultConfig(), configExtension), ...createConfig);
const $85fc2fe65ff21506$var$twMerge = /*#__PURE__*/ $85fc2fe65ff21506$var$createTailwindMerge($85fc2fe65ff21506$var$getDefaultConfig);
$85fc2fe65ff21506$exports.createTailwindMerge = $85fc2fe65ff21506$var$createTailwindMerge;
$85fc2fe65ff21506$exports.extendTailwindMerge = $85fc2fe65ff21506$var$extendTailwindMerge;
$85fc2fe65ff21506$exports.fromTheme = $85fc2fe65ff21506$var$fromTheme;
$85fc2fe65ff21506$exports.getDefaultConfig = $85fc2fe65ff21506$var$getDefaultConfig;
$85fc2fe65ff21506$exports.mergeConfigs = $85fc2fe65ff21506$var$mergeConfigs;
$85fc2fe65ff21506$exports.twJoin = $85fc2fe65ff21506$var$twJoin;
$85fc2fe65ff21506$exports.twMerge = $85fc2fe65ff21506$var$twMerge;
$85fc2fe65ff21506$exports.validators = $85fc2fe65ff21506$var$validators;


function $42e05640dae453c1$export$1343a74baacb0543(...inputs) {
    return (0, $85fc2fe65ff21506$exports.twMerge)((0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(inputs));
}
const $42e05640dae453c1$export$e6aa7dbb1e28c5bd = (str)=>String(str).replace(/[۰-۹]/g, (d)=>d.charCodeAt(0) - 0x06F0).replace(/[٠-٩]/g, (d)=>d.charCodeAt(0) - 0x0660);


'use client';
// The field wrapper every kit input renders through — and therefore the one
// place that decides whether this design system produces labelled controls.
//
// It used to draw the label as a `<span>`. That looks identical and is not the
// same thing: a screen reader announcing an unlabelled text box says "edit
// text, blank", `getByLabelText` cannot find the control, and clicking the
// label does not focus the field. §12.3 says all form inputs are labelled
// through `FormField` with a real `<label for>` — this is that.
//
// The association is made here rather than at the call sites, because a rule
// that depends on every caller remembering to pass an `id` is a rule that is
// half-applied within a month. `useId` supplies one, the child's own `id` wins
// if it has one, and the error/helper line is wired as `aria-describedby` so
// the reason a field is red is announced with it.
const $221000a87dfafb8e$var$FormField = ({ label: label, required: required, error: error, helperText: helperText, children: children, className: className, style: style, htmlFor: htmlFor })=>{
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const only = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(children) ? children : null;
    const controlId = htmlFor || only?.props?.id || (only ? `${generatedId}-control` : undefined);
    // Derived from the control's id, not the wrapper's, so a component that owns
    // its own wiring (the inputs that wrap their control in a positioning div)
    // can point at this message without asking for the id back.
    const messageId = (error || helperText) && controlId ? `${controlId}-message` : undefined;
    // `htmlFor` means the caller has already put the id on the real control.
    // Cloning here too would stamp the same id onto its wrapper — two elements,
    // one id, and the label resolves to whichever the browser sees first.
    const control = only && !htmlFor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(only, {
        id: controlId,
        // Never clobber a caller's own description — join, so a field that
        // already points at a hint keeps it AND gains the error line.
        'aria-describedby': [
            only.props['aria-describedby'],
            messageId
        ].filter(Boolean).join(' ') || undefined,
        'aria-invalid': only.props['aria-invalid'] ?? (error ? true : undefined)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex flex-col gap-1.5', className),
        style: style
    }, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        htmlFor: controlId,
        className: "text-[11.5px] font-semibold text-[#5a6780] tracking-[0.01em] select-none leading-none"
    }, label, required && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-destructive ms-1"
    }, "*")), control, error ? // Announced, not merely displayed: §12.3 requires validation errors to
    // reach a screen reader when they appear, and a field whose only signal
    // is a red border tells a non-sighted user nothing at all.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: messageId,
        role: "alert",
        className: "m-0 text-[11.5px] text-destructive font-medium leading-snug"
    }, error) : helperText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: messageId,
        className: "m-0 text-[11.5px] text-muted-foreground leading-snug"
    }, helperText) : null);
};
var $221000a87dfafb8e$export$2e2bcd8739ae039 = $221000a87dfafb8e$var$FormField;



var $acw62 = parcelRequire("acw62");


'use client';
const $6e2f2bccd0e2a9fb$var$TextInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, placeholder: placeholder, type: type = 'text', validate: validate, disabled: disabled = false, maxLength: maxLength, style: style, inputStyle: inputStyle, dir: // Unset: the field inherits the document's direction, which is what lets one
// component render a Persian and an English account. Pass dir="ltr" for a
// phone number, a code or any other Latin-digit run inside an RTL page.
dir, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest }, ref)=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ...rest,
        ref: ref,
        type: type,
        value: value,
        onChange: onChange,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        maxLength: maxLength,
        dir: dir,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('w-full h-11 px-3.5 rounded-lg font-sans text-[13.5px] text-foreground', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70'),
        style: inputStyle
    }));
});
$6e2f2bccd0e2a9fb$var$TextInput.displayName = 'TextInput';
var $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039 = $6e2f2bccd0e2a9fb$var$TextInput;



var $acw62 = parcelRequire("acw62");


// Phone numbers, reduced to one canonical form — and read back in whatever form a
// human wants to look at.
//
// ═══════════════════════════════════════════════════════════════════════════════
// THE THREE SIBLINGS OF THIS FILE
//
//   microservices/parsina.patientmanagement.microservice/app/domain/phone.py
//       `normalize_phone` — the matching key behind `patients.phone_normalized`.
//       Iran only. Its tests are tests/test_phone.py.
//   sso/parsina.keycloakify/spi/src/main/java/ir/parsinabot/keycloak/phoneotp/PhoneNumbers.java
//       `normalize` / `toNational` / `lookupVariants` / `mask`, inside the Keycloak
//       authenticator. Iran only. Its tests are PhoneNumbersTest.java.
//   sso/parsina.keycloakify/src/login/lib/{countries.ts,phone.ts}
//       The login screen's country-aware picker and E.164 parse. 52 countries,
//       Iran first, "the list is a convenience, never a gate".
//
// This module is the fourth hand-rolled implementation of the same rules, and it is
// deliberate. Keycloak is a Java process that cannot import Python; the login theme
// cannot `npm install @parsina/framework` (its own `digits.ts` header says why); the
// alembic backfill re-implements the rules in SQL on purpose, because a migration is a
// historical record of what a database was actually given and must not change meaning
// when a source file changes. What holds them together is not a shared module — it is a
// shared CASE TABLE. `PhoneNumbersTest` carries `test_phone.py`'s cases, `test_phone.py`
// carries the migration's, and `ui/lib/phone.test.js` beside this file carries
// `test_phone.py`'s. Adding a country is one row here and one row in `countries.ts`.
//
// ═══════════════════════════════════════════════════════════════════════════════
// WHY THIS EXISTS AT ALL
//
// A phone number is the only handle joining a walk-in patient record — typed at the
// clinic desk, on paper, in a hurry — to the Keycloak account that person later
// registers with themselves. The two are typed by different people, years apart, in
// whatever form each found natural: the desk's Persian-digit spelling, and
// `+98 912 345 6789` in the signup form. Compared literally they are two different
// strings and the match never happens — which is how a doctor whose realm record held
// `+989199118259` ended up with a SECOND account when a desk typed `09199118259`.
//
// So the canonical form is E.164 — `+`, country code, national significant number, ASCII
// digits and nothing else — and every comparison goes through `normalizePhone`.
//
// ═══════════════════════════════════════════════════════════════════════════════
// THE ONE PROMISE THIS FILE MAKES
//
//   With no options, `normalizePhone` is byte-identical to `phone.py#normalize_phone`
//   and `PhoneNumbers.normalize` for EVERY INPUT — not merely for the rows of
//   tests/test_phone.py — and is idempotent.
//
// "Every input" and "every row of the table" are not the same promise, and the weaker one
// was not enough: 74 real Iranian ranges written as `+9901234567` came back as
// `+9901234567` while both twins answered `+989901234567`, and 61 spellings the twins
// accept (`+0…`, `+00…`, `00<national>`, `+<national>`) were refused outright. Every one
// of those passed a green suite, because none of them was a row in the table.
//
// So the twins' algorithm is not APPROXIMATED here by a catalog that happens to contain
// Iran — it is TRANSCRIBED, in `peelIranianMobile`, and runs before the catalog is
// consulted at all. Everything else — countries, landlines, the picker — is the
// generalisation layered around it, and reaches a string only once the peel has declined
// it. `phone.test.js` executes the two implementations against each other over a
// generated corpus, so the promise is checked rather than asserted.
//
// ═══════════════════════════════════════════════════════════════════════════════
// TWO JOBS, NOT ONE
//
// `compactPhone` is LENIENT and `parsePhone` is STRICT, and the split is on purpose:
//
//   - A FIELD filters what a human may put in a box. Typing a word after a number should
//     make the letters simply not appear — the user watches them not arrive and nothing
//     is "rejected". That is `compactPhone`, and `PhoneInput` is its only real caller.
//   - A CANONICALISER judges a string that arrived from a database, an import or another
//     system, and can afford to refuse: `"09123456789abc"` is not a number with junk on
//     it, it is a string we do not understand, and guessing would be worse than
//     declining. That is `parsePhone`, and everything else calls it.
//
// Every non-field caller wants the second one.
//
// ═══════════════════════════════════════════════════════════════════════════════
// AND A THIRD JOB: READING
//
// DISPLAYING A PHONE IS NOT VALIDATING IT.
//
// `parsePhone`/`normalizePhone`/`isValidPhone`/`toNational` all JUDGE — they are the
// converters, and `''` is a verdict they are entitled to return. A READ SURFACE is not
// entitled to it. The value is already in the column; somebody stored it; a person is
// looking at the screen for it. Showing nothing, or showing `+98…` where a human expects
// `021…`, is the only way a read can fail.
//
// So every read goes through `forDisplay`, which is `toNational` with `allowLandline`
// ALWAYS on and the raw value as its fallback, and which therefore never blanks and never
// refuses. Restricting to mobiles belongs on the INPUT — `PhoneInput`, where a desk is
// still typing — and has no meaning at all on a value already written.
//
// The exports, by which job they do:
//
//   INPUT (lenient, shapes a keystroke)   compactPhone, foldDigits
//   CONVERT/VALIDATE (strict, may refuse) parsePhone, normalizePhone, isValidPhone,
//                                         toNational, lookupVariants
//   READ (never refuses)                  forDisplay, maskPhone
//   CATALOG                               COUNTRIES, DEFAULT_COUNTRY, findByIso2,
//                                         findByDialCode, countryName, SEPARATORS
// The extension is NOT optional here, and the omission was a real break.
//
// The barrel resolves either spelling because a bundler is doing the resolving.
// But this module is imported DIRECTLY by DOM-free logic that runs under Node's
// own ESM resolver — the patient and student apps do exactly that, deliberately,
// so a `node` test environment does not pull raw JSX through the barrel. Node
// does not guess extensions, so `'./money'` failed there with
// ERR_MODULE_NOT_FOUND naming a file that plainly exists.
// Money — the one place the toman/rial boundary lives.
//
// Every service, every gRPC message and every GraphQL field in Parsina carries WHOLE
// RIALS. Iranian clinics quote, type and read TOMAN. Ten rials to the toman, and the
// conversion happens here, at the display edge, and nowhere else.
//
// Getting this wrong is not a cosmetic bug. A rial figure printed under a toman label
// reads as ten times the money — a 500,000 ت visit shows as 5,000,000 ت — and a toman
// figure typed into a rial field bills a tenth of what the cashier meant. Both of those
// shipped, in opposite directions, on the same screen.
//
// So: rials cross the wire, toman meets the human. Anything reaching for
// `.toLocaleString()` on a raw rial value is a bug.
const $ca1f40e638c62a9a$export$166519e0fc2d4fb3 = 10;
const $ca1f40e638c62a9a$export$d3105a4d9be2f59 = (rial)=>rial == null || rial === '' || !Number.isFinite(Number(rial)) ? null : Number(rial) / $ca1f40e638c62a9a$export$166519e0fc2d4fb3;
const $ca1f40e638c62a9a$export$496c2c39d7e0791 = (toman)=>{
    const n = Number(String(toman ?? '').replace(/[,٬\s]/g, ''));
    return Number.isFinite(n) ? Math.round(n * $ca1f40e638c62a9a$export$166519e0fc2d4fb3) : NaN;
};
function $ca1f40e638c62a9a$export$1736ebd23f2adeaf(rial) {
    const t = $ca1f40e638c62a9a$export$d3105a4d9be2f59(rial);
    if (t == null) return "\u2014";
    // Sub-toman precision cannot exist (prices are entered in toman) but a percentage
    // discount can land on a half-toman; show it rather than silently rounding money away.
    return t.toLocaleString('fa-IR', {
        maximumFractionDigits: 1
    });
}
function $ca1f40e638c62a9a$export$cbc4bde7d9461cfb(n) {
    if (n == null || n === '' || !Number.isFinite(Number(n))) return "\u2014";
    return Number(n).toLocaleString('fa-IR');
}
function $ca1f40e638c62a9a$export$3d047decf6215cd7(input) {
    if (input == null || String(input).trim() === '') return NaN;
    return $ca1f40e638c62a9a$export$496c2c39d7e0791($ca1f40e638c62a9a$var$toAsciiDigits(input));
}
// Persian/Arabic-Indic digits → ASCII, so a pasted or typed «۵۰۰۰۰۰» parses.
function $ca1f40e638c62a9a$var$toAsciiDigits(input) {
    return String(input).replace(/[۰-۹]/g, (d)=>String("\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9".indexOf(d))).replace(/[٠-٩]/g, (d)=>String("\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669".indexOf(d)));
}
function $ca1f40e638c62a9a$export$8a2f5adb56df4f49(input, allowDecimal = false, numerals = $ca1f40e638c62a9a$export$4b87c97d2471ab43) {
    let raw = String(input ?? '');
    // A locale whose decimal mark is not «.» (Persian uses «٫») would otherwise have
    // it stripped as punctuation, silently turning «۱٫۵» into «۱۵». Grouping marks
    // need no such care — they are non-digits and are meant to go.
    if (allowDecimal && numerals.decimal !== '.') raw = raw.split(numerals.decimal).join('.');
    let s = $ca1f40e638c62a9a$var$toAsciiDigits(raw).replace(allowDecimal ? /[^\d.]/g : /\D/g, '');
    if (allowDecimal) {
        const [intPart, ...rest] = s.split('.');
        if (rest.length) s = `${intPart}.${rest.join('')}`; // collapse extra dots
    }
    return s;
}
function $ca1f40e638c62a9a$export$302430bce3371cb8(value, numerals = $ca1f40e638c62a9a$export$4b87c97d2471ab43) {
    if (value == null || value === '') return '';
    const s = String(value);
    const neg = s.startsWith('-') ? '-' : '';
    const [intPart, ...rest] = (neg ? s.slice(1) : s).split('.');
    const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, numerals.group);
    const out = neg + (rest.length ? `${grouped}${numerals.decimal}${rest.join('')}` : grouped);
    // Only the ASCII digits are remapped; the separators are already the locale's.
    return numerals === $ca1f40e638c62a9a$export$4b87c97d2471ab43 ? out : out.replace(/\d/g, (d)=>numerals.digits[Number(d)]);
}
const $ca1f40e638c62a9a$export$4b87c97d2471ab43 = Object.freeze({
    locale: 'en',
    digits: Object.freeze([
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9'
    ]),
    group: ',',
    decimal: '.'
});
const $ca1f40e638c62a9a$var$numeralsCache = new Map([
    [
        'en',
        $ca1f40e638c62a9a$export$4b87c97d2471ab43
    ]
]);
function $ca1f40e638c62a9a$export$20975da26e036f6b(locale) {
    const key = locale || 'en';
    const hit = $ca1f40e638c62a9a$var$numeralsCache.get(key);
    if (hit) return hit;
    let resolved = $ca1f40e638c62a9a$export$4b87c97d2471ab43;
    try {
        const plain = new Intl.NumberFormat(key, {
            useGrouping: false
        });
        const digits = Array.from({
            length: 10
        }, (_, d)=>plain.format(d));
        // 1000.1 exercises both separators in one pass; a locale missing either
        // (none in practice) falls back to the Latin one rather than to undefined.
        const parts = new Intl.NumberFormat(key, {
            useGrouping: true
        }).formatToParts(1000.1);
        const part = (type, fallback)=>parts.find((p)=>p.type === type)?.value ?? fallback;
        resolved = Object.freeze({
            locale: key,
            digits: Object.freeze(digits),
            group: part('group', ','),
            decimal: part('decimal', '.')
        });
    } catch  {
        // An unsupported or malformed tag is a caller bug, not a reason to stop
        // rendering a price. Latin digits are always readable.
        resolved = $ca1f40e638c62a9a$export$4b87c97d2471ab43;
    }
    $ca1f40e638c62a9a$var$numeralsCache.set(key, resolved);
    return resolved;
}
function $ca1f40e638c62a9a$export$594d280e896fc02b(fallback = 'fa') {
    if (typeof document === 'undefined') return fallback;
    return document.documentElement?.getAttribute('lang') || fallback;
}


// ─────────────────────────────────────────────────────────────────────────────
// Digits
// ─────────────────────────────────────────────────────────────────────────────
/** Persian U+06F0–U+06F9 — the default on an Iranian keyboard. */ const $412e1a8a99c19c1a$var$FA_ZERO = 0x06f0;
/** Arabic-Indic U+0660–U+0669 — Arabic-locale keyboards and some legacy imports. */ const $412e1a8a99c19c1a$var$AR_ZERO = 0x0660;
/** Fullwidth U+FF10–U+FF19 — emitted by some IME keyboards. */ const $412e1a8a99c19c1a$var$FW_ZERO = 0xff10;
function $412e1a8a99c19c1a$export$522be3011864bb18(raw) {
    if (typeof raw !== 'string') return '';
    let out = '';
    for(let i = 0; i < raw.length; i++){
        const c = raw.charCodeAt(i);
        if (c >= $412e1a8a99c19c1a$var$FA_ZERO && c <= $412e1a8a99c19c1a$var$FA_ZERO + 9) out += String.fromCharCode(48 + (c - $412e1a8a99c19c1a$var$FA_ZERO));
        else if (c >= $412e1a8a99c19c1a$var$AR_ZERO && c <= $412e1a8a99c19c1a$var$AR_ZERO + 9) out += String.fromCharCode(48 + (c - $412e1a8a99c19c1a$var$AR_ZERO));
        else if (c >= $412e1a8a99c19c1a$var$FW_ZERO && c <= $412e1a8a99c19c1a$var$FW_ZERO + 9) out += String.fromCharCode(48 + (c - $412e1a8a99c19c1a$var$FW_ZERO));
        else out += raw[i];
    }
    return out;
}
const $412e1a8a99c19c1a$export$bc4e24532d262f45 = " 	\r\n\f\v\xa0\u202F\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u205F\u3000\u200B\u200C\u200D\u200E\u200F\u061C\uFEFF-\u2010\u2011\u2012\u2013\u2014\u2015\u2212()[]{}<>._/\\|,;:*#'\"`"; // everything else a desk has been seen to type
const $412e1a8a99c19c1a$var$SEPARATOR_SET = new Set($412e1a8a99c19c1a$export$bc4e24532d262f45.split(''));
const $412e1a8a99c19c1a$var$stripSeparators = (s)=>{
    let out = '';
    for(let i = 0; i < s.length; i++)if (!$412e1a8a99c19c1a$var$SEPARATOR_SET.has(s[i])) out += s[i];
    return out;
};
/**
 * What must remain once decoration is gone: digits, optionally introduced by ONE leading
 * `+`. Anything else — a letter, a second `+`, an interior symbol we did not list — means
 * this string is not a phone number.
 */ const $412e1a8a99c19c1a$var$DIGITS_ONLY = /^\+?[0-9]+$/;
/**
 * The national significant number of an Iranian mobile: ten digits, the first a 9.
 * `phone.py#_IR_MOBILE` character for character (`\d` and `[0-9]` are the same set here,
 * and Iran's catalog row spells the same rule `/^9\d{9}$/`).
 *
 * It is written out separately from that row because the twins' peel below is not a
 * catalog lookup and must not become one — see `peelIranianMobile`.
 */ const $412e1a8a99c19c1a$var$IR_MOBILE = /^9[0-9]{9}$/;
/** E.164 caps the whole number — country code included — at 15 digits. The floor is a
 *  sanity bound, not a standard: no plan in this catalog is shorter. */ const $412e1a8a99c19c1a$var$E164_MIN_DIGITS = 7;
const $412e1a8a99c19c1a$var$E164_MAX_DIGITS = 15;
function $412e1a8a99c19c1a$export$2ae1a93e018170a7(raw) {
    const ascii = $412e1a8a99c19c1a$var$stripSeparators($412e1a8a99c19c1a$export$522be3011864bb18(raw));
    const prefix = ascii.startsWith('+') ? '+' : '';
    return prefix + ascii.replace(/\D/g, '');
}
const $412e1a8a99c19c1a$export$4d78c43b7fa734a7 = Object.freeze([
    Object.freeze({
        iso2: 'IR',
        dial: '98',
        en: 'Iran',
        fa: "\u0627\u06CC\u0631\u0627\u0646",
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        nsnPattern: /^9\d{9}$/,
        example: '09121234567'
    }),
    Object.freeze({
        iso2: 'AF',
        dial: '93',
        en: 'Afghanistan',
        fa: "\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0701234567'
    }),
    Object.freeze({
        iso2: 'AM',
        dial: '374',
        en: 'Armenia',
        fa: "\u0627\u0631\u0645\u0646\u0633\u062A\u0627\u0646",
        trunk: '0',
        nsnMin: 8,
        nsnMax: 8,
        example: '077123456'
    }),
    Object.freeze({
        iso2: 'AU',
        dial: '61',
        en: 'Australia',
        fa: "\u0627\u0633\u062A\u0631\u0627\u0644\u06CC\u0627",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0412345678'
    }),
    Object.freeze({
        iso2: 'AT',
        dial: '43',
        en: 'Austria',
        fa: "\u0627\u062A\u0631\u06CC\u0634",
        trunk: '0',
        nsnMin: 7,
        nsnMax: 13,
        example: '06641234567'
    }),
    Object.freeze({
        iso2: 'AZ',
        dial: '994',
        en: 'Azerbaijan',
        fa: "\u0622\u0630\u0631\u0628\u0627\u06CC\u062C\u0627\u0646",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0401234567'
    }),
    Object.freeze({
        iso2: 'BH',
        dial: '973',
        en: 'Bahrain',
        fa: "\u0628\u062D\u0631\u06CC\u0646",
        nsnMin: 8,
        nsnMax: 8,
        example: '36001234'
    }),
    Object.freeze({
        iso2: 'BE',
        dial: '32',
        en: 'Belgium',
        fa: "\u0628\u0644\u0698\u06CC\u06A9",
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0470123456'
    }),
    Object.freeze({
        iso2: 'BR',
        dial: '55',
        en: 'Brazil',
        fa: "\u0628\u0631\u0632\u06CC\u0644",
        trunk: '0',
        nsnMin: 10,
        nsnMax: 11,
        example: '11912345678'
    }),
    Object.freeze({
        iso2: 'CA',
        dial: '1',
        en: 'Canada',
        fa: "\u06A9\u0627\u0646\u0627\u062F\u0627",
        nsnMin: 10,
        nsnMax: 10,
        example: '4165550123'
    }),
    Object.freeze({
        iso2: 'CN',
        dial: '86',
        en: 'China',
        fa: "\u0686\u06CC\u0646",
        trunk: '0',
        nsnMin: 7,
        nsnMax: 12,
        example: '13123456789'
    }),
    Object.freeze({
        iso2: 'CY',
        dial: '357',
        en: 'Cyprus',
        fa: "\u0642\u0628\u0631\u0633",
        nsnMin: 8,
        nsnMax: 8,
        example: '96123456'
    }),
    Object.freeze({
        iso2: 'DK',
        dial: '45',
        en: 'Denmark',
        fa: "\u062F\u0627\u0646\u0645\u0627\u0631\u06A9",
        nsnMin: 8,
        nsnMax: 8,
        example: '20123456'
    }),
    Object.freeze({
        iso2: 'FI',
        dial: '358',
        en: 'Finland',
        fa: "\u0641\u0646\u0644\u0627\u0646\u062F",
        trunk: '0',
        nsnMin: 6,
        nsnMax: 12,
        example: '0401234567'
    }),
    Object.freeze({
        iso2: 'FR',
        dial: '33',
        en: 'France',
        fa: "\u0641\u0631\u0627\u0646\u0633\u0647",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0612345678'
    }),
    Object.freeze({
        iso2: 'GE',
        dial: '995',
        en: 'Georgia',
        fa: "\u06AF\u0631\u062C\u0633\u062A\u0627\u0646",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '555123456'
    }),
    Object.freeze({
        iso2: 'DE',
        dial: '49',
        en: 'Germany',
        fa: "\u0622\u0644\u0645\u0627\u0646",
        trunk: '0',
        nsnMin: 6,
        nsnMax: 12,
        example: '015112345678'
    }),
    Object.freeze({
        iso2: 'GR',
        dial: '30',
        en: 'Greece',
        fa: "\u06CC\u0648\u0646\u0627\u0646",
        nsnMin: 10,
        nsnMax: 10,
        example: '6912345678'
    }),
    Object.freeze({
        iso2: 'HU',
        dial: '36',
        en: 'Hungary',
        fa: "\u0645\u062C\u0627\u0631\u0633\u062A\u0627\u0646",
        trunk: '06',
        nsnMin: 8,
        nsnMax: 9,
        example: '06201234567'
    }),
    Object.freeze({
        iso2: 'IN',
        dial: '91',
        en: 'India',
        fa: "\u0647\u0646\u062F",
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '9812345678'
    }),
    Object.freeze({
        iso2: 'ID',
        dial: '62',
        en: 'Indonesia',
        fa: "\u0627\u0646\u062F\u0648\u0646\u0632\u06CC",
        trunk: '0',
        nsnMin: 8,
        nsnMax: 12,
        example: '081234567890'
    }),
    Object.freeze({
        iso2: 'IQ',
        dial: '964',
        en: 'Iraq',
        fa: "\u0639\u0631\u0627\u0642",
        trunk: '0',
        nsnMin: 8,
        nsnMax: 10,
        example: '07912345678'
    }),
    Object.freeze({
        iso2: 'IT',
        dial: '39',
        en: 'Italy',
        fa: "\u0627\u06CC\u062A\u0627\u0644\u06CC\u0627",
        nsnMin: 6,
        nsnMax: 11,
        example: '3123456789'
    }),
    Object.freeze({
        iso2: 'JP',
        dial: '81',
        en: 'Japan',
        fa: "\u0698\u0627\u067E\u0646",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 10,
        example: '09012345678'
    }),
    Object.freeze({
        iso2: 'KZ',
        dial: '7',
        en: 'Kazakhstan',
        fa: "\u0642\u0632\u0627\u0642\u0633\u062A\u0627\u0646",
        trunk: '8',
        nsnMin: 10,
        nsnMax: 10,
        example: '87011234567'
    }),
    Object.freeze({
        iso2: 'KW',
        dial: '965',
        en: 'Kuwait',
        fa: "\u06A9\u0648\u06CC\u062A",
        nsnMin: 8,
        nsnMax: 8,
        example: '50012345'
    }),
    Object.freeze({
        iso2: 'LB',
        dial: '961',
        en: 'Lebanon',
        fa: "\u0644\u0628\u0646\u0627\u0646",
        trunk: '0',
        nsnMin: 7,
        nsnMax: 8,
        example: '03123456'
    }),
    Object.freeze({
        iso2: 'MY',
        dial: '60',
        en: 'Malaysia',
        fa: "\u0645\u0627\u0644\u0632\u06CC",
        trunk: '0',
        nsnMin: 8,
        nsnMax: 10,
        example: '0123456789'
    }),
    Object.freeze({
        iso2: 'NL',
        dial: '31',
        en: 'Netherlands',
        fa: "\u0647\u0644\u0646\u062F",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0612345678'
    }),
    Object.freeze({
        iso2: 'NZ',
        dial: '64',
        en: 'New Zealand',
        fa: "\u0646\u06CC\u0648\u0632\u06CC\u0644\u0646\u062F",
        trunk: '0',
        nsnMin: 8,
        nsnMax: 10,
        example: '0211234567'
    }),
    Object.freeze({
        iso2: 'NO',
        dial: '47',
        en: 'Norway',
        fa: "\u0646\u0631\u0648\u0698",
        nsnMin: 8,
        nsnMax: 8,
        example: '40612345'
    }),
    Object.freeze({
        iso2: 'OM',
        dial: '968',
        en: 'Oman',
        fa: "\u0639\u0645\u0627\u0646",
        nsnMin: 8,
        nsnMax: 8,
        example: '92123456'
    }),
    Object.freeze({
        iso2: 'PK',
        dial: '92',
        en: 'Pakistan',
        fa: "\u067E\u0627\u06A9\u0633\u062A\u0627\u0646",
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '03012345678'
    }),
    Object.freeze({
        iso2: 'PL',
        dial: '48',
        en: 'Poland',
        fa: "\u0644\u0647\u0633\u062A\u0627\u0646",
        nsnMin: 9,
        nsnMax: 9,
        example: '512345678'
    }),
    Object.freeze({
        iso2: 'QA',
        dial: '974',
        en: 'Qatar',
        fa: "\u0642\u0637\u0631",
        nsnMin: 8,
        nsnMax: 8,
        example: '33123456'
    }),
    Object.freeze({
        iso2: 'RU',
        dial: '7',
        en: 'Russia',
        fa: "\u0631\u0648\u0633\u06CC\u0647",
        trunk: '8',
        nsnMin: 10,
        nsnMax: 10,
        example: '89123456789'
    }),
    Object.freeze({
        iso2: 'SA',
        dial: '966',
        en: 'Saudi Arabia',
        fa: "\u0639\u0631\u0628\u0633\u062A\u0627\u0646 \u0633\u0639\u0648\u062F\u06CC",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0501234567'
    }),
    Object.freeze({
        iso2: 'SG',
        dial: '65',
        en: 'Singapore',
        fa: "\u0633\u0646\u06AF\u0627\u067E\u0648\u0631",
        nsnMin: 8,
        nsnMax: 8,
        example: '81234567'
    }),
    Object.freeze({
        iso2: 'ZA',
        dial: '27',
        en: 'South Africa',
        fa: "\u0622\u0641\u0631\u06CC\u0642\u0627\u06CC \u062C\u0646\u0648\u0628\u06CC",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0821234567'
    }),
    Object.freeze({
        iso2: 'ES',
        dial: '34',
        en: 'Spain',
        fa: "\u0627\u0633\u067E\u0627\u0646\u06CC\u0627",
        nsnMin: 9,
        nsnMax: 9,
        example: '612345678'
    }),
    Object.freeze({
        iso2: 'SE',
        dial: '46',
        en: 'Sweden',
        fa: "\u0633\u0648\u0626\u062F",
        trunk: '0',
        nsnMin: 7,
        nsnMax: 13,
        example: '0701234567'
    }),
    Object.freeze({
        iso2: 'CH',
        dial: '41',
        en: 'Switzerland',
        fa: "\u0633\u0648\u0626\u06CC\u0633",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0781234567'
    }),
    Object.freeze({
        iso2: 'SY',
        dial: '963',
        en: 'Syria',
        fa: "\u0633\u0648\u0631\u06CC\u0647",
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0944567890'
    }),
    Object.freeze({
        iso2: 'TJ',
        dial: '992',
        en: 'Tajikistan',
        fa: "\u062A\u0627\u062C\u06CC\u06A9\u0633\u062A\u0627\u0646",
        nsnMin: 9,
        nsnMax: 9,
        example: '917123456'
    }),
    Object.freeze({
        iso2: 'TH',
        dial: '66',
        en: 'Thailand',
        fa: "\u062A\u0627\u06CC\u0644\u0646\u062F",
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0812345678'
    }),
    Object.freeze({
        iso2: 'TR',
        dial: '90',
        en: "T\xfcrkiye",
        fa: "\u062A\u0631\u06A9\u06CC\u0647",
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '05321234567'
    }),
    Object.freeze({
        iso2: 'TM',
        dial: '993',
        en: 'Turkmenistan',
        fa: "\u062A\u0631\u06A9\u0645\u0646\u0633\u062A\u0627\u0646",
        trunk: '8',
        nsnMin: 8,
        nsnMax: 8,
        example: '65123456'
    }),
    Object.freeze({
        iso2: 'UA',
        dial: '380',
        en: 'Ukraine',
        fa: "\u0627\u0648\u06A9\u0631\u0627\u06CC\u0646",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0501234567'
    }),
    Object.freeze({
        iso2: 'AE',
        dial: '971',
        en: 'United Arab Emirates',
        fa: "\u0627\u0645\u0627\u0631\u0627\u062A \u0645\u062A\u062D\u062F\u0647\u0654 \u0639\u0631\u0628\u06CC",
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0501234567'
    }),
    Object.freeze({
        iso2: 'GB',
        dial: '44',
        en: 'United Kingdom',
        fa: "\u0628\u0631\u06CC\u062A\u0627\u0646\u06CC\u0627",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 10,
        example: '07400123456'
    }),
    Object.freeze({
        iso2: 'US',
        dial: '1',
        en: 'United States',
        fa: "\u0627\u06CC\u0627\u0644\u0627\u062A \u0645\u062A\u062D\u062F\u0647",
        nsnMin: 10,
        nsnMax: 10,
        example: '2025550123'
    }),
    Object.freeze({
        iso2: 'UZ',
        dial: '998',
        en: 'Uzbekistan',
        fa: "\u0627\u0632\u0628\u06A9\u0633\u062A\u0627\u0646",
        nsnMin: 9,
        nsnMax: 9,
        example: '901234567'
    })
]);
const $412e1a8a99c19c1a$export$84b76667b0a9e7b4 = $412e1a8a99c19c1a$export$4d78c43b7fa734a7[0];
function $412e1a8a99c19c1a$export$586b3eaa727579f5(iso2) {
    if (typeof iso2 !== 'string') return undefined;
    const key = iso2.toUpperCase();
    return $412e1a8a99c19c1a$export$4d78c43b7fa734a7.find((c)=>c.iso2 === key);
}
function $412e1a8a99c19c1a$export$21894a57509f6ed5(digits) {
    if (typeof digits !== 'string') return undefined;
    let best;
    for (const country of $412e1a8a99c19c1a$export$4d78c43b7fa734a7){
        if (!digits.startsWith(country.dial)) continue;
        if (best === undefined || country.dial.length > best.dial.length) best = country;
    }
    return best;
}
function $412e1a8a99c19c1a$export$3162e773cd568eb(country, locale) {
    if (!country) return '';
    const tag = locale || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)();
    return String(tag).split('-')[0] === 'fa' ? country.fa : country.en;
}
// ─────────────────────────────────────────────────────────────────────────────
// The one parse
// ─────────────────────────────────────────────────────────────────────────────
/**
 * @typedef {'required'|'tooShort'|'tooLong'|'notMobile'|'invalid'} PhoneProblem
 * Why a number was refused. Each one gets its own message: "invalid" alone tells the
 * user nothing about which digit to go looking for.
 */ /**
 * @typedef {Object} PhoneParse
 * @property {boolean} ok
 * @property {string}  e164      `'+989121234567'`, or `''` when `ok` is false.
 * @property {string}  national  `'09121234567'`, or `''` when `ok` is false — and also
 *                               `''` for an accepted number whose country is not in the
 *                               catalog, because there is no national form to render
 *                               without knowing the plan.
 * @property {Country} country   The country the MESSAGE should name: the one the number
 *                               claims where it claimed one, otherwise the selected one.
 * @property {PhoneProblem|null} problem
 */ /**
 * @typedef {Object} PhoneOptions
 * @property {Country|string} [country]        A `Country` record OR an iso2 string
 *                                             (`{ country: 'TR' }`), so no caller has to
 *                                             import the catalog to name a country.
 *                                             Default: Iran.
 * @property {boolean}        [allowLandline]  Drop the country's `nsnPattern`. Iran only,
 *                                             in practice. Default: false.
 */ const $412e1a8a99c19c1a$var$resolveCountry = (c)=>(typeof c === 'string' ? $412e1a8a99c19c1a$export$586b3eaa727579f5(c) : c) || $412e1a8a99c19c1a$export$84b76667b0a9e7b4;
/** Does this NSN look like one of `country`'s? Length, plus — where the country declares
 *  one and the caller has not waived it — a shape. */ function $412e1a8a99c19c1a$var$fitsNsn(nsn, country, allowLandline) {
    if (nsn.length < country.nsnMin || nsn.length > country.nsnMax) return false;
    if (allowLandline || country.nsnPattern === undefined) return true;
    return country.nsnPattern.test(nsn);
}
/**
 * Drop a leading trunk prefix — the digits a number wears only when it is dialled INSIDE
 * its own country, and which are never part of the national significant number.
 *
 * **A trunk that begins with `0` comes off unconditionally.** In a plan that HAS a trunk
 * zero, no NSN begins with `0` — the zero IS the trunk, by construction — so keeping it
 * cannot produce a right answer, only one that is wrong by exactly a digit. Length bounds
 * are a check ON the NSN; they were never a way to choose whether to peel. Letting them
 * choose is what made `parsePhone('0218800000', { allowLandline: true })` — a Tehran
 * landline one digit short — answer `+980218800000`: the peeled body is nine digits and
 * misses Iran's 10/10 window, the trunk-kept string is ten and fits it, so the trunk was
 * kept and `judge`, with the mobile pattern waived, passed it on length alone. The number
 * was stored AND redisplayed («00218800000») wrong, stably and silently.
 *
 * **A trunk that is an ordinary digit stays conditional.** Russia's, Kazakhstan's and
 * Turkmenistan's trunk is `8`, and `8121234567` is St Petersburg — a real national number
 * that BEGINS with the trunk digit. There is no structural rule to appeal to, so the
 * heuristic is the best available: peel when the result is a number the country
 * recognises, or when keeping it cannot produce one.
 *
 * The `!fitsNsn(candidate)` half of that heuristic is also what makes a short Russian
 * number report "too short" rather than a shape complaint.
 *
 * ONE helper, used on BOTH branches of `parsePhone`. The live login theme peels the trunk
 * only on the national path, which is why it gets `"+98 0912 345 6789"` and
 * `"00980912 3456789"` wrong — and both of those are rows in tests/test_phone.py, i.e.
 * shapes this platform's data genuinely holds. This is the single rule here that the theme
 * does not yet have; it is filed as a follow-up against parsina.keycloakify. The theme's
 * direction is the safe one (it refuses rather than mis-reads), so the symptom there is a
 * rejected login and never a wrong number.
 *
 * What this function does NOT do is peel a SECOND zero. One trunk comes off; a string
 * wearing two (`+43 0 0664…`) is not a number this module claims to understand, and
 * `judge` refuses it rather than guessing which zero was the trunk — see the guard there.
 */ function $412e1a8a99c19c1a$var$peelTrunk(candidate, country, allowLandline) {
    const trunk = country.trunk;
    if (!trunk || !candidate.startsWith(trunk) || candidate.length <= trunk.length) return candidate;
    const without = candidate.slice(trunk.length);
    if (trunk[0] === '0') return without;
    return $412e1a8a99c19c1a$var$fitsNsn(without, country, allowLandline) || !$412e1a8a99c19c1a$var$fitsNsn(candidate, country, allowLandline) ? without : candidate;
}
/**
 * Iran's rule, exactly as the twins write it: drop a leading `+`, then peel `00`, then
 * the country code `98` when what is left would be too long to be an NSN, then the trunk
 * `0` — and require the remainder to be `9` plus nine digits.
 *
 * A LINEAR PEEL, not a catalog lookup, and the difference is the whole point of this
 * function existing. The peel never asks which country `990…` belongs to, so
 * `+9901234567` is read as the 0990 mobile it is. Asking the catalog instead is how this
 * kit used to answer `+9901234567` where both twins answer `+989901234567`: no row starts
 * with `990`, the number fell through to the generic "some foreign country" accept, and
 * `lookupVariants` then offered ONE spelling. A Keycloak probe in that spelling misses the
 * same person stored as `09901234567`, and the auto-provisioning flow mints a duplicate
 * account — the precise harm this module exists to prevent. Seventy-four live Iranian
 * ranges (0940–0949, 0950–0959, 0960–0962, 0967, 0969, 0970, 0972, 0975–0979, 0990, 0991,
 * 0996, 0997, 0999) were wrong that way.
 *
 * Line for line this is `phone.py#normalize_phone`'s body after its shared prelude, down
 * to the sequential `if`s — they are NOT mutually exclusive there and must not become so
 * here, because `+00989…` wears all three prefixes at once. `phone.test.js` executes this
 * against the real Python over a generated corpus so the two cannot drift silently.
 *
 * @param {string} s  Folded, separator-stripped, already matched against `DIGITS_ONLY`.
 * @returns {string|null}  The ten-digit NSN, or `null` when this is not an Iranian mobile.
 */ function $412e1a8a99c19c1a$var$peelIranianMobile(s) {
    let t = s;
    if (t[0] === '+') t = t.slice(1);
    if (t.startsWith('00')) t = t.slice(2);
    // The `length > 10` guard is what keeps 9812345678 — an ordinary 0981 mobile — from
    // being read as country code 98 followed by an eight-digit stub.
    if (t.startsWith('98') && t.length > 10) t = t.slice(2);
    if (t.startsWith('0')) t = t.slice(1);
    return $412e1a8a99c19c1a$var$IR_MOBILE.test(t) ? t : null;
}
/**
 * The last word on an NSN once the prefixes are off it.
 *
 * The first guard is not a length rule and deliberately runs before the length rules: in a
 * plan whose trunk prefix is a zero, an NSN that still BEGINS with one is not a number
 * this module can read. `peelTrunk` takes exactly one trunk off, so a leading zero here
 * means the string wore its trunk twice (`+43 0 0664 123 4567`, and 94 shapes like it
 * across 17 of the 52 rows). Accepting it was worse than refusing for a reason that has
 * nothing to do with the user's typing: `+430664123456` fed back through this module
 * peels the surviving zero and answers `+43664123456`, so the kit emitted an E.164 it
 * would later read as a DIFFERENT phone — the one thing a matching key may never do. A
 * number cannot be both, and guessing which zero was the trunk would be inventing data,
 * so the answer is `invalid` and the value is refused whole.
 *
 * Italy is the reason this is gated on the trunk rather than written as "no NSN begins
 * with 0": Italian landlines genuinely keep their leading zero (`+39 06 …` is Rome), which
 * is exactly why Italy's row carries no `trunk` at all.
 */ function $412e1a8a99c19c1a$var$judge(nsn, country, allowLandline) {
    const digits = country.dial + nsn;
    const fail = (problem)=>({
            ok: false,
            e164: '',
            national: '',
            country: country,
            problem: problem
        });
    if (country.trunk && country.trunk[0] === '0' && nsn[0] === '0') return fail('invalid');
    if (nsn.length < country.nsnMin || digits.length < $412e1a8a99c19c1a$var$E164_MIN_DIGITS) return fail('tooShort');
    if (nsn.length > country.nsnMax || digits.length > $412e1a8a99c19c1a$var$E164_MAX_DIGITS) return fail('tooLong');
    if (country.nsnPattern && !allowLandline && !country.nsnPattern.test(nsn)) return fail('notMobile');
    return {
        ok: true,
        e164: `+${digits}`,
        national: (country.trunk || '') + nsn,
        country: country,
        problem: null
    };
}
function $412e1a8a99c19c1a$export$48c6adddc5539199(raw, options = {}) {
    const selected = $412e1a8a99c19c1a$var$resolveCountry(options.country);
    const allowLandline = options.allowLandline === true;
    const fail = (problem, country = selected)=>({
            ok: false,
            e164: '',
            national: '',
            country: country,
            problem: problem
        });
    if (typeof raw !== 'string') return fail('invalid');
    let s = $412e1a8a99c19c1a$var$stripSeparators($412e1a8a99c19c1a$export$522be3011864bb18(raw));
    if (s === '') return fail('required');
    if (!$412e1a8a99c19c1a$var$DIGITS_ONLY.test(s)) return fail('invalid');
    // ── The twins ──────────────────────────────────────────────────────────────────
    // `allowLandline` does not switch this off: a landline is not an Iranian mobile, so the
    // peel declines it and the catalog below is what accepts it.
    if (selected.iso2 === 'IR') {
        const nsn = $412e1a8a99c19c1a$var$peelIranianMobile(s);
        if (nsn !== null) // Iran's trunk is `0` and its row is fixed (see COUNTRIES): `0` + NSN is the
        // national spelling, `+98` + NSN the canonical one.
        return {
            ok: true,
            e164: `+98${nsn}`,
            national: `0${nsn}`,
            country: selected,
            problem: null
        };
    }
    // ── The generalisation ─────────────────────────────────────────────────────────
    let international = false;
    if (s[0] === '+') {
        s = s.slice(1);
        international = true;
    }
    if (s.startsWith('00')) {
        s = s.slice(2);
        international = true;
    }
    if (s === '') return fail('required');
    if (international && s[0] !== '0') {
        const country = $412e1a8a99c19c1a$export$21894a57509f6ed5(s);
        if (country === undefined) {
            if (s.length < $412e1a8a99c19c1a$var$E164_MIN_DIGITS) return fail('tooShort');
            if (s.length > $412e1a8a99c19c1a$var$E164_MAX_DIGITS) return fail('tooLong');
            // Accepted, with no national form to offer and the picker left where it was.
            return {
                ok: true,
                e164: `+${s}`,
                national: '',
                country: selected,
                problem: null
            };
        }
        return $412e1a8a99c19c1a$var$judge($412e1a8a99c19c1a$var$peelTrunk(s.slice(country.dial.length), country, allowLandline), country, allowLandline);
    }
    const candidate = s.startsWith(selected.dial) && s.length > selected.nsnMax ? s.slice(selected.dial.length) : s;
    return $412e1a8a99c19c1a$var$judge($412e1a8a99c19c1a$var$peelTrunk(candidate, selected, allowLandline), selected, allowLandline);
}
function $412e1a8a99c19c1a$export$e9b617754cf28d84(raw, options) {
    return $412e1a8a99c19c1a$export$48c6adddc5539199(raw, options).e164;
}
function $412e1a8a99c19c1a$export$f9c4d85d720ef909(raw, options) {
    return $412e1a8a99c19c1a$export$e9b617754cf28d84(raw, options) !== '';
}
function $412e1a8a99c19c1a$export$317852993b4735b6(raw, options) {
    return $412e1a8a99c19c1a$export$48c6adddc5539199(raw, options).national;
}
function $412e1a8a99c19c1a$export$1069b069fb83ae5b(raw, options) {
    if (typeof raw !== 'string') return '';
    return $412e1a8a99c19c1a$export$317852993b4735b6(raw, {
        ...options,
        allowLandline: true
    }) || raw;
}
function $412e1a8a99c19c1a$export$1f64b92865689d0d(raw) {
    if (typeof raw !== 'string') return '';
    if (raw.length < 7) return raw;
    return `${raw.slice(0, 5)}***${raw.slice(-3)}`;
}
function $412e1a8a99c19c1a$export$493e0fb9b5aae030(raw, options) {
    const e164 = $412e1a8a99c19c1a$export$e9b617754cf28d84(raw, options);
    if (e164 === '') return [];
    const digits = e164.slice(1);
    const country = $412e1a8a99c19c1a$export$21894a57509f6ed5(digits);
    // An accepted number from outside the catalog has no known plan, so there is no trunk
    // prefix to add and no national spelling to guess at. One shape — the only one we
    // could ever have written.
    if (!country) return [
        e164
    ];
    const nsn = digits.slice(country.dial.length);
    const seen = new Set([
        e164,
        digits,
        `00${digits}`,
        ...country.trunk ? [
            country.trunk + nsn
        ] : [],
        nsn
    ]);
    return [
        ...seen
    ];
}



'use client';
// The one phone field. Everywhere in Parsina a human types a phone number, it types it
// here — a patient at the desk, a staff member being added, a supplier, a clinic line.
//
// ═══════════════════════════════════════════════════════════════════════════════
// WHAT IT WRITES, AND WHAT IT SHOWS — they are not the same thing, and that is the
// whole design.
//
//   `onChange` hands back **E.164 and only E.164** — `'+989121234567'`, or `''` while
//   the number is incomplete. Never an event object. The rules live in `lib/phone.js`;
//   this component owns none of them.
//
//   The BOX still shows `09121234567`, and always will. A stored `09121234567` and a
//   stored `+989121234567` render IDENTICALLY, because the draft is seeded through
//   `toNational`. Nothing on any screen changes shape on the day this ships. That is the
//   migration cushion, and it is what lets the wire format change without a coordinated
//   three-app cutover.
//
// Why a bare string rather than the `{ target: { value } }` shim this component used to
// emit: `MoneyInput` already broke that pattern in this kit and states the rule in its
// own header — "Value in and value out are both the BARE ASCII numeric string… onChange
// is handed that string directly, not an event" — and `JalaliDatePicker` does the same.
// Entrenching a fake event in the one component whose output is a MATCHING KEY is the
// wrong direction. The second argument carries the rest: `{ ok, problem, e164, national,
// country, draft }`, for the rare caller that needs the national form or the reason.
//
// ═══════════════════════════════════════════════════════════════════════════════
// THE VALUE/DRAFT SPLIT — the subtlest thing in this file, and the thing a later
// "simplification" will break.
//
//   - The PARENT owns the canonical value (E.164). The COMPONENT owns the visible draft.
//   - The draft is seeded from the value on mount, and RE-seeded only when the `value`
//     PROP itself changed and the two no longer normalize to the same number. So typing
//     `0912` (parent holds `''`, draft holds `'0912'`, both normalize to `''`) does not
//     wipe the half-typed number; loading a patient re-seeds; a parent reset to `''`
//     clears it; and a parent that round-trips E.164 straight back never disturbs the
//     user's own typing.
//   - It NEVER calls `onChange` on mount or on a `value` prop change. These forms drive
//     `SaveBar` and dirty-tracking, and an emit-on-mount would mark every profile dirty
//     the moment it opened.
//
// Turning this into a plain controlled input wipes half-typed numbers on every keystroke
// — a regression visible only with a parent that round-trips through async state, which
// is why `PhoneInput.test.jsx` drives it from a real Host component.
//
// ═══════════════════════════════════════════════════════════════════════════════
// COUNTRY IS DERIVED, NEVER STORED.
//
// E.164 carries the country code inside the value, so `findByDialCode` recovers the
// picker on load. There is no `country_code` column, proto field or GraphQL field
// anywhere in this platform, and this change adds none: no schema change, no migration.
//
// ═══════════════════════════════════════════════════════════════════════════════
// DIGITS ON SCREEN ARE THE LOCALE'S; DIGITS ON THE WIRE ARE ASCII.
//
// DESIGN_SYSTEM.md §6.4: displayed digit strings — phone included — use the locale's
// digit set "with no per-surface exceptions". This field used to render ASCII always,
// on the argument that a phone number is a KEY; the key is what is EMITTED, and that is
// still ASCII E.164. What changed is only the paint: the draft stays an ASCII string in
// state, and `localize` maps it digit-for-digit on the way to the DOM — the dial chip,
// the box, the default placeholder and the example in an error message alike. The
// mapping is one character to one character, so the caret arithmetic below (which
// counts kept characters in the ASCII draft) is untouched; `compactPhone` already folds
// whatever numerals come back in. `locale` defaults to <html lang>, as in `MoneyInput`.
// ─────────────────────────────────────────────────────────────────────────────
// Copy. Persian defaults, per DESIGN.md rule 7 — the kit carries no translation
// catalogue, only a default a caller may replace.
//
// Five problems, not one: "invalid" alone tells nobody which digit to go looking for.
// The example is wrapped in U+2068 FSI … U+2069 PDI so an ASCII number inside a Persian
// sentence isolates itself without any CSS — the same reasoning as rule 8's LTR island,
// applied to a string rather than a box.
// ─────────────────────────────────────────────────────────────────────────────
const $5f69d84dab43bb31$var$isolate = (s)=>`\u2068${s}\u2069`;
const $5f69d84dab43bb31$var$DEFAULT_MESSAGES = {
    required: "\u0634\u0645\u0627\u0631\u0647 \u0645\u0648\u0628\u0627\u06CC\u0644 \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F",
    tooShort: (ctx)=>`\u{634}\u{645}\u{627}\u{631}\u{647}\u{654} ${ctx.countryName} \u{6A9}\u{648}\u{62A}\u{627}\u{647} \u{627}\u{633}\u{62A} \u{2014} \u{646}\u{645}\u{648}\u{646}\u{647}: ${$5f69d84dab43bb31$var$isolate(ctx.example)}`,
    tooLong: (ctx)=>`\u{634}\u{645}\u{627}\u{631}\u{647}\u{654} ${ctx.countryName} \u{628}\u{644}\u{646}\u{62F} \u{627}\u{633}\u{62A} \u{2014} \u{646}\u{645}\u{648}\u{646}\u{647}: ${$5f69d84dab43bb31$var$isolate(ctx.example)}`,
    notMobile: (ctx)=>`\u{627}\u{6CC}\u{646} \u{634}\u{645}\u{627}\u{631}\u{647} \u{645}\u{648}\u{628}\u{627}\u{6CC}\u{644} \u{646}\u{6CC}\u{633}\u{62A} \u{2014} \u{646}\u{645}\u{648}\u{646}\u{647}: ${$5f69d84dab43bb31$var$isolate(ctx.example)}`,
    invalid: "\u0634\u0645\u0627\u0631\u0647\u0654 \u0648\u0627\u0631\u062F\u0634\u062F\u0647 \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A"
};
/** A `Country`, an iso2 string, or nothing → a `Country`. */ const $5f69d84dab43bb31$var$asCountry = (value, fallback)=>(typeof value === 'string' ? (0, $412e1a8a99c19c1a$export$586b3eaa727579f5)(value) : value) || fallback;
/** The offered list: `Country` records or iso2 strings, defaulting to the whole catalog. */ function $5f69d84dab43bb31$var$resolveList(countries) {
    if (!Array.isArray(countries) || countries.length === 0) return 0, $412e1a8a99c19c1a$export$4d78c43b7fa734a7;
    const rows = countries.map((c)=>$5f69d84dab43bb31$var$asCountry(c, undefined)).filter(Boolean);
    return rows.length ? rows : (0, $412e1a8a99c19c1a$export$4d78c43b7fa734a7);
}
/**
 * What to put in the box for a value that arrived from somewhere else.
 *
 * A number becomes its national form. Anything else is shown AS STORED — and that rule
 * is load-bearing: a phone column in this platform can hold a note («تماس با منشی»), and
 * seeding an unparseable value to `''` would make the stored content vanish from the
 * field the moment the record opened, after which any save would silently wipe it.
 * Showing what is stored, emitting nothing until the user types, and letting the filter
 * strip it on the first keystroke is the honest behaviour.
 *
 * A number whose country is outside the catalog has no national form to render, so its
 * E.164 stands in — the alternative is a blank box over a real stored number.
 */ const $5f69d84dab43bb31$var$seedDraft = (parsed, value)=>parsed.ok ? parsed.national || parsed.e164 : typeof value === 'string' ? value : '';
/** The characters `compactPhone` keeps. Counting these is how the caret survives a
 *  separator being filtered out from under it. */ const $5f69d84dab43bb31$var$isKept = (ch)=>ch >= '0' && ch <= '9' || ch === '+';
const $5f69d84dab43bb31$var$countKept = (s)=>(0, $412e1a8a99c19c1a$export$2ae1a93e018170a7)(s).length;
const $5f69d84dab43bb31$var$PhoneInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ value: // Value — E.164 preferred, ANY legacy shape accepted (09…, +98…, 0098…, 98…, 9…,
// Persian/Arabic-Indic/fullwidth digits, separators, invisible marks).
value, onChange: onChange, onBlur: onBlur, // Country — `country` is controlled (pair it with `onCountryChange`),
// `defaultCountry` is the uncontrolled seed. Iran is a DEFAULT, not a lock.
country: countryProp, defaultCountry: defaultCountry = (0, $412e1a8a99c19c1a$export$84b76667b0a9e7b4), onCountryChange: onCountryChange, countries: // Narrow the offered list. Resolving to exactly ONE renders a static dial chip
// instead of a `<select>` — see below.
countries, allowLandline: // Drop the selected country's `nsnPattern` for this field: a supplier's or a
// clinic's number is an office line. Iran only, in practice.
allowLandline = false, // Locale — defaults to <html lang>, which every client sets via applyDocumentLocale.
locale: localeProp, messages: // Copy — each entry `string | (ctx) => string`, ctx = { country, countryName, example }.
messages, label: // Chrome — the same contract as TextInput.
label = "\u0634\u0645\u0627\u0631\u0647 \u0645\u0648\u0628\u0627\u06CC\u0644", countryLabel: countryLabel = "\u06A9\u0634\u0648\u0631", required: required, error: externalError, helperText: helperText, disabled: disabled = false, className: // `className` merges onto the bordered SHELL — the element that carries the box,
// and the one a caller sizing this field inside a 170px column means. `style` is
// the FormField's and `inputStyle` the real input's, as in `MoneyInput`.
className, style: style, inputStyle: inputStyle, // Extra props (data-testid, aria-*, name…) land on the real control.
// §17.2 requires a kit component to forward them, and a past bug was exactly this.
...rest }, ref)=>{
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const innerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const caret = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // ASCII in state, the locale's numerals in the DOM. See the header.
    const numerals = (0, $ca1f40e638c62a9a$export$20975da26e036f6b)(localeProp || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)());
    const localize = (str)=>String(str ?? '').replace(/\d/g, (d)=>numerals.digits[Number(d)]);
    const options = $5f69d84dab43bb31$var$resolveList(countries);
    const base = $5f69d84dab43bb31$var$asCountry(countryProp !== undefined ? countryProp : defaultCountry, options[0] || (0, $412e1a8a99c19c1a$export$84b76667b0a9e7b4));
    const opts = {
        allowLandline: allowLandline
    };
    // Draft and country live in ONE state object so a re-seed moves both atomically —
    // a load that changes the number and the country must never render half-applied.
    const [own, setOwn] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>{
        const parsed = (0, $412e1a8a99c19c1a$export$48c6adddc5539199)(value, {
            ...opts,
            country: base
        });
        return {
            draft: $5f69d84dab43bb31$var$seedDraft(parsed, value),
            country: parsed.ok ? parsed.country : base
        };
    });
    const country = countryProp !== undefined ? base : own.country;
    const draft = own.draft;
    // Re-seed on a `value` PROP change only. Comparing the normalized forms is what keeps
    // a parent that echoes E.164 back from rewriting what the user is still typing;
    // comparing the raw prop is what still lets a parent clear the field.
    const prevValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(value);
    if (prevValue.current !== value) {
        prevValue.current = value;
        const incoming = (0, $412e1a8a99c19c1a$export$48c6adddc5539199)(value, {
            ...opts,
            country: country
        });
        if (incoming.e164 !== (0, $412e1a8a99c19c1a$export$48c6adddc5539199)(draft, {
            ...opts,
            country: country
        }).e164) setOwn({
            draft: $5f69d84dab43bb31$var$seedDraft(incoming, value),
            country: incoming.ok ? incoming.country : country
        });
    }
    const parsed = (0, $412e1a8a99c19c1a$export$48c6adddc5539199)(draft, {
        ...opts,
        country: country
    });
    // An empty field is never an error unless the caller says it is required. Every other
    // problem is reported as it stands — including for a stored note, which genuinely is
    // not a phone number and is never silently cleared.
    const problem = parsed.problem === 'required' && !required ? null : parsed.problem;
    const copy = {
        ...$5f69d84dab43bb31$var$DEFAULT_MESSAGES,
        ...messages
    };
    const entry = problem ? copy[problem] : null;
    const internalError = typeof entry === 'function' ? entry({
        country: parsed.country,
        countryName: (0, $412e1a8a99c19c1a$export$3162e773cd568eb)(parsed.country),
        example: localize(parsed.country.example)
    }) : entry || '';
    // On blur only (`touched`), never while typing; an external `error` always wins; and
    // the error is ADVISORY — `onChange` still fires and the value is never cleared.
    const error = externalError || (touched ? internalError : '');
    const emit = (nextDraft, nextCountry)=>{
        const next = (0, $412e1a8a99c19c1a$export$48c6adddc5539199)(nextDraft, {
            ...opts,
            country: nextCountry
        });
        onChange?.(next.e164, {
            ...next,
            draft: nextDraft
        });
    };
    const handleChange = (event)=>{
        const el = event.target;
        const raw = el.value;
        // How many KEPT characters sat left of the caret. The filter removes characters, so
        // a separator typed or pasted mid-string shifts every index after it. Copied from
        // `MoneyInput.jsx`, which carries the same loop and the largest caret suite in the
        // kit; the counting is the part that has to be right.
        const keptLeft = $5f69d84dab43bb31$var$countKept(raw.slice(0, el.selectionStart ?? raw.length));
        const compact = (0, $412e1a8a99c19c1a$export$2ae1a93e018170a7)(raw);
        const international = compact.startsWith('+') || compact.startsWith('00');
        // The picker follows an EXPLICITLY international number and nothing else. A bare
        // national number means whatever the selected country says it means, so reading a
        // country out of it would be guessing. An international number whose dial code is
        // not in the catalog leaves the picker where it was — the list is not a gate.
        let nextCountry = country;
        if (international && countryProp === undefined) {
            const claimed = (0, $412e1a8a99c19c1a$export$21894a57509f6ed5)(compact.startsWith('+') ? compact.slice(1) : compact.slice(2));
            if (claimed) nextCountry = claimed;
        }
        const next = (0, $412e1a8a99c19c1a$export$48c6adddc5539199)(compact, {
            ...opts,
            country: nextCountry
        });
        // What you typed stays on screen — no rewrite under the cursor — with ONE exception:
        // a number written internationally is re-spelled nationally once it resolves,
        // because the dial code is now showing in the chip beside it and printing `+98`
        // twice in one field is not what the user wrote either.
        const nextDraft = international && next.ok && next.national ? next.national : compact;
        let pos = 0;
        let seen = 0;
        while(pos < nextDraft.length && seen < keptLeft){
            if ($5f69d84dab43bb31$var$isKept(nextDraft[pos])) seen++;
            pos++;
        }
        caret.current = pos;
        setOwn({
            draft: nextDraft,
            country: nextCountry
        });
        if (nextCountry !== country) onCountryChange?.(nextCountry);
        emit(nextDraft, nextCountry);
    };
    const handleCountry = (event)=>{
        const next = $5f69d84dab43bb31$var$asCountry(event.target.value, null);
        if (!next) return;
        // An explicit international prefix is rewritten in place; a bare national number is
        // left exactly as typed, because its MEANING changed the moment the country did.
        const compact = (0, $412e1a8a99c19c1a$export$2ae1a93e018170a7)(draft);
        let nextDraft = draft;
        if (compact.startsWith(`+${country.dial}`)) nextDraft = `+${next.dial}${compact.slice(1 + country.dial.length)}`;
        else if (compact.startsWith(`00${country.dial}`)) nextDraft = `00${next.dial}${compact.slice(2 + country.dial.length)}`;
        setOwn({
            draft: nextDraft,
            country: next
        });
        onCountryChange?.(next);
        emit(nextDraft, next);
    };
    const handleBlur = (event)=>{
        setTouched(true);
        // The one moment where moving the caret costs nothing: a number that parses is
        // re-spelled in its national form, which is the field's confirmation that it
        // understood you. The login theme does not do this because a login field is left
        // immediately; a form field that is filled and then revisited is a different
        // surface. No emit — the canonical value has not changed.
        if (parsed.ok && parsed.national && parsed.national !== draft) setOwn((s)=>({
                ...s,
                draft: parsed.national
            }));
        onBlur?.(event);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (caret.current != null && innerRef.current) {
            innerRef.current.setSelectionRange(caret.current, caret.current);
            caret.current = null;
        }
    });
    const setRefs = (node)=>{
        innerRef.current = node;
        if (typeof ref === 'function') ref(node);
        else if (ref) ref.current = node;
    };
    // A list that resolves to exactly one country gets a static chip, not a `<select>`
    // with a single option: no fake choice, no tab stop, and — the practical reason — it
    // is what keeps the whole field inside the 170px and 160px boxes `SetupViews.jsx`
    // wraps it in, and off the ~150px clipping `ProfileSection.jsx` records in its own
    // comment. No flag emoji anywhere, in either shape: DESIGN.md rule 10 bans
    // emoji-as-icon because the OS draws it, Windows Chrome renders no regional-indicator
    // pairs at all, and flags are freighted in this market. Short text is also the only
    // thing that fits.
    const single = options.length === 1;
    const testid = rest['data-testid'];
    // The error/helper line, JOINED to whatever the caller already pointed the field at —
    // never replacing it. `FormField` is passed `htmlFor`, which tells it this component
    // owns its own aria wiring, so its own join (see FormField) does not run for this
    // field and this is the only place the two ids can meet.
    //
    // Written as one value rather than an attribute before `{...rest}`, because that order
    // means a caller's `aria-describedby` OVERWRITES the message id: the field goes red,
    // and a screen reader reads the caller's hint and never says why. `MoneyInput` already
    // does it this way, for the same reason.
    const describedBy = [
        rest['aria-describedby'],
        error || helperText ? `${controlId}-message` : null
    ].filter(Boolean).join(' ') || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex items-center h-11 rounded-lg overflow-hidden bg-white border-[1.5px]', 'transition-[border-color,box-shadow] duration-150', error ? 'border-destructive shadow-ring-red focus-within:shadow-ring-red' : 'border-border focus-within:border-primary focus-within:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70', className)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "ltr",
        className: "flex items-center w-full h-full [unicode-bidi:isolate]"
    }, single ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center h-full ps-3 pe-2 shrink-0 font-sans text-[13.5px] text-muted-foreground select-none"
    }, localize(`+${country.dial}`)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "relative flex items-center h-full shrink-0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        className: "flex items-center gap-0.5 ps-3 pe-2 font-sans text-[13.5px] text-muted-foreground select-none"
    }, localize(`+${country.dial}`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "14",
        height: "14"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7 10l5 5 5-5z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        value: country.iso2,
        onChange: handleCountry,
        disabled: disabled,
        "aria-label": countryLabel,
        "data-testid": testid ? `${testid}-country` : undefined,
        className: "absolute inset-0 w-full h-full opacity-0 cursor-pointer disabled:cursor-not-allowed"
    }, (options.some((c)=>c.iso2 === country.iso2) ? options : [
        country,
        ...options
    ]).map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: c.iso2,
            value: c.iso2
        }, localize(`${(0, $412e1a8a99c19c1a$export$3162e773cd568eb)(c)} +${c.dial}`))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        className: "w-px h-5 shrink-0 bg-border"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: controlId,
        "aria-invalid": error ? true : undefined,
        ...rest,
        // A caller's placeholder is an example NUMBER like the default, and the
        // catalogues spell it in ASCII as often as not — so it gets the page's
        // numerals too, rather than being the one Latin run left in the field.
        placeholder: localize(rest.placeholder ?? country.example),
        // After `{...rest}`: the joined value is the one that must win, and it
        // already contains the caller's own.
        "aria-describedby": describedBy,
        ref: setRefs,
        type: "tel",
        inputMode: "tel",
        autoComplete: "tel",
        value: localize(draft),
        onChange: handleChange,
        onBlur: handleBlur,
        disabled: disabled,
        // The DOM `maxLength={11}` is gone: one attribute cannot express both a
        // national and an international shape, and 11 silently truncated every
        // number written as `+98…`. 20 is a cap no real number reaches after
        // filtering.
        maxLength: 20,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex-1 min-w-0 w-full h-full ps-2.5 pe-3.5 bg-transparent border-0 outline-none', 'font-sans text-[13.5px] text-foreground tracking-[0.5px]', 'disabled:cursor-not-allowed disabled:bg-transparent'),
        style: inputStyle
    }))));
});
$5f69d84dab43bb31$var$PhoneInput.displayName = 'PhoneInput';
var $5f69d84dab43bb31$export$2e2bcd8739ae039 = $5f69d84dab43bb31$var$PhoneInput;



var $acw62 = parcelRequire("acw62");


'use client';
function $6dabae5d3309de70$var$isValidNID(nid) {
    if (!/^\d{10}$/.test(nid)) return false;
    if (/^(.)\1{9}$/.test(nid)) return false;
    const d = nid.split('').map(Number);
    const sum = d.slice(0, 9).reduce((acc, n, i)=>acc + n * (10 - i), 0);
    const rem = sum % 11;
    return d[9] === (rem < 2 ? rem : 11 - rem);
}
const $6dabae5d3309de70$var$NationalIdInput = ({ label: label = "\u06A9\u062F \u0645\u0644\u06CC", required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, disabled: disabled = false, style: style, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest })=>{
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const isComplete = value?.length === 10;
    const isValid = isComplete && $6dabae5d3309de70$var$isValidNID(value);
    const isInvalid = isComplete && !isValid;
    const error = externalError || (touched && isInvalid ? "\u06A9\u062F \u0645\u0644\u06CC \u0648\u0627\u0631\u062F \u0634\u062F\u0647 \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A" : '');
    const handleChange = (e)=>{
        const v = (0, $42e05640dae453c1$export$e6aa7dbb1e28c5bd)(e.target.value).replace(/\D/g, '').slice(0, 10);
        onChange({
            target: {
                value: v
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: !error && isValid ? '' : helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: controlId,
        "aria-describedby": error || helperText ? `${controlId}-message` : undefined,
        "aria-invalid": error ? true : undefined,
        ...rest,
        type: "text",
        inputMode: "numeric",
        value: value,
        onChange: handleChange,
        onBlur: (e)=>{
            setTouched(true);
            onBlur?.(e);
        },
        placeholder: "\u06F1\u06F0 \u0631\u0642\u0645",
        disabled: disabled,
        maxLength: 10,
        dir: "ltr",
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('w-full h-11 rounded-lg font-sans text-[14px] text-foreground tracking-[1.5px]', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', 'pl-10 pr-3.5', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : isValid ? 'border-[#1A9B6C] shadow-ring-green' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70')
    }), isComplete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "img",
        "aria-label": isValid ? "\u06A9\u062F \u0645\u0644\u06CC \u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A" : "\u06A9\u062F \u0645\u0644\u06CC \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A",
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('absolute left-3 top-1/2 -translate-y-1/2 flex items-center', isValid ? 'text-[#1A9B6C]' : 'text-destructive')
    }, isValid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "17",
        height: "17"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "17",
        height: "17"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    })))), isValid && !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "m-0 text-[11.5px] font-semibold text-[#1A9B6C] leading-snug"
    }, "\u06A9\u062F \u0645\u0644\u06CC \u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A"));
};
var $6dabae5d3309de70$export$2e2bcd8739ae039 = $6dabae5d3309de70$var$NationalIdInput;



var $acw62 = parcelRequire("acw62");


'use client';
const $4fe0519cb1ec239e$var$NumberInput = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, placeholder: placeholder, unit: unit, min: min, max: max, validate: validate, disabled: disabled = false, style: style, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest })=>{
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const defaultValidate = (v)=>{
        if (!v) return '';
        const n = parseFloat(v);
        if (isNaN(n)) return "\u0645\u0642\u062F\u0627\u0631 \u0648\u0627\u0631\u062F \u0634\u062F\u0647 \u0635\u062D\u06CC\u062D \u0646\u06CC\u0633\u062A";
        if (min !== undefined && n < min) return `\u{62D}\u{62F}\u{627}\u{642}\u{644} ${min}`;
        if (max !== undefined && n > max) return `\u{62D}\u{62F}\u{627}\u{6A9}\u{62B}\u{631} ${max}`;
        return '';
    };
    const error = externalError || (touched ? internalError : '');
    const handleChange = (e)=>{
        let v = (0, $42e05640dae453c1$export$e6aa7dbb1e28c5bd)(e.target.value).replace(/[^\d.]/g, '');
        const parts = v.split('.');
        if (parts.length > 2) v = parts[0] + '.' + parts.slice(1).join('');
        onChange({
            target: {
                value: v
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: controlId,
        "aria-describedby": error || helperText ? `${controlId}-message` : undefined,
        "aria-invalid": error ? true : undefined,
        ...rest,
        type: "text",
        inputMode: "decimal",
        value: value,
        onChange: handleChange,
        onBlur: (e)=>{
            setTouched(true);
            setInternalError((validate || defaultValidate)(value));
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        dir: "ltr",
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('w-full h-11 rounded-lg font-sans text-[14px] text-foreground', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', unit ? 'pr-3.5 pl-11' : 'px-3.5', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70')
    }), unit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "absolute left-3.5 top-1/2 -translate-y-1/2 text-[11px] font-semibold text-muted-foreground pointer-events-none select-none"
    }, unit)));
};
var $4fe0519cb1ec239e$export$2e2bcd8739ae039 = $4fe0519cb1ec239e$var$NumberInput;



var $acw62 = parcelRequire("acw62");



'use client';
// The one money field. Everywhere in Parsina a human types a price, it types it here.
//
// Three things it does that a plain <input> cannot:
//
//   1. **Thousands separators as you type.** «500000» reads back as «۵۰۰٬۰۰۰».
//      Native <input type="number"> can't render a separator at all (the browser
//      rejects the comma), so this is a text input that DISPLAYS the grouped string
//      and reports the bare numeric one.
//   2. **The numerals of the language on screen.** Persian digits under `fa`, Latin
//      under `en`, each with that locale's own separators — resolved from CLDR, so
//      nothing here branches on a locale id. See `numeralsFor`.
//   3. **The unit, always.** A money field with no unit is how a rial figure ends up
//      read as toman; the label defaults rather than being optional.
//
// Value in and value out are both the BARE ASCII numeric string — «500000», never
// «۵۰۰٬۰۰۰». Localised digits exist only between here and the DOM, so no form, no
// parse and no toman↔rial conversion downstream sees them. onChange is handed that
// string directly, not an event: `onChange={setAmount}`.
//
// It preserves the caret across regrouping: inserting a digit that pushes a new
// separator in would otherwise fling the cursor to the end. We remember how many
// digits sat to the left of the caret and put it back after the same digit once
// React re-renders.
// The only copy the kit owns. Anything else — «پارسه», a foreign currency — is the
// caller's `unitLabel`; this is just the overwhelmingly common case, spelled out so
// that forgetting the prop yields the right answer instead of a naked number.
const $b90d527c31e5b4da$var$TOMAN_LABEL = {
    fa: "\u062A\u0648\u0645\u0627\u0646",
    en: 'toman'
};
const $b90d527c31e5b4da$var$unitLabelFor = (locale)=>$b90d527c31e5b4da$var$TOMAN_LABEL[String(locale).split('-')[0]] ?? $b90d527c31e5b4da$var$TOMAN_LABEL.fa;
const $b90d527c31e5b4da$var$MoneyInput = ({ value: value, onChange: onChange, onBlur: onBlur, allowDecimal: allowDecimal = false, unit: // Unit — `unit` is a full node override, `unitLabel` just changes the text.
// `unit={null}` is the deliberate way to render none.
unit, unitLabel: unitLabel, // Locale — defaults to <html lang>, which every client sets via applyDocumentLocale.
locale: localeProp, label: // Chrome — the same contract as TextInput.
label, required: required, error: externalError, helperText: helperText, validate: validate, placeholder: placeholder, disabled: disabled = false, className: className, style: style, inputStyle: inputStyle, // Extra props (data-testid, aria-*, name…) land on the real control.
...rest })=>{
    const ref = (0, $acw62.useRef)(null);
    const caret = (0, $acw62.useRef)(null);
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const locale = localeProp || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)();
    const numerals = (0, $acw62.useMemo)(()=>(0, $ca1f40e638c62a9a$export$20975da26e036f6b)(locale), [
        locale
    ]);
    const error = externalError || (touched ? internalError : '');
    const display = (0, $ca1f40e638c62a9a$export$302430bce3371cb8)(value ?? '', numerals);
    // `unit === null` means "no unit, I mean it"; `undefined` means "you choose".
    const unitNode = unit !== undefined ? unit : unitLabel ?? $b90d527c31e5b4da$var$unitLabelFor(locale);
    const hasUnit = unitNode != null && unitNode !== '';
    // The chip is painted beside the digits, which a screen reader never connects to
    // the field — «۵۰۰٬۰۰۰» alone does not say toman. Describing the input by it is
    // what makes the unit part of the field for a non-sighted reader too. A caller's
    // own `aria-describedby` is kept, not replaced.
    const unitId = `${(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId()}-unit`;
    const describedBy = [
        rest['aria-describedby'],
        hasUnit ? unitId : null
    ].filter(Boolean).join(' ') || undefined;
    (0, $acw62.useLayoutEffect)(()=>{
        if (caret.current != null && ref.current) {
            ref.current.setSelectionRange(caret.current, caret.current);
            caret.current = null;
        }
    });
    const handleChange = (e)=>{
        const el = e.target;
        // How many MEANINGFUL characters sat left of the caret — digits, plus the
        // decimal mark when one is allowed. Counting digits alone parks the caret
        // before a just-typed decimal mark, so «1.5» lands as «1.» + «5» = «15.».
        const keptLeft = (0, $ca1f40e638c62a9a$export$8a2f5adb56df4f49)(el.value.slice(0, el.selectionStart ?? el.value.length), allowDecimal, numerals).length;
        const raw = (0, $ca1f40e638c62a9a$export$8a2f5adb56df4f49)(el.value, allowDecimal, numerals);
        const grouped = (0, $ca1f40e638c62a9a$export$302430bce3371cb8)(raw, numerals);
        // Walk the regrouped string until that many are behind us; the separators it
        // inserted are skipped over. `\p{Nd}` rather than an ASCII range: «۵» is a
        // digit too, and an ASCII test flings the caret to the end in Persian.
        const isKept = (ch)=>/\p{Nd}/u.test(ch) || allowDecimal && ch === numerals.decimal;
        let pos = 0, seen = 0;
        while(pos < grouped.length && seen < keptLeft){
            if (isKept(grouped[pos])) seen++;
            pos++;
        }
        caret.current = pos;
        onChange(raw);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ...rest,
        ref: ref,
        type: "text",
        inputMode: allowDecimal ? 'decimal' : 'numeric',
        // A number is an LTR run even inside an RTL form — the same rule that
        // keeps phone numbers and codes readable.
        dir: "ltr",
        value: display,
        onChange: handleChange,
        "aria-describedby": describedBy,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('w-full h-11 rounded-lg font-sans text-[13.5px] text-foreground', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', hasUnit ? 'pr-3.5 pl-11' : 'px-3.5', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70', className),
        style: inputStyle
    }), hasUnit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: unitId,
        className: "absolute left-3.5 top-1/2 -translate-y-1/2 text-[11px] font-semibold text-muted-foreground pointer-events-none select-none"
    }, unitNode)));
};
var $b90d527c31e5b4da$export$2e2bcd8739ae039 = $b90d527c31e5b4da$var$MoneyInput;



var $acw62 = parcelRequire("acw62");


'use client';
const $26a45cd6e1b19edd$var$Textarea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, placeholder: placeholder, rows: rows = 3, maxLength: maxLength, showCount: showCount = false, validate: validate, disabled: disabled = false, style: style, inputStyle: // `style` dresses the FIELD (label + control + helper); `inputStyle` reaches
// the control itself — the same split `TextInput` already has. It exists for
// the mobile rule that a field's type must be ≥1rem or iOS zooms the page on
// focus (DESIGN-CONCEPT-MOBILE §6), which the 13.5px default is under.
inputStyle, dir: // Unset: inherits the document's direction (§16.3). It defaulted to 'rtl',
// which pinned every note field in the product to RTL whatever the language.
dir, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest }, ref)=>{
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        ref: ref,
        id: controlId,
        "aria-describedby": error || helperText ? `${controlId}-message` : undefined,
        "aria-invalid": error ? true : undefined,
        ...rest,
        value: value,
        onChange: onChange,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        rows: rows,
        maxLength: maxLength,
        dir: dir,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('w-full px-3.5 py-3 rounded-lg font-sans text-[13.5px] text-foreground', 'bg-white border-[1.5px] outline-none resize-none leading-7', 'transition-[border-color,box-shadow] duration-150', showCount && maxLength && 'pb-6', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70'),
        style: inputStyle
    }), showCount && maxLength && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "absolute bottom-2 end-3 text-[10.5px] text-muted-foreground pointer-events-none select-none"
    }, (value || '').length, "/", maxLength)));
});
$26a45cd6e1b19edd$var$Textarea.displayName = 'Textarea';
var $26a45cd6e1b19edd$export$2e2bcd8739ae039 = $26a45cd6e1b19edd$var$Textarea;



var $acw62 = parcelRequire("acw62");


'use client';
const $2f997edd3d0e9220$var$Select = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, options: options = [], placeholder: placeholder = "\u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F...", validate: validate, disabled: disabled = false, style: style, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest }, ref)=>{
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        ref: ref,
        id: controlId,
        "aria-describedby": error || helperText ? `${controlId}-message` : undefined,
        "aria-invalid": error ? true : undefined,
        ...rest,
        value: value,
        onChange: onChange,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        disabled: disabled,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(// Logical padding, and no `dir` of its own: the room for the chevron
        // is on the field's END edge, whichever side that is. It used to be
        // `dir="rtl"` + `pr-3.5 pl-8`, which put a Persian-shaped control
        // inside an English page and the chevron on top of the text.
        'w-full h-11 ps-3.5 pe-8 rounded-lg font-sans text-[13.5px]', 'bg-white border-[1.5px] outline-none appearance-none cursor-pointer', 'transition-[border-color,box-shadow] duration-150', value ? 'text-foreground' : 'text-muted-foreground', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70')
    }, placeholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, placeholder), options.map((o)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: o.value,
            value: o.value
        }, o.label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        className: "absolute end-2.5 top-1/2 -translate-y-1/2 pointer-events-none text-muted-foreground flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "15",
        height: "15"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7 10l5 5 5-5z"
    })))));
});
$2f997edd3d0e9220$var$Select.displayName = 'Select';
var $2f997edd3d0e9220$export$2e2bcd8739ae039 = $2f997edd3d0e9220$var$Select;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// src/create-context.tsx

var $acw62 = parcelRequire("acw62");

function $45e038b71f97d914$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $acw62.createContext(defaultContext);
    Context.displayName = rootComponentName + "Context";
    const Provider = (props)=>{
        const { children: children, ...context } = props;
        const value = $acw62.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = $acw62.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function $45e038b71f97d914$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $acw62.createContext(defaultContext);
        BaseContext.displayName = rootComponentName + "Context";
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $acw62.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $acw62.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $acw62.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $acw62.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $45e038b71f97d914$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $45e038b71f97d914$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $acw62.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}


// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
// src/slot.tsx

var $acw62 = parcelRequire("acw62");
// src/compose-refs.tsx

var $acw62 = parcelRequire("acw62");
function $fb3356a19a5676fa$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $fb3356a19a5676fa$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $fb3356a19a5676fa$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $fb3356a19a5676fa$var$setRef(refs[i], null);
            }
        };
    };
}
function $fb3356a19a5676fa$export$c7b2cbe3552a0d05(...refs) {
    return $acw62.useCallback($fb3356a19a5676fa$export$43e446d32b3d21af(...refs), refs);
}


// @__NO_SIDE_EFFECTS__
function $cf381de56a25bc52$export$e88b45bda5c13eb9(ownerName) {
    const Slot2 = $acw62.forwardRef((props, forwardedRef)=>{
        let { children: children, ...slotProps } = props;
        let slottableElement = null;
        let hasSlottable = false;
        const newChildren = [];
        if ($cf381de56a25bc52$var$isLazyComponent(children) && typeof $cf381de56a25bc52$var$use === "function") children = $cf381de56a25bc52$var$use(children._payload);
        $acw62.Children.forEach(children, (maybeSlottable)=>{
            if ($cf381de56a25bc52$var$isSlottable(maybeSlottable)) {
                hasSlottable = true;
                const slottable = maybeSlottable;
                let child = "child" in slottable.props ? slottable.props.child : slottable.props.children;
                if ($cf381de56a25bc52$var$isLazyComponent(child) && typeof $cf381de56a25bc52$var$use === "function") child = $cf381de56a25bc52$var$use(child._payload);
                slottableElement = $cf381de56a25bc52$var$getSlottableElementFromSlottable(slottable, child);
                newChildren.push(slottableElement?.props?.children);
            } else newChildren.push(maybeSlottable);
        });
        if (slottableElement) slottableElement = $acw62.cloneElement(slottableElement, void 0, newChildren);
        else if (// A `Slottable` was found but it didn't resolve to a single element (e.g.
        // it wrapped multiple elements, text, or a render-prop `child` that
        // wasn't an element). Don't fall back to treating the `Slottable` wrapper
        // itself as the slot target — throw a descriptive error below instead.
        !hasSlottable && $acw62.Children.count(children) === 1 && $acw62.isValidElement(children)) slottableElement = children;
        const slottableElementRef = slottableElement ? $cf381de56a25bc52$var$getElementRef(slottableElement) : void 0;
        const composedRef = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, slottableElementRef);
        if (!slottableElement) {
            if (children || children === 0) throw new Error(hasSlottable ? $cf381de56a25bc52$var$createSlottableError(ownerName) : $cf381de56a25bc52$var$createSlotError(ownerName));
            return children;
        }
        const mergedProps = $cf381de56a25bc52$var$mergeProps(slotProps, slottableElement.props ?? {});
        if (slottableElement.type !== $acw62.Fragment) mergedProps.ref = forwardedRef ? composedRef : slottableElementRef;
        return $acw62.cloneElement(slottableElement, mergedProps);
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
var $cf381de56a25bc52$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $cf381de56a25bc52$export$e88b45bda5c13eb9("Slot");
var $cf381de56a25bc52$var$SLOTTABLE_IDENTIFIER = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $cf381de56a25bc52$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = (props)=>"child" in props ? props.children(props.child) : props.children;
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $cf381de56a25bc52$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var $cf381de56a25bc52$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $cf381de56a25bc52$export$bf68c29d8281d0f7("Slottable");
var $cf381de56a25bc52$var$getSlottableElementFromSlottable = (slottable, child)=>{
    if ("child" in slottable.props) {
        const child2 = slottable.props.child;
        if (!$acw62.isValidElement(child2)) return null;
        return $acw62.cloneElement(child2, void 0, slottable.props.children(child2.props.children));
    }
    return $acw62.isValidElement(child) ? child : null;
};
function $cf381de56a25bc52$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $cf381de56a25bc52$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
function $cf381de56a25bc52$var$isSlottable(child) {
    return $acw62.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $cf381de56a25bc52$var$SLOTTABLE_IDENTIFIER;
}
var $cf381de56a25bc52$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
function $cf381de56a25bc52$var$isLazyComponent(element) {
    return element != null && typeof element === "object" && "$$typeof" in element && element.$$typeof === $cf381de56a25bc52$var$REACT_LAZY_TYPE && "_payload" in element && $cf381de56a25bc52$var$isPromiseLike(element._payload);
}
function $cf381de56a25bc52$var$isPromiseLike(value) {
    return typeof value === "object" && value !== null && "then" in value;
}
var $cf381de56a25bc52$var$createSlotError = (ownerName)=>{
    return `${ownerName} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`;
};
var $cf381de56a25bc52$var$createSlottableError = (ownerName)=>{
    return `${ownerName} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`;
};
var $cf381de56a25bc52$var$use = $acw62[" use ".trim().toString()];



var $dc7d5df3de21cdcb$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $dc7d5df3de21cdcb$export$250ffa63cdc0d034 = $dc7d5df3de21cdcb$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $dc7d5df3de21cdcb$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $dc7d5df3de21cdcb$export$be92b6f5f03c0fe9 = $dc7d5df3de21cdcb$export$250ffa63cdc0d034;



var $acw62 = parcelRequire("acw62");
// src/primitive.tsx
var $b4e9a20689651e16$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $b4e9a20689651e16$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}
function $b4e9a20689651e16$export$f21a1ffae260145a(element) {
    if (!$b4e9a20689651e16$export$71594e8a50f746f4) throw new Error("Cannot access window outside of the DOM");
    return element?.ownerDocument?.defaultView ?? window;
}
function $b4e9a20689651e16$export$b204af158042fbac(element) {
    if (!$b4e9a20689651e16$export$71594e8a50f746f4) throw new Error("Cannot access document outside of the DOM");
    return element?.ownerDocument ?? document;
}
function $b4e9a20689651e16$export$cd4e5573fbe2b576(node, activeDescendant = false) {
    const { activeElement: activeElement } = $b4e9a20689651e16$export$b204af158042fbac(node);
    if (!activeElement?.nodeName) return null;
    if ($b4e9a20689651e16$export$6a12f24039de8f3a(activeElement) && activeElement.contentDocument) return $b4e9a20689651e16$export$cd4e5573fbe2b576(activeElement.contentDocument.body, activeDescendant);
    if (activeDescendant) {
        const id = activeElement.getAttribute("aria-activedescendant");
        if (id) {
            const element = $b4e9a20689651e16$export$b204af158042fbac(activeElement).getElementById(id);
            if (element) return element;
        }
    }
    return activeElement;
}
function $b4e9a20689651e16$export$6a12f24039de8f3a(element) {
    return element.tagName === "IFRAME";
}



var $acw62 = parcelRequire("acw62");




"use client";
function $a9634733d4b9bce9$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = $acw62.useRef(null);
        const itemMap = $acw62.useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(COLLECTION_SLOT_NAME);
    const CollectionSlot = $acw62.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(ITEM_SLOT_NAME);
    const CollectionItemSlot = $acw62.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = $acw62.useRef(null);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        $acw62.useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = $acw62.useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}
// src/ordered-dictionary.ts
var $a9634733d4b9bce9$var$__instanciated = /* @__PURE__ */ new WeakMap();
var $a9634733d4b9bce9$var$OrderedDict = class _OrderedDict extends Map {
    #keys;
    constructor(entries){
        super(entries);
        this.#keys = [
            ...super.keys()
        ];
        $a9634733d4b9bce9$var$__instanciated.set(this, true);
    }
    set(key, value) {
        if ($a9634733d4b9bce9$var$__instanciated.get(this)) {
            if (this.has(key)) this.#keys[this.#keys.indexOf(key)] = key;
            else this.#keys.push(key);
        }
        super.set(key, value);
        return this;
    }
    insert(index, key, value) {
        const has = this.has(key);
        const length = this.#keys.length;
        const relativeIndex = $a9634733d4b9bce9$var$toSafeInteger(index);
        let actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
        const safeIndex = actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
        if (safeIndex === this.size || has && safeIndex === this.size - 1 || safeIndex === -1) {
            this.set(key, value);
            return this;
        }
        const size = this.size + (has ? 0 : 1);
        if (relativeIndex < 0) actualIndex++;
        const keys = [
            ...this.#keys
        ];
        let nextValue;
        let shouldSkip = false;
        for(let i = actualIndex; i < size; i++)if (actualIndex === i) {
            let nextKey = keys[i];
            if (keys[i] === key) nextKey = keys[i + 1];
            if (has) this.delete(key);
            nextValue = this.get(nextKey);
            this.set(key, value);
        } else {
            if (!shouldSkip && keys[i - 1] === key) shouldSkip = true;
            const currentKey = keys[shouldSkip ? i : i - 1];
            const currentValue = nextValue;
            nextValue = this.get(currentKey);
            this.delete(currentKey);
            this.set(currentKey, currentValue);
        }
        return this;
    }
    with(index, key, value) {
        const copy = new _OrderedDict(this);
        copy.insert(index, key, value);
        return copy;
    }
    before(key) {
        const index = this.#keys.indexOf(key) - 1;
        if (index < 0) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position before the given key.
   */ setBefore(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index, newKey, value);
    }
    after(key) {
        let index = this.#keys.indexOf(key);
        index = index === -1 || index === this.size - 1 ? -1 : index + 1;
        if (index === -1) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position after the given key.
   */ setAfter(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index + 1, newKey, value);
    }
    first() {
        return this.entryAt(0);
    }
    last() {
        return this.entryAt(-1);
    }
    clear() {
        this.#keys = [];
        return super.clear();
    }
    delete(key) {
        const deleted = super.delete(key);
        if (deleted) this.#keys.splice(this.#keys.indexOf(key), 1);
        return deleted;
    }
    deleteAt(index) {
        const key = this.keyAt(index);
        if (key !== void 0) return this.delete(key);
        return false;
    }
    at(index) {
        const key = $a9634733d4b9bce9$var$at(this.#keys, index);
        if (key !== void 0) return this.get(key);
    }
    entryAt(index) {
        const key = $a9634733d4b9bce9$var$at(this.#keys, index);
        if (key !== void 0) return [
            key,
            this.get(key)
        ];
    }
    indexOf(key) {
        return this.#keys.indexOf(key);
    }
    keyAt(index) {
        return $a9634733d4b9bce9$var$at(this.#keys, index);
    }
    from(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.at(dest);
    }
    keyFrom(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.keyAt(dest);
    }
    find(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return entry;
            index++;
        }
        return void 0;
    }
    findIndex(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return index;
            index++;
        }
        return -1;
    }
    filter(predicate, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) entries.push(entry);
            index++;
        }
        return new _OrderedDict(entries);
    }
    map(callbackfn, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            entries.push([
                entry[0],
                Reflect.apply(callbackfn, thisArg, [
                    entry,
                    index,
                    this
                ])
            ]);
            index++;
        }
        return new _OrderedDict(entries);
    }
    reduce(...args) {
        const [callbackfn, initialValue] = args;
        let index = 0;
        let accumulator = initialValue ?? this.at(0);
        for (const entry of this){
            if (index === 0 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
            index++;
        }
        return accumulator;
    }
    reduceRight(...args) {
        const [callbackfn, initialValue] = args;
        let accumulator = initialValue ?? this.at(-1);
        for(let index = this.size - 1; index >= 0; index--){
            const entry = this.at(index);
            if (index === this.size - 1 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
        }
        return accumulator;
    }
    toSorted(compareFn) {
        const entries = [
            ...this.entries()
        ].sort(compareFn);
        return new _OrderedDict(entries);
    }
    toReversed() {
        const reversed = new _OrderedDict();
        for(let index = this.size - 1; index >= 0; index--){
            const key = this.keyAt(index);
            const element = this.get(key);
            reversed.set(key, element);
        }
        return reversed;
    }
    toSpliced(...args) {
        const entries = [
            ...this.entries()
        ];
        entries.splice(...args);
        return new _OrderedDict(entries);
    }
    slice(start, end) {
        const result = new _OrderedDict();
        let stop = this.size - 1;
        if (start === void 0) return result;
        if (start < 0) start = start + this.size;
        if (end !== void 0 && end > 0) stop = end - 1;
        for(let index = start; index <= stop; index++){
            const key = this.keyAt(index);
            const element = this.get(key);
            result.set(key, element);
        }
        return result;
    }
    every(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (!Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return false;
            index++;
        }
        return true;
    }
    some(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return true;
            index++;
        }
        return false;
    }
};
function $a9634733d4b9bce9$var$at(array, index) {
    if ("at" in Array.prototype) return Array.prototype.at.call(array, index);
    const actualIndex = $a9634733d4b9bce9$var$toSafeIndex(array, index);
    return actualIndex === -1 ? void 0 : array[actualIndex];
}
function $a9634733d4b9bce9$var$toSafeIndex(array, index) {
    const length = array.length;
    const relativeIndex = $a9634733d4b9bce9$var$toSafeInteger(index);
    const actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
    return actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
}
function $a9634733d4b9bce9$var$toSafeInteger(number) {
    return number !== number || number === 0 ? 0 : Math.trunc(number);
}
function $a9634733d4b9bce9$export$ec5c5a85b7371a0f(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionContextProvider, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionElement: null,
        collectionRef: {
            current: null
        },
        collectionRefObject: {
            current: null
        },
        itemMap: new $a9634733d4b9bce9$var$OrderedDict(),
        setItemMap: ()=>void 0
    });
    const CollectionProvider = ({ state: state, ...props })=>{
        return state ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionProviderImpl, {
            ...props,
            state: state
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionInit, {
            ...props
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const CollectionInit = (props)=>{
        const state = useInitCollection();
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionProviderImpl, {
            ...props,
            state: state
        });
    };
    CollectionInit.displayName = PROVIDER_NAME + "Init";
    const CollectionProviderImpl = (props)=>{
        const { scope: scope, children: children, state: state } = props;
        const ref = $acw62.useRef(null);
        const [collectionElement, setCollectionElement] = $acw62.useState(null);
        const composeRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(ref, setCollectionElement);
        const [itemMap, setItemMap] = state;
        $acw62.useEffect(()=>{
            if (!collectionElement) return;
            const observer = $a9634733d4b9bce9$var$getChildListObserver(()=>{});
            observer.observe(collectionElement, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
            };
        }, [
            collectionElement
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionContextProvider, {
            scope: scope,
            itemMap: itemMap,
            setItemMap: setItemMap,
            collectionRef: composeRefs,
            collectionRefObject: ref,
            collectionElement: collectionElement,
            children: children
        });
    };
    CollectionProviderImpl.displayName = PROVIDER_NAME + "Impl";
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(COLLECTION_SLOT_NAME);
    const CollectionSlot = $acw62.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(ITEM_SLOT_NAME);
    const CollectionItemSlot = $acw62.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = $acw62.useRef(null);
        const [element, setElement] = $acw62.useState(null);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref, setElement);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        const { setItemMap: setItemMap } = context;
        const itemDataRef = $acw62.useRef(itemData);
        if (!$a9634733d4b9bce9$var$shallowEqual(itemDataRef.current, itemData)) itemDataRef.current = itemData;
        const memoizedItemData = itemDataRef.current;
        $acw62.useEffect(()=>{
            const itemData2 = memoizedItemData;
            setItemMap((map)=>{
                if (!element) return map;
                if (!map.has(element)) {
                    map.set(element, {
                        ...itemData2,
                        element: element
                    });
                    return map.toSorted($a9634733d4b9bce9$var$sortByDocumentPosition);
                }
                return map.set(element, {
                    ...itemData2,
                    element: element
                }).toSorted($a9634733d4b9bce9$var$sortByDocumentPosition);
            });
            return ()=>{
                setItemMap((map)=>{
                    if (!element || !map.has(element)) return map;
                    map.delete(element);
                    return new $a9634733d4b9bce9$var$OrderedDict(map);
                });
            };
        }, [
            element,
            memoizedItemData,
            setItemMap
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useInitCollection() {
        return $acw62.useState(new $a9634733d4b9bce9$var$OrderedDict());
    }
    function useCollection(scope) {
        const { itemMap: itemMap } = useCollectionContext(name + "CollectionConsumer", scope);
        return itemMap;
    }
    const functions = {
        createCollectionScope: createCollectionScope,
        useCollection: useCollection,
        useInitCollection: useInitCollection
    };
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        functions
    ];
}
function $a9634733d4b9bce9$var$shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || typeof b !== "object") return false;
    if (a == null || b == null) return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $a9634733d4b9bce9$var$isElementPreceding(a, b) {
    return !!(b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING);
}
function $a9634733d4b9bce9$var$sortByDocumentPosition(a, b) {
    return !a[1].element || !b[1].element ? 0 : $a9634733d4b9bce9$var$isElementPreceding(a[1].element, b[1].element) ? -1 : 1;
}
function $a9634733d4b9bce9$var$getChildListObserver(callback) {
    const observer = new MutationObserver((mutationsList)=>{
        for (const mutation of mutationsList)if (mutation.type === "childList") {
            callback();
            return;
        }
    });
    return observer;
}




// src/id.tsx

var $acw62 = parcelRequire("acw62");
// src/use-layout-effect.tsx

var $acw62 = parcelRequire("acw62");
var $b68d88740313b08e$export$e5c5a5f917a5871c = globalThis?.document ? $acw62.useLayoutEffect : ()=>{};


var $11885ec535b13ccc$var$useReactId = $acw62[" useId ".trim().toString()] || (()=>void 0);
var $11885ec535b13ccc$var$count = 0;
function $11885ec535b13ccc$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $acw62.useState($11885ec535b13ccc$var$useReactId());
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($11885ec535b13ccc$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}



// src/use-callback-ref.tsx

var $acw62 = parcelRequire("acw62");
function $95d2d9f03fd0d4db$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $acw62.useRef(callback);
    $acw62.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


// src/use-controllable-state.tsx

var $acw62 = parcelRequire("acw62");

// src/use-effect-event.tsx


var $acw62 = parcelRequire("acw62");
var $07b0b1ce13d5e29f$var$useReactEffectEvent = $acw62[" useEffectEvent ".trim().toString()];
var $07b0b1ce13d5e29f$var$useReactInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()];
function $07b0b1ce13d5e29f$export$7f54fc3180508a52(callback) {
    if (typeof $07b0b1ce13d5e29f$var$useReactEffectEvent === "function") return $07b0b1ce13d5e29f$var$useReactEffectEvent(callback);
    const ref = $acw62.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof $07b0b1ce13d5e29f$var$useReactInsertionEffect === "function") $07b0b1ce13d5e29f$var$useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        ref.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>ref.current?.(...args), []);
}


var $aef12de5508fd46e$var$useInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()] || (0, $b68d88740313b08e$export$e5c5a5f917a5871c);
function $aef12de5508fd46e$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{}, caller: caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = $aef12de5508fd46e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    {
        const isControlledRef = $acw62.useRef(prop !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = $acw62.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = $aef12de5508fd46e$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function $aef12de5508fd46e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const [value, setValue] = $acw62.useState(defaultProp);
    const prevValueRef = $acw62.useRef(value);
    const onChangeRef = $acw62.useRef(onChange);
    $aef12de5508fd46e$var$useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function $aef12de5508fd46e$var$isFunction(value) {
    return typeof value === "function";
}
var $aef12de5508fd46e$var$SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function $aef12de5508fd46e$export$bf6fc034f0c038af(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp: defaultProp, onChange: onChangeProp, caller: caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, $07b0b1ce13d5e29f$export$7f54fc3180508a52)(onChangeProp);
    {
        const isControlledRef = $acw62.useRef(controlledState !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = $acw62.useReducer((state2, action)=>{
        if (action.type === $aef12de5508fd46e$var$SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = $acw62.useRef(uncontrolledState);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = $acw62.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    $acw62.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: $aef12de5508fd46e$var$SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}



var $acw62 = parcelRequire("acw62");

"use client";
var $f9ad7d2f57cc5bec$var$DirectionContext = $acw62.createContext(void 0);
var $f9ad7d2f57cc5bec$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($f9ad7d2f57cc5bec$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
};
function $f9ad7d2f57cc5bec$export$b39126d51d94e6f3(localDir) {
    const globalDir = $acw62.useContext($f9ad7d2f57cc5bec$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
var $f9ad7d2f57cc5bec$export$2881499e37b75b9a = $f9ad7d2f57cc5bec$export$c760c09fdd558351;



"use client";
var $0483c88073bf4923$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var $0483c88073bf4923$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $0483c88073bf4923$var$GROUP_NAME = "RovingFocusGroup";
var [$0483c88073bf4923$var$Collection, $0483c88073bf4923$var$useCollection, $0483c88073bf4923$var$createCollectionScope] = (0, $a9634733d4b9bce9$export$c74125a8e3af6bb2)($0483c88073bf4923$var$GROUP_NAME);
var [$0483c88073bf4923$var$createRovingFocusGroupContext, $0483c88073bf4923$export$c7109489551a4f4] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($0483c88073bf4923$var$GROUP_NAME, [
    $0483c88073bf4923$var$createCollectionScope
]);
var [$0483c88073bf4923$var$RovingFocusProvider, $0483c88073bf4923$var$useRovingFocusContext] = $0483c88073bf4923$var$createRovingFocusGroupContext($0483c88073bf4923$var$GROUP_NAME);
var $0483c88073bf4923$export$8699f7c8af148338 = $acw62.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$Collection.Slot, {
            scope: props.__scopeRovingFocusGroup,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$RovingFocusGroupImpl, {
                ...props,
                ref: forwardedRef
            })
        })
    });
});
$0483c88073bf4923$export$8699f7c8af148338.displayName = $0483c88073bf4923$var$GROUP_NAME;
var $0483c88073bf4923$var$RovingFocusGroupImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, preventScrollOnEntryFocus: preventScrollOnEntryFocus = false, ...groupProps } = props;
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $f9ad7d2f57cc5bec$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId, setCurrentTabStopId] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId ?? null,
        onChange: onCurrentTabStopIdChange,
        caller: $0483c88073bf4923$var$GROUP_NAME
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = $acw62.useState(false);
    const handleEntryFocus = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $0483c88073bf4923$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = $acw62.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = $acw62.useState(0);
    $acw62.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($0483c88073bf4923$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($0483c88073bf4923$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: $acw62.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: $acw62.useCallback(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: $acw62.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: $acw62.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), []),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
            tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
            "data-orientation": orientation,
            ...groupProps,
            ref: composedRefs,
            style: {
                outline: "none",
                ...props.style
            },
            onMouseDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
                isClickFocusRef.current = true;
            }),
            onFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
                const isKeyboardFocus = !isClickFocusRef.current;
                if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                    const entryFocusEvent = new CustomEvent($0483c88073bf4923$var$ENTRY_FOCUS, $0483c88073bf4923$var$EVENT_OPTIONS);
                    event.currentTarget.dispatchEvent(entryFocusEvent);
                    if (!entryFocusEvent.defaultPrevented) {
                        const items = getItems().filter((item)=>item.focusable);
                        const activeItem = items.find((item)=>item.active);
                        const currentItem = items.find((item)=>item.id === currentTabStopId);
                        const candidateItems = [
                            activeItem,
                            currentItem,
                            ...items
                        ].filter(Boolean);
                        const candidateNodes = candidateItems.map((item)=>item.ref.current);
                        $0483c88073bf4923$var$focusFirst(candidateNodes, preventScrollOnEntryFocus);
                    }
                }
                isClickFocusRef.current = false;
            }),
            onBlur: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
        })
    });
});
var $0483c88073bf4923$var$ITEM_NAME = "RovingFocusGroupItem";
var $0483c88073bf4923$export$ab9df7c53fe8454 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, children: children, ...itemProps } = props;
    const autoId = (0, $11885ec535b13ccc$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $0483c88073bf4923$var$useRovingFocusContext($0483c88073bf4923$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $0483c88073bf4923$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove, currentTabStopId: currentTabStopId } = context;
    $acw62.useEffect(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).span, {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
                if (!focusable) event.preventDefault();
                else context.onItemFocus(id);
            }),
            onFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
            onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if (event.key === "Tab" && event.shiftKey) {
                    context.onItemShiftTab();
                    return;
                }
                if (event.target !== event.currentTarget) return;
                const focusIntent = $0483c88073bf4923$var$getFocusIntent(event, context.orientation, context.dir);
                if (focusIntent !== void 0) {
                    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                    event.preventDefault();
                    const items = getItems().filter((item)=>item.focusable);
                    let candidateNodes = items.map((item)=>item.ref.current);
                    if (focusIntent === "last") candidateNodes.reverse();
                    else if (focusIntent === "prev" || focusIntent === "next") {
                        if (focusIntent === "prev") candidateNodes.reverse();
                        const currentIndex = candidateNodes.indexOf(event.currentTarget);
                        candidateNodes = context.loop ? $0483c88073bf4923$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                    }
                    setTimeout(()=>$0483c88073bf4923$var$focusFirst(candidateNodes));
                }
            }),
            children: typeof children === "function" ? children({
                isCurrentTabStop: isCurrentTabStop,
                hasTabStop: currentTabStopId != null
            }) : children
        })
    });
});
$0483c88073bf4923$export$ab9df7c53fe8454.displayName = $0483c88073bf4923$var$ITEM_NAME;
var $0483c88073bf4923$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $0483c88073bf4923$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $0483c88073bf4923$var$getFocusIntent(event, orientation, dir) {
    const key = $0483c88073bf4923$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return void 0;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return void 0;
    return $0483c88073bf4923$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $0483c88073bf4923$var$focusFirst(candidates, preventScroll = false) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus({
            preventScroll: preventScroll
        });
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function $0483c88073bf4923$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var $0483c88073bf4923$export$be92b6f5f03c0fe9 = $0483c88073bf4923$export$8699f7c8af148338;
var $0483c88073bf4923$export$6d08773d2e66f8f2 = $0483c88073bf4923$export$ab9df7c53fe8454;



var $acw62 = parcelRequire("acw62");




"use client";
var $62b265af90252982$var$NAME = "Toggle";
var $62b265af90252982$export$bea8ebba691c5813 = $acw62.forwardRef((props, forwardedRef)=>{
    const { pressed: pressedProp, defaultPressed: defaultPressed, onPressedChange: onPressedChange, ...buttonProps } = props;
    const [pressed, setPressed] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: pressedProp,
        onChange: onPressedChange,
        defaultProp: defaultPressed ?? false,
        caller: $62b265af90252982$var$NAME
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-pressed": pressed,
        "data-state": pressed ? "on" : "off",
        "data-disabled": props.disabled ? "" : void 0,
        ...buttonProps,
        ref: forwardedRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, ()=>{
            if (!props.disabled) setPressed(!pressed);
        })
    });
});
$62b265af90252982$export$bea8ebba691c5813.displayName = $62b265af90252982$var$NAME;
var $62b265af90252982$export$be92b6f5f03c0fe9 = $62b265af90252982$export$bea8ebba691c5813;





"use client";
var $57c1675cf83b8426$var$TOGGLE_GROUP_NAME = "ToggleGroup";
var [$57c1675cf83b8426$var$createToggleGroupContext, $57c1675cf83b8426$export$d1c7c4bcd9f26dd4] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($57c1675cf83b8426$var$TOGGLE_GROUP_NAME, [
    (0, $0483c88073bf4923$export$c7109489551a4f4)
]);
var $57c1675cf83b8426$var$useRovingFocusGroupScope = (0, $0483c88073bf4923$export$c7109489551a4f4)();
var $57c1675cf83b8426$export$be92b6f5f03c0fe9 = $acw62.forwardRef((props, forwardedRef)=>{
    const { type: type, ...toggleGroupProps } = props;
    if (type === "single") {
        const singleProps = toggleGroupProps;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupImplSingle, {
            role: "radiogroup",
            ...singleProps,
            ref: forwardedRef
        });
    }
    if (type === "multiple") {
        const multipleProps = toggleGroupProps;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupImplMultiple, {
            role: "toolbar",
            ...multipleProps,
            ref: forwardedRef
        });
    }
    throw new Error(`Missing prop \`type\` expected on \`${$57c1675cf83b8426$var$TOGGLE_GROUP_NAME}\``);
});
$57c1675cf83b8426$export$be92b6f5f03c0fe9.displayName = $57c1675cf83b8426$var$TOGGLE_GROUP_NAME;
var [$57c1675cf83b8426$var$ToggleGroupValueProvider, $57c1675cf83b8426$var$useToggleGroupValueContext] = $57c1675cf83b8426$var$createToggleGroupContext($57c1675cf83b8426$var$TOGGLE_GROUP_NAME);
var $57c1675cf83b8426$var$ToggleGroupImplSingle = $acw62.forwardRef((props, forwardedRef)=>{
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = ()=>{}, ...toggleGroupSingleProps } = props;
    const [value, setValue] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue ?? "",
        onChange: onValueChange,
        caller: $57c1675cf83b8426$var$TOGGLE_GROUP_NAME
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupValueProvider, {
        scope: props.__scopeToggleGroup,
        type: "single",
        value: $acw62.useMemo(()=>value ? [
                value
            ] : [], [
            value
        ]),
        onItemActivate: setValue,
        onItemDeactivate: $acw62.useCallback(()=>setValue(""), [
            setValue
        ]),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupImpl, {
            ...toggleGroupSingleProps,
            ref: forwardedRef
        })
    });
});
var $57c1675cf83b8426$var$ToggleGroupImplMultiple = $acw62.forwardRef((props, forwardedRef)=>{
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = ()=>{}, ...toggleGroupMultipleProps } = props;
    const [value, setValue] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue ?? [],
        onChange: onValueChange,
        caller: $57c1675cf83b8426$var$TOGGLE_GROUP_NAME
    });
    const handleButtonActivate = $acw62.useCallback((itemValue)=>setValue((prevValue = [])=>[
                ...prevValue,
                itemValue
            ]), [
        setValue
    ]);
    const handleButtonDeactivate = $acw62.useCallback((itemValue)=>setValue((prevValue = [])=>prevValue.filter((value2)=>value2 !== itemValue)), [
        setValue
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupValueProvider, {
        scope: props.__scopeToggleGroup,
        type: "multiple",
        value: value,
        onItemActivate: handleButtonActivate,
        onItemDeactivate: handleButtonDeactivate,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupImpl, {
            ...toggleGroupMultipleProps,
            ref: forwardedRef
        })
    });
});
$57c1675cf83b8426$export$be92b6f5f03c0fe9.displayName = $57c1675cf83b8426$var$TOGGLE_GROUP_NAME;
var [$57c1675cf83b8426$var$ToggleGroupContext, $57c1675cf83b8426$var$useToggleGroupContext] = $57c1675cf83b8426$var$createToggleGroupContext($57c1675cf83b8426$var$TOGGLE_GROUP_NAME);
var $57c1675cf83b8426$var$ToggleGroupImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeToggleGroup: __scopeToggleGroup, disabled: disabled = false, rovingFocus: rovingFocus = true, orientation: orientation, dir: dir, loop: loop = true, ...toggleGroupProps } = props;
    const rovingFocusGroupScope = $57c1675cf83b8426$var$useRovingFocusGroupScope(__scopeToggleGroup);
    const direction = (0, $f9ad7d2f57cc5bec$export$b39126d51d94e6f3)(dir);
    const commonProps = {
        dir: direction,
        ...toggleGroupProps
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupContext, {
        scope: __scopeToggleGroup,
        rovingFocus: rovingFocus,
        disabled: disabled,
        children: rovingFocus ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$export$be92b6f5f03c0fe9, {
            asChild: true,
            ...rovingFocusGroupScope,
            orientation: orientation,
            dir: direction,
            loop: loop,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
                ...commonProps,
                ref: forwardedRef
            })
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
            ...commonProps,
            ref: forwardedRef
        })
    });
});
var $57c1675cf83b8426$var$ITEM_NAME = "ToggleGroupItem";
var $57c1675cf83b8426$export$6d08773d2e66f8f2 = $acw62.forwardRef((props, forwardedRef)=>{
    const valueContext = $57c1675cf83b8426$var$useToggleGroupValueContext($57c1675cf83b8426$var$ITEM_NAME, props.__scopeToggleGroup);
    const context = $57c1675cf83b8426$var$useToggleGroupContext($57c1675cf83b8426$var$ITEM_NAME, props.__scopeToggleGroup);
    const rovingFocusGroupScope = $57c1675cf83b8426$var$useRovingFocusGroupScope(props.__scopeToggleGroup);
    const pressed = valueContext.value.includes(props.value);
    const disabled = context.disabled || props.disabled;
    const commonProps = {
        ...props,
        pressed: pressed,
        disabled: disabled
    };
    const ref = $acw62.useRef(null);
    return context.rovingFocus ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$export$6d08773d2e66f8f2, {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !disabled,
        active: pressed,
        ref: ref,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupItemImpl, {
            ...commonProps,
            ref: forwardedRef
        })
    }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupItemImpl, {
        ...commonProps,
        ref: forwardedRef
    });
});
$57c1675cf83b8426$export$6d08773d2e66f8f2.displayName = $57c1675cf83b8426$var$ITEM_NAME;
var $57c1675cf83b8426$var$ToggleGroupItemImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeToggleGroup: __scopeToggleGroup, value: value, ...itemProps } = props;
    const valueContext = $57c1675cf83b8426$var$useToggleGroupValueContext($57c1675cf83b8426$var$ITEM_NAME, __scopeToggleGroup);
    const singleProps = {
        role: "radio",
        "aria-checked": props.pressed,
        "aria-pressed": void 0
    };
    const typeProps = valueContext.type === "single" ? singleProps : void 0;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $62b265af90252982$export$bea8ebba691c5813), {
        ...typeProps,
        ...itemProps,
        ref: forwardedRef,
        onPressedChange: (pressed)=>{
            if (pressed) valueContext.onItemActivate(value);
            else valueContext.onItemDeactivate(value);
        }
    });
});




'use client';
const $43f8655df02249d5$var$ToggleGroup = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, options: options = [], validate: validate, disabled: disabled = false, style: style })=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($57c1675cf83b8426$export$be92b6f5f03c0fe9, {
        type: "single",
        value: value,
        onValueChange: (v)=>{
            if (!v) return;
            onChange(v);
            setTouched(true);
            if (validate) setInternalError(validate(v) || '');
        },
        disabled: disabled,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex gap-1.5 p-1 rounded-xl bg-[#f4f6f9]', error && 'ring-[1.5px] ring-destructive')
    }, options.map((opt)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($57c1675cf83b8426$export$6d08773d2e66f8f2, {
            key: opt.value,
            value: opt.value,
            className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex-1 h-[38px] rounded-[9px] font-sans text-[13px]', 'flex items-center justify-center gap-1.5', 'transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring', 'data-[state=on]:bg-white data-[state=on]:text-navy data-[state=on]:font-bold data-[state=on]:shadow-sm', 'data-[state=off]:bg-transparent data-[state=off]:text-muted-foreground data-[state=off]:font-medium', disabled && 'cursor-not-allowed opacity-50')
        }, opt.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-[15px]"
        }, opt.icon), opt.label))));
};
var $43f8655df02249d5$export$2e2bcd8739ae039 = $43f8655df02249d5$var$ToggleGroup;



var $acw62 = parcelRequire("acw62");


'use client';
const $fcaca06c97c91379$var$ChipSelector = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, options: options = [], multi: multi = false, activeColor: activeColor = 'var(--p-navy)', activeBg: activeBg = 'hsl(var(--accent))', validate: validate, disabled: disabled = false, style: style })=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    const isActive = (v)=>multi ? (value || []).includes(v) : value === v;
    const handleToggle = (optValue)=>{
        if (disabled) return;
        let next;
        if (multi) {
            const arr = value || [];
            next = arr.includes(optValue) ? arr.filter((v)=>v !== optValue) : [
                ...arr,
                optValue
            ];
        } else next = value === optValue ? '' : optValue;
        onChange(next);
        setTouched(true);
        if (validate) setInternalError(validate(next) || '');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-wrap gap-1.5"
    }, options.map((opt)=>{
        const active = isActive(opt.value);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: opt.value,
            type: "button",
            onClick: ()=>handleToggle(opt.value),
            disabled: disabled,
            className: (0, $42e05640dae453c1$export$1343a74baacb0543)('h-[34px] px-3.5 rounded-full font-sans text-xs whitespace-nowrap', 'border-[1.5px] transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring', error && !active && 'border-destructive', !error && !active && 'border-border text-[#5a6780] font-medium', disabled && 'cursor-not-allowed opacity-50'),
            style: active ? {
                borderColor: activeColor,
                background: activeBg,
                color: activeColor,
                fontWeight: 700
            } : undefined
        }, opt.label);
    })));
};
var $fcaca06c97c91379$export$2e2bcd8739ae039 = $fcaca06c97c91379$var$ChipSelector;



var $acw62 = parcelRequire("acw62");


'use client';
const $995baf94da7c0c12$var$CardSelector = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, options: options = [], columns: columns = 4, validate: validate, disabled: disabled = false, style: style })=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    const handleSelect = (v)=>{
        if (disabled) return;
        onChange(v);
        setTouched(true);
        if (validate) setInternalError(validate(v) || '');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "grid gap-2",
        style: {
            gridTemplateColumns: `repeat(${columns}, 1fr)`
        }
    }, options.map((opt)=>{
        const active = value === opt.value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: opt.value,
            type: "button",
            onClick: ()=>handleSelect(opt.value),
            disabled: disabled,
            className: (0, $42e05640dae453c1$export$1343a74baacb0543)('py-3.5 px-2 rounded-xl border-[1.5px] text-center font-sans', 'transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring', active ? 'border-navy bg-accent text-navy shadow-sm' : error ? 'border-destructive bg-white text-muted-foreground' : 'border-border bg-white text-muted-foreground', disabled && 'cursor-not-allowed opacity-50')
        }, opt.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "text-xl mb-1.5 leading-none"
        }, opt.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $42e05640dae453c1$export$1343a74baacb0543)('text-[11px] leading-snug', active ? 'font-bold' : 'font-medium')
        }, opt.label));
    })));
};
var $995baf94da7c0c12$export$2e2bcd8739ae039 = $995baf94da7c0c12$var$CardSelector;



var $acw62 = parcelRequire("acw62");

'use client';
// A search box is a *labelled control*, and a filter toolbar needs to be
// selectable in tests (§15.1) — so the wrapper takes the rest props
// (`data-testid`, `id`, …) and the input takes the ones that belong to a text
// field (`aria-label`, `onKeyDown`, `name`, `autoFocus`, `disabled`).
// The clear button restores focus to the field: losing focus to <body> after
// clearing is a keyboard dead end.
const $318ef1f4a903d866$var$SearchInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ value: value, onChange: onChange, placeholder: placeholder = "\u062C\u0633\u062A\u062C\u0648...", className: className, style: style, inputProps: inputProps, 'aria-label': ariaLabel, onKeyDown: onKeyDown, name: name, id: id, disabled: disabled = false, autoFocus: autoFocus, clearLabel: clearLabel = "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u062C\u0633\u062A\u062C\u0648", ...rest }, ref)=>{
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The caller's ref wins; the internal one is what the clear button focuses.
    // A search box that a keyboard shortcut cannot focus is a search box the
    // keyboard-first flows (F3, `/`) have to reach by querySelector.
    const setRef = (node)=>{
        inputRef.current = node;
        if (typeof ref === 'function') ref(node);
        else if (ref) ref.current = node;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('relative', className),
        style: style,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "absolute start-3 top-1/2 -translate-y-1/2 pointer-events-none text-muted-foreground flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        width: "15",
        height: "15",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "11",
        cy: "11",
        r: "7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "21",
        y1: "21",
        x2: "16.65",
        y2: "16.65"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: setRef,
        type: "search",
        value: value,
        onChange: onChange,
        onKeyDown: onKeyDown,
        placeholder: placeholder,
        "aria-label": ariaLabel || placeholder,
        name: name,
        id: id,
        disabled: disabled,
        autoFocus: autoFocus,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(// min-h-11 (2.75rem), not h-10: this control ships in mobile filter
        // toolbars, where DESIGN-CONCEPT-MOBILE §368 puts the floor at 44px.
        'w-full min-h-11 ps-9 pe-8 rounded-lg font-sans text-[13px] text-foreground', 'bg-white border-[1.5px] border-border outline-none', 'transition-[border-color,box-shadow] duration-150', 'focus:border-primary focus:shadow-ring-navy', 'placeholder:text-muted-foreground', disabled && 'opacity-50 cursor-not-allowed', // The native search affordance would sit on top of our clear button.
        '[&::-webkit-search-cancel-button]:appearance-none'),
        ...inputProps
    }), value && !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": clearLabel,
        onClick: ()=>{
            onChange({
                target: {
                    value: ''
                }
            });
            inputRef.current?.focus();
        },
        className: "absolute end-2.5 top-1/2 -translate-y-1/2 flex p-0.5 rounded text-muted-foreground hover:text-foreground transition-colors"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "13",
        height: "13",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }))));
});
$318ef1f4a903d866$var$SearchInput.displayName = 'SearchInput';
var $318ef1f4a903d866$export$2e2bcd8739ae039 = $318ef1f4a903d866$var$SearchInput;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");




// src/use-previous.tsx

var $acw62 = parcelRequire("acw62");
function $44b714300f6a50aa$export$5cae361ad82dce8b(value) {
    const ref = $acw62.useRef({
        value: value,
        previous: value
    });
    return $acw62.useMemo(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}


// src/use-size.tsx

var $acw62 = parcelRequire("acw62");

function $db5ba6ddde57f255$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $acw62.useState(void 0);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}



var $acw62 = parcelRequire("acw62");

"use client";
function $3207c0aa9f229d8f$var$useStateMachine(initialState, machine) {
    return $acw62.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// src/presence.tsx
var $3207c0aa9f229d8f$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $3207c0aa9f229d8f$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $acw62.Children.only(children);
    const ref = $3207c0aa9f229d8f$var$useStableComposedRefs(presence.ref, $3207c0aa9f229d8f$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $acw62.cloneElement(child, {
        ref: ref
    }) : null;
};
$3207c0aa9f229d8f$export$99c2b779aa4e8b8b.displayName = "Presence";
function $3207c0aa9f229d8f$var$usePresence(present) {
    const [node, setNode] = $acw62.useState();
    const stylesRef = $acw62.useRef(null);
    const prevPresentRef = $acw62.useRef(present);
    const prevAnimationNameRef = $acw62.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $3207c0aa9f229d8f$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $acw62.useEffect(()=>{
        const currentAnimationName = $3207c0aa9f229d8f$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $3207c0aa9f229d8f$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $3207c0aa9f229d8f$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $3207c0aa9f229d8f$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $acw62.useCallback((node2)=>{
            stylesRef.current = node2 ? getComputedStyle(node2) : null;
            setNode(node2);
        }, [])
    };
}
function $3207c0aa9f229d8f$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $3207c0aa9f229d8f$var$useStableComposedRefs(...refs) {
    const refsRef = $acw62.useRef(refs);
    refsRef.current = refs;
    return $acw62.useCallback((node)=>{
        const currentRefs = refsRef.current;
        let hasCleanup = false;
        const cleanups = currentRefs.map((ref)=>{
            const cleanup = $3207c0aa9f229d8f$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup === "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup === "function") cleanup();
                else $3207c0aa9f229d8f$var$setRef(currentRefs[i], null);
            }
        };
    }, []);
}
function $3207c0aa9f229d8f$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $3207c0aa9f229d8f$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $3207c0aa9f229d8f$export$be92b6f5f03c0fe9 = $3207c0aa9f229d8f$export$99c2b779aa4e8b8b;




"use client";
var $99e5d66a1fc753c6$var$CHECKBOX_NAME = "Checkbox";
var [$99e5d66a1fc753c6$var$createCheckboxContext, $99e5d66a1fc753c6$export$b566c4ff5488ea01] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($99e5d66a1fc753c6$var$CHECKBOX_NAME);
var [$99e5d66a1fc753c6$var$CheckboxProviderImpl, $99e5d66a1fc753c6$var$useCheckboxContext] = $99e5d66a1fc753c6$var$createCheckboxContext($99e5d66a1fc753c6$var$CHECKBOX_NAME);
function $99e5d66a1fc753c6$export$1335a92a9ee50a8d(props) {
    const { __scopeCheckbox: __scopeCheckbox, checked: checkedProp, children: children, defaultChecked: defaultChecked, disabled: disabled, form: form, name: name, onCheckedChange: onCheckedChange, required: required, value: value = "on", internal_do_not_use_render: // @ts-expect-error
    internal_do_not_use_render } = props;
    const [checked, setChecked] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked ?? false,
        onChange: onCheckedChange,
        caller: $99e5d66a1fc753c6$var$CHECKBOX_NAME
    });
    const [control, setControl] = $acw62.useState(null);
    const [bubbleInput, setBubbleInput] = $acw62.useState(null);
    const hasConsumerStoppedPropagationRef = $acw62.useRef(false);
    const isFormControl = control ? !!form || !!control.closest("form") : // We set this to true by default so that events bubble to forms without JS (SSR)
    true;
    const context = {
        checked: checked,
        disabled: disabled,
        setChecked: setChecked,
        control: control,
        setControl: setControl,
        name: name,
        form: form,
        value: value,
        hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef,
        required: required,
        defaultChecked: $99e5d66a1fc753c6$var$isIndeterminate(defaultChecked) ? false : defaultChecked,
        isFormControl: isFormControl,
        bubbleInput: bubbleInput,
        setBubbleInput: setBubbleInput
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$var$CheckboxProviderImpl, {
        scope: __scopeCheckbox,
        ...context,
        children: $99e5d66a1fc753c6$var$isFunction(internal_do_not_use_render) ? internal_do_not_use_render(context) : children
    });
}
var $99e5d66a1fc753c6$var$TRIGGER_NAME = "CheckboxTrigger";
var $99e5d66a1fc753c6$export$1386466acbe59ca2 = $acw62.forwardRef(({ __scopeCheckbox: __scopeCheckbox, onKeyDown: onKeyDown, onClick: onClick, ...checkboxProps }, forwardedRef)=>{
    const { control: control, value: value, disabled: disabled, checked: checked, required: required, setControl: setControl, setChecked: setChecked, hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef, isFormControl: isFormControl, bubbleInput: bubbleInput } = $99e5d66a1fc753c6$var$useCheckboxContext($99e5d66a1fc753c6$var$TRIGGER_NAME, __scopeCheckbox);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, setControl);
    const initialCheckedStateRef = $acw62.useRef(checked);
    $acw62.useEffect(()=>{
        const form = control?.form;
        if (form) {
            const reset = ()=>setChecked(initialCheckedStateRef.current);
            form.addEventListener("reset", reset);
            return ()=>form.removeEventListener("reset", reset);
        }
    }, [
        control,
        setChecked
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, {
        type: "button",
        role: "checkbox",
        "aria-checked": $99e5d66a1fc753c6$var$isIndeterminate(checked) ? "mixed" : checked,
        "aria-required": required,
        "data-state": $99e5d66a1fc753c6$var$getState(checked),
        "data-disabled": disabled ? "" : void 0,
        disabled: disabled,
        value: value,
        ...checkboxProps,
        ref: composedRefs,
        onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(onKeyDown, (event)=>{
            if (event.key === "Enter") event.preventDefault();
        }),
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(onClick, (event)=>{
            setChecked((prevChecked)=>$99e5d66a1fc753c6$var$isIndeterminate(prevChecked) ? true : !prevChecked);
            if (bubbleInput && isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    });
});
$99e5d66a1fc753c6$export$1386466acbe59ca2.displayName = $99e5d66a1fc753c6$var$TRIGGER_NAME;
var $99e5d66a1fc753c6$export$48513f6b9f8ce62d = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, name: name, checked: checked, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value, onCheckedChange: onCheckedChange, form: form, ...checkboxProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$export$1335a92a9ee50a8d, {
        __scopeCheckbox: __scopeCheckbox,
        checked: checked,
        defaultChecked: defaultChecked,
        disabled: disabled,
        required: required,
        onCheckedChange: onCheckedChange,
        name: name,
        form: form,
        value: value,
        internal_do_not_use_render: ({ isFormControl: isFormControl })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$export$1386466acbe59ca2, {
                        ...checkboxProps,
                        ref: forwardedRef,
                        __scopeCheckbox: __scopeCheckbox
                    }),
                    isFormControl && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$export$493083511fc9f964, {
                        __scopeCheckbox: __scopeCheckbox
                    })
                ]
            })
    });
});
$99e5d66a1fc753c6$export$48513f6b9f8ce62d.displayName = $99e5d66a1fc753c6$var$CHECKBOX_NAME;
var $99e5d66a1fc753c6$var$INDICATOR_NAME = "CheckboxIndicator";
var $99e5d66a1fc753c6$export$59aad738f51d1c05 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, forceMount: forceMount, ...indicatorProps } = props;
    const context = $99e5d66a1fc753c6$var$useCheckboxContext($99e5d66a1fc753c6$var$INDICATOR_NAME, __scopeCheckbox);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || $99e5d66a1fc753c6$var$isIndeterminate(context.checked) || context.checked === true,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).span, {
            "data-state": $99e5d66a1fc753c6$var$getState(context.checked),
            "data-disabled": context.disabled ? "" : void 0,
            ...indicatorProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "none",
                ...props.style
            }
        })
    });
});
$99e5d66a1fc753c6$export$59aad738f51d1c05.displayName = $99e5d66a1fc753c6$var$INDICATOR_NAME;
var $99e5d66a1fc753c6$var$BUBBLE_INPUT_NAME = "CheckboxBubbleInput";
var $99e5d66a1fc753c6$export$493083511fc9f964 = $acw62.forwardRef(({ __scopeCheckbox: __scopeCheckbox, ...props }, forwardedRef)=>{
    const { control: control, hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef, checked: checked, defaultChecked: defaultChecked, required: required, disabled: disabled, name: name, value: value, form: form, bubbleInput: bubbleInput, setBubbleInput: setBubbleInput } = $99e5d66a1fc753c6$var$useCheckboxContext($99e5d66a1fc753c6$var$BUBBLE_INPUT_NAME, __scopeCheckbox);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, setBubbleInput);
    const prevChecked = (0, $44b714300f6a50aa$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $db5ba6ddde57f255$export$1ab7ae714698c4b8)(control);
    $acw62.useEffect(()=>{
        const input = bubbleInput;
        if (!input) return;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        const bubbles = !hasConsumerStoppedPropagationRef.current;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            input.indeterminate = $99e5d66a1fc753c6$var$isIndeterminate(checked);
            setChecked.call(input, $99e5d66a1fc753c6$var$isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(event);
        }
    }, [
        bubbleInput,
        prevChecked,
        checked,
        hasConsumerStoppedPropagationRef
    ]);
    const defaultCheckedRef = $acw62.useRef($99e5d66a1fc753c6$var$isIndeterminate(checked) ? false : checked);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).input, {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: defaultChecked ?? defaultCheckedRef.current,
        required: required,
        disabled: disabled,
        name: name,
        value: value,
        form: form,
        ...props,
        tabIndex: -1,
        ref: composedRefs,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0,
            // We transform because the input is absolutely positioned but we have
            // rendered it **after** the button. This pulls it back to sit on top
            // of the button.
            transform: "translateX(-100%)"
        }
    });
});
$99e5d66a1fc753c6$export$493083511fc9f964.displayName = $99e5d66a1fc753c6$var$BUBBLE_INPUT_NAME;
function $99e5d66a1fc753c6$var$isFunction(value) {
    return typeof value === "function";
}
function $99e5d66a1fc753c6$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $99e5d66a1fc753c6$var$getState(checked) {
    return $99e5d66a1fc753c6$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}



'use client';
// `label` takes a node, not just a string: a picker row is a checkbox whose
// label IS the row (name, value, trend), and wrapping it here keeps the whole
// row inside the native <label> hit area instead of re-implementing one.
// `className`/rest land on that <label> so callers can carry the §15.1
// `data-testid` / `data-state` contract without a wrapper element.
const $7a6c6e1277da35de$var$Checkbox = ({ checked: checked, onChange: onChange, label: label, disabled: disabled = false, className: className, labelClassName: labelClassName, style: style, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex items-center gap-2.5 select-none', disabled ? 'cursor-not-allowed' : 'cursor-pointer', className),
        style: style,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($99e5d66a1fc753c6$export$48513f6b9f8ce62d, {
        checked: checked,
        onCheckedChange: onChange,
        disabled: disabled,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('h-[18px] w-[18px] shrink-0 rounded-[5px] border-[1.5px]', 'flex items-center justify-center', 'transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1', checked ? 'bg-navy border-navy' : 'bg-white border-border', disabled && 'opacity-50')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($99e5d66a1fc753c6$export$59aad738f51d1c05, {
        className: "flex items-center justify-center text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "11",
        height: "11"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    })))), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('text-sm font-sans text-foreground', labelClassName)
    }, label));
var $7a6c6e1277da35de$export$2e2bcd8739ae039 = $7a6c6e1277da35de$var$Checkbox;



var $acw62 = parcelRequire("acw62");
// ─────────────────────────────────────────────────────────────────────────────
// @parsina/tokens — the single source of truth for the Parsina design system.
//
// Canonical copy: /packages/tokens (monorepo root). Each client app receives a
// synced copy at src/shared/tokens via `python dev/sync_shared.py` — edit HERE,
// never in the synced copies.
//
// Three historical token systems (constants/theme.js `C`, constants/unifiedTheme.js
// `CT`, and per-app CSS vars) are collapsed into this module + tokens.css +
// tailwind.preset.js. Prefer Tailwind classes; `C`/`CT` exist for the screens
// still written with inline style objects.
// ─────────────────────────────────────────────────────────────────────────────
// Core palette — legacy `C` shape, kept verbatim so inline-styled screens keep working.
// Brand hues are sampled from the P+ logo (logo.png): teal #00BEB2 → azure #0173BE.
// `navy*` names are kept for compatibility but now hold the azure family.
//
// THEMEABLE vs FIXED — the accent family (navy*/teal*) resolves to CSS custom
// properties so the doctor's accent preset re-themes every screen that uses the
// tokens, without a single component re-rendering. The semantic colours
// (red/green/amber) and the surfaces are deliberately literal hex: a red drug
// interaction warning must look the same under every preset.
//
// Because the accent entries are `var(...)` strings and not hex, never do colour
// arithmetic on them by hand (`C.navy + '15'`, parseInt, slice). Use `soft()`
// below — it handles both forms.
const $e7c165fb515b04ea$export$e7094788287c5e9b = {
    navy: 'var(--p-navy)',
    navyDark: 'var(--p-navy-dark)',
    navyLight: 'var(--p-navy-light)',
    red: '#D93025',
    redLight: '#F5E8E7',
    teal: 'var(--p-teal)',
    tealLight: 'var(--p-teal-light)',
    green: '#1A9B6C',
    greenLight: '#E6F5EF',
    amber: '#F59E0B',
    amberLight: '#FEF3C7',
    bg: '#f5f7fa',
    card: '#ffffff',
    border: '#eef0f3',
    textPrimary: '#1a2332',
    textSecondary: '#5a6780',
    textMuted: '#9aa3b0'
};
const $e7c165fb515b04ea$export$4b57bfb4dade55bd = {
    // Backgrounds
    bg: '#f5f7fa',
    surface: '#ffffff',
    surface2: '#f3f2f0',
    // Borders
    border: '#eef0f3',
    border2: '#ece9e4',
    // Text
    ink: '#1a2332',
    ink2: '#5a6780',
    mute: '#9aa3b0',
    mute2: '#b0aca3',
    // Accent (teal — logo top hue). Themed; see the note on `C`.
    accent: 'var(--p-teal)',
    accentInk: 'var(--p-navy-dark)',
    accentSoft: 'color-mix(in srgb, var(--p-teal) 12%, transparent)',
    // Good (green)
    good: '#1A9B6C',
    goodInk: '#166534',
    goodSoft: 'rgba(22,163,74,0.12)',
    // Warn (amber)
    warn: '#F59E0B',
    warnInk: '#92400e',
    warnSoft: 'rgba(217,119,6,0.12)',
    // Danger (red)
    danger: '#D93025',
    dangerInk: '#991b1b',
    dangerSoft: 'rgba(220,38,38,0.08)',
    // Legacy aliases (keep older code working)
    navy: 'var(--p-navy)',
    navyDark: 'var(--p-navy-dark)',
    navyLight: 'var(--p-navy-light)',
    teal: 'var(--p-teal)',
    tealLight: 'var(--p-teal-light)',
    green: '#1A9B6C',
    greenLight: '#E6F5EF',
    amber: '#F59E0B',
    amberLight: '#FEF3C7',
    red: '#D93025',
    redLight: '#F5E8E7',
    card: '#ffffff',
    textPrimary: '#1a2332',
    textSecondary: '#5a6780',
    textMuted: '#9aa3b0'
};
const $e7c165fb515b04ea$export$2d2c9be8b5b863f = {
    chip: 6,
    control: 10,
    card: 14,
    hero: 20,
    pill: 999
};
const $e7c165fb515b04ea$export$98b6069deb71e13e = {
    card: '0 1px 4px rgba(0,0,0,0.06)',
    floating: '0 8px 24px rgba(0,0,0,0.10)',
    modal: '0 25px 60px rgba(0,0,0,0.20)'
};
const $e7c165fb515b04ea$export$169e587b68892b4e = {
    base: '#e9ecf1',
    sheen: '#f6f7f9',
    // On a gradient header, the sidebar or a dark canvas: white-alpha blocks.
    onDark: 'rgba(255,255,255,0.14)',
    onDarkSheen: 'rgba(255,255,255,0.26)'
};
const $e7c165fb515b04ea$export$959fb1d648dd9e6c = 'rgba(28,27,24,0.55)';
const $e7c165fb515b04ea$export$7deb2be06092489e = 'var(--gradient-brand)';
const $e7c165fb515b04ea$export$4c2e201e0b6dbaa3 = 'var(--gradient-brand-dark)';
const $e7c165fb515b04ea$export$4a4d076b923f4e78 = 'var(--gradient-sidebar)';
const $e7c165fb515b04ea$export$18e630330c8bca65 = 50;
const $e7c165fb515b04ea$export$63b7f4b4938ce481 = 200;
function $e7c165fb515b04ea$export$2e1a2382662bd4ea(balance) {
    if (balance == null) return null;
    if (balance < $e7c165fb515b04ea$export$18e630330c8bca65) return 'low';
    if (balance < $e7c165fb515b04ea$export$63b7f4b4938ce481) return 'mid';
    return 'ok';
}
const $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7 = {
    low: {
        color: $e7c165fb515b04ea$export$e7094788287c5e9b.red,
        tint: $e7c165fb515b04ea$export$e7094788287c5e9b.redLight,
        labelKey: 'credits.level.low',
        shortLabelKey: 'credits.level.lowShort'
    },
    mid: {
        color: $e7c165fb515b04ea$export$e7094788287c5e9b.amber,
        tint: $e7c165fb515b04ea$export$e7094788287c5e9b.amberLight,
        labelKey: 'credits.level.mid',
        shortLabelKey: 'credits.level.midShort'
    },
    ok: {
        color: $e7c165fb515b04ea$export$e7094788287c5e9b.green,
        tint: $e7c165fb515b04ea$export$e7094788287c5e9b.greenLight,
        labelKey: 'credits.level.ok',
        shortLabelKey: 'credits.level.okShort'
    }
};
function $e7c165fb515b04ea$export$3b48083d65d829ca(balance, fallback = $e7c165fb515b04ea$export$e7094788287c5e9b.textMuted) {
    const level = $e7c165fb515b04ea$export$2e1a2382662bd4ea(balance);
    return level ? $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7[level].color : fallback;
}
const $e7c165fb515b04ea$export$7bce9182245b1545 = (color, alpha = 0.12)=>{
    if (typeof color !== 'string' || !color) return 'transparent';
    const c = color.trim();
    if (c.startsWith('var(') || c.startsWith('color-mix(')) {
        const pct = Math.max(0, Math.min(100, Math.round(alpha * 100)));
        return `color-mix(in srgb, ${c} ${pct}%, transparent)`;
    }
    const h = c.replace('#', '');
    const full = h.length === 3 ? h.split('').map((x)=>x + x).join('') : h;
    const n = parseInt(full, 16);
    if (!/^[0-9a-fA-F]{6}$/.test(full) || Number.isNaN(n)) return c;
    return `rgba(${n >> 16 & 255}, ${n >> 8 & 255}, ${n & 255}, ${alpha})`;
};
const $e7c165fb515b04ea$export$a1d018c6ed60ae4c = [
    {
        id: 'default',
        label: "\u0622\u0628\u06CC \u067E\u0627\u0631\u0633\u06CC\u0646\u0627",
        swatch: '#0173BE',
        swatch2: '#00BEB2'
    },
    {
        id: 'teal',
        label: "\u0641\u06CC\u0631\u0648\u0632\u0647\u200C\u0627\u06CC",
        swatch: '#00A99E',
        swatch2: '#0173BE'
    },
    {
        id: 'ocean',
        label: "\u0644\u0627\u062C\u0648\u0631\u062F\u06CC",
        swatch: '#0A5C8A',
        swatch2: '#0E8F9E'
    },
    {
        id: 'slate',
        label: "\u062E\u0627\u06A9\u0633\u062A\u0631\u06CC \u0622\u0628\u06CC",
        swatch: '#3F5E75',
        swatch2: '#5C8A9E'
    }
];
const $e7c165fb515b04ea$export$7634868d3a6a0a2e = {
    doctor: {
        label: "\u067E\u0646\u0644 \u067E\u0632\u0634\u06A9",
        primary: '#0173BE',
        ink: '#083250'
    },
    clinic: {
        label: "\u067E\u0646\u0644 \u06A9\u0644\u06CC\u0646\u06CC\u06A9",
        primary: '#0A4F8F',
        ink: '#062F57'
    },
    patient: {
        label: "\u067E\u0631\u0648\u0646\u062F\u0647 \u0633\u0644\u0627\u0645\u062A \u0645\u0646",
        primary: '#007C8C',
        ink: '#06363F'
    },
    dentist: {
        label: "\u067E\u0646\u0644 \u062F\u0646\u062F\u0627\u0646\u200C\u067E\u0632\u0634\u06A9\u06CC",
        primary: '#007D74',
        ink: '#063F3C'
    }
};
function $e7c165fb515b04ea$export$32d6efa0a3310091(panel) {
    const id = $e7c165fb515b04ea$export$7634868d3a6a0a2e[panel];
    if (!id) return $e7c165fb515b04ea$export$a1d018c6ed60ae4c;
    return $e7c165fb515b04ea$export$a1d018c6ed60ae4c.map((t)=>t.id === 'default' ? {
            ...t,
            label: "\u0631\u0646\u06AF \u067E\u0646\u0644",
            swatch: id.primary
        } : t);
}
const $e7c165fb515b04ea$export$58c32c962db85532 = [
    {
        id: 'small',
        label: "\u06A9\u0648\u0686\u06A9"
    },
    {
        id: 'medium',
        label: "\u0645\u062A\u0648\u0633\u0637"
    },
    {
        id: 'large',
        label: "\u0628\u0632\u0631\u06AF"
    }
];
const $e7c165fb515b04ea$export$2faeed762aac6741 = 'default';
const $e7c165fb515b04ea$export$b1461457ea2c1179 = 'medium';
const $e7c165fb515b04ea$export$888c18c43ead4265 = (id)=>$e7c165fb515b04ea$export$a1d018c6ed60ae4c.some((t)=>t.id === id);
const $e7c165fb515b04ea$export$5414ec5c49c0af0f = (id)=>$e7c165fb515b04ea$export$58c32c962db85532.some((f)=>f.id === id);
const $e7c165fb515b04ea$export$ff61b65939f754cc = 'parsina.appearance';
function $e7c165fb515b04ea$export$dde01dc24facb6b0(storage) {
    const store = storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);
    try {
        const raw = store?.getItem($e7c165fb515b04ea$export$ff61b65939f754cc);
        const parsed = raw ? JSON.parse(raw) : null;
        return {
            theme: $e7c165fb515b04ea$export$888c18c43ead4265(parsed?.theme) ? parsed.theme : $e7c165fb515b04ea$export$2faeed762aac6741,
            fontSize: $e7c165fb515b04ea$export$5414ec5c49c0af0f(parsed?.fontSize) ? parsed.fontSize : $e7c165fb515b04ea$export$b1461457ea2c1179
        };
    } catch  {
        // Private mode, quota, or a corrupt value — fall back rather than throw.
        return {
            theme: $e7c165fb515b04ea$export$2faeed762aac6741,
            fontSize: $e7c165fb515b04ea$export$b1461457ea2c1179
        };
    }
}
function $e7c165fb515b04ea$export$48c323151b232e54({ theme: theme, fontSize: fontSize } = {}, doc) {
    const root = (doc ?? (typeof document !== 'undefined' ? document : null))?.documentElement;
    if (!root) return {
        theme: $e7c165fb515b04ea$export$2faeed762aac6741,
        fontSize: $e7c165fb515b04ea$export$b1461457ea2c1179
    };
    const resolved = {
        theme: $e7c165fb515b04ea$export$888c18c43ead4265(theme) ? theme : $e7c165fb515b04ea$export$2faeed762aac6741,
        fontSize: $e7c165fb515b04ea$export$5414ec5c49c0af0f(fontSize) ? fontSize : $e7c165fb515b04ea$export$b1461457ea2c1179
    };
    root.setAttribute('data-theme', resolved.theme);
    root.setAttribute('data-font-size', resolved.fontSize);
    return resolved;
}
function $e7c165fb515b04ea$export$64464588479aad90(appearance, storage) {
    const store = storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);
    try {
        store?.setItem($e7c165fb515b04ea$export$ff61b65939f754cc, JSON.stringify(appearance));
    } catch  {
    // Persisting the cache is best-effort; the server copy is the real record.
    }
}
const $e7c165fb515b04ea$export$6881c75116d5bd6e = {
    // Appointment lifecycle, in the scheduling service's own vocabulary and with the
    // same Persian labels the clinic day panel uses — the desk and the doctor must not
    // call the same patient two different things.
    scheduled: {
        bg: '#F1F5F9',
        text: '#475569',
        label: "\u0646\u0648\u0628\u062A\u200C\u062F\u0627\u0631"
    },
    arrived: {
        bg: '#D1FAE5',
        text: '#065F46',
        label: "\u062D\u0627\u0636\u0631"
    },
    in_visit: {
        bg: '#DBEAFE',
        text: '#1E40AF',
        label: "\u062F\u0631 \u062D\u0627\u0644 \u0648\u06CC\u0632\u06CC\u062A"
    },
    completed: {
        bg: '#D1FAE5',
        text: '#065F46',
        label: "\u0648\u06CC\u0632\u06CC\u062A\u200C\u0634\u062F\u0647"
    },
    cancelled: {
        bg: '#FEE2E2',
        text: '#991B1B',
        label: "\u0644\u063A\u0648 \u0634\u062F\u0647"
    },
    // A booked patient who never arrived. Distinct from `cancelled` — nobody
    // cancelled it — and neutral rather than red, because it is a fact about the
    // past, not a problem to act on. The patient app used to fork its own badge
    // for exactly this key (§1.1: missing keys get added here, never re-created
    // locally).
    no_show: {
        bg: '#F1F5F9',
        text: '#64748B',
        label: "\u0639\u062F\u0645 \u062D\u0636\u0648\u0631"
    },
    // ── Patient-originated requests (docs/PATIENT_CLINIC_CARE_CONTEXT_AND_SELF_SERVICE_DESIGN.md §3) ──
    // A patient asked for this slot from the app and the clinic has not answered yet.
    // It HOLDS the slot, so it is a real appointment state and belongs here — amber
    // because it is work waiting on the desk, not a settled fact.
    requested: {
        bg: '#FEF3C7',
        text: '#92400E',
        label: "\u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631 \u062A\u0623\u06CC\u06CC\u062F \u06A9\u0644\u06CC\u0646\u06CC\u06A9"
    },
    // The clinic declined the request, or it expired unanswered. Terminal and neutral:
    // like `no_show`, it is a fact about the past rather than a problem to act on.
    rejected: {
        bg: '#F1F5F9',
        text: '#64748B',
        label: "\u0631\u062F \u0634\u062F\u0647"
    },
    // Patient-record statuses (Patients / PatientDetail screens), a different domain.
    waiting: {
        bg: '#FEF3C7',
        text: '#92400E',
        label: "\u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631"
    },
    visited: {
        bg: '#D1FAE5',
        text: '#065F46',
        label: "\u0648\u06CC\u0632\u06CC\u062A \u0634\u062F"
    },
    inprogress: {
        bg: '#DBEAFE',
        text: '#1E40AF',
        label: "\u062F\u0631 \u062D\u0627\u0644 \u0648\u06CC\u0632\u06CC\u062A"
    }
};
const $e7c165fb515b04ea$export$c7989e6ff0cf1179 = [
    '#0173BE',
    '#00BEB2',
    '#F59E0B',
    '#7C4DBE'
];
const $e7c165fb515b04ea$export$6ee8bfc459aebd80 = {
    acquired: $e7c165fb515b04ea$export$c7989e6ff0cf1179[0],
    converted: $e7c165fb515b04ea$export$c7989e6ff0cf1179[1],
    lost: $e7c165fb515b04ea$export$c7989e6ff0cf1179[2],
    recovered: $e7c165fb515b04ea$export$c7989e6ff0cf1179[3]
};


'use client';
function $ddccb5e00ce1ba3b$export$2e2bcd8739ae039({ checked: checked, onChange: onChange, label: label, description: description, disabled: disabled = false, id: id, ...rest }) {
    const reactId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const rowId = id || reactId;
    const labelId = `${rowId}-label`;
    const descId = description ? `${rowId}-desc` : undefined;
    // The kit styles inline, which cannot express :focus-visible — so the ring is
    // tracked here. Keyed on :focus-visible rather than :focus so a pointer tap
    // does not leave a ring behind, which is the behaviour the pseudo-class
    // exists to give. Setting only outlineColor (as this component did) paints
    // nothing: without an outline-style there is no outline to colour.
    const [focusRing, setFocusRing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 16,
            padding: '14px 0',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            opacity: disabled ? 0.55 : 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        id: labelId,
        htmlFor: rowId,
        style: {
            display: 'block',
            fontSize: 14,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            cursor: disabled ? 'not-allowed' : 'pointer'
        }
    }, label), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: descId,
        style: {
            display: 'block',
            fontSize: 12,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: 3
        }
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        id: rowId,
        role: "switch",
        "aria-checked": checked,
        "aria-labelledby": labelId,
        "aria-describedby": descId,
        disabled: disabled,
        onClick: ()=>!disabled && onChange(!checked),
        onFocus: (e)=>{
            // `matches` can throw on engines without :focus-visible; a ring on
            // plain focus is a better failure than no ring at all.
            let visible = true;
            try {
                visible = e.target.matches(':focus-visible');
            } catch  {}
            setFocusRing(visible);
        },
        onBlur: ()=>setFocusRing(false),
        style: {
            width: 44,
            height: 24,
            borderRadius: 999,
            flexShrink: 0,
            padding: 0,
            border: `1px solid ${checked ? 'transparent' : '#cbd2dc'}`,
            background: checked ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : '#d1d5db',
            cursor: disabled ? 'not-allowed' : 'pointer',
            position: 'relative',
            transition: 'background 0.25s, box-shadow 0.15s',
            outline: 'none',
            boxShadow: focusRing ? `0 0 0 3px ${(0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.45)}` : 'none'
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            position: 'absolute',
            top: 2,
            width: 18,
            height: 18,
            borderRadius: '50%',
            background: 'white',
            transition: 'inset-inline-end 0.25s',
            insetInlineEnd: checked ? 2 : 22,
            boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
            pointerEvents: 'none'
        }
    })));
}



var $acw62 = parcelRequire("acw62");

/**
 * Copyright 2022 Joe Bell. All rights reserved.
 *
 * This file is licensed to you under the Apache License, Version 2.0
 * (the "License"); you may not use this file except in compliance with the
 * License. You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR REPRESENTATIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */ 
const $7d867aa0bbfd521e$var$falsyToString = (value)=>typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
const $7d867aa0bbfd521e$export$a274e22fb40f762e = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37);
const $7d867aa0bbfd521e$export$87dc52566e90b739 = (base, config)=>(props)=>{
        var _config_compoundVariants;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return $7d867aa0bbfd521e$export$a274e22fb40f762e(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants: variants, defaultVariants: defaultVariants } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = $7d867aa0bbfd521e$var$falsyToString(variantProp) || $7d867aa0bbfd521e$var$falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) return acc;
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param)=>{
            let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return $7d867aa0bbfd521e$export$a274e22fb40f762e(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };



'use client';
const $39b6a9e95398564b$export$dca1ee5a936bb312 = (0, $7d867aa0bbfd521e$export$87dc52566e90b739)('inline-flex items-center justify-center gap-2 font-sans font-semibold rounded-lg transition-all duration-150 outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:pointer-events-none disabled:opacity-50 select-none', {
    variants: {
        variant: {
            default: 'bg-navy text-white hover:bg-navy-dark active:scale-[0.98]',
            destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90 active:scale-[0.98]',
            outline: 'border-[1.5px] border-border bg-white text-foreground hover:bg-muted active:scale-[0.98]',
            ghost: 'bg-transparent text-foreground hover:bg-muted',
            link: 'text-primary underline-offset-4 hover:underline',
            teal: 'bg-clinic-teal text-white hover:opacity-90 active:scale-[0.98]',
            // Tonal primary — a navy-tinted pill for secondary actions that still read
            // as brand (jump-to-today, filter chips) without the weight of a solid fill.
            subtle: 'bg-navy/5 text-navy border-[1.5px] border-navy/20 hover:bg-navy/10 active:scale-[0.98]',
            // A sidebar destination, on the deep-azure gradient rail. Selected state
            // arrives as `data-active="true"` (set it beside `aria-current="page"`),
            // NOT as a className the caller assembles: all four staff shells were
            // writing the same four overrides onto `variant="ghost"`, which §17.1
            // calls a fork of a kit component. The active pill is the brand
            // gradient — the single lit moment on a deliberately teal-free rail.
            nav: 'w-full justify-start font-medium text-white/60 hover:bg-white/10 hover:text-white data-[active=true]:bg-gradient-brand data-[active=true]:text-white data-[active=true]:font-bold data-[active=true]:hover:bg-gradient-brand'
        },
        size: {
            default: 'h-11 px-5 text-[13.5px]',
            sm: 'h-9  px-4 text-xs rounded-md',
            lg: 'h-12 px-7 text-[15px]',
            icon: 'h-10 w-10'
        }
    },
    defaultVariants: {
        variant: 'default',
        size: 'default'
    }
});
const $39b6a9e95398564b$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, variant: variant, size: size, asChild: asChild = false, ...props }, ref)=>{
    const Comp = asChild ? (0, $cf381de56a25bc52$export$be92b6f5f03c0fe9) : 'button';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Comp, {
        ref: ref,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)($39b6a9e95398564b$export$dca1ee5a936bb312({
            variant: variant,
            size: size
        }), className),
        ...props
    });
});
$39b6a9e95398564b$export$353f5b6fc5456de1.displayName = 'Button';
var $39b6a9e95398564b$export$2e2bcd8739ae039 = $39b6a9e95398564b$export$353f5b6fc5456de1;



var $acw62 = parcelRequire("acw62");


'use client';
const $ddd0c49a5377bd48$export$48443d129636634d = (0, $7d867aa0bbfd521e$export$87dc52566e90b739)('inline-flex items-center rounded-full font-sans font-semibold whitespace-nowrap', {
    variants: {
        variant: {
            default: 'bg-accent text-accent-foreground text-[11px] px-2.5 py-0.5',
            // The three pale chip pairs are CSS variables (tokens.css), not
            // literals. Same pixels; the point is that a theme can reach them —
            // every raw hex left in a component is a future dark-mode bug (§11).
            destructive: 'bg-[var(--chip-danger-bg)]  text-[var(--chip-danger-ink)]  text-[11px] px-2.5 py-0.5',
            success: 'bg-[var(--chip-success-bg)] text-[var(--chip-success-ink)] text-[11px] px-2.5 py-0.5',
            warning: 'bg-[var(--chip-warning-bg)] text-[var(--chip-warning-ink)] text-[11px] px-2.5 py-0.5',
            outline: 'border border-border text-foreground text-[11px] px-2.5 py-0.5',
            // `count` — the ONE unread/tally chip. A solid navy pill, not the pale
            // tint `default` gives: every conversation row in every app was
            // overriding `default` with the same inline `background`/`color` to get
            // this, which is the hand-rolled primitive rule in slow motion.
            // `tabular-nums` keeps «۱» and «۹+» the same width so a live count does
            // not jitter the row, and `min-w-5` keeps a single digit round.
            // The swatch is navy, matching `BottomNav`'s `badgeTone: 'count'` —
            // one colour means "unread" everywhere (see DESIGN.md, Messaging).
            // `var(--p-navy)` rather than the `bg-navy` hex so the chip follows the
            // doctor's accent preset exactly as `C.navy` (which BottomNav uses) does.
            count: 'bg-[var(--p-navy)] text-white text-[11px] font-bold leading-5 min-w-5 justify-center px-1.5 tabular-nums shrink-0'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});
const $ddd0c49a5377bd48$export$37acb3580601e69a = ({ className: className, variant: variant, children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)($ddd0c49a5377bd48$export$48443d129636634d({
            variant: variant
        }), className),
        ...props
    }, children);
var $ddd0c49a5377bd48$export$2e2bcd8739ae039 = $ddd0c49a5377bd48$export$37acb3580601e69a;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");




// src/use-escape-keydown.tsx

var $acw62 = parcelRequire("acw62");

function $322b9f9e9e453dd6$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $acw62.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



"use client";
var $30a399657994b369$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $30a399657994b369$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $30a399657994b369$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $30a399657994b369$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $30a399657994b369$var$originalBodyPointerEvents;
var $30a399657994b369$var$DismissableLayerContext = $acw62.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set(),
    // Outside elements that belong to a layer's own dismiss affordance (eg, a
    // dialog overlay). Pressing them should dismiss the layer regardless of
    // whether or not they stop propagation.
    //
    // See https://github.com/radix-ui/primitives/issues/3346
    dismissableSurfaces: /* @__PURE__ */ new Set()
});
var $30a399657994b369$export$177fb62ff3ec1f22 = $acw62.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, deferPointerDownOutside: deferPointerDownOutside = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $acw62.useContext($30a399657994b369$var$DismissableLayerContext);
    const [node, setNode] = $acw62.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $acw62.useState({});
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const isDeferredPointerDownOutsideRef = $acw62.useRef(false);
    const pointerDownOutside = $30a399657994b369$var$usePointerDownOutside((event)=>{
        const target = event.target;
        if (!(target instanceof Node)) return;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, {
        ownerDocument: ownerDocument,
        deferPointerDownOutside: deferPointerDownOutside,
        isDeferredPointerDownOutsideRef: isDeferredPointerDownOutsideRef,
        dismissableSurfaces: context.dismissableSurfaces
    });
    const focusOutside = $30a399657994b369$var$useFocusOutside((event)=>{
        if (deferPointerDownOutside && isDeferredPointerDownOutsideRef.current) return;
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, $322b9f9e9e453dd6$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $acw62.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $30a399657994b369$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $30a399657994b369$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents) {
                context.layersWithOutsidePointerEventsDisabled.delete(node);
                if (context.layersWithOutsidePointerEventsDisabled.size === 0) ownerDocument.body.style.pointerEvents = $30a399657994b369$var$originalBodyPointerEvents;
            }
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $30a399657994b369$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $acw62.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($30a399657994b369$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($30a399657994b369$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$30a399657994b369$export$177fb62ff3ec1f22.displayName = $30a399657994b369$var$DISMISSABLE_LAYER_NAME;
var $30a399657994b369$var$BRANCH_NAME = "DismissableLayerBranch";
var $30a399657994b369$export$4d5eb2109db14228 = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $acw62.useContext($30a399657994b369$var$DismissableLayerContext);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $acw62.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$30a399657994b369$export$4d5eb2109db14228.displayName = $30a399657994b369$var$BRANCH_NAME;
function $30a399657994b369$export$210785236bdfcb27() {
    const context = $acw62.useContext($30a399657994b369$var$DismissableLayerContext);
    const [node, setNode] = $acw62.useState(null);
    $acw62.useEffect(()=>{
        if (!node) return;
        context.dismissableSurfaces.add(node);
        return ()=>{
            context.dismissableSurfaces.delete(node);
        };
    }, [
        node,
        context.dismissableSurfaces
    ]);
    return setNode;
}
function $30a399657994b369$var$usePointerDownOutside(onPointerDownOutside, args) {
    const { ownerDocument: ownerDocument = globalThis?.document, deferPointerDownOutside: deferPointerDownOutside = false, isDeferredPointerDownOutsideRef: isDeferredPointerDownOutsideRef, dismissableSurfaces: dismissableSurfaces } = args;
    const handlePointerDownOutside = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $acw62.useRef(false);
    const isPointerDownOutsideRef = $acw62.useRef(false);
    const interceptedOutsideInteractionEventsRef = $acw62.useRef(/* @__PURE__ */ new Map());
    const handleClickRef = $acw62.useRef(()=>{});
    $acw62.useEffect(()=>{
        function resetOutsideInteraction() {
            isPointerDownOutsideRef.current = false;
            isDeferredPointerDownOutsideRef.current = false;
            interceptedOutsideInteractionEventsRef.current.clear();
        }
        function isOutsideInteractionIntercepted() {
            return Array.from(interceptedOutsideInteractionEventsRef.current.values()).some(Boolean);
        }
        function handleInteractionCapture(event) {
            if (!isPointerDownOutsideRef.current) return;
            const target = event.target;
            const isDismissableSurface = target instanceof Node && [
                ...dismissableSurfaces
            ].some((surface)=>surface.contains(target));
            if (!isDismissableSurface) interceptedOutsideInteractionEventsRef.current.set(event.type, true);
            if (event.type === "click") window.setTimeout(()=>{
                if (isPointerDownOutsideRef.current) handleClickRef.current();
            }, 0);
        }
        function handleInteractionBubble(event) {
            if (isPointerDownOutsideRef.current) interceptedOutsideInteractionEventsRef.current.set(event.type, false);
        }
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    const wasOutsideInteractionIntercepted = isOutsideInteractionIntercepted();
                    resetOutsideInteraction();
                    if (!wasOutsideInteractionIntercepted) $30a399657994b369$var$handleAndDispatchCustomEvent($30a399657994b369$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                isPointerDownOutsideRef.current = true;
                isDeferredPointerDownOutsideRef.current = deferPointerDownOutside && event.button === 0;
                interceptedOutsideInteractionEventsRef.current.clear();
                if (!deferPointerDownOutside || event.button !== 0) handleAndDispatchPointerDownOutsideEvent2();
                else {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                }
            } else {
                ownerDocument.removeEventListener("click", handleClickRef.current);
                resetOutsideInteraction();
            }
            isPointerInsideReactTreeRef.current = false;
        };
        const outsideInteractionEvents = [
            "pointerup",
            "mousedown",
            "mouseup",
            "touchstart",
            "touchend",
            "click"
        ];
        for (const eventName of outsideInteractionEvents){
            ownerDocument.addEventListener(eventName, handleInteractionCapture, true);
            ownerDocument.addEventListener(eventName, handleInteractionBubble);
        }
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
            for (const eventName of outsideInteractionEvents){
                ownerDocument.removeEventListener(eventName, handleInteractionCapture, true);
                ownerDocument.removeEventListener(eventName, handleInteractionBubble);
            }
        };
    }, [
        ownerDocument,
        handlePointerDownOutside,
        deferPointerDownOutside,
        isDeferredPointerDownOutsideRef,
        dismissableSurfaces
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $30a399657994b369$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $30a399657994b369$var$handleAndDispatchCustomEvent($30a399657994b369$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $30a399657994b369$var$dispatchUpdate() {
    const event = new CustomEvent($30a399657994b369$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $30a399657994b369$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $dc7d5df3de21cdcb$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $30a399657994b369$export$be92b6f5f03c0fe9 = $30a399657994b369$export$177fb62ff3ec1f22;
var $30a399657994b369$export$aecb2ddcb55c95be = $30a399657994b369$export$4d5eb2109db14228;



var $acw62 = parcelRequire("acw62");




"use client";
var $03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $03c48a27777929a8$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $03c48a27777929a8$var$FOCUS_SCOPE_NAME = "FocusScope";
var $03c48a27777929a8$export$20e40289641fbbb6 = $acw62.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $acw62.useState(null);
    const onMountAutoFocus = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = $acw62.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $acw62.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $03c48a27777929a8$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $03c48a27777929a8$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $03c48a27777929a8$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $acw62.useEffect(()=>{
        if (container) {
            $03c48a27777929a8$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT, $03c48a27777929a8$var$EVENT_OPTIONS);
                container.addEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $03c48a27777929a8$var$focusFirst($03c48a27777929a8$var$removeLinks($03c48a27777929a8$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $03c48a27777929a8$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT, $03c48a27777929a8$var$EVENT_OPTIONS);
                    container.addEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $03c48a27777929a8$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $03c48a27777929a8$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $acw62.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $03c48a27777929a8$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $03c48a27777929a8$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $03c48a27777929a8$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$03c48a27777929a8$export$20e40289641fbbb6.displayName = $03c48a27777929a8$var$FOCUS_SCOPE_NAME;
function $03c48a27777929a8$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $03c48a27777929a8$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $03c48a27777929a8$var$getTabbableEdges(container) {
    const candidates = $03c48a27777929a8$var$getTabbableCandidates(container);
    const first = $03c48a27777929a8$var$findVisible(candidates, container);
    const last = $03c48a27777929a8$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $03c48a27777929a8$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $03c48a27777929a8$var$findVisible(elements, container) {
    for (const element of elements){
        if (!$03c48a27777929a8$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $03c48a27777929a8$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $03c48a27777929a8$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $03c48a27777929a8$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $03c48a27777929a8$var$isSelectableInput(element) && select) element.select();
    }
}
var $03c48a27777929a8$var$focusScopesStack = $03c48a27777929a8$var$createFocusScopesStack();
function $03c48a27777929a8$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $03c48a27777929a8$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $03c48a27777929a8$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function $03c48a27777929a8$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $03c48a27777929a8$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $03c48a27777929a8$export$be92b6f5f03c0fe9 = $03c48a27777929a8$export$20e40289641fbbb6;



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");



"use client";
var $95d053caea9c023a$var$PORTAL_NAME = "Portal";
var $95d053caea9c023a$export$602eac185826482c = $acw62.forwardRef((props, forwardedRef)=>{
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $acw62.useState(false);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? $1u0KT.createPortal(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$95d053caea9c023a$export$602eac185826482c.displayName = $95d053caea9c023a$var$PORTAL_NAME;
var $95d053caea9c023a$export$be92b6f5f03c0fe9 = $95d053caea9c023a$export$602eac185826482c;





var $acw62 = parcelRequire("acw62");
"use client";
var $264faec0fdf8876a$var$count = 0;
var $264faec0fdf8876a$var$guards = null;
function $264faec0fdf8876a$export$ac5b58043b79449b(props) {
    $264faec0fdf8876a$export$b7ece24a22aeda8c();
    return props.children;
}
function $264faec0fdf8876a$export$b7ece24a22aeda8c() {
    $acw62.useEffect(()=>{
        if (!$264faec0fdf8876a$var$guards) $264faec0fdf8876a$var$guards = {
            start: $264faec0fdf8876a$var$createFocusGuard(),
            end: $264faec0fdf8876a$var$createFocusGuard()
        };
        const { start: start, end: end } = $264faec0fdf8876a$var$guards;
        if (document.body.firstElementChild !== start) document.body.insertAdjacentElement("afterbegin", start);
        if (document.body.lastElementChild !== end) document.body.insertAdjacentElement("beforeend", end);
        $264faec0fdf8876a$var$count++;
        return ()=>{
            if ($264faec0fdf8876a$var$count === 1) {
                $264faec0fdf8876a$var$guards?.start.remove();
                $264faec0fdf8876a$var$guards?.end.remove();
                $264faec0fdf8876a$var$guards = null;
            }
            $264faec0fdf8876a$var$count = Math.max(0, $264faec0fdf8876a$var$count - 1);
        };
    }, []);
}
function $264faec0fdf8876a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = 'right-scroll-bar-position';
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = 'width-before-scroll-bar';
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = 'with-scroll-bars-hidden';
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = '--removed-body-scroll-bar-size';



var $acw62 = parcelRequire("acw62");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $1ec01e2201501f3d$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $1ec01e2201501f3d$var$currentValues = new WeakMap();
function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $05ac61ef45da8ec5$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $1ec01e2201501f3d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $1ec01e2201501f3d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $1ec01e2201501f3d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)();


var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $f6d5b57f3512e73c$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e),
    zeroRight: (0, $3f8d56f1a38c65c8$export$1da7500147d4bc3)
};




var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return $acw62.createElement(Target, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};


function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, $1334c25f36aeceaf$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $be1d9ed5bb532264$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $b5f767dd03f483e5$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $9f2b7a700f678519$var$Style = (0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8)();
var $9f2b7a700f678519$export$65254d5f26cb9564 = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, $3f8d56f1a38c65c8$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    ").concat((0, $3f8d56f1a38c65c8$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($9f2b7a700f678519$export$65254d5f26cb9564) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var $9f2b7a700f678519$export$a1939b1f9f9b02dc = function() {
    $acw62.useEffect(function() {
        document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, ($9f2b7a700f678519$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $9f2b7a700f678519$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($9f2b7a700f678519$export$65254d5f26cb9564);
            else document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    $9f2b7a700f678519$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $19c77eb414ad2a19$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};







var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;


var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowY');
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowX');
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState((0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8))[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        // allow drag selection (iOS); check if selection's anchorNode is the same as target or contains target
        var selection = window.getSelection();
        var anchorNode = selection && selection.anchorNode;
        var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
        if (isTouchingSelection) return false;
        var canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $a7f277057d6643d0$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $f5f147098910888d$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener('touchmove', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener('touchstart', scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener('touchmove', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $9f2b7a700f678519$export$9aa43b459c5ae9b9), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function $f5f147098910888d$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce)((0, $f6d5b57f3512e73c$export$e27363444bedfeac), (0, $f5f147098910888d$export$a09dbff87b5da2d));


var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $cac2578984d345ac$export$22940b497e769dee), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $0e88b28988758ab2$export$2e2bcd8739ae039)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $cac2578984d345ac$export$22940b497e769dee).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;


var $4a7537e072260c10$var$getDefaultParent = function(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $4a7537e072260c10$var$counterMap = new WeakMap();
var $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
var $4a7537e072260c10$var$markerMap = {};
var $4a7537e072260c10$var$lockCount = 0;
var $4a7537e072260c10$var$unwrapHost = function(node) {
    return node && (node.host || $4a7537e072260c10$var$unwrapHost(node.parentNode));
};
var $4a7537e072260c10$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $4a7537e072260c10$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $4a7537e072260c10$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $4a7537e072260c10$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$4a7537e072260c10$var$markerMap[markerName]) $4a7537e072260c10$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $4a7537e072260c10$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = ($4a7537e072260c10$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $4a7537e072260c10$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $4a7537e072260c10$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $4a7537e072260c10$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $4a7537e072260c10$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $4a7537e072260c10$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$4a7537e072260c10$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $4a7537e072260c10$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $4a7537e072260c10$var$lockCount--;
        if (!$4a7537e072260c10$var$lockCount) {
            // clear
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
            $4a7537e072260c10$var$markerMap = {};
        }
    };
};
var $4a7537e072260c10$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return $4a7537e072260c10$var$applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var $4a7537e072260c10$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-inert-ed';
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $4a7537e072260c10$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
var $4a7537e072260c10$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
var $4a7537e072260c10$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-suppressed';
    return ($4a7537e072260c10$export$cc95fea82d705fca() ? $4a7537e072260c10$export$59151cc8db999a24 : $4a7537e072260c10$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};




"use client";
var $eeaeb48e23f662e7$var$DIALOG_NAME = "Dialog";
var [$eeaeb48e23f662e7$var$createDialogContext, $eeaeb48e23f662e7$export$cc702773b8ea3e41] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($eeaeb48e23f662e7$var$DIALOG_NAME);
var [$eeaeb48e23f662e7$var$DialogProvider, $eeaeb48e23f662e7$var$useDialogContext] = $eeaeb48e23f662e7$var$createDialogContext($eeaeb48e23f662e7$var$DIALOG_NAME);
var $eeaeb48e23f662e7$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = $acw62.useRef(null);
    const contentRef = $acw62.useRef(null);
    const [open, setOpen] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $eeaeb48e23f662e7$var$DIALOG_NAME
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        titleId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        descriptionId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $acw62.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: children
    });
};
$eeaeb48e23f662e7$export$3ddf2d174ce01153.displayName = $eeaeb48e23f662e7$var$DIALOG_NAME;
var $eeaeb48e23f662e7$var$TRIGGER_NAME = "DialogTrigger";
var $eeaeb48e23f662e7$export$2e1e1122cf0cba88 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.open ? context.contentId : void 0,
        "data-state": $eeaeb48e23f662e7$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
});
$eeaeb48e23f662e7$export$2e1e1122cf0cba88.displayName = $eeaeb48e23f662e7$var$TRIGGER_NAME;
var $eeaeb48e23f662e7$var$PORTAL_NAME = "DialogPortal";
var [$eeaeb48e23f662e7$var$PortalProvider, $eeaeb48e23f662e7$var$usePortalContext] = $eeaeb48e23f662e7$var$createDialogContext($eeaeb48e23f662e7$var$PORTAL_NAME, {
    forceMount: void 0
});
var $eeaeb48e23f662e7$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $acw62.Children.map(children, (child)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $95d053caea9c023a$export$602eac185826482c), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
};
$eeaeb48e23f662e7$export$dad7c95542bacce0.displayName = $eeaeb48e23f662e7$var$PORTAL_NAME;
var $eeaeb48e23f662e7$var$OVERLAY_NAME = "DialogOverlay";
var $eeaeb48e23f662e7$export$bd1d06c79be19e17 = $acw62.forwardRef((props, forwardedRef)=>{
    const portalContext = $eeaeb48e23f662e7$var$usePortalContext($eeaeb48e23f662e7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
});
$eeaeb48e23f662e7$export$bd1d06c79be19e17.displayName = $eeaeb48e23f662e7$var$OVERLAY_NAME;
var $eeaeb48e23f662e7$var$Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)("DialogOverlay.RemoveScroll");
var $eeaeb48e23f662e7$var$DialogOverlayImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$OVERLAY_NAME, __scopeDialog);
    const registerDismissableSurface = (0, $30a399657994b369$export$210785236bdfcb27)();
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, registerDismissableSurface);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039), {
        as: $eeaeb48e23f662e7$var$Slot,
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
            "data-state": $eeaeb48e23f662e7$var$getState(context.open),
            ...overlayProps,
            ref: composedRefs,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
});
var $eeaeb48e23f662e7$var$CONTENT_NAME = "DialogContent";
var $eeaeb48e23f662e7$export$7c6e2c02157bb7d2 = $acw62.forwardRef((props, forwardedRef)=>{
    const portalContext = $eeaeb48e23f662e7$var$usePortalContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$eeaeb48e23f662e7$export$7c6e2c02157bb7d2.displayName = $eeaeb48e23f662e7$var$CONTENT_NAME;
var $eeaeb48e23f662e7$var$DialogContentModal = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef);
    $acw62.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $4a7537e072260c10$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: context.open,
        onCloseAutoFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    });
});
var $eeaeb48e23f662e7$var$DialogContentNonModal = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $acw62.useRef(false);
    const hasPointerDownOutsideRef = $acw62.useRef(false);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $eeaeb48e23f662e7$var$DialogContentImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, __scopeDialog);
    (0, $264faec0fdf8876a$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $03c48a27777929a8$export$20e40289641fbbb6), {
            asChild: true,
            loop: true,
            trapped: trapFocus,
            onMountAutoFocus: onOpenAutoFocus,
            onUnmountAutoFocus: onCloseAutoFocus,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $30a399657994b369$export$177fb62ff3ec1f22), {
                role: "dialog",
                id: context.contentId,
                "aria-describedby": context.descriptionId,
                "aria-labelledby": context.titleId,
                "data-state": $eeaeb48e23f662e7$var$getState(context.open),
                ...contentProps,
                ref: forwardedRef,
                deferPointerDownOutside: true,
                onDismiss: ()=>context.onOpenChange(false)
            })
        })
    });
});
var $eeaeb48e23f662e7$var$TITLE_NAME = "DialogTitle";
var $eeaeb48e23f662e7$export$16f7638e4a34b909 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
});
$eeaeb48e23f662e7$export$16f7638e4a34b909.displayName = $eeaeb48e23f662e7$var$TITLE_NAME;
var $eeaeb48e23f662e7$var$DESCRIPTION_NAME = "DialogDescription";
var $eeaeb48e23f662e7$export$393edc798c47379d = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$eeaeb48e23f662e7$export$393edc798c47379d.displayName = $eeaeb48e23f662e7$var$DESCRIPTION_NAME;
var $eeaeb48e23f662e7$var$CLOSE_NAME = "DialogClose";
var $eeaeb48e23f662e7$export$f39c2d165cd861fe = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$eeaeb48e23f662e7$export$f39c2d165cd861fe.displayName = $eeaeb48e23f662e7$var$CLOSE_NAME;
var $eeaeb48e23f662e7$export$69b62a49393917d6 = (props)=>{
    return props.children;
};
function $eeaeb48e23f662e7$var$getState(open) {
    return open ? "open" : "closed";
}



'use client';
const $ace11be13f1c53cf$export$3ddf2d174ce01153 = $eeaeb48e23f662e7$export$3ddf2d174ce01153;
const $ace11be13f1c53cf$export$2e1e1122cf0cba88 = $eeaeb48e23f662e7$export$2e1e1122cf0cba88;
const $ace11be13f1c53cf$export$fba2fb7cd781b7ac = $eeaeb48e23f662e7$export$f39c2d165cd861fe;
const $ace11be13f1c53cf$export$dad7c95542bacce0 = $eeaeb48e23f662e7$export$dad7c95542bacce0;
// ── Overlay z-scale (keep these in sync; see DESIGN.md "Overlay layering") ──
// Drawer 11 < BottomSheet 1000 < Dialog/ConfirmDialog 1100 < Toast / JalaliDatePicker 9999
//
// The dialog layer MUST sit above BottomSheet: a ConfirmDialog is routinely opened from
// inside a sheet (destructive confirms, unsaved-changes guards). At the old z-50 it
// rendered *behind* the sheet while Radix's modal mode set `pointer-events: none` on
// <body> — so the sheet froze with an invisible modal trapping focus, unrecoverable by
// touch. Raising the dialog (rather than lowering the sheet) is the safe direction:
// mobile chrome that must stay under a sheet — the doctor app's MobileBottomNav (z-50)
// and MobileVisitClosureFlow (z-60) — keeps working unchanged.
const $ace11be13f1c53cf$var$Z_DIALOG = 'z-[1100]';
// A dialog is a transition the user asked for, so it animates — but §12.4 of the
// design concept says every transition collapses to instant under
// `prefers-reduced-motion`. Radix drives the animation through `data-state`
// classes, so the opt-out has to be a class too; without it the dialog was the
// one overlay that kept moving for a user who asked it not to.
const $ace11be13f1c53cf$var$MOTION_SAFE = 'motion-reduce:animate-none motion-reduce:transition-none';
const $ace11be13f1c53cf$export$bd1d06c79be19e17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eeaeb48e23f662e7$export$bd1d06c79be19e17, {
        ref: ref,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('fixed inset-0 bg-black/45', $ace11be13f1c53cf$var$Z_DIALOG, 'data-[state=open]:animate-in data-[state=closed]:animate-out', 'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0', $ace11be13f1c53cf$var$MOTION_SAFE, className),
        ...props
    }));
$ace11be13f1c53cf$export$bd1d06c79be19e17.displayName = 'DialogOverlay';
// Floating layers portaled to <body> (e.g. the Jalali calendar popup) live outside the
// dialog's DOM, so Radix would treat interacting with them as an outside click and close
// the dialog mid-pick. Anything inside [data-jalali-popup] is ours, not "outside".
const $ace11be13f1c53cf$var$isInFloatingLayer = (e)=>e.target instanceof Element && e.target.closest('[data-jalali-popup]');
// ── Width ────────────────────────────────────────────────────────────────────
// Four widths rather than a free `className` override, because "how wide is a
// dialog" is a design-system decision: a confirm and a full review surface must
// not each pick their own number. `md` is the historical default, so every
// existing call site keeps its exact width.
const $ace11be13f1c53cf$var$SIZE = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-3xl',
    xl: 'max-w-[52rem]'
};
// ── Layout ───────────────────────────────────────────────────────────────────
// `scroll` (default) is the classic dialog: one padded box that scrolls as a
// whole. `frame` is the surface with its own chrome — a fixed header, a
// scrolling body and a docked footer — which is what a review/receipt overlay
// needs so its primary action never scrolls out of reach. The three slot
// components read the mode from context rather than taking a prop, so a caller
// cannot half-apply it.
const $ace11be13f1c53cf$var$LayoutContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext('scroll');
const $ace11be13f1c53cf$export$b6d9565de1e068cf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, children: children, showClose: showClose = true, size: size = 'md', layout: layout = 'scroll', ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ace11be13f1c53cf$export$dad7c95542bacce0, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ace11be13f1c53cf$export$bd1d06c79be19e17, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eeaeb48e23f662e7$export$7c6e2c02157bb7d2, {
        ref: ref,
        onPointerDownOutside: (e)=>{
            if ($ace11be13f1c53cf$var$isInFloatingLayer(e)) e.preventDefault();
        },
        onFocusOutside: (e)=>{
            if ($ace11be13f1c53cf$var$isInFloatingLayer(e)) e.preventDefault();
        },
        onInteractOutside: (e)=>{
            if ($ace11be13f1c53cf$var$isInFloatingLayer(e)) e.preventDefault();
        },
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2', $ace11be13f1c53cf$var$Z_DIALOG, 'w-full bg-white rounded-2xl shadow-modal', $ace11be13f1c53cf$var$SIZE[size] || $ace11be13f1c53cf$var$SIZE.md, layout === 'frame' ? [
            'grid grid-rows-[auto_minmax(0,1fr)_auto] overflow-hidden',
            'max-h-[calc(100vh-3rem)] [@supports(height:1dvh)]:max-h-[calc(100dvh-3rem)]'
        ] : 'max-h-[90vh] overflow-y-auto p-8', 'data-[state=open]:animate-in data-[state=closed]:animate-out', 'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0', 'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95', 'data-[state=closed]:slide-out-to-left-1/2 data-[state=open]:slide-in-from-left-1/2', 'data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-top-[48%]', $ace11be13f1c53cf$var$MOTION_SAFE, className),
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ace11be13f1c53cf$var$LayoutContext.Provider, {
        value: layout
    }, children), showClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eeaeb48e23f662e7$export$f39c2d165cd861fe, {
        className: "absolute end-5 top-5 rounded-sm opacity-70 hover:opacity-100 outline-none focus:ring-2 focus:ring-ring transition-opacity"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "18",
        height: "18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }))))));
$ace11be13f1c53cf$export$b6d9565de1e068cf.displayName = 'DialogContent';
const $ace11be13f1c53cf$export$742513523b177e3b = ({ className: className, ...props })=>{
    const layout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ace11be13f1c53cf$var$LayoutContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex flex-col gap-1.5', layout === 'frame' ? 'px-5 py-4 border-b border-border' : 'mb-6', className),
        ...props
    });
};
// The scroll region of a `frame` dialog. `overscroll-contain` is what stops a
// flick at the end of the list from scrolling the page behind the dialog.
const $ace11be13f1c53cf$export$5d20f2c38fcde41f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>{
    const layout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ace11be13f1c53cf$var$LayoutContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(layout === 'frame' ? 'overflow-y-auto overscroll-contain p-5' : '', className),
        ...props
    });
});
$ace11be13f1c53cf$export$5d20f2c38fcde41f.displayName = 'DialogBody';
const $ace11be13f1c53cf$export$7bbfb2d443473050 = ({ className: className, ...props })=>{
    const layout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ace11be13f1c53cf$var$LayoutContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex gap-2.5', layout === 'frame' ? 'px-5 py-3 border-t border-border flex-wrap' : 'mt-6', className),
        ...props
    });
};
const $ace11be13f1c53cf$export$16f7638e4a34b909 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eeaeb48e23f662e7$export$16f7638e4a34b909, {
        ref: ref,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('text-[18px] font-extrabold text-foreground', className),
        ...props
    }));
$ace11be13f1c53cf$export$16f7638e4a34b909.displayName = 'DialogTitle';
const $ace11be13f1c53cf$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eeaeb48e23f662e7$export$393edc798c47379d, {
        ref: ref,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('text-sm text-muted-foreground leading-6', className),
        ...props
    }));
$ace11be13f1c53cf$export$94e94c2ec2c954d5.displayName = 'DialogDescription';



var $acw62 = parcelRequire("acw62");

'use client';
function $49383ac93d397699$export$2e2bcd8739ae039({ open: open, onClose: onClose, width: width = 400, children: children }) {
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const h = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', h);
        return ()=>document.removeEventListener('keydown', h);
    }, [
        open,
        onClose
    ]);
    if (!open) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        onClick: onClose,
        style: {
            position: 'absolute',
            inset: 0,
            background: 'rgba(0,0,0,0.25)',
            zIndex: 10,
            backdropFilter: 'blur(1px)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            // Docks at the inline-END — the side away from the shell's sidebar, so
            // a drawer never covers the navigation it was opened from (§5.2). This
            // was `left: 0`, the inline-end under `rtl` and the inline-START under
            // `ltr`, i.e. straight over an English layout's sidebar.
            position: 'absolute',
            top: 0,
            insetInlineEnd: 0,
            width: width,
            height: '100%',
            background: '#fff',
            // No x-offset: a signed offset points at a physical side, and this
            // panel sits on whichever side the reading direction puts the end on.
            boxShadow: '0 0 24px rgba(0,0,0,0.12)',
            zIndex: 11,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        }
    }, children));
}
function $49383ac93d397699$export$bb68d554ded258ea({ title: title, sub: sub, onClose: onClose, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '18px 20px',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 16,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        }
    }, title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: 2
        }
    }, sub), children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClose,
        style: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: 22,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            lineHeight: 1,
            padding: '2px 6px'
        }
    }, "\xd7"));
}
function $49383ac93d397699$export$4ed8420cdfcb2b8f({ children: children, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflow: 'auto',
            padding: 20,
            ...style
        }
    }, children);
}
function $49383ac93d397699$export$d05a7d25ec5abf06({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '16px 20px',
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            display: 'flex',
            gap: 8,
            flexShrink: 0
        }
    }, children);
}



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $acw62 = parcelRequire("acw62");
'use client';
function $da50fe1f8f323572$export$a477a7ade7efed9c() {
    const [inset, setInset] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        const vv = typeof window === 'undefined' ? null : window.visualViewport;
        if (!vv) return undefined;
        const read = ()=>{
            // Everything below the visual viewport's bottom edge is covered. The
            // rounding keeps a sub-pixel viewport from re-rendering on every frame of
            // the keyboard animation.
            const covered = window.innerHeight - (vv.height + vv.offsetTop);
            setInset(Math.max(0, Math.round(covered)));
        };
        read();
        vv.addEventListener('resize', read);
        vv.addEventListener('scroll', read);
        return ()=>{
            vv.removeEventListener('resize', read);
            vv.removeEventListener('scroll', read);
        };
    }, []);
    return inset;
}
var $da50fe1f8f323572$export$2e2bcd8739ae039 = $da50fe1f8f323572$export$a477a7ade7efed9c;



var $acw62 = parcelRequire("acw62");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// useOverlayHistory — put an overlay INTO the history stack.
//
// ── The problem ─────────────────────────────────────────────────────────────
// A bottom sheet, a full-screen picker and a closure overlay are all things a
// person opened and expects to be able to *back out of*. On a phone that means
// the hardware back button on Android and the browser's back gesture on iOS —
// neither of which the page can veto. Because no overlay pushed anything onto
// the history stack, pressing back with a sheet open navigated the ROUTE
// UNDERNEATH it: the sheet stayed on screen over a different screen, or the
// person left a half-finished form without ever being asked.
//
// Per-screen fixes for this do not work. Every app that tried one ended up with
// a `popstate` listener per screen, each guessing how many entries to unwind,
// and one of them (the doctor app's visit guard) hardcoded `history.go(-2)` —
// correct only while exactly one anchor exists, and wrong the moment a sheet is
// open on top of it.
//
// ── The rule this implements ────────────────────────────────────────────────
// Opening an overlay pushes ONE history entry tagged with a private token;
// closing it pops that entry. A `popstate` that removes the token is the
// platform saying "close this overlay", so `onClose` runs and nothing else
// happens — the route never changes. Overlays stack: the innermost one owns the
// newest entry, so back closes them one at a time, in order.
//
// The pushed entry deliberately CARRIES THE ROUTER'S OWN STATE FORWARD
// (`...history.state`), which keeps `idx`/`key` identical. React Router reads
// `state.idx` on `popstate` to compute a delta; leaving it untouched makes the
// delta zero, so the router sees the pop and correctly does nothing. Bumping it
// would make the router re-navigate to the same URL with a new key and reset
// screen state that the overlay was sitting on top of.
//
// ── Depth, for guarded routes ───────────────────────────────────────────────
// A route with a leave-guard (an open visit) has to unwind its own anchor PLUS
// whatever overlays are above it. `overlayHistoryDepth()` is that count, so the
// guard says `history.go(-(1 + overlayHistoryDepth()))` rather than a literal.
//
// ── Whose pop is this? (v0.11.5) ────────────────────────────────────────────
// A leave-guard is itself a `popstate` listener, and `popstate` does not say
// what was left — only what was landed on. So a guard that treats every pop
// as "the person is leaving" fires on the pops THIS hook makes: close a sheet
// with the ✕, the scrim or a submit, the cleanup below calls `back()` to drop
// the sheet's entry, and the guard asks «خروج از ویزیت؟» over a screen the
// person never tried to leave. Found on a phone in the doctor app, where every
// sheet on the visit did it.
//
// `overlayOwnsPop()` is the one question a guard needs to ask first. It is
// true in exactly the two cases where a pop is an overlay's business:
//   · an overlay still HOLDS an entry — the platform back is closing it, and
//     the overlay's own listener (registered later, so it runs after the
//     guard's) will handle it;
//   · this hook has just popped its own entry from inside the app. That is
//     announced BEFORE `back()` and consumed by the first reader within a
//     short window, so a `back()` that never produced a pop cannot swallow a
//     real one later.
//
// SSR/jsdom-safe: with no `window.history` it is inert, so a caller can add it
// unconditionally.
// ─────────────────────────────────────────────────────────────────────────────
const $6fd4a6c8c2176e20$var$MARK = 'parsinaOverlay';
let $6fd4a6c8c2176e20$var$sequence = 0;
/** Tokens of the overlays that currently own a history entry, innermost last. */ const $6fd4a6c8c2176e20$var$openTokens = [];
/** When this hook last popped its own entry (ms epoch); 0 when it has not. */ let $6fd4a6c8c2176e20$var$selfPopAt = 0;
// A history traversal completes within a frame or two; the window is only
// there so a `back()` that never produced a pop cannot claim a later one.
const $6fd4a6c8c2176e20$var$SELF_POP_WINDOW_MS = 1000;
function $6fd4a6c8c2176e20$export$9452f2c4c9460e1e() {
    return $6fd4a6c8c2176e20$var$openTokens.length;
}
function $6fd4a6c8c2176e20$export$2846246580854e2f() {
    if ($6fd4a6c8c2176e20$var$openTokens.length > 0) return true;
    if ($6fd4a6c8c2176e20$var$selfPopAt && Date.now() - $6fd4a6c8c2176e20$var$selfPopAt < $6fd4a6c8c2176e20$var$SELF_POP_WINDOW_MS) {
        $6fd4a6c8c2176e20$var$selfPopAt = 0;
        return true;
    }
    $6fd4a6c8c2176e20$var$selfPopAt = 0;
    return false;
}
function $6fd4a6c8c2176e20$export$b512be9f39899018() {
    $6fd4a6c8c2176e20$var$openTokens.length = 0;
    $6fd4a6c8c2176e20$var$sequence = 0;
    $6fd4a6c8c2176e20$var$selfPopAt = 0;
}
function $6fd4a6c8c2176e20$export$2e2bcd8739ae039(open, onClose, { enabled: enabled = true, id: id } = {}) {
    // `onClose` is almost always an inline arrow, so depending on it would tear
    // the history entry down and rebuild it on every render of the host screen.
    const onCloseRef = (0, $acw62.useRef)(onClose);
    onCloseRef.current = onClose;
    (0, $acw62.useEffect)(()=>{
        if (!enabled || !open) return undefined;
        if (typeof window === 'undefined' || !window.history?.pushState) return undefined;
        const seq = ++$6fd4a6c8c2176e20$var$sequence;
        const token = `${id || 'overlay'}#${seq}`;
        $6fd4a6c8c2176e20$var$openTokens.push(token);
        // True once the platform has already taken our entry off the stack, so the
        // cleanup below knows not to pop a second time.
        let popped = false;
        // Set by the cleanup; a reclaim scheduled before it must not fire after it.
        let disposed = false;
        let reclaimTimer = null;
        // The URL the entry was claimed on. A pop that lands on a different URL is
        // a navigation (a leave-guard's `go(-n)`), never a refused close.
        const claimedHref = window.location.href;
        const drop = ()=>{
            const at = $6fd4a6c8c2176e20$var$openTokens.indexOf(token);
            if (at !== -1) $6fd4a6c8c2176e20$var$openTokens.splice(at, 1);
        };
        const ours = ()=>window.history.state?.[$6fd4a6c8c2176e20$var$MARK] === token;
        try {
            window.history.pushState({
                ...window.history.state || {},
                [$6fd4a6c8c2176e20$var$MARK]: token
            }, '');
        } catch  {
            // iOS caps pushState calls per interval. An overlay that cannot claim an
            // entry still opens; it just does not intercept back, which is exactly
            // today's behaviour and strictly better than refusing to render.
            drop();
            return undefined;
        }
        // ── A refused close (v0.16.1) ─────────────────────────────────────────────
        // The platform back has ALREADY removed our entry by the time `onClose`
        // runs, and the page cannot veto that. A consumer may still refuse — a dirty
        // form that asks «خروج بدون ذخیره؟» and hears «بمانم», or TaskOverlay's
        // `busy` withholding `onClose` mid-write. Before this, the overlay stayed on
        // screen with no entry, so the NEXT back left the route under it.
        //
        // So one tick after `onClose`: if this effect is still alive (nothing set
        // `open` to false), claim the entry again. An honoured close has cleaned the
        // effect up by then and nothing here runs.
        const reclaim = ()=>{
            reclaimTimer = null;
            if (disposed || !popped || ours()) return;
            if (window.location.href !== claimedHref) return;
            const seqOf = (t)=>Number(t.slice(t.lastIndexOf('#') + 1));
            // Overlays opened DURING the refusal (a confirm sheet) already pushed
            // their entries above where ours belongs. With exactly one, rotate: the
            // top entry becomes ours and theirs is pushed back on top of it.
            const above = $6fd4a6c8c2176e20$var$openTokens.filter((t)=>seqOf(t) > seq);
            const state = window.history.state || {};
            try {
                if (above.length === 0) window.history.pushState({
                    ...state,
                    [$6fd4a6c8c2176e20$var$MARK]: token
                }, '');
                else if (above.length === 1 && state[$6fd4a6c8c2176e20$var$MARK] === above[0]) {
                    window.history.replaceState({
                        ...state,
                        [$6fd4a6c8c2176e20$var$MARK]: token
                    }, '');
                    window.history.pushState({
                        ...state,
                        [$6fd4a6c8c2176e20$var$MARK]: above[0]
                    }, '');
                } else // Two or more inner entries cannot be reordered without a traversal
                // the person would see; leave it as it was rather than misorder them.
                return;
            } catch  {
                return; // the iOS pushState cap — same fallback as the first claim
            }
            const at = above.length ? $6fd4a6c8c2176e20$var$openTokens.indexOf(above[0]) : -1;
            if (at === -1) $6fd4a6c8c2176e20$var$openTokens.push(token);
            else $6fd4a6c8c2176e20$var$openTokens.splice(at, 0, token);
            popped = false;
        };
        const onPop = ()=>{
            // Still ours: something DEEPER popped, and its own hook is handling it.
            if (ours()) return;
            popped = true;
            drop();
            onCloseRef.current?.();
            if (!disposed && reclaimTimer === null) reclaimTimer = setTimeout(reclaim, 0);
        };
        window.addEventListener('popstate', onPop);
        return ()=>{
            disposed = true;
            if (reclaimTimer !== null) {
                clearTimeout(reclaimTimer);
                reclaimTimer = null;
            }
            window.removeEventListener('popstate', onPop);
            drop();
            // Closed from inside the app (the ✕, a submit, Escape). Our entry is
            // still on the stack, so remove it — otherwise back would have to be
            // pressed once for the ghost entry and once for the actual route.
            //
            // `ours()` is the guard that makes this safe on unmount-by-navigation: a
            // sheet whose button routed somewhere else no longer owns the top entry,
            // and calling back() there would undo the navigation it just performed.
            if (!popped && ours()) {
                // Announced before the traversal, because the guard's listener will
                // run inside the resulting `popstate` and has no other way to know.
                $6fd4a6c8c2176e20$var$selfPopAt = Date.now();
                try {
                    window.history.back();
                } catch  {
                    $6fd4a6c8c2176e20$var$selfPopAt = 0;
                }
            }
        };
    }, [
        open,
        enabled,
        id
    ]);
}


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// BottomSheet — mobile-first modal that slides up from the bottom edge.
// Replaces the duplicated ClinicModal implementations in the patient app and
// ad-hoc bottom sheets elsewhere. For desktop-centred dialogs use Dialog.
//
// It is the default overlay for a mobile task or filter set
// (DESIGN-CONCEPT-MOBILE §6); `ConfirmDialog` stays a centered dialog and sits
// ABOVE this one on the z-scale (DESIGN.md, Overlay layering).
//
// ── What makes it phone-grade (v0.10.0) ─────────────────────────────────────
// Every one of these was a defect a phone could reproduce and a desktop could
// not, and each was found in all three apps at once because they all render
// this component:
//
//   dvh, not vh        `85vh` is measured against the LARGEST viewport, so on
//                      iOS Safari with the address bar expanded the sheet was
//                      taller than the screen and its own footer sat under the
//                      toolbar. `100dvh` tracks the live viewport; the `vh`
//                      declaration stays as the fallback for browsers without
//                      it, behind an `@supports` upgrade.
//   the keyboard       `position: fixed` is blind to the software keyboard, so
//                      a focused field's submit button sat *under* the keys.
//                      `useKeyboardInset` is the kit's answer and the sheet
//                      subtracts it from its own ceiling.
//   back closes it     the platform back button used to navigate the route
//                      underneath an open sheet, leaving the sheet floating
//                      over a different screen. `useOverlayHistory` puts the
//                      sheet in the history stack (opt out with
//                      `historyIntegration={false}` for a desktop dialog).
//   focus stays in     a modal that leaks focus to the page behind it is not a
//                      modal. Focus moves in on open, Tab cycles inside, and
//                      the previously-focused element gets it back on close.
//   the page is still  without a scroll lock, scrolling past the sheet's end
//                      scrolls the screen behind it — on iOS the page then
//                      rubber-bands and the sheet appears to drift.
//   44px close         the ✕ was 30px, under the 2.75rem minimum (§6).
//   tokens             surfaces, scrim, radius and text now come from the token
//                      layer instead of five literal hexes.
//   rendered at body   (v0.11.4) `position: fixed` and a z-index only mean
//                      what they say inside the ROOT stacking context. A sheet
//                      mounted deep in a screen — inside the scroller of a tab,
//                      say — sat in whatever context its ancestors made: iOS
//                      WebKit composites an overflow scroller and traps fixed
//                      descendants in it, so the sheet was clipped to the
//                      scroller and the screen's own docked bar, later in the
//                      DOM, painted OVER it. Chromium does not do this, which
//                      is why a browser test could not see it. The sheet now
//                      portals to `document.body`, exactly as the kit `Dialog`
//                      does through Radix: where a sheet happens to be mounted
//                      is no longer something a screen has to get right.
//
// Props:
//   open / onClose
//   title      — optional heading
//   footer     — optional docked commit row. §6 says "submit docks bottom", and
//                the sheet's body is a scroll region, so a footer placed in
//                `children` scrolls away exactly when it is needed. This slot
//                sticks to the bottom edge, above the safe-area inset AND above
//                the software keyboard.
//   fullHeight — a tall form (a stepper, a long picker) takes the whole
//                available height instead of hugging its content, so the footer
//                sits at the bottom edge rather than halfway up the screen.
//   snap       — cap the sheet at a fraction of the viewport (0.2–1, default
//                0.85). `snap={1}` with `fullHeight` is a full-screen task.
//   dir        — writing direction. UNSET by default, so the sheet INHERITS the
//                document's. It used to hardcode `dir="rtl"`, which renders
//                backwards in an app that also ships `en`; the three RTL apps
//                set `dir="rtl"` on <html>, so inheriting is identical for them.
//   closeLabel — accessible name of the close button (default «بستن»)
//   maxWidth   — the sheet's cap on a wide viewport
//   historyIntegration — false to opt out of the back-button behaviour
//   portal     — false to render in place instead of at `document.body`. Only
//                for a consumer that deliberately scopes CSS custom properties
//                to a subtree and needs the sheet inside it; the default is the
//                one that is correct on a phone.
//   className / data-testid and any other prop are forwarded to the overlay.
//
// `dir` inherits from `<html>` after the portal, which is what it inherited
// before in every app that sets the direction where the I18N rule says to.
// ─────────────────────────────────────────────────────────────────────────────
// Everything focusable a sheet can realistically contain. `[hidden]` and
// `disabled` are excluded because Tab skips them anyway, and a trap that
// disagrees with the browser about the cycle is worse than no trap.
const $cfba7d02b5e7069f$var$FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
].join(',');
const $cfba7d02b5e7069f$var$PANEL_CLASS = 'parsina-sheet-panel';
// One stylesheet for every sheet on the page, not one per instance: the rules
// are identical and the per-sheet numbers arrive as custom properties.
const $cfba7d02b5e7069f$var$SHEET_CSS = `
  @keyframes parsina-sheet-fade{from{opacity:0}to{opacity:1}}
  @keyframes parsina-sheet-up{from{transform:translateY(24px);opacity:0}to{transform:translateY(0);opacity:1}}
  .${$cfba7d02b5e7069f$var$PANEL_CLASS}{max-height:var(--parsina-sheet-vh)}
  .${$cfba7d02b5e7069f$var$PANEL_CLASS}[data-full-height]{height:var(--parsina-sheet-vh)}
  /* The upgrade. Guarded because a custom property holding an unsupported unit
     is invalid at computed-value time, which would drop max-height entirely. */
  @supports (height: 100dvh){
    .${$cfba7d02b5e7069f$var$PANEL_CLASS}{max-height:var(--parsina-sheet-dvh)}
    .${$cfba7d02b5e7069f$var$PANEL_CLASS}[data-full-height]{height:var(--parsina-sheet-dvh)}
  }
  @media (prefers-reduced-motion: reduce){
    .${$cfba7d02b5e7069f$var$PANEL_CLASS}, .parsina-sheet-scrim{animation:none!important}
  }
`;
function $cfba7d02b5e7069f$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, children: children, footer: footer, fullHeight: fullHeight = false, snap: snap = 0.85, dir: dir, closeLabel: closeLabel = "\u0628\u0633\u062A\u0646", maxWidth: maxWidth = 480, historyIntegration: historyIntegration = true, portal: portal = true, className: className, 'data-testid': testId, ...rest }) {
    const panelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const restoreFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const keyboardInset = (0, $da50fe1f8f323572$export$2e2bcd8739ae039)();
    // Back / hardware-back closes the sheet and leaves the route alone.
    (0, $6fd4a6c8c2176e20$export$2e2bcd8739ae039)(open, onClose, {
        enabled: historyIntegration,
        id: testId || 'sheet'
    });
    // Escape + the focus trap. One listener for both: they are the same contract
    // — while this is open, the keyboard belongs to it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') {
                onClose?.();
                return;
            }
            if (e.key !== 'Tab') return;
            const panel = panelRef.current;
            if (!panel) return;
            const items = [
                ...panel.querySelectorAll($cfba7d02b5e7069f$var$FOCUSABLE)
            ].filter((el)=>el.offsetParent !== null);
            if (items.length === 0) {
                e.preventDefault();
                panel.focus();
                return;
            }
            const first = items[0];
            const last = items[items.length - 1];
            const active = document.activeElement;
            // Wrapping by hand is what keeps focus inside: the browser's own next
            // stop after `last` is the page behind the scrim.
            if (e.shiftKey && (active === first || !panel.contains(active))) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && (active === last || !panel.contains(active))) {
                e.preventDefault();
                first.focus();
            }
        };
        document.addEventListener('keydown', onKey);
        return ()=>document.removeEventListener('keydown', onKey);
    }, [
        open,
        onClose
    ]);
    // Move focus in on open and hand it back on close. Without the hand-back, a
    // sheet opened from a list left focus on <body>, so the next Tab started from
    // the top of the page instead of from the control that opened it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        restoreFocusRef.current = document.activeElement;
        // After paint, so the panel and its children exist to receive it.
        const raf = typeof requestAnimationFrame === 'function' ? requestAnimationFrame(()=>{
            const panel = panelRef.current;
            if (!panel) return;
            const firstField = panel.querySelector($cfba7d02b5e7069f$var$FOCUSABLE);
            (firstField || panel).focus?.({
                preventScroll: true
            });
        }) : null;
        return ()=>{
            if (raf !== null) cancelAnimationFrame(raf);
            const previous = restoreFocusRef.current;
            restoreFocusRef.current = null;
            if (previous && typeof previous.focus === 'function' && document.contains(previous)) previous.focus({
                preventScroll: true
            });
        };
    }, [
        open
    ]);
    // Body scroll lock. Restores the exact previous inline values rather than
    // clearing them, so two stacked sheets do not leave the page unlocked when
    // the inner one closes.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || typeof document === 'undefined') return undefined;
        const body = document.body;
        const previous = {
            overflow: body.style.overflow,
            touchAction: body.style.touchAction,
            overscroll: body.style.overscrollBehavior
        };
        body.style.overflow = 'hidden';
        // iOS ignores `overflow: hidden` on <body> for touch scrolling; these two
        // are what actually stop the page behind the scrim from moving.
        body.style.touchAction = 'none';
        body.style.overscrollBehavior = 'none';
        return ()=>{
            body.style.overflow = previous.overflow;
            body.style.touchAction = previous.touchAction;
            body.style.overscrollBehavior = previous.overscroll;
        };
    }, [
        open
    ]);
    if (!open) return null;
    // `calc()` multiplies a NUMBER by a length, so the snap stays a fraction.
    const cap = Math.min(Math.max(Number(snap) || 0.85, 0.2), 1);
    const tree = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: dir,
        className: className ? `parsina-sheet-scrim ${className}` : 'parsina-sheet-scrim',
        "data-testid": testId,
        onClick: onClose,
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: 1000,
            background: (0, $e7c165fb515b04ea$export$959fb1d648dd9e6c),
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            animation: 'parsina-sheet-fade 0.2s ease-out'
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, $cfba7d02b5e7069f$var$SHEET_CSS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: panelRef,
        className: $cfba7d02b5e7069f$var$PANEL_CLASS,
        "data-full-height": fullHeight ? '' : undefined,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": title || closeLabel,
        tabIndex: -1,
        onClick: (e)=>e.stopPropagation(),
        style: {
            width: '100%',
            maxWidth: maxWidth,
            display: 'flex',
            flexDirection: 'column',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderRadius: `${(0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).hero}px ${(0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).hero}px 0 0`,
            boxShadow: '0 -12px 40px rgba(0,0,0,0.18)',
            // The keyboard eats the bottom of the viewport, so the sheet's own
            // ceiling comes down by the same amount or its footer is under the
            // keys. Both units are published; the stylesheet picks.
            '--parsina-sheet-vh': `calc(${cap} * 100vh - ${keyboardInset}px)`,
            '--parsina-sheet-dvh': `calc(${cap} * 100dvh - ${keyboardInset}px)`,
            animation: 'parsina-sheet-up 0.25s cubic-bezier(0.4,0,0.2,1)',
            // No `fontFamily` here: the typeface is set once at the app root and
            // inherited (§2.1 — a component-level font declaration is a defect).
            outline: 'none',
            padding: '1rem 1.25rem 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '0.75rem',
            marginBottom: title ? '0.75rem' : 0,
            flexShrink: 0
        }
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            fontSize: '0.9375rem',
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            margin: 0,
            minWidth: 0
        }
    }, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClose,
        "aria-label": closeLabel,
        "data-testid": testId ? `${testId}-close` : undefined,
        style: {
            border: 'none',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            cursor: 'pointer',
            // §6: 2.75rem is the floor for anything a thumb has to hit. The
            // glyph stays small; the TARGET is what grew.
            width: '2.75rem',
            height: '2.75rem',
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            flexShrink: 0,
            padding: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M18 6 6 18M6 6l12 12"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: fullHeight ? 1 : undefined,
            minHeight: 0,
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
            // The sheet is the one scroller while it is open; a flick that
            // reaches its end must not hand the gesture to the page behind it.
            overscrollBehavior: 'contain',
            paddingBottom: footer ? 0 : 'calc(1.25rem + env(safe-area-inset-bottom, 0px))'
        }
    }, children), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0,
            marginTop: '0.75rem',
            marginInline: '-1.25rem',
            padding: '0.625rem 1.25rem',
            paddingBottom: 'calc(0.625rem + env(safe-area-inset-bottom, 0px))',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        }
    }, footer)));
    // `document` is absent during a Next.js server render; a sheet that is open
    // on the server (rare, but a valid initial state) renders in place there and
    // moves to <body> on the client.
    if (portal && typeof document !== 'undefined') return /*#__PURE__*/ (0, $1u0KT.createPortal)(tree, document.body);
    return tree;
}



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Menu — an anchored menu.
//
// PROMOTED from the clinic app's `src/components/common/ClinicMenu.jsx`, which
// had marked itself a promotion candidate: the kit had no menu primitive at any
// version — not a Menu, not a Popover, not a DropdownMenu — so per DESIGN.md
// rule 4 it lived in the app until a second app needed one. `AccountCard` is
// that second need, in all four panels at once.
//
// Not built from `Dialog`: a Dialog is a centred modal and this is an anchored
// menu, so the kit's overlay would be the wrong shape AND the wrong semantics
// (`role="dialog"` where a screen reader needs `role="menu"`).
//
// Portaled to `document.body` so a clipping ancestor cannot cut it off — the
// staff sidebars are fixed-width flex columns with `overflow: hidden`, and an
// anchored child of one is sliced at 260px (or at 68px when collapsed).
//
// LAYERING — z 900. Above every piece of app chrome (the doctor app's mobile
// bottom nav at z-50, its visit-closure flow at z-60) and below every kit
// overlay: BottomSheet 1000, Dialog/ConfirmDialog 1100. That order is the one
// DESIGN.md insists on — a ConfirmDialog raised from inside a menu row (sign
// out, a destructive switch) must render ABOVE the menu, and the fix for that
// ordering is never to lower the dialog. ClinicMenu sat at 11, the Drawer
// level, which was enough for the one trigger it had; 900 is what a menu opened
// from anywhere needs.
//
// Props:
//   open / onClose        — controlled
//   anchorRef             — ref to the trigger; the menu is measured against it
//   placement             — 'bottom' (default) | 'top' | 'auto'. 'auto' opens
//                           downward and flips up when the space below is too
//                           small. A menu at the FOOT of a sidebar wants 'top'.
//   width                 — px (default 300)
//   ariaLabel             — required in practice: the trigger's visible text is
//                           often a person's or a clinic's name, not the menu's
//   children              — the rows; give them role="menuitem"/"menuitemradio"
//   data-testid
// ─────────────────────────────────────────────────────────────────────────────
const $08d1958bc1315b40$var$Z = 900;
const $08d1958bc1315b40$var$GAP = 6; // breathing room between trigger and menu
const $08d1958bc1315b40$var$EDGE = 8; // never touch the viewport edge
const $08d1958bc1315b40$var$MIN_BELOW = 180; // 'auto' flips up below this much room
// Every focusable row, in DOM order. Radio rows come from ClinicSwitcher, plain
// menuitems from AccountCard; `[data-menu-focus]` lets a caller nominate
// something else entirely (ClinicSwitcher's search box).
const $08d1958bc1315b40$var$ROW_SELECTOR = '[data-menu-focus="true"], [role="menuitem"]:not([aria-disabled="true"]), [role="menuitemradio"]:not([aria-disabled="true"])';
function $08d1958bc1315b40$export$d9b273488cd8ce6f({ open: open, onClose: onClose, anchorRef: anchorRef, children: children, ariaLabel: ariaLabel, width: width = 300, placement: placement = 'bottom', 'data-testid': testId = 'menu' }) {
    const menuRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [pos, setPos] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Position against the trigger. Measured on open and on every resize/scroll,
    // rather than once: the sidebar collapses under a CSS transition, so a
    // position captured at open time is wrong 300ms later.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (!open) {
            setPos(null);
            return undefined;
        }
        const place = ()=>{
            const el = anchorRef?.current;
            if (!el) return;
            const r = el.getBoundingClientRect();
            const isRtl = typeof document !== 'undefined' && document.documentElement.dir === 'rtl';
            // Anchor to the INLINE-START edge in both directions, which is the visual
            // edge the trigger shares with its container in RTL and LTR alike.
            const left = isRtl ? Math.max($08d1958bc1315b40$var$EDGE, r.right - width) : Math.min(r.left, window.innerWidth - width - $08d1958bc1315b40$var$EDGE);
            const roomBelow = window.innerHeight - r.bottom - $08d1958bc1315b40$var$EDGE * 2;
            const roomAbove = r.top - $08d1958bc1315b40$var$EDGE * 2;
            const up = placement === 'top' || placement === 'auto' && roomBelow < $08d1958bc1315b40$var$MIN_BELOW && roomAbove > roomBelow;
            const room = up ? roomAbove : roomBelow;
            const maxHeight = Math.min(Math.max(160, room), Math.round(window.innerHeight * 0.6));
            setPos(up ? {
                bottom: Math.max($08d1958bc1315b40$var$EDGE, window.innerHeight - r.top + $08d1958bc1315b40$var$GAP),
                left: left,
                maxHeight: maxHeight
            } : {
                top: r.bottom + $08d1958bc1315b40$var$GAP,
                left: left,
                maxHeight: maxHeight
            });
        };
        place();
        window.addEventListener('resize', place);
        window.addEventListener('scroll', place, true);
        return ()=>{
            window.removeEventListener('resize', place);
            window.removeEventListener('scroll', place, true);
        };
    }, [
        open,
        anchorRef,
        width,
        placement
    ]);
    // Close on an outside press. `mousedown` rather than `click`, so a press that
    // starts outside and ends inside cannot re-open what it just closed.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onDown = (e)=>{
            if (menuRef.current?.contains(e.target)) return;
            if (anchorRef?.current?.contains(e.target)) return;
            onClose?.();
        };
        document.addEventListener('mousedown', onDown);
        return ()=>document.removeEventListener('mousedown', onDown);
    }, [
        open,
        onClose,
        anchorRef
    ]);
    // Escape closes, arrows walk the rows, Home/End jump. A menu you can open by
    // keyboard but only leave by mouse is a trap.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') {
                e.stopPropagation();
                onClose?.();
                return;
            }
            if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Home' && e.key !== 'End') return;
            const rows = Array.from(menuRef.current?.querySelectorAll($08d1958bc1315b40$var$ROW_SELECTOR) || []);
            if (!rows.length) return;
            e.preventDefault();
            const at = rows.indexOf(document.activeElement);
            const next = e.key === 'Home' ? 0 : e.key === 'End' ? rows.length - 1 : e.key === 'ArrowDown' ? (at + 1) % rows.length : at <= 0 ? rows.length - 1 : at - 1;
            rows[next]?.focus?.();
        };
        document.addEventListener('keydown', onKey);
        return ()=>document.removeEventListener('keydown', onKey);
    }, [
        open,
        onClose
    ]);
    // Focus lands inside on open and returns to the trigger on close — a menu that
    // opens without focus is unreachable by keyboard, and one that drops focus on
    // close strands the caret at the top of the document.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const t = window.setTimeout(()=>{
            menuRef.current?.querySelector($08d1958bc1315b40$var$ROW_SELECTOR)?.focus?.();
        }, 0);
        const anchor = anchorRef?.current;
        return ()=>{
            window.clearTimeout(t);
            if (anchor && document.contains(anchor)) anchor.focus?.();
        };
    }, [
        open,
        anchorRef
    ]);
    if (!open || !pos) return null;
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: menuRef,
        role: "menu",
        "aria-label": ariaLabel,
        "data-testid": testId,
        style: {
            position: 'fixed',
            top: pos.top,
            bottom: pos.bottom,
            left: pos.left,
            width: width,
            maxHeight: pos.maxHeight,
            overflowY: 'auto',
            overflowX: 'hidden',
            background: 'white',
            borderRadius: 12,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            boxShadow: '0 18px 48px rgba(15, 34, 51, 0.18)',
            zIndex: $08d1958bc1315b40$var$Z,
            padding: 6,
            fontFamily: 'Meshkat, sans-serif'
        }
    }, children), document.body);
}
var $08d1958bc1315b40$export$2e2bcd8739ae039 = $08d1958bc1315b40$export$d9b273488cd8ce6f;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * useResponsive — is this viewport the MOBILE surface?
 *
 * ≤ 768px is mobile across the whole product (DESIGN-CONCEPT-MOBILE preamble:
 * "everything rendered when `useResponsive()` reports ≤ 768px"). The boundary
 * is inclusive: 768 is mobile, 769 is desktop.
 *
 * It lives in the kit because it is the switch every `X.mobile.jsx` fork is
 * chosen by, and a byte-identical copy already existed in the doctor and the
 * clinic client — the second app needing it is DESIGN.md rule 4's trigger to
 * move it here. It sits beside `useKeyboardInset` and `useMeasuredWidth`: all
 * three are facts about the device's geometry that a whole class of screens
 * depends on.
 *
 * Hardened over the app-local copies in two ways:
 *   • `matchMedia` rather than a `resize` listener, so a rotation or a
 *     window drag fires once at the boundary instead of on every frame;
 *   • an SSR / no-window guard, so importing it in a Next.js server component
 *     or a node-environment test does not throw. It reports DESKTOP there —
 *     the surface with the full content, which is the safe default for a
 *     first paint that has not measured anything yet.
 *
 * @param breakpoint the inclusive mobile ceiling in px (default 768)
 * @returns { isMobile }
 */ const $e959a5a9c1f6e19d$var$query = (breakpoint)=>`(max-width: ${breakpoint}px)`;
const $e959a5a9c1f6e19d$var$read = (breakpoint)=>{
    if (typeof window === 'undefined') return false;
    if (typeof window.matchMedia === 'function') return window.matchMedia($e959a5a9c1f6e19d$var$query(breakpoint)).matches;
    return window.innerWidth <= breakpoint;
};
function $e959a5a9c1f6e19d$export$2e2bcd8739ae039(breakpoint = 768) {
    const [isMobile, setIsMobile] = (0, $acw62.useState)(()=>$e959a5a9c1f6e19d$var$read(breakpoint));
    (0, $acw62.useEffect)(()=>{
        if (typeof window === 'undefined') return undefined;
        // The state initialiser ran before mount; re-read now in case the viewport
        // is not what it was (hydration, a rotation during boot).
        setIsMobile($e959a5a9c1f6e19d$var$read(breakpoint));
        if (typeof window.matchMedia !== 'function') {
            const onResize = ()=>setIsMobile(window.innerWidth <= breakpoint);
            window.addEventListener('resize', onResize);
            return ()=>window.removeEventListener('resize', onResize);
        }
        const mq = window.matchMedia($e959a5a9c1f6e19d$var$query(breakpoint));
        const onChange = (e)=>setIsMobile(e.matches);
        // `addListener` is the pre-2019 Safari spelling; still worth keeping while
        // the product supports older iOS webviews.
        if (mq.addEventListener) mq.addEventListener('change', onChange);
        else mq.addListener(onChange);
        return ()=>{
            if (mq.removeEventListener) mq.removeEventListener('change', onChange);
            else mq.removeListener(onChange);
        };
    }, [
        breakpoint
    ]);
    return {
        isMobile: isMobile
    };
}



'use client';
// The panel surface both shells paint on. A sticky header has to repaint it, or
// the body shows through as it scrolls under.
const $382b400f7624ec9d$var$OVERLAY_SURFACE = (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card;
function $382b400f7624ec9d$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, description: description, header: header, footer: footer, children: children, busy: busy = false, size: size = 'md', isMobile: isMobile, historyIntegration: historyIntegration = true, snap: snap = 1, fullHeight: fullHeight = true, closeLabel: closeLabel = "\u0628\u0633\u062A\u0646", className: className, 'data-testid': testId, ...rest }) {
    const auto = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    // ── Why this cannot be server-rendered blind ──────────────────────────────
    // WHICH SHELL this is depends on the viewport, and a server does not have
    // one. Rendering the desktop guess and then swapping to a sheet on the client
    // is a hydration mismatch — React discards the tree and re-renders it, and in
    // an app that streams the overlay open from a deep link (`?book=1`) that is a
    // visible flash of the wrong shape.
    //
    // So: when the caller TELLS us the tier we trust it and render on the server
    // like anything else. When it does not, we wait for the client, where the
    // question has an answer. One frame later than ideal, and never wrong.
    const told = isMobile !== undefined;
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(told);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setMounted(true);
    }, []);
    const mobile = told ? isMobile : auto.isMobile;
    // One guard for every way out, so "can this close right now?" has a single
    // answer rather than one per dismissal path. On the sheet tier a platform back
    // has already popped the sheet's history entry when this refuses; the sheet's
    // `useOverlayHistory` re-claims it one tick later (v0.16.1), so a busy overlay
    // keeps exactly one entry and the next back is delivered to it again.
    const close = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (busy) return;
        if (typeof onClose === 'function') onClose();
    }, [
        busy,
        onClose
    ]);
    if (!open || !mounted) return null;
    if (mobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: open,
        onClose: close,
        title: title,
        footer: footer,
        snap: snap,
        fullHeight: fullHeight,
        closeLabel: closeLabel,
        historyIntegration: historyIntegration,
        className: className,
        "data-testid": testId,
        "data-busy": busy || undefined,
        ...rest
    }, header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId ? `${testId}-header` : undefined,
        style: {
            position: 'sticky',
            top: 0,
            zIndex: 1,
            background: $382b400f7624ec9d$var$OVERLAY_SURFACE,
            padding: '0 1.25rem 0.75rem'
        }
    }, header) : null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
        open: open,
        onOpenChange: (next)=>{
            if (!next) close();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
        size: size,
        layout: "frame",
        showClose: !busy,
        className: className,
        "data-testid": testId,
        "data-busy": busy || undefined,
        // Radix would otherwise close on Esc or an outside click mid-write.
        onEscapeKeyDown: (e)=>{
            if (busy) e.preventDefault();
        },
        onInteractOutside: (e)=>{
            if (busy) e.preventDefault();
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$742513523b177e3b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
        dir: "auto"
    }, title), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$94e94c2ec2c954d5), {
        dir: "auto"
    }, description) : null, header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId ? `${testId}-header` : undefined,
        style: {
            marginTop: '0.75rem'
        }
    }, header) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$5d20f2c38fcde41f), null, children), footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$7bbfb2d443473050), null, footer) : null));
}



var $acw62 = parcelRequire("acw62");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Toast — the one notification system for every Parsina client.
//
// Replaces: native alert() calls (doctor app), the 5+ per-screen setToast/
// setTimeout implementations (clinic app), and inline-only feedback (patient app).
//
// Usage:
//   <ToastProvider>  ← once, at the app root
//   const toast = useToast();
//   toast.success('ذخیره شد');
//   toast.error('خطا در ارتباط با سرور');
//   toast.info('...'); toast.warn('...');
// ─────────────────────────────────────────────────────────────────────────────
const $352ffee698fbd002$var$PALETTE = {
    success: {
        bg: '#1A9B6C',
        text: '#ffffff'
    },
    error: {
        bg: '#D93025',
        text: '#ffffff'
    },
    warn: {
        bg: '#F59E0B',
        text: '#1a2332'
    },
    info: {
        bg: '#0173BE',
        text: '#ffffff'
    }
};
const $352ffee698fbd002$var$ToastContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
let $352ffee698fbd002$var$nextId = 1;
function $352ffee698fbd002$export$f5d03d415824e0e({ children: children, duration: duration = 3500 }) {
    const [toasts, setToasts] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const timers = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const dismiss = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>{
        setToasts((t)=>t.filter((x)=>x.id !== id));
        const timer = timers.current.get(id);
        if (timer) {
            clearTimeout(timer);
            timers.current.delete(id);
        }
    }, []);
    const push = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((message, type = 'info', opts = {})=>{
        const id = $352ffee698fbd002$var$nextId++;
        setToasts((t)=>[
                ...t.slice(-3),
                {
                    id: id,
                    message: message,
                    type: type
                }
            ]); // keep at most 4
        timers.current.set(id, setTimeout(()=>dismiss(id), opts.duration ?? duration));
        return id;
    }, [
        dismiss,
        duration
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            timers.current.forEach(clearTimeout);
        }, []);
    const api = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            show: push,
            success: (m, o)=>push(m, 'success', o),
            error: (m, o)=>push(m, 'error', o),
            warn: (m, o)=>push(m, 'warn', o),
            info: (m, o)=>push(m, 'info', o),
            dismiss: dismiss
        }), [
        push,
        dismiss
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($352ffee698fbd002$var$ToastContext.Provider, {
        value: api
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'fixed',
            bottom: 24,
            left: 0,
            right: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 8,
            zIndex: 9999,
            pointerEvents: 'none'
        }
    }, toasts.map((t)=>{
        const p = $352ffee698fbd002$var$PALETTE[t.type] || $352ffee698fbd002$var$PALETTE.info;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: t.id,
            onClick: ()=>dismiss(t.id),
            role: "status",
            style: {
                pointerEvents: 'auto',
                cursor: 'pointer',
                background: p.bg,
                color: p.text,
                padding: '10px 18px',
                borderRadius: 'var(--radius, 10px)',
                fontSize: 13,
                fontWeight: 600,
                fontFamily: 'Meshkat, sans-serif',
                boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
                maxWidth: 'min(92vw, 420px)',
                animation: 'parsina-toast-in 0.22s ease-out'
            }
        }, t.message);
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, `@keyframes parsina-toast-in{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}`)));
}
function $352ffee698fbd002$export$a407b657d3044108() {
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($352ffee698fbd002$var$ToastContext);
    if (!ctx) throw new Error('useToast must be used inside <ToastProvider>');
    return ctx;
}



var $acw62 = parcelRequire("acw62");

'use client';
function $31e8de2f297417a1$export$7f7cbe89f1eacd2({ size: size = 32, color: color = (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal, thickness: thickness = 2, style: style, label: label = "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC" }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        // The accessible name is a PROP (rule 7). It used to be a Persian string
        // literal with no way past it, so an English screen announced its loading
        // state in Persian and the app could do nothing about it.
        "aria-label": label,
        style: {
            width: size,
            height: size,
            borderRadius: '50%',
            border: `${thickness}px solid ${color}`,
            borderTopColor: 'transparent',
            animation: 'parsina-spin 0.8s linear infinite',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, `@keyframes parsina-spin{to{transform:rotate(360deg)}}`));
}
function $31e8de2f297417a1$export$e2b0760399e6dece({ label: label, minHeight: minHeight = '60vh' }) {
    return(// No `dir` of its own — it inherits the document's, like every other
    // component in the kit. It is a centred column either way.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minHeight: minHeight,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($31e8de2f297417a1$export$7f7cbe89f1eacd2, {
        label: label
    }), label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 13,
            color: '#9aa3b0',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, label) : null));
}
var $31e8de2f297417a1$export$2e2bcd8739ae039 = $31e8de2f297417a1$export$7f7cbe89f1eacd2;



var $acw62 = parcelRequire("acw62");

'use client';
// ─────────────────────────────────────────────────────────────────────────────
// SessionCheck / SessionError / SessionPage — what EVERY Parsina panel shows
// between opening the tab and knowing who is signed in.
//
// The Keycloak round trip, the token check and whatever read a panel needs
// before its first screen (onboarding status, memberships, appearance) all sit
// behind this one card. It was the doctor panel's (its App.jsx `AuthPage`),
// copied into the clinic panel in 2026-09 and drawn differently again in the
// dentist, student and admin panels — five front doors to one product. It is
// the kit's now, so a person who opens two panels in one morning meets one
// door, and a change to it is one release rather than five edits.
//
//   SessionPage   the canvas (145° navy gradient, two drifting discs) and the
//                 420px white card that rises in
//   SessionCheck  the loading state: brand hero, three bouncing dots, the
//                 progress track, and the manual sign-in link after 4s
//   SessionError  a boot that could not finish: logo, tone disc, message,
//                 one gradient action, and the SSO host it tried
//
// ── Continuing across a remount ─────────────────────────────────────────────
//
// A panel's boot often has two owners — the auth check, then a provider that
// reads what the panel needs — and each renders its own SessionCheck. Left
// alone the second mount would restart every animation: the card rising again,
// the track snapping back to 5%. So every animation is offset by the time since
// this MODULE loaded (≈ the page's start) with a negative `animation-delay`,
// and the manual link counts from the same moment. The second mount continues
// the first.
//
// Every word is a PROP (rule 7) and so is the logo: the kit ships no image, and
// a panel with its own mark (ParsinaDent) passes its own.
// ─────────────────────────────────────────────────────────────────────────────
const $3c4ca280922aa4ea$var$now = ()=>typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
const $3c4ca280922aa4ea$var$SESSION_T0 = $3c4ca280922aa4ea$var$now();
/** Milliseconds since the kit loaded — the one clock every session screen shares. */ const $3c4ca280922aa4ea$var$sinceBoot = ()=>$3c4ca280922aa4ea$var$now() - $3c4ca280922aa4ea$var$SESSION_T0;
const $3c4ca280922aa4ea$var$continued = (elapsedMs, ownDelayS = 0)=>({
        animationDelay: `${ownDelayS - elapsedMs / 1000}s`
    });
const $3c4ca280922aa4ea$export$6b89370abb8fc4ae = `linear-gradient(145deg, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyDark} 0%, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy} 55%, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyLight} 100%)`;
const $3c4ca280922aa4ea$export$e3b7f640fe979c0e = `linear-gradient(160deg, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyDark} 0%, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy} 60%, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyLight} 100%)`;
const $3c4ca280922aa4ea$var$SESSION_ACTION = `linear-gradient(135deg, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyDark}, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy})`;
// Reduced motion: the card simply appears, the dots rest, the track sits part
// filled. Those resting values are the base rules, so they hold wherever the
// animation does not.
const $3c4ca280922aa4ea$var$SESSION_CSS = `
  @keyframes parsina-session-rise { from { opacity: 0; transform: translateY(24px) } to { opacity: 1; transform: translateY(0) } }
  @keyframes parsina-session-dot { 0%, 65%, 100% { transform: translateY(0); opacity: 0.3 } 30% { transform: translateY(-9px); opacity: 1 } }
  @keyframes parsina-session-progress { 0% { width: 5% } 50% { width: 65% } 85% { width: 88% } 100% { width: 93% } }
  @keyframes parsina-session-float { 0%, 100% { transform: scale(1) } 50% { transform: scale(1.06) } }
  @keyframes parsina-session-appear { from { opacity: 0 } to { opacity: 1 } }
  [data-session-dot] { opacity: 0.6; }
  [data-session-progress] { width: 65%; }
  @media (prefers-reduced-motion: no-preference) {
    [data-session-card] { animation: parsina-session-rise 0.5s cubic-bezier(0.22, 1, 0.36, 1) both; }
    [data-session-dot] { animation: parsina-session-dot 1.5s ease-in-out infinite; }
    [data-session-progress] { animation: parsina-session-progress 3s ease-out both; }
    [data-session-float] { animation-name: parsina-session-float; animation-timing-function: ease-in-out; animation-iteration-count: infinite; }
    [data-session-appear] { animation: parsina-session-appear 0.4s ease both; }
  }
`;
function $3c4ca280922aa4ea$export$15364261a1aca489({ children: children, testId: testId }) {
    // Read once per mount: the offset must not move under a running animation.
    const [elapsed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($3c4ca280922aa4ea$var$sinceBoot);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100vw',
            height: '100vh',
            background: $3c4ca280922aa4ea$export$6b89370abb8fc4ae,
            fontFamily: 'Meshkat, sans-serif',
            position: 'relative',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, $3c4ca280922aa4ea$var$SESSION_CSS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        "data-session-float": "",
        style: {
            position: 'absolute',
            top: -120,
            insetInlineEnd: -80,
            width: 380,
            height: 380,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.04)',
            animationDuration: '9s',
            pointerEvents: 'none'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        "data-session-float": "",
        style: {
            position: 'absolute',
            bottom: -160,
            insetInlineStart: -100,
            width: 500,
            height: 500,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.03)',
            animationDuration: '12s',
            pointerEvents: 'none',
            ...$3c4ca280922aa4ea$var$continued(elapsed, 3)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("main", {
        "data-session-card": "",
        style: {
            background: 'white',
            borderRadius: 16,
            width: 420,
            maxWidth: 'calc(100vw - 48px)',
            boxShadow: '0 32px 80px rgba(0,0,0,0.3), 0 8px 32px rgba(0,0,0,0.18)',
            textAlign: 'center',
            overflow: 'hidden',
            ...$3c4ca280922aa4ea$var$continued(elapsed)
        }
    }, children));
}
function $3c4ca280922aa4ea$export$cd72095868f03c30({ logo: logo, brandName: brandName, panelName: panelName, title: title, subtitle: subtitle, stuckLabel: stuckLabel, manualLabel: manualLabel, onManualSignIn: onManualSignIn, manualAfterMs: manualAfterMs = 4000, testId: testId = 'session-check' }) {
    const [elapsed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($3c4ca280922aa4ea$var$sinceBoot);
    const [showManual, setShowManual] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>elapsed >= manualAfterMs);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (showManual || !onManualSignIn) return undefined;
        const timer = setTimeout(()=>setShowManual(true), Math.max(0, manualAfterMs - $3c4ca280922aa4ea$var$sinceBoot()));
        return ()=>clearTimeout(timer);
    }, [
        showManual,
        onManualSignIn,
        manualAfterMs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c4ca280922aa4ea$export$15364261a1aca489, {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: $3c4ca280922aa4ea$export$e3b7f640fe979c0e,
            padding: '36px 44px 32px',
            position: 'relative',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            position: 'absolute',
            top: -24,
            insetInlineEnd: -24,
            width: 100,
            height: 100,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.05)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            position: 'absolute',
            bottom: -30,
            insetInlineStart: -20,
            width: 120,
            height: 120,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.04)'
        }
    }), logo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 14,
            position: 'relative'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 72,
            height: 72,
            borderRadius: 18,
            background: 'rgba(255,255,255,0.12)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: logo,
        alt: brandName || '',
        style: {
            width: 52,
            height: 52,
            objectFit: 'contain'
        }
    }))) : null, brandName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 26,
            fontWeight: 800,
            color: 'white',
            marginBottom: 4,
            letterSpacing: -0.5
        }
    }, brandName) : null, panelName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: 'rgba(255,255,255,0.55)'
        }
    }, panelName) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '32px 44px 40px'
        },
        role: "status",
        "aria-live": "polite",
        "aria-busy": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            display: 'flex',
            justifyContent: 'center',
            gap: 10,
            marginBottom: 18
        }
    }, [
        0,
        0.18,
        0.36
    ].map((delay)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: delay,
            "data-session-dot": "",
            style: {
                width: 10,
                height: 10,
                borderRadius: '50%',
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
                ...$3c4ca280922aa4ea$var$continued(elapsed, delay)
            }
        }))), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 15,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            marginBottom: 6,
            fontWeight: 500
        }
    }, title) : null, subtitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginBottom: 28
        }
    }, subtitle) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            width: '100%',
            height: 4,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
            borderRadius: 4,
            overflow: 'hidden',
            marginBottom: 28
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-session-progress": "",
        style: {
            height: '100%',
            background: `linear-gradient(90deg, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyDark}, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyLight})`,
            borderRadius: 4,
            ...$3c4ca280922aa4ea$var$continued(elapsed)
        }
    })), showManual && onManualSignIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-session-appear": "",
        style: {
            marginTop: 18,
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, stuckLabel, stuckLabel ? ' ' : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onManualSignIn,
        "data-testid": `${testId}-manual`,
        style: {
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            font: 'inherit',
            fontSize: 13,
            fontWeight: 600,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            textDecoration: 'underline',
            textUnderlineOffset: 3
        }
    }, manualLabel)) : null));
}
// Filled glyphs (Material `error`, `cloud_off`) — the doctor card's family.
const $3c4ca280922aa4ea$var$ErrorGlyph = ({ color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: "30",
        height: "30",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
    }));
const $3c4ca280922aa4ea$var$OfflineGlyph = ({ color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: "30",
        height: "30",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z"
    }));
const $3c4ca280922aa4ea$var$TONES = {
    /** The sign-in service failed, or the redirect looped. */ danger: {
        bg: '#FEF2F2',
        ring: '#FECACA',
        ink: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
        Glyph: $3c4ca280922aa4ea$var$ErrorGlyph
    },
    /** Signed in, but the panel's backend did not answer. */ warning: {
        bg: '#FFFBEB',
        ring: '#FDE68A',
        ink: '#B45309',
        Glyph: $3c4ca280922aa4ea$var$OfflineGlyph
    }
};
function $3c4ca280922aa4ea$export$d422f67d76bf24e4({ tone: tone = 'danger', logo: logo, brandName: brandName, title: title, body: body, detail: detail, actionLabel: actionLabel, onAction: onAction, secondary: secondary, host: host, testId: testId = 'session-error', stateTestId: stateTestId }) {
    const look = $3c4ca280922aa4ea$var$TONES[tone] || $3c4ca280922aa4ea$var$TONES.danger;
    const { Glyph: Glyph } = look;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c4ca280922aa4ea$export$15364261a1aca489, {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '40px 44px 44px'
        },
        role: "alert",
        "data-testid": stateTestId
    }, logo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: logo,
        alt: brandName || '',
        style: {
            width: 52,
            height: 52,
            objectFit: 'contain',
            marginBottom: 20,
            opacity: 0.55
        }
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 60,
            height: 60,
            borderRadius: '50%',
            background: look.bg,
            border: `2px solid ${look.ring}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Glyph, {
        color: look.ink
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            margin: '0 0 10px',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            fontSize: 18,
            fontWeight: 800,
            letterSpacing: -0.3
        }
    }, title), body ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            fontSize: 14,
            marginBottom: detail ? 12 : 32,
            lineHeight: 1.8
        }
    }, body) : null, detail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            fontSize: 12,
            marginBottom: 32,
            lineHeight: 1.7,
            wordBreak: 'break-word'
        }
    }, detail) : null, onAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onAction,
        style: {
            width: '100%',
            height: 50,
            background: $3c4ca280922aa4ea$var$SESSION_ACTION,
            color: 'white',
            border: 'none',
            borderRadius: 12,
            fontSize: 15,
            fontWeight: 700,
            fontFamily: 'inherit',
            cursor: 'pointer',
            boxShadow: `0 4px 16px ${(0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.3)}`,
            marginBottom: secondary ? 10 : 20
        }
    }, actionLabel) : null, secondary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: secondary.onClick,
        style: {
            width: '100%',
            height: 44,
            background: 'white',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            border: `1.5px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 12,
            fontSize: 14,
            fontWeight: 600,
            fontFamily: 'inherit',
            cursor: 'pointer',
            marginBottom: 20
        }
    }, secondary.label) : null, host ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6,
            padding: '10px 14px',
            background: '#f8fafc',
            borderRadius: 10,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
        width: "13",
        height: "13",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "ltr",
        style: {
            fontSize: 11,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            fontFamily: 'monospace',
            letterSpacing: 0.2
        }
    }, host)) : null));
}
var $3c4ca280922aa4ea$export$2e2bcd8739ae039 = $3c4ca280922aa4ea$export$cd72095868f03c30;



var $acw62 = parcelRequire("acw62");

'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Skeleton family — the loading state of every Parsina screen.
//
// A screen that is fetching draws ITS OWN SHAPE in placeholder blocks: the
// header, tabs, filters, table or cards it is about to show, at the sizes they
// will have. Not a centred spinner, not «در حال بارگذاری…», not a blank page —
// see DESIGN.md §"Loading & skeleton". The primitives here are the vocabulary;
// each screen composes its own skeleton from them (`PatientDetailSkeleton`,
// `ReceptionSkeleton`, …) so the skeleton matches THAT screen, desktop and
// mobile alike, and nothing jumps when the data lands.
//
// Sizes mirror the real components on purpose: `SkeletonInput` is 44px like a
// `TextInput`, `SkeletonButton` 44px like a `Button`, `SkeletonTable` rows are
// 52px (44 dense) like `Table`, `SkeletonCard` has the `Card` surface. If a real
// component's geometry changes, change its skeleton in the same commit.
//
// Every block is `aria-hidden`; a composite root carries `role="status"`,
// `aria-busy` and an accessible `label` (a prop, rule 7) so assistive tech hears
// ONE "loading" instead of forty empty boxes. Motion respects
// `prefers-reduced-motion`: the sheen stops, the blocks stay.
// ─────────────────────────────────────────────────────────────────────────────
const $c90190398471f24a$var$SHIMMER_CSS = `
  @keyframes parsina-shimmer {
    0%   { background-position: 200% 0 }
    100% { background-position: -200% 0 }
  }
  [data-skeleton] {
    background: linear-gradient(90deg, ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).base} 25%, ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).sheen} 50%, ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).base} 75%);
    background-size: 200% 100%;
    animation: parsina-shimmer 1.4s ease-in-out infinite;
  }
  [data-skeleton][data-tone="onDark"] {
    background: linear-gradient(90deg, ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).onDark} 25%, ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).onDarkSheen} 50%, ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).onDark} 75%);
    background-size: 200% 100%;
  }
  @media (prefers-reduced-motion: reduce) {
    [data-skeleton] { animation: none; background: ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).base}; }
    [data-skeleton][data-tone="onDark"] { background: ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).onDark}; }
  }
`;
// One stylesheet for the whole family. React 19 hoists a <style> with `href` +
// `precedence` into <head> once, however many skeletons are on screen.
const $c90190398471f24a$var$Styles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", {
        href: "parsina-skeleton",
        precedence: "default"
    }, $c90190398471f24a$var$SHIMMER_CSS);
function $c90190398471f24a$export$8f31e4c4a37b8e9c({ width: width = '100%', height: height = 14, radius: radius = (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip, circle: circle = false, tone: tone, style: style, className: className, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Styles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        "data-skeleton": "",
        // `tone="onDark"` — white-alpha blocks for a gradient header, a sidebar
        // or a dark image canvas, where the neutral grey would read as a hole.
        "data-tone": tone === 'onDark' ? 'onDark' : undefined,
        className: className,
        style: {
            width: width,
            height: circle ? width : height,
            borderRadius: circle ? '50%' : radius,
            flexShrink: 0,
            ...style
        },
        ...rest
    }));
}
// Whether we are already inside an announced skeleton region. A page skeleton
// composed of a SkeletonStats, a SkeletonTable and two SkeletonCards used to
// announce "loading" four times; only the OUTERMOST region speaks now, the
// nested ones are plain hidden boxes.
const $c90190398471f24a$var$Nested = /*#__PURE__*/ (0, $acw62.createContext)(false);
const $c90190398471f24a$var$DEFAULT_LABEL = "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC";
function $c90190398471f24a$export$8b3e24dbbac64362({ as: Tag = 'div', label: label, style: style, children: children, ...rest }) {
    const nested = (0, $acw62.useContext)($c90190398471f24a$var$Nested);
    if (nested) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        "aria-hidden": true,
        "data-state": "loading",
        style: style,
        ...rest
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Nested.Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        role: "status",
        "aria-busy": "true",
        "aria-label": label ?? $c90190398471f24a$var$DEFAULT_LABEL,
        "data-state": "loading",
        style: style,
        ...rest
    }, children));
}
const $c90190398471f24a$var$Root = $c90190398471f24a$export$8b3e24dbbac64362;
// Line widths for a paragraph — the last line is shorter, like real text.
const $c90190398471f24a$var$LINE_WIDTHS = [
    '100%',
    '92%',
    '96%',
    '85%',
    '70%'
];
function $c90190398471f24a$export$cb6ddd830302c2a8({ width: width = '60%', height: height = 14, lines: lines = 1, lastWidth: lastWidth = '60%', gap: gap = 8, style: style, ...rest }) {
    if (lines <= 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: width,
        height: height,
        style: style,
        ...rest
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: gap,
            width: '100%',
            ...style
        },
        ...rest
    }, Array.from({
        length: lines
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            height: height,
            width: i === lines - 1 ? lastWidth : $c90190398471f24a$var$LINE_WIDTHS[i % $c90190398471f24a$var$LINE_WIDTHS.length]
        })));
}
function $c90190398471f24a$export$53c2c5a35a7e31a2({ size: size = 40, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: size,
        circle: true,
        style: style,
        ...rest
    });
}
function $c90190398471f24a$export$7387c3f2666b9f16({ width: width = 112, size: size = 'default', style: style, ...rest }) {
    const height = size === 'sm' ? 36 : size === 'icon' ? 40 : 44;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: size === 'icon' ? height : width,
        height: height,
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
        style: style,
        ...rest
    });
}
function $c90190398471f24a$export$5ce4f4d8e50e2948({ label: label = true, labelWidth: labelWidth = 88, multiline: multiline = false, width: width = '100%', style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            width: width,
            ...style
        },
        ...rest
    }, label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: labelWidth,
        height: 12
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "100%",
        height: multiline ? 96 : 44,
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control
    }));
}
function $c90190398471f24a$export$5956eb8f2ff4afde({ avatar: avatar = true, lines: lines = 0, chips: chips = 2, actions: actions = 2, padding: padding = 20, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            padding: padding,
            display: 'flex',
            flexDirection: 'column',
            gap: 14,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12
        }
    }, avatar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$53c2c5a35a7e31a2, {
        size: 48
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "60%",
        height: 14
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "40%",
        height: 11
    }))), lines > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$cb6ddd830302c2a8, {
        lines: lines,
        height: 12
    }) : null, chips > 0 || actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 1,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border
        }
    }) : null, chips > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 6
        }
    }, Array.from({
        length: chips
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            width: 60 + i % 2 * 12,
            height: 22,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill
        }))) : null, actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8
        }
    }, Array.from({
        length: actions
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            height: 36,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
            style: {
                flex: 1
            }
        }))) : null);
}
const $c90190398471f24a$var$ROW_WIDTHS = [
    48,
    120,
    100,
    70,
    80,
    70,
    100
];
function $c90190398471f24a$export$8bbcb87f63697989({ cols: cols = 7, widths: widths = $c90190398471f24a$var$ROW_WIDTHS, dense: dense = false, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
        "aria-hidden": true,
        style: {
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            height: dense ? 44 : 52
        },
        ...rest
    }, Array.from({
        length: cols
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            key: i,
            style: {
                padding: '0 16px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: widths[i % widths.length] || 80,
            height: i === 0 ? 18 : 13
        }))));
}
function $c90190398471f24a$export$6a15d3f7c248c5bb({ rows: rows = 6, columns: columns = 5, dense: dense = false, header: header = true, style: style, label: label, ...rest }) {
    const cols = Array.isArray(columns) ? columns : Array.from({
        length: columns
    }, (_, i)=>$c90190398471f24a$var$ROW_WIDTHS[(i + 1) % $c90190398471f24a$var$ROW_WIDTHS.length]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
            overflow: 'hidden',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        style: {
            width: '100%',
            borderCollapse: 'collapse',
            tableLayout: 'fixed'
        }
    }, header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
        style: {
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
            height: 40
        }
    }, cols.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
            key: i,
            style: {
                padding: '0 16px',
                textAlign: 'start'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: Math.min(typeof w === 'number' ? w * 0.7 : 72, 96),
            height: 11
        }))))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, Array.from({
        length: rows
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8bbcb87f63697989, {
            key: i,
            cols: cols.length,
            widths: cols,
            dense: dense
        })))));
}
function $c90190398471f24a$export$9e2e66b17fdb9730({ count: count = 5, avatar: avatar = true, trailing: trailing = 56, divided: divided = true, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'flex',
            flexDirection: 'column',
            ...style
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                minHeight: avatar ? 64 : 52,
                padding: '0 4px',
                borderTop: divided && i > 0 ? `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}` : 'none'
            }
        }, avatar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$53c2c5a35a7e31a2, {
            size: 40
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: `${55 + i * 17 % 30}%`,
            height: 14
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: `${30 + i * 11 % 25}%`,
            height: 11
        })), trailing > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: trailing,
            height: 22,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill
        }) : null)));
}
function $c90190398471f24a$export$452537ec11d5437e({ count: count = 4, widths: widths, gap: gap = 4, padding: padding = '12px 14px', style: style, ...rest }) {
    const ws = widths || Array.from({
        length: count
    }, (_, i)=>[
            72,
            60,
            96,
            84,
            68
        ][i % 5]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            gap: gap,
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            overflowX: 'hidden',
            ...style
        },
        ...rest
    }, ws.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                padding: padding
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: w,
            height: 13
        }))));
}
const $c90190398471f24a$var$BAR_HEIGHTS = [
    0.55,
    0.8,
    0.4,
    0.95,
    0.65,
    0.75,
    0.5,
    0.85,
    0.6,
    0.7,
    0.45,
    0.9
];
function $c90190398471f24a$export$9e5a4339fadac171({ height: height = 200, bars: bars = 8, line: line = false, legend: legend = 2, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            ...style
        }
    }, legend > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 14
        }
    }, Array.from({
        length: legend
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: 10,
            circle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: 56,
            height: 11
        })))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: height,
            display: 'flex',
            alignItems: 'flex-end',
            gap: 8,
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            padding: '0 8px'
        }
    }, line ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "100%",
        height: Math.round(height * 0.35),
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
        style: {
            marginBottom: Math.round(height * 0.25)
        }
    }) : Array.from({
        length: bars
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            height: Math.round(height * $c90190398471f24a$var$BAR_HEIGHTS[i % $c90190398471f24a$var$BAR_HEIGHTS.length]),
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip,
            style: {
                flex: 1,
                width: 'auto'
            }
        }))));
}
function $c90190398471f24a$export$68fb050a45c52f04({ fields: fields = 4, columns: columns = 1, actions: actions = 1, multiline: multiline = [], gap: gap = 16, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: gap,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
            gap: gap
        }
    }, Array.from({
        length: fields
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$5ce4f4d8e50e2948, {
            key: i,
            multiline: multiline.includes(i),
            style: multiline.includes(i) && columns > 1 ? {
                gridColumn: '1 / -1'
            } : undefined
        }))), actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8,
            justifyContent: 'flex-end'
        }
    }, Array.from({
        length: actions
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$7387c3f2666b9f16, {
            key: i,
            width: i === 0 ? 120 : 96
        }))) : null);
}
function $c90190398471f24a$export$171a4533b2ae49b5({ subtitle: subtitle = true, actions: actions = 1, back: back = false, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            minHeight: 44,
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            minWidth: 0
        }
    }, back ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 36,
        height: 36,
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 160,
        height: 20
    }), subtitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 110,
        height: 12
    }) : null)), actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8
        }
    }, Array.from({
        length: actions
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$7387c3f2666b9f16, {
            key: i,
            width: i === 0 ? 112 : 44
        }))) : null);
}
function $c90190398471f24a$export$f70e1ea07462d9df({ search: search = true, chips: chips = 3, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap',
            ...style
        },
        ...rest
    }, search ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 240,
        height: 44,
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
        style: {
            maxWidth: '100%'
        }
    }) : null, Array.from({
        length: chips
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            width: [
                84,
                72,
                96,
                64
            ][i % 4],
            height: 36,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill
        })));
}
function $c90190398471f24a$export$3122f708803a735a({ count: count = 4, icon: icon = true, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'grid',
            gridTemplateColumns: `repeat(${count}, minmax(0, 1fr))`,
            gap: 12,
            ...style
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                borderRadius: 12,
                padding: '16px 20px',
                display: 'flex',
                alignItems: 'center',
                gap: 14,
                border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
            }
        }, icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: 44,
            height: 44,
            radius: 12
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
                flex: 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: "55%",
            height: 22
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: "70%",
            height: 11
        })))));
}
var $c90190398471f24a$export$2e2bcd8739ae039 = $c90190398471f24a$export$8f31e4c4a37b8e9c;



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $ebab042c7bf4d462$export$73bda83cddbc7187 = (string)=>string?.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();


function $9849370148eea58e$export$cffcae2df5126ae4(iconName, iconNode, aliases = []) {
    if (iconNode == null) throw new Error("[lucide]: iconNode is required when icon name is used");
    return {
        name: (0, $ebab042c7bf4d462$export$73bda83cddbc7187)(iconName),
        size: 24,
        node: iconNode,
        ...aliases.length > 0 ? {
            aliases: aliases
        } : {}
    };
}


/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $679cfb4006de9dc2$export$86f54f62aa7a7514 = (string)=>{
    let out = "";
    let upperNext = false;
    for (const ch of string){
        if (ch === "-" || ch === "_" || ch <= " ") {
            upperNext = out.length > 0;
            continue;
        }
        if (out.length === 0) out += ch.toLowerCase();
        else out += upperNext ? ch.toUpperCase() : ch;
        upperNext = false;
    }
    return out;
};


const $05938c6aab1a7024$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = (0, $679cfb4006de9dc2$export$86f54f62aa7a7514)(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $5921600fb4e81be8$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();


/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $c6be556545857de8$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": 2,
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
};



function $4ca0126f0d25626c$var$isDefined(value) {
    return value !== null && value !== void 0;
}
function $4ca0126f0d25626c$export$2e2bcd8739ae039(icon, params = {}) {
    const attributeNames = params.attributeNames ?? {};
    const getAttributeName = (attributeName)=>attributeNames[attributeName] ?? attributeName;
    const viewBoxWidth = icon.size ?? icon.width ?? (0, $c6be556545857de8$export$2e2bcd8739ae039)["width"];
    const viewBoxHeight = icon.size ?? icon.height ?? (0, $c6be556545857de8$export$2e2bcd8739ae039)["height"];
    const aliasClassNames = icon.aliases?.filter((alias)=>typeof alias === "string" && alias.trim() !== "").map((alias)=>`lucide-${alias}`) ?? [];
    const iconClassNames = [
        ...icon.name ? [
            `lucide-${icon.name}`
        ] : [],
        ...aliasClassNames
    ];
    const classNamesFromClassName = params.className?.split(" ").filter(Boolean) ?? [];
    const className = params.includeDefaultClasses === false ? (0, $5921600fb4e81be8$export$3d46f4579dba46e5)(...classNamesFromClassName) : (0, $5921600fb4e81be8$export$3d46f4579dba46e5)("lucide", ...iconClassNames, ...classNamesFromClassName);
    const calculatedStrokeWidth = params.absoluteStrokeWidth ? Number(params.strokeWidth ?? (0, $c6be556545857de8$export$2e2bcd8739ae039)["stroke-width"]) * Number(icon.size ?? icon.width ?? (0, $c6be556545857de8$export$2e2bcd8739ae039)["width"]) / Number(params.size ?? params.width ?? (0, $c6be556545857de8$export$2e2bcd8739ae039)["width"]) : params.strokeWidth ?? (0, $c6be556545857de8$export$2e2bcd8739ae039)["stroke-width"];
    const attributes = {
        ...Object.entries((0, $c6be556545857de8$export$2e2bcd8739ae039)).reduce((attrs, [attrName, value])=>{
            attrs[getAttributeName(attrName)] = value;
            return attrs;
        }, {}),
        ..."color" in params && params.color && {
            [getAttributeName("stroke")]: params.color
        },
        ..."size" in params && $4ca0126f0d25626c$var$isDefined(params.size) && {
            [getAttributeName("width")]: params.size,
            [getAttributeName("height")]: params.size
        },
        ..."width" in params && $4ca0126f0d25626c$var$isDefined(params.width) && {
            [getAttributeName("width")]: params.width
        },
        ..."height" in params && $4ca0126f0d25626c$var$isDefined(params.height) && {
            [getAttributeName("height")]: params.height
        },
        [getAttributeName("stroke-width")]: calculatedStrokeWidth,
        ...className && {
            [getAttributeName("class")]: className
        },
        [getAttributeName("viewBox")]: `0 0 ${viewBoxWidth} ${viewBoxHeight}`,
        ...params.hasA11yProp === false ? {
            [getAttributeName("aria-hidden")]: "true"
        } : {},
        ..."attributes" in params && params.attributes
    };
    return [
        "svg",
        attributes,
        icon.node.map((child)=>{
            const [name, attrs, children] = child;
            const nextAttrs = params.nonScalingStroke ? {
                [getAttributeName("vector-effect")]: "non-scaling-stroke",
                ...attrs
            } : attrs;
            return children ? [
                name,
                nextAttrs,
                children
            ] : [
                name,
                nextAttrs
            ];
        })
    ];
}


function $f9986151c9447952$export$2e2bcd8739ae039(icon, params = {}) {
    return (0, $4ca0126f0d25626c$export$2e2bcd8739ae039)(icon, {
        ...params,
        attributeNames: {
            ...params.attributeNames,
            class: "className",
            "stroke-width": "strokeWidth",
            "stroke-linecap": "strokeLinecap",
            "stroke-linejoin": "strokeLinejoin",
            "vector-effect": "vectorEffect"
        }
    });
}


/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $08ed9cd30f364255$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
    return false;
};



var $acw62 = parcelRequire("acw62");
"use strict";
"use client";
const $fdd26cba762f63b6$var$LucideContext = (0, $acw62.createContext)({});
function $fdd26cba762f63b6$export$f4a5ae9d8b2d8a16({ children: children, size: size, color: color, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, nonScalingStroke: nonScalingStroke, className: className }) {
    const value = (0, $acw62.useMemo)(()=>({
            size: size,
            color: color,
            strokeWidth: strokeWidth,
            absoluteStrokeWidth: absoluteStrokeWidth,
            nonScalingStroke: nonScalingStroke,
            className: className
        }), [
        size,
        color,
        strokeWidth,
        absoluteStrokeWidth,
        nonScalingStroke,
        className
    ]);
    return (0, $acw62.createElement)($fdd26cba762f63b6$var$LucideContext.Provider, {
        value: value
    }, children);
}
const $fdd26cba762f63b6$export$52ee7576b6cde767 = ()=>(0, $acw62.useContext)($fdd26cba762f63b6$var$LucideContext);


"use strict";
"use client";
const $8c69f6577678916e$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)(({ color: color, size: size, width: width, height: height, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, nonScalingStroke: nonScalingStroke, className: className = "", children: children, iconNode: iconNode = [], icon: icon = {
    node: iconNode,
    aliases: [],
    size: 24
}, ...rest }, ref)=>{
    const { size: contextSize = 24, strokeWidth: contextStrokeWidth = 2, absoluteStrokeWidth: contextAbsoluteStrokeWidth = false, nonScalingStroke: contextNonScalingStroke = false, color: contextColor = "currentColor", className: contextClass = "" } = (0, $fdd26cba762f63b6$export$52ee7576b6cde767)() ?? {};
    const hasAccessibleProp = Boolean(children) || (0, $08ed9cd30f364255$export$ab365959aa6deed0)(rest);
    const [name, svgAttributes, builtIconNode = []] = (0, $f9986151c9447952$export$2e2bcd8739ae039)(icon, {
        color: color ?? contextColor,
        width: width ?? size ?? contextSize,
        height: height ?? size ?? contextSize,
        strokeWidth: strokeWidth ?? contextStrokeWidth,
        absoluteStrokeWidth: absoluteStrokeWidth ?? contextAbsoluteStrokeWidth,
        nonScalingStroke: nonScalingStroke ?? contextNonScalingStroke,
        className: (0, $5921600fb4e81be8$export$3d46f4579dba46e5)(contextClass, className),
        hasA11yProp: hasAccessibleProp,
        attributes: rest
    });
    return (0, $acw62.createElement)(name, {
        ref: ref,
        ...svgAttributes
    }, [
        ...builtIconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});


function $cb908d1b06653674$export$2e2bcd8739ae039(iconDataOrName, iconNode = [], aliases = []) {
    const iconData = typeof iconDataOrName === "string" ? (0, $9849370148eea58e$export$cffcae2df5126ae4)(iconDataOrName, iconNode, aliases) : iconDataOrName;
    const Component = (0, $acw62.forwardRef)(({ className: className, ...props }, ref)=>(0, $acw62.createElement)((0, $8c69f6577678916e$export$2e2bcd8739ae039), {
            ref: ref,
            icon: iconData,
            className: className,
            ...props
        }));
    if (iconData.name) Component.displayName = (0, $05938c6aab1a7024$export$6fb43ff9addf7357)(iconData.name);
    return Component;
}


const $5c08c9e83bb1a976$export$a2387ed3b5d536eb = {
    name: "inbox",
    size: 24,
    node: [
        [
            "polyline",
            {
                points: "22 12 16 12 14 15 10 15 8 12 2 12",
                key: "o97t9d"
            }
        ],
        [
            "path",
            {
                d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
                key: "oot6mr"
            }
        ]
    ]
};
$5c08c9e83bb1a976$export$a2387ed3b5d536eb.node;
const $5c08c9e83bb1a976$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($5c08c9e83bb1a976$export$a2387ed3b5d536eb);



'use client';
function $838915ee2bfb8ab1$export$2e2bcd8739ae039({ icon: icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5c08c9e83bb1a976$export$2e2bcd8739ae039), {
    size: 44,
    strokeWidth: 1.5,
    "aria-hidden": true
}), title: title, description: description, action: action, fill: fill = false, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            textAlign: 'center',
            padding: '60px 20px',
            animation: 'fadeUp .3s ease',
            ...fill && {
                flex: 1,
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            },
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 56,
            marginBottom: 16,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }
    }, icon), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 18,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            marginBottom: 8
        }
    }, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, description), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 16
        }
    }, action));
}



var $acw62 = parcelRequire("acw62");
'use client';
// Inlined so the component carries no bundler-specific asset import (Parcel's
// `url:` scheme does not exist in Next.js) — same default-avatar silhouette.
const $a53b6ea678d7efe0$var$defaultAvatarSrc = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><rect width="40" height="40" fill="#e2e8f0"/><circle cx="20" cy="15" r="7" fill="#94a3b8"/><path d="M6 38c1.8-8 7.5-12 14-12s12.2 4 14 12z" fill="#94a3b8"/></svg>');
const $a53b6ea678d7efe0$var$AVATAR_COLORS = [
    '#1d4ed8',
    '#0891b2',
    '#0d9488',
    '#7c3aed',
    '#db2777',
    '#ea580c',
    '#16a34a'
];
function $a53b6ea678d7efe0$export$75ef3c97b2be2f20(name) {
    const s = name || '';
    let h = 0;
    for(let i = 0; i < s.length; i++)h = s.charCodeAt(i) + ((h << 5) - h);
    return $a53b6ea678d7efe0$var$AVATAR_COLORS[Math.abs(h) % $a53b6ea678d7efe0$var$AVATAR_COLORS.length];
}
const $a53b6ea678d7efe0$var$Avatar = ({ name: name, size: size = 40, bg: bg, color: color = 'white', src: src })=>{
    const resolvedBg = bg ?? $a53b6ea678d7efe0$export$75ef3c97b2be2f20(name);
    const [status, setStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(src ? 'loading' : 'idle');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setStatus(src ? 'loading' : 'idle');
    }, [
        src
    ]);
    const initials = (name || '').split(' ').filter(Boolean).map((w)=>w[0]).join('').slice(0, 2) || '?';
    const isSkeleton = status === 'loading';
    const isError = status === 'error';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: size,
            height: size,
            borderRadius: '50%',
            background: isSkeleton ? '#e2e8f0' : src && !isError ? 'transparent' : resolvedBg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: size * 0.35,
            fontWeight: '700',
            color: color,
            flexShrink: 0,
            overflow: 'hidden',
            position: 'relative',
            animation: isSkeleton ? 'avatar-pulse 1.4s ease-in-out infinite' : 'none'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, `@keyframes avatar-pulse{0%,100%{opacity:1}50%{opacity:.4}}`), src && !isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: src,
        alt: name,
        onLoad: ()=>setStatus('loaded'),
        onError: ()=>setStatus('error'),
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            opacity: isSkeleton ? 0 : 1,
            transition: 'opacity 0.25s',
            position: 'absolute',
            inset: 0
        }
    }), (!src || isError) && (isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: $a53b6ea678d7efe0$var$defaultAvatarSrc,
        alt: "",
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, initials)));
};
var $a53b6ea678d7efe0$export$2e2bcd8739ae039 = $a53b6ea678d7efe0$var$Avatar;



var $acw62 = parcelRequire("acw62");




'use client';
// ─────────────────────────────────────────────────────────────────────────────
// PersonRow — a person, offered for choosing or simply stated.
//
// ── Why this is kit ─────────────────────────────────────────────────────────
// RECEPTION_PRACTITIONER_BOOKING §6.2 specifies a row anatomy for the clinic's
// practitioner picker — avatar, name, a meta line of «حرفه · تخصص · مدت», a
// trailing availability phrase, an ordinal for the first nine, and a disabled
// state that still says WHY. The patient app's practitioner step is the same
// row with different words in it. Two apps, one anatomy, and a *document*
// specifying it app-agnostically: §17.1 answers yes twice over.
//
// The rule it encodes is DESIGN.md rule 12 — an avatar means a person. This is
// not for anything that is not somebody.
//
// ── One component, two sizes — deliberately not two components ──────────────
// `size="sm"` is the CHIP: the pill in the clinic `BookingModal`'s header and
// the identity line of the patient's booking overlay. It is the same person
// with the same avatar and the same two lines, smaller and not tappable —
// shipping it as a second export would be the many-components failure §17.1
// warns about, and would let the two drift.
//
// Interactivity follows `onClick`: with one it is a real `<button>` and grows a
// chevron; without one it is a `<div>` that states rather than offers. A caller
// never has to ask for both.
//
// ── Unbookable is shown, never hidden (§2.6, §8.5) ──────────────────────────
// `disabled` mutes the row and shows `disabledReason` instead of dropping it
// from the list. Omitting is what makes a list lie: a patient looking for a
// specific doctor concludes they have left the clinic. `action` is the way out
// of the reason — the «تعریف ↗» link the clinic offers somebody who may fix it
// — and is simply not passed to a caller who may not.
//
// ── No copy, no numbers of its own ──────────────────────────────────────────
// §16.2 / §16.1: `name`, `meta`, `trailing`, `disabledReason` and `ordinal` are
// rendered VERBATIM, so their digits are whatever the app's own seam already
// made them. This component must never call a formatter and carries no
// catalogue. The patient app's `formatNumber` and the clinic's `formatDigits`
// are different seams, and both stay on their side of this line.
// ─────────────────────────────────────────────────────────────────────────────
// The chevron points the way the reader travels, which flips with the document.
// `--dir-flip` is the kit's one mirror (§11) — there is no `dir` prop, because a
// component that took one could be told to disagree with <html>.
const $cff717c1fa706fb8$var$Chevron = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "16",
        height: "16",
        fill: "currentColor",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            transform: 'scaleX(var(--dir-flip, 1))'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }));
const $cff717c1fa706fb8$var$SIZES = {
    md: {
        avatar: 34,
        pad: '0.6875rem 0.875rem',
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
        name: '0.84375rem',
        meta: '0.75rem',
        gap: '0.625rem'
    },
    sm: {
        avatar: 28,
        pad: '0.3125rem 0.75rem',
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill,
        name: '0.8125rem',
        meta: '0.6875rem',
        gap: '0.5rem'
    }
};
function $cff717c1fa706fb8$export$2e2bcd8739ae039({ name: name, meta: meta, trailing: trailing, ordinal: ordinal, avatar: avatar, size: size = 'md', selected: selected = false, disabled: disabled = false, disabledReason: disabledReason, action: action, chevron: chevron, onClick: onClick, as: as, className: className, 'data-testid': testId, ...rest }) {
    const S = $cff717c1fa706fb8$var$SIZES[size] || $cff717c1fa706fb8$var$SIZES.md;
    const interactive = typeof onClick === 'function' && !disabled;
    const showChevron = chevron === undefined ? interactive : chevron && !disabled;
    const tail = disabled && disabledReason ? disabledReason : trailing;
    const Tag = as || (interactive ? 'button' : 'div');
    const isButton = Tag === 'button';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        type: isButton ? 'button' : undefined,
        onClick: interactive ? onClick : undefined,
        disabled: isButton ? disabled : undefined,
        "aria-disabled": !isButton && disabled ? true : undefined,
        "aria-selected": rest.role === 'option' ? selected : undefined,
        "data-testid": testId,
        "data-state": disabled ? 'disabled' : selected ? 'selected' : 'default',
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(interactive || size === 'md' ? 'w-full text-start' : 'text-start', className),
        style: {
            // A chip HUGS its contents; a row fills the list it is in. A
            // block-level chip stretched to the panel width reads as an empty field
            // rather than as a named person.
            display: size === 'sm' ? 'inline-flex' : 'flex',
            width: size === 'sm' ? 'fit-content' : undefined,
            maxWidth: '100%',
            alignItems: 'center',
            gap: S.gap,
            padding: S.pad,
            borderRadius: S.radius,
            border: size === 'sm' ? 'none' : `1px solid ${selected ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            background: size === 'sm' ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg : selected ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent, 0.08) : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            cursor: disabled ? 'not-allowed' : interactive ? 'pointer' : 'default',
            opacity: disabled ? 0.6 : 1,
            // ≥ 2.75rem is the phone hit target (MOBILE_WEB_PWA §5); a chip is not a
            // target at all, so it is exempt.
            minHeight: size === 'sm' ? undefined : '2.75rem',
            minWidth: 0,
            transition: 'background 0.15s, border-color 0.15s'
        },
        ...rest
    }, ordinal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            width: '1.25rem',
            textAlign: 'center',
            fontSize: '0.6875rem',
            fontWeight: 800,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, ordinal) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a53b6ea678d7efe0$export$2e2bcd8739ae039), {
        name: avatar?.name ?? (typeof name === 'string' ? name : ''),
        bg: avatar?.color,
        src: avatar?.src,
        size: S.avatar
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '0.125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: S.name,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            lineHeight: 1.4,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, name), meta ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: S.meta,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            lineHeight: 1.5,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, meta) : null), tail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            flexShrink: 0,
            fontSize: '0.6875rem',
            fontWeight: 700,
            lineHeight: 1.5,
            color: disabled ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk,
            textAlign: 'end'
        }
    }, tail) : null, action, showChevron ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cff717c1fa706fb8$var$Chevron, null) : null);
}
function $cff717c1fa706fb8$export$fb8511da6566433c({ count: count = 4, size: size = 'md', label: label, 'data-testid': testId }) {
    const S = $cff717c1fa706fb8$var$SIZES[size] || $cff717c1fa706fb8$var$SIZES.md;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8b3e24dbbac64362), {
        label: label,
        "data-testid": testId,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: S.gap,
                padding: S.pad,
                borderRadius: S.radius,
                border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$2e2bcd8739ae039), {
            width: S.avatar,
            height: S.avatar,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: '0.25rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$2e2bcd8739ae039), {
            width: "45%",
            height: 11,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$2e2bcd8739ae039), {
            width: "30%",
            height: 9,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip
        })))));
}



var $acw62 = parcelRequire("acw62");



'use client';
function $7718f00aead6941c$export$2e2bcd8739ae039({ state: state = 'content', slots: slots = [], value: value, onSelect: onSelect, notice: notice = null, label: label = "\u0633\u0627\u0639\u062A\u200C\u0647\u0627\u06CC \u0622\u0632\u0627\u062F", loadingLabel: loadingLabel = "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0632\u0645\u0627\u0646\u200C\u0647\u0627\u06CC \u0622\u0632\u0627\u062F", min: min = '5rem', columns: columns, loadingCount: loadingCount = 12, className: className, 'data-testid': testId, ...rest }) {
    const gridStyle = {
        display: 'grid',
        gridTemplateColumns: columns ? `repeat(${columns}, minmax(0, 1fr))` : `repeat(auto-fill, minmax(${min}, 1fr))`,
        gap: '0.5rem'
    };
    if (state === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8b3e24dbbac64362), {
        label: loadingLabel,
        "data-testid": testId,
        "data-state": "loading",
        style: gridStyle
    }, Array.from({
        length: loadingCount
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$2e2bcd8739ae039), {
            key: i,
            height: 44,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control
        })));
    if (state === 'error' || state === 'empty') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-state": state,
        className: className,
        ...rest
    }, notice);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": label,
        "data-testid": testId,
        "data-state": "content",
        className: className,
        style: gridStyle,
        ...rest
    }, slots.map((slot)=>{
        const selected = value != null && slot.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: slot.value,
            type: "button",
            onClick: slot.disabled ? undefined : ()=>onSelect?.(slot),
            disabled: slot.disabled,
            "aria-pressed": selected,
            "data-testid": `${testId || 'slot'}-${slot.value}`,
            "data-state": slot.disabled ? 'disabled' : selected ? 'selected' : 'default',
            "data-held": slot.held || undefined,
            className: "tabular-nums",
            style: {
                // ≥ 2.75rem: a time is among the smallest things a thumb has to
                // hit on this screen, and there are dozens of them.
                minHeight: '2.75rem',
                padding: '0.5rem 0.625rem',
                borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
                fontSize: '0.8125rem',
                fontWeight: 600,
                cursor: slot.disabled ? 'not-allowed' : 'pointer',
                border: selected ? `2px solid ${(0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent}` : slot.held ? `1.5px dashed ${(0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn}` : `1.5px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                background: selected ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent, 0.14) : slot.held ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn, 0.1) : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                color: selected ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                opacity: slot.disabled ? 0.45 : 1,
                transition: 'background 0.14s, border-color 0.14s'
            }
        }, slot.label);
    }));
}



var $acw62 = parcelRequire("acw62");


'use client';
// Card — the system's surface unit.
//
// With `onClick` it becomes a REAL button (never a `<div onClick>`): callers used
// to wrap it in a `role="button"` div to get keyboard operation and a focus ring
// back, which nested two interactive elements and handed screen readers a control
// inside a control. Those semantics belong here. Pass `role="link"` when the tap
// navigates rather than acts.
const $9169df7fa2fdff01$var$Card = ({ children: children, style: style, onClick: onClick, role: role, disabled: disabled, className: className, ...rest })=>{
    const surface = {
        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
        borderRadius: 16,
        padding: '16px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
        ...style
    };
    if (!onClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        style: surface,
        ...rest
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        role: role,
        disabled: disabled,
        onClick: onClick,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('outline-none focus-visible:ring-2 focus-visible:ring-ring', className),
        style: {
            ...surface,
            display: 'block',
            width: '100%',
            textAlign: 'inherit',
            font: 'inherit',
            color: 'inherit',
            cursor: disabled ? 'default' : 'pointer',
            transition: 'transform 0.15s, box-shadow 0.15s'
        },
        onMouseDown: (e)=>{
            if (!disabled) e.currentTarget.style.transform = 'scale(0.98)';
        },
        onMouseUp: (e)=>{
            e.currentTarget.style.transform = 'scale(1)';
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.transform = 'scale(1)';
        },
        ...rest
    }, children);
};
var $9169df7fa2fdff01$export$2e2bcd8739ae039 = $9169df7fa2fdff01$var$Card;



var $acw62 = parcelRequire("acw62");

'use client';
function $4f942082497afe1e$export$2e2bcd8739ae039({ status: status, style: style }) {
    const cfg = (0, $e7c165fb515b04ea$export$6881c75116d5bd6e)[status] || {
        label: status || "\u2014",
        bg: '#f1f5f9',
        text: '#64748b'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            fontWeight: 700,
            padding: '3px 10px',
            borderRadius: 20,
            background: cfg.bg,
            color: cfg.text,
            ...style
        }
    }, cfg.label);
}



var $acw62 = parcelRequire("acw62");

'use client';
function $178f36e6e586ad89$export$2e2bcd8739ae039({ label: label, value: value, unit: unit, icon: icon, bg: bg, accent: accent, loading: loading, minWidth: minWidth = 140, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            background: '#fff',
            borderRadius: 12,
            padding: '16px 20px',
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
            flex: 1,
            minWidth: minWidth,
            ...rest.style
        }
    }, icon !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 44,
            height: 44,
            borderRadius: 12,
            background: bg || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 22,
            flexShrink: 0
        }
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 22,
            fontWeight: 800,
            color: accent || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            lineHeight: 1.15
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            whiteSpace: 'nowrap'
        }
    }, loading ? "\u2014" : value), unit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("wbr", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 14,
            fontWeight: 500,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginInlineStart: 4,
            whiteSpace: 'nowrap'
        }
    }, unit))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            marginTop: 4
        }
    }, label)));
}



var $acw62 = parcelRequire("acw62");

'use client';
function $64626580dc6749e0$export$2e2bcd8739ae039({ stats: stats, loading: loading, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: '#fff',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            padding: '12px 32px',
            display: 'flex',
            gap: 12,
            flexShrink: 0,
            overflowX: 'auto',
            ...style
        }
    }, stats.map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                background: s.bg,
                borderRadius: 10,
                padding: '8px 16px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 20,
                fontWeight: 800,
                color: s.color
            }
        }, loading ? "\u2014" : s.value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 11,
                fontWeight: 600,
                color: s.color,
                opacity: 0.75
            }
        }, s.label))));
}



var $acw62 = parcelRequire("acw62");

'use client';
function $ed420e5a4f8c639f$export$2e2bcd8739ae039({ title: title, sub: sub, breadcrumb: breadcrumb, children: children, autoFocus: autoFocus = false, ...rest }) {
    const hasMeta = sub || breadcrumb;
    const titleRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!autoFocus) return;
        // `preventScroll`: the heading is already at the top of the page, and
        // scrolling on focus would fight the route change's own scroll reset.
        titleRef.current?.focus({
            preventScroll: true
        });
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            background: '#fff',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            padding: hasMeta ? '14px 32px' : '0 32px',
            display: 'flex',
            alignItems: 'center',
            gap: 20,
            minHeight: 64,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1
        }
    }, breadcrumb && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginBottom: 3
        }
    }, breadcrumb), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        ref: titleRef,
        // -1: reachable by script, never a stop in the tab order. A heading
        // that took a Tab of its own would be a new obstacle on every page.
        tabIndex: autoFocus ? -1 : undefined,
        style: {
            margin: 0,
            fontWeight: 800,
            fontSize: 18,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            lineHeight: 1.2,
            outline: 'none'
        }
    }, title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: 3
        }
    }, sub)), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexShrink: 0
        }
    }, children));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2a140ead2dcbdb51$export$a2387ed3b5d536eb = {
    name: "arrow-right",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M5 12h14",
                key: "1ays0h"
            }
        ],
        [
            "path",
            {
                d: "m12 5 7 7-7 7",
                key: "xquz4c"
            }
        ]
    ]
};
$2a140ead2dcbdb51$export$a2387ed3b5d536eb.node;
const $2a140ead2dcbdb51$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($2a140ead2dcbdb51$export$a2387ed3b5d536eb);




'use client';
function $3c79ee8367a72d83$export$2e2bcd8739ae039({ onBack: onBack, backLabel: backLabel = "\u0628\u0627\u0632\u06AF\u0634\u062A", title: title, sub: sub, avatar: avatar, status: status, badges: badges, meta: meta, stats: stats, children: children, className: className, 'data-testid': testId, ...rest }) {
    const metaItems = (meta || []).filter(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: className,
        "data-testid": testId,
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            paddingInline: '1.75rem',
            paddingBlock: '0.75rem',
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            minHeight: '4rem',
            flexShrink: 0,
            flexWrap: 'wrap'
        },
        ...rest
    }, onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        onClick: onBack,
        "aria-label": backLabel,
        title: backLabel,
        "data-testid": testId ? `${testId}-back` : undefined,
        className: "shrink-0 gap-1.5 ps-2 pe-3 text-muted-foreground hover:text-foreground"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2a140ead2dcbdb51$export$2e2bcd8739ae039), {
        size: 16,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600
        }
    }, backLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            flex: 1,
            minWidth: 0
        }
    }, avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0
        }
    }, avatar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0,
            flex: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5625rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        dir: "auto",
        style: {
            margin: 0,
            fontWeight: 800,
            fontSize: '1.125rem',
            lineHeight: 1.2,
            letterSpacing: '-0.01em',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        }
    }, title), status, badges), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: '0.1875rem'
        }
    }, sub), metaItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flexWrap: 'wrap',
            marginTop: '0.1875rem',
            fontSize: '0.78125rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, metaItems.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: i
        }, i > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                width: 3,
                height: 3,
                borderRadius: '50%',
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                opacity: 0.6,
                flexShrink: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, m)))))), (stats?.length || children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            flexShrink: 0,
            flexWrap: 'wrap'
        }
    }, stats?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5625rem'
        }
    }, stats.map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                minWidth: '4.5rem',
                paddingInline: '0.75rem',
                paddingBlock: '0.375rem',
                borderRadius: 'var(--radius, 0.625rem)',
                textAlign: 'center',
                background: s.accent ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentSoft : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
                border: `1px solid ${s.accent ? 'transparent' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.65625rem',
                fontWeight: 600,
                marginBottom: '0.0625rem',
                color: s.accent ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
            }
        }, s.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '1rem',
                fontWeight: 800,
                letterSpacing: '-0.01em',
                color: s.accent ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                fontVariantNumeric: 'tabular-nums'
            }
        }, s.value)))), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, children)));
}



var $acw62 = parcelRequire("acw62");

'use client';
const $ca91b548719491bb$var$TopBar = ({ title: title, subtitle: subtitle, onBack: onBack, action: action })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            padding: '16px 20px 20px',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12
        }
    }, onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onBack,
        style: {
            background: 'rgba(255,255,255,0.15)',
            border: 'none',
            borderRadius: 10,
            width: 36,
            height: 36,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            color: 'white',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        width: "18",
        height: "18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "9 18 15 12 9 6"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'white',
            fontSize: 18,
            fontWeight: 700
        }
    }, title), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'rgba(255,255,255,0.65)',
            fontSize: 12,
            marginTop: 2
        }
    }, subtitle))), action));
var $ca91b548719491bb$export$2e2bcd8739ae039 = $ca91b548719491bb$var$TopBar;



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $30b4d9519dd12f8d$export$a2387ed3b5d536eb = {
    name: "search",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m21 21-4.34-4.34",
                key: "14j7rj"
            }
        ],
        [
            "circle",
            {
                cx: "11",
                cy: "11",
                r: "8",
                key: "4ej97u"
            }
        ]
    ]
};
$30b4d9519dd12f8d$export$a2387ed3b5d536eb.node;
const $30b4d9519dd12f8d$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($30b4d9519dd12f8d$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4b6a18bc128c0629$export$a2387ed3b5d536eb = {
    name: "x",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M18 6 6 18",
                key: "1bl5f8"
            }
        ],
        [
            "path",
            {
                d: "m6 6 12 12",
                key: "d8bk6v"
            }
        ]
    ]
};
$4b6a18bc128c0629$export$a2387ed3b5d536eb.node;
const $4b6a18bc128c0629$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($4b6a18bc128c0629$export$a2387ed3b5d536eb);





'use client';
/**
 * MobileHeader — the gradient screen header that is the mobile brand signature
 * (DESIGN-CONCEPT-MOBILE §3.2). Every top-level mobile screen opens with it.
 *
 * Two modes, chosen by the props you pass — never a mode flag:
 *
 *   • **Cockpit** (`user`) — the person's name as a *greeting*, not chrome:
 *     avatar + «خوش آمدید،» + name on the inline-start edge. What a top-level
 *     bottom-nav destination uses.
 *   • **Content screen** (`onBack` + `title`) — a drilled-into full-screen
 *     surface has no bottom nav, so the header itself carries the way back:
 *     back affordance above the screen title, on the same brand chrome rather
 *     than in a separate bar above it (§3.1).
 *
 * Both modes render `title` as the page's single `<h1>` (§12.1) and accept
 * `actions` — white-alpha square quick actions ≥2.75rem, the sanctioned way to
 * tint on-gradient chrome (§2.2). A control that navigates nowhere is a defect,
 * so a caller passes an action only when its destination exists.
 *
 * `children` is the optional context-widget row (a date navigator, a filter
 * strip) rendered inside the gradient below the identity row.
 *
 * Props:
 *   title      — screen title; rendered as the page's <h1>
 *   subtitle   — optional line under the title
 *   greeting   — cockpit lead-in above the name (default «خوش آمدید،»)
 *   user       — { name, avatar } → cockpit greeting mode
 *   onBack     — back handler → content mode; renders the «بازگشت» affordance
 *   backLabel  — label for the back affordance (default «بازگشت»)
 *   actions    — [{ key, icon, label, onClick, badge? }] end-side quick actions;
 *                `badge` = { color } renders a small status dot
 *   action     — a single trailing node (shorthand; rendered after `actions`)
 *   backTestId — override for the back control's `data-testid`. Defaults to
 *                `${testId}-back`; a screen whose selector contract already
 *                names its own back control passes it here rather than
 *                renaming the whole header (which is what an app fork did).
 *   sticky     — pin the header to the top of its scroller. A list destination
 *                whose filter bar lives in `children` needs the bar to stay
 *                reachable while the list scrolls under it (§3.2).
 *   search     — `{ value, onChange, placeholder, clearLabel, onClear, onSubmit,
 *                autoFocus, testId }`. Renders the on-gradient search field that a lookup
 *                screen opens into: a real `<input>` at ≥2.75rem with an inline
 *                clear control, sitting above `children`. Passing it is what
 *                turns a 🔍 quick action into a search surface, so no screen
 *                hand-rolls a white field on the brand chrome again.
 *   children   — optional context-widget row
 *   className / data-testid — forwarded to the root (§15.1)
 */ function $62f4a9fc87ba90f8$var$QuickActions({ actions: actions, testId: testId }) {
    if (!actions?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.375rem',
            flexShrink: 0
        }
    }, actions.map(({ key: key, icon: icon, label: label, onClick: onClick, badge: badge })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key,
            style: {
                position: 'relative'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            variant: "ghost",
            size: "icon",
            onClick: onClick,
            "aria-label": label,
            title: label,
            "data-testid": testId ? `${testId}-action-${key}` : undefined,
            className: "min-w-11 min-h-11 text-white hover:bg-white/25",
            style: {
                background: 'rgba(255,255,255,0.14)',
                borderRadius: 'var(--radius, 0.625rem)'
            }
        }, icon), badge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                position: 'absolute',
                top: '0.25rem',
                insetInlineEnd: '0.25rem',
                width: '0.5rem',
                height: '0.5rem',
                borderRadius: '50%',
                background: badge.color,
                border: '1.5px solid rgba(1,94,156,0.9)'
            }
        }))));
}
function $62f4a9fc87ba90f8$export$2e2bcd8739ae039({ title: title, subtitle: subtitle, greeting: greeting = "\u062E\u0648\u0634 \u0622\u0645\u062F\u06CC\u062F\u060C", user: user, onBack: onBack, backLabel: backLabel = "\u0628\u0627\u0632\u06AF\u0634\u062A", actions: actions = [], action: action, backTestId: backTestId, sticky: sticky = false, search: search, children: children, className: className, style: style, 'data-testid': testId = 'mobile-header', ...rest }) {
    const hasTrailing = actions.length > 0 || Boolean(action);
    const trailing = hasTrailing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$QuickActions, {
        actions: actions,
        testId: testId
    }), action);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: className,
        "data-testid": testId,
        style: {
            background: (0, $e7c165fb515b04ea$export$4c2e201e0b6dbaa3),
            padding: 'calc(1rem + env(safe-area-inset-top, 0px)) 1rem 1.5rem',
            // `sticky` keeps the filter bar in `children` reachable while a long
            // list scrolls under it; `relative` is the default so the decorative
            // circles below still clip to the header.
            position: sticky ? 'sticky' : 'relative',
            ...sticky ? {
                top: 0,
                zIndex: 30
            } : null,
            overflow: 'hidden',
            flexShrink: 0,
            // A caller's `style` is MERGED OVER the computed layout, the convention
            // the rest of the kit follows (`Card`, the chat family). It used to fall
            // into `...rest` and — because the spread sits after this attribute —
            // REPLACE the whole object: passing `style` for so much as a
            // `position: sticky` silently deleted the brand gradient, the padding
            // and the safe-area inset, and left white text on a white page.
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            top: '-1.875rem',
            insetInlineEnd: '-1.875rem',
            width: '8.75rem',
            height: '8.75rem',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.04)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            bottom: '-1.25rem',
            insetInlineStart: '-0.625rem',
            width: '6.25rem',
            height: '6.25rem',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.06)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative'
        }
    }, onBack ? /* Content mode — the way back lives on the brand chrome (§3.1). */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        onClick: onBack,
        "aria-label": backLabel,
        "data-testid": backTestId || `${testId}-back`,
        className: "h-auto min-h-11 gap-1.5 ps-0 pe-2 text-white/85 hover:bg-white/15 hover:text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2a140ead2dcbdb51$export$2e2bcd8739ae039), {
        size: 16,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600
        }
    }, backLabel)), trailing), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            margin: '0.25rem 0 0',
            color: '#fff',
            fontSize: '1.25rem',
            fontWeight: 800,
            lineHeight: 1.25
        }
    }, title)) : /* Cockpit mode — greeting (or a bare title) + quick actions (§3.2). */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (user || hasTrailing) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '0.75rem'
        }
    }, user ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem',
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a53b6ea678d7efe0$export$2e2bcd8739ae039), {
        name: user.name || "\u061F",
        size: 40,
        bg: "rgba(255,255,255,0.2)",
        src: user.avatar || undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'rgba(255,255,255,0.65)',
            fontSize: '0.6875rem'
        }
    }, greeting), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            color: '#fff',
            fontSize: '0.9375rem',
            fontWeight: 700,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, user.name || "\u2026"))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null), trailing), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            margin: user || hasTrailing ? '0.75rem 0 0' : 0,
            color: '#fff',
            fontSize: '1.25rem',
            fontWeight: 800,
            lineHeight: 1.25
        }
    }, title)), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'rgba(255,255,255,0.7)',
            fontSize: '0.75rem',
            marginTop: '0.25rem'
        }
    }, subtitle), search && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$SearchField, {
        ...search,
        headerTestId: testId
    }), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.875rem'
        }
    }, children)));
}
/**
 * The on-gradient search field (§3.2). A real `<input>` — not a kit `TextInput`
 * — because the kit field is painted for a white surface and this one sits on
 * the brand chrome; the shared contract it does keep is the 2.75rem height, the
 * ≥1rem font (anything smaller triggers iOS focus-zoom) and a clear control.
 */ function $62f4a9fc87ba90f8$var$SearchField({ value: value = '', onChange: onChange, onClear: onClear, onSubmit: onSubmit, placeholder: placeholder, clearLabel: clearLabel = "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646", autoFocus: autoFocus = false, testId: testId, headerTestId: headerTestId }) {
    const id = testId || `${headerTestId}-search`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        role: "search",
        onSubmit: (e)=>{
            e.preventDefault();
            onSubmit?.(value);
        },
        style: {
            marginTop: '0.875rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            background: 'rgba(255,255,255,0.16)',
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
            paddingInline: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $30b4d9519dd12f8d$export$2e2bcd8739ae039), {
        size: 17,
        color: "rgba(255,255,255,0.75)",
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "search",
        inputMode: "search",
        enterKeyHint: "search",
        autoFocus: autoFocus,
        value: value,
        onChange: (e)=>onChange?.(e.target.value),
        placeholder: placeholder,
        "data-testid": id,
        style: {
            flex: 1,
            minWidth: 0,
            height: '2.75rem',
            border: 'none',
            outline: 'none',
            background: 'transparent',
            color: '#fff',
            // ≥1rem or iOS zooms the whole page on focus and never zooms back.
            fontSize: '1rem',
            fontFamily: 'inherit'
        }
    }), value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        type: "button",
        variant: "ghost",
        size: "icon",
        onClick: ()=>onClear?.(),
        "aria-label": clearLabel,
        "data-testid": `${id}-clear`,
        className: "min-w-11 min-h-11 text-white/80 hover:bg-white/15 hover:text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b6a18bc128c0629$export$2e2bcd8739ae039), {
        size: 16,
        "aria-hidden": true
    })) : null);
}



var $acw62 = parcelRequire("acw62");


'use client';
function $5943a0a75dff01a1$export$2e2bcd8739ae039({ items: items = [], active: active, onSelect: onSelect, heightVar: heightVar = '--app-bottom-nav', className: className, 'data-testid': testId = 'bottom-nav', ...rest }) {
    const barRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Publish the real height while this bar is mounted, and clear it when it is
    // not — the bar is absent on full-screen flows, and a stale value there would
    // push floating chrome up over nothing.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = barRef.current;
        if (!el || !heightVar || typeof document === 'undefined') return undefined;
        const root = document.documentElement;
        const publish = ()=>root.style.setProperty(heightVar, `${Math.round(el.offsetHeight)}px`);
        publish();
        // ResizeObserver is absent in jsdom and in older webviews; the one-shot
        // measurement above is already right for them, since what it would catch
        // (a rotation changing the inset, a text-size change) is rare and
        // self-correcting on the next navigation.
        const ro = typeof ResizeObserver === 'function' ? new ResizeObserver(publish) : null;
        if (ro) ro.observe(el);
        return ()=>{
            if (ro) ro.disconnect();
            root.style.removeProperty(heightVar);
        };
    }, [
        heightVar,
        items.length
    ]);
    if (!items.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        ref: barRef,
        className: className,
        "data-testid": testId,
        "aria-label": "\u0646\u0627\u0648\u0628\u0631\u06CC \u0627\u0635\u0644\u06CC",
        style: {
            flexShrink: 0,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            display: 'flex',
            alignItems: 'stretch',
            justifyContent: 'space-around',
            paddingInline: '0.5rem',
            paddingTop: 0,
            // `max(…)`, not the bare inset: in a browser tab the inset is 0 because
            // the browser's own toolbar occupies that strip, which left the labels
            // sitting on the very edge of the window. The floor gives them the same
            // breathing room the home indicator provides in standalone mode.
            paddingBottom: 'max(env(safe-area-inset-bottom, 0px), 0.25rem)',
            position: 'relative',
            zIndex: 50
        },
        ...rest
    }, items.map((item)=>{
        const isActive = item.key === active;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            key: item.key,
            variant: "ghost",
            onClick: ()=>onSelect?.(item.key, item),
            "aria-current": isActive ? 'page' : undefined,
            "data-testid": `${testId}-${item.key}`,
            className: "h-auto min-h-11 flex-1 flex-col gap-1 rounded-none py-2 font-medium",
            style: {
                color: isActive ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                position: 'relative',
                display: 'inline-flex'
            }
        }, item.icon, item.badge != null && item.badge !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": `${testId}-${item.key}-badge`,
            // The count is decoration to the eye and information to a
            // screen reader; without a label it is read as a bare digit
            // beside the destination's name. The caller supplies the
            // sentence because only it knows what is being counted.
            "aria-label": item.badgeLabel,
            style: {
                position: 'absolute',
                top: '-0.25rem',
                insetInlineEnd: '-0.375rem',
                minWidth: '1rem',
                height: '1rem',
                paddingInline: '0.25rem',
                borderRadius: '0.5rem',
                // Tone is the caller's to choose, and the default is NOT the
                // safe one. Red carries "something is wrong"; an unread count
                // is not wrong, it is waiting — the colour budget reserves red
                // for destructive meaning, so a count uses `badgeTone="count"`.
                // ('accent' is the original spelling and still resolves here;
                // it drew navy from the start, and navy is the swatch the
                // whole unread family now agrees on.)
                // The default stays red only because it is what shipped, and
                // changing it silently would restyle callers that meant alarm.
                background: item.badgeTone === 'count' || item.badgeTone === 'accent' ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
                color: '#fff',
                fontSize: '0.625rem',
                fontWeight: 700,
                lineHeight: '1rem',
                textAlign: 'center'
            }
        }, item.badge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: isActive ? 700 : 500
            }
        }, item.label));
    }));
}



var $acw62 = parcelRequire("acw62");

'use client';
function $ea4bc4a14affb445$export$2e2bcd8739ae039({ tiles: tiles = [], loading: loading = false, columns: columns = 4, className: className, 'data-testid': testId = 'stat-tiles', ...rest }) {
    if (!tiles.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        "data-state": loading ? 'loading' : 'content',
        style: {
            display: 'grid',
            // minmax(0, 1fr) rather than 1fr: a grid track's default `min-width:auto`
            // is its content's minimum, so one long value would push the row past
            // 320px and take the whole page into horizontal scroll (§9).
            gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
            gap: '0.5rem'
        },
        ...rest
    }, tiles.map(({ key: key, label: label, value: value, icon: icon, color: color, solid: solid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key ?? label,
            "data-testid": `${testId}-${key ?? label}`,
            style: {
                background: solid ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                borderRadius: '0.875rem',
                padding: '0.625rem 0.25rem',
                textAlign: 'center',
                boxShadow: solid ? `0 4px 16px ${(0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.35)}` : '0 1px 4px rgba(0,0,0,0.06)',
                border: `1px solid ${solid ? 'transparent' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                minWidth: 0
            }
        }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-hidden": true,
            style: {
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '0.1875rem',
                color: solid ? '#fff' : color || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
            }
        }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '1.0625rem',
                fontWeight: 800,
                color: solid ? '#fff' : color || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, loading || value == null || value === '' ? "\u2014" : value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.59375rem',
                color: solid ? 'rgba(255,255,255,0.7)' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                marginTop: '0.125rem',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, label))));
}



var $acw62 = parcelRequire("acw62");




'use client';
// ─────────────────────────────────────────────────────────────────────────────
// AccountCard — the block at the foot of the sidebar.
//
// ONE component for the doctor, clinic, dentist and patient panels, each of
// which had hand-rolled its own version: three copies of the پارسه balance card
// that already disagreed about their hex values, and four different answers to
// «چطور از حسابم خارج شوم؟».
//
// ── TWO ZONES, ONE COMPONENT ────────────────────────────────────────────────
// The balance on top, the identity below it, separated by the hairline that was
// already there. Not one merged row: the balance is a number read at a glance
// many times an hour, the identity is a control pressed rarely. The doctor and
// clinic panels independently arrived at this same stacking; this makes it the
// rule rather than a coincidence.
//
// ── THE IDENTITY ROW IS THE MENU TRIGGER ────────────────────────────────────
// The two loose 16px glyphs are gone. A sign-out icon sat one pixel from an
// external-link icon, both unlabelled, and the only thing distinguishing «رفتن
// به حساب» from «خروج» was the shape of a 16px arrow. Now the whole row opens a
// menu whose every destination is named in words.
//
// ── ONE BALANCE: THE SIGNED-IN PERSON'S OWN ─────────────────────────────────
// In the clinic panel there are two pots of money — the clinic's shared pool
// that reception AI spends, and the person's own wallet. This card shows ONLY
// the person's. They are never summed and never offset, and a block labelled
// «حساب من» must not be able to show money that belongs to the clinic. Omit
// `credit` entirely (a receptionist owns no wallet; patients hold no پارسه at
// all) and the zone is not rendered — there is then no number here to be wrong
// about.
//
// ── THE APP FORMATS THE DIGITS ──────────────────────────────────────────────
// `credit.amount` is a STRING the app already localised — Persian digits in fa,
// Latin in en. Same seam as `BottomNav`'s badge: the digit boundary belongs to
// the app, which knows its locale; the kit does not. `credit.level` likewise
// comes from `creditLevel()` in @parsina/framework/tokens, so all four panels
// agree on what «کم» means.
//
// ── SURVIVING THE 68px RAIL ─────────────────────────────────────────────────
// Coin tile and avatar sit in fixed-width cells FIRST in DOM order, so under RTL
// they are rightmost and the collapse — which clips from the inline-end — takes
// only the fading text. Both zones stay operable collapsed, and the menu still
// opens (it is portaled, so the sidebar's `overflow: hidden` cannot slice it).
// Nothing focusable is left painted at zero opacity: the top-up button is not
// rendered at all when collapsed, rather than faded into an invisible tab stop.
//
// Props:
//   user       {name, subtitle?, avatarUrl?}                       — required
//   credit     {amount, level, unit, label, levelLabel, onClick?}  — omit to hide the zone
//   onTopUp    ()=>void  — shows «شارژ اعتبار», expanded + level 'low' only
//   topUpLabel string
//   items      MenuItem[] — {key, label, description?, icon?, href?, external?,
//                            onClick?, tone?, separatorBefore?, 'data-testid'?}
//   collapsed  boolean    — the 68px rail
//   overlay    'auto' | 'menu' | 'sheet'  — auto switches at 768px (DESIGN.md §6:
//              a BottomSheet is the default overlay for a task on mobile; a 236px
//              popover anchored to the bottom edge of a phone is not)
//   menuLabel  string     — accessible name; required, because the trigger's own
//                           visible text is a person's name
// ─────────────────────────────────────────────────────────────────────────────
const $a13c7c62f369d090$var$MINI = 68; // the collapsed rail, and so the width of every icon cell
const $a13c7c62f369d090$var$INSET = 10; // the card's inset from the sidebar edges
const $a13c7c62f369d090$var$NARROW_QUERY = '(max-width: 768px)';
function $a13c7c62f369d090$var$useNarrow(enabled) {
    const [narrow, setNarrow] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!enabled || typeof window === 'undefined' || !window.matchMedia) return undefined;
        const mq = window.matchMedia($a13c7c62f369d090$var$NARROW_QUERY);
        const sync = ()=>setNarrow(mq.matches);
        sync();
        // `addListener` is the Safari < 14 spelling; both are cheap to support and
        // the patient app is the one that actually meets phones.
        if (mq.addEventListener) mq.addEventListener('change', sync);
        else mq.addListener(sync);
        return ()=>{
            if (mq.removeEventListener) mq.removeEventListener('change', sync);
            else mq.removeListener(sync);
        };
    }, [
        enabled
    ]);
    return narrow;
}
const $a13c7c62f369d090$var$CoinGlyph = ({ size: size = 16 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        width: size,
        height: size,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "8.5",
        stroke: "currentColor",
        strokeWidth: "1.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 7.5v9M9.5 10h5M9.5 14h5",
        stroke: "currentColor",
        strokeWidth: "1.8",
        strokeLinecap: "round"
    }));
// Says the press LEAVES this panel. Without it a row that navigates to حساب
// پارسینا reads as a tab that never opens.
const $a13c7c62f369d090$var$ExternalGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "13",
        height: "13",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            opacity: 0.55
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "15 3 21 3 21 9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "10",
        y1: "14",
        x2: "21",
        y2: "3"
    }));
// ── one menu row, in either presentation ────────────────────────────────────
function $a13c7c62f369d090$var$AccountMenuRow({ item: item, onDone: onDone, compact: compact, testIdBase: testIdBase }) {
    const destructive = item.tone === 'destructive';
    const ink = destructive ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary;
    const hover = destructive ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).red, 0.10) : (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.08);
    const style = {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        width: '100%',
        padding: compact ? '10px' : '13px 12px',
        minHeight: compact ? 40 : 48,
        border: 'none',
        borderRadius: 9,
        background: 'transparent',
        color: ink,
        textAlign: 'start',
        textDecoration: 'none',
        fontFamily: 'inherit',
        fontSize: 13.5,
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'background 0.14s'
    };
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, item.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flexShrink: 0,
            display: 'flex',
            color: destructive ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
        },
        "aria-hidden": true
    }, item.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, item.label), item.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            fontSize: 11,
            fontWeight: 500,
            marginTop: 1,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, item.description)), item.external && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$ExternalGlyph, null));
    const shared = {
        role: 'menuitem',
        'data-testid': item['data-testid'] || `${testIdBase}-item-${item.key}`,
        style: style,
        onMouseEnter: (e)=>{
            e.currentTarget.style.background = hover;
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.background = 'transparent';
        }
    };
    // A real <a> when the destination is a URL: it must be focusable, openable in
    // a new tab with the usual modifiers, and readable in the status bar.
    return item.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        ...shared,
        href: item.href,
        target: item.target,
        rel: item.target === '_blank' ? 'noopener noreferrer' : undefined,
        onClick: ()=>onDone?.()
    }, body) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ...shared,
        type: "button",
        onClick: ()=>{
            onDone?.();
            item.onClick?.();
        }
    }, body);
}
// ── the balance, in either presentation ─────────────────────────────────────
// A real <a> when `credit.href` is given — the clinic panel's balance points at
// حساب پارسینا, and a link there must be middle-clickable and readable in the
// status bar rather than a button that happens to navigate. A <button> when the
// destination is inside this SPA, so it does not reload the app.
function $a13c7c62f369d090$var$CreditZone({ credit: credit, levelColor: levelColor, isLow: isLow, collapsed: collapsed, fade: fade, testId: testId }) {
    const bg = (hovered)=>isLow ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).red, hovered ? 0.24 : 0.16) : `rgba(255,255,255,${hovered ? 0.12 : 0.06})`;
    const props = {
        'data-testid': `${testId}-credit`,
        onClick: credit.onClick,
        title: collapsed ? `${credit.label} \u{2014} ${credit.amount} ${credit.unit}` : undefined,
        'aria-label': `${credit.label} \u{2014} ${credit.amount} ${credit.unit}`,
        style: {
            width: `calc(100% - ${$a13c7c62f369d090$var$INSET * 2}px)`,
            margin: `0 ${$a13c7c62f369d090$var$INSET}px`,
            display: 'flex',
            alignItems: 'center',
            borderRadius: 12,
            padding: 0,
            background: bg(false),
            border: `1px solid ${isLow ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).red, 0.4) : 'rgba(255,255,255,0.08)'}`,
            cursor: credit.href || credit.onClick ? 'pointer' : 'default',
            fontFamily: 'inherit',
            textAlign: 'start',
            textDecoration: 'none',
            color: 'inherit',
            transition: 'background 0.18s'
        },
        onMouseEnter: (e)=>{
            e.currentTarget.style.background = bg(true);
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.background = bg(false);
        }
    };
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: $a13c7c62f369d090$var$MINI - $a13c7c62f369d090$var$INSET * 2,
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'center',
            padding: '9px 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 30,
            height: 30,
            borderRadius: 9,
            flexShrink: 0,
            background: (0, $e7c165fb515b04ea$export$7bce9182245b1545)(levelColor, 0.22),
            color: levelColor,
            display: 'grid',
            placeItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$CoinGlyph, {
        size: 16
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            ...fade,
            flex: 1,
            minWidth: 0,
            paddingInlineEnd: $a13c7c62f369d090$var$INSET
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: 10.5,
            fontWeight: 600,
            color: 'rgba(255,255,255,0.5)',
            whiteSpace: 'nowrap'
        }
    }, credit.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            marginTop: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 15,
            fontWeight: 800,
            color: '#fff',
            whiteSpace: 'nowrap'
        }
    }, credit.amount), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            color: 'rgba(255,255,255,0.5)'
        }
    }, credit.unit), credit.levelLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            marginInlineStart: 'auto',
            whiteSpace: 'nowrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: levelColor
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 10.5,
            fontWeight: 700,
            color: 'rgba(255,255,255,0.6)'
        }
    }, credit.levelLabel)))));
    return credit.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        ...props,
        href: credit.href,
        target: credit.target,
        rel: credit.target === '_blank' ? 'noopener noreferrer' : undefined
    }, body) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ...props,
        type: "button"
    }, body);
}
function $a13c7c62f369d090$export$2e2bcd8739ae039({ user: user, credit: credit = null, onTopUp: onTopUp, topUpLabel: topUpLabel = "\u0634\u0627\u0631\u0698 \u0627\u0639\u062A\u0628\u0627\u0631", items: items = [], collapsed: collapsed = false, overlay: overlay = 'auto', menuLabel: menuLabel = "\u062D\u0633\u0627\u0628 \u06A9\u0627\u0631\u0628\u0631\u06CC", 'data-testid': testId = 'account-card' }) {
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const narrow = $a13c7c62f369d090$var$useNarrow(overlay === 'auto');
    const asSheet = overlay === 'sheet' || overlay === 'auto' && narrow;
    // Collapsing must not leave the menu floating beside a rail that just changed
    // width — the anchor moves 192px under a CSS transition.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setOpen(false);
    }, [
        collapsed
    ]);
    const rows = items.filter(Boolean);
    const close = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setOpen(false), []);
    const fade = {
        opacity: collapsed ? 0 : 1,
        pointerEvents: collapsed ? 'none' : 'auto',
        transition: 'opacity 0.16s ease'
    };
    const level = credit?.level || 'ok';
    const levelColor = (0, $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7)[level]?.color || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal;
    const isLow = level === 'low';
    const rendered = rows.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: item.key
        }, item.separatorBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "separator",
            style: {
                height: 1,
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
                margin: '5px 8px'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$AccountMenuRow, {
            item: item,
            onDone: close,
            compact: !asSheet,
            testIdBase: testId
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        style: {
            flexShrink: 0,
            position: 'relative'
        }
    }, credit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '6px 0 2px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$CreditZone, {
        credit: credit,
        levelColor: levelColor,
        isLow: isLow,
        collapsed: collapsed,
        fade: fade,
        testId: testId
    }), onTopUp && isLow && !collapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "data-testid": `${testId}-topup`,
        onClick: onTopUp,
        style: {
            width: `calc(100% - ${$a13c7c62f369d090$var$INSET * 2}px)`,
            margin: `6px ${$a13c7c62f369d090$var$INSET}px 0`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 5,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
            border: 'none',
            borderRadius: 10,
            padding: '7px 0',
            color: '#fff',
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: 12,
            fontWeight: 800
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$CoinGlyph, {
        size: 13
    }), " ", topUpLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: triggerRef,
        type: "button",
        "data-testid": `${testId}-trigger`,
        onClick: ()=>setOpen((v)=>!v),
        "aria-haspopup": "menu",
        "aria-expanded": open,
        "aria-label": `${menuLabel} \u{2014} ${user?.name || ''}`,
        title: collapsed ? `${menuLabel} \u{2014} ${user?.name || ''}` : undefined,
        style: {
            width: '100%',
            marginTop: credit ? 10 : 0,
            display: 'flex',
            alignItems: 'center',
            padding: '12px 0',
            border: 'none',
            borderTop: '1px solid rgba(255,255,255,0.07)',
            background: open ? 'rgba(255,255,255,0.09)' : 'transparent',
            cursor: 'pointer',
            fontFamily: 'inherit',
            textAlign: 'start',
            overflow: 'hidden',
            transition: 'background 0.16s'
        },
        onMouseEnter: (e)=>{
            if (!open) e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
        },
        onMouseLeave: (e)=>{
            if (!open) e.currentTarget.style.background = 'transparent';
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: $a13c7c62f369d090$var$MINI,
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a53b6ea678d7efe0$export$2e2bcd8739ae039), {
        name: user?.name || '',
        size: 36,
        bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
        src: user?.avatarUrl || undefined
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            ...fade,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flex: 1,
            minWidth: 0,
            paddingInlineEnd: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            color: '#fff',
            fontSize: 13,
            fontWeight: 700,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, user?.name || "\u2014"), user?.subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            color: 'rgba(255,255,255,0.42)',
            fontSize: 11,
            marginTop: 2,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, user.subtitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "15",
        height: "15",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            color: open ? '#fff' : 'rgba(255,255,255,0.45)',
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.18s, color 0.18s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "18 15 12 9 6 15"
    })))), asSheet ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: open,
        onClose: close,
        title: menuLabel,
        "data-testid": `${testId}-sheet`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "menu",
        "aria-label": menuLabel,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        }
    }, rendered)) : // 'top': this card is the LAST thing in the sidebar, so a menu opening
    // downward would render off the bottom of the viewport.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $08d1958bc1315b40$export$2e2bcd8739ae039), {
        open: open,
        onClose: close,
        anchorRef: triggerRef,
        ariaLabel: menuLabel,
        placement: "top",
        width: 236,
        "data-testid": `${testId}-menu`
    }, rendered));
}



var $acw62 = parcelRequire("acw62");


'use client';
function $dd795e2724b3b1d0$export$2e2bcd8739ae039({ items: items = [], active: active, onSelect: onSelect, ariaLabel: ariaLabel, className: className, 'data-testid': testId = 'section-nav', ...rest }) {
    const activeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Keep the selected section in view: a strip long enough to scroll can put
    // the active item off-screen (or half-clipped at an edge) after a tap, a
    // route restore, or a rotation.
    //
    // Feature-detected, not assumed: `scrollIntoView` does not exist in jsdom and
    // is missing from some old webviews, and an unguarded call there throws from
    // inside an effect — which unmounts the whole record rather than merely
    // failing to centre a tab. Centring is a convenience; rendering is not.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = activeRef.current;
        if (typeof el?.scrollIntoView !== 'function') return;
        el.scrollIntoView({
            inline: 'center',
            block: 'nearest',
            behavior: 'smooth'
        });
    }, [
        active
    ]);
    if (!items.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        role: "tablist",
        "aria-label": ariaLabel,
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            flexShrink: 0,
            display: 'flex',
            overflowX: 'auto',
            scrollbarWidth: 'none',
            padding: '0 0.25rem'
        },
        ...rest
    }, items.map(({ key: key, label: label, icon: icon })=>{
        const on = key === active;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            key: key,
            ref: on ? activeRef : undefined,
            variant: "ghost",
            role: "tab",
            "aria-selected": on,
            "data-testid": `${testId}-${key}`,
            onClick: ()=>onSelect?.(key, {
                    key: key,
                    label: label,
                    icon: icon
                }),
            className: "h-auto min-h-11 shrink-0 flex-col gap-0.5 rounded-none px-3.5 py-2 hover:bg-transparent",
            style: {
                color: on ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                fontWeight: on ? 700 : 500,
                borderBottom: on ? `2.5px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy}` : '2.5px solid transparent'
            }
        }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                display: 'inline-flex'
            }
        }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem'
            }
        }, label));
    }));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5b56343e65588121$export$a2387ed3b5d536eb = {
    name: "calendar-days",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M8 2v3",
                key: "1ioesn"
            }
        ],
        [
            "path",
            {
                d: "M16 2v3",
                key: "otl347"
            }
        ],
        [
            "rect",
            {
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2",
                key: "h1oib"
            }
        ],
        [
            "path",
            {
                d: "M3 9h18",
                key: "1pudct"
            }
        ],
        [
            "path",
            {
                d: "M8 13h.01",
                key: "1sbv64"
            }
        ],
        [
            "path",
            {
                d: "M12 13h.01",
                key: "y0uutt"
            }
        ],
        [
            "path",
            {
                d: "M16 13h.01",
                key: "wip0gl"
            }
        ],
        [
            "path",
            {
                d: "M8 17h.01",
                key: "p3bg7i"
            }
        ],
        [
            "path",
            {
                d: "M12 17h.01",
                key: "p32p05"
            }
        ],
        [
            "path",
            {
                d: "M16 17h.01",
                key: "ql8jdd"
            }
        ]
    ]
};
$5b56343e65588121$export$a2387ed3b5d536eb.node;
const $5b56343e65588121$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($5b56343e65588121$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9c8dd034124f4eb9$export$a2387ed3b5d536eb = {
    name: "chevron-right",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m9 18 6-6-6-6",
                key: "mthhwq"
            }
        ]
    ]
};
$9c8dd034124f4eb9$export$a2387ed3b5d536eb.node;
const $9c8dd034124f4eb9$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($9c8dd034124f4eb9$export$a2387ed3b5d536eb);





var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


'use client';
const $d9dd19094c9f758e$var$J_MONTHS = [
    "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
    "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
    "\u062E\u0631\u062F\u0627\u062F",
    "\u062A\u06CC\u0631",
    "\u0645\u0631\u062F\u0627\u062F",
    "\u0634\u0647\u0631\u06CC\u0648\u0631",
    "\u0645\u0647\u0631",
    "\u0622\u0628\u0627\u0646",
    "\u0622\u0630\u0631",
    "\u062F\u06CC",
    "\u0628\u0647\u0645\u0646",
    "\u0627\u0633\u0641\u0646\u062F"
];
const $d9dd19094c9f758e$var$DAY_NAMES = [
    "\u0634",
    "\u06CC",
    "\u062F",
    "\u0633",
    "\u0686",
    "\u067E",
    "\u062C"
];
const $d9dd19094c9f758e$var$toFa = (n)=>String(n).replace(/\d/g, (d)=>"\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9"[d]);
const $d9dd19094c9f758e$var$pad2 = (n)=>String(n).padStart(2, '0');
// ── Jalali math (works for years 1300–1500) ───────────────────────────────────
function $d9dd19094c9f758e$var$jIsLeap(y) {
    return (y * 8 + 29) % 33 < 8;
}
function $d9dd19094c9f758e$var$jMonthDays(y, m) {
    if (m <= 6) return 31;
    if (m <= 11) return 30;
    return $d9dd19094c9f758e$var$jIsLeap(y) ? 30 : 29;
}
// Anchor: 1400/01/01 = 2021-03-21 UTC. Works backward too.
function $d9dd19094c9f758e$var$jalaliToMs(jy, jm, jd) {
    const anchor = Date.UTC(2021, 2, 21);
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $d9dd19094c9f758e$var$jIsLeap(jy) ? 30 : 29
    ];
    let doy = jd - 1;
    for(let i = 0; i < jm - 1; i++)doy += md[i];
    let days = 0;
    if (jy >= 1400) for(let y = 1400; y < jy; y++)days += $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
    else for(let y = jy; y < 1400; y++)days -= $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
    return anchor + (days + doy) * 86400000;
}
function $d9dd19094c9f758e$var$msToJalali(ms) {
    const anchor = Date.UTC(2021, 2, 21);
    let days = Math.floor((ms - anchor) / 86400000);
    let y = 1400;
    if (days >= 0) while(true){
        const diy = $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
        if (days < diy) break;
        days -= diy;
        y++;
    }
    else while(days < 0){
        y--;
        days += $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
    }
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $d9dd19094c9f758e$var$jIsLeap(y) ? 30 : 29
    ];
    let m = 0;
    while(m < 11 && days >= md[m]){
        days -= md[m];
        m++;
    }
    return {
        y: y,
        m: m + 1,
        d: days + 1
    };
}
function $d9dd19094c9f758e$var$getTodayJalali() {
    return $d9dd19094c9f758e$var$msToJalali(Date.now());
}
function $d9dd19094c9f758e$var$gregorianToJalali(str) {
    if (!str || str.length < 10) return null;
    const [y, m, d] = str.split('-').map(Number);
    if (!y || !m || !d) return null;
    return $d9dd19094c9f758e$var$msToJalali(Date.UTC(y, m - 1, d));
}
function $d9dd19094c9f758e$var$jalaliToGregorian(jy, jm, jd) {
    const ms = $d9dd19094c9f758e$var$jalaliToMs(jy, jm, jd);
    const dt = new Date(ms);
    return [
        dt.getUTCFullYear(),
        String(dt.getUTCMonth() + 1).padStart(2, '0'),
        String(dt.getUTCDate()).padStart(2, '0')
    ].join('-');
}
function $d9dd19094c9f758e$export$565a3e0423f3fda3(value) {
    const s = String(value || '').trim();
    if (!s) return {
        date: '',
        time: ''
    };
    const [date, rest = ''] = s.split(/[T\s]+/);
    const t = rest.match(/^(\d{1,2}):(\d{1,2})/);
    return {
        date: date,
        time: t ? `${$d9dd19094c9f758e$var$pad2(+t[1])}:${$d9dd19094c9f758e$var$pad2(+t[2])}` : ''
    };
}
function $d9dd19094c9f758e$export$5a5aa410a9e7d978(raw, { withTime: withTime = false, disableFuture: disableFuture = false } = {}) {
    const s = (0, $42e05640dae453c1$export$e6aa7dbb1e28c5bd)(raw ?? '').replace(/[،,]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (!s) return {
        empty: true
    };
    const m = s.match(/^(\d{4})\s*[/\-.]\s*(\d{1,2})\s*[/\-.]\s*(\d{1,2})(?:[ T]+(\d{1,2})\s*[:.]\s*(\d{1,2}))?$/);
    if (!m) return {
        error: 'format'
    };
    const y = +m[1], mo = +m[2], d = +m[3];
    if (y < 1300 || y > 1500) return {
        error: 'range'
    };
    if (mo < 1 || mo > 12) return {
        error: 'range'
    };
    if (d < 1 || d > $d9dd19094c9f758e$var$jMonthDays(y, mo)) return {
        error: 'range'
    };
    const hasTime = m[4] !== undefined;
    let hh = 0, mi = 0;
    if (hasTime) {
        if (!withTime) return {
            error: 'noTime'
        };
        hh = +m[4];
        mi = +m[5];
        if (hh > 23 || mi > 59) return {
            error: 'time'
        };
    }
    if (disableFuture) {
        const t = $d9dd19094c9f758e$var$getTodayJalali();
        if ($d9dd19094c9f758e$var$jalaliToMs(y, mo, d) > $d9dd19094c9f758e$var$jalaliToMs(t.y, t.m, t.d)) return {
            error: 'future'
        };
    }
    const date = $d9dd19094c9f758e$var$jalaliToGregorian(y, mo, d);
    return {
        j: {
            y: y,
            m: mo,
            d: d
        },
        hh: hh,
        mi: mi,
        hasTime: hasTime,
        value: withTime ? `${date} ${$d9dd19094c9f758e$var$pad2(hh)}:${$d9dd19094c9f758e$var$pad2(mi)}` : date
    };
}
function $d9dd19094c9f758e$export$544b31198dd3053c(value, { withTime: withTime = false } = {}) {
    const { date: date, time: time } = $d9dd19094c9f758e$export$565a3e0423f3fda3(value);
    const j = $d9dd19094c9f758e$var$gregorianToJalali(date);
    if (!j) return '';
    const base = `${j.y}/${$d9dd19094c9f758e$var$pad2(j.m)}/${$d9dd19094c9f758e$var$pad2(j.d)}`;
    return $d9dd19094c9f758e$var$toFa(withTime ? `${base} ${time || '00:00'}` : base);
}
const $d9dd19094c9f758e$var$INPUT_ERRORS = {
    format: "\u0642\u0627\u0644\u0628 \u062A\u0627\u0631\u06CC\u062E: \u06F1\u06F4\u06F0\u06F4/\u06F0\u06F5/\u06F1\u06F2",
    range: "\u062A\u0627\u0631\u06CC\u062E \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
    time: "\u0633\u0627\u0639\u062A \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
    noTime: "\u0627\u06CC\u0646 \u0641\u06CC\u0644\u062F \u0633\u0627\u0639\u062A \u0646\u0645\u06CC\u200C\u067E\u0630\u06CC\u0631\u062F",
    future: "\u062A\u0627\u0631\u06CC\u062E \u0622\u06CC\u0646\u062F\u0647 \u0645\u062C\u0627\u0632 \u0646\u06CC\u0633\u062A"
};
function $d9dd19094c9f758e$var$buildGrid(y, m) {
    const days = $d9dd19094c9f758e$var$jMonthDays(y, m);
    const firstMs = $d9dd19094c9f758e$var$jalaliToMs(y, m, 1);
    const offset = (new Date(firstMs).getUTCDay() + 1) % 7; // 0=Sat…6=Fri
    const cells = [
        ...Array(offset).fill(null),
        ...Array.from({
            length: days
        }, (_, i)=>i + 1)
    ];
    while(cells.length % 7)cells.push(null);
    const grid = [];
    for(let i = 0; i < cells.length; i += 7)grid.push(cells.slice(i, i + 7));
    return grid;
}
// ── Sub-components ────────────────────────────────────────────────────────────
const $d9dd19094c9f758e$var$NavBtn = ({ onClick: onClick, children: children, disabled: disabled })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: disabled ? undefined : onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            background: hov && !disabled ? '#e2e8f0' : '#f0f4f8',
            border: 'none',
            borderRadius: 6,
            width: 28,
            height: 28,
            cursor: disabled ? 'default' : 'pointer',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: disabled ? '#c8c8c8' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            flexShrink: 0,
            transition: 'background 0.12s'
        }
    }, children);
};
const $d9dd19094c9f758e$var$ChevR = ({ size: size = 14 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: size,
        height: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
    }));
const $d9dd19094c9f758e$var$ChevL = ({ size: size = 14 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: size,
        height: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }));
const $d9dd19094c9f758e$var$GridCell = ({ label: label, selected: selected, current: current, disabled: disabled, onClick: onClick })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    let bg = hov && !disabled ? '#e2e8f0' : '#f8fafc';
    let color = disabled ? '#c8c8c8' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary;
    let fw = 400;
    if (selected && !disabled) {
        bg = (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy;
        color = 'white';
        fw = 700;
    } else if (current && !disabled) {
        bg = '#EAF4FC';
        color = (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy;
        fw = 600;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: disabled ? undefined : onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            height: 36,
            borderRadius: 8,
            border: 'none',
            cursor: disabled ? 'default' : 'pointer',
            fontSize: 12,
            fontFamily: 'Meshkat, sans-serif',
            fontWeight: fw,
            background: bg,
            color: color,
            transition: 'background 0.12s'
        }
    }, label);
};
const $d9dd19094c9f758e$var$DayCell = ({ day: day, isToday: isToday, isSel: isSel, disabled: disabled, onClick: onClick })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    if (!day) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null);
    let bg = hov && !disabled ? '#f0f4f8' : 'transparent';
    let color = disabled ? '#d0d0d0' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary;
    let fw = 400;
    if (isSel && !disabled) {
        bg = (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy;
        color = 'white';
        fw = 700;
    } else if (isToday) {
        bg = '#EAF4FC';
        color = (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy;
        fw = 700;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: disabled ? undefined : onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            height: 34,
            borderRadius: 8,
            border: 'none',
            cursor: disabled ? 'default' : 'pointer',
            background: bg,
            color: color,
            fontWeight: fw,
            fontSize: 12,
            fontFamily: 'Meshkat, sans-serif',
            transition: 'background 0.12s'
        }
    }, $d9dd19094c9f758e$var$toFa(day));
};
const $d9dd19094c9f758e$export$9c97d98ce20c6c7a = ({ value: value, onChange: onChange, disableFuture: disableFuture = false })=>{
    const today = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$d9dd19094c9f758e$var$getTodayJalali(), []);
    const [mode, setMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('day'); // 'day' | 'month' | 'year'
    const [viewY, setViewY] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(today.y);
    const [viewM, setViewM] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(today.m);
    const [sel, setSel] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const yrRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null); // scrollable year container
    const yrSelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null); // selected/current year cell
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (value) {
            const j = $d9dd19094c9f758e$var$gregorianToJalali(value);
            if (j) {
                setSel(j);
                setViewY(j.y);
                setViewM(j.m);
                return;
            }
        }
        setSel(null);
    }, [
        value
    ]);
    const changeMonth = (delta)=>{
        let m = viewM + delta, y = viewY;
        if (m > 12) {
            m = 1;
            y++;
        }
        if (m < 1) {
            m = 12;
            y--;
        }
        setViewM(m);
        setViewY(y);
    };
    const enterYearMode = ()=>setMode('year');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (mode !== 'year') return;
        const t = setTimeout(()=>{
            if (yrSelRef.current && yrRef.current) {
                const el = yrSelRef.current;
                const container = yrRef.current;
                container.scrollTop = el.offsetTop - container.clientHeight / 2 + el.clientHeight / 2;
            }
        }, 30);
        return ()=>clearTimeout(t);
    }, [
        mode
    ]);
    const selectDay = (d)=>{
        if (!d) return;
        setSel({
            y: viewY,
            m: viewM,
            d: d
        });
        onChange($d9dd19094c9f758e$var$jalaliToGregorian(viewY, viewM, d));
        setMode('day');
    };
    // disableFuture checks
    const yearDisabled = (y)=>disableFuture && y > today.y;
    const monthDisabled = (y, m)=>disableFuture && (y > today.y || y === today.y && m > today.m);
    const dayDisabled = (d)=>{
        if (!disableFuture || !d) return false;
        if (viewY > today.y) return true;
        if (viewY === today.y && viewM > today.m) return true;
        if (viewY === today.y && viewM === today.m && d > today.d) return true;
        return false;
    };
    const grid = $d9dd19094c9f758e$var$buildGrid(viewY, viewM);
    // Shared header label button style
    const labelBtn = (extra)=>({
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif',
            borderRadius: 6,
            padding: '4px 10px',
            ...extra
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, mode === 'year' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            fontSize: 12,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            marginBottom: 10,
            letterSpacing: 1
        }
    }, "\u0627\u0646\u062A\u062E\u0627\u0628 \u0633\u0627\u0644"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: yrRef,
        style: {
            maxHeight: 240,
            overflowY: 'auto',
            paddingLeft: 2,
            paddingRight: 2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 4
        }
    }, Array.from({
        length: disableFuture ? today.y - 1299 : today.y - 1299 + 6
    }, (_, i)=>1300 + i).map((yr)=>{
        const isFocused = yr === (sel?.y ?? today.y);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: yr,
            ref: isFocused ? yrSelRef : null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$GridCell, {
            label: $d9dd19094c9f758e$var$toFa(yr),
            selected: sel ? yr === sel.y : false,
            current: yr === today.y,
            disabled: yearDisabled(yr),
            onClick: ()=>{
                setViewY(yr);
                setMode('month');
            }
        }));
    })))), mode === 'month' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavBtn, {
        onClick: ()=>setViewY((y)=>y + 1),
        disabled: yearDisabled(viewY + 1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevR, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: enterYearMode,
        style: labelBtn({
            fontSize: 15,
            fontWeight: 800,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
        })
    }, $d9dd19094c9f758e$var$toFa(viewY)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavBtn, {
        onClick: ()=>setViewY((y)=>y - 1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevL, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 6
        }
    }, $d9dd19094c9f758e$var$J_MONTHS.map((name, idx)=>{
        const mn = idx + 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$GridCell, {
            key: idx,
            label: name,
            selected: !!(sel && sel.y === viewY && sel.m === mn),
            current: viewY === today.y && mn === today.m,
            disabled: monthDisabled(viewY, mn),
            onClick: ()=>{
                setViewM(mn);
                setMode('day');
            }
        });
    }))), mode === 'day' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 4
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavBtn, {
        onClick: ()=>setViewY((y)=>y + 1),
        disabled: yearDisabled(viewY + 1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevR, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: enterYearMode,
        style: labelBtn({
            fontSize: 13,
            fontWeight: 800,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        })
    }, $d9dd19094c9f758e$var$toFa(viewY)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavBtn, {
        onClick: ()=>setViewY((y)=>y - 1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevL, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavBtn, {
        onClick: ()=>changeMonth(1),
        disabled: monthDisabled(viewM === 12 ? viewY + 1 : viewY, viewM === 12 ? 1 : viewM + 1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevR, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setMode('month'),
        style: labelBtn({
            fontSize: 15,
            fontWeight: 800,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
        })
    }, $d9dd19094c9f758e$var$J_MONTHS[viewM - 1]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavBtn, {
        onClick: ()=>changeMonth(-1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevL, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 1,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
            marginBottom: 10
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            marginBottom: 4
        }
    }, $d9dd19094c9f758e$var$DAY_NAMES.map((d)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: d,
            style: {
                textAlign: 'center',
                fontSize: 11,
                fontWeight: 700,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                padding: '2px 0'
            }
        }, d))), grid.map((week, wi)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: wi,
            style: {
                display: 'grid',
                gridTemplateColumns: 'repeat(7, 1fr)',
                gap: 2
            }
        }, week.map((day, di)=>{
            const isToday = day && viewY === today.y && viewM === today.m && day === today.d;
            const isSel = day && sel && viewY === sel.y && viewM === sel.m && day === sel.d;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$DayCell, {
                key: di,
                day: day,
                isToday: isToday,
                isSel: isSel,
                disabled: dayDisabled(day),
                onClick: ()=>selectDay(day)
            });
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>{
            setViewY(today.y);
            setViewM(today.m);
        },
        style: {
            marginTop: 12,
            width: '100%',
            height: 32,
            background: '#f8fafc',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 8,
            fontSize: 12,
            fontWeight: 600,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, "\u0628\u0631\u0648 \u0628\u0647 \u0627\u0645\u0631\u0648\u0632")));
};
// ── Popup shell ───────────────────────────────────────────────────────────────
// The floating card the calendar sits in, positioned under `anchorRef` (flipping above
// it when the viewport has no room below) and closed by a click anywhere outside both.
// Portaled to <body>: an ancestor with a CSS transform (e.g. a centered DialogContent)
// would otherwise become the containing block of this fixed card and misplace it, and
// an ancestor overflow would clip it. Dialog.jsx whitelists [data-jalali-popup] so the
// portaled card doesn't count as an outside click that dismisses the dialog.
//
// Placement is measured from the card's REAL height, never a guessed constant: the
// calendar is ~380px tall in day mode, so the old `spaceBelow > 320` test opened it
// downward with 60px too little room and the last week of the month fell off the
// bottom of the screen — the exact failure seen with the field low in a tall modal.
// The measured box is then clamped into the viewport on both axes, and re-placed on
// scroll/resize because a field inside a scrollable DialogContent moves under it.
const $d9dd19094c9f758e$var$POPUP_WIDTH = 300;
const $d9dd19094c9f758e$var$POPUP_GAP = 6; // breathing room between the trigger and the card
const $d9dd19094c9f758e$var$POPUP_MARGIN = 8; // never touch the viewport edge
const $d9dd19094c9f758e$export$bb703e6cd16789d6 = ({ anchorRef: anchorRef, onClose: onClose, children: children, width: width = $d9dd19094c9f758e$var$POPUP_WIDTH })=>{
    const cardRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Positions the card by writing to the DOM node rather than through state: this runs
    // from a ResizeObserver (mode switches change the card's height) and from scroll, and
    // a setState there would re-render → re-measure → re-render without ever settling.
    const place = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const card = cardRef.current;
        const anchor = anchorRef.current;
        if (!card || !anchor) return;
        const vh = window.innerHeight;
        const vw = window.innerWidth;
        const maxH = vh - $d9dd19094c9f758e$var$POPUP_MARGIN * 2;
        // Cap first, measure second — otherwise a card taller than the viewport reports a
        // height no placement can satisfy.
        card.style.maxHeight = `${maxH}px`;
        const h = Math.min(card.offsetHeight || 0, maxH);
        const rect = anchor.getBoundingClientRect();
        const roomBelow = vh - rect.bottom - $d9dd19094c9f758e$var$POPUP_GAP - $d9dd19094c9f758e$var$POPUP_MARGIN;
        const roomAbove = rect.top - $d9dd19094c9f758e$var$POPUP_GAP - $d9dd19094c9f758e$var$POPUP_MARGIN;
        // Below by default; flip above only when that side genuinely has more room.
        let top = h <= roomBelow || roomBelow >= roomAbove ? rect.bottom + $d9dd19094c9f758e$var$POPUP_GAP : rect.top - $d9dd19094c9f758e$var$POPUP_GAP - h;
        top = Math.max($d9dd19094c9f758e$var$POPUP_MARGIN, Math.min(top, vh - $d9dd19094c9f758e$var$POPUP_MARGIN - h));
        // RTL: right edges align with the trigger, then clamp so a trigger near either
        // viewport edge can't push the card off-screen.
        let left = rect.right - width;
        left = Math.max($d9dd19094c9f758e$var$POPUP_MARGIN, Math.min(left, vw - $d9dd19094c9f758e$var$POPUP_MARGIN - width));
        card.style.top = `${top}px`;
        card.style.left = `${left}px`;
        card.style.visibility = 'visible';
    }, [
        anchorRef,
        width
    ]);
    // Layout effect, before paint: a card positioned after the fact is a card the user
    // sees jump from the corner of the screen to where it belongs.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        place();
        const onScroll = ()=>place();
        // capture:true — the scroll that matters is usually an ancestor's (the modal body),
        // and scroll events from those don't bubble to window.
        window.addEventListener('scroll', onScroll, true);
        window.addEventListener('resize', place);
        let ro;
        if (typeof ResizeObserver !== 'undefined' && cardRef.current) {
            ro = new ResizeObserver(()=>place());
            ro.observe(cardRef.current);
        }
        return ()=>{
            window.removeEventListener('scroll', onScroll, true);
            window.removeEventListener('resize', place);
            ro?.disconnect();
        };
    }, [
        place
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const h = (e)=>{
            if (cardRef.current?.contains(e.target)) return;
            if (anchorRef.current?.contains(e.target)) return; // the trigger toggles itself
            onClose();
        };
        document.addEventListener('mousedown', h);
        return ()=>document.removeEventListener('mousedown', h);
    }, [
        anchorRef,
        onClose
    ]);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: cardRef,
        "data-jalali-popup": "",
        style: {
            position: 'fixed',
            top: 0,
            left: 0,
            visibility: 'hidden',
            overflowY: 'auto',
            overscrollBehavior: 'contain',
            zIndex: 9999,
            width: width,
            background: 'white',
            borderRadius: 16,
            padding: '16px 14px',
            boxShadow: '0 16px 48px rgba(0,0,0,0.18)',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            direction: 'rtl',
            boxSizing: 'border-box',
            pointerEvents: 'auto'
        }
    }, children), document.body);
};
// ── Time row ──────────────────────────────────────────────────────────────────
// Two spinnable segments under the calendar, shown only when `withTime`. Rendered LTR:
// an "HH:MM" pair inside an RTL paragraph gets its two numeric runs reordered by the
// bidi algorithm, so the minutes would appear where the hours belong.
//
// Steppers, not text boxes, on purpose. The popup is portaled to <body>, so inside a
// modal Radix dialog it sits outside the focus scope and anything focusable in it gets
// focus yanked straight back into the dialog — a text field there could never be typed
// into. Buttons don't need focus to be clicked, and an exact time can always be typed
// into the field itself, which does live inside the dialog.
const $d9dd19094c9f758e$var$StepBtn = ({ onClick: onClick, label: label, children: children })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": label,
        onClick: onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            background: hov ? '#e2e8f0' : 'transparent',
            border: 'none',
            borderRadius: 4,
            width: 26,
            height: 18,
            padding: 0,
            cursor: 'pointer',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background 0.12s'
        }
    }, children);
};
const $d9dd19094c9f758e$var$ChevUp = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "12",
        height: "12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
    }));
const $d9dd19094c9f758e$var$ChevDn = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "12",
        height: "12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 16l6-6-1.41-1.41L12 13.17 7.41 8.59 6 10z"
    }));
const $d9dd19094c9f758e$var$TimeSegment = ({ value: value, onChange: onChange, max: max, step: step, label: label })=>{
    const wrap = (n)=>(n % (max + 1) + max + 1) % (max + 1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "spinbutton",
        "aria-label": label,
        "aria-valuenow": value,
        "aria-valuemin": 0,
        "aria-valuemax": max,
        "aria-valuetext": $d9dd19094c9f758e$var$toFa($d9dd19094c9f758e$var$pad2(value)),
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$StepBtn, {
        label: `${label} \u{628}\u{6CC}\u{634}\u{62A}\u{631}`,
        onClick: ()=>onChange(wrap(value + step))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevUp, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 42,
            height: 30,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 8,
            background: '#f8fafc',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            fontSize: 14,
            fontWeight: 700,
            fontFamily: 'Meshkat, sans-serif',
            boxSizing: 'border-box',
            userSelect: 'none'
        }
    }, $d9dd19094c9f758e$var$toFa($d9dd19094c9f758e$var$pad2(value))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$StepBtn, {
        label: `${label} \u{6A9}\u{645}\u{62A}\u{631}`,
        onClick: ()=>onChange(wrap(value - step))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevDn, null)));
};
const $d9dd19094c9f758e$var$TimeRow = ({ hh: hh, mi: mi, onChange: onChange, minuteStep: minuteStep = 5 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 12,
            paddingTop: 12,
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 12,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            fontFamily: 'Meshkat, sans-serif'
        }
    }, "\u0633\u0627\u0639\u062A"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            direction: 'ltr'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$TimeSegment, {
        label: "\u0633\u0627\u0639\u062A",
        value: hh,
        max: 23,
        step: 1,
        onChange: (h)=>onChange(h, mi)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 14,
            fontWeight: 800,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$TimeSegment, {
        label: "\u062F\u0642\u06CC\u0642\u0647",
        value: mi,
        max: 59,
        step: minuteStep,
        onChange: (m)=>onChange(hh, m)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>{
            const n = new Date();
            onChange(n.getHours(), Math.floor(n.getMinutes() / minuteStep) * minuteStep);
        },
        style: {
            background: '#f8fafc',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 8,
            height: 28,
            padding: '0 10px',
            fontSize: 12,
            fontWeight: 600,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, "\u0627\u06A9\u0646\u0648\u0646"));
// ── Main Component ────────────────────────────────────────────────────────────
// Editable input + the shared calendar. The selected moment lives entirely in `value` —
// the only local copy is `draft`, the half-typed text, which exists exactly while the
// field has focus and is discarded (never committed) if it never parses.
//
// Idle, the field reads «۱۲ مرداد ۱۴۰۴»; focused, it becomes the numeric «۱۴۰۴/۰۵/۱۲»
// the parser round-trips. The input is dir="ltr" so date and time segments keep their
// order — bidi reorders two numeric runs inside an RTL field.
const $d9dd19094c9f758e$var$JalaliDatePicker = ({ value: value, onChange: onChange, placeholder: placeholder = "\u0627\u0646\u062A\u062E\u0627\u0628 \u062A\u0627\u0631\u06CC\u062E", height: height = 44, fontSize: fontSize = 14, disabled: disabled = false, disableFuture: disableFuture = false, withTime: withTime = false, minuteStep: minuteStep = 5, readOnlyInput: readOnlyInput = false, id: // Forwarded to the typeable <input> (v0.16.1), so a FormField label can name it
// (DESIGN_CONCEPT §12.3) and a caller can validate on blur.
id, name: name, onBlur: onBlur, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-describedby': ariaDescribedBy, 'aria-invalid': ariaInvalid, 'data-testid': testId })=>{
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // null ⇒ not typing
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const { date: date, time: time } = $d9dd19094c9f758e$export$565a3e0423f3fda3(value);
    const sel = date ? $d9dd19094c9f758e$var$gregorianToJalali(date) : null;
    const [hh, mi] = time ? time.split(':').map(Number) : [
        0,
        0
    ];
    const prettyVal = sel ? `${$d9dd19094c9f758e$var$toFa(sel.d)} ${$d9dd19094c9f758e$var$J_MONTHS[sel.m - 1]} ${$d9dd19094c9f758e$var$toFa(sel.y)}` + (withTime && time ? ` \u{633}\u{627}\u{639}\u{62A} ${$d9dd19094c9f758e$var$toFa($d9dd19094c9f758e$var$pad2(hh))}:${$d9dd19094c9f758e$var$toFa($d9dd19094c9f758e$var$pad2(mi))}` : '') : '';
    const editable = !disabled && !readOnlyInput;
    const shownText = draft !== null ? draft : prettyVal;
    // The time a with-time field falls back to when a date arrives without one — by
    // picking or by typing, the same either way. Now, rounded down to the step: 00:00 is
    // almost never the moment someone meant, and the result is visible in the field.
    const fallbackTime = ()=>{
        const now = new Date();
        return `${$d9dd19094c9f758e$var$pad2(now.getHours())}:${$d9dd19094c9f758e$var$pad2(Math.floor(now.getMinutes() / minuteStep) * minuteStep)}`;
    };
    const emitDate = (gregorian)=>{
        if (!gregorian) {
            onChange('');
            return;
        }
        if (!withTime) {
            onChange(gregorian);
            setOpen(false);
            return;
        }
        onChange(`${gregorian} ${time || fallbackTime()}`); // popup stays open for the time
    };
    // Setting a time before a day picks today, so the field can never hold a bare time.
    // The draft is dropped: a modal's focus trap can bounce focus back into the field
    // while the popup is used, and a stale half-typed draft would then hide the new time.
    const emitTime = (h, m)=>{
        const t = $d9dd19094c9f758e$var$getTodayJalali();
        const d = date || $d9dd19094c9f758e$var$jalaliToGregorian(t.y, t.m, t.d);
        setDraft(null);
        setError('');
        onChange(`${d} ${$d9dd19094c9f758e$var$pad2(h)}:${$d9dd19094c9f758e$var$pad2(m)}`);
    };
    const handleType = (raw)=>{
        setDraft(raw);
        if (!raw.trim()) {
            setError('');
            if (value) onChange('');
            return;
        }
        const r = $d9dd19094c9f758e$export$5a5aa410a9e7d978(raw, {
            withTime: withTime,
            disableFuture: disableFuture
        });
        if (r.error) {
            setError($d9dd19094c9f758e$var$INPUT_ERRORS[r.error] || $d9dd19094c9f758e$var$INPUT_ERRORS.format);
            return;
        }
        setError('');
        // A date typed with no time keeps the time the field already holds.
        if (withTime && !r.hasTime) onChange(`${r.value.slice(0, 10)} ${time || fallbackTime()}`);
        else onChange(r.value);
    };
    const startEditing = ()=>{
        if (!editable || draft !== null) return;
        setDraft($d9dd19094c9f758e$export$544b31198dd3053c(value, {
            withTime: withTime
        }));
    };
    const commit = ()=>{
        if (draft === null) return;
        setDraft(null); // whatever survived is already in `value`; anything else reverts
        setError('');
    };
    const clearDate = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        setDraft(null);
        setError('');
        onChange('');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: triggerRef,
        onMouseDown: (e)=>{
            // Only the box's own padding — the input and the icons handle their own clicks.
            if (disabled || e.target !== e.currentTarget) return;
            if (editable) {
                e.preventDefault();
                inputRef.current?.focus();
                setOpen(true);
            } else setOpen((o)=>!o);
        },
        style: {
            height: height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 12px',
            gap: 6,
            border: `1.5px solid ${error ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red : open || draft !== null ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 10,
            cursor: disabled ? 'default' : editable ? 'text' : 'pointer',
            background: disabled ? '#f8fafc' : 'white',
            transition: 'border-color 0.18s',
            boxSizing: 'border-box'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: inputRef,
        type: "text",
        id: id,
        name: name,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-describedby": ariaDescribedBy,
        "aria-invalid": ariaInvalid ?? (error ? true : undefined),
        "data-testid": testId,
        // Displayed RTL, edited LTR. «۱۷ مهر ۱۳۶۹» is number/word/number: under an LTR
        // base the day lands on the far left and the whole thing reads backwards. The
        // typed «۱۳۶۹/۰۷/۱۷ ۱۴:۳۰» is the opposite case — two numeric runs that bidi
        // would swap in an RTL field, putting the minutes where the year belongs.
        dir: draft !== null ? 'ltr' : 'rtl',
        value: shownText,
        placeholder: placeholder,
        disabled: disabled,
        readOnly: !editable,
        onFocus: startEditing,
        onClick: ()=>{
            if (disabled) return;
            if (editable) setOpen(true);
            else setOpen((o)=>!o);
        },
        onChange: (e)=>handleType(e.target.value),
        onBlur: (e)=>{
            commit();
            onBlur?.(e);
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter') {
                e.preventDefault();
                commit();
                setOpen(false);
                inputRef.current?.blur();
            } else if (e.key === 'Escape') {
                setDraft(null);
                setError('');
                setOpen(false);
            } else if (e.key === 'ArrowDown' && !open) setOpen(true);
        },
        style: {
            flex: 1,
            minWidth: 0,
            height: '100%',
            border: 'none',
            outline: 'none',
            background: 'transparent',
            padding: 0,
            textAlign: 'right',
            fontSize: fontSize,
            fontFamily: 'Meshkat, sans-serif',
            color: shownText ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            cursor: editable ? 'text' : disabled ? 'default' : 'pointer'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            flexShrink: 0
        }
    }, (sel || draft) && !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u062A\u0627\u0631\u06CC\u062E",
        onMouseDown: clearDate,
        style: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 2,
            borderRadius: 4,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "14",
        height: "14"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": "\u0646\u0645\u0627\u06CC\u0634 \u062A\u0642\u0648\u06CC\u0645",
        onMouseDown: (e)=>{
            e.preventDefault();
            if (!disabled) setOpen((o)=>!o);
        },
        style: {
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: disabled ? 'default' : 'pointer',
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: open ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
        width: "18",
        height: "18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M20 3h-1V1h-2v2H7V1H5v2H4C2.9 5 2 5.9 2 7v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 18H4V8h16v13zM7 10h5v5H7z"
    }))))), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 4,
            fontSize: 11,
            fontWeight: 600,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
            fontFamily: 'Meshkat, sans-serif'
        }
    }, error), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$export$bb703e6cd16789d6, {
        anchorRef: triggerRef,
        onClose: ()=>setOpen(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$export$9c97d98ce20c6c7a, {
        value: date,
        onChange: (v)=>{
            setDraft(null);
            setError('');
            emitDate(v);
        },
        disableFuture: disableFuture
    }), withTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$TimeRow, {
        hh: hh,
        mi: mi,
        minuteStep: minuteStep,
        onChange: emitTime
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>setOpen(false),
        style: {
            marginTop: 10,
            width: '100%',
            height: 34,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            border: 'none',
            borderRadius: 8,
            fontSize: 13,
            fontWeight: 700,
            color: 'white',
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, "\u062A\u0627\u06CC\u06CC\u062F"))));
};
var $d9dd19094c9f758e$export$2e2bcd8739ae039 = $d9dd19094c9f758e$var$JalaliDatePicker;


'use client';
/**
 * DateNavigator — the mobile day stepper (DESIGN-CONCEPT-MOBILE §4): prev/next
 * arrows around a TAPPABLE day label that opens the kit `JalaliCalendar` in a
 * `BottomSheet`. It is the mobile counterpart of the desktop header's
 * `JalaliDatePicker`, and it exists because §4 says arrow-stepping must never
 * be the ONLY path to a date — a doctor looking at next Tuesday should not
 * press an arrow five times.
 *
 * `variant="onGradient"` is the §3.2 "white-alpha inset card": the context
 * widget that lives INSIDE `MobileHeader`'s gradient.
 *
 * Every label is a prop and none is defaulted to Persian. The kit has no
 * translator, the calendar formatting stays with the app (the same rule
 * `TimeRuler.formatTick` and `ChatDayDivider.label` follow), and this component
 * is used by an app that ships in two languages.
 *
 * Props:
 *   value / onChange  — Gregorian 'YYYY-MM-DD', like every kit date component
 *   dateLabel         — the day, formatted by the caller (Jalaali under fa)
 *   subLabel          — optional second line, shown only when `isToday`
 *   isToday           — drives the «back to today» affordance
 *   onPrev / onNext / onToday
 *   prevLabel / nextLabel / pickLabel / todayLabel / sheetTitle — all required
 *                       in practice; they are this component's whole copy
 *   variant           — 'onGradient' (default) | 'plain'
 *   className / data-testid — forwarded to the root
 */ const $e0ac3bcac665682a$var$PREV_GLYPH = {
    transform: 'scaleX(var(--dir-flip, 1))'
};
const $e0ac3bcac665682a$var$NEXT_GLYPH = {
    transform: 'scaleX(calc(var(--dir-flip, 1) * -1))'
};
function $e0ac3bcac665682a$export$2e2bcd8739ae039({ value: value, onChange: onChange, dateLabel: dateLabel, subLabel: subLabel, isToday: isToday = true, onPrev: onPrev, onNext: onNext, onToday: onToday, prevLabel: prevLabel, nextLabel: nextLabel, pickLabel: pickLabel, todayLabel: todayLabel, sheetTitle: sheetTitle, closeLabel: closeLabel, variant: variant = 'onGradient', className: className, 'data-testid': testId = 'date-navigator', ...rest }) {
    const [pickerOpen, setPickerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const onGradient = variant === 'onGradient';
    const arrowClass = onGradient ? 'min-w-11 min-h-11 text-white hover:bg-white/25' : 'min-w-11 min-h-11';
    const arrowStyle = onGradient ? {
        background: 'rgba(255,255,255,0.12)',
        borderRadius: '0.5rem'
    } : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            background: onGradient ? 'rgba(255,255,255,0.12)' : 'transparent',
            borderRadius: '0.75rem',
            padding: '0.375rem 0.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '0.375rem'
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${testId}-prev`,
        "aria-label": prevLabel,
        title: prevLabel,
        className: arrowClass,
        style: arrowStyle,
        onClick: onPrev
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c8dd034124f4eb9$export$2e2bcd8739ae039), {
        size: 18,
        "aria-hidden": true,
        style: $e0ac3bcac665682a$var$PREV_GLYPH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        "data-testid": `${testId}-pick`,
        "aria-label": pickLabel,
        className: onGradient ? 'h-auto min-h-11 gap-1.5 px-2 py-0 text-[0.84375rem] font-bold text-white hover:bg-white/15' : 'h-auto min-h-11 gap-1.5 px-2 py-0 text-[0.84375rem] font-bold',
        onClick: ()=>setPickerOpen(true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5b56343e65588121$export$2e2bcd8739ae039), {
        size: 14,
        style: {
            opacity: 0.7
        },
        "aria-hidden": true
    }), dateLabel), isToday ? subLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: onGradient ? 'rgba(255,255,255,0.6)' : undefined,
            fontSize: '0.6875rem'
        }
    }, subLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        "data-testid": `${testId}-today`,
        className: onGradient ? 'mx-auto block h-auto min-h-0 p-0 text-[0.65625rem] font-semibold text-white/85 hover:bg-transparent hover:text-white' : 'mx-auto block h-auto min-h-0 p-0 text-[0.65625rem] font-semibold',
        onClick: onToday
    }, todayLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${testId}-next`,
        "aria-label": nextLabel,
        title: nextLabel,
        className: arrowClass,
        style: arrowStyle,
        onClick: onNext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c8dd034124f4eb9$export$2e2bcd8739ae039), {
        size: 18,
        "aria-hidden": true,
        style: $e0ac3bcac665682a$var$NEXT_GLYPH
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: pickerOpen,
        onClose: ()=>setPickerOpen(false),
        title: sheetTitle || pickLabel,
        closeLabel: closeLabel,
        "data-testid": `${testId}-sheet`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d9dd19094c9f758e$export$9c97d98ce20c6c7a), {
        value: value,
        onChange: (v)=>{
            setPickerOpen(false);
            if (v) onChange?.(v);
        }
    }), !isToday && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "outline",
        className: "mt-3 w-full min-h-11",
        "data-testid": `${testId}-sheet-today`,
        onClick: ()=>{
            setPickerOpen(false);
            onToday?.();
        }
    }, todayLabel)));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3fbaf9031554177f$export$a2387ed3b5d536eb = {
    name: "check",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M20 6 9 17l-5-5",
                key: "1gmf2c"
            }
        ]
    ]
};
$3fbaf9031554177f$export$a2387ed3b5d536eb.node;
const $3fbaf9031554177f$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($3fbaf9031554177f$export$a2387ed3b5d536eb);





'use client';
function $a1c3a031457b1019$export$2e2bcd8739ae039({ onSave: onSave, onCancel: onCancel, saving: saving = false, saved: saved = false, disabled: disabled = false, sticky: sticky = false, saveLabel: saveLabel = "\u0630\u062E\u06CC\u0631\u0647 \u062A\u063A\u06CC\u06CC\u0631\u0627\u062A", cancelLabel: cancelLabel = "\u0644\u063A\u0648", className: className, style: // Merged OVER the computed layout, the `Card`/messaging-family precedent
// (DESIGN.md). It used to arrive through `...rest`, which is spread after
// `style` — so a caller adding one padding value silently deleted `display`,
// `position` and the safe-area inset and took the whole bar's layout with it.
style, 'data-testid': testId = 'savebar', ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        "data-state": saving ? 'saving' : saved ? 'saved' : 'idle',
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginTop: '1.75rem',
            ...sticky && {
                position: 'sticky',
                bottom: 0,
                marginTop: '1rem',
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                padding: '0.75rem 0 calc(0.75rem + env(safe-area-inset-bottom, 0px))',
                zIndex: 5
            },
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        onClick: onSave,
        disabled: saving || disabled,
        "data-testid": `${testId}-submit`
    }, saving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
        size: 16,
        thickness: 2,
        color: "currentColor"
    }), saved && !saving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3fbaf9031554177f$export$2e2bcd8739ae039), {
        size: 16,
        "aria-hidden": true
    }), saved && !saving ? "\u0630\u062E\u06CC\u0631\u0647 \u0634\u062F" : saveLabel), onCancel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "outline",
        onClick: onCancel,
        disabled: saving,
        "data-testid": `${testId}-cancel`
    }, cancelLabel));
}



var $acw62 = parcelRequire("acw62");

'use client';
function $5f9cbffc25828c55$export$2e2bcd8739ae039({ n: n, title: title, sub: sub, icon: Icon, children: children, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        ...rest,
        style: {
            background: '#fff',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 18,
            boxShadow: '0 1px 2px rgba(22,39,61,.04), 0 8px 24px rgba(22,39,61,.05)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 13,
            padding: '18px 22px 0'
        }
    }, n != null && n !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flexShrink: 0,
            width: 30,
            height: 30,
            borderRadius: '50%',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            color: '#fff',
            fontWeight: 800,
            fontSize: 14,
            display: 'grid',
            placeItems: 'center'
        }
    }, n), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: 16,
            fontWeight: 800,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        }
    }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 17,
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
    }), title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12.5,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: 3
        }
    }, sub))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '18px 22px 22px',
            display: 'flex',
            flexDirection: 'column',
            gap: 16
        }
    }, children));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dc4be5d9d5a360aa$export$a2387ed3b5d536eb = {
    name: "chevron-down",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m6 9 6 6 6-6",
                key: "qrunsl"
            }
        ]
    ]
};
$dc4be5d9d5a360aa$export$a2387ed3b5d536eb.node;
const $dc4be5d9d5a360aa$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($dc4be5d9d5a360aa$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7f8899ae39ae38a1$export$a2387ed3b5d536eb = {
    name: "chevron-up",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m18 15-6-6-6 6",
                key: "153udz"
            }
        ]
    ]
};
$7f8899ae39ae38a1$export$a2387ed3b5d536eb.node;
const $7f8899ae39ae38a1$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($7f8899ae39ae38a1$export$a2387ed3b5d536eb);




'use client';
function $82e7212e133be19c$export$2e2bcd8739ae039({ columns: columns = [], rows: rows = [], rowKey: rowKey, onRowClick: onRowClick, onRowActivate: onRowActivate, rowProps: rowProps, empty: empty, loading: loading = false, skeletonRows: skeletonRows = 6, dense: dense = false, ariaLabel: ariaLabel, caption: caption, sort: sort, onSort: onSort, ...rest }) {
    const rowH = dense ? 44 : 52;
    // Logical, not physical. `'end'` used to resolve to `left`, which is the end
    // of an RTL row and the START of an LTR one — so a numeric column aligned to
    // the wrong edge the moment a table rendered in English.
    const alignOf = (a)=>a === 'center' ? 'center' : a === 'end' ? 'end' : 'start';
    const isEmpty = !loading && rows.length === 0;
    // Placeholder block widths for the loading body, derived from the REAL
    // column widths so a cell's block sits where that column's content will.
    // Without this the blocks cycled a generic width list, and a 70px status
    // column drew a 120px block that the <th> then clipped — the one thing a
    // skeleton exists to avoid. A column with no declared width (the flexible
    // ones, usually the name) keeps the generic rhythm; a percentage width is
    // relative to a table whose pixel size we do not know here, so it falls
    // back too. 60% of the column, because a cell is content plus padding.
    const skeletonWidths = columns.map((col, i)=>{
        const w = col.width;
        const px = typeof w === 'number' ? w : typeof w === 'string' && /^\d+(\.\d+)?px$/.test(w) ? parseFloat(w) : null;
        if (px == null) return [
            120,
            96,
            110,
            84
        ][i % 4];
        return Math.max(32, Math.round(px * 0.6));
    });
    const activate = onRowActivate || null;
    const interactive = !!(activate || onRowClick);
    const headerCell = (col)=>{
        if (!col.sortable || !onSort) return col.header;
        const key = col.sortKey || col.key;
        const active = sort?.key === key;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: ()=>onSort(key),
            className: "inline-flex items-center gap-1 bg-transparent border-0 p-0 cursor-pointer text-inherit hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded",
            style: {
                fontSize: 'inherit',
                fontWeight: 'inherit',
                fontFamily: 'inherit'
            },
            "data-active": active ? 'true' : undefined
        }, col.header, active ? sort.dir === 'asc' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7f8899ae39ae38a1$export$2e2bcd8739ae039), {
            size: 13,
            "aria-hidden": true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dc4be5d9d5a360aa$export$2e2bcd8739ae039), {
            size: 13,
            "aria-hidden": true
        }) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        "data-state": loading ? 'loading' : isEmpty ? 'empty' : 'content',
        "aria-busy": loading ? 'true' : undefined,
        style: {
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: '100%',
            overflowX: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        "aria-label": caption ? undefined : ariaLabel,
        style: {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: 13.5
        }
    }, caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("caption", {
        style: {
            captionSide: 'top',
            textAlign: 'start',
            padding: '0 14px 8px',
            fontSize: 12.5,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
        }
    }, caption), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, columns.map((col)=>{
        const key = col.sortKey || col.key;
        const active = sort?.key === key;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
            key: col.key,
            scope: "col",
            "aria-sort": !col.sortable || !onSort ? undefined : active ? sort.dir === 'asc' ? 'ascending' : 'descending' : 'none',
            style: {
                position: 'sticky',
                top: 0,
                zIndex: 1,
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                fontWeight: 700,
                fontSize: 12.5,
                textAlign: alignOf(col.align),
                padding: '10px 14px',
                borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                width: col.width,
                whiteSpace: 'nowrap'
            }
        }, headerCell(col));
    }))), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, Array.from({
        length: skeletonRows
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8bbcb87f63697989), {
            key: i,
            cols: columns.length,
            widths: skeletonWidths,
            dense: dense
        }))), !loading && !isEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, rows.map((row, i)=>{
        const extra = rowProps ? rowProps(row, i) || {} : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: rowKey ? rowKey(row, i) : row.id ?? i,
            onClick: interactive ? ()=>(activate || onRowClick)(row) : undefined,
            // Hover and focus are CSS states. The onMouseEnter/onMouseLeave
            // pair this replaces mutated inline styles — which §1.3 forbids,
            // and which left a row stuck highlighted whenever the pointer
            // left during a re-render.
            className: interactive ? 'transition-colors hover:bg-muted focus-visible:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring' : undefined,
            ...activate ? {
                tabIndex: 0,
                role: 'link',
                onKeyDown: (e)=>{
                    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                        e.preventDefault();
                        activate(row);
                    }
                }
            } : null,
            ...extra,
            style: {
                height: rowH,
                cursor: interactive ? 'pointer' : 'default',
                ...extra.style
            }
        }, columns.map((col)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
                key: col.key,
                style: {
                    textAlign: alignOf(col.align),
                    padding: '8px 14px',
                    borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                    verticalAlign: 'middle'
                }
            }, col.render ? col.render(row, i) : row[col.key])));
    })))), isEmpty && empty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, empty) : null);
}



var $acw62 = parcelRequire("acw62");

'use client';
function $24dfcaee8d76ee07$export$2e2bcd8739ae039({ options: options = [], value: value, onChange: onChange, size: size = 'md', semantics: semantics = 'tabs', ariaLabel: ariaLabel, ...rest }) {
    const h = size === 'lg' ? 44 : size === 'sm' ? 32 : 36;
    const isFilter = semantics === 'filter';
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const move = (delta)=>{
        const enabled = options.filter((o)=>!o.disabled);
        if (!enabled.length) return;
        const at = enabled.findIndex((o)=>o.value === value);
        const next = enabled[(at + delta + enabled.length) % enabled.length];
        if (next) onChange?.(next.value);
    };
    const onKeyDown = (e)=>{
        if (![
            'ArrowLeft',
            'ArrowRight',
            'Home',
            'End'
        ].includes(e.key)) return;
        e.preventDefault();
        if (e.key === 'Home' || e.key === 'End') {
            const enabled = options.filter((o)=>!o.disabled);
            const target = e.key === 'Home' ? enabled[0] : enabled[enabled.length - 1];
            if (target) onChange?.(target.value);
            return;
        }
        // Direction from the DOM, not an assumption: the visual "next" option is on
        // the left in an RTL group and on the right in an LTR one.
        const rtl = ref.current ? getComputedStyle(ref.current).direction === 'rtl' : true;
        const forward = rtl ? e.key === 'ArrowLeft' : e.key === 'ArrowRight';
        move(forward ? 1 : -1);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        ref: ref,
        role: isFilter ? 'radiogroup' : 'tablist',
        "aria-label": ariaLabel,
        onKeyDown: onKeyDown,
        style: {
            display: 'inline-flex',
            gap: 4,
            padding: 4,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            borderRadius: 12,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        }
    }, options.map((opt)=>{
        const active = opt.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: opt.value,
            type: "button",
            role: isFilter ? 'radio' : 'tab',
            ...isFilter ? {
                'aria-checked': active
            } : {
                'aria-selected': active
            },
            // Roving tabindex: the group is ONE tab stop and the arrows move
            // inside it. Without this every option is its own stop, so tabbing
            // past a six-option filter takes six presses.
            tabIndex: active ? 0 : -1,
            disabled: opt.disabled,
            "data-state": active ? 'active' : 'inactive',
            onClick: ()=>!opt.disabled && onChange?.(opt.value),
            className: "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
            style: {
                height: h,
                padding: size === 'sm' ? '0 12px' : '0 16px',
                border: 'none',
                cursor: opt.disabled ? 'not-allowed' : 'pointer',
                borderRadius: 9,
                fontSize: size === 'sm' ? 12.5 : 13.5,
                fontWeight: 700,
                fontFamily: 'inherit',
                background: active ? '#fff' : 'transparent',
                color: active ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                boxShadow: active ? '0 1px 3px rgba(22,39,61,.12)' : 'none',
                opacity: opt.disabled ? 0.5 : 1,
                transition: 'all .15s',
                whiteSpace: 'nowrap'
            }
        }, opt.label);
    }));
}



var $acw62 = parcelRequire("acw62");

'use client';
const $7bca3244df749c49$var$faNum = (n)=>Number(n).toLocaleString('fa-IR', {
        useGrouping: false
    });
function $7bca3244df749c49$export$2e2bcd8739ae039({ page: page = 1, pageCount: pageCount, total: total, pageSize: pageSize = 20, onChange: onChange, prevLabel: prevLabel = "\u0642\u0628\u0644\u06CC", nextLabel: nextLabel = "\u0628\u0639\u062F\u06CC", pageLabel: pageLabel = (current, pages)=>`\u{635}\u{641}\u{62D}\u{647} ${current} \u{627}\u{632} ${pages}`, formatNumber: formatNumber = $7bca3244df749c49$var$faNum }) {
    const pages = pageCount ?? Math.max(1, Math.ceil((total || 0) / pageSize));
    if (pages <= 1) return null;
    const go = (p)=>{
        if (p >= 1 && p <= pages && p !== page) onChange?.(p);
    };
    const btn = (label, target, disabled)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            onClick: ()=>go(target),
            disabled: disabled,
            style: {
                minWidth: 34,
                height: 34,
                padding: '0 10px',
                borderRadius: 9,
                border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                background: '#fff',
                cursor: disabled ? 'default' : 'pointer',
                color: disabled ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                fontFamily: 'inherit',
                fontSize: 13,
                opacity: disabled ? 0.5 : 1
            }
        }, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            padding: '12px 0'
        }
    }, btn(prevLabel, page - 1, page <= 1), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-live": "polite",
        style: {
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            fontWeight: 600,
            padding: '0 6px'
        }
    }, pageLabel(formatNumber(page), formatNumber(pages))), btn(nextLabel, page + 1, page >= pages));
}



var $acw62 = parcelRequire("acw62");


'use client';
function $ab3d370aebf1b917$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, title: title, description: description, confirmLabel: confirmLabel = "\u062A\u0623\u06CC\u06CC\u062F", cancelLabel: cancelLabel = "\u0627\u0646\u0635\u0631\u0627\u0641", destructive: destructive = false, loading: loading = false, confirmDisabled: confirmDisabled = false, onConfirm: onConfirm, children: children, confirmTestId: confirmTestId, cancelTestId: cancelTestId, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
        open: open,
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
        size: "sm",
        showClose: false,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$742513523b177e3b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$16f7638e4a34b909), null, title)), typeof description === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "text-sm text-muted-foreground leading-6"
    }, description) : description || null, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "mt-4"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$7bbfb2d443473050), {
        className: "mt-6 flex gap-2 justify-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: destructive ? 'destructive' : 'default',
        disabled: loading || confirmDisabled,
        onClick: onConfirm,
        "data-testid": confirmTestId
    }, confirmLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "outline",
        disabled: loading,
        autoFocus: true,
        onClick: ()=>onOpenChange?.(false),
        "data-testid": cancelTestId
    }, cancelLabel))));
}



var $acw62 = parcelRequire("acw62");

'use client';
/**
 * Inline alert / callout banner (zone ②). Tokened bg/ink per variant — never raw hex.
 *
 * Props:
 *   variant  — 'info' | 'success' | 'warning' | 'error' | 'neutral'
 *   title    — optional bold lead line
 *   icon     — optional leading lucide node
 *   action   — optional trailing node (e.g. a Button)
 *   children — body content
 */ const $35331361c3270146$var$VARIANT = {
    info: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk
    },
    success: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk
    },
    warning: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk
    },
    error: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk
    },
    neutral: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
    }
};
function $35331361c3270146$export$2e2bcd8739ae039({ variant: variant = 'info', title: title, icon: icon, action: action, children: children, style: style, ...rest }) {
    const v = $35331361c3270146$var$VARIANT[variant] || $35331361c3270146$var$VARIANT.info;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            background: v.bg,
            color: v.ink,
            padding: '11px 16px',
            borderRadius: 12,
            fontSize: 13,
            ...style
        }
    }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            flexShrink: 0
        }
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 700,
            marginBottom: children ? 4 : 0
        }
    }, title), children), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0
        }
    }, action));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f66de94054a4f331$export$a2387ed3b5d536eb = {
    name: "triangle-alert",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
                key: "wmoenq"
            }
        ],
        [
            "path",
            {
                d: "M12 9v4",
                key: "juzpu7"
            }
        ],
        [
            "path",
            {
                d: "M12 17h.01",
                key: "p32p05"
            }
        ]
    ],
    aliases: [
        "alert-triangle"
    ]
};
$f66de94054a4f331$export$a2387ed3b5d536eb.node;
const $f66de94054a4f331$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($f66de94054a4f331$export$a2387ed3b5d536eb);




'use client';
function $3cbee9b1abdcb86a$export$2e2bcd8739ae039({ icon: icon, title: title = "\u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A", description: description, onRetry: onRetry, retryLabel: retryLabel = "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F", fill: fill = false, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        "data-state": "error",
        style: {
            textAlign: 'center',
            padding: '60px 20px',
            ...fill && {
                flex: 1,
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            },
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'inline-flex',
            marginBottom: 16,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red
        }
    }, icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f66de94054a4f331$export$2e2bcd8739ae039), {
        size: 44
    })), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 18,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            marginBottom: 8
        }
    }, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginBottom: 16
        }
    }, description), onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "outline",
        onClick: onRetry
    }, retryLabel));
}



var $acw62 = parcelRequire("acw62");


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// The one shell every whole-page system state renders through: 404, 403, the
// crash recovery page, maintenance, the cold offline boot, session expiry.
//
// Why one component rather than six designs: these screens are, by definition,
// the moments a user is already unsure whether the app is working. Six
// different layouts for six different faults reads as six different kinds of
// broken. One recognisable shape — icon, one-line verdict, one-line advice, a
// primary action — makes an unexpected page legible as "the app is telling me
// something", which is exactly the reassurance the situation needs.
//
// The shape is deliberately NOT the framework's `EmptyState`. An empty state
// says «there is nothing here yet» inside a working screen and must stay quiet;
// a system state says «something is wrong» and owns the viewport. Collapsing
// them is how a failed load ends up looking like a successful load of nothing.
//
// DESIGN COMPLIANCE — this page is not a special case:
//   • sizes and weights are the documented type roles (hero / metric / body /
//     caption). The kit cannot import an app's `type` module, so the values are
//     inlined with the role named beside them — never a size chosen for this
//     component alone,
//   • radius and elevation from RADIUS/SHADOW, so the card matches every other
//     card rather than being 2px rounder,
//   • actions are the kit `Button` — the app has seven button variants and a
//     hand-rolled one here would be an eighth,
//   • colours from `C`, never literal hex, so an accent preset reaches this
//     page too.
// ─────────────────────────────────────────────────────────────────────────────
/**
 * Tone drives the icon disc only, never the page. A red wash behind a 404 would
 * make a mistyped URL look like a clinical incident.
 */ const $46e1ac2ff7a7c6a8$var$TONES = {
    neutral: ()=>({
            fg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            bg: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted, 0.1)
        }),
    info: ()=>({
            fg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            bg: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.1)
        }),
    warning: ()=>({
            fg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amber,
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amberLight
        }),
    danger: ()=>({
            fg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).redLight
        })
};
// The disc matches ErrorState's, so the inline and full-page failures read as
// one family seen at two sizes.
const $46e1ac2ff7a7c6a8$var$DISC = 56;
// The documented type roles, at their default-setting values. The kit cannot
// import an app's `constants/typography`, so the scale is restated here rather
// than sizes being invented per component — spread it exactly as an app spreads
// `type.*`, and the two surfaces stay identical.
const $46e1ac2ff7a7c6a8$var$TYPE = {
    hero: {
        fontSize: '2.25rem',
        fontWeight: 800,
        lineHeight: 1.05
    },
    metric: {
        fontSize: '1.1875rem',
        fontWeight: 800,
        lineHeight: 1.2
    },
    body: {
        fontSize: '0.8125rem',
        fontWeight: 500,
        lineHeight: 1.85
    },
    caption: {
        fontSize: '0.6875rem',
        fontWeight: 600,
        lineHeight: 1.4
    }
};
function $46e1ac2ff7a7c6a8$export$2e2bcd8739ae039({ tone: tone = 'neutral', icon: icon, code: code, title: title, body: body, detail: detail, actions: actions = [], children: children, footer: footer, fullscreen: fullscreen = false, testId: testId = 'system-page' }) {
    const palette = ($46e1ac2ff7a7c6a8$var$TONES[tone] || $46e1ac2ff7a7c6a8$var$TONES.neutral)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-system-state": tone,
        role: "alert",
        // `polite`, not `assertive`: the page has already replaced everything the
        // user was looking at, so the screen reader does not also need to
        // interrupt itself mid-sentence to say so.
        "aria-live": "polite",
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: fullscreen ? undefined : 1,
            width: fullscreen ? '100vw' : '100%',
            height: fullscreen ? '100vh' : '100%',
            minHeight: fullscreen ? undefined : '20rem',
            padding: '2rem 1.25rem',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            boxSizing: 'border-box'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
            padding: '2.5rem 2rem 2rem',
            maxWidth: '28.75rem',
            width: '100%',
            textAlign: 'center',
            position: 'relative',
            overflow: 'hidden',
            boxShadow: (0, $e7c165fb515b04ea$export$98b6069deb71e13e).card
        }
    }, code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.hero,
            position: 'absolute',
            top: '-0.5rem',
            insetInlineStart: '0.875rem',
            color: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted, 0.09),
            userSelect: 'none',
            direction: 'ltr',
            pointerEvents: 'none'
        }
    }, code), icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: $46e1ac2ff7a7c6a8$var$DISC,
            height: $46e1ac2ff7a7c6a8$var$DISC,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill,
            background: palette.bg,
            color: palette.fg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1rem',
            position: 'relative'
        }
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.metric,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            marginBottom: '0.5rem'
        }
    }, title), body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.body,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            marginBottom: '1.25rem'
        }
    }, body), children, detail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testId}-detail`,
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.caption,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            direction: 'ltr',
            textAlign: 'left',
            fontFamily: 'monospace',
            wordBreak: 'break-word',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip,
            padding: '0.5rem 0.625rem',
            margin: '0 0 1.25rem',
            maxHeight: '7.5rem',
            overflow: 'auto'
        }
    }, detail), actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: actions.length > 2 ? 'column' : 'row',
            gap: '0.625rem',
            justifyContent: 'center'
        }
    }, actions.map((action, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($46e1ac2ff7a7c6a8$var$SystemAction, {
            key: action.key || action.label || i,
            ...action,
            // The first action is the recommended one unless a caller says
            // otherwise — a system page with two equally-weighted buttons
            // makes the user decide something they have no basis to decide.
            variant: action.variant || (i === 0 ? 'primary' : 'secondary')
        }))), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.caption,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: '1.25rem',
            lineHeight: 1.8
        }
    }, footer)));
}
// The two roles a system page offers map onto kit variants: `default` (the
// navy fill) for the recommended action, `outline` for the alternative. The
// prop names stay primary/secondary because that is what the CALLER is
// choosing — an intent, not a paint job — and it keeps the call sites readable.
const $46e1ac2ff7a7c6a8$var$VARIANT_MAP = {
    primary: 'default',
    secondary: 'outline',
    ghost: 'ghost'
};
function $46e1ac2ff7a7c6a8$var$SystemAction({ label: label, onClick: onClick, href: href, variant: variant, testId: testId }) {
    const kitVariant = $46e1ac2ff7a7c6a8$var$VARIANT_MAP[variant] || 'outline';
    // `asChild` renders the anchor with the button's styling, so a link action is
    // visually identical to a button one instead of being a hand-styled <a>.
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        asChild: true,
        variant: kitVariant,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: href
    }, label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        type: "button",
        variant: kitVariant,
        onClick: onClick,
        "data-testid": testId
    }, label);
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b5539f6bdf6973c1$export$a2387ed3b5d536eb = {
    name: "octagon-alert",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 16h.01",
                key: "1drbdi"
            }
        ],
        [
            "path",
            {
                d: "M12 8v4",
                key: "1got3b"
            }
        ],
        [
            "path",
            {
                d: "M15.312 2a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z",
                key: "1fd625"
            }
        ]
    ],
    aliases: [
        "alert-octagon"
    ]
};
$b5539f6bdf6973c1$export$a2387ed3b5d536eb.node;
const $b5539f6bdf6973c1$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($b5539f6bdf6973c1$export$a2387ed3b5d536eb);



'use client';
class $10231e94a06472aa$export$7583e06808a373a5 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, info) {
        // Keep the component stack. `error.stack` points at the component that
        // threw, not the tree that rendered it — and for a shared primitive
        // (Button, Card) the latter is the only part identifying WHICH screen is
        // broken.
        // eslint-disable-next-line no-console
        console.error('[ErrorBoundary]', error, info?.componentStack);
        this.props.onError?.(error, info);
    }
    componentDidUpdate(prevProps) {
        if (this.state.error && prevProps.resetKey !== this.props.resetKey) this.setState({
            error: null
        });
    }
    reset = ()=>this.setState({
            error: null
        });
    render() {
        if (!this.state.error) return this.props.children;
        return this.props.renderFallback(this.state.error, this.reset);
    }
}
function $10231e94a06472aa$export$2e2bcd8739ae039({ children: children, resetKey: resetKey, title: title = "\u0627\u06CC\u0646 \u0635\u0641\u062D\u0647 \u0628\u0627\u0632 \u0646\u0634\u062F", body: body = "\u0647\u0646\u06AF\u0627\u0645 \u0646\u0645\u0627\u06CC\u0634 \u0627\u06CC\u0646 \u0635\u0641\u062D\u0647 \u062E\u0637\u0627\u06CC\u06CC \u0631\u062E \u062F\u0627\u062F.", retryLabel: retryLabel = "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F", showRetry: showRetry = true, actions: actions = [], footer: footer, fullscreen: fullscreen = false, onError: onError, testId: testId = 'error-boundary' }) {
    const renderFallback = (error, reset)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $46e1ac2ff7a7c6a8$export$2e2bcd8739ae039), {
            testId: testId,
            tone: "danger",
            fullscreen: fullscreen,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b5539f6bdf6973c1$export$2e2bcd8739ae039), {
                size: 30,
                strokeWidth: 2,
                "aria-hidden": true
            }),
            title: title,
            body: body,
            // The message, not the stack: a user cannot read a stack, and the message
            // is the part that lets support reproduce it. The stack is in the console
            // for whoever goes looking.
            detail: error?.message || String(error),
            actions: [
                ...showRetry ? [
                    {
                        key: 'retry',
                        label: retryLabel,
                        onClick: reset,
                        variant: 'primary',
                        testId: `${testId}-retry`
                    }
                ] : [],
                ...actions
            ],
            footer: footer
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($10231e94a06472aa$export$7583e06808a373a5, {
        resetKey: resetKey,
        renderFallback: renderFallback,
        onError: onError
    }, children);
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $07c0fad7e9511576$export$a2387ed3b5d536eb = {
    name: "cloud-off",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10.94 5.274A7 7 0 0 1 15.71 10h1.79a4.5 4.5 0 0 1 4.222 6.057",
                key: "1uxyv8"
            }
        ],
        [
            "path",
            {
                d: "M18.796 18.81A4.5 4.5 0 0 1 17.5 19H9A7 7 0 0 1 5.79 5.78",
                key: "99tcn7"
            }
        ],
        [
            "path",
            {
                d: "m2 2 20 20",
                key: "1ooewy"
            }
        ]
    ]
};
$07c0fad7e9511576$export$a2387ed3b5d536eb.node;
const $07c0fad7e9511576$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($07c0fad7e9511576$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $96b330d9ae0cfa5e$export$a2387ed3b5d536eb = {
    name: "refresh-cw",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
                key: "v9h5vc"
            }
        ],
        [
            "path",
            {
                d: "M21 3v5h-5",
                key: "1q7to0"
            }
        ],
        [
            "path",
            {
                d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
                key: "3uifl3"
            }
        ],
        [
            "path",
            {
                d: "M8 16H3v5",
                key: "1cv678"
            }
        ]
    ]
};
$96b330d9ae0cfa5e$export$a2387ed3b5d536eb.node;
const $96b330d9ae0cfa5e$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($96b330d9ae0cfa5e$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f44aa7a4ced52702$export$a2387ed3b5d536eb = {
    name: "wifi",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 20h.01",
                key: "zekei9"
            }
        ],
        [
            "path",
            {
                d: "M2 8.82a15 15 0 0 1 20 0",
                key: "dnpr2z"
            }
        ],
        [
            "path",
            {
                d: "M5 12.859a10 10 0 0 1 14 0",
                key: "1x1e6c"
            }
        ],
        [
            "path",
            {
                d: "M8.5 16.429a5 5 0 0 1 7 0",
                key: "1bycff"
            }
        ]
    ]
};
$f44aa7a4ced52702$export$a2387ed3b5d536eb.node;
const $f44aa7a4ced52702$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($f44aa7a4ced52702$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $34b17daf5c0ea500$export$a2387ed3b5d536eb = {
    name: "wifi-off",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 20h.01",
                key: "zekei9"
            }
        ],
        [
            "path",
            {
                d: "M8.5 16.429a5 5 0 0 1 7 0",
                key: "1bycff"
            }
        ],
        [
            "path",
            {
                d: "M5 12.859a10 10 0 0 1 5.17-2.69",
                key: "1dl1wf"
            }
        ],
        [
            "path",
            {
                d: "M19 12.859a10 10 0 0 0-2.007-1.523",
                key: "4k23kn"
            }
        ],
        [
            "path",
            {
                d: "M2 8.82a15 15 0 0 1 4.177-2.643",
                key: "1grhjp"
            }
        ],
        [
            "path",
            {
                d: "M22 8.82a15 15 0 0 0-11.288-3.764",
                key: "z3jwby"
            }
        ],
        [
            "path",
            {
                d: "m2 2 20 20",
                key: "1ooewy"
            }
        ]
    ]
};
$34b17daf5c0ea500$export$a2387ed3b5d536eb.node;
const $34b17daf5c0ea500$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($34b17daf5c0ea500$export$a2387ed3b5d536eb);





var $acw62 = parcelRequire("acw62");
// ─────────────────────────────────────────────────────────────────────────────
// The one-way channel from "a request just failed for transport reasons" to
// "the connectivity detector should go and check".
//
// It exists because the two halves cannot import each other. `bffClient` is a
// leaf module with no React in it — deliberately, so it can be used from
// anywhere, including outside a component — while `useOnlineStatus` is a hook.
// Without this the detector would only ever learn about an outage from
// `navigator.onLine`, which is exactly the signal that lies: it reports online
// for a captive portal, a dead VPN, and a firewall that black-holes the BFF.
// Those are the cases the doctor most needs named, because in every one of them
// the laptop insists everything is fine.
//
// Kept as a plain subscriber list rather than an event emitter or a context: it
// carries no payload, has at most one listener (the shell's hook), and must be
// safe to call from a `catch` block during module teardown. There is nothing
// here to configure and nothing to get wrong.
// ─────────────────────────────────────────────────────────────────────────────
const $1ca1f567c505cbd8$var$listeners = new Set();
function $1ca1f567c505cbd8$export$288ba6b4215d30f3(listener) {
    $1ca1f567c505cbd8$var$listeners.add(listener);
    return ()=>$1ca1f567c505cbd8$var$listeners.delete(listener);
}
function $1ca1f567c505cbd8$export$87a8bdb1d0a966cf() {
    for (const listener of $1ca1f567c505cbd8$var$listeners)try {
        listener();
    } catch  {}
}
function $1ca1f567c505cbd8$export$d433e139d37a5376() {
    $1ca1f567c505cbd8$var$listeners.clear();
}


// ─────────────────────────────────────────────────────────────────────────────
// Is the app actually able to reach its backend?
//
// The app had no answer to this at all. A doctor whose Wi-Fi dropped mid-clinic
// saw each screen fail on its own schedule, each with its own error card, none
// of them saying the one thing that explained all of them — and nothing told
// them when it came back, so the habit became "refresh and hope".
//
// `navigator.onLine` alone is not the answer, and the direction of its error
// matters. It is RELIABLE when false (the OS says there is no route to
// anywhere) and near-worthless when true (it means "an interface is up", which
// a captive portal, an expired hotel Wi-Fi login, a VPN drop and a firewall all
// satisfy while dropping every packet to the BFF). So:
//
//   offline  — the browser says so. Trusted immediately, no probe needed.
//   degraded — the browser says we are online but the BFF is not answering.
//              Only entered from real evidence: a request that actually failed,
//              confirmed by a probe. This is the state that catches the captive
//              portal, and it is why a bare `navigator.onLine` hook was not
//              enough.
//   online   — reachable.
//
// The probe is deliberately cheap and deliberately rare: it only runs while
// something is known to be wrong, or once when the browser says the network
// came back. It never polls a healthy connection — a heartbeat that fires all
// day to detect a condition that lasts seconds is a battery cost paid by every
// doctor to benefit none of them.
// ─────────────────────────────────────────────────────────────────────────────
/** The browser's own verdict. Reliable when true, worthless when false — see above. */ const $2a96b0bae45a4311$var$isBrowserOffline = ()=>typeof navigator !== 'undefined' && navigator.onLine === false;
const $2a96b0bae45a4311$export$cd9c3c6bf535afc9 = {
    ONLINE: 'online',
    DEGRADED: 'degraded',
    OFFLINE: 'offline'
};
// Backoff for the recovery probe while disconnected. Starts brisk — most
// outages are a few seconds of a lift or a dead spot, and the doctor should not
// wait a minute to be told they are back — then eases off so a genuinely long
// outage is not a request every two seconds for twenty minutes.
const $2a96b0bae45a4311$var$PROBE_MIN_MS = 3000;
const $2a96b0bae45a4311$var$PROBE_MAX_MS = 30000;
// The probe budget. Much shorter than a real query's: this asks one question
// ("is anything there?") and a slow answer is a no for our purposes.
const $2a96b0bae45a4311$var$PROBE_TIMEOUT_MS = 5000;
/**
 * Ask the BFF whether it is reachable.
 *
 * Sends the smallest legal GraphQL request rather than hitting a health path:
 * the BFF has no unauthenticated health endpoint, and this way the probe
 * traverses exactly the path real queries do — same origin, same proxy, same
 * TLS. Any HTTP response at all counts as reachable, INCLUDING 400 and 401: the
 * question is whether packets arrive, not whether we are welcome. Treating a
 * 401 as "offline" would put a network banner in front of a user whose session
 * simply expired, which is a different problem with different copy.
 */ async function $2a96b0bae45a4311$var$probeBff(url, signal) {
    try {
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: '{__typename}'
            }),
            signal: signal,
            cache: 'no-store'
        });
        return Boolean(res);
    } catch  {
        return false;
    }
}
function $2a96b0bae45a4311$export$a32c5b7f472865fb({ url: url } = {}) {
    const [state, setState] = (0, $acw62.useState)(()=>$2a96b0bae45a4311$var$isBrowserOffline() ? $2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE : $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE);
    // Was the connection ever lost in this session? Drives the transient «اتصال
    // برقرار شد» confirmation — without it, the banner would announce a recovery
    // to every doctor who simply opened the app.
    const [recovered, setRecovered] = (0, $acw62.useState)(false);
    const timerRef = (0, $acw62.useRef)(null);
    const backoffRef = (0, $acw62.useRef)($2a96b0bae45a4311$var$PROBE_MIN_MS);
    const abortRef = (0, $acw62.useRef)(null);
    const stateRef = (0, $acw62.useRef)(state);
    stateRef.current = state;
    const clearTimer = ()=>{
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    };
    const goOnline = (0, $acw62.useCallback)(()=>{
        backoffRef.current = $2a96b0bae45a4311$var$PROBE_MIN_MS;
        clearTimer();
        setState((prev)=>{
            if (prev !== $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE) setRecovered(true);
            return $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE;
        });
    }, []);
    /**
   * Run one probe now and schedule the next if it fails.
   *
   * Exposed as `check` so a failed real request can hand its evidence over
   * rather than making the hook discover the same outage independently.
   */ const check = (0, $acw62.useCallback)(async ()=>{
        if ($2a96b0bae45a4311$var$isBrowserOffline()) {
            setState($2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE);
            return false;
        }
        abortRef.current?.abort();
        const controller = new AbortController();
        abortRef.current = controller;
        const timeout = setTimeout(()=>controller.abort(), $2a96b0bae45a4311$var$PROBE_TIMEOUT_MS);
        const reachable = url ? await $2a96b0bae45a4311$var$probeBff(url, controller.signal) : true;
        clearTimeout(timeout);
        if (reachable) {
            goOnline();
            return true;
        }
        // Re-read the authoritative signal at the moment of the verdict rather than
        // trusting the state we entered with: a probe can outlive the condition that
        // started it, and an in-flight request that resolves after the interface
        // genuinely dropped must not downgrade a true OFFLINE to DEGRADED.
        //
        // The reverse matters more, and is the case the test pins: once the browser
        // reports online again, a failing probe means DEGRADED — there IS a network,
        // the BFF is just not on the other end of it. Keeping OFFLINE sticky here
        // would have described a captive portal as "no internet", which sends the
        // doctor to look at a router that is working perfectly.
        setState($2a96b0bae45a4311$var$isBrowserOffline() ? $2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE : $2a96b0bae45a4311$export$cd9c3c6bf535afc9.DEGRADED);
        clearTimer();
        timerRef.current = setTimeout(check, backoffRef.current);
        backoffRef.current = Math.min(backoffRef.current * 2, $2a96b0bae45a4311$var$PROBE_MAX_MS);
        return false;
    }, [
        goOnline,
        url
    ]);
    /**
   * Report a request that just failed for transport reasons.
   *
   * The distinction that makes this hook trustworthy: we do NOT go straight to
   * `degraded` on one failed request. A single 502 from one flaky upstream is
   * not a connectivity problem, and telling the doctor their connection is down
   * when one panel failed would train them to ignore the banner — which is the
   * whole asset here. The probe is what turns a suspicion into a claim.
   */ const reportFailure = (0, $acw62.useCallback)(()=>{
        if (stateRef.current === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE) check();
    }, [
        check
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleOffline = ()=>{
            // No probe: the browser is authoritative in this direction, and firing a
            // request at a machine with no route just burns a timeout.
            clearTimer();
            abortRef.current?.abort();
            setState($2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE);
        };
        // …and NOT authoritative in the other. 'online' means an interface came up,
        // which a captive portal satisfies. Confirm before claiming recovery.
        const handleOnline = ()=>{
            backoffRef.current = $2a96b0bae45a4311$var$PROBE_MIN_MS;
            check();
        };
        // Coming back to a backgrounded tab is the other moment worth checking: a
        // laptop that slept through a network change reports nothing, and the first
        // thing the doctor does is read a screen full of stale data.
        const handleVisibility = ()=>{
            if (document.visibilityState === 'visible' && stateRef.current !== $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE) check();
        };
        window.addEventListener('offline', handleOffline);
        window.addEventListener('online', handleOnline);
        document.addEventListener('visibilitychange', handleVisibility);
        // The evidence `navigator.onLine` cannot give us: a real request that just
        // failed at the transport layer.
        const unsubscribe = (0, $1ca1f567c505cbd8$export$288ba6b4215d30f3)(reportFailure);
        // A tab that BOOTS offline never fires an event — it was already in that
        // state — so the initial value has to stand on its own, and it does.
        if ($2a96b0bae45a4311$var$isBrowserOffline()) setState($2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE);
        return ()=>{
            window.removeEventListener('offline', handleOffline);
            window.removeEventListener('online', handleOnline);
            document.removeEventListener('visibilitychange', handleVisibility);
            unsubscribe();
            clearTimer();
            abortRef.current?.abort();
        };
    }, [
        check,
        reportFailure
    ]);
    return {
        state: state,
        isOnline: state === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE,
        isOffline: state === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE,
        isDegraded: state === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.DEGRADED,
        recovered: recovered,
        acknowledgeRecovery: (0, $acw62.useCallback)(()=>setRecovered(false), []),
        check: check,
        reportFailure: reportFailure
    };
}
var $2a96b0bae45a4311$export$2e2bcd8739ae039 = $2a96b0bae45a4311$export$a32c5b7f472865fb;


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// The one place the app says «you are not connected».
//
// Without one, a dropped connection produces N independent error cards, one per
// panel, each blaming itself, none of them explaining the others — and no signal
// at all when it comes back, so the user's only strategy is to refresh and see.
//
// Deliberate choices:
//
//   It is a BAR, not a modal or a toast. A modal would block a doctor from
//   reading the notes already on screen, which are still perfectly good and are
//   the most valuable thing in the room during an outage. A toast would vanish
//   while the condition persisted. A bar states an ongoing fact and lets work
//   continue around it.
//
//   It sits at the top and pushes content down rather than floating over it.
//   Overlaying would cover the page header on every screen — which in a
//   clinical app is often the patient's name, not something to hide.
//
//   Recovery is announced ONCE and then disappears on its own. A permanent
//   «متصل» is chrome nobody reads; the useful signal is the transition, and
//   specifically the moment a user can stop wondering whether their last save
//   went through.
// ─────────────────────────────────────────────────────────────────────────────
const $0790d8ae08647dfa$var$RECOVERY_VISIBLE_MS = 4000;
const $0790d8ae08647dfa$var$VARIANTS = {
    [(0, $2a96b0bae45a4311$export$cd9c3c6bf535afc9).OFFLINE]: {
        Icon: (0, $34b17daf5c0ea500$export$2e2bcd8739ae039),
        bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
        fg: '#fff',
        testId: 'connectivity-offline'
    },
    [(0, $2a96b0bae45a4311$export$cd9c3c6bf535afc9).DEGRADED]: {
        Icon: (0, $07c0fad7e9511576$export$2e2bcd8739ae039),
        bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amber,
        // Amber is a light hue; white on it fails contrast. `CT.warnInk` is the
        // ink the kit already pairs with a warning surface — a hand-mixed brown
        // here is how a second, slightly-off warning colour enters a design system.
        fg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk,
        testId: 'connectivity-degraded'
    }
};
function $0790d8ae08647dfa$export$2e2bcd8739ae039({ state: state, recovered: recovered, onAcknowledgeRecovery: onAcknowledgeRecovery, onRetry: onRetry, busy: busy, offlineLabel: offlineLabel = "\u0627\u06CC\u0646\u062A\u0631\u0646\u062A \u0642\u0637\u0639 \u0627\u0633\u062A \u2014 \u062A\u063A\u06CC\u06CC\u0631\u0627\u062A \u062B\u0628\u062A \u0646\u0645\u06CC\u200C\u0634\u0648\u062F", degradedLabel: degradedLabel = "\u0627\u0631\u062A\u0628\u0627\u0637 \u0628\u0627 \u0633\u0631\u0648\u0631 \u0628\u0631\u0642\u0631\u0627\u0631 \u0646\u06CC\u0633\u062A \u2014 \u062F\u0631 \u062D\u0627\u0644 \u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F", restoredLabel: restoredLabel = "\u0627\u062A\u0635\u0627\u0644 \u062F\u0648\u0628\u0627\u0631\u0647 \u0628\u0631\u0642\u0631\u0627\u0631 \u0634\u062F", retryLabel: retryLabel = "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F", busyLabel: busyLabel = "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0631\u0631\u0633\u06CC\u2026" }) {
    const disconnected = state !== (0, $2a96b0bae45a4311$export$cd9c3c6bf535afc9).ONLINE;
    const LABELS = {
        [(0, $2a96b0bae45a4311$export$cd9c3c6bf535afc9).OFFLINE]: offlineLabel,
        [(0, $2a96b0bae45a4311$export$cd9c3c6bf535afc9).DEGRADED]: degradedLabel
    };
    // The recovery bar retires itself. The timer is keyed on the flag so a second
    // outage inside the window restarts it rather than inheriting a stale
    // countdown that would hide the confirmation early.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!recovered || disconnected) return undefined;
        const timer = setTimeout(()=>onAcknowledgeRecovery?.(), $0790d8ae08647dfa$var$RECOVERY_VISIBLE_MS);
        return ()=>clearTimeout(timer);
    }, [
        recovered,
        disconnected,
        onAcknowledgeRecovery
    ]);
    if (disconnected) {
        const variant = $0790d8ae08647dfa$var$VARIANTS[state];
        if (!variant) return null;
        const { Icon: Icon, bg: bg, fg: fg, testId: testId } = variant;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0790d8ae08647dfa$var$Bar, {
            bg: bg,
            fg: fg,
            testId: testId,
            state: state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            size: 15,
            strokeWidth: 2.2,
            "aria-hidden": true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, LABELS[state]), onRetry && // The kit Button at `sm`, not a hand-rolled pill. It sits on a
        // coloured bar rather than the page, so `currentColor` carries the
        // bar's ink through — the only thing the variants cannot know — and
        // height, radius, type, focus ring and disabled state all come from
        // the kit like every other button.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            type: "button",
            size: "sm",
            variant: "ghost",
            onClick: onRetry,
            disabled: busy,
            "data-testid": "connectivity-retry",
            style: {
                marginInlineStart: 'auto',
                color: fg,
                border: '1px solid currentColor',
                background: 'transparent',
                gap: '0.3125rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96b330d9ae0cfa5e$export$2e2bcd8739ae039), {
            size: 12,
            "aria-hidden": true,
            style: busy ? {
                animation: 'connectivity-spin 0.9s linear infinite'
            } : undefined
        }), busy ? busyLabel : retryLabel));
    }
    if (recovered) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0790d8ae08647dfa$var$Bar, {
        bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green,
        fg: "#fff",
        testId: "connectivity-restored",
        state: "restored"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f44aa7a4ced52702$export$2e2bcd8739ae039), {
        size: 15,
        strokeWidth: 2.2,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, restoredLabel));
    return null;
}
function $0790d8ae08647dfa$var$Bar({ bg: bg, fg: fg, testId: testId, state: state, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-connection-state": state,
        role: "status",
        // `polite`, not `assertive`. A user mid-sentence must not have their
        // screen reader interrupted by an infrastructure notice — the connection
        // dropping is not more urgent than what they are writing.
        "aria-live": "polite",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.4375rem 1rem',
            background: bg,
            color: fg,
            fontSize: '0.75rem',
            fontWeight: 600,
            flexShrink: 0,
            zIndex: 40
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, '@keyframes connectivity-spin { to { transform: rotate(360deg) } }'), children);
}



var $acw62 = parcelRequire("acw62");

'use client';
/**
 * Square icon-only button with a ≥44px touch target (mobile-safe) and a required
 * accessible label. `onGradient` variant is the white-alpha control for gradient
 * headers (§3.2). Encapsulates the affordance so screens never hand-roll a raw <button>.
 *
 * Props:
 *   icon     — lucide node (required)
 *   label    — accessible label / tooltip (required)
 *   variant  — 'default' | 'ghost' | 'outline' | 'onGradient'
 *   size     — px (default 44 — the mobile minimum)
 *   onClick, disabled
 */ const $26386601b5f40a7d$var$VARIANT = {
    default: {
        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
        color: '#fff',
        border: 'none'
    },
    ghost: {
        background: 'transparent',
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
        border: 'none'
    },
    outline: {
        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
        border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
    },
    onGradient: {
        background: 'rgba(255,255,255,0.15)',
        color: '#fff',
        border: 'none'
    }
};
function $26386601b5f40a7d$export$2e2bcd8739ae039({ icon: icon, label: label, onClick: onClick, variant: variant = 'default', size: size = 44, disabled: disabled = false, style: style, ...rest }) {
    const v = $26386601b5f40a7d$var$VARIANT[variant] || $26386601b5f40a7d$var$VARIANT.default;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        ...rest,
        onClick: onClick,
        disabled: disabled,
        "aria-label": label,
        title: label,
        style: {
            width: size,
            height: size,
            minWidth: size,
            padding: 0,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 12,
            cursor: disabled ? 'default' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            flexShrink: 0,
            fontFamily: 'inherit',
            ...v,
            ...style
        }
    }, icon);
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $83905746e46531b9$export$a2387ed3b5d536eb = {
    name: "plus",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M5 12h14",
                key: "1ays0h"
            }
        ],
        [
            "path",
            {
                d: "M12 5v14",
                key: "s699le"
            }
        ]
    ]
};
$83905746e46531b9$export$a2387ed3b5d536eb.node;
const $83905746e46531b9$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($83905746e46531b9$export$a2387ed3b5d536eb);



'use client';
function $9b6fb81a56105b0d$export$2e2bcd8739ae039({ label: label, icon: icon, onClick: onClick, minHeight: minHeight = 118, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClick,
        style: {
            width: '100%',
            minHeight: minHeight,
            padding: 16,
            background: 'transparent',
            border: `1.5px dashed ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 16,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6,
            cursor: 'pointer',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            fontFamily: 'inherit',
            fontWeight: 700,
            fontSize: 14,
            ...style
        }
    }, icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $83905746e46531b9$export$2e2bcd8739ae039), {
        size: 22
    }), label);
}



var $acw62 = parcelRequire("acw62");

'use client';
function $0d47a2201c3cd6a9$export$2e2bcd8739ae039({ checked: checked, onChange: onChange, disabled: disabled = false, label: label, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "switch",
        "aria-checked": checked,
        "aria-disabled": disabled,
        "aria-label": label,
        onClick: ()=>{
            if (!disabled) onChange?.(!checked);
        },
        style: {
            width: 44,
            height: 24,
            borderRadius: 4,
            flexShrink: 0,
            position: 'relative',
            cursor: disabled ? 'not-allowed' : 'pointer',
            background: checked ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : '#d1d5db',
            opacity: disabled ? 0.5 : 1,
            transition: 'background .25s',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            top: 3,
            width: 18,
            height: 18,
            borderRadius: '50%',
            background: '#fff',
            boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
            right: checked ? 3 : 23,
            transition: 'right .25s'
        }
    }));
}



var $acw62 = parcelRequire("acw62");


'use client';
function $2358e3acbc4a7e55$export$2e2bcd8739ae039({ title: title, badge: badge, defaultOpen: defaultOpen = false, open: controlledOpen, onOpenChange: onOpenChange, children: children, style: style }) {
    const [uncontrolled, setUncontrolled] = (0, $acw62.useState)(defaultOpen);
    const open = controlledOpen !== undefined ? controlledOpen : uncontrolled;
    const toggle = ()=>{
        const next = !open;
        if (onOpenChange) onOpenChange(next);
        if (controlledOpen === undefined) setUncontrolled(next);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: toggle,
        "aria-expanded": open,
        style: {
            width: '100%',
            minHeight: 44,
            padding: '14px 4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 8,
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 700,
            fontSize: 14.5,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6
        }
    }, title, badge != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
            fontSize: 12
        }
    }, badge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dc4be5d9d5a360aa$export$2e2bcd8739ae039), {
        size: 18,
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
        style: {
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform .15s'
        }
    })), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            paddingBottom: 8
        }
    }, children));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5401c97ba566f60e$export$a2387ed3b5d536eb = {
    name: "camera",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z",
                key: "18u6gg"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "13",
                r: "3",
                key: "1vg3eu"
            }
        ]
    ]
};
$5401c97ba566f60e$export$a2387ed3b5d536eb.node;
const $5401c97ba566f60e$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($5401c97ba566f60e$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $df9771111904a5d5$export$a2387ed3b5d536eb = {
    name: "file-text",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
                key: "1oefj6"
            }
        ],
        [
            "path",
            {
                d: "M14 2v5a1 1 0 0 0 1 1h5",
                key: "wfsgrz"
            }
        ],
        [
            "path",
            {
                d: "M10 9H8",
                key: "b1mrlr"
            }
        ],
        [
            "path",
            {
                d: "M16 13H8",
                key: "t4e002"
            }
        ],
        [
            "path",
            {
                d: "M16 17H8",
                key: "z1uh3a"
            }
        ]
    ]
};
$df9771111904a5d5$export$a2387ed3b5d536eb.node;
const $df9771111904a5d5$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($df9771111904a5d5$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8745eaf007923a88$export$a2387ed3b5d536eb = {
    name: "folder-open",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
                key: "usdka0"
            }
        ]
    ]
};
$8745eaf007923a88$export$a2387ed3b5d536eb.node;
const $8745eaf007923a88$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($8745eaf007923a88$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $557120626e51c22d$export$a2387ed3b5d536eb = {
    name: "upload",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 3v12",
                key: "1x0j5s"
            }
        ],
        [
            "path",
            {
                d: "m17 8-5-5-5 5",
                key: "7q97r8"
            }
        ],
        [
            "path",
            {
                d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
                key: "ih7n3h"
            }
        ]
    ]
};
$557120626e51c22d$export$a2387ed3b5d536eb.node;
const $557120626e51c22d$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($557120626e51c22d$export$a2387ed3b5d536eb);








'use client';
const $ad7c85561d054b68$export$d8640b1e4d69af25 = [
    'queued',
    'preparing',
    'sending',
    'done',
    'failed'
];
const $ad7c85561d054b68$var$DEFAULT_PHASE_LABELS = {
    queued: "\u062F\u0631 \u0635\u0641",
    preparing: "\u0622\u0645\u0627\u062F\u0647\u200C\u0633\u0627\u0632\u06CC",
    sending: "\u062F\u0631 \u062D\u0627\u0644 \u0627\u0631\u0633\u0627\u0644\u2026",
    done: "\u0627\u0631\u0633\u0627\u0644 \u0634\u062F",
    failed: "\u0627\u0631\u0633\u0627\u0644 \u0646\u0634\u062F"
};
// ≥ 2.75rem on a coarse pointer (MOBILE_WEB_PWA §5); a mouse keeps `sm`.
const $ad7c85561d054b68$var$TOUCH_TARGET = '[@media(pointer:coarse)]:min-h-[2.75rem]';
const $ad7c85561d054b68$var$SIZES = {
    regular: {
        padBlock: '1.75rem',
        icon: 28
    },
    compact: {
        padBlock: '1rem',
        icon: 20
    }
};
// ── accept matching ─────────────────────────────────────────────────────────
function $ad7c85561d054b68$var$acceptTokens(accept) {
    if (!accept) return [];
    const list = Array.isArray(accept) ? accept : String(accept).split(',');
    return list.map((t)=>String(t).trim().toLowerCase()).filter(Boolean);
}
function $ad7c85561d054b68$export$b4699969e89702eb(file, accept) {
    const tokens = $ad7c85561d054b68$var$acceptTokens(accept);
    if (tokens.length === 0) return true;
    const name = String(file?.name || '').toLowerCase();
    const type = String(file?.type || '').toLowerCase();
    return tokens.some((token)=>{
        if (token.startsWith('.')) return name.endsWith(token);
        if (token.endsWith('/*')) return type.startsWith(token.slice(0, -1));
        return type === token;
    });
}
// `null`, '' and [] mean "no filter" — and no `accept` attribute on the input.
function $ad7c85561d054b68$var$acceptAttr(accept) {
    const tokens = $ad7c85561d054b68$var$acceptTokens(accept);
    return tokens.length ? tokens.join(',') : undefined;
}
function $ad7c85561d054b68$var$isImage(file) {
    return !!file && typeof file.type === 'string' && file.type.toLowerCase().startsWith('image/');
}
function $ad7c85561d054b68$export$8c95ef2c56e9a241({ name: name, meta: meta, phase: phase = 'queued', progress: progress, progressLabel: progressLabel, error: error, file: file, previewUrl: previewUrl, badge: badge, removable: removable, replaceable: replaceable = false, trailing: trailing, busy: busy = false, disabled: disabled = false, onRemove: onRemove, onRetry: onRetry, onReplace: onReplace, phaseLabels: phaseLabels, removeLabel: removeLabel = "\u062D\u0630\u0641", retryLabel: retryLabel = "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F", replaceLabel: replaceLabel = "\u062C\u0627\u06CC\u06AF\u0632\u06CC\u0646\u06CC", as: Tag = 'li', className: className, 'data-testid': testId, ...rest }) {
    const labels = {
        ...$ad7c85561d054b68$var$DEFAULT_PHASE_LABELS,
        ...phaseLabels
    };
    const phaseLabel = labels[phase] ?? phase;
    // A thumbnail for an image File, created here and revoked when the row
    // leaves or the file changes — a leaked object URL holds the whole blob.
    const [objectUrl, setObjectUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const wantsObjectUrl = !previewUrl && !badge && $ad7c85561d054b68$var$isImage(file);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!wantsObjectUrl || typeof URL === 'undefined' || typeof URL.createObjectURL !== 'function') {
            setObjectUrl(null);
            return undefined;
        }
        const url = URL.createObjectURL(file);
        setObjectUrl(url);
        return ()=>{
            if (typeof URL.revokeObjectURL === 'function') URL.revokeObjectURL(url);
        };
    }, [
        file,
        wantsObjectUrl
    ]);
    const thumbSrc = previewUrl || (wantsObjectUrl ? objectUrl : null);
    const canRemove = (removable ?? phase !== 'done') && !busy && typeof onRemove === 'function';
    const canRetry = phase === 'failed' && !!file && !busy && typeof onRetry === 'function';
    const canReplace = replaceable && !busy && typeof onReplace === 'function';
    const hasBar = typeof progress === 'number' && Number.isFinite(progress);
    const pct = hasBar ? Math.max(0, Math.min(100, progress)) : 0;
    const phaseColor = phase === 'failed' ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk : phase === 'done' ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        "data-testid": testId,
        "data-state": phase,
        "aria-live": "polite",
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex items-center', className),
        style: {
            gap: '0.625rem',
            paddingBlock: '0.5rem',
            paddingInline: '0.625rem',
            minHeight: '2.75rem',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            minWidth: 0,
            opacity: disabled ? 0.6 : 1
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        className: "flex items-center justify-center overflow-hidden",
        style: {
            flexShrink: 0,
            width: '2.25rem',
            height: '2.25rem',
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            fontSize: '0.625rem',
            fontWeight: 800
        }
    }, badge ? badge : thumbSrc ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: thumbSrc,
        alt: "",
        "data-testid": testId ? `${testId}-thumb` : undefined,
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df9771111904a5d5$export$2e2bcd8739ae039), {
        size: 18,
        strokeWidth: 1.5
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex flex-col",
        style: {
            flex: 1,
            minWidth: 0,
            gap: '0.125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        className: "text-start",
        style: {
            unicodeBidi: 'isolate',
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            lineHeight: 1.4,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, name), error ? // Keyed on the text: a CHANGED error remounts and is announced once;
    // an unchanged one re-rendering stays quiet.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        key: String(error),
        role: "alert",
        style: {
            fontSize: '0.6875rem',
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk,
            lineHeight: 1.5
        }
    }, error) : meta ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            lineHeight: 1.5
        }
    }, meta) : null, hasBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": pct,
        "aria-label": progressLabel || phaseLabel,
        className: "flex",
        style: {
            flex: 1,
            height: '0.25rem',
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "transition-[width] duration-200 motion-reduce:transition-none",
        style: {
            width: `${pct}%`,
            height: '100%',
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill
        }
    })), progressLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "tabular-nums",
        style: {
            fontSize: '0.6875rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, progressLabel) : null) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center",
        style: {
            flexShrink: 0,
            gap: '0.375rem'
        }
    }, trailing, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center",
        style: {
            gap: '0.25rem',
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: phaseColor
        }
    }, phase === 'sending' || phase === 'preparing' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        className: "inline-flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
        size: 14,
        thickness: 2,
        label: ""
    })) : null, phase === 'done' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3fbaf9031554177f$export$2e2bcd8739ae039), {
        "aria-hidden": true,
        size: 14,
        strokeWidth: 2,
        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).good
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, phaseLabel)), canReplace ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        type: "button",
        variant: "ghost",
        size: "sm",
        className: $ad7c85561d054b68$var$TOUCH_TARGET,
        onClick: onReplace,
        disabled: disabled,
        "data-testid": testId ? `${testId}-replace` : undefined
    }, replaceLabel) : null, canRetry ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        type: "button",
        variant: "outline",
        size: "sm",
        className: $ad7c85561d054b68$var$TOUCH_TARGET,
        onClick: onRetry,
        disabled: disabled,
        "data-testid": testId ? `${testId}-retry` : undefined
    }, retryLabel) : null, canRemove ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: 40,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b6a18bc128c0629$export$2e2bcd8739ae039), {
            size: 16,
            "aria-hidden": true
        }),
        label: removeLabel,
        onClick: onRemove,
        disabled: disabled,
        "data-testid": testId ? `${testId}-remove` : undefined
    }) : null));
}
const $ad7c85561d054b68$export$731398005976572f = $ad7c85561d054b68$export$8c95ef2c56e9a241;
// ─────────────────────────────────────────────────────────────────────────────
// FileDropzone
// ─────────────────────────────────────────────────────────────────────────────
// Every row the zone counts: the flat `files`, or the rows of every group.
function $ad7c85561d054b68$var$rowsOf(groups, files) {
    if (Array.isArray(groups)) return groups.flatMap((g)=>Array.isArray(g?.files) ? g.files : []);
    return Array.isArray(files) ? files : [];
}
function $ad7c85561d054b68$export$2e2bcd8739ae039({ files: filesProp, groups: groups, onFiles: onFiles, onRemove: onRemove, onRetry: onRetry, onReplace: onReplace, accept: accept, multiple: multiple = true, maxFiles: maxFiles, maxBytes: maxBytes, capture: capture, directory: directory = false, extraActions: extraActions, disabled: disabled = false, busy: busy = false, error: error, size: size = 'regular', label: label, required: required, helperText: helperText, dropLabel: dropLabel = "\u0641\u0627\u06CC\u0644\u200C\u0647\u0627 \u0631\u0627 \u0627\u06CC\u0646\u062C\u0627 \u0631\u0647\u0627 \u06A9\u0646\u06CC\u062F \u06CC\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F", pickLabel: pickLabel = "\u0627\u0646\u062A\u062E\u0627\u0628 \u0641\u0627\u06CC\u0644", cameraLabel: cameraLabel = "\u0639\u06A9\u0633 \u06AF\u0631\u0641\u062A\u0646", directoryLabel: directoryLabel = "\u0627\u0646\u062A\u062E\u0627\u0628 \u067E\u0648\u0634\u0647", removeLabel: removeLabel = "\u062D\u0630\u0641", retryLabel: retryLabel = "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F", replaceLabel: replaceLabel = "\u062C\u0627\u06CC\u06AF\u0632\u06CC\u0646\u06CC", phaseLabels: phaseLabels, draggingLabel: draggingLabel = "\u0631\u0647\u0627 \u06A9\u0646\u06CC\u062F", emptyHint: emptyHint, listLabel: listLabel, className: className, style: style, 'data-testid': testId, ...rest }) {
    const S = $ad7c85561d054b68$var$SIZES[size] || $ad7c85561d054b68$var$SIZES.regular;
    const baseId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const zoneId = `${baseId}-zone`;
    const helperId = helperText ? `${baseId}-helper` : undefined;
    const errorId = error ? `${baseId}-error` : undefined;
    const mainRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const cameraRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const directoryRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const replaceRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const replaceTarget = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const dragDepth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const [dragging, setDragging] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const files = $ad7c85561d054b68$var$rowsOf(groups, filesProp);
    const warnedBoth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const inert = disabled || busy;
    const tid = (suffix)=>testId ? `${testId}-${suffix}` : undefined;
    // `webkitdirectory` is not a React prop; it has to be an attribute.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = directoryRef.current;
        if (!el) return;
        el.setAttribute('webkitdirectory', '');
        el.setAttribute('directory', '');
    }, [
        directory
    ]);
    // Never lingers in `dragging` if the zone is disabled mid-drag.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (inert) {
            dragDepth.current = 0;
            setDragging(false);
        }
    }, [
        inert
    ]);
    const report = (picked, source)=>{
        const list = Array.from(picked || []);
        // Nothing picked (a cancelled dialog, a drop of text) is not a batch.
        if (list.length === 0) return;
        let room = Infinity;
        if (typeof maxFiles === 'number') room = Math.max(0, maxFiles - files.length);
        if (!multiple) room = Math.min(room, 1);
        const accepted = [];
        const rejected = [];
        for (const f of list){
            if (!$ad7c85561d054b68$export$b4699969e89702eb(f, accept)) rejected.push({
                file: f,
                reason: 'type'
            });
            else if (typeof maxBytes === 'number' && typeof f.size === 'number' && f.size > maxBytes) rejected.push({
                file: f,
                reason: 'size'
            });
            else if (accepted.length >= room) rejected.push({
                file: f,
                reason: 'count'
            });
            else accepted.push(f);
        }
        onFiles?.(accepted, rejected, source);
    };
    const onInputChange = (source)=>(e)=>{
            const picked = e.target.files;
            try {
                report(picked, source);
            } finally{
                // Reset, so picking the same file twice still fires `change`.
                e.target.value = '';
            }
        };
    const onReplaceChange = (e)=>{
        const f = e.target.files?.[0];
        const id = replaceTarget.current;
        e.target.value = '';
        replaceTarget.current = null;
        if (!f || id == null) return;
        // A refused replacement is reported like any refused pick, so the caller
        // has one place that writes the sentence.
        if (!$ad7c85561d054b68$export$b4699969e89702eb(f, accept)) {
            onFiles?.([], [
                {
                    file: f,
                    reason: 'type'
                }
            ], 'picker');
            return;
        }
        if (typeof maxBytes === 'number' && f.size > maxBytes) {
            onFiles?.([], [
                {
                    file: f,
                    reason: 'size'
                }
            ], 'picker');
            return;
        }
        onReplace?.(id, f);
    };
    const open = (ref)=>()=>{
            if (inert) return;
            ref.current?.click();
        };
    const hasDragFiles = (e)=>{
        const types = e.dataTransfer?.types;
        if (!types) return true;
        return Array.from(types).includes('Files');
    };
    const onDragEnter = (e)=>{
        if (!hasDragFiles(e)) return;
        e.preventDefault();
        if (inert) return;
        dragDepth.current += 1;
        setDragging(true);
    };
    const onDragOver = (e)=>{
        if (!hasDragFiles(e)) return;
        e.preventDefault();
        if (e.dataTransfer) e.dataTransfer.dropEffect = inert ? 'none' : 'copy';
    };
    const onDragLeave = ()=>{
        if (inert) return;
        // `dragleave` fires on every child boundary; only the last one leaves.
        dragDepth.current = Math.max(0, dragDepth.current - 1);
        if (dragDepth.current === 0) setDragging(false);
    };
    const onDrop = (e)=>{
        e.preventDefault();
        dragDepth.current = 0;
        setDragging(false);
        if (inert) return;
        report(e.dataTransfer?.files, 'drop');
    };
    const state = disabled ? 'disabled' : dragging ? 'dragging' : files.length ? 'has-files' : 'idle';
    const accentOn = dragging && !inert;
    const describedBy = [
        helperId,
        errorId
    ].filter(Boolean).join(' ') || undefined;
    const pickerProps = {
        type: 'button',
        variant: 'outline',
        size: 'sm',
        className: $ad7c85561d054b68$var$TOUCH_TARGET,
        disabled: disabled,
        'aria-disabled': busy || undefined
    };
    const renderRow = (f)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7c85561d054b68$export$8c95ef2c56e9a241, {
            key: f.id,
            name: f.name,
            meta: f.meta,
            phase: f.phase,
            progress: f.progress,
            progressLabel: f.progressLabel,
            error: f.error,
            file: f.file,
            previewUrl: f.previewUrl,
            badge: f.badge,
            removable: f.removable,
            replaceable: f.replaceable,
            trailing: f.trailing,
            busy: busy,
            disabled: disabled,
            phaseLabels: phaseLabels,
            removeLabel: removeLabel,
            retryLabel: retryLabel,
            replaceLabel: replaceLabel,
            onRemove: onRemove ? ()=>onRemove(f.id) : undefined,
            onRetry: onRetry ? ()=>onRetry(f.id) : undefined,
            onReplace: onReplace ? ()=>{
                if (inert) return;
                replaceTarget.current = f.id;
                replaceRef.current?.click();
            } : undefined,
            "data-testid": testId ? `${testId}-row-${f.id}` : undefined
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-state": state,
        "data-busy": busy || undefined,
        className: className,
        style: style,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        label: label,
        required: required,
        htmlFor: zoneId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-col",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('frame'),
        onDragEnter: onDragEnter,
        onDragOver: onDragOver,
        onDragLeave: onDragLeave,
        onDrop: onDrop,
        className: "flex flex-col items-center",
        style: {
            gap: '0.625rem',
            paddingBlock: S.padBlock,
            paddingInline: '1rem',
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
            border: `1.5px dashed ${accentOn ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            background: accentOn ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent, 0.06) : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
            opacity: disabled ? 0.55 : 1,
            cursor: disabled ? 'not-allowed' : undefined,
            transition: 'border-color 0.15s, background 0.15s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        id: zoneId,
        type: "button",
        "data-testid": tid('zone'),
        onClick: open(mainRef),
        disabled: disabled,
        "aria-disabled": busy || undefined,
        "aria-describedby": describedBy,
        className: "flex w-full flex-col items-center text-center outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md",
        style: {
            gap: '0.375rem',
            background: 'transparent',
            border: 'none',
            padding: '0.25rem',
            cursor: inert ? disabled ? 'not-allowed' : 'default' : 'pointer',
            font: 'inherit',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $557120626e51c22d$export$2e2bcd8739ae039), {
        "aria-hidden": true,
        size: S.icon,
        strokeWidth: 1.5,
        color: accentOn ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600
        }
    }, accentOn ? draggingLabel : dropLabel), emptyHint && files.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, emptyHint) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-wrap items-center justify-center",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        ...pickerProps,
        onClick: open(mainRef),
        "data-testid": tid('pick')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $557120626e51c22d$export$2e2bcd8739ae039), {
        "aria-hidden": true,
        size: 14
    }), pickLabel), capture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        ...pickerProps,
        onClick: open(cameraRef),
        "data-testid": tid('camera-button')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5401c97ba566f60e$export$2e2bcd8739ae039), {
        "aria-hidden": true,
        size: 14
    }), cameraLabel) : null, directory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        ...pickerProps,
        onClick: open(directoryRef),
        "data-testid": tid('directory-button')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8745eaf007923a88$export$2e2bcd8739ae039), {
        "aria-hidden": true,
        size: 14
    }), directoryLabel) : null, typeof extraActions === 'function' ? extraActions({
        openPicker: open(mainRef),
        openCamera: capture ? open(cameraRef) : undefined,
        openDirectory: directory ? open(directoryRef) : undefined,
        labels: {
            pick: pickLabel,
            camera: cameraLabel,
            directory: directoryLabel
        },
        disabled: inert
    }) : extraActions), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: mainRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": pickLabel,
        accept: $ad7c85561d054b68$var$acceptAttr(accept),
        multiple: multiple,
        disabled: disabled,
        onChange: onInputChange('picker'),
        "data-testid": tid('input')
    }), capture ? // A SEPARATE input: `capture` on the main one makes iOS skip the
    // gallery entirely.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: cameraRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": cameraLabel,
        accept: "image/*",
        capture: capture,
        disabled: disabled,
        onChange: onInputChange('camera'),
        "data-testid": tid('camera')
    }) : null, directory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: directoryRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": directoryLabel,
        multiple: true,
        disabled: disabled,
        onChange: onInputChange('directory'),
        "data-testid": tid('directory')
    }) : null, typeof onReplace === 'function' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: replaceRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": replaceLabel,
        accept: $ad7c85561d054b68$var$acceptAttr(accept),
        disabled: disabled,
        onChange: onReplaceChange,
        "data-testid": tid('replace-input')
    }) : null), helperText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: helperId,
        className: "m-0",
        style: {
            fontSize: '0.71875rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            lineHeight: 1.5
        }
    }, helperText) : null, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: errorId,
        key: String(error),
        role: "alert",
        className: "m-0",
        style: {
            fontSize: '0.71875rem',
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk,
            fontWeight: 500,
            lineHeight: 1.5
        }
    }, error) : null, Array.isArray(groups) ? groups.map((g)=>{
        const rows = Array.isArray(g.files) ? g.files : [];
        const headingId = `${baseId}-group-${g.id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
            key: g.id,
            "aria-labelledby": headingId,
            "data-testid": tid(`group-${g.id}`),
            "data-state": rows.length ? 'has-files' : 'empty',
            className: "flex flex-col",
            style: {
                gap: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "flex items-baseline",
            style: {
                gap: '0.5rem',
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            id: headingId,
            style: {
                fontSize: '0.75rem',
                fontWeight: 700,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                lineHeight: 1.5
            }
        }, g.title), g.meta ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                lineHeight: 1.5
            }
        }, g.meta) : null), rows.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            "aria-labelledby": headingId,
            className: "m-0 flex list-none flex-col p-0",
            style: {
                gap: '0.375rem'
            }
        }, rows.map(renderRow)) : g.emptyText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
            className: "m-0",
            style: {
                fontSize: '0.71875rem',
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                lineHeight: 1.5
            }
        }, g.emptyText) : null);
    }) : files.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "aria-label": listLabel || (typeof label === 'string' ? label : undefined),
        className: "m-0 flex list-none flex-col p-0",
        style: {
            gap: '0.375rem'
        }
    }, files.map(renderRow)) : null)));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c96e72789512f0bb$export$a2387ed3b5d536eb = {
    name: "maximize",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M8 3H5a2 2 0 0 0-2 2v3",
                key: "1dcmit"
            }
        ],
        [
            "path",
            {
                d: "M21 8V5a2 2 0 0 0-2-2h-3",
                key: "1e4gt3"
            }
        ],
        [
            "path",
            {
                d: "M3 16v3a2 2 0 0 0 2 2h3",
                key: "wsl5sc"
            }
        ],
        [
            "path",
            {
                d: "M16 21h3a2 2 0 0 0 2-2v-3",
                key: "18trek"
            }
        ]
    ]
};
$c96e72789512f0bb$export$a2387ed3b5d536eb.node;
const $c96e72789512f0bb$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($c96e72789512f0bb$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $191016e022d4d457$export$a2387ed3b5d536eb = {
    name: "zoom-in",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "11",
                cy: "11",
                r: "8",
                key: "4ej97u"
            }
        ],
        [
            "line",
            {
                x1: "21",
                x2: "16.65",
                y1: "21",
                y2: "16.65",
                key: "13gj7c"
            }
        ],
        [
            "line",
            {
                x1: "11",
                x2: "11",
                y1: "8",
                y2: "14",
                key: "1vmskp"
            }
        ],
        [
            "line",
            {
                x1: "8",
                x2: "14",
                y1: "11",
                y2: "11",
                key: "durymu"
            }
        ]
    ]
};
$191016e022d4d457$export$a2387ed3b5d536eb.node;
const $191016e022d4d457$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($191016e022d4d457$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a481aded68921702$export$a2387ed3b5d536eb = {
    name: "zoom-out",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "11",
                cy: "11",
                r: "8",
                key: "4ej97u"
            }
        ],
        [
            "line",
            {
                x1: "21",
                x2: "16.65",
                y1: "21",
                y2: "16.65",
                key: "13gj7c"
            }
        ],
        [
            "line",
            {
                x1: "8",
                x2: "14",
                y1: "11",
                y2: "11",
                key: "durymu"
            }
        ]
    ]
};
$a481aded68921702$export$a2387ed3b5d536eb.node;
const $a481aded68921702$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($a481aded68921702$export$a2387ed3b5d536eb);











'use client';
// ─────────────────────────────────────────────────────────────────────────────
// ImageStackViewer — a stack of rendered frames, scrolled like a study.
//
// ── Why this is kit ─────────────────────────────────────────────────────────
// Phones, the patient app and the clinic app all preview a DICOM study as
// server-rendered JPEG frames (DICOM_COMPRESSION_LIMITS_AND_DOCUMENT_OCR_DESIGN
// §8.9.2, §24.11). Three apps, one anatomy: §17.1 answers yes. Cornerstone (the
// diagnostic viewer) stays in the doctor app's desktop route; this is a preview.
//
// ── Presentational: the app fetches, the kit shows ─────────────────────────
// The component never fetches and knows nothing about DICOM. The app supplies
// `loadFrame(i, { signal }) → Promise<string>` — an object URL it created from a
// response it fetched WITH ITS OWN AUTH (so PHI and tokens never ride in a URL
// query). The kit calls it for the current frame and the ±`preloadRadius`
// neighbours, and aborts `signal` when a pending frame falls out of that window
// or the source changes (`activeSeriesId`, `activePresetId`, `frameCount`,
// `sourceKey`). `loadFrame` is read through a ref, so an inline arrow does not
// restart loading on every render.
//
// ── Object-URL ownership ────────────────────────────────────────────────────
// The URL a `loadFrame` resolves to belongs to the APP. By default the kit
// never revokes anything: it forgets a frame once it leaves the window, and the
// app revokes on its own schedule (or keeps its own cache). An app that wants
// the kit to hand URLs back passes `revokeFrame(url)`; it is then called
// exactly once per URL the kit no longer shows or will show — a frame evicted
// from the window, a load that resolved after it was cancelled, and everything
// still held at unmount. The frame on screen is never revoked while it is shown.
//
// ── Interaction (every gesture duplicates a visible control, PWA §6) ────────
// slider + prev/next buttons; ↑/↓ PageUp/PageDown Home/End change frame; the
// wheel and a vertical swipe step frames; ctrl+wheel and pinch zoom; + − zoom,
// 0 resets; a drag pans once zoomed; double-tap / double-click resets.
//
// ── Direction ───────────────────────────────────────────────────────────────
// No `dir`. Chrome follows the document; the IMAGE is never mirrored — a
// radiograph has a patient left and right, and RTL is not a reason to flip it.
// Pan offsets are physical pixels on purpose: the finger moves the picture.
// ─────────────────────────────────────────────────────────────────────────────
const $cb5da664f84994ea$var$FA_DIGITS = "\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9";
const $cb5da664f84994ea$var$faDigits = (n)=>String(n).replace(/\d/g, (d)=>$cb5da664f84994ea$var$FA_DIGITS[d]);
const $cb5da664f84994ea$export$eb119caddc05b7a2 = {
    // `i` is the 1-based position, `n` the frame count.
    frame: (i, n)=>`\u{62A}\u{635}\u{648}\u{6CC}\u{631} ${$cb5da664f84994ea$var$faDigits(i)} \u{627}\u{632} ${$cb5da664f84994ea$var$faDigits(n)}`,
    prev: "\u062A\u0635\u0648\u06CC\u0631 \u0642\u0628\u0644\u06CC",
    next: "\u062A\u0635\u0648\u06CC\u0631 \u0628\u0639\u062F\u06CC",
    slider: "\u062C\u0627\u0628\u0647\u200C\u062C\u0627\u06CC\u06CC \u0628\u06CC\u0646 \u062A\u0635\u0627\u0648\u06CC\u0631",
    zoomIn: "\u0628\u0632\u0631\u06AF\u200C\u0646\u0645\u0627\u06CC\u06CC",
    zoomOut: "\u06A9\u0648\u0686\u06A9\u200C\u0646\u0645\u0627\u06CC\u06CC",
    reset: "\u0628\u0627\u0632\u0646\u0634\u0627\u0646\u06CC \u0646\u0645\u0627",
    series: "\u0633\u0631\u06CC\u200C\u0647\u0627",
    presets: "\u062A\u0646\u0638\u06CC\u0645 \u0646\u0645\u0627\u06CC\u0634",
    viewport: "\u0646\u0645\u0627\u06CC \u062A\u0635\u0648\u06CC\u0631",
    loading: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u062A\u0635\u0648\u06CC\u0631",
    error: "\u062A\u0635\u0648\u06CC\u0631 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F",
    retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
    empty: "\u062A\u0635\u0648\u06CC\u0631\u06CC \u0628\u0631\u0627\u06CC \u0646\u0645\u0627\u06CC\u0634 \u0646\u06CC\u0633\u062A"
};
const $cb5da664f84994ea$var$MIN_ZOOM = 1;
const $cb5da664f84994ea$var$MAX_ZOOM = 8;
const $cb5da664f84994ea$var$ZOOM_STEP = 1.25;
// Pixels of wheel delta / finger travel per frame. Interaction thresholds,
// not layout — they never reach a style.
const $cb5da664f84994ea$var$WHEEL_PER_FRAME = 60;
const $cb5da664f84994ea$var$SWIPE_PER_FRAME = 24;
const $cb5da664f84994ea$var$DOUBLE_TAP_MS = 300;
// ≥ 2.75rem on a coarse pointer (MOBILE_WEB_PWA §5).
const $cb5da664f84994ea$var$TOUCH_TARGET = '[@media(pointer:coarse)]:min-h-[2.75rem]';
const $cb5da664f84994ea$var$clamp = (v, lo, hi)=>Math.max(lo, Math.min(hi, v));
function $cb5da664f84994ea$export$2e2bcd8739ae039({ frameCount: frameCount = 0, index: indexProp, defaultIndex: defaultIndex = 0, onIndexChange: onIndexChange, loadFrame: loadFrame, revokeFrame: revokeFrame, preloadRadius: preloadRadius = 5, sourceKey: sourceKey, series: series, activeSeriesId: activeSeriesId, onSeriesChange: onSeriesChange, presets: presets, activePresetId: activePresetId, onPresetChange: onPresetChange, caption: caption, banner: banner, loading: loading = false, error: error, onRetry: onRetry, labels: labelsProp, className: className, style: style, 'data-testid': testId, ...rest }) {
    const labels = {
        ...$cb5da664f84994ea$export$eb119caddc05b7a2,
        ...labelsProp
    };
    const tid = (suffix)=>testId ? `${testId}-${suffix}` : undefined;
    const n = Math.max(0, Math.floor(Number(frameCount) || 0));
    // ── index: controlled when `index` is given, otherwise internal ───────────
    const [innerIndex, setInnerIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(defaultIndex);
    const controlled = indexProp !== undefined && indexProp !== null;
    const index = n ? $cb5da664f84994ea$var$clamp(Math.floor(controlled ? indexProp : innerIndex) || 0, 0, n - 1) : 0;
    const indexRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(index);
    indexRef.current = index;
    const go = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((next)=>{
        if (!n) return;
        const target = $cb5da664f84994ea$var$clamp(Math.round(next), 0, n - 1);
        if (target === indexRef.current) return;
        if (!controlled) setInnerIndex(target);
        onIndexChange?.(target);
    }, [
        n,
        controlled,
        onIndexChange
    ]);
    // ── frame cache ───────────────────────────────────────────────────────────
    const loadRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(loadFrame);
    loadRef.current = loadFrame;
    const revokeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(revokeFrame);
    revokeRef.current = revokeFrame;
    const cache = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map()); // i → url
    const pending = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map()); // i → AbortController
    const failed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Set()); // i
    const shownRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null); // url on screen
    const [, bump] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useReducer((x)=>x + 1, 0);
    const [shownUrl, setShownUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [, setRetryTick] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const release = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((url)=>{
        if (!url || url === shownRef.current) return;
        revokeRef.current?.(url);
    }, []);
    const source = `${activeSeriesId ?? ''}|${activePresetId ?? ''}|${n}|${sourceKey ?? ''}`;
    const sourceRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(source);
    // A new source: cancel everything in flight and forget every frame. The
    // shown image stays up (under a spinner) until its replacement arrives.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (sourceRef.current === source) return;
        sourceRef.current = source;
        for (const ctrl of pending.current.values())ctrl.abort();
        pending.current.clear();
        for (const url of cache.current.values())release(url);
        cache.current.clear();
        failed.current.clear();
        bump();
    }, [
        source,
        release
    ]);
    // Load the current frame and its neighbours; evict what fell out.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!n || typeof loadRef.current !== 'function' || loading || error) return;
        const lo = Math.max(0, index - preloadRadius);
        const hi = Math.min(n - 1, index + preloadRadius);
        for (const [i, ctrl] of pending.current)if (i < lo || i > hi) {
            ctrl.abort();
            pending.current.delete(i);
        }
        for (const [i, url] of cache.current)if (i < lo || i > hi) {
            cache.current.delete(i);
            release(url);
        }
        for (const i of failed.current)if (i < lo || i > hi) failed.current.delete(i);
        // Current frame first, then outward: ±1, ±2, …
        const order = [
            index
        ];
        for(let d = 1; d <= preloadRadius; d += 1){
            if (index + d <= hi) order.push(index + d);
            if (index - d >= lo) order.push(index - d);
        }
        const mySource = sourceRef.current;
        for (const i of order){
            if (cache.current.has(i) || pending.current.has(i) || failed.current.has(i)) continue;
            const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : {
                abort () {},
                signal: undefined
            };
            pending.current.set(i, ctrl);
            let p;
            try {
                p = Promise.resolve(loadRef.current(i, {
                    signal: ctrl.signal
                }));
            } catch (e) {
                p = Promise.reject(e);
            }
            p.then((url)=>{
                const stale = ctrl.signal?.aborted || sourceRef.current !== mySource || pending.current.get(i) !== ctrl;
                if (stale) {
                    if (url) revokeRef.current?.(url);
                    return;
                }
                pending.current.delete(i);
                cache.current.set(i, url);
                bump();
            }, ()=>{
                const stale = ctrl.signal?.aborted || sourceRef.current !== mySource || pending.current.get(i) !== ctrl;
                if (stale) return;
                pending.current.delete(i);
                failed.current.add(i);
                bump();
            });
        }
    });
    // Show the current frame as soon as it is cached; revoke what it replaced.
    const currentUrl = cache.current.get(index) ?? null;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!currentUrl || currentUrl === shownRef.current) return;
        const previous = shownRef.current;
        shownRef.current = currentUrl;
        setShownUrl(currentUrl);
        if (previous && ![
            ...cache.current.values()
        ].includes(previous)) revokeRef.current?.(previous);
    }, [
        currentUrl
    ]);
    // Unmount: cancel, and hand back every URL still held.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            for (const ctrl of pending.current.values())ctrl.abort();
            pending.current.clear();
            const urls = new Set([
                ...cache.current.values(),
                shownRef.current
            ].filter(Boolean));
            cache.current.clear();
            shownRef.current = null;
            for (const url of urls)revokeRef.current?.(url);
        }, []);
    const retryFrame = ()=>{
        failed.current.delete(index);
        setRetryTick((t)=>t + 1);
    };
    const frameState = failed.current.has(index) ? 'error' : currentUrl ? 'ready' : 'loading';
    // ── zoom & pan ────────────────────────────────────────────────────────────
    const [zoom, setZoom] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(1);
    const [pan, setPan] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        x: 0,
        y: 0
    });
    const stageRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const clampPan = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((p, z)=>{
        const rect = stageRef.current?.getBoundingClientRect?.();
        if (!rect || !rect.width || !rect.height) return z <= 1 ? {
            x: 0,
            y: 0
        } : p;
        const mx = (z - 1) * rect.width / 2;
        const my = (z - 1) * rect.height / 2;
        return {
            x: $cb5da664f84994ea$var$clamp(p.x, -mx, mx),
            y: $cb5da664f84994ea$var$clamp(p.y, -my, my)
        };
    }, []);
    const zoomTo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((z)=>{
        const next = $cb5da664f84994ea$var$clamp(z, $cb5da664f84994ea$var$MIN_ZOOM, $cb5da664f84994ea$var$MAX_ZOOM);
        setZoom(next);
        setPan((p)=>next <= 1 ? {
                x: 0,
                y: 0
            } : clampPan(p, next));
    }, [
        clampPan
    ]);
    const resetView = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setZoom(1);
        setPan({
            x: 0,
            y: 0
        });
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        resetView();
    }, [
        activeSeriesId,
        resetView
    ]);
    // Latest values for the native listeners below.
    const live = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({});
    live.current = {
        zoom: zoom,
        go: go,
        index: index,
        zoomTo: zoomTo
    };
    // Wheel needs a non-passive listener to keep the page from scrolling.
    const wheelAcc = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = stageRef.current;
        if (!el) return undefined;
        const onWheel = (e)=>{
            e.preventDefault();
            const L = live.current;
            if (e.ctrlKey || e.metaKey) {
                L.zoomTo(L.zoom * (e.deltaY < 0 ? $cb5da664f84994ea$var$ZOOM_STEP : 1 / $cb5da664f84994ea$var$ZOOM_STEP));
                return;
            }
            // Line/page deltas (a notched mouse on some platforms) step one frame
            // per event; pixel deltas (trackpads) accumulate.
            if (e.deltaMode !== 0) {
                wheelAcc.current = 0;
                if (e.deltaY) L.go(L.index + Math.sign(e.deltaY));
                return;
            }
            wheelAcc.current += e.deltaY;
            const steps = Math.trunc(wheelAcc.current / $cb5da664f84994ea$var$WHEEL_PER_FRAME);
            if (steps) {
                wheelAcc.current -= steps * $cb5da664f84994ea$var$WHEEL_PER_FRAME;
                L.go(L.index + steps);
            }
        };
        el.addEventListener('wheel', onWheel, {
            passive: false
        });
        return ()=>el.removeEventListener('wheel', onWheel);
    });
    // Pointers: one finger pans (zoomed) or swipes frames (not zoomed); two pinch.
    const pointers = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const gesture = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const lastTap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const onPointerDown = (e)=>{
        pointers.current.set(e.pointerId, {
            x: e.clientX,
            y: e.clientY
        });
        try {
            e.currentTarget.setPointerCapture?.(e.pointerId);
        } catch  {}
        const pts = [
            ...pointers.current.values()
        ];
        if (pts.length === 2) gesture.current = {
            kind: 'pinch',
            dist: Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1,
            zoom: zoom
        };
        else if (pts.length === 1) gesture.current = zoom > 1 ? {
            kind: 'pan',
            x: e.clientX,
            y: e.clientY,
            pan: pan
        } : {
            kind: 'swipe',
            y: e.clientY,
            index: index
        };
    };
    const onPointerMove = (e)=>{
        if (!pointers.current.has(e.pointerId)) return;
        pointers.current.set(e.pointerId, {
            x: e.clientX,
            y: e.clientY
        });
        const g = gesture.current;
        if (!g) return;
        if (g.kind === 'pinch') {
            const pts = [
                ...pointers.current.values()
            ];
            if (pts.length < 2) return;
            const dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
            zoomTo(g.zoom * (dist / g.dist));
        } else if (g.kind === 'pan') setPan(clampPan({
            x: g.pan.x + (e.clientX - g.x),
            y: g.pan.y + (e.clientY - g.y)
        }, zoom));
        else if (g.kind === 'swipe') {
            // Finger up = next frame, like scrolling a page of film.
            const steps = Math.trunc((g.y - e.clientY) / $cb5da664f84994ea$var$SWIPE_PER_FRAME);
            go(g.index + steps);
        }
    };
    const onPointerUp = (e)=>{
        pointers.current.delete(e.pointerId);
        if (pointers.current.size === 0) {
            if (e.pointerType === 'touch') {
                const now = Date.now();
                if (now - lastTap.current < $cb5da664f84994ea$var$DOUBLE_TAP_MS) {
                    resetView();
                    lastTap.current = 0;
                } else lastTap.current = now;
            }
            gesture.current = null;
        } else if (pointers.current.size === 1) {
            const [pt] = [
                ...pointers.current.values()
            ];
            gesture.current = zoom > 1 ? {
                kind: 'pan',
                x: pt.x,
                y: pt.y,
                pan: pan
            } : null;
        }
    };
    const onKeyDown = (e)=>{
        switch(e.key){
            case 'ArrowUp':
            case 'PageUp':
                go(index - 1);
                break;
            case 'ArrowDown':
            case 'PageDown':
                go(index + 1);
                break;
            case 'Home':
                go(0);
                break;
            case 'End':
                go(n - 1);
                break;
            case '+':
            case '=':
                zoomTo(zoom * $cb5da664f84994ea$var$ZOOM_STEP);
                break;
            case '-':
            case '_':
                zoomTo(zoom / $cb5da664f84994ea$var$ZOOM_STEP);
                break;
            case '0':
                resetView();
                break;
            default:
                return;
        }
        e.preventDefault();
    };
    // ── states ────────────────────────────────────────────────────────────────
    const state = loading ? 'loading' : error ? 'error' : n === 0 ? 'empty' : 'content';
    const frameText = n ? labels.frame(index + 1, n) : '';
    const canvasStyle = {
        position: 'relative',
        width: '100%',
        aspectRatio: '1 / 1',
        maxHeight: '70dvh',
        maxWidth: '100%',
        borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
        background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink,
        overflow: 'hidden'
    };
    const seriesStrip = Array.isArray(series) && series.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": labels.series,
        "data-testid": tid('series'),
        className: "flex",
        style: {
            gap: '0.5rem',
            overflowX: 'auto',
            paddingBlock: '0.125rem',
            scrollbarWidth: 'thin'
        }
    }, series.map((s)=>{
        const active = s.id === activeSeriesId;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: s.id,
            type: "button",
            "aria-pressed": active,
            "data-state": active ? 'active' : 'inactive',
            "data-testid": tid(`series-${s.id}`),
            onClick: ()=>{
                if (!active) onSeriesChange?.(s.id);
            },
            className: (0, $42e05640dae453c1$export$1343a74baacb0543)('inline-flex items-center outline-none focus-visible:ring-2 focus-visible:ring-ring', $cb5da664f84994ea$var$TOUCH_TARGET),
            style: {
                flexShrink: 0,
                gap: '0.375rem',
                minHeight: '2.25rem',
                paddingInline: '0.75rem',
                paddingBlock: '0.25rem',
                borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
                border: `1px solid ${active ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                background: active ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent, 0.1) : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                color: active ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                font: 'inherit',
                fontSize: '0.75rem',
                fontWeight: 600,
                cursor: 'pointer',
                whiteSpace: 'nowrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                unicodeBidi: 'isolate'
            }
        }, s.label), s.badge != null && s.badge !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
                borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip,
                paddingInline: '0.3125rem'
            }
        }, s.badge) : null);
    })) : null;
    const presetControl = Array.isArray(presets) && presets.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('presets'),
        style: {
            maxWidth: '100%',
            overflowX: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
        semantics: "filter",
        size: "lg",
        ariaLabel: labels.presets,
        options: presets.map((p)=>({
                value: p.id,
                label: p.label
            })),
        value: activePresetId,
        onChange: (id)=>{
            if (id !== activePresetId) onPresetChange?.(id);
        }
    })) : null;
    let body;
    if (state === 'loading') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8b3e24dbbac64362), {
        label: labels.loading,
        "data-testid": tid('loading'),
        className: "flex flex-col",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8f31e4c4a37b8e9c), {
        height: "auto",
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
        style: {
            ...canvasStyle,
            background: undefined
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8f31e4c4a37b8e9c), {
        height: "2.75rem",
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control
    }));
    else if (state === 'error') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
        "data-testid": tid('error'),
        title: typeof error === 'string' ? error : labels.error,
        onRetry: onRetry,
        retryLabel: labels.retry
    });
    else if (state === 'empty') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
        "data-testid": tid('empty'),
        title: labels.empty
    });
    else {
        const transform = `translate(${pan.x}px, ${pan.y}px) scale(${zoom})`;
        body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: stageRef,
            role: "img",
            "aria-roledescription": labels.viewport,
            "aria-label": frameText,
            tabIndex: 0,
            "data-testid": tid('stage'),
            "data-frame-state": frameState,
            "data-zoom": String(Math.round(zoom * 100) / 100),
            onKeyDown: onKeyDown,
            onPointerDown: onPointerDown,
            onPointerMove: onPointerMove,
            onPointerUp: onPointerUp,
            onPointerCancel: onPointerUp,
            onDoubleClick: resetView,
            className: "outline-none focus-visible:ring-2 focus-visible:ring-ring",
            style: {
                ...canvasStyle,
                touchAction: 'none',
                userSelect: 'none',
                cursor: zoom > 1 ? 'grab' : 'ns-resize'
            }
        }, shownUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
            src: shownUrl,
            alt: "",
            draggable: false,
            "data-testid": tid('image'),
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0,
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                transform: transform,
                transformOrigin: 'center',
                opacity: frameState === 'ready' ? 1 : 0.6,
                pointerEvents: 'none'
            }
        }) : frameState === 'loading' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8f31e4c4a37b8e9c), {
            tone: "onDark",
            width: "100%",
            height: "100%",
            radius: 0,
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0
            }
        }) : null, frameState === 'loading' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": tid('frame-loading'),
            className: "flex items-center justify-center",
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0,
                pointerEvents: 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
            size: 28,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            label: labels.loading
        })) : null, frameState === 'error' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('frame-error'),
            className: "flex flex-col items-center justify-center text-center",
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0,
                gap: '0.75rem',
                paddingInline: '1rem',
                background: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink, 0.7),
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            role: "alert",
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600
            }
        }, labels.error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            type: "button",
            variant: "outline",
            size: "sm",
            className: $cb5da664f84994ea$var$TOUCH_TARGET,
            onClick: retryFrame,
            "data-testid": tid('frame-retry')
        }, labels.retry)) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "flex flex-wrap items-center",
            style: {
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
            variant: "outline",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7f8899ae39ae38a1$export$2e2bcd8739ae039), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.prev,
            onClick: ()=>go(index - 1),
            disabled: index <= 0,
            "data-testid": tid('prev')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            type: "range",
            min: 0,
            max: Math.max(0, n - 1),
            step: 1,
            value: index,
            "aria-label": labels.slider,
            "aria-valuetext": frameText,
            onChange: (e)=>go(Number(e.target.value)),
            disabled: n <= 1,
            "data-testid": tid('slider'),
            className: (0, $42e05640dae453c1$export$1343a74baacb0543)('outline-none focus-visible:ring-2 focus-visible:ring-ring', $cb5da664f84994ea$var$TOUCH_TARGET),
            style: {
                flex: '1 1 8rem',
                minWidth: 0,
                minHeight: '2.25rem',
                accentColor: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
            variant: "outline",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dc4be5d9d5a360aa$export$2e2bcd8739ae039), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.next,
            onClick: ()=>go(index + 1),
            disabled: index >= n - 1,
            "data-testid": tid('next')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-live": "polite",
            "aria-atomic": "true",
            "data-testid": tid('counter'),
            className: "tabular-nums",
            style: {
                fontSize: '0.75rem',
                fontWeight: 600,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                whiteSpace: 'nowrap'
            }
        }, frameText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "flex items-center",
            style: {
                gap: '0.25rem',
                marginInlineStart: 'auto'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
            variant: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a481aded68921702$export$2e2bcd8739ae039), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.zoomOut,
            onClick: ()=>zoomTo(zoom / $cb5da664f84994ea$var$ZOOM_STEP),
            disabled: zoom <= $cb5da664f84994ea$var$MIN_ZOOM,
            "data-testid": tid('zoom-out')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
            variant: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $191016e022d4d457$export$2e2bcd8739ae039), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.zoomIn,
            onClick: ()=>zoomTo(zoom * $cb5da664f84994ea$var$ZOOM_STEP),
            disabled: zoom >= $cb5da664f84994ea$var$MAX_ZOOM,
            "data-testid": tid('zoom-in')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
            variant: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c96e72789512f0bb$export$2e2bcd8739ae039), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.reset,
            onClick: resetView,
            disabled: zoom === 1 && pan.x === 0 && pan.y === 0,
            "data-testid": tid('reset')
        }))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-state": state,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex flex-col', className),
        style: {
            gap: '0.625rem',
            minWidth: 0,
            ...style
        },
        ...rest
    }, banner, state !== 'loading' ? seriesStrip : null, state !== 'loading' ? presetControl : null, body, caption ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "m-0",
        style: {
            fontSize: '0.71875rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            lineHeight: 1.5
        }
    }, caption) : null);
}



var $acw62 = parcelRequire("acw62");


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// FilterChip — one toggleable filter in a chip row (category, type, status).
//
// Distinct from `ChipSelector`, which is a *form field* (label, validation,
// helper text, a value the user submits). This is a **view filter**: it narrows
// what a list shows, lives in a toolbar rather than a form, and reports its
// state through `aria-pressed` — the correct semantics for a toggle button, and
// the reason the two are not one component.
//
// Sized for touch by default (`min-h-11` = 2.75rem), because the phone is where
// chip rows are used most and a sub-44px target is a defect there. `count` is a
// node, not a number, so the caller formats digits in its own locale.
// ─────────────────────────────────────────────────────────────────────────────
const $4f5f0e3d96e18162$var$FilterChip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, count: count, active: active = false, onClick: onClick, disabled: disabled, className: className, children: children, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        ref: ref,
        type: "button",
        variant: active ? 'subtle' : 'outline',
        size: "sm",
        "aria-pressed": active,
        disabled: disabled,
        onClick: onClick,
        "data-state": active ? 'active' : 'inactive',
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('min-h-11 shrink-0 rounded-full gap-1', className),
        ...rest
    }, label ?? children, count != null && count !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-[0.625rem] opacity-70"
    }, "(", count, ")")));
$4f5f0e3d96e18162$var$FilterChip.displayName = 'FilterChip';
var $4f5f0e3d96e18162$export$2e2bcd8739ae039 = $4f5f0e3d96e18162$var$FilterChip;



var $acw62 = parcelRequire("acw62");


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Sparkline — an inline, axis-less trend glyph for a short numeric series.
//
// The smallest data-viz unit in the system: it rides inside a row or a tile to
// answer «is this going up or down?» without spending a chart's worth of space.
// It is deliberately unlabelled — the row already carries the name, the value
// and the unit, and the glyph only has to show shape.
//
// Tones resolve from the token set, so a sparkline never invents a colour:
// `accent` for an in-range series, `danger`/`warn` when the caller has already
// judged the latest reading out of range.
//
// Empty appearance (by design): fewer than two numeric points cannot describe a
// trend, so the glyph renders nothing at all rather than a misleading flat line.
// ─────────────────────────────────────────────────────────────────────────────
const $91c948f90369c6a3$var$TONES = {
    accent: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent,
    danger: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger,
    warn: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn,
    good: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).good,
    mute: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
};
const $91c948f90369c6a3$var$Sparkline = ({ points: points = [], width: width = 72, height: height = 26, tone: tone = 'accent', strokeWidth: strokeWidth = 1.5, showLast: showLast = true, className: className, style: style, ...rest })=>{
    const vals = (points || []).map((p)=>typeof p === 'number' ? p : parseFloat(p)).filter((v)=>!Number.isNaN(v));
    if (vals.length < 2) return null;
    const min = Math.min(...vals);
    const max = Math.max(...vals);
    // A flat series would divide by zero; pad it so the line sits mid-height.
    const pad = (max - min) * 0.15 || 1;
    const lo = min - pad;
    const hi = max + pad;
    const xOf = (i)=>i / (vals.length - 1) * width;
    const yOf = (v)=>height - (v - lo) / (hi - lo) * height;
    const path = vals.map((v, i)=>`${xOf(i).toFixed(1)},${yOf(v).toFixed(1)}`).join(' ');
    const stroke = $91c948f90369c6a3$var$TONES[tone] || $91c948f90369c6a3$var$TONES.accent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        // Time always reads left→right, including on an RTL page.
        style: {
            direction: 'ltr',
            overflow: 'visible',
            display: 'block',
            flexShrink: 0,
            ...style
        },
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        "aria-hidden": true,
        focusable: "false",
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: path,
        fill: "none",
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeLinejoin: "round",
        strokeLinecap: "round"
    }), showLast && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: xOf(vals.length - 1),
        cy: yOf(vals[vals.length - 1]),
        r: "2.5",
        fill: stroke
    }));
};
var $91c948f90369c6a3$export$2e2bcd8739ae039 = $91c948f90369c6a3$var$Sparkline;



var $acw62 = parcelRequire("acw62");


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// TrendChart — the full-size counterpart to `Sparkline`: one numeric series over
// time, with an optional reference band and per-point status.
//
// It is the system's answer to «show me this measurement's history» — a lab
// analyte, a vital sign, a wallet balance, a clinic's daily revenue. It stays
// presentational: the caller normalises its data to `readings` and decides what
// «abnormal» means; the chart only draws.
//
//   readings   [{ value, date?, status? }]  — chronological, oldest first
//   refLow/refHigh                          — optional reference band + guides
//   formatX(reading, index)                 — axis label; the caller owns the
//                                             locale (Jalali dates, digits…)
//   formatValue(v)                          — value-axis label; same reason —
//                                             digits follow the UI locale, and
//                                             only the app knows what that is
//   emptyLabel                              — copy for the not-enough-data state;
//                                             omitted ⇒ silent blank of the same
//                                             height, so layout never jumps
//
// Status → colour uses the semantic tokens and accepts either casing, because
// clinical back-ends disagree about it (`ABNORMAL` vs `abnormal`).
// ─────────────────────────────────────────────────────────────────────────────
const $b7b57ad44712e2b0$var$STATUS_TONE = {
    abnormal: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn,
    ABNORMAL: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn,
    critical: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger,
    CRITICAL: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger
};
const $b7b57ad44712e2b0$var$VIEWBOX_W = 520;
const $b7b57ad44712e2b0$var$PAD = {
    t: 12,
    r: 16,
    b: 36,
    l: 46
};
const $b7b57ad44712e2b0$var$TrendChart = ({ readings: readings = [], color: color = (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent, refLow: refLow, refHigh: refHigh, height: height = 160, gridLines: gridLines = 4, formatX: formatX, formatValue: formatValue = (v)=>v.toFixed(1), emptyLabel: emptyLabel, className: className, style: style, ...rest })=>{
    const numeric = (readings || []).map((r)=>({
            ...r,
            num: typeof r?.value === 'number' ? r.value : parseFloat(r?.value)
        }));
    const plottable = numeric.filter((r)=>!Number.isNaN(r.num));
    if (plottable.length < 2) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        "data-state": "empty",
        style: {
            height: height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.75rem',
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
            ...style
        },
        ...rest
    }, emptyLabel || null);
    const nums = plottable.map((r)=>r.num);
    const dataMin = Math.min(...nums);
    const dataMax = Math.max(...nums);
    const span = dataMax - dataMin;
    // Include the reference band in the visible window, then breathe by 15% (or a
    // flat ±2 when every reading is identical and the span is 0).
    const lo = Math.min(dataMin, refLow ?? dataMin) - (span * 0.15 || 2);
    const hi = Math.max(dataMax, refHigh ?? dataMax) + (span * 0.15 || 2);
    const range = hi - lo || 1;
    const H = height;
    const cw = $b7b57ad44712e2b0$var$VIEWBOX_W - $b7b57ad44712e2b0$var$PAD.l - $b7b57ad44712e2b0$var$PAD.r;
    const ch = H - $b7b57ad44712e2b0$var$PAD.t - $b7b57ad44712e2b0$var$PAD.b;
    const xOf = (i)=>$b7b57ad44712e2b0$var$PAD.l + i / (plottable.length - 1) * cw;
    const yOf = (v)=>$b7b57ad44712e2b0$var$PAD.t + ch - (v - lo) / range * ch;
    const path = plottable.map((r, i)=>`${xOf(i).toFixed(1)},${yOf(r.num).toFixed(1)}`).join(' ');
    const xStep = Math.max(1, Math.floor(plottable.length / 5));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${$b7b57ad44712e2b0$var$VIEWBOX_W} ${H}`,
        // Decorative by contract: every screen that plots a series also lists the
        // readings, and the list is the accessible equivalent (§12).
        "aria-hidden": true,
        focusable: "false",
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        "data-state": "content",
        // A time axis reads left→right regardless of the page's direction.
        style: {
            width: '100%',
            height: H,
            display: 'block',
            overflow: 'visible',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, refLow != null && refHigh != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: $b7b57ad44712e2b0$var$PAD.l,
        y: yOf(refHigh),
        width: cw,
        height: Math.abs(yOf(refLow) - yOf(refHigh)),
        fill: (0, $e7c165fb515b04ea$export$7bce9182245b1545)(color, 0.08),
        rx: "2"
    }), Array.from({
        length: gridLines + 1
    }, (_, i)=>{
        const v = lo + range / gridLines * i;
        const y = yOf(v);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
            x1: $b7b57ad44712e2b0$var$PAD.l,
            x2: $b7b57ad44712e2b0$var$PAD.l + cw,
            y1: y,
            y2: y,
            stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).border,
            strokeWidth: "1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: $b7b57ad44712e2b0$var$PAD.l - 5,
            y: y + 4,
            textAnchor: "end",
            fontSize: "10",
            fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
        }, formatValue(v)));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: path,
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinejoin: "round",
        strokeLinecap: "round"
    }), plottable.map((r, i)=>{
        const cx = xOf(i);
        const cy = yOf(r.num);
        const dot = $b7b57ad44712e2b0$var$STATUS_TONE[r.status] || color;
        const label = i % xStep === 0 && formatX ? formatX(r, i) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: r.id ?? i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            cx: cx,
            cy: cy,
            r: "4",
            fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            stroke: dot,
            strokeWidth: "2"
        }), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: cx,
            y: H - 6,
            textAnchor: "middle",
            fontSize: "9",
            fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
        }, label));
    }), refHigh != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
        x: $b7b57ad44712e2b0$var$PAD.l + cw + 4,
        y: yOf(refHigh) + 4,
        fontSize: "9",
        fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
    }, formatValue(refHigh)), refLow != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
        x: $b7b57ad44712e2b0$var$PAD.l + cw + 4,
        y: yOf(refLow) + 4,
        fontSize: "9",
        fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
    }, formatValue(refLow)));
};
var $b7b57ad44712e2b0$export$2e2bcd8739ae039 = $b7b57ad44712e2b0$var$TrendChart;



var $acw62 = parcelRequire("acw62");


// ─────────────────────────────────────────────────────────────────────────────
// timeScale — the shared time→pixel mapping behind the kit's timeline charts.
//
// A timeline is only useful when every lane agrees on the clock: the whole
// point of stacking a measurement strip over an interval bar is that a vertical
// line means «the same moment». So the scale is computed ONCE by the caller and
// handed to every lane, instead of each chart deriving its own domain from its
// own data (which would silently misalign lanes with different date coverage).
//
// Domain-free by contract: milliseconds in, viewBox units out. The kit never
// decides what a date *means* — locale, calendar and label text stay with the
// app (the same division `TrendChart.formatX` already draws).
// ─────────────────────────────────────────────────────────────────────────────
// A linear scale over [min,max] → [padStart, width-padEnd].
//
//   scale.x(t)        → viewBox x for a timestamp (ms)
//   scale.invert(px)  → timestamp for a viewBox x
//   scale.clampX(t)   → x, clamped into the plot area (bars that start before
//                       the window still render, flush to the edge)
//   scale.inWindow(t) → is this timestamp inside the visible domain
function $95e851aef96b9382$export$27d74465d4d4bf01({ min: min, max: max, width: width, padStart: padStart = 0, padEnd: padEnd = 0 }) {
    const span = max - min || 1;
    const x0 = padStart;
    const x1 = Math.max(padStart + 1, width - padEnd);
    const w = x1 - x0;
    const x = (t)=>x0 + (t - min) / span * w;
    return {
        min: min,
        max: max,
        x0: x0,
        x1: x1,
        width: w,
        x: x,
        clampX: (t)=>Math.min(x1, Math.max(x0, x(t))),
        invert: (px)=>min + (px - x0) / w * span,
        inWindow: (t)=>t >= min && t <= max
    };
}
function $95e851aef96b9382$export$b9a1c56e49c8e590(min, max, count = 6) {
    const step = (max - min) / Math.max(1, count);
    return Array.from({
        length: count + 1
    }, (_, i)=>min + step * i);
}
function $95e851aef96b9382$export$849b7cb2b6ea39a7(points, scale, minGapPx = 8, isSignificant) {
    if (!points || points.length < 3) return points || [];
    const out = [];
    let lastX = -Infinity;
    points.forEach((p, i)=>{
        const px = scale.x(p.x);
        const keep = i === 0 || i === points.length - 1 || (isSignificant ? isSignificant(p) : false) || px - lastX >= minGapPx;
        if (keep) {
            out.push(p);
            lastX = px;
        }
    });
    return out;
}



var $acw62 = parcelRequire("acw62");

'use client';
const $33096ab4a7258714$export$52ff61eca6e84e5a = ({ scale: scale, ticks: ticks, top: top = 0, bottom: bottom })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        "aria-hidden": true
    }, (ticks || []).map((t, i)=>{
        if (!scale.inWindow(t)) return null;
        const x = Math.round(scale.x(t)) + 0.5; // crisp hairline
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
            key: i,
            "data-chrome": "grid",
            x1: x,
            x2: x,
            y1: top,
            y2: bottom,
            stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).border,
            strokeWidth: "1"
        });
    }));
const $33096ab4a7258714$export$cb94255ec4be9f06 = ({ scale: scale, at: at, top: top = 0, bottom: bottom })=>{
    if (at == null || !scale.inWindow(at)) return null;
    const x = Math.round(scale.x(at)) + 0.5;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        "data-chrome": "now",
        x1: x,
        x2: x,
        y1: top,
        y2: bottom,
        stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent,
        strokeWidth: "1",
        opacity: "0.9",
        "aria-hidden": true
    });
};
const $33096ab4a7258714$export$5c09e766dd7f9830 = ({ scale: scale, at: at, top: top = 0, bottom: bottom })=>{
    if (at == null || !scale.inWindow(at)) return null;
    const x = Math.round(scale.x(at)) + 0.5;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        "data-chrome": "cursor",
        x1: x,
        x2: x,
        y1: top,
        y2: bottom,
        stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
        strokeWidth: "1",
        opacity: "0.75",
        "aria-hidden": true
    });
};
const $33096ab4a7258714$export$348dc3495f07d294 = (status, fallback)=>{
    const s = String(status || '').toLowerCase();
    if (s === 'critical') return (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger;
    if (s === 'abnormal' || s === 'high' || s === 'low' || s === 'h' || s === 'l') return (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn;
    return fallback;
};
const $33096ab4a7258714$export$3b8c55d8340f8b88 = {
    start: 44,
    end: 12
};


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// TimeRuler — the clock a stack of timeline lanes shares.
//
// It draws the tick labels once, at the top of the stack, so the lanes beneath
// stay pure plot. The caller owns the calendar: it supplies the tick
// timestamps and `formatTick`, exactly as `TrendChart.formatX` already does —
// the kit never decides that a boundary is a Jalali month rather than a week.
//
// Time reads left→right even on an RTL page (`direction: ltr`), the convention
// `Sparkline` and `TrendChart` already set; the surrounding labels stay RTL.
//
//   scale     — from createTimeScale, or pass xMin/xMax/width and let it build
//   ticks     — timestamps (ms) to label
//   formatTick(t, i) → node
//   nowAt     — timestamp of «now», drawn as the accent boundary
//   cursorAt  — synced crosshair position
//   markers   — optional [{ t, tone, shape, label }] event dots riding the axis
// ─────────────────────────────────────────────────────────────────────────────
const $88ed18dfb45d0422$var$TimeRuler = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, ticks: ticks = [], formatTick: formatTick, nowAt: nowAt, cursorAt: cursorAt, markers: markers, height: height = 52, labelGap: labelGap = 56, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $95e851aef96b9382$export$27d74465d4d4bf01)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).start,
        padEnd: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).end
    });
    const axisY = height - 18;
    // Labels thin out rather than collide: a tick keeps its gridline always, but
    // only prints its label when it clears the previous printed one. The newest
    // boundary is the anchor a reader looks for, so labelling walks from the end.
    const labelled = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const keep = new Set();
        let lastX = Infinity;
        for(let i = ticks.length - 1; i >= 0; i -= 1){
            const t = ticks[i];
            if (!scale.inWindow(t)) continue;
            const x = scale.x(t);
            if (lastX - x >= labelGap) {
                keep.add(i);
                lastX = x;
            }
        }
        return keep;
    }, [
        ticks,
        scale,
        labelGap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${height}`,
        width: width,
        height: height,
        preserveAspectRatio: "xMinYMid meet",
        // Decorative by contract (DESIGN.md data-viz rule): the readout and the
        // table view carry the same information for assistive tech.
        "aria-hidden": true,
        focusable: "false",
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$52ff61eca6e84e5a), {
        scale: scale,
        ticks: ticks,
        top: 0,
        bottom: axisY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$cb94255ec4be9f06), {
        scale: scale,
        at: nowAt,
        top: 0,
        bottom: axisY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$5c09e766dd7f9830), {
        scale: scale,
        at: cursorAt,
        top: 0,
        bottom: axisY
    }), (markers || []).map((m, i)=>{
        if (!scale.inWindow(m.t)) return null;
        const cx = scale.x(m.t);
        const cy = axisY - 20;
        if (m.shape === 'cross') {
            const r = 4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                key: m.id ?? i,
                stroke: m.tone || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                strokeWidth: "1.6",
                strokeLinecap: "round"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
                x1: cx - r,
                y1: cy - r,
                x2: cx + r,
                y2: cy + r
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
                x1: cx - r,
                y1: cy + r,
                x2: cx + r,
                y2: cy - r
            }));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            key: m.id ?? i,
            cx: cx,
            cy: cy,
            r: "4.5",
            fill: m.filled ? m.tone || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            stroke: m.tone || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
            strokeWidth: "2"
        });
    }), formatTick && ticks.map((t, i)=>{
        if (!labelled.has(i)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            key: i,
            x: scale.x(t),
            y: height - 5,
            textAnchor: "middle",
            fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
            style: {
                fontSize: '0.625rem'
            }
        }, formatTick(t, i));
    }));
};
var $88ed18dfb45d0422$export$2e2bcd8739ae039 = $88ed18dfb45d0422$var$TimeRuler;



var $acw62 = parcelRequire("acw62");




'use client';
// ─────────────────────────────────────────────────────────────────────────────
// SeriesLane — one measurement plotted against a SHARED time axis.
//
// The time-domain sibling of `TrendChart`. The two are deliberately different
// components rather than one with a mode, because they answer different
// questions and their x-axes are not the same kind of thing:
//
//   TrendChart  — one series, standalone, points spaced by INDEX. «How has this
//                 analyte moved?» Even spacing is a feature there: it spends
//                 every pixel on shape, and a lone chart has nothing to align to.
//   SeriesLane  — points sit at their real TIMESTAMPS on a domain the caller
//                 owns, so several lanes stack into one timeline and a vertical
//                 line means «the same moment» in all of them.
//
// Multiple series per lane are for the components of ONE measurement (systolic
// and diastolic), never for unrelated metrics: those get their own lane with
// their own value scale. Two unrelated measures sharing one y-axis is the
// dual-axis mistake, and it invents correlations that are not in the data.
//
//   series      — [{ points:[{x,y,status?,id?}], color?, label? }] (x = ms, sorted)
//   refLow/High — reference band + the window it must stay inside
//   ticks       — the shared gridline timestamps
//   formatValue — value-axis labels; the caller owns the locale/digits
// ─────────────────────────────────────────────────────────────────────────────
const $db32618d5eb876e6$var$PAD_TOP = 10;
const $db32618d5eb876e6$var$PAD_BOTTOM = 8;
const $db32618d5eb876e6$var$SeriesLane = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, series: series = [], refLow: refLow, refHigh: refHigh, height: height = 88, ticks: ticks = [], nowAt: nowAt, cursorAt: cursorAt, gridLines: gridLines = 2, formatValue: formatValue = (v)=>String(Math.round(v * 10) / 10), emptyLabel: emptyLabel, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $95e851aef96b9382$export$27d74465d4d4bf01)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).start,
        padEnd: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).end
    });
    const lanes = (series || []).map((s)=>({
            ...s,
            points: (s.points || []).filter((p)=>p && Number.isFinite(p.y))
        })).filter((s)=>s.points.length);
    const all = lanes.flatMap((s)=>s.points.map((p)=>p.y));
    if (!all.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        "data-state": "empty",
        style: {
            height: height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.6875rem',
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
            ...style
        },
        ...rest
    }, emptyLabel || null);
    // The value window always contains the reference band: a result is read
    // against its range, so a band pushed off-canvas would hide the very thing
    // that makes the number mean something.
    const dataMin = Math.min(...all, refLow ?? Infinity);
    const dataMax = Math.max(...all, refHigh ?? -Infinity);
    const span = dataMax - dataMin;
    const lo = dataMin - (span * 0.18 || Math.abs(dataMin * 0.1) || 1);
    const hi = dataMax + (span * 0.18 || Math.abs(dataMax * 0.1) || 1);
    const range = hi - lo || 1;
    const plotTop = $db32618d5eb876e6$var$PAD_TOP;
    const plotBottom = height - $db32618d5eb876e6$var$PAD_BOTTOM;
    const yOf = (v)=>plotTop + (plotBottom - plotTop) - (v - lo) / range * (plotBottom - plotTop);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${height}`,
        width: width,
        height: height,
        preserveAspectRatio: "xMinYMid meet",
        "aria-hidden": true,
        focusable: "false",
        "data-state": "content",
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, refLow != null && refHigh != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: scale.x0,
        y: yOf(refHigh),
        width: scale.x1 - scale.x0,
        height: Math.max(1, Math.abs(yOf(refLow) - yOf(refHigh))),
        fill: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent, 0.09)
    }), Array.from({
        length: gridLines + 1
    }, (_, i)=>{
        const v = lo + range / gridLines * i;
        const y = Math.round(yOf(v)) + 0.5;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: `g${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
            x1: scale.x0,
            x2: scale.x1,
            y1: y,
            y2: y,
            stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).border,
            strokeWidth: "1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: scale.x0 - 6,
            y: y + 3,
            textAnchor: "end",
            fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
            style: {
                fontSize: '0.5625rem'
            }
        }, formatValue(v)));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$52ff61eca6e84e5a), {
        scale: scale,
        ticks: ticks,
        top: plotTop,
        bottom: plotBottom
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$cb94255ec4be9f06), {
        scale: scale,
        at: nowAt,
        top: plotTop,
        bottom: plotBottom
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$5c09e766dd7f9830), {
        scale: scale,
        at: cursorAt,
        top: plotTop,
        bottom: plotBottom
    }), lanes.map((s, si)=>{
        const color = s.color || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent;
        const inWin = s.points.filter((p)=>p.x >= scale.min && p.x <= scale.max);
        if (!inWin.length) return null;
        const path = inWin.map((p)=>`${scale.x(p.x).toFixed(1)},${yOf(p.y).toFixed(1)}`).join(' ');
        // Dots thin when dense, but an out-of-range reading is never thinned
        // away — the abnormal point is the one the doctor came for.
        const dots = (0, $95e851aef96b9382$export$849b7cb2b6ea39a7)(inWin, scale, 9, (p)=>!!p.status && p.status !== 'normal');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: s.id ?? si
        }, inWin.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
            points: path,
            fill: "none",
            stroke: color,
            strokeWidth: "2",
            strokeLinejoin: "round",
            strokeLinecap: "round"
        }), dots.map((p, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
                key: p.id ?? i,
                cx: scale.x(p.x),
                cy: yOf(p.y),
                r: "3.5",
                fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
                stroke: (0, $33096ab4a7258714$export$348dc3495f07d294)(p.status, color),
                strokeWidth: "2"
            })));
    }));
};
var $db32618d5eb876e6$export$2e2bcd8739ae039 = $db32618d5eb876e6$var$SeriesLane;



var $acw62 = parcelRequire("acw62");




'use client';
// ─────────────────────────────────────────────────────────────────────────────
// IntervalBars — spans of time as bars on a shared axis (a Gantt lane).
//
// Some facts are not points: a prescription is an exposure window, a shift is a
// span of coverage. Plotted as intervals against the same clock as the
// measurement lanes, they answer the question a dot never can — «was this
// running while that changed?».
//
//   rows  — [{ id, label, segments: [{ from, to, label?, tone?, open? }] }]
//           `to == null` (or open) ⇒ still running: the bar reaches `nowAt`
//           and takes an arrow cap instead of a flat end.
//
// Adjacent segments of one row are separated by a 2px gap in the surface
// colour — never a stroke around the bar: the gap is the separator, a border
// would add ink that is not data. That gap is also how a dosage change reads
// as a change rather than one long uninterrupted bar.
// ─────────────────────────────────────────────────────────────────────────────
const $c413dd52a563653b$var$SEG_GAP = 2;
// SVG has no text-overflow, and slicing a string is the wrong tool for a label
// that may be RTL: cutting Persian text and appending «…» puts the ellipsis on
// the visually *leading* edge, so the label reads as though its beginning were
// missing. So a label is drawn only when it fits whole (measure-free estimate at
// the label's font size, ~6.2px/char for the mixed fa/Latin names this carries);
// otherwise it is dropped and the value lives in the row header and the table.
// «A label that won't fit doesn't get clipped.»
const $c413dd52a563653b$var$CHAR_W = 6.2;
const $c413dd52a563653b$var$labelFits = (label, room)=>String(label).length * $c413dd52a563653b$var$CHAR_W <= room;
const $c413dd52a563653b$var$IntervalBars = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, rows: rows = [], rowHeight: rowHeight = 26, barThickness: barThickness = 15, height: height, ticks: ticks = [], nowAt: nowAt, cursorAt: cursorAt, formatLabel: formatLabel, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $95e851aef96b9382$export$27d74465d4d4bf01)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).start,
        padEnd: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).end
    });
    const h = height || Math.max(rowHeight, rows.length * rowHeight + 8);
    const r = barThickness / 2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${h}`,
        width: width,
        height: h,
        preserveAspectRatio: "xMinYMid meet",
        "aria-hidden": true,
        focusable: "false",
        "data-state": rows.length ? 'content' : 'empty',
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$52ff61eca6e84e5a), {
        scale: scale,
        ticks: ticks,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$cb94255ec4be9f06), {
        scale: scale,
        at: nowAt,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$5c09e766dd7f9830), {
        scale: scale,
        at: cursorAt,
        top: 0,
        bottom: h
    }), rows.map((row, ri)=>{
        const cy = 4 + ri * rowHeight + rowHeight / 2;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: row.id ?? ri
        }, (row.segments || []).map((seg, si)=>{
            const open = seg.open || seg.to == null;
            const rawTo = open ? nowAt ?? scale.max : seg.to;
            if (seg.from > scale.max || rawTo < scale.min) return null;
            const x1 = scale.clampX(seg.from);
            // The gap belongs to every segment but the row's last one.
            const isLast = si === row.segments.length - 1;
            const x2 = Math.max(x1 + 2, scale.clampX(rawTo) - (isLast ? 0 : $c413dd52a563653b$var$SEG_GAP));
            const w = Math.max(2, x2 - x1);
            const tone = seg.tone || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).navy;
            const label = formatLabel ? formatLabel(seg, row) : seg.label;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                key: seg.id ?? si
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                x: x1,
                y: cy - r,
                width: w,
                height: barThickness,
                rx: Math.min(4, r),
                fill: tone
            }), open && scale.inWindow(rawTo) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: `M${x2 - 1},${cy - r} L${x2 + 6},${cy} L${x2 - 1},${cy + r} Z`,
                fill: tone
            }), label && w > 52 && $c413dd52a563653b$var$labelFits(label, w - 14) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
                x: x1 + w / 2,
                y: cy + 3.5,
                textAnchor: "middle",
                fill: "#ffffff",
                style: {
                    fontSize: '0.625rem',
                    fontWeight: 700,
                    direction: 'rtl'
                }
            }, label));
        }));
    }));
};
var $c413dd52a563653b$export$2e2bcd8739ae039 = $c413dd52a563653b$var$IntervalBars;



var $acw62 = parcelRequire("acw62");




'use client';
// ─────────────────────────────────────────────────────────────────────────────
// EventMarkers — discrete moments on a shared time axis.
//
// The lane for things that happen rather than things that are measured: a
// diagnosis recorded, an order placed, a document filed. Each mark carries its
// identity in its SHAPE and its row as well as its tone, so the lane still
// reads under colour-blindness, in monochrome print, and — the case that
// actually bites — under an accent preset where two brand hues sit close
// together. Colour reinforces identity here; it never carries it alone.
//
//   events — [{ id, t, row, label, tone, shape }]
//            shape: 'triangle' | 'diamond' | 'circle' | 'square'
//            row:   0-based lane row (events of a kind share a row)
//
// Labels are placed left→right and only when they clear the previous label on
// the same row; the rest stay reachable through the crosshair readout and the
// table view. A dense month is normal for a sick patient, and overlapping
// labels would make exactly those months unreadable.
// ─────────────────────────────────────────────────────────────────────────────
const $b578d6619b9c2e00$var$SHAPES = {
    triangle: (cx, cy, s)=>`M${cx},${cy - s} L${cx + s},${cy + s * 0.8} L${cx - s},${cy + s * 0.8} Z`,
    diamond: (cx, cy, s)=>`M${cx},${cy - s} L${cx + s},${cy} L${cx},${cy + s} L${cx - s},${cy} Z`,
    square: (cx, cy, s)=>`M${cx - s},${cy - s} L${cx + s},${cy - s} L${cx + s},${cy + s} L${cx - s},${cy + s} Z`
};
const $b578d6619b9c2e00$var$CHAR_W = 5.6;
const $b578d6619b9c2e00$var$EventMarkers = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, events: events = [], rows: rows = 1, rowHeight: rowHeight = 22, height: height, size: size = 5, ticks: ticks = [], nowAt: nowAt, cursorAt: cursorAt, showLabels: showLabels = true, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $95e851aef96b9382$export$27d74465d4d4bf01)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).start,
        padEnd: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).end
    });
    const h = height || rows * rowHeight + 10;
    // Declutter per row, walking forward; `labelEnd` tracks where the last
    // printed label finished so the next one only prints if it clears it.
    const placed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const rowEnd = {};
        return [
            ...events
        ].filter((e)=>scale.inWindow(e.t)).sort((a, b)=>a.t - b.t).map((e)=>{
            const x = scale.x(e.t);
            const row = e.row || 0;
            const textW = String(e.label || '').length * $b578d6619b9c2e00$var$CHAR_W;
            const start = x + 9;
            const show = showLabels && !!e.label && start >= (rowEnd[row] ?? -Infinity) + 8;
            if (show) rowEnd[row] = start + textW;
            return {
                ...e,
                x: x,
                row: row,
                showLabel: show
            };
        });
    }, [
        events,
        scale,
        showLabels
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${h}`,
        width: width,
        height: h,
        preserveAspectRatio: "xMinYMid meet",
        "aria-hidden": true,
        focusable: "false",
        "data-state": events.length ? 'content' : 'empty',
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$52ff61eca6e84e5a), {
        scale: scale,
        ticks: ticks,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$cb94255ec4be9f06), {
        scale: scale,
        at: nowAt,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$5c09e766dd7f9830), {
        scale: scale,
        at: cursorAt,
        top: 0,
        bottom: h
    }), placed.map((e, i)=>{
        const cy = 6 + e.row * rowHeight + rowHeight / 2;
        const tone = e.tone || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent;
        const path = $b578d6619b9c2e00$var$SHAPES[e.shape];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: e.id ?? i
        }, path ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: path(e.x, cy, size + 1),
            fill: tone,
            stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            strokeWidth: "1.5"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            cx: e.x,
            cy: cy,
            r: size,
            fill: tone,
            stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            strokeWidth: "1.5"
        }), e.showLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: e.x + 9,
            y: cy + 3.5,
            fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2,
            style: {
                fontSize: '0.625rem'
            }
        }, e.label));
    }));
};
var $b578d6619b9c2e00$export$2e2bcd8739ae039 = $b578d6619b9c2e00$var$EventMarkers;




var $acw62 = parcelRequire("acw62");
'use client';
function $28afc58f3cd2c6a9$export$7266b1e659c4866f(initial = 640) {
    const [width, setWidth] = (0, $acw62.useState)(initial);
    const observerRef = (0, $acw62.useRef)(null);
    const ref = (0, $acw62.useCallback)((node)=>{
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }
        // Expose the node on the callback ref itself.
        ref.current = node;
        if (!node) return;
        const read = ()=>{
            const w = node.clientWidth || node.getBoundingClientRect?.().width || 0;
            // Sub-pixel jitter would re-render every lane on every scroll.
            if (w > 0) setWidth((prev)=>Math.abs(prev - w) >= 0.5 ? w : prev);
        };
        read();
        if (typeof ResizeObserver !== 'undefined') {
            const ro = new ResizeObserver(read);
            ro.observe(node);
            observerRef.current = ro;
        }
    }, []);
    return [
        ref,
        width
    ];
}
var $28afc58f3cd2c6a9$export$2e2bcd8739ae039 = $28afc58f3cd2c6a9$export$7266b1e659c4866f;








var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2b71f7c0d2454a8e$export$a2387ed3b5d536eb = {
    name: "clock",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "M12 6v6l4 2",
                key: "mmk7yg"
            }
        ]
    ]
};
$2b71f7c0d2454a8e$export$a2387ed3b5d536eb.node;
const $2b71f7c0d2454a8e$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($2b71f7c0d2454a8e$export$a2387ed3b5d536eb);




'use client';
/**
 * ChatBubble — one message in a conversation (kit-grade per DESIGN-CONCEPT
 * §17.2: tokens only, logical properties only, language-free, presentational).
 *
 * The chat-spec decisions this component encodes so no app re-derives them:
 *
 *  - **Alignment is `alignSelf`, never a margin hack.** `flex-end` for my
 *    messages, `flex-start` for the other party — logical values, so the whole
 *    conversation mirrors correctly under `dir="ltr"` with no direction prop.
 *  - **Radius 14px card scale (`0.875rem`) with a 10px "tail" corner**
 *    (`var(--radius, 0.625rem)`): the reduced corner sits on the block-end,
 *    *inline-start-or-end* edge nearest the sender — `borderEndEndRadius` on
 *    mine, `borderEndStartRadius` on theirs. Logical corners: the tail flips
 *    with the document direction by itself.
 *  - **No `•` separator ever** — the meta row (time + status) is a space-gap
 *    flex layout.
 *  - **A failed write must look failed**: `failed` restyles the surface from
 *    the `CT.danger*` family and renders a retry affordance; the caller decides
 *    when to actually re-send (`onRetry`).
 *  - **Delivery state is never colour-only.** Pass `status` and the bubble
 *    draws the glyph itself — `Clock` / `Check` / `TriangleAlert` — so the
 *    difference between "sending", "sent" and "failed" survives a colour-blind
 *    reader and a greyscale screen (DESIGN-CONCEPT §12 "colour is never the
 *    only carrier of meaning"). Apps do not ship their own dot.
 *
 * States (always stamped on the root as `data-state`): `sent` | `pending`
 * (60% opacity — visibly in flight) | `failed`.
 *
 * The root stays a plain div forwarding `...rest`; `role="listitem"` and any
 * grouping semantics are the caller's business.
 *
 * Props:
 *   body        — message text (rendered `dir="auto"`, pre-wrap, wraps anywhere)
 *   timeLabel   — pre-formatted time string; the calendar/locale stays with the app
 *   mine        — true for the authenticated user's own messages
 *   pending     — in-flight local echo (awaiting the server)
 *   failed      — the send failed; renders the retry affordance when `onRetry` given
 *   status      — 'pending' | 'sent' | 'failed': draws the delivery glyph. This
 *                 is the supported way to show delivery state; `statusLabel`
 *                 names it for screen readers.
 *   statusIcon  — escape hatch: a caller-supplied status node, used INSTEAD of
 *                 the built-in glyph
 *   statusLabel — screen-reader text for the status glyph (an icon alone says
 *                 nothing). NOTE: `statusLabel` on its own draws nothing
 *                 visible — it is the accessible name of a glyph, so it needs
 *                 `status` (or `statusIcon`) beside it. Dev builds warn.
 *   onRetry     — re-send handler; button rendered only when `failed`
 *   retryLabel  — label for the retry affordance
 *   style       — MERGED over the component's own layout, never replacing it
 *   className / data-testid — forwarded to the root (§15.1)
 */ // The delivery vocabulary the kit draws. Three states, three shapes — the
// glyph, not the hue, is what distinguishes them.
const $a6342f4e7688b45e$var$STATUS_GLYPH = {
    pending: (0, $2b71f7c0d2454a8e$export$2e2bcd8739ae039),
    sent: (0, $3fbaf9031554177f$export$2e2bcd8739ae039),
    failed: (0, $f66de94054a4f331$export$2e2bcd8739ae039)
};
function $a6342f4e7688b45e$export$2e2bcd8739ae039({ body: body, timeLabel: timeLabel, mine: mine = false, pending: pending = false, failed: failed = false, status: status, statusIcon: statusIcon, statusLabel: statusLabel, onRetry: onRetry, retryLabel: retryLabel, className: className, style: style, 'data-testid': testId = 'chat-bubble', ...rest }) {
    const state = failed ? 'failed' : pending ? 'pending' : 'sent';
    // Surface per party; `failed` overrides both — an undelivered message is a
    // problem to act on, not a normal bubble at lower opacity.
    const surface = failed ? {
        background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerSoft,
        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk,
        border: `1px solid ${(0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger, 0.4)}`
    } : mine ? {
        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
        color: '#ffffff',
        border: 'none'
    } : {
        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
        border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
    };
    // Meta ink follows the surface. On navy the safe soft ink is literal white at
    // reduced opacity (colour arithmetic on a var() token is banned — soft() would
    // work, but #fff is the one sanctioned literal on navy).
    const metaStyle = failed ? {
        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk,
        opacity: 0.8
    } : mine ? {
        color: '#ffffff',
        opacity: 0.75
    } : {
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
    };
    const Glyph = status ? $a6342f4e7688b45e$var$STATUS_GLYPH[status] : null;
    // Tint: the muted ink for the two quiet states, the danger ink for a failed
    // write. The one exception is the navy `mine` surface, where a fixed grey is
    // simply unreadable — there the glyph inherits the meta row's ink, which is
    // already the muted value FOR that surface. Same intent, legible result.
    const glyphColor = mine && !failed ? 'currentColor' : status === 'failed' ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute;
    const glyph = statusIcon || (Glyph ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Glyph, {
        size: 13,
        strokeWidth: 2.25,
        "aria-hidden": true,
        style: {
            color: glyphColor
        }
    }) : null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: mine ? 'flex-end' : 'flex-start',
            // Alignment via alignSelf ONLY — never marginInline hacks, never textAlign.
            alignSelf: mine ? 'flex-end' : 'flex-start',
            maxWidth: 'min(85%, 42rem)',
            gap: '0.25rem',
            // Caller style MERGES over the computed layout (the `Card` precedent) —
            // spreading it after `...rest` used to silently drop `alignSelf` and
            // take mine/theirs alignment with it.
            ...style
        },
        ...rest,
        // AFTER ...rest: the delivery state is derived, not caller-supplied.
        "data-state": state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...surface,
            borderRadius: '0.875rem',
            // The "tail": the corner nearest the sender drops to the base radius.
            ...mine ? {
                borderEndEndRadius: 'var(--radius, 0.625rem)'
            } : {
                borderEndStartRadius: 'var(--radius, 0.625rem)'
            },
            padding: '0.5rem 0.875rem',
            ...pending && {
                opacity: 0.6
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: '0.875rem',
            lineHeight: 1.8,
            whiteSpace: 'pre-wrap',
            overflowWrap: 'anywhere'
        }
    }, body), (timeLabel || glyph || statusLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '0.375rem',
            marginTop: '0.125rem',
            fontSize: '0.75rem',
            ...metaStyle
        }
    }, timeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, timeLabel), glyph && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "img",
        "aria-label": statusLabel,
        style: {
            display: 'inline-flex',
            alignItems: 'center'
        }
    }, glyph), !glyph && statusLabel && // Misuse (warned above), but the fact is not thrown away: assistive
    // tech still gets the delivery state.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            position: 'absolute',
            width: 1,
            height: 1,
            margin: -1,
            padding: 0,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            clip: 'rect(0 0 0 0)',
            clipPath: 'inset(50%)',
            border: 0
        }
    }, statusLabel))), failed && onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        onClick: onRetry,
        "data-testid": `${testId}-retry`,
        // size="sm" is 2.25rem; this renders on both apps' phone threads,
        // where the floor is 2.75rem (DESIGN-CONCEPT-MOBILE §368).
        className: "min-h-11",
        style: {
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger
        }
    }, retryLabel));
}



var $acw62 = parcelRequire("acw62");

'use client';
function $01fd1e3fa9bffaa8$export$2e2bcd8739ae039({ label: label, className: className, style: style, 'data-testid': testId = 'chat-day-divider', ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            paddingBlock: '0.5rem',
            // Caller style MERGES over the computed layout (the `Card` precedent):
            // arriving inside `...rest` it used to replace `display: flex` outright
            // and collapse the two hairlines.
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            flex: 1,
            height: '1px',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            paddingInline: '0.625rem',
            borderRadius: 'var(--radius, 0.625rem)',
            whiteSpace: 'nowrap'
        }
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            flex: 1,
            height: '1px',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border
        }
    }));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6c49d7be4abd1b80$export$a2387ed3b5d536eb = {
    name: "send",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
                key: "1ffxy3"
            }
        ],
        [
            "path",
            {
                d: "m21.854 2.147-10.94 10.939",
                key: "12cjpa"
            }
        ]
    ]
};
$6c49d7be4abd1b80$export$a2387ed3b5d536eb.node;
const $6c49d7be4abd1b80$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($6c49d7be4abd1b80$export$a2387ed3b5d536eb);






'use client';
function $27c9e9585cb6c9b4$export$2e2bcd8739ae039({ value: value, onChange: onChange, onSend: onSend, disabled: disabled = false, sending: sending = false, placeholder: placeholder, sendLabel: sendLabel, sendIcon: sendIcon, readOnlyNotice: readOnlyNotice, maxLength: maxLength = 4000, autoGrowMaxRem: autoGrowMaxRem = 7.5, className: className, style: style, 'data-testid': testId = 'chat-composer', inputProps: inputProps, ...rest }) {
    const fieldRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Auto-grow: collapse, then take the content's scrollHeight. The rem clamp
    // lives in CSS (`maxHeight`), so the px assignment here never exceeds it and
    // the field starts scrolling instead of growing.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = fieldRef.current;
        if (!el) return;
        el.style.height = 'auto';
        el.style.height = `${el.scrollHeight}px`;
    }, [
        value,
        readOnlyNotice
    ]);
    if (readOnlyNotice) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            padding: '0.5rem 1rem',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            ...style
        },
        ...rest,
        "data-state": "readonly"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $35331361c3270146$export$2e2bcd8739ae039), {
        variant: "info",
        "data-testid": `${testId}-notice`
    }, readOnlyNotice));
    const canSend = !disabled && !sending && Boolean(value && value.trim());
    const handleKeyDown = (e)=>{
        if (e.key !== 'Enter' || e.shiftKey) return;
        // Committing IME composition ends with Enter too — that one is not a send.
        if (e.nativeEvent && e.nativeEvent.isComposing) return;
        e.preventDefault();
        if (canSend) onSend();
    };
    const { className: fieldClassName, style: fieldStyle, ...fieldRest } = inputProps || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'flex-end',
            gap: '0.5rem',
            padding: '0.5rem 1rem',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            // Caller style MERGES over the computed layout (the `Card` precedent).
            ...style
        },
        ...rest,
        // AFTER ...rest: the send lifecycle is the composer's own state.
        "data-state": sending ? 'sending' : 'ready'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        ref: fieldRef,
        value: value,
        onChange: onChange,
        onKeyDown: handleKeyDown,
        placeholder: placeholder,
        "aria-label": placeholder,
        disabled: disabled || sending,
        rows: 1,
        maxLength: maxLength,
        dir: "auto",
        "data-testid": `${testId}-field`,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(// The replacement for the outline we suppress — keyboard focus on the
        // feature's primary input has to be visible (§12.2).
        'outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1', 'transition-shadow duration-150', fieldClassName),
        style: {
            flex: 1,
            minWidth: 0,
            // ≥1rem or iOS zooms the page on focus — the composer's iron rule.
            fontSize: '1rem',
            lineHeight: 1.6,
            fontFamily: 'inherit',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 'var(--radius, 0.625rem)',
            padding: '0.625rem 0.875rem',
            resize: 'none',
            maxHeight: `${autoGrowMaxRem}rem`,
            overflowY: 'auto',
            ...disabled || sending ? {
                opacity: 0.6
            } : null,
            ...fieldStyle
        },
        ...fieldRest
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
        icon: sendIcon || // RTL-first flip — see the header note; LTR apps override via sendIcon.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6c49d7be4abd1b80$export$2e2bcd8739ae039), {
            size: 18,
            "aria-hidden": true,
            style: {
                transform: 'scaleX(-1)'
            }
        }),
        label: sendLabel,
        onClick: ()=>{
            if (canSend) onSend();
        },
        disabled: !canSend,
        "data-testid": `${testId}-send`
    }));
}



var $acw62 = parcelRequire("acw62");



'use client';
/**
 * ChatThread — the message column of a conversation (kit-grade per
 * DESIGN-CONCEPT §17.2). A flex column of `ChatBubble`/`ChatDayDivider`
 * children with the two behaviours every thread needs and no app should
 * re-derive:
 *
 *  - **Backwards pagination is a button, never a scroll trigger** (the
 *    pagination-not-infinite-scroll rule): when `hasOlder`, a ghost expander
 *    sits at the top of the thread; `loadingOlder` disables it and shows the
 *    kit spinner.
 *  - **Containment-safe autoscroll**: when the children count grows and the
 *    user was at/near the bottom (within ~4rem), the thread follows — by
 *    assigning `scrollTop` on the **resolved scroll container**, NEVER
 *    `scrollIntoView`, which walks every ancestor scroller and yanks the whole
 *    page in an embedded pane. A reader scrolled up into history is never
 *    yanked down, and a prepended older page never triggers it.
 *
 * Two containment modes via `fill`:
 *   true  — the thread IS the scroll container (`flex: 1; minHeight: 0;
 *           overflowY: auto`) for a desktop pane (the doctor app's P4 column);
 *   false — the thread sits in page flow and something ABOVE it scrolls.
 *
 * **Resolving the scroller (why this is not `document.scrollingElement`).**
 * In `fill={false}` mode the scroller is whatever ancestor actually scrolls,
 * and on a phone that is almost never the document: both mobile shells are
 * `inset: 0; overflow: hidden` with a single inner `overflow-y: auto` region.
 * Writing `document.scrollingElement.scrollTop` there lands on an element that
 * cannot scroll, and listening on `window` never fires, so the sampled gap
 * stays at its seed and autoscroll is silently dead. So the component walks
 * `containerRef.current.parentElement` upward for a computed `overflowY` of
 * `auto`/`scroll` and uses the first hit — falling back to
 * `document.scrollingElement` for a genuinely page-scrolled surface. The result
 * is cached per mount and re-resolved if the container node itself changes.
 * Callers may name the scroller explicitly with `scrollParentRef` instead.
 *
 * `role="log"` + `aria-live="polite"`: new messages are announced without
 * interrupting, and assistive tech knows earliest-first ordering applies.
 *
 * Exposes `scrollToBottom()` via ref for the caller's "jump to latest"
 * affordances.
 *
 * Props:
 *   children       — the message column (bubbles, day dividers)
 *   fill           — scroll-container mode (see above; default false)
 *   padBlockRem    — block padding in rem. Pass this instead of
 *                    `style={{ paddingBlock }}`: `style` is merged now, but a
 *                    named prop keeps the caller out of the layout entirely.
 *   hasOlder       — render the load-older expander
 *   onLoadOlder    — expander handler
 *   loadingOlder   — expander busy state (disabled + spinner)
 *   loadOlderLabel — expander label
 *   autoScroll     — follow new messages when near the bottom (default true)
 *   scrollParentRef— optional ref to the scroll container, skipping resolution
 *   style          — MERGED over the component's own layout, never replacing it
 *   className / data-testid — forwarded to the root (§15.1)
 */ // "Near the bottom" — ~4rem at the default type scale. Close enough that the
// reader is clearly following the conversation, not studying history.
const $af5a908f2b99a71b$var$NEAR_BOTTOM_PX = 64;
const $af5a908f2b99a71b$var$SCROLLY = new Set([
    'auto',
    'scroll',
    'overlay'
]);
const $af5a908f2b99a71b$var$ChatThread = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function ChatThread({ children: children, fill: fill = false, padBlockRem: padBlockRem, hasOlder: hasOlder = false, onLoadOlder: onLoadOlder, loadingOlder: loadingOlder = false, loadOlderLabel: loadOlderLabel, autoScroll: autoScroll = true, scrollParentRef: scrollParentRef, className: className, style: style, 'data-testid': testId = 'chat-thread', ...rest }, ref) {
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Distance from the bottom edge, sampled on every scroll — read (not
    // recomputed) when children arrive, so the decision reflects where the user
    // WAS before the DOM grew. Starts at 0: opening a thread lands on the latest
    // message.
    const bottomGapRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const prevCountRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    // The resolved scroller, cached per mount, plus the container node it was
    // resolved FROM — a `key` swap gives us a new node and must re-resolve.
    const scrollerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const scrollerForRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Set while a backwards page is being prepended, so the growth it causes is
    // not mistaken for a new message. Without it a short thread — one that never
    // scrolled, so the sampled gap is still its 0 seed — passes the near-bottom
    // guard and yanks the reader away from the «older» button they just pressed.
    const prependingRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children);
    const resolveScroller = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const el = containerRef.current;
        if (!el) return null;
        // `fill` — the thread IS the scroller; nothing to walk.
        if (fill) return el;
        if (scrollParentRef && scrollParentRef.current) return scrollParentRef.current;
        if (scrollerForRef.current === el && scrollerRef.current) return scrollerRef.current;
        let found = null;
        if (typeof window !== 'undefined' && typeof window.getComputedStyle === 'function') for(let node = el.parentElement; node; node = node.parentElement){
            const overflowY = window.getComputedStyle(node).overflowY;
            if ($af5a908f2b99a71b$var$SCROLLY.has(overflowY)) {
                found = node;
                break;
            }
        }
        // Nothing between here and the root scrolls → the page really does.
        if (!found && typeof document !== 'undefined') found = document.scrollingElement;
        scrollerRef.current = found;
        scrollerForRef.current = el;
        return found;
    }, [
        fill,
        scrollParentRef
    ]);
    const sampleGap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const el = resolveScroller();
        if (el) bottomGapRef.current = el.scrollHeight - el.scrollTop - el.clientHeight;
    }, [
        resolveScroller
    ]);
    const scrollToBottom = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const el = resolveScroller();
        if (el) el.scrollTop = el.scrollHeight; // the scroller itself — containment-safe
        bottomGapRef.current = 0;
    }, [
        resolveScroller
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, ()=>({
            scrollToBottom: scrollToBottom
        }), [
        scrollToBottom
    ]);
    // Sample the gap from whatever actually scrolls.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (typeof window === 'undefined') return undefined;
        const el = resolveScroller();
        if (!el) return undefined;
        // The viewport's scroll event is dispatched at the Document, not at <html>,
        // so a document-level scroller has to be listened to on `window`.
        const isDocScroller = typeof document !== 'undefined' && (el === document.scrollingElement || el === document.documentElement || el === document.body);
        const target = isDocScroller ? window : el;
        const onScroll = ()=>sampleGap();
        target.addEventListener('scroll', onScroll, {
            passive: true
        });
        return ()=>target.removeEventListener('scroll', onScroll);
    }, [
        resolveScroller,
        sampleGap
    ]);
    // Follow growth only when the reader was already at the bottom.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const prev = prevCountRef.current;
        prevCountRef.current = childCount;
        if (!autoScroll || childCount <= prev) return;
        // Backwards page: the growth is above the reader, never below.
        if (prependingRef.current) {
            prependingRef.current = false;
            return;
        }
        if (bottomGapRef.current <= $af5a908f2b99a71b$var$NEAR_BOTTOM_PX) scrollToBottom();
    }, [
        childCount,
        autoScroll,
        scrollToBottom
    ]);
    // Declared AFTER the growth effect on purpose: when a load-older resolves,
    // both run in the same commit and the growth effect must still see the flag.
    // This one only clears a flag the fetch never spent — an empty or failed page
    // produces no growth, and a stale flag would swallow the next real message.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!loadingOlder) prependingRef.current = false;
    }, [
        loadingOlder
    ]);
    const handleLoadOlder = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((e)=>{
        prependingRef.current = true;
        onLoadOlder?.(e);
    }, [
        onLoadOlder
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        role: "log",
        "aria-live": "polite",
        ref: containerRef,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            paddingInline: '1rem',
            ...padBlockRem != null && {
                paddingBlock: `${padBlockRem}rem`
            },
            ...fill && {
                flex: 1,
                minHeight: 0,
                overflowY: 'auto'
            },
            // Caller style MERGES over the computed layout — it never replaces it.
            // (Same precedent as `Card`.) Anything a caller genuinely needs to own,
            // like block padding, has a named prop.
            ...style
        },
        ...rest,
        // AFTER ...rest: the thread's own busy state is not the caller's to
        // overwrite — a caller-side data-state would hide `loading` forever.
        "data-state": loadingOlder ? 'loading' : 'ready'
    }, hasOlder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            paddingBlock: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        onClick: handleLoadOlder,
        disabled: loadingOlder,
        "data-testid": `${testId}-load-older`,
        // size="sm" is 2.25rem; this control renders on both apps' phone
        // threads, where the floor is 2.75rem (DESIGN-CONCEPT-MOBILE §368).
        className: "min-h-11",
        style: {
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
        }
    }, loadingOlder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
        size: 14,
        thickness: 2
    }), loadOlderLabel)), children);
});
var $af5a908f2b99a71b$export$2e2bcd8739ae039 = $af5a908f2b99a71b$var$ChatThread;




var $acw62 = parcelRequire("acw62");

const $393fa4133562fea6$export$6c2d0d964670e2e3 = [
    "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
    "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
    "\u062E\u0631\u062F\u0627\u062F",
    "\u062A\u06CC\u0631",
    "\u0645\u0631\u062F\u0627\u062F",
    "\u0634\u0647\u0631\u06CC\u0648\u0631",
    "\u0645\u0647\u0631",
    "\u0622\u0628\u0627\u0646",
    "\u0622\u0630\u0631",
    "\u062F\u06CC",
    "\u0628\u0647\u0645\u0646",
    "\u0627\u0633\u0641\u0646\u062F"
];
const $393fa4133562fea6$export$fb4a539c21dc93d2 = [
    "\u0634",
    "\u06CC",
    "\u062F",
    "\u0633",
    "\u0686",
    "\u067E",
    "\u062C"
];
const $393fa4133562fea6$export$961e0c326b64dc98 = (n)=>String(n).replace(/\d/g, (d)=>"\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9"[+d]);
const $393fa4133562fea6$export$c7153f4b19854938 = 12600000;
const $393fa4133562fea6$export$710ba58c9cc5d7e7 = ()=>new Date(Date.now() + $393fa4133562fea6$export$c7153f4b19854938);
function $393fa4133562fea6$var$jIsLeap(y) {
    return (y * 8 + 29) % 33 < 8;
}
function $393fa4133562fea6$export$129955be4a159fb3(ms) {
    const anchor = Date.UTC(2021, 2, 21); // 1400/01/01
    let days = Math.floor((ms - anchor) / 86400000);
    if (!Number.isFinite(days)) return null;
    // Nothing in a medical record predates the Jalali era, so a timestamp that
    // far back is corrupt input. Reject it rather than walk ~270,000 iterations
    // and hand the caller a confident negative year.
    if (days < -520000) return null; // ≈ year 1
    let y = 1400;
    // Before the anchor: step back a year at a time until the day index lands
    // inside one, mirroring the forward walk below.
    while(days < 0){
        y--;
        days += $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
    }
    while(true){
        const diy = $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
        if (days < diy) break;
        days -= diy;
        y++;
    }
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $393fa4133562fea6$var$jIsLeap(y) ? 30 : 29
    ];
    let m = 0;
    while(days >= md[m]){
        days -= md[m];
        m++;
    }
    return {
        y: y,
        m: m + 1,
        d: days + 1
    };
}
function $393fa4133562fea6$export$998538909dbe3791(jy, jm, jd) {
    const anchor = Date.UTC(2021, 2, 21); // 1400/01/01
    let days = 0;
    if (jy >= 1400) for(let y = 1400; y < jy; y++)days += $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
    else for(let y = jy; y < 1400; y++)days -= $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $393fa4133562fea6$var$jIsLeap(jy) ? 30 : 29
    ];
    for(let m = 0; m < jm - 1; m++)days += md[m];
    days += jd - 1;
    return anchor + days * 86400000;
}
function $393fa4133562fea6$export$33c90dd38a62167e(jy, jm) {
    if (jm <= 6) return 31;
    if (jm <= 11) return 30;
    return $393fa4133562fea6$var$jIsLeap(jy) ? 30 : 29;
}
function $393fa4133562fea6$export$748262491e74cb62() {
    const now = $393fa4133562fea6$export$710ba58c9cc5d7e7();
    // Day-of-week in Iran time: getUTCDay() because we manually shifted the clock
    const jsDay = now.getUTCDay(); // 0=Sun … 6=Sat
    const irWeekday = (jsDay + 1) % 7; // 0=ش … 6=ج
    const nowMs = now.getTime(); // already shifted UTC+3:30
    return Array.from({
        length: 7
    }, (_, i)=>{
        const dayMs = nowMs + (i - irWeekday) * 86400000;
        return {
            ...$393fa4133562fea6$export$129955be4a159fb3(dayMs),
            shortName: $393fa4133562fea6$export$fb4a539c21dc93d2[i],
            isToday: i === irWeekday
        };
    });
}



'use client';
/**
 * Date-range filter as a single dropdown.
 *
 * The trigger always reads out the *applied* range ("امروز", "۱۲–۱۸ تیر"), so the
 * active filter is never ambiguous — the older layout left the two date inputs
 * visible next to the preset chips, and a custom range highlighted no chip at all.
 *
 * Props:
 *   presets   — [{ id, label }]; the ids are opaque, the parent maps them to a window
 *   preset    — active preset id, or 'custom'
 *   custom    — { from, to } applied custom range, Gregorian 'YYYY-MM-DD' (picker format)
 *   onPreset  — (id) => void
 *   onCustom  — (from, to) => void; only fired once BOTH ends are picked
 */ // Gregorian 'YYYY-MM-DD' (what JalaliDatePicker emits) → Jalali { y, m, d }.
const $751677fd0a80fd7a$var$gToJalali = (s)=>{
    if (!s || s.length < 10) return null;
    const [y, m, d] = s.split('-').map(Number);
    if (!y || !m || !d) return null;
    return (0, $393fa4133562fea6$export$129955be4a159fb3)(Date.UTC(y, m - 1, d));
};
const $751677fd0a80fd7a$var$jDay = (j)=>`${(0, $393fa4133562fea6$export$961e0c326b64dc98)(j.d)} ${(0, $393fa4133562fea6$export$6c2d0d964670e2e3)[j.m - 1]}`;
const $751677fd0a80fd7a$var$jKey = (j)=>j.y * 10000 + j.m * 100 + j.d;
function $751677fd0a80fd7a$export$a0d62bcaf969e834(fromStr, toStr) {
    let a = $751677fd0a80fd7a$var$gToJalali(fromStr);
    let b = $751677fd0a80fd7a$var$gToJalali(toStr);
    if (!a || !b) return "\u0628\u0627\u0632\u0647\u0654 \u062F\u0644\u062E\u0648\u0627\u0647";
    if ($751677fd0a80fd7a$var$jKey(a) > $751677fd0a80fd7a$var$jKey(b)) [a, b] = [
        b,
        a
    ];
    if ($751677fd0a80fd7a$var$jKey(a) === $751677fd0a80fd7a$var$jKey(b)) return `${$751677fd0a80fd7a$var$jDay(a)} ${(0, $393fa4133562fea6$export$961e0c326b64dc98)(a.y)}`;
    if (a.y === b.y && a.m === b.m) return `${(0, $393fa4133562fea6$export$961e0c326b64dc98)(a.d)}\u{2013}${(0, $393fa4133562fea6$export$961e0c326b64dc98)(b.d)} ${(0, $393fa4133562fea6$export$6c2d0d964670e2e3)[a.m - 1]}`;
    if (a.y === b.y) return `${$751677fd0a80fd7a$var$jDay(a)} \u{2013} ${$751677fd0a80fd7a$var$jDay(b)}`;
    return `${$751677fd0a80fd7a$var$jDay(a)} ${(0, $393fa4133562fea6$export$961e0c326b64dc98)(a.y)} \u{2013} ${$751677fd0a80fd7a$var$jDay(b)} ${(0, $393fa4133562fea6$export$961e0c326b64dc98)(b.y)}`;
}
function $751677fd0a80fd7a$export$94bb145bb1ee00a2(preset, fromStr, toStr, presets) {
    if (preset === 'custom') return $751677fd0a80fd7a$export$a0d62bcaf969e834(fromStr, toStr);
    return (presets.find((p)=>p.id === preset) || {}).label || '';
}
const $751677fd0a80fd7a$var$CalendarIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "currentColor",
        style: {
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M20 3h-1V1h-2v2H7V1H5v2H4C2.9 3 2 3.9 2 5v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13zM7 10h5v5H7z"
    }));
const $751677fd0a80fd7a$var$ChevronIcon = ({ open: open })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "14",
        height: "14",
        fill: "currentColor",
        style: {
            flexShrink: 0,
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.15s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7 10l5 5 5-5z"
    }));
const $751677fd0a80fd7a$var$CheckIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "currentColor",
        style: {
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    }));
const $751677fd0a80fd7a$var$PresetRow = ({ label: label, active: active, onClick: onClick })=>{
    const [hov, setHov] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            padding: '8px 10px',
            borderRadius: 8,
            border: 'none',
            background: active ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).tealLight : hov ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg : 'transparent',
            color: active ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            fontSize: 13,
            fontWeight: active ? 700 : 500,
            fontFamily: 'inherit',
            cursor: 'pointer',
            textAlign: 'right',
            transition: 'background 0.12s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, label), active && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$CheckIcon, null));
};
function $751677fd0a80fd7a$export$2e2bcd8739ae039({ presets: presets, preset: preset, custom: custom, onPreset: onPreset, onCustom: onCustom }) {
    const [open, setOpen] = (0, $acw62.useState)(false);
    const ref = (0, $acw62.useRef)(null);
    // Draft dates live here, not in the parent: a range is only *applied* once both
    // ends exist, so a half-picked range can never desync the trigger label from the
    // window the list is actually showing.
    const [dFrom, setDFrom] = (0, $acw62.useState)(custom.from);
    const [dTo, setDTo] = (0, $acw62.useState)(custom.to);
    (0, $acw62.useEffect)(()=>{
        if (open) {
            setDFrom(custom.from);
            setDTo(custom.to);
        }
    }, [
        open,
        custom.from,
        custom.to
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const h = (e)=>{
            if (!ref.current) return;
            if (ref.current.contains(e.target)) return;
            // The two custom-range fields are `JalaliDatePicker`s, and their calendar
            // is PORTALED to <body> so a clipping ancestor cannot slice it. That puts
            // it outside `ref`, so picking a day counted as an outside click and shut
            // the dropdown before the date could register — which made the custom
            // range unreachable by calendar in every screen that uses this filter.
            if (e.target.closest?.('[data-jalali-popup]')) return;
            setOpen(false);
        };
        document.addEventListener('mousedown', h);
        return ()=>document.removeEventListener('mousedown', h);
    }, [
        open
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const h = (e)=>{
            if (e.key === 'Escape') setOpen(false);
        };
        document.addEventListener('keydown', h);
        return ()=>document.removeEventListener('keydown', h);
    }, [
        open
    ]);
    const isCustom = preset === 'custom';
    const label = $751677fd0a80fd7a$export$94bb145bb1ee00a2(preset, custom.from, custom.to, presets);
    const halfDone = !!dFrom !== !!dTo;
    const pickPreset = (id)=>{
        onPreset(id);
        setOpen(false);
    };
    const pickFrom = (v)=>{
        setDFrom(v);
        if (v && dTo) {
            onCustom(v, dTo);
            setOpen(false);
        }
    };
    const pickTo = (v)=>{
        setDTo(v);
        if (v && dFrom) {
            onCustom(dFrom, v);
            setOpen(false);
        }
    };
    const highlighted = open || isCustom;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        style: {
            position: 'relative',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setOpen((o)=>!o),
        title: "\u0628\u0627\u0632\u0647\u0654 \u0632\u0645\u0627\u0646\u06CC",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 7,
            height: 36,
            padding: '0 12px',
            borderRadius: 8,
            border: `1px solid ${highlighted ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            background: highlighted ? '#fff' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            color: highlighted ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            fontSize: 13,
            fontWeight: 700,
            fontFamily: 'inherit',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            transition: 'all 0.12s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$CalendarIcon, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$ChevronIcon, {
        open: open
    })), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            top: 'calc(100% + 6px)',
            left: 0,
            zIndex: 60,
            width: 260,
            background: '#fff',
            borderRadius: 12,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            boxShadow: '0 12px 36px rgba(0,0,0,0.14)',
            padding: 8,
            direction: 'rtl'
        }
    }, presets.map((p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$PresetRow, {
            key: p.id,
            label: p.label,
            active: preset === p.id,
            onClick: ()=>pickPreset(p.id)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 1,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
            margin: '8px 4px'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            fontWeight: 700,
            color: isCustom ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            padding: '2px 10px 8px'
        }
    }, "\u0628\u0627\u0632\u0647\u0654 \u062F\u0644\u062E\u0648\u0627\u0647"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gap: 8,
            padding: '0 4px 4px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
        value: dFrom,
        onChange: pickFrom,
        placeholder: "\u0627\u0632 \u062A\u0627\u0631\u06CC\u062E",
        height: 38,
        fontSize: 13,
        disableFuture: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
        value: dTo,
        onChange: pickTo,
        placeholder: "\u062A\u0627 \u062A\u0627\u0631\u06CC\u062E",
        height: 38,
        fontSize: 13,
        disableFuture: true
    }), halfDone && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amber,
            fontWeight: 600,
            padding: '0 2px'
        }
    }, "\u0628\u0631\u0627\u06CC \u0627\u0639\u0645\u0627\u0644\u060C \u0647\u0631 \u062F\u0648 \u062A\u0627\u0631\u06CC\u062E \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F"))));
}



var $acw62 = parcelRequire("acw62");

'use client';
/**
 * Applies the doctor's accent preset and type scale to <html>.
 *
 * Where the value comes from, in order:
 *   1. localStorage, read synchronously during the first render, so a reload
 *      paints the chosen accent immediately instead of flashing the default
 *      while the `me` query is still in flight.
 *   2. The server copy, pushed in via `appearance` once settings load. That is
 *      the real record and wins whenever it differs — it is how the preference
 *      follows the doctor to another device.
 *
 * Themed values are CSS custom properties (see tokens.css), so switching the
 * preset re-themes every screen without re-rendering anything: this provider
 * only sets two attributes on the root element.
 */ const $54fc473ae52026aa$var$ThemeContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $54fc473ae52026aa$export$d8964aec282183a3({ appearance: appearance, children: children }) {
    // Lazy initialiser — runs before first paint, not in an effect.
    const [local, setLocal] = (0, $acw62.useState)(()=>{
        const stored = (0, $e7c165fb515b04ea$export$dde01dc24facb6b0)();
        (0, $e7c165fb515b04ea$export$48c323151b232e54)(stored);
        return stored;
    });
    const serverTheme = appearance?.theme;
    const serverFontSize = appearance?.fontSize;
    // Adopt the server's copy when it arrives or changes (e.g. the doctor changed
    // the accent on another device). Nulls mean "not loaded yet" — not "reset".
    (0, $acw62.useEffect)(()=>{
        if (!serverTheme && !serverFontSize) return;
        setLocal((prev)=>{
            const next = {
                theme: serverTheme || prev.theme,
                fontSize: serverFontSize || prev.fontSize
            };
            if (next.theme === prev.theme && next.fontSize === prev.fontSize) return prev;
            const resolved = (0, $e7c165fb515b04ea$export$48c323151b232e54)(next);
            (0, $e7c165fb515b04ea$export$64464588479aad90)(resolved);
            return resolved;
        });
    }, [
        serverTheme,
        serverFontSize
    ]);
    const value = (0, $acw62.useMemo)(()=>({
            theme: local.theme,
            fontSize: local.fontSize,
            // Apply a choice locally and cache it. Two callers:
            //   - the settings picker, so the accent switches under the doctor's cursor
            //     instead of after a server round trip;
            //   - app boot, to adopt the server's copy once `me` resolves.
            // Persisting to the BFF is the caller's job — this only paints and caches.
            setAppearance: (patch)=>{
                setLocal((prev)=>{
                    const resolved = (0, $e7c165fb515b04ea$export$48c323151b232e54)({
                        ...prev,
                        ...patch
                    });
                    (0, $e7c165fb515b04ea$export$64464588479aad90)(resolved);
                    return resolved;
                });
            }
        }), [
        local
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($54fc473ae52026aa$var$ThemeContext.Provider, {
        value: value
    }, children);
}
function $54fc473ae52026aa$export$93d4e7f90805808f() {
    return (0, $acw62.useContext)($54fc473ae52026aa$var$ThemeContext) ?? {
        theme: (0, $e7c165fb515b04ea$export$2faeed762aac6741),
        fontSize: (0, $e7c165fb515b04ea$export$b1461457ea2c1179),
        setAppearance: ()=>{}
    };
}
var $54fc473ae52026aa$export$2e2bcd8739ae039 = $54fc473ae52026aa$export$d8964aec282183a3;








// Runtime configuration, resolved once at module load.
//
// window.__ENV__ is written by docker-entrypoint.sh at container start from the
// k8s deployment env, so the same image serves every environment. process.env is
// the Parcel build-time fallback (baked in via the Dockerfile ARG) for local dev.
const $d87bd335296b449f$var$runtime = typeof window !== 'undefined' && window.__ENV__ || {};
const $d87bd335296b449f$export$bb117bdb9f34de64 = $d87bd335296b449f$var$runtime.BFF_URL || undefined || 'https://sapi.parsinabot.ir/graphql';
const $d87bd335296b449f$export$91dbb4a8660769db = $d87bd335296b449f$var$runtime.PARSINA_KC_BASE_URL || undefined || 'https://sso.itechtrade.ir';
const $d87bd335296b449f$export$5aec0b605bf1c5bb = ($d87bd335296b449f$var$runtime.ACCOUNT_APP_URL || undefined || 'https://account.parsinabot.ir').replace(/\/+$/, '');
function $d87bd335296b449f$export$cce6d3603c0b63d(section = '/') {
    const back = typeof window !== 'undefined' ? window.location.origin : '';
    const path = section.startsWith('/') ? section : `/${section}`;
    return `${$d87bd335296b449f$export$5aec0b605bf1c5bb}${path}${back ? `?return_url=${encodeURIComponent(back)}` : ''}`;
}


var $23a4fb8df39836e9$exports = {};
$23a4fb8df39836e9$exports = import.meta.resolve("90mMd");


var $f0b50123bb07e4c7$exports = {};
$f0b50123bb07e4c7$exports = import.meta.resolve("8C9I7");


// i18n provider — resolves the locale (config.js), serves t() and the
// formatters (format.js), persists the choice, and keeps <html lang/dir> in
// sync. The inline script in index.html owns only the pre-paint frame; from
// mount onward this owns it, and nothing else in the app sets `direction`.


var $acw62 = parcelRequire("acw62");
// Locale resolution — the SAME contract as the inline pre-paint script in
// index.html: stored choice ('parsina.locale') → Persian. Keep the two in step.
//
// THE DEVICE LANGUAGE IS DELIBERATELY NOT CONSULTED, and that is the one place
// this app departs from the doctor client (whose order is stored → device →
// English). This panel is for Iranian medical students; its content, its
// clinical vocabulary and every case a student writes are Persian. Reading the
// browser's language means a student on a laptop that shipped as en-US — which
// is most of them — gets an English shell around Persian content, having asked
// for nothing.
//
// English is not lost, it is just no longer guessed at: SUPPORTED still carries
// it, and the language switcher in the Profile screen selects it explicitly.
// That choice is what STORAGE_KEY holds, and step 1 above still honours it
// outright, so a student who wants English keeps it across every reload.
//
// A deliberately small implementation of that contract: resolution is the only
// part of i18n this app needs that the doctor client's src/i18n/ also has, and
// the rest of that module (namespace-per-file, a lazy loader) buys nothing for
// six screens and one bundle — see catalogs.js. Keep this contract identical to
// the sibling clients' and to the pre-paint script in index.html.
const $94f36eaf2deb686d$export$4c4b683c586ca56e = {
    fa: 'rtl',
    en: 'ltr'
};
const $94f36eaf2deb686d$export$86880b4b2e1a2384 = 'parsina.locale';
const $94f36eaf2deb686d$export$9e8d0820828f4de3 = 'fa';
function $94f36eaf2deb686d$export$ec67f55c222e1546(tag) {
    if (!tag) return null;
    if ($94f36eaf2deb686d$export$4c4b683c586ca56e[tag]) return tag;
    const base = String(tag).toLowerCase().split(/[-_]/)[0];
    return $94f36eaf2deb686d$export$4c4b683c586ca56e[base] ? base : null;
}
function $94f36eaf2deb686d$export$df9bcabe7f932e01(storage, _languages) {
    let stored = null;
    try {
        stored = $94f36eaf2deb686d$export$ec67f55c222e1546(storage?.getItem($94f36eaf2deb686d$export$86880b4b2e1a2384));
    } catch  {
    /* storage off */ }
    return stored || $94f36eaf2deb686d$export$9e8d0820828f4de3;
}


// The catalogue barrel.
//
// EN is the SOURCE catalogue (the doctor-app rule, docs/I18N.md there): every
// key is declared in en.js and fa.js translates it. A fa-only key is a defect,
// and tests/i18n.test.js asserts parity in both directions.
//
// Persian is the PRODUCT language: this panel is for Iranian medical students
// and every screen ships complete Persian copy. English exists because the
// source catalogue is the reviewable record of what the app says.
//
// Both halves live in ./translations/ so a screen's copy can be reviewed
// without scrolling past the mechanism.
//
// One flat map per locale, with fully qualified dotted keys, rather than the
// doctor app's namespace-per-file + lazy loader. This app has six screens and
// one bundle; the loader's job — not shipping fifteen JSON files to render one
// screen — does not exist here yet. The KEY SHAPE is identical, so promoting to
// the namespaced loader later is a mechanical move that touches no screen.
// EN — the SOURCE catalogue. One flat map, composed from one module per
// namespace.
//
// Every key the app can ask for is DECLARED here and translated in fa.js. A
// fa-only key is a defect; tests/i18n.test.js asserts parity in both directions.
//
// The split into ./en/<namespace>.js is the same one fa.js explains at length:
// one file per namespace so that the patients, chat and visit screens can be
// written at the same time without two authors editing one map. ./en/chat.js
// and ./en/visit.js belong to the chat and visit authors; add keys to the
// namespace you own and to no other.
//
// The exported shape is unchanged — a flat map of fully-qualified dotted keys —
// so catalogs.js, translator.js and the tests are untouched by the split.
// Chrome, actions, units, the practice/AI notices and the shortcut overlay —
// the copy every screen shares.
const $c41f06ba6bf140f2$export$919daad019702595 = {
    // ── app ──────────────────────────────────────────────────────────────
    'app.title': "Parsina \u2014 Student & Resident Panel",
    // ── common ───────────────────────────────────────────────────────────
    'common.actions.cancel': 'Cancel',
    'common.actions.retry': 'Try again',
    'common.actions.save': 'Save',
    'common.actions.saving': "Saving\u2026",
    'common.actions.back': 'Back',
    'common.actions.add': 'Add',
    'common.actions.edit': 'Edit',
    'common.actions.delete': 'Delete',
    'common.actions.close': 'Close',
    'common.actions.confirm': 'Confirm',
    'common.actions.create': 'Create',
    'common.actions.open': 'Open',
    'common.actions.clear': 'Clear',
    'common.actions.copy': 'Copy',
    'common.actions.copied': 'Copied',
    'common.actions.rename': 'Rename',
    'common.actions.more': 'More',
    'common.actions.viewAll': 'View all',
    'common.actions.continue': 'Continue',
    'common.labels.none': "\u2014",
    'common.labels.optional': 'optional',
    'common.labels.search': 'Search',
    'common.labels.loading': "Loading\u2026",
    'common.state.all': 'All',
    'common.state.pleaseWait': "Please wait\u2026",
    'common.time.today': 'Today',
    'common.time.yesterday': 'Yesterday',
    'common.time.last7': 'Last 7 days',
    'common.time.older': 'Older',
    'common.units.parseh': 'Parseh',
    'common.units.toman': 'Toman',
    'common.units.tomanShort': 'T',
    'common.units.years': '{{count}} yrs',
    'common.units.kg': 'kg',
    'common.units.cm': 'cm',
    'common.units.second': 's',
    'common.gender.male': 'Male',
    'common.gender.female': 'Female',
    'common.gender.other': 'Other',
    // ── mobile shell ─────────────────────────────────────────────────────
    'mobile.greeting': 'Welcome,',
    'mobile.showMore': 'Show more',
    'mobile.close': 'Close',
    'mobile.menu': 'Menu',
    // ── the practice / teaching disclaimers — core.md §3 ─────────────────
    'practice.badge': 'Practice patient',
    'practice.badge.short': 'Practice',
    'practice.banner.title': 'This is an imaginary patient',
    'practice.banner.body': "Everything here is a teaching case you invented. Never enter a real person\u2019s details \u2014 no name, no national ID, no phone number.",
    'practice.caseRef.label': 'Your own filing label',
    'practice.caseRef.helper': "Your own label \u2014 \xabCase 12\xbb, \xabCASE-2026-03\xbb. It is NOT a national ID and must never be one.",
    'practice.ai.title': 'Educational answer, not clinical advice',
    'practice.ai.body': 'The assistant explains its reasoning so you can study it. It is answering about an imaginary patient and must never be used to treat a real person.',
    'practice.ai.short': "Educational \u2014 not clinical advice.",
    // ── keyboard shortcuts ───────────────────────────────────────────────
    'shortcuts.title': 'Keyboard shortcuts',
    'shortcuts.groups.general': 'General',
    'shortcuts.groups.visit': 'Visit',
    'shortcuts.search': 'Search patients',
    'shortcuts.help': 'This list',
    'shortcuts.close': 'Close the open sheet',
    'shortcuts.empty': 'No shortcuts on this screen.',
    // The static reference the `?` overlay shows OUTSIDE a visit: the bindings
    // only exist while a visit is open, but a student should be able to read them
    // before opening one.
    'shortcuts.groups.insideVisit': 'Inside a visit',
    // ── paging ───────────────────────────────────────────────────────────
    'common.pager.prev': 'Previous',
    'common.pager.next': 'Next',
    'common.pager.page': 'Page {{current}} of {{pages}}',
    // ── connectivity banner — core.md §15 ────────────────────────────────
    'connectivity.offline': "No internet \u2014 changes are not being saved",
    'connectivity.degraded': "The server cannot be reached \u2014 retrying",
    'connectivity.restored': 'Connection is back',
    'connectivity.retry': 'Check again',
    'connectivity.checking': "Checking\u2026"
};
var $c41f06ba6bf140f2$export$2e2bcd8739ae039 = $c41f06ba6bf140f2$export$919daad019702595;


// The four destinations, and the rail around them.
const $8f48bf69643a3ca0$export$80e4b313e5e6b30d = {
    // ── nav / chrome ─────────────────────────────────────────────────────
    'nav.brand.name': 'Parsina',
    'nav.brand.panel': 'Student & resident panel',
    'nav.items.patients': 'Patients',
    'nav.items.chat': 'Chat',
    'nav.items.credits': 'Parseh',
    'nav.items.profile': 'Profile',
    'nav.sidebar.collapse': 'Collapse menu',
    'nav.sidebar.expand': 'Expand menu',
    'nav.sidebar.logout': 'Sign out',
    'nav.sidebar.editProfile': 'Profile',
    'nav.sidebar.shortcuts': 'Keyboard shortcuts',
    'nav.balance.label': 'Balance',
    'nav.landmark.primary': 'Main menu',
    'nav.landmark.content': 'Content'
};
var $8f48bf69643a3ca0$export$2e2bcd8739ae039 = $8f48bf69643a3ca0$export$80e4b313e5e6b30d;


// The sign-in screen and the session states around it.
const $4152f707a3a6bfcc$export$596d806903d1f59e = {
    // ── auth ─────────────────────────────────────────────────────────────
    'auth.checking': "Checking your session\u2026",
    'auth.loading': "Loading your workspace\u2026",
    'auth.retry': 'Start over',
    'auth.loopError': 'Sign-in kept redirecting in a loop and was stopped. Clear the session and try again.',
    'auth.loopTitle': 'Sign-in failed',
    'auth.checkingHint': 'This takes a moment',
    'auth.stuck': 'Not redirected?',
    'auth.manualSignIn': 'Click here',
    // core.md §4.3: the boot's status query failing is «سرویس در دسترس نیست» —
    // an outage with a retry, never a verdict about the account.
    'auth.bootFailed.title': 'The service is unavailable',
    'auth.bootFailed.body': "The server did not answer. This is not a problem with your account \u2014 your patients are untouched.",
    'auth.session.expiringTitle': 'Your session is about to end',
    'auth.session.expiringBody': 'Stay signed in to keep working without interruption. What you have typed stays on screen either way.',
    'auth.session.staySignedIn': 'Stay signed in',
    'auth.session.expiredTitle': 'Your session has ended',
    'auth.session.expiredBody': 'Sign in again to continue. You will come back to this same screen.',
    'auth.session.signInAgain': 'Sign in again',
    'auth.session.returnNotice': 'What you saved is safe. What is on screen but not yet saved may be lost.',
    // ── login ────────────────────────────────────────────────────────────
    'login.title': 'Student & resident panel',
    'login.sub': 'Invent a patient, document the visit, and ask the teaching assistant why.',
    'login.action': 'Sign in or sign up with your mobile number',
    'login.working': "Taking you to sign-in\u2026",
    'login.hint': 'Sign-in is by phone number and a one-time code.',
    'login.feature.case.title': 'Build a practice patient',
    'login.feature.case.body': 'An imaginary person you invent. Never a real one.',
    'login.feature.visit.title': 'Document the visit',
    'login.feature.visit.body': "SOAP note, diagnoses, prescription, orders \u2014 the way a doctor would.",
    'login.feature.chat.title': 'Talk to the teaching assistant',
    'login.feature.chat.body': 'It knows the whole record and explains how it reasons.',
    'login.free': '500 Parseh free every month',
    'login.badRedirect': 'This address is not registered for sign-in. Open the panel from its official address.'
};
var $4152f707a3a6bfcc$export$2e2bcd8739ae039 = $4152f707a3a6bfcc$export$596d806903d1f59e;


// The one-step profile form of core.md §4.3 — its fields, its rules, its states.
const $ef4b345cd740543e$export$66d87fc9a79fcf2d = {
    // ── onboarding — core.md §4.3 ────────────────────────────────────────
    'onboarding.title': "Welcome \u2014 tell us who you are",
    'onboarding.sub': 'One short form. You can change any of it later in your profile.',
    'onboarding.fields.fullName': 'Full name',
    'onboarding.fields.studentNumber': 'Student number',
    'onboarding.fields.studentNumberHelper': "Your university\u2019s student number \u2014 not a medical council number. It is not verified.",
    'onboarding.fields.university': 'University',
    'onboarding.fields.universityHelper': 'Pick from the list or type your own.',
    'onboarding.fields.level': 'Level',
    'onboarding.fields.field': 'Specialty',
    'onboarding.fields.fieldHelper': 'The residency programme, e.g. internal medicine.',
    'onboarding.fields.entryYear': 'Entry year (Jalali)',
    'onboarding.fields.bio': 'Short bio',
    'onboarding.fields.phone': 'Mobile number',
    'onboarding.fields.phoneHelper': 'From your sign-in account; changed there, not here.',
    'onboarding.level.student': 'Medical student',
    'onboarding.level.intern': 'Intern',
    'onboarding.level.resident': 'Resident',
    'onboarding.submit': 'Start',
    'onboarding.saving': "Saving your profile\u2026",
    'onboarding.done': "All set \u2014 opening your patients\u2026",
    'onboarding.validation.fullName': "Enter your name (2\u2013120 characters).",
    'onboarding.validation.studentNumber': "Enter 4\u201320 letters, digits or dashes.",
    'onboarding.validation.university': "Enter your university (2\u2013120 characters).",
    'onboarding.validation.level': 'Choose your level.',
    'onboarding.validation.field': 'At most 80 characters.',
    'onboarding.validation.entryYear': 'A Jalali year between 1370 and 1420.',
    'onboarding.validation.bio': 'At most 500 characters.',
    'onboarding.error.unavailable': "Could not save right now. Your answers are kept \u2014 try again."
};
var $ef4b345cd740543e$export$2e2bcd8739ae039 = $ef4b345cd740543e$export$66d87fc9a79fcf2d;


// «بیماران» — the list, its toolbar and its states — plus the patient form that
// both the create dialog and the edit drawer render.
const $1e09a0565f515ba1$export$4a82ecccfc2a9a4a = {
    // ── patients — the list ──────────────────────────────────────────────
    'patients.title': 'Practice patients',
    'patients.sub': 'Imaginary patients you built to practise on.',
    'patients.new': 'New patient',
    'patients.search': "Search patients\u2026",
    'patients.count': '{{count}} patients',
    'patients.filters.active': 'Active',
    'patients.filters.draft': 'Draft',
    'patients.filters.archived': 'Archived',
    'patients.filters.all': 'All',
    'patients.sort.label': 'Sort',
    'patients.sort.lastVisit': 'Last visit',
    'patients.sort.newest': 'Newest',
    'patients.sort.name': 'Name',
    'patients.columns.name': 'Name / label',
    'patients.columns.age': "Age \xb7 sex",
    'patients.columns.complaint': 'Chief complaint',
    'patients.columns.visits': 'Visits',
    'patients.columns.lastVisit': 'Last visit',
    'patients.columns.status': 'Status',
    'patients.columns.actions': 'Actions',
    'patients.status.draft': 'Draft',
    'patients.status.active': 'Active',
    'patients.status.archived': 'Archived',
    'patients.empty.title': 'No patients yet',
    'patients.empty.body': "Patients here are imaginary \u2014 invent one and start practising.",
    'patients.noMatch.title': 'Nothing matches that search',
    'patients.noMatch.body': 'Clear the filter to see all your patients.',
    'patients.error.title': 'Could not load your patients',
    'patients.error.body': 'The server did not answer. Nothing was lost.',
    'patients.capped': 'More than 100 patients; search to find one faster.',
    'patients.delete.title': 'Delete this patient?',
    'patients.delete.body': '{{entries}} history entries, {{visits}} visits and {{threads}} conversations go with it. There is no undo, and Parseh already spent is not refunded. To keep the work, archive instead.',
    'patients.delete.confirm': 'Delete permanently',
    'patients.deleted': 'The patient was deleted.',
    'patients.created': 'The patient was created.',
    'patients.createdHint': 'Write the history, or dictate it.',
    'patients.archived': 'Archived.',
    'patients.unarchived': 'Back in the active list.',
    'patients.actions.open': 'Open record',
    'patients.actions.startVisit': 'Start visit',
    'patients.actions.chat': 'Chat',
    'patients.actions.archive': 'Archive',
    'patients.actions.unarchive': 'Unarchive',
    'patients.actions.delete': 'Delete',
    'patients.actions.clearFilters': 'Clear filters',
    'patients.openLabel': 'Open {{title}}',
    'patients.moreLabel': 'More actions for {{title}}',
    'patients.unnamed': 'Unnamed patient',
    'patients.visitsCount': '{{count}} visits',
    'patients.noVisits': 'No visits',
    // ── the patient form — create and edit ───────────────────────────────
    'caseForm.title.create': 'New practice patient',
    'caseForm.title.edit': 'Edit patient',
    'caseForm.fields.title': 'Title',
    'caseForm.fields.titlePlaceholder': 'A 54-year-old man with chest pain',
    'caseForm.fields.titleHelper': 'What YOU call this patient in your list.',
    'caseForm.fields.displayName': 'Made-up name',
    'caseForm.fields.displayNamePlaceholder': 'Mr. Rezaei',
    'caseForm.fields.displayNameHelper': "Invent one so the record reads naturally. Never a real person\u2019s name.",
    'caseForm.fields.ageYears': 'Age in years',
    'caseForm.fields.ageDisplay': 'Age, in another unit',
    'caseForm.fields.ageDisplayPlaceholder': '6 months',
    'caseForm.fields.ageDisplayHelper': 'Overrides the years, for a paediatric or neonatal case.',
    'caseForm.fields.sex': 'Sex',
    'caseForm.fields.bloodType': 'Blood type',
    'caseForm.fields.weightKg': 'Weight (kg)',
    'caseForm.fields.heightCm': 'Height (cm)',
    'caseForm.fields.chiefComplaint': 'Chief complaint',
    'caseForm.fields.chiefComplaintPlaceholder': 'Crushing chest pain since this morning',
    'caseForm.fields.chiefComplaintHelper': 'One line. The full story goes in the history.',
    'caseForm.fields.status': 'Status',
    'caseForm.fields.note': 'Note to yourself',
    'caseForm.submit.create': 'Create patient',
    'caseForm.submit.edit': 'Save changes',
    'caseForm.validation.title': 'A title is required.'
};
var $1e09a0565f515ba1$export$2e2bcd8739ae039 = $1e09a0565f515ba1$export$4a82ecccfc2a9a4a;


// The patient record: header, the four tabs, the شرح حال sections, the timeline.
const $353ea1a139e95e5e$export$e5185e241753e543 = {
    // ── the patient record ───────────────────────────────────────────────
    'record.notFound.title': 'This patient was not found',
    'record.notFound.body': 'It may have been deleted. Go back to your list.',
    'record.notFound.action': 'Back to patients',
    'record.tabs.overview': 'Overview',
    'record.tabs.history': 'History',
    'record.tabs.visits': 'Visits',
    'record.tabs.timeline': 'Timeline',
    'record.header.visits': "Visits \xd7{{count}}",
    'record.header.lastVisit': 'Last visit {{date}}',
    'record.header.archived': 'Archived',
    'record.header.archivedHint': 'Unarchive the patient to start a visit.',
    'record.actions.startVisit': 'Start visit',
    'record.actions.continueVisit': 'Continue open visit',
    'record.actions.chat': 'Chat with the assistant',
    'record.actions.edit': 'Edit patient',
    'record.actions.archive': 'Archive',
    'record.actions.unarchive': 'Unarchive',
    'record.actions.delete': 'Delete',
    'record.saved': 'Saved.',
    'record.startVisit.title': 'Start a visit',
    'record.startVisit.reason': 'Reason for the visit',
    'record.startVisit.reasonHelper': 'Pre-filled from the chief complaint; change it if this visit is about something else.',
    'record.startVisit.submit': 'Start visit',
    'record.startVisit.alreadyOpen': "A visit was already open \u2014 continuing it.",
    'record.overview.details': 'Details',
    'record.overview.allergies': 'Allergy alert',
    'record.overview.problems': 'Active problems',
    'record.overview.meds': 'Current medications',
    'record.overview.pendingOrders': 'Pending orders',
    'record.overview.lastVisit': 'Last visit',
    'record.overview.recentChats': 'Recent conversations',
    'record.overview.noProblems': 'No active problems recorded.',
    'record.overview.noMeds': 'No current medications.',
    'record.overview.noOrders': 'No pending orders.',
    'record.overview.noVisits': 'No visits yet.',
    'record.overview.noChats': 'No conversations yet.',
    'record.overview.openVisit': 'Open visit',
    'record.overview.fromHistory': 'from history',
    'record.overview.fromVisit': 'visit {{n}}',
    'record.visits.empty.title': 'No visits yet',
    'record.visits.empty.body': 'Start a visit to document a SOAP note, diagnoses, a prescription and orders.',
    'record.visits.columns.visit': 'Visit',
    'record.visits.columns.date': 'Date',
    'record.visits.columns.reason': 'Reason',
    'record.visits.columns.status': 'Status',
    'record.visits.columns.counts': "Dx \xb7 Rx \xb7 Orders",
    'record.visits.columns.summary': 'Summary',
    'record.visits.openLabel': 'Open visit {{n}}',
    'record.timeline.empty.title': 'Nothing on the timeline yet',
    'record.timeline.empty.body': 'Visits, findings, diagnoses and orders will appear here in order.',
    'record.timeline.outside': 'Outside any visit',
    'record.timeline.filter': 'Filter by type',
    'record.history.hint': "Write the seven sections \u2014 this is what the assistant reads.",
    'record.history.dictate': 'Dictate',
    'record.history.visitChip': 'Visit {{n}}',
    // ── timeline event types (BFF-derived) ───────────────────────────────
    'timeline.type.encounter_start': 'Visit started',
    'timeline.type.encounter_end': 'Visit closed',
    'timeline.type.entry': 'History entry',
    'timeline.type.diagnosis': 'Diagnosis',
    'timeline.type.rx': 'Prescription',
    'timeline.type.order': 'Order',
    'timeline.type.order_result': 'Result',
    'timeline.type.thread': 'Conversation',
    // ── شرح حال — the seven sections ─────────────────────────────────────
    'history.sections.chiefComplaint': 'Chief complaint',
    'history.sections.hpi': 'History of present illness',
    'history.sections.pmh': 'Past medical history',
    'history.sections.medications': 'Current medications',
    'history.sections.allergies': 'Allergies',
    'history.sections.vitals': 'Vital signs',
    'history.sections.labs': 'Labs',
    'history.empty.title': 'Nothing written here yet',
    'history.empty.body': "Write this section out \u2014 it is what the assistant reads.",
    'history.add': 'Add',
    'history.entry.label': 'Heading',
    'history.entry.labelPlaceholder': 'Blood test, 1405/05/12',
    'history.entry.body': 'What you want to record',
    'history.entry.bodyPlaceholder': 'Write it the way you would say it out loud.',
    'history.entry.recordedAt': 'When it happened in the case',
    'history.entry.recordedAtHelper': 'Optional, and usually left empty.',
    'history.entry.sourceLabel': 'Written by',
    'history.entry.source.manual': 'You',
    'history.entry.source.voice': 'You, from a voice draft',
    'history.entry.source.ai': 'You, from an AI suggestion',
    'history.entry.needsContent': 'Write something, or fill in at least one row.',
    'history.delete.title': 'Delete this entry?',
    'history.delete.body': 'Only this entry goes. The rest of the record stays.',
    'history.saved': 'The history was saved.',
    'history.deleted': 'The entry was deleted.',
    'history.structured.title': 'Structured values',
    'history.structured.helper': 'Optional. The written text above is what carries the case.',
    'history.vitals.bp': 'Blood pressure',
    'history.vitals.hr': 'Heart rate',
    'history.vitals.rr': 'Respiratory rate',
    'history.vitals.temp': 'Temperature',
    'history.vitals.spo2': "SpO\u2082",
    'history.units.bpm': 'bpm',
    'history.units.perMin': '/min',
    'history.units.celsius': "\xb0C",
    'history.units.percent': '%',
    'history.labs.name': 'Test',
    'history.labs.value': 'Value',
    'history.labs.unit': 'Unit',
    'history.labs.ref': 'Reference',
    'history.labs.addRow': 'Add a row',
    'history.labs.removeRow': 'Remove this row'
};
var $353ea1a139e95e5e$export$2e2bcd8739ae039 = $353ea1a139e95e5e$export$e5185e241753e543;


// OWNED BY THE CHAT AUTHOR. Nothing outside this namespace belongs here, and
// nothing here belongs in another file: this module exists so that the CHAT
// work and the rest of the app can be written at the same time without two
// people editing one map.
const $1b3e413808cf2139$export$530dccc8e24f4e99 = {
    // ── the chat page — core.md §9 ───────────────────────────────────────
    'chat.title': 'Teaching assistant',
    'chat.landing.title': 'Which patient would you like to talk about?',
    'chat.landing.body': "The assistant knows that patient\u2019s whole record \u2014 history, visits, diagnoses and orders.",
    'chat.landing.new': 'New patient',
    'chat.landing.open': 'Chat about {{name}}',
    'chat.sidebar.title': 'Conversations',
    'chat.sidebar.new': 'New conversation',
    'chat.sidebar.today': 'Today',
    'chat.sidebar.yesterday': 'Yesterday',
    'chat.sidebar.last7': 'Last 7 days',
    'chat.sidebar.older': 'Older',
    'chat.sidebar.empty': 'No conversations yet.',
    'chat.sidebar.otherPatient': 'Another patient',
    'chat.sidebar.inVisit': 'Conversations inside visits',
    'chat.sidebar.collapse': 'Hide conversations',
    'chat.sidebar.expand': 'Show conversations',
    'chat.sidebar.menu': 'Conversation actions',
    'chat.sidebar.justNow': 'Just now',
    'chat.sidebar.minutesAgo': '{{count}} min ago',
    'chat.sidebar.hoursAgo': '{{count}} h ago',
    'chat.thread.untitled': 'New conversation',
    'chat.thread.renameTitle': 'Rename conversation',
    'chat.thread.renamePlaceholder': 'Conversation title',
    'chat.thread.renameHelper': 'Leave empty to go back to the automatic title.',
    'chat.thread.renamed': 'Renamed.',
    'chat.thread.deleteTitle': 'Delete this conversation?',
    'chat.thread.deleteBody': 'The questions and answers go with it. The patient stays.',
    'chat.thread.deleted': 'The conversation was deleted.',
    'chat.thread.notFound': "Conversation not found \u2014 starting a new one.",
    'chat.thread.notFoundToast': 'Conversation not found',
    'chat.thread.movedToast': 'The answer was saved in the previous conversation.',
    'chat.header.back': 'Back to the record',
    'chat.header.patient': 'Patient',
    'chat.empty.title': 'Ask about {{name}}',
    'chat.empty.body': "Every answer is written into this conversation and costs Parseh \u2014 the price is shown on the button.",
    'chat.prompts.summary': 'Summarise this record',
    'chat.prompts.differential': 'Walk me through the differential, with reasoning',
    'chat.prompts.keyFinding': 'Which finding matters most, and why?',
    'chat.prompts.nextVisit': 'What should I ask at the next visit?',
    'chat.prompts.summaryOf': 'Summarise {{name}}',
    'chat.prompts.differentialFor': "Walk me through the differential for \u201C{{complaint}}\u201D, with reasoning",
    'chat.prompts.keyFindingFor': "In \u201C{{complaint}}\u201D, which finding matters most, and why?",
    'chat.composer.placeholder': "Ask about this patient\u2026",
    'chat.composer.send': 'Send',
    'chat.composer.stop': 'Stop',
    'chat.composer.thinking': "Thinking\u2026",
    'chat.composer.counter': '{{count}} / {{max}}',
    'chat.composer.offline': 'Offline',
    'chat.composer.reserved': 'A question cannot start with two underscores.',
    'chat.composer.tooLong': 'A question can be at most 4000 characters.',
    'chat.composer.noCredits': 'Not enough Parseh',
    'chat.message.you': 'You',
    'chat.message.assistant': 'Assistant',
    'chat.message.sending': 'Sending',
    'chat.message.sent': 'Sent',
    'chat.message.failed': 'Not sent',
    'chat.message.retry': 'Retry',
    'chat.message.copy': 'Copy',
    'chat.message.copied': 'Copied',
    'chat.message.regenerate': 'Regenerate',
    'chat.message.thumbsUp': 'Helpful',
    'chat.message.thumbsDown': 'Not helpful',
    'chat.message.older': 'Older messages',
    'chat.message.loadingOlder': "Loading\u2026",
    'chat.message.typing': 'The assistant is thinking',
    'chat.followUps': 'Ask next',
    'chat.references': 'Cited',
    'chat.confidenceLabel': 'Confidence',
    'chat.confidence.low': 'Low',
    'chat.confidence.medium': 'Medium',
    'chat.confidence.high': 'High',
    'chat.kind.chat': 'Question',
    'chat.kind.differential': 'Differential',
    'chat.kind.interaction': 'Interaction check',
    'chat.kind.soap_suggest': 'SOAP suggestion',
    'chat.kind.order_suggest': 'Order suggestions',
    'chat.error.title': 'Could not load this conversation',
    'chat.noCredits.title': 'Not enough Parseh',
    'chat.noCredits.body': 'Your question is back in the box. Top up and send it again.',
    'chat.noCredits.action': 'Top up'
};
var $1b3e413808cf2139$export$2e2bcd8739ae039 = $1b3e413808cf2139$export$530dccc8e24f4e99;


// OWNED BY THE VISIT AUTHOR. Nothing outside this namespace belongs here, and
// nothing here belongs in another file: this module exists so that the VISIT
// work and the rest of the app can be written at the same time without two
// people editing one map.
const $55539e1145d82385$export$bf638b60ea8b89b7 = {
    // ── visits ───────────────────────────────────────────────────────────
    'visit.number': 'Visit {{n}}',
    'visit.status.open': 'Open',
    'visit.status.closed': 'Closed',
    'visit.placeholder.title': 'The visit workspace is under construction',
    'visit.placeholder.body': 'The SOAP note, diagnoses, prescription and orders arrive here soon.',
    'visit.placeholder.back': 'Back to the record',
    // ── clinical vocabulary — core.md §5.3 (used by the Visit workspace too) ──
    'clinical.dx.kind.primary': 'Primary',
    'clinical.dx.kind.secondary': 'Secondary',
    'clinical.dx.kind.differential': 'Differential',
    'clinical.dx.status.active': 'Active',
    'clinical.dx.status.resolved': 'Resolved',
    'clinical.dx.status.ruled_out': 'Ruled out',
    'clinical.rx.route.oral': 'Oral',
    'clinical.rx.route.im': 'IM',
    'clinical.rx.route.iv': 'IV',
    'clinical.rx.route.sc': 'SC',
    'clinical.rx.route.topical': 'Topical',
    'clinical.rx.route.inhaled': 'Inhaled',
    'clinical.rx.route.rectal': 'Rectal',
    'clinical.rx.route.ophthalmic': 'Ophthalmic',
    'clinical.rx.route.otic': 'Otic',
    'clinical.rx.route.nasal': 'Nasal',
    'clinical.rx.route.sublingual': 'Sublingual',
    'clinical.rx.route.other': 'Other',
    'clinical.order.type.lab': 'Lab',
    'clinical.order.type.imaging': 'Imaging',
    'clinical.order.type.procedure': 'Procedure',
    'clinical.order.type.referral': 'Referral',
    'clinical.order.type.other': 'Other',
    'clinical.order.urgency.routine': 'Routine',
    'clinical.order.urgency.urgent': 'Urgent',
    'clinical.order.urgency.stat': 'Stat',
    'clinical.order.status.ordered': 'Ordered',
    'clinical.order.status.resulted': 'Resulted',
    'clinical.order.status.cancelled': 'Cancelled',
    'clinical.origin.manual': 'Entered by you',
    'clinical.origin.ai': 'From an AI suggestion',
    'clinical.differential.likelihood.high': 'Likely',
    'clinical.differential.likelihood.medium': 'Possible',
    'clinical.differential.likelihood.low': 'Less likely',
    'clinical.interaction.severity.severe': 'Severe',
    'clinical.interaction.severity.moderate': 'Moderate',
    'clinical.interaction.severity.mild': 'Mild',
    'clinical.interaction.type.interaction': 'Drug interaction',
    'clinical.interaction.type.contraindication': 'Contraindication',
    'clinical.interaction.type.allergy': 'Allergy',
    'clinical.interaction.type.black_box': 'Black-box warning',
    'clinical.interaction.source.rule_engine_static': 'Rule table',
    'clinical.interaction.source.rule_engine_rxnorm': 'RxNorm rules',
    'clinical.interaction.source.rule_engine_contraindication': 'Contraindication rules',
    'clinical.interaction.source.rule_engine_allergy': 'Allergy rules',
    'clinical.interaction.source.rule_engine_openfda': 'openFDA',
    'clinical.interaction.source.llm': 'Language model',
    // ── the assistant (shared pieces: cost chip, voice) ──────────────────
    'assistant.cost': '{{parseh}} Parseh',
    'assistant.costBefore': 'Costs {{parseh}} Parseh',
    'assistant.costFree': 'Free',
    'assistant.balance': 'You have {{parseh}} Parseh',
    'assistant.noCredits.title': 'Not enough Parseh',
    'assistant.noCredits.body': "Top up, or wait for next month\u2019s free grant. Nothing you wrote was lost.",
    'assistant.noCredits.action': 'Top up Parseh',
    'assistant.voice.title': 'Dictate the history',
    'assistant.voice.body': 'Describe the patient out loud, then review what it understood before anything is saved.',
    'assistant.voice.start': 'Start dictating',
    'assistant.voice.stop': 'Stop',
    'assistant.voice.listening': "Listening\u2026",
    'assistant.voice.unsupported': 'This browser cannot transcribe speech. Type or paste what you dictated instead.',
    'assistant.voice.transcript': 'What was heard',
    'assistant.voice.transcriptPlaceholder': "A 54-year-old man with crushing chest pain since this morning, known diabetic, on metformin\u2026",
    'assistant.voice.parse': 'Turn this into a history',
    'assistant.voice.parsing': "Reading it\u2026",
    'assistant.voice.needsTranscript': 'There is nothing to read yet.',
    'assistant.voice.draft.title': "Draft \u2014 nothing has been saved",
    'assistant.voice.draft.body': 'Untick anything you do not want, then confirm.',
    'assistant.voice.draft.none': 'It found nothing it could file into a section.',
    'assistant.voice.draft.confirm': 'Add the ticked entries',
    'assistant.voice.draft.confirming': "Adding\u2026",
    'assistant.voice.draft.discard': 'Discard the draft',
    'assistant.voice.draft.demographics': 'It also heard',
    'assistant.voice.draft.demographicsNote': "These are not applied \u2014 edit the patient if you want them.",
    'assistant.voice.applied': '{{count}} entries were added to the history.',
    'visit.back': 'Back to the record',
    'visit.backToRecord': 'Back to the record',
    'visit.notFound': 'This visit was not found',
    'visit.end': 'End the visit',
    'visit.reopen': 'Reopen',
    'visit.cancel': 'Cancel the visit',
    'visit.elapsed': '{{h}}h {{m}}m into the visit',
    'visit.closedAt': 'Closed on {{date}}',
    'visit.save.saved': 'Saved',
    'visit.save.saving': "Saving\u2026",
    'visit.save.failed': "Not saved \u2014 retry",
    'visit.tabs.aria': 'Visit sections',
    'visit.tabs.note': 'Note',
    'visit.tabs.diagnoses': 'Diagnoses',
    'visit.tabs.rx': 'Prescription',
    'visit.tabs.orders': 'Orders',
    'visit.soap.s': 'S',
    'visit.soap.o': 'O',
    'visit.soap.a': 'A',
    'visit.soap.p': 'P',
    'visit.soap.sCaption': 'History',
    'visit.soap.oCaption': 'Examination and findings',
    'visit.soap.aCaption': 'Assessment',
    'visit.soap.pCaption': 'Plan',
    'visit.soap.suggest': 'Assistant suggestion',
    'visit.soap.suggesting': "Writing a draft\u2026",
    'visit.soap.suggestNote': "A draft \u2014 nothing is applied until you apply it.",
    'visit.soap.listening': "Listening\u2026",
    'visit.soap.dictate': 'Dictate into this section',
    'visit.soap.dictateStop': 'Stop dictating',
    'visit.soap.reviewTitle': 'Review the suggested note',
    'visit.soap.reviewEmpty': 'It suggested nothing that fits a section.',
    'visit.soap.reviewCurrent': 'What you have written',
    'visit.soap.applyReplace': 'Replace',
    'visit.soap.applyAppend': 'Add below',
    'visit.dx.title': 'Diagnosis',
    'visit.dx.icd': 'ICD code',
    'visit.dx.icdHint': "Optional \u2014 a letter and two digits, e.g. I21.0",
    'visit.dx.icdInvalid': 'This is not shaped like an ICD code',
    'visit.dx.kind': 'Kind',
    'visit.dx.status': 'Status',
    'visit.dx.note': 'Note',
    'visit.dx.add': 'Add a diagnosis',
    'visit.dx.empty': 'No diagnosis yet',
    'visit.dx.emptyBody': 'Write what you think is going on, or ask for a differential.',
    'visit.dx.moveUp': 'Move up',
    'visit.dx.moveDown': 'Move down',
    'visit.dx.differential': 'Assistant differential',
    'visit.dx.differentialBusy': "Thinking\u2026",
    'visit.dx.differentialLast': 'The last differential',
    'visit.dx.differentialTitle': 'Differential diagnosis',
    'visit.dx.differentialEmpty': "It returned no separable list \u2014 read the explanation above.",
    'visit.dx.discriminators': 'What separates it',
    'visit.dx.nextSteps': 'Next steps',
    'visit.dx.addToList': 'Add to diagnoses',
    'visit.dx.addedToList': 'Added',
    'visit.rx.drug': 'Drug',
    'visit.rx.drugHint': 'Pick from the formulary, or type a name it does not carry',
    'visit.rx.searching': "Searching\u2026",
    'visit.rx.freeText': 'Outside the formulary',
    'visit.rx.freeTextNote': 'Rows outside the formulary are skipped by the interaction check.',
    'visit.rx.dose': 'Dose',
    'visit.rx.route': 'Route',
    'visit.rx.frequency': 'Frequency',
    'visit.rx.duration': 'Duration',
    'visit.rx.quantity': 'Quantity',
    'visit.rx.instructions': 'Instructions',
    'visit.rx.detail': 'Directions',
    'visit.rx.add': 'Add a drug',
    'visit.rx.empty': 'Nothing prescribed yet',
    'visit.rx.emptyBody': 'Add the drugs you would prescribe in this visit.',
    'visit.rx.check': 'Check interactions',
    'visit.rx.checking': "Checking\u2026",
    'visit.rx.lastCheck': 'The last check',
    'visit.rx.interactionTitle': 'Interaction check',
    'visit.rx.interactionNone': 'No interaction was found',
    'visit.rx.interactionNoneBody': 'For the rows the check could see. Read the skipped list below.',
    'visit.rx.interactionSource': 'Source',
    'visit.rx.skippedTitle': 'These rows were not checked',
    'visit.rx.skippedBody': 'They were typed by hand and carry no formulary code, so the check could not look them up.',
    'visit.rx.print': 'Print the prescription',
    'visit.rx.printTitle': 'Practice prescription',
    'visit.rx.printAction': 'Print',
    'visit.rx.printFooter': 'A practice document. It is not valid and must never be dispensed.',
    'visit.rx.watermark': "PRACTICE PRESCRIPTION \u2014 NOT VALID",
    'visit.rx.studentNumber': 'Student number',
    'visit.orders.add': 'Add an order',
    'visit.orders.fromCatalog': 'From the catalogue',
    'visit.orders.title': 'Order',
    'visit.orders.type': 'Type',
    'visit.orders.urgency': 'Urgency',
    'visit.orders.notes': 'Why / instructions',
    'visit.orders.empty': 'No orders yet',
    'visit.orders.emptyBody': 'Order the labs and imaging this visit calls for.',
    'visit.orders.pickTitle': 'Pick from the catalogue',
    'visit.orders.pickEmpty': "Nothing matches \u2014 type the order instead.",
    'visit.orders.search': 'Search the catalogue',
    'visit.orders.recordResult': 'Record a result',
    'visit.orders.cancelOrder': 'Cancel the order',
    'visit.orders.resultTitle': 'Record the result',
    'visit.orders.resultBody': 'The result',
    'visit.orders.resultRows': 'Values',
    'visit.orders.resultAddRow': 'Add a row',
    'visit.orders.resultName': 'Test',
    'visit.orders.resultValue': 'Value',
    'visit.orders.resultUnit': 'Unit',
    'visit.orders.resultRef': 'Reference',
    'visit.orders.resultSave': 'Save the result',
    'visit.orders.resultFlag': 'Flag',
    'visit.orders.resultFlagNone': "\u2014",
    'visit.orders.resultEmpty': 'Write a result, or enter at least one value row.',
    'visit.orders.suggest': 'Assistant suggestions',
    'visit.orders.suggestBusy': "Thinking\u2026",
    'visit.orders.suggestLast': 'The last suggestions',
    'visit.orders.suggestTitle': 'Suggested orders',
    'visit.orders.suggestEmpty': "It suggested no separable orders \u2014 read the explanation above.",
    'visit.orders.suggestAdd': 'Add the ticked ({{count}})',
    'visit.rail.title': 'Record',
    'visit.rail.expand': 'Open the record rail',
    'visit.rail.collapse': 'Collapse the record rail',
    'visit.rail.allergies': 'Allergy alert',
    'visit.rail.identity': 'Details',
    'visit.rail.vitals': 'Vital signs',
    'visit.rail.vitalsAdd': 'Record',
    'visit.rail.vitalsPlaceholder': "BP 120/80 \xb7 HR 72",
    'visit.rail.medications': 'Current medications',
    'visit.rail.problems': 'Active problems',
    'visit.rail.pmh': 'Past medical history',
    'visit.rail.labs': 'Labs',
    'visit.rail.history': 'History',
    'visit.rail.ageYears': '{{n}} years old',
    'visit.rail.noVitals': 'No vital signs recorded.',
    'visit.rail.noMedications': 'No current medications.',
    'visit.rail.noProblems': 'No active problems.',
    'visit.rail.noPmh': 'Nothing written yet.',
    'visit.rail.noLabs': 'No labs written yet.',
    'visit.rail.noHistory': 'The history is empty.',
    'visit.rail.emptyList': 'Nothing here yet.',
    'visit.copilot.title': 'Assistant',
    'visit.copilot.aria': 'Assistant sections',
    'visit.copilot.ask': 'Ask',
    'visit.copilot.differential': 'Differential',
    'visit.copilot.suggestions': 'Suggestions',
    'visit.copilot.askEmpty': "Ask about this visit \u2014 it reads the record and the note you are writing.",
    'visit.copilot.thinking': "Thinking\u2026",
    'visit.copilot.placeholder': 'Ask about this visit',
    'visit.copilot.send': 'Ask',
    'visit.copilot.offline': "Offline \u2014 the assistant cannot be reached.",
    'visit.copilot.open': 'Open the assistant',
    'visit.copilot.collapse': 'Collapse the assistant',
    'visit.copilot.refresh': 'Refresh',
    'visit.copilot.openCards': 'Open the cards',
    'visit.copilot.differentialEmpty': 'No differential has been asked for in this visit.',
    'visit.copilot.soapSuggestion': 'Note suggestion',
    'visit.copilot.orderSuggestion': 'Order suggestions',
    'visit.copilot.suggestionsEmpty': 'Nothing suggested in this visit yet.',
    'visit.copilot.reopen': 'Open again',
    'visit.close.title': 'End the visit',
    'visit.close.summary': 'Visit summary',
    'visit.close.summaryHint': 'Optional. Pre-filled from the first lines of your assessment and plan.',
    'visit.close.warningsTitle': 'Before you close it',
    'visit.close.warningsNote': 'None of these prevents closing.',
    'visit.close.warning.emptyNote': 'The visit note is empty.',
    'visit.close.warning.noDiagnoses': 'No diagnosis has been recorded.',
    'visit.close.warning.openSuggestions': 'An assistant suggestion is still open and unreviewed.',
    'visit.close.ending': "Ending\u2026",
    'visit.close.saveFailed': 'The note could not be saved, so the visit was not closed',
    'visit.cancelConfirm.title': 'Cancel this visit?',
    'visit.cancelConfirm.body': '{{dx}} diagnoses, {{rx}} drugs and {{orders}} orders will be deleted. Vital signs and history entries stay on the record.',
    'visit.cancelConfirm.confirm': 'Delete the visit',
    'visit.offline.title': 'The service cannot be reached',
    'visit.offline.body': 'What you write is kept on this device and sent when the connection returns.',
    'visit.toast.ended': 'The visit was closed.',
    'visit.toast.cancelled': 'The visit was deleted.',
    'visit.toast.discardedDraft': 'A local draft of the note was older than the saved one and was discarded.',
    'visit.shortcuts.group': 'Visit',
    'visit.shortcuts.save': 'Save the note now',
    'visit.shortcuts.tab1': 'Note',
    'visit.shortcuts.tab2': 'Diagnoses',
    'visit.shortcuts.tab3': 'Prescription',
    'visit.shortcuts.tab4': 'Orders',
    'visit.shortcuts.send': 'Send the question',
    'visit.shortcuts.end': 'End the visit'
};
var $55539e1145d82385$export$2e2bcd8739ae039 = $55539e1145d82385$export$bf638b60ea8b89b7;


// پارسه — balance, price list, top-up, gift codes, the ledger.
const $429b796293eac695$export$68c7321cb43cac49 = {
    // ── پارسه — the wallet ───────────────────────────────────────────────
    'credits.title': 'Parseh',
    'credits.sub': "Parsina\u2019s credit for the assistant. Every answer spends some.",
    'credits.balance.label': 'Your balance',
    'credits.balance.loading': "Reading your balance\u2026",
    'credits.free.title': '500 Parseh, free, every month',
    'credits.free.body': 'Renewed at the start of each month whether you top up or not.',
    'credits.priceList.title': 'What each action costs',
    'credits.price.ask': 'Ask the assistant',
    'credits.price.differential': 'Differential diagnosis',
    'credits.price.soap': 'SOAP suggestion',
    'credits.price.orders': 'Order suggestions',
    'credits.price.interaction': 'Drug interaction check',
    'credits.price.voice': 'Voice intake',
    'credits.topUp.title': 'Top up',
    'credits.topUp.action': 'Buy Parseh',
    'credits.topUp.recommended': 'Recommended',
    'credits.topUp.custom': 'Another amount',
    'credits.topUp.customLabel': 'Amount in Toman',
    'credits.topUp.pay': 'Pay {{amount}} Toman via {{gateway}}',
    'credits.topUp.redirecting': "Taking you to the bank\u2026",
    'credits.topUp.min': 'The smallest purchase is {{amount}} Toman.',
    'credits.topUp.note': "You will be taken to the bank\u2019s own page to pay.",
    'credits.topUp.failed': 'Could not start the payment.',
    'credits.gateway.saderat': 'Saderat / Sepehr',
    'credits.gateway.zarinpal': 'Zarinpal',
    'credits.gift.title': 'Gift code',
    'credits.gift.hint': 'Have a code from a Parsina campaign? Redeem it here.',
    'credits.gift.placeholder': 'PARSINA-XXXX',
    'credits.gift.submit': 'Redeem',
    'credits.gift.submitting': "Redeeming\u2026",
    'credits.gift.empty': 'Enter a code first.',
    'credits.gift.notFound': 'That code is not valid.',
    'credits.gift.success': '{{parseh}} Parseh added.',
    'credits.gift.newBalance': 'New balance',
    'credits.gift.oneUse': 'A code can be used once.',
    'credits.gift.myCodes': 'Codes you have used',
    'credits.gift.worth': 'Worth {{parseh}} Parseh',
    'credits.gift.status.issued': 'Unused',
    'credits.gift.status.redeemed': 'Used',
    'credits.gift.status.revoked': 'Revoked',
    'credits.gift.status.expired': 'Expired',
    'credits.tx.title': 'Transactions',
    'credits.tx.empty.title': 'Nothing yet',
    'credits.tx.empty.body': 'Your spending and top-ups will appear here.',
    'credits.tx.error.title': 'Could not load the transactions',
    'credits.tx.columns.date': 'When',
    'credits.tx.columns.service': 'What for',
    'credits.tx.columns.description': 'Detail',
    'credits.tx.columns.amount': 'Parseh',
    'credits.tx.filter.all': 'All',
    'credits.tx.filter.credit': 'Added',
    'credits.tx.filter.debit': 'Spent',
    'credits.service.ask': 'Assistant question',
    'credits.service.differential': 'Differential diagnosis',
    'credits.service.interaction': 'Interaction check',
    'credits.service.transcription': 'Transcription',
    'credits.service.gift': 'Gift code',
    'credits.service.topup': 'Top-up',
    'credits.service.sms': 'SMS',
    'credits.service.other': 'Smart feature'
};
var $429b796293eac695$export$2e2bcd8739ae039 = $429b796293eac695$export$68c7321cb43cac49;


// پروفایل — the editable profile, appearance, and the way out.
const $d770f6c8c996d2d3$export$4882ae973e0491e = {
    // ── profile ──────────────────────────────────────────────────────────
    'profile.title': 'Profile',
    'profile.sections.identity': 'Your details',
    'profile.sections.account': 'Account',
    'profile.sections.appearance': 'Appearance and language',
    'profile.fields.phone': 'Mobile number',
    'profile.fields.studentId': 'Account ID',
    'profile.fields.cases': 'Practice patients',
    'profile.fields.balance': 'Parseh balance',
    'profile.identity.note': 'Your mobile number comes from your Parsina sign-in account and is changed there, not here.',
    'profile.saved': 'Profile saved.',
    'profile.appearance.theme': 'Accent colour',
    'profile.appearance.fontSize': 'Text size',
    'profile.appearance.language': 'Language',
    'profile.appearance.localOnly': "These are remembered in this browser only \u2014 they do not follow you to another device.",
    'profile.theme.default': 'Parsina blue',
    'profile.theme.teal': 'Teal',
    'profile.theme.ocean': 'Ocean',
    'profile.theme.slate': 'Slate blue',
    'profile.fontSize.small': 'Small',
    'profile.fontSize.medium': 'Medium',
    'profile.fontSize.large': 'Large',
    'profile.language.fa': "\u0641\u0627\u0631\u0633\u06CC",
    'profile.language.en': 'English',
    'profile.logout': 'Sign out'
};
var $d770f6c8c996d2d3$export$2e2bcd8739ae039 = $d770f6c8c996d2d3$export$4882ae973e0491e;


// The error vocabulary of core.md §14, one key per code.
const $91ffcbd526d95c7e$export$30f3b02011db23c0 = {
    // ── errors ───────────────────────────────────────────────────────────
    'errors.generic': 'Something went wrong.',
    'errors.loadFailed': 'Could not load.',
    'errors.saveFailed': 'Could not save.',
    'errors.deleteFailed': 'Could not delete.',
    'errors.invalidInput': 'Some of what you entered is not valid.',
    'errors.insufficientCredits': 'Not enough Parseh for this action.',
    'errors.unavailable': 'The service is not available right now.',
    'errors.unavailableBody': "The server did not answer. Nothing was lost \u2014 try again in a moment.",
    'errors.notFound': 'Not found.',
    'errors.encounterClosed': 'This visit is closed. Reopen it to make changes.',
    'errors.anotherEncounterOpen': 'Another visit is already open for this patient.',
    'errors.caseArchived': 'This patient is archived. Unarchive it to start a visit.',
    'errors.threadNotFound': 'That conversation no longer exists.',
    'errors.queryTooComplex': 'The request was too large. Reopen the page.',
    'errors.offline': 'You are offline.'
};
var $91ffcbd526d95c7e$export$2e2bcd8739ae039 = $91ffcbd526d95c7e$export$30f3b02011db23c0;


const $6ecdd4f2fd8400bc$export$84584c2a98eb6753 = {
    ...(0, $c41f06ba6bf140f2$export$919daad019702595),
    ...(0, $8f48bf69643a3ca0$export$80e4b313e5e6b30d),
    ...(0, $4152f707a3a6bfcc$export$596d806903d1f59e),
    ...(0, $ef4b345cd740543e$export$66d87fc9a79fcf2d),
    ...(0, $1e09a0565f515ba1$export$4a82ecccfc2a9a4a),
    ...(0, $353ea1a139e95e5e$export$e5185e241753e543),
    ...(0, $1b3e413808cf2139$export$530dccc8e24f4e99),
    ...(0, $55539e1145d82385$export$bf638b60ea8b89b7),
    ...(0, $429b796293eac695$export$68c7321cb43cac49),
    ...(0, $d770f6c8c996d2d3$export$4882ae973e0491e),
    ...(0, $91ffcbd526d95c7e$export$30f3b02011db23c0)
};
var $6ecdd4f2fd8400bc$export$2e2bcd8739ae039 = $6ecdd4f2fd8400bc$export$84584c2a98eb6753;


// FA — the product language. One flat map, composed from one module per
// namespace.
//
// ── Why the split exists ─────────────────────────────────────────────────
//
// This catalogue was a single 600-line map, and a single map is a file two
// people cannot write at the same time: the patients screen, the chat page and
// the visit workspace are being built in parallel, and every one of them adds
// copy. Two authors appending to one object produce a conflict on every hunk,
// and the resolution — «keep both» — is exactly where a duplicate key or a lost
// line comes from. So the copy now lives in ./fa/<namespace>.js, ONE FILE PER
// NAMESPACE, and this file only merges them. An author owns a namespace, edits
// that file alone, and never touches a line another author wrote. ./fa/chat.js
// and ./fa/visit.js in particular belong to the chat and visit authors; nothing
// else may add keys to them.
//
// The EXPORTED SHAPE is unchanged: `fa` is still the flat, fully-qualified,
// dotted-key map that catalogs.js, translator.js and tests/i18n.test.js consume.
// Nothing downstream knows the split happened.
//
// Every key here must exist in en.js (EN is the source catalogue) and every EN
// key must be translated here; tests/i18n.test.js asserts both directions.
//
// The `practice.*` lines and the assistant's disclaimer are the copy core.md
// §3.1 calls non-negotiable, and Persian is the language it names: this is the
// text a student actually reads before they act on a model's answer. Do not
// soften it.
// Chrome, actions, units, the practice/AI notices and the shortcut overlay —
// the copy every screen shares.
const $8cbe6b749c07aa23$export$919daad019702595 = {
    // ── app ──────────────────────────────────────────────────────────────
    'app.title': "\u067E\u0627\u0631\u0633\u06CC\u0646\u0627 \u2014 \u067E\u0646\u0644 \u062F\u0627\u0646\u0634\u062C\u0648 \u0648 \u062F\u0633\u062A\u06CC\u0627\u0631",
    // ── common ───────────────────────────────────────────────────────────
    'common.actions.cancel': "\u0627\u0646\u0635\u0631\u0627\u0641",
    'common.actions.retry': "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
    'common.actions.save': "\u0630\u062E\u06CC\u0631\u0647",
    'common.actions.saving': "\u062F\u0631 \u062D\u0627\u0644 \u0630\u062E\u06CC\u0631\u0647\u2026",
    'common.actions.back': "\u0628\u0627\u0632\u06AF\u0634\u062A",
    'common.actions.add': "\u0627\u0641\u0632\u0648\u062F\u0646",
    'common.actions.edit': "\u0648\u06CC\u0631\u0627\u06CC\u0634",
    'common.actions.delete': "\u062D\u0630\u0641",
    'common.actions.close': "\u0628\u0633\u062A\u0646",
    'common.actions.confirm': "\u062A\u0623\u06CC\u06CC\u062F",
    'common.actions.create': "\u0633\u0627\u062E\u062A\u0646",
    'common.actions.open': "\u0628\u0627\u0632 \u06A9\u0631\u062F\u0646",
    'common.actions.clear': "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646",
    'common.actions.copy': "\u06A9\u067E\u06CC",
    'common.actions.copied': "\u06A9\u067E\u06CC \u0634\u062F",
    'common.actions.rename': "\u062A\u063A\u06CC\u06CC\u0631 \u0646\u0627\u0645",
    'common.actions.more': "\u0628\u06CC\u0634\u062A\u0631",
    'common.actions.viewAll': "\u0645\u0634\u0627\u0647\u062F\u0647\u0654 \u0647\u0645\u0647",
    'common.actions.continue': "\u0627\u062F\u0627\u0645\u0647",
    'common.labels.none': "\u2014",
    'common.labels.optional': "\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC",
    'common.labels.search': "\u062C\u0633\u062A\u062C\u0648",
    'common.labels.loading': "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC\u2026",
    'common.state.all': "\u0647\u0645\u0647",
    'common.state.pleaseWait': "\u0644\u0637\u0641\u0627\u064B \u0635\u0628\u0631 \u06A9\u0646\u06CC\u062F\u2026",
    'common.time.today': "\u0627\u0645\u0631\u0648\u0632",
    'common.time.yesterday': "\u062F\u06CC\u0631\u0648\u0632",
    'common.time.last7': "\u06F7 \u0631\u0648\u0632 \u06AF\u0630\u0634\u062A\u0647",
    'common.time.older': "\u0642\u062F\u06CC\u0645\u06CC\u200C\u062A\u0631",
    'common.units.parseh': "\u067E\u0627\u0631\u0633\u0647",
    'common.units.toman': "\u062A\u0648\u0645\u0627\u0646",
    'common.units.tomanShort': "\u062A",
    'common.units.years': "{{count}} \u0633\u0627\u0644",
    'common.units.kg': "\u06A9\u06CC\u0644\u0648\u06AF\u0631\u0645",
    'common.units.cm': "\u0633\u0627\u0646\u062A\u06CC\u200C\u0645\u062A\u0631",
    'common.units.second': "\u062B\u0627\u0646\u06CC\u0647",
    'common.gender.male': "\u0645\u0631\u062F",
    'common.gender.female': "\u0632\u0646",
    'common.gender.other': "\u0633\u0627\u06CC\u0631",
    // ── mobile shell ─────────────────────────────────────────────────────
    'mobile.greeting': "\u062E\u0648\u0634 \u0622\u0645\u062F\u06CC\u062F\u060C",
    'mobile.showMore': "\u0646\u0645\u0627\u06CC\u0634 \u0628\u06CC\u0634\u062A\u0631",
    'mobile.close': "\u0628\u0633\u062A\u0646",
    'mobile.menu': "\u0645\u0646\u0648",
    // ── the practice / teaching disclaimers — core.md §3 ─────────────────
    'practice.badge': "\u0628\u06CC\u0645\u0627\u0631 \u062A\u0645\u0631\u06CC\u0646\u06CC",
    'practice.badge.short': "\u062A\u0645\u0631\u06CC\u0646\u06CC",
    'practice.banner.title': "\u0627\u06CC\u0646 \u0628\u06CC\u0645\u0627\u0631 \u062E\u06CC\u0627\u0644\u06CC \u0627\u0633\u062A",
    'practice.banner.body': "\u0647\u0631\u0686\u0647 \u0627\u06CC\u0646\u062C\u0627 \u0645\u06CC\u200C\u0646\u0648\u06CC\u0633\u06CC\u062F \u06CC\u06A9 \u0645\u0648\u0631\u062F \u0622\u0645\u0648\u0632\u0634\u06CC \u0633\u0627\u062E\u062A\u0647\u0654 \u062E\u0648\u062F\u062A\u0627\u0646 \u0627\u0633\u062A. \u0647\u0631\u06AF\u0632 \u0627\u0637\u0644\u0627\u0639\u0627\u062A \u06CC\u06A9 \u0641\u0631\u062F \u0648\u0627\u0642\u0639\u06CC \u0631\u0627 \u0648\u0627\u0631\u062F \u0646\u06A9\u0646\u06CC\u062F \u2014 \u0646\u0647 \u0646\u0627\u0645\u060C \u0646\u0647 \u06A9\u062F \u0645\u0644\u06CC\u060C \u0646\u0647 \u0634\u0645\u0627\u0631\u0647\u0654 \u062A\u0645\u0627\u0633.",
    'practice.caseRef.label': "\u0628\u0631\u0686\u0633\u0628 \u0634\u062E\u0635\u06CC \u067E\u0631\u0648\u0646\u062F\u0647",
    'practice.caseRef.helper': "\u0628\u0631\u0686\u0633\u0628 \u0628\u0627\u06CC\u06AF\u0627\u0646\u06CC \u062E\u0648\u062F\u062A\u0627\u0646 \u2014 \xab\u0645\u0648\u0631\u062F \u06F1\u06F2\xbb\u060C \xabCASE-2026-03\xbb. \u0627\u06CC\u0646 \u06A9\u062F \u0645\u0644\u06CC \u0646\u06CC\u0633\u062A \u0648 \u0647\u0631\u06AF\u0632 \u0646\u0628\u0627\u06CC\u062F \u0628\u0627\u0634\u062F.",
    'practice.ai.title': "\u067E\u0627\u0633\u062E \u0622\u0645\u0648\u0632\u0634\u06CC \u0627\u0633\u062A\u060C \u0646\u0647 \u062A\u0648\u0635\u06CC\u0647\u0654 \u0628\u0627\u0644\u06CC\u0646\u06CC",
    'practice.ai.body': "\u062F\u0633\u062A\u06CC\u0627\u0631 \u0627\u0633\u062A\u062F\u0644\u0627\u0644\u0634 \u0631\u0627 \u062A\u0648\u0636\u06CC\u062D \u0645\u06CC\u200C\u062F\u0647\u062F \u062A\u0627 \u0622\u0646 \u0631\u0627 \u0645\u0637\u0627\u0644\u0639\u0647 \u06A9\u0646\u06CC\u062F. \u067E\u0627\u0633\u062E \u062F\u0631\u0628\u0627\u0631\u0647\u0654 \u06CC\u06A9 \u0628\u06CC\u0645\u0627\u0631 \u062E\u06CC\u0627\u0644\u06CC \u0627\u0633\u062A \u0648 \u0647\u0631\u06AF\u0632 \u0646\u0628\u0627\u06CC\u062F \u0628\u0631\u0627\u06CC \u062F\u0631\u0645\u0627\u0646 \u0641\u0631\u062F \u0648\u0627\u0642\u0639\u06CC \u0628\u0647 \u06A9\u0627\u0631 \u0631\u0648\u062F.",
    'practice.ai.short': "\u0622\u0645\u0648\u0632\u0634\u06CC \u0627\u0633\u062A\u060C \u0646\u0647 \u062A\u0648\u0635\u06CC\u0647\u0654 \u0628\u0627\u0644\u06CC\u0646\u06CC.",
    // ── keyboard shortcuts ───────────────────────────────────────────────
    'shortcuts.title': "\u0645\u06CC\u0627\u0646\u0628\u0631\u0647\u0627\u06CC \u0635\u0641\u062D\u0647\u200C\u06A9\u0644\u06CC\u062F",
    'shortcuts.groups.general': "\u0639\u0645\u0648\u0645\u06CC",
    'shortcuts.groups.visit': "\u0648\u06CC\u0632\u06CC\u062A",
    'shortcuts.search': "\u062C\u0633\u062A\u062C\u0648\u06CC \u0628\u06CC\u0645\u0627\u0631",
    'shortcuts.help': "\u0647\u0645\u06CC\u0646 \u0641\u0647\u0631\u0633\u062A",
    'shortcuts.close': "\u0628\u0633\u062A\u0646 \u067E\u0646\u062C\u0631\u0647\u0654 \u0628\u0627\u0632",
    'shortcuts.empty': "\u062F\u0631 \u0627\u06CC\u0646 \u0635\u0641\u062D\u0647 \u0645\u06CC\u0627\u0646\u0628\u0631\u06CC \u0646\u06CC\u0633\u062A.",
    // The static reference the `?` overlay shows OUTSIDE a visit: the bindings
    // only exist while a visit is open, but a student should be able to read them
    // before opening one.
    'shortcuts.groups.insideVisit': "\u062F\u0627\u062E\u0644 \u0648\u06CC\u0632\u06CC\u062A",
    // ── paging ───────────────────────────────────────────────────────────
    'common.pager.prev': "\u0642\u0628\u0644\u06CC",
    'common.pager.next': "\u0628\u0639\u062F\u06CC",
    'common.pager.page': "\u0635\u0641\u062D\u0647 {{current}} \u0627\u0632 {{pages}}",
    // ── connectivity banner — core.md §15 ────────────────────────────────
    'connectivity.offline': "\u0627\u06CC\u0646\u062A\u0631\u0646\u062A \u0642\u0637\u0639 \u0627\u0633\u062A \u2014 \u062A\u063A\u06CC\u06CC\u0631\u0627\u062A \u062B\u0628\u062A \u0646\u0645\u06CC\u200C\u0634\u0648\u062F",
    'connectivity.degraded': "\u0627\u0631\u062A\u0628\u0627\u0637 \u0628\u0627 \u0633\u0631\u0648\u0631 \u0628\u0631\u0642\u0631\u0627\u0631 \u0646\u06CC\u0633\u062A \u2014 \u062F\u0631 \u062D\u0627\u0644 \u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
    'connectivity.restored': "\u0627\u062A\u0635\u0627\u0644 \u062F\u0648\u0628\u0627\u0631\u0647 \u0628\u0631\u0642\u0631\u0627\u0631 \u0634\u062F",
    'connectivity.retry': "\u0628\u0631\u0631\u0633\u06CC \u062F\u0648\u0628\u0627\u0631\u0647",
    'connectivity.checking': "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0631\u0631\u0633\u06CC\u2026"
};
var $8cbe6b749c07aa23$export$2e2bcd8739ae039 = $8cbe6b749c07aa23$export$919daad019702595;


// The four destinations, and the rail around them.
const $0b2899e8f9498f7d$export$80e4b313e5e6b30d = {
    // ── nav / chrome ─────────────────────────────────────────────────────
    'nav.brand.name': "\u067E\u0627\u0631\u0633\u06CC\u0646\u0627",
    'nav.brand.panel': "\u067E\u0646\u0644 \u062F\u0627\u0646\u0634\u062C\u0648 \u0648 \u062F\u0633\u062A\u06CC\u0627\u0631",
    'nav.items.patients': "\u0628\u06CC\u0645\u0627\u0631\u0627\u0646",
    'nav.items.chat': "\u06AF\u0641\u062A\u06AF\u0648",
    'nav.items.credits': "\u067E\u0627\u0631\u0633\u0647",
    'nav.items.profile': "\u067E\u0631\u0648\u0641\u0627\u06CC\u0644",
    'nav.sidebar.collapse': "\u0628\u0633\u062A\u0646 \u0645\u0646\u0648",
    'nav.sidebar.expand': "\u0628\u0627\u0632 \u06A9\u0631\u062F\u0646 \u0645\u0646\u0648",
    'nav.sidebar.logout': "\u062E\u0631\u0648\u062C \u0627\u0632 \u062D\u0633\u0627\u0628",
    'nav.sidebar.editProfile': "\u067E\u0631\u0648\u0641\u0627\u06CC\u0644",
    'nav.sidebar.shortcuts': "\u0645\u06CC\u0627\u0646\u0628\u0631\u0647\u0627\u06CC \u0635\u0641\u062D\u0647\u200C\u06A9\u0644\u06CC\u062F",
    'nav.balance.label': "\u0645\u0648\u062C\u0648\u062F\u06CC",
    'nav.landmark.primary': "\u0645\u0646\u0648\u06CC \u0627\u0635\u0644\u06CC",
    'nav.landmark.content': "\u0645\u062D\u062A\u0648\u0627"
};
var $0b2899e8f9498f7d$export$2e2bcd8739ae039 = $0b2899e8f9498f7d$export$80e4b313e5e6b30d;


// The sign-in screen and the session states around it.
const $f4588d8a9a359f11$export$596d806903d1f59e = {
    // ── auth ─────────────────────────────────────────────────────────────
    'auth.checking': "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0631\u0631\u0633\u06CC \u0646\u0634\u0633\u062A\u2026",
    'auth.loading': "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0641\u0636\u0627\u06CC \u06A9\u0627\u0631\u06CC\u2026",
    'auth.retry': "\u0634\u0631\u0648\u0639 \u062F\u0648\u0628\u0627\u0631\u0647",
    'auth.loopError': "\u0648\u0631\u0648\u062F \u0628\u0627\u0631\u0647\u0627 \u062A\u06A9\u0631\u0627\u0631 \u0634\u062F \u0648 \u0645\u062A\u0648\u0642\u0641 \u0634\u062F. \u0646\u0634\u0633\u062A \u0631\u0627 \u067E\u0627\u06A9 \u06A9\u0646\u06CC\u062F \u0648 \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.",
    'auth.loopTitle': "\u0648\u0631\u0648\u062F \u0646\u0627\u0645\u0648\u0641\u0642 \u0628\u0648\u062F",
    'auth.checkingHint': "\u0686\u0646\u062F \u0644\u062D\u0638\u0647 \u0635\u0628\u0631 \u06A9\u0646\u06CC\u062F",
    'auth.stuck': "\u0647\u062F\u0627\u06CC\u062A \u0646\u0634\u062F\u06CC\u062F\u061F",
    'auth.manualSignIn': "\u0627\u06CC\u0646\u062C\u0627 \u06A9\u0644\u06CC\u06A9 \u06A9\u0646\u06CC\u062F",
    // core.md §4.3: the boot's status query failing is «سرویس در دسترس نیست» —
    // an outage with a retry, never a verdict about the account.
    'auth.bootFailed.title': "\u0633\u0631\u0648\u06CC\u0633 \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A",
    'auth.bootFailed.body': "\u0633\u0631\u0648\u0631 \u067E\u0627\u0633\u062E \u0646\u062F\u0627\u062F. \u0645\u0634\u06A9\u0644\u06CC \u0628\u0631\u0627\u06CC \u062D\u0633\u0627\u0628 \u0634\u0645\u0627 \u067E\u06CC\u0634 \u0646\u06CC\u0627\u0645\u062F\u0647 \u0648 \u0628\u06CC\u0645\u0627\u0631\u0627\u0646 \u0634\u0645\u0627 \u062F\u0633\u062A\u200C\u0646\u062E\u0648\u0631\u062F\u0647\u200C\u0627\u0646\u062F.",
    'auth.session.expiringTitle': "\u0646\u0634\u0633\u062A \u0634\u0645\u0627 \u062F\u0631 \u062D\u0627\u0644 \u067E\u0627\u06CC\u0627\u0646 \u0627\u0633\u062A",
    'auth.session.expiringBody': "\u0628\u0631\u0627\u06CC \u0627\u062F\u0627\u0645\u0647\u0654 \u06A9\u0627\u0631 \u0628\u062F\u0648\u0646 \u0648\u0642\u0641\u0647\u060C \u0646\u0634\u0633\u062A \u0631\u0627 \u062A\u0645\u062F\u06CC\u062F \u06A9\u0646\u06CC\u062F. \u0622\u0646\u0686\u0647 \u0646\u0648\u0634\u062A\u0647\u200C\u0627\u06CC\u062F \u062F\u0631 \u0647\u0631 \u0635\u0648\u0631\u062A \u0631\u0648\u06CC \u0635\u0641\u062D\u0647 \u0645\u06CC\u200C\u0645\u0627\u0646\u062F.",
    'auth.session.staySignedIn': "\u0627\u062F\u0627\u0645\u0647\u0654 \u06A9\u0627\u0631",
    'auth.session.expiredTitle': "\u0646\u0634\u0633\u062A \u0634\u0645\u0627 \u0628\u0647 \u067E\u0627\u06CC\u0627\u0646 \u0631\u0633\u06CC\u062F",
    'auth.session.expiredBody': "\u0628\u0631\u0627\u06CC \u0627\u062F\u0627\u0645\u0647 \u062F\u0648\u0628\u0627\u0631\u0647 \u0648\u0627\u0631\u062F \u0634\u0648\u06CC\u062F. \u0628\u0647 \u0647\u0645\u06CC\u0646 \u0635\u0641\u062D\u0647 \u0628\u0631\u0645\u06CC\u200C\u06AF\u0631\u062F\u06CC\u062F.",
    'auth.session.signInAgain': "\u0648\u0631\u0648\u062F \u0645\u062C\u062F\u062F",
    'auth.session.returnNotice': "\u0622\u0646\u0686\u0647 \u0630\u062E\u06CC\u0631\u0647 \u06A9\u0631\u062F\u0647\u200C\u0627\u06CC\u062F \u0645\u062D\u0641\u0648\u0638 \u0627\u0633\u062A. \u0622\u0646\u0686\u0647 \u0631\u0648\u06CC \u0635\u0641\u062D\u0647 \u0627\u0633\u062A \u0648 \u0647\u0646\u0648\u0632 \u0630\u062E\u06CC\u0631\u0647 \u0646\u0634\u062F\u0647 \u0645\u0645\u06A9\u0646 \u0627\u0633\u062A \u0627\u0632 \u062F\u0633\u062A \u0628\u0631\u0648\u062F.",
    // ── login ────────────────────────────────────────────────────────────
    'login.title': "\u067E\u0646\u0644 \u062F\u0627\u0646\u0634\u062C\u0648 \u0648 \u062F\u0633\u062A\u06CC\u0627\u0631",
    'login.sub': "\u0628\u06CC\u0645\u0627\u0631 \u0628\u0633\u0627\u0632\u06CC\u062F\u060C \u0648\u06CC\u0632\u06CC\u062A \u0631\u0627 \u0645\u0633\u062A\u0646\u062F \u06A9\u0646\u06CC\u062F \u0648 \u0627\u0632 \u062F\u0633\u062A\u06CC\u0627\u0631 \u0622\u0645\u0648\u0632\u0634\u06CC \xab\u0686\u0631\u0627\xbb \u0628\u067E\u0631\u0633\u06CC\u062F.",
    'login.action': "\u0648\u0631\u0648\u062F \u06CC\u0627 \u062B\u0628\u062A\u200C\u0646\u0627\u0645 \u0628\u0627 \u0634\u0645\u0627\u0631\u0647\u0654 \u0645\u0648\u0628\u0627\u06CC\u0644",
    'login.working': "\u062F\u0631 \u062D\u0627\u0644 \u0627\u0646\u062A\u0642\u0627\u0644 \u0628\u0647 \u0635\u0641\u062D\u0647\u0654 \u0648\u0631\u0648\u062F\u2026",
    'login.hint': "\u0648\u0631\u0648\u062F \u0628\u0627 \u0634\u0645\u0627\u0631\u0647\u0654 \u0645\u0648\u0628\u0627\u06CC\u0644 \u0648 \u06A9\u062F \u06CC\u06A9\u200C\u0628\u0627\u0631\u0645\u0635\u0631\u0641 \u0627\u0646\u062C\u0627\u0645 \u0645\u06CC\u200C\u0634\u0648\u062F.",
    'login.feature.case.title': "\u0628\u06CC\u0645\u0627\u0631 \u062A\u0645\u0631\u06CC\u0646\u06CC \u0628\u0633\u0627\u0632\u06CC\u062F",
    'login.feature.case.body': "\u0641\u0631\u062F\u06CC \u062E\u06CC\u0627\u0644\u06CC \u06A9\u0647 \u062E\u0648\u062F\u062A\u0627\u0646 \u0645\u06CC\u200C\u0633\u0627\u0632\u06CC\u062F. \u0647\u0631\u06AF\u0632 \u06CC\u06A9 \u0641\u0631\u062F \u0648\u0627\u0642\u0639\u06CC.",
    'login.feature.visit.title': "\u0648\u06CC\u0632\u06CC\u062A \u0631\u0627 \u0645\u0633\u062A\u0646\u062F \u06A9\u0646\u06CC\u062F",
    'login.feature.visit.body': "\u06CC\u0627\u062F\u062F\u0627\u0634\u062A SOAP\u060C \u062A\u0634\u062E\u06CC\u0635\u200C\u0647\u0627\u060C \u0646\u0633\u062E\u0647 \u0648 \u062F\u0633\u062A\u0648\u0631\u0627\u062A \u2014 \u0647\u0645\u0627\u0646\u200C\u0637\u0648\u0631 \u06A9\u0647 \u06CC\u06A9 \u067E\u0632\u0634\u06A9 \u0645\u06CC\u200C\u0646\u0648\u06CC\u0633\u062F.",
    'login.feature.chat.title': "\u0628\u0627 \u062F\u0633\u062A\u06CC\u0627\u0631 \u0622\u0645\u0648\u0632\u0634\u06CC \u06AF\u0641\u062A\u06AF\u0648 \u06A9\u0646\u06CC\u062F",
    'login.feature.chat.body': "\u06A9\u0644 \u067E\u0631\u0648\u0646\u062F\u0647 \u0631\u0627 \u0645\u06CC\u200C\u0634\u0646\u0627\u0633\u062F \u0648 \u0627\u0633\u062A\u062F\u0644\u0627\u0644\u0634 \u0631\u0627 \u062A\u0648\u0636\u06CC\u062D \u0645\u06CC\u200C\u062F\u0647\u062F.",
    'login.free': "\u0647\u0631 \u0645\u0627\u0647 \u06F5\u06F0\u06F0 \u067E\u0627\u0631\u0633\u0647 \u0631\u0627\u06CC\u06AF\u0627\u0646",
    'login.badRedirect': "\u0627\u06CC\u0646 \u0646\u0634\u0627\u0646\u06CC \u0628\u0631\u0627\u06CC \u0648\u0631\u0648\u062F \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A. \u067E\u0646\u0644 \u0631\u0627 \u0627\u0632 \u0646\u0634\u0627\u0646\u06CC \u0631\u0633\u0645\u06CC \u0628\u0627\u0632 \u06A9\u0646\u06CC\u062F."
};
var $f4588d8a9a359f11$export$2e2bcd8739ae039 = $f4588d8a9a359f11$export$596d806903d1f59e;


// The one-step profile form of core.md §4.3 — its fields, its rules, its states.
const $4a5379b2c5080346$export$66d87fc9a79fcf2d = {
    // ── onboarding — core.md §4.3 ────────────────────────────────────────
    'onboarding.title': "\u062E\u0648\u0634 \u0622\u0645\u062F\u06CC\u062F \u2014 \u062E\u0648\u062F\u062A\u0627\u0646 \u0631\u0627 \u0645\u0639\u0631\u0641\u06CC \u06A9\u0646\u06CC\u062F",
    'onboarding.sub': "\u06CC\u06A9 \u0641\u0631\u0645 \u06A9\u0648\u062A\u0627\u0647. \u0647\u0645\u0647\u200C\u0627\u0634 \u0631\u0627 \u0628\u0639\u062F\u0627\u064B \u062F\u0631 \u067E\u0631\u0648\u0641\u0627\u06CC\u0644 \u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u06CC\u062F \u062A\u063A\u06CC\u06CC\u0631 \u062F\u0647\u06CC\u062F.",
    'onboarding.fields.fullName': "\u0646\u0627\u0645 \u0648 \u0646\u0627\u0645 \u062E\u0627\u0646\u0648\u0627\u062F\u06AF\u06CC",
    'onboarding.fields.studentNumber': "\u0634\u0645\u0627\u0631\u0647 \u062F\u0627\u0646\u0634\u062C\u0648\u06CC\u06CC",
    'onboarding.fields.studentNumberHelper': "\u0634\u0645\u0627\u0631\u0647\u0654 \u062F\u0627\u0646\u0634\u062C\u0648\u06CC\u06CC \u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0634\u0645\u0627 \u2014 \u0646\u0647 \u06A9\u062F \u0646\u0638\u0627\u0645 \u067E\u0632\u0634\u06A9\u06CC. \u0628\u0631\u0631\u0633\u06CC \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
    'onboarding.fields.university': "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647",
    'onboarding.fields.universityHelper': "\u0627\u0632 \u0641\u0647\u0631\u0633\u062A \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F \u06CC\u0627 \u062E\u0648\u062F\u062A\u0627\u0646 \u0628\u0646\u0648\u06CC\u0633\u06CC\u062F.",
    'onboarding.fields.level': "\u0645\u0642\u0637\u0639",
    'onboarding.fields.field': "\u0631\u0634\u062A\u0647",
    'onboarding.fields.fieldHelper': "\u0631\u0634\u062A\u0647\u0654 \u062F\u0633\u062A\u06CC\u0627\u0631\u06CC\u060C \u0645\u062B\u0644\u0627\u064B \u062F\u0627\u062E\u0644\u06CC.",
    'onboarding.fields.entryYear': "\u0633\u0627\u0644 \u0648\u0631\u0648\u062F (\u0634\u0645\u0633\u06CC)",
    'onboarding.fields.bio': "\u0645\u0639\u0631\u0641\u06CC \u06A9\u0648\u062A\u0627\u0647",
    'onboarding.fields.phone': "\u0634\u0645\u0627\u0631\u0647\u0654 \u0645\u0648\u0628\u0627\u06CC\u0644",
    'onboarding.fields.phoneHelper': "\u0627\u0632 \u062D\u0633\u0627\u0628 \u0648\u0631\u0648\u062F \u0634\u0645\u0627 \u062E\u0648\u0627\u0646\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u0627\u0632 \u0647\u0645\u0627\u0646\u200C\u062C\u0627 \u062A\u063A\u06CC\u06CC\u0631 \u0645\u06CC\u200C\u06A9\u0646\u062F.",
    'onboarding.level.student': "\u062F\u0627\u0646\u0634\u062C\u0648\u06CC \u067E\u0632\u0634\u06A9\u06CC",
    'onboarding.level.intern': "\u06A9\u0627\u0631\u0648\u0631\u0632",
    'onboarding.level.resident': "\u062F\u0633\u062A\u06CC\u0627\u0631 \u062A\u062E\u0635\u0635\u06CC",
    'onboarding.submit': "\u0634\u0631\u0648\u0639",
    'onboarding.saving': "\u062F\u0631 \u062D\u0627\u0644 \u0630\u062E\u06CC\u0631\u0647\u0654 \u067E\u0631\u0648\u0641\u0627\u06CC\u0644\u2026",
    'onboarding.done': "\u0622\u0645\u0627\u062F\u0647 \u0627\u0633\u062A \u2014 \u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0632 \u06A9\u0631\u062F\u0646 \u0628\u06CC\u0645\u0627\u0631\u0627\u0646\u2026",
    'onboarding.validation.fullName': "\u0646\u0627\u0645 \u062E\u0648\u062F \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F (\u06F2 \u062A\u0627 \u06F1\u06F2\u06F0 \u0646\u0648\u06CC\u0633\u0647).",
    'onboarding.validation.studentNumber': "\u06F4 \u062A\u0627 \u06F2\u06F0 \u062D\u0631\u0641\u060C \u0631\u0642\u0645 \u06CC\u0627 \u062E\u0637 \u062A\u06CC\u0631\u0647 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.",
    'onboarding.validation.university': "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u062E\u0648\u062F \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F (\u06F2 \u062A\u0627 \u06F1\u06F2\u06F0 \u0646\u0648\u06CC\u0633\u0647).",
    'onboarding.validation.level': "\u0645\u0642\u0637\u0639 \u062E\u0648\u062F \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F.",
    'onboarding.validation.field': "\u062D\u062F\u0627\u06A9\u062B\u0631 \u06F8\u06F0 \u0646\u0648\u06CC\u0633\u0647.",
    'onboarding.validation.entryYear': "\u06CC\u06A9 \u0633\u0627\u0644 \u0634\u0645\u0633\u06CC \u0628\u06CC\u0646 \u06F1\u06F3\u06F7\u06F0 \u0648 \u06F1\u06F4\u06F2\u06F0.",
    'onboarding.validation.bio': "\u062D\u062F\u0627\u06A9\u062B\u0631 \u06F5\u06F0\u06F0 \u0646\u0648\u06CC\u0633\u0647.",
    'onboarding.error.unavailable': "\u0641\u0639\u0644\u0627\u064B \u0630\u062E\u06CC\u0631\u0647 \u0646\u0634\u062F. \u067E\u0627\u0633\u062E\u200C\u0647\u0627\u06CC \u0634\u0645\u0627 \u0646\u06AF\u0647 \u062F\u0627\u0634\u062A\u0647 \u0634\u062F\u0647\u200C\u0627\u0646\u062F\u061B \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F."
};
var $4a5379b2c5080346$export$2e2bcd8739ae039 = $4a5379b2c5080346$export$66d87fc9a79fcf2d;


// «بیماران» — the list, its toolbar and its states — plus the patient form that
// both the create dialog and the edit drawer render.
const $88e3875838382379$export$4a82ecccfc2a9a4a = {
    // ── patients — the list ──────────────────────────────────────────────
    'patients.title': "\u0628\u06CC\u0645\u0627\u0631\u0627\u0646 \u062A\u0645\u0631\u06CC\u0646\u06CC",
    'patients.sub': "\u0628\u06CC\u0645\u0627\u0631\u0627\u0646 \u062E\u06CC\u0627\u0644\u06CC \u06A9\u0647 \u0628\u0631\u0627\u06CC \u062A\u0645\u0631\u06CC\u0646 \u0633\u0627\u062E\u062A\u0647\u200C\u0627\u06CC\u062F.",
    'patients.new': "\u0628\u06CC\u0645\u0627\u0631 \u062C\u062F\u06CC\u062F",
    'patients.search': "\u062C\u0633\u062A\u062C\u0648\u06CC \u0628\u06CC\u0645\u0627\u0631\u2026",
    'patients.count': "{{count}} \u0628\u06CC\u0645\u0627\u0631",
    'patients.filters.active': "\u0641\u0639\u0627\u0644",
    'patients.filters.draft': "\u067E\u06CC\u0634\u200C\u0646\u0648\u06CC\u0633",
    'patients.filters.archived': "\u0628\u0627\u06CC\u06AF\u0627\u0646\u06CC",
    'patients.filters.all': "\u0647\u0645\u0647",
    'patients.sort.label': "\u0645\u0631\u062A\u0628\u200C\u0633\u0627\u0632\u06CC",
    'patients.sort.lastVisit': "\u0622\u062E\u0631\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A",
    'patients.sort.newest': "\u062A\u0627\u0632\u0647\u200C\u062A\u0631\u06CC\u0646",
    'patients.sort.name': "\u0646\u0627\u0645",
    'patients.columns.name': "\u0646\u0627\u0645 / \u0628\u0631\u0686\u0633\u0628",
    'patients.columns.age': "\u0633\u0646 \u0648 \u062C\u0646\u0633\u06CC\u062A",
    'patients.columns.complaint': "\u0634\u06A9\u0627\u06CC\u062A \u0627\u0635\u0644\u06CC",
    'patients.columns.visits': "\u0648\u06CC\u0632\u06CC\u062A\u200C\u0647\u0627",
    'patients.columns.lastVisit': "\u0622\u062E\u0631\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A",
    'patients.columns.status': "\u0648\u0636\u0639\u06CC\u062A",
    'patients.columns.actions': "\u0639\u0645\u0644\u06CC\u0627\u062A",
    'patients.status.draft': "\u067E\u06CC\u0634\u200C\u0646\u0648\u06CC\u0633",
    'patients.status.active': "\u0641\u0639\u0627\u0644",
    'patients.status.archived': "\u0628\u0627\u06CC\u06AF\u0627\u0646\u06CC",
    'patients.empty.title': "\u0647\u0646\u0648\u0632 \u0628\u06CC\u0645\u0627\u0631\u06CC \u0646\u0633\u0627\u062E\u062A\u0647\u200C\u0627\u06CC\u062F",
    'patients.empty.body': "\u0628\u06CC\u0645\u0627\u0631\u0627\u0646 \u0627\u06CC\u0646\u062C\u0627 \u062E\u06CC\u0627\u0644\u06CC\u200C\u0627\u0646\u062F \u2014 \u06CC\u06A9\u06CC \u0628\u0633\u0627\u0632\u06CC\u062F \u0648 \u062A\u0645\u0631\u06CC\u0646 \u0631\u0627 \u0634\u0631\u0648\u0639 \u06A9\u0646\u06CC\u062F.",
    'patients.noMatch.title': "\u0645\u0648\u0631\u062F\u06CC \u0645\u0637\u0627\u0628\u0642 \u062C\u0633\u062A\u062C\u0648 \u0646\u06CC\u0633\u062A",
    'patients.noMatch.body': "\u0628\u0631\u0627\u06CC \u062F\u06CC\u062F\u0646 \u0647\u0645\u0647\u0654 \u0628\u06CC\u0645\u0627\u0631\u0627\u0646 \u0641\u06CC\u0644\u062A\u0631 \u0631\u0627 \u067E\u0627\u06A9 \u06A9\u0646\u06CC\u062F.",
    'patients.error.title': "\u0628\u06CC\u0645\u0627\u0631\u0627\u0646 \u0634\u0645\u0627 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F",
    'patients.error.body': "\u0633\u0631\u0648\u0631 \u067E\u0627\u0633\u062E \u0646\u062F\u0627\u062F. \u0686\u06CC\u0632\u06CC \u0627\u0632 \u062F\u0633\u062A \u0646\u0631\u0641\u062A\u0647 \u0627\u0633\u062A.",
    'patients.capped': "\u0628\u06CC\u0634 \u0627\u0632 \u06F1\u06F0\u06F0 \u0628\u06CC\u0645\u0627\u0631\u061B \u0628\u0631\u0627\u06CC \u06CC\u0627\u0641\u062A\u0646 \u0633\u0631\u06CC\u0639\u200C\u062A\u0631 \u062C\u0633\u062A\u062C\u0648 \u06A9\u0646\u06CC\u062F.",
    'patients.delete.title': "\u0627\u06CC\u0646 \u0628\u06CC\u0645\u0627\u0631 \u062D\u0630\u0641 \u0634\u0648\u062F\u061F",
    'patients.delete.body': "{{entries}} \u0628\u062E\u0634 \u0634\u0631\u062D \u062D\u0627\u0644\u060C {{visits}} \u0648\u06CC\u0632\u06CC\u062A \u0648 {{threads}} \u06AF\u0641\u062A\u06AF\u0648 \u0628\u0627 \u0622\u0646 \u062D\u0630\u0641 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F. \u0628\u0627\u0632\u06AF\u0634\u062A\u06CC \u0648\u062C\u0648\u062F \u0646\u062F\u0627\u0631\u062F \u0648 \u067E\u0627\u0631\u0633\u0647\u0654 \u062E\u0631\u062C\u200C\u0634\u062F\u0647 \u0628\u0631\u0646\u0645\u06CC\u200C\u06AF\u0631\u062F\u062F. \u0628\u0631\u0627\u06CC \u062D\u0641\u0638 \u06A9\u0627\u0631\u060C \u0628\u0647\u200C\u062C\u0627\u06CC \u062D\u0630\u0641 \u0628\u0627\u06CC\u06AF\u0627\u0646\u06CC \u06A9\u0646\u06CC\u062F.",
    'patients.delete.confirm': "\u062D\u0630\u0641 \u062F\u0627\u0626\u0645\u06CC",
    'patients.deleted': "\u0628\u06CC\u0645\u0627\u0631 \u062D\u0630\u0641 \u0634\u062F.",
    'patients.created': "\u0628\u06CC\u0645\u0627\u0631 \u0633\u0627\u062E\u062A\u0647 \u0634\u062F.",
    'patients.createdHint': "\u0634\u0631\u062D \u062D\u0627\u0644 \u0631\u0627 \u0628\u0646\u0648\u06CC\u0633\u06CC\u062F \u06CC\u0627 \u062F\u06CC\u06A9\u062A\u0647 \u06A9\u0646\u06CC\u062F.",
    'patients.archived': "\u0628\u0627\u06CC\u06AF\u0627\u0646\u06CC \u0634\u062F.",
    'patients.unarchived': "\u0628\u0647 \u0641\u0647\u0631\u0633\u062A \u0641\u0639\u0627\u0644 \u0628\u0631\u06AF\u0634\u062A.",
    'patients.actions.open': "\u0628\u0627\u0632 \u06A9\u0631\u062F\u0646 \u067E\u0631\u0648\u0646\u062F\u0647",
    'patients.actions.startVisit': "\u0634\u0631\u0648\u0639 \u0648\u06CC\u0632\u06CC\u062A",
    'patients.actions.chat': "\u06AF\u0641\u062A\u06AF\u0648",
    'patients.actions.archive': "\u0628\u0627\u06CC\u06AF\u0627\u0646\u06CC",
    'patients.actions.unarchive': "\u062E\u0631\u0648\u062C \u0627\u0632 \u0628\u0627\u06CC\u06AF\u0627\u0646\u06CC",
    'patients.actions.delete': "\u062D\u0630\u0641",
    'patients.actions.clearFilters': "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u0641\u06CC\u0644\u062A\u0631",
    'patients.openLabel': "\u0628\u0627\u0632 \u06A9\u0631\u062F\u0646 {{title}}",
    'patients.moreLabel': "\u0639\u0645\u0644\u06CC\u0627\u062A \u0628\u06CC\u0634\u062A\u0631 \u0628\u0631\u0627\u06CC {{title}}",
    'patients.unnamed': "\u0628\u06CC\u0645\u0627\u0631 \u0628\u06CC\u200C\u0646\u0627\u0645",
    'patients.visitsCount': "{{count}} \u0648\u06CC\u0632\u06CC\u062A",
    'patients.noVisits': "\u0628\u062F\u0648\u0646 \u0648\u06CC\u0632\u06CC\u062A",
    // ── the patient form — create and edit ───────────────────────────────
    'caseForm.title.create': "\u0628\u06CC\u0645\u0627\u0631 \u062A\u0645\u0631\u06CC\u0646\u06CC \u062C\u062F\u06CC\u062F",
    'caseForm.title.edit': "\u0648\u06CC\u0631\u0627\u06CC\u0634 \u0628\u06CC\u0645\u0627\u0631",
    'caseForm.fields.title': "\u0639\u0646\u0648\u0627\u0646",
    'caseForm.fields.titlePlaceholder': "\u0622\u0642\u0627\u06CC \u06F5\u06F4 \u0633\u0627\u0644\u0647 \u0628\u0627 \u062F\u0631\u062F \u0642\u0641\u0633\u0647\u0654 \u0633\u06CC\u0646\u0647",
    'caseForm.fields.titleHelper': "\u0647\u0645\u0627\u0646 \u0686\u06CC\u0632\u06CC \u06A9\u0647 \u062E\u0648\u062F\u062A\u0627\u0646 \u0627\u06CC\u0646 \u0628\u06CC\u0645\u0627\u0631 \u0631\u0627 \u062F\u0631 \u0641\u0647\u0631\u0633\u062A \u0628\u0627 \u0622\u0646 \u0645\u06CC\u200C\u0634\u0646\u0627\u0633\u06CC\u062F.",
    'caseForm.fields.displayName': "\u0646\u0627\u0645 \u0633\u0627\u062E\u062A\u06AF\u06CC",
    'caseForm.fields.displayNamePlaceholder': "\u0622\u0642\u0627\u06CC \u0631\u0636\u0627\u06CC\u06CC",
    'caseForm.fields.displayNameHelper': "\u06CC\u06A9 \u0646\u0627\u0645 \u0628\u0633\u0627\u0632\u06CC\u062F \u062A\u0627 \u067E\u0631\u0648\u0646\u062F\u0647 \u0637\u0628\u06CC\u0639\u06CC \u062E\u0648\u0627\u0646\u062F\u0647 \u0634\u0648\u062F. \u0647\u0631\u06AF\u0632 \u0646\u0627\u0645 \u06CC\u06A9 \u0641\u0631\u062F \u0648\u0627\u0642\u0639\u06CC.",
    'caseForm.fields.ageYears': "\u0633\u0646 (\u0633\u0627\u0644)",
    'caseForm.fields.ageDisplay': "\u0633\u0646\u060C \u0628\u0627 \u0648\u0627\u062D\u062F \u062F\u06CC\u06AF\u0631",
    'caseForm.fields.ageDisplayPlaceholder': "\u06F6 \u0645\u0627\u0647\u0647",
    'caseForm.fields.ageDisplayHelper': "\u062C\u0627\u06CC\u06AF\u0632\u06CC\u0646 \u0633\u0646\u0650 \u0633\u0627\u0644 \u0645\u06CC\u200C\u0634\u0648\u062F\u061B \u0628\u0631\u0627\u06CC \u0645\u0648\u0631\u062F\u0647\u0627\u06CC \u06A9\u0648\u062F\u06A9\u0627\u0646 \u0648 \u0646\u0648\u0632\u0627\u062F\u0627\u0646.",
    'caseForm.fields.sex': "\u062C\u0646\u0633\u06CC\u062A",
    'caseForm.fields.bloodType': "\u06AF\u0631\u0648\u0647 \u062E\u0648\u0646\u06CC",
    'caseForm.fields.weightKg': "\u0648\u0632\u0646 (\u06A9\u06CC\u0644\u0648\u06AF\u0631\u0645)",
    'caseForm.fields.heightCm': "\u0642\u062F (\u0633\u0627\u0646\u062A\u06CC\u200C\u0645\u062A\u0631)",
    'caseForm.fields.chiefComplaint': "\u0634\u06A9\u0627\u06CC\u062A \u0627\u0635\u0644\u06CC",
    'caseForm.fields.chiefComplaintPlaceholder': "\u062F\u0631\u062F \u0641\u0634\u0627\u0631\u0646\u062F\u0647\u0654 \u0642\u0641\u0633\u0647\u0654 \u0633\u06CC\u0646\u0647 \u0627\u0632 \u0635\u0628\u062D \u0627\u0645\u0631\u0648\u0632",
    'caseForm.fields.chiefComplaintHelper': "\u06CC\u06A9 \u062E\u0637. \u0634\u0631\u062D \u06A9\u0627\u0645\u0644 \u062F\u0631 \u0628\u062E\u0634 \u0634\u0631\u062D \u062D\u0627\u0644 \u0646\u0648\u0634\u062A\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.",
    'caseForm.fields.status': "\u0648\u0636\u0639\u06CC\u062A",
    'caseForm.fields.note': "\u06CC\u0627\u062F\u062F\u0627\u0634\u062A \u0634\u062E\u0635\u06CC",
    'caseForm.submit.create': "\u0633\u0627\u062E\u062A\u0646 \u0628\u06CC\u0645\u0627\u0631",
    'caseForm.submit.edit': "\u0630\u062E\u06CC\u0631\u0647\u0654 \u062A\u063A\u06CC\u06CC\u0631\u0627\u062A",
    'caseForm.validation.title': "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0632\u0627\u0645\u06CC \u0627\u0633\u062A."
};
var $88e3875838382379$export$2e2bcd8739ae039 = $88e3875838382379$export$4a82ecccfc2a9a4a;


// The patient record: header, the four tabs, the شرح حال sections, the timeline.
const $6fdd3abd7668d8a6$export$e5185e241753e543 = {
    // ── the patient record ───────────────────────────────────────────────
    'record.notFound.title': "\u0627\u06CC\u0646 \u0628\u06CC\u0645\u0627\u0631 \u067E\u06CC\u062F\u0627 \u0646\u0634\u062F",
    'record.notFound.body': "\u0645\u0645\u06A9\u0646 \u0627\u0633\u062A \u062D\u0630\u0641 \u0634\u062F\u0647 \u0628\u0627\u0634\u062F. \u0628\u0647 \u0641\u0647\u0631\u0633\u062A \u0628\u06CC\u0645\u0627\u0631\u0627\u0646 \u0628\u0631\u06AF\u0631\u062F\u06CC\u062F.",
    'record.notFound.action': "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0628\u06CC\u0645\u0627\u0631\u0627\u0646",
    'record.tabs.overview': "\u062E\u0644\u0627\u0635\u0647",
    'record.tabs.history': "\u0634\u0631\u062D \u062D\u0627\u0644",
    'record.tabs.visits': "\u0648\u06CC\u0632\u06CC\u062A\u200C\u0647\u0627",
    'record.tabs.timeline': "\u062E\u0637 \u0632\u0645\u0627\u0646\u06CC",
    'record.header.visits': "\u0648\u06CC\u0632\u06CC\u062A \xd7{{count}}",
    'record.header.lastVisit': "\u0622\u062E\u0631\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A {{date}}",
    'record.header.archived': "\u0628\u0627\u06CC\u06AF\u0627\u0646\u06CC\u200C\u0634\u062F\u0647",
    'record.header.archivedHint': "\u0628\u0631\u0627\u06CC \u0634\u0631\u0648\u0639 \u0648\u06CC\u0632\u06CC\u062A\u060C \u0628\u06CC\u0645\u0627\u0631 \u0631\u0627 \u0627\u0632 \u0628\u0627\u06CC\u06AF\u0627\u0646\u06CC \u062E\u0627\u0631\u062C \u06A9\u0646\u06CC\u062F.",
    'record.actions.startVisit': "\u0634\u0631\u0648\u0639 \u0648\u06CC\u0632\u06CC\u062A",
    'record.actions.continueVisit': "\u0627\u062F\u0627\u0645\u0647\u0654 \u0648\u06CC\u0632\u06CC\u062A \u0628\u0627\u0632",
    'record.actions.chat': "\u06AF\u0641\u062A\u06AF\u0648 \u0628\u0627 \u062F\u0633\u062A\u06CC\u0627\u0631",
    'record.actions.edit': "\u0648\u06CC\u0631\u0627\u06CC\u0634 \u0628\u06CC\u0645\u0627\u0631",
    'record.actions.archive': "\u0628\u0627\u06CC\u06AF\u0627\u0646\u06CC",
    'record.actions.unarchive': "\u062E\u0631\u0648\u062C \u0627\u0632 \u0628\u0627\u06CC\u06AF\u0627\u0646\u06CC",
    'record.actions.delete': "\u062D\u0630\u0641",
    'record.saved': "\u0630\u062E\u06CC\u0631\u0647 \u0634\u062F.",
    'record.startVisit.title': "\u0634\u0631\u0648\u0639 \u0648\u06CC\u0632\u06CC\u062A",
    'record.startVisit.reason': "\u0639\u0644\u062A \u0645\u0631\u0627\u062C\u0639\u0647",
    'record.startVisit.reasonHelper': "\u0627\u0632 \u0634\u06A9\u0627\u06CC\u062A \u0627\u0635\u0644\u06CC \u067E\u0631 \u0634\u062F\u0647 \u0627\u0633\u062A\u061B \u0627\u06AF\u0631 \u0627\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A \u062F\u0631\u0628\u0627\u0631\u0647\u0654 \u0686\u06CC\u0632 \u062F\u06CC\u06AF\u0631\u06CC \u0627\u0633\u062A \u062A\u063A\u06CC\u06CC\u0631\u0634 \u062F\u0647\u06CC\u062F.",
    'record.startVisit.submit': "\u0634\u0631\u0648\u0639 \u0648\u06CC\u0632\u06CC\u062A",
    'record.startVisit.alreadyOpen': "\u0648\u06CC\u0632\u06CC\u062A \u0628\u0627\u0632\u06CC \u0648\u062C\u0648\u062F \u062F\u0627\u0634\u062A \u2014 \u0647\u0645\u0627\u0646 \u0627\u062F\u0627\u0645\u0647 \u0645\u06CC\u200C\u06CC\u0627\u0628\u062F.",
    'record.overview.details': "\u0645\u0634\u062E\u0635\u0627\u062A",
    'record.overview.allergies': "\u0647\u0634\u062F\u0627\u0631 \u062D\u0633\u0627\u0633\u06CC\u062A",
    'record.overview.problems': "\u0645\u0634\u06A9\u0644\u0627\u062A \u0641\u0639\u0627\u0644",
    'record.overview.meds': "\u062F\u0627\u0631\u0648\u0647\u0627\u06CC \u0641\u0639\u0644\u06CC",
    'record.overview.pendingOrders': "\u062F\u0633\u062A\u0648\u0631\u0647\u0627\u06CC \u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631",
    'record.overview.lastVisit': "\u0622\u062E\u0631\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A",
    'record.overview.recentChats': "\u06AF\u0641\u062A\u06AF\u0648\u0647\u0627\u06CC \u0627\u062E\u06CC\u0631",
    'record.overview.noProblems': "\u0645\u0634\u06A9\u0644 \u0641\u0639\u0627\u0644\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'record.overview.noMeds': "\u062F\u0627\u0631\u0648\u06CC \u0641\u0639\u0644\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'record.overview.noOrders': "\u062F\u0633\u062A\u0648\u0631\u06CC \u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631 \u0646\u06CC\u0633\u062A.",
    'record.overview.noVisits': "\u0647\u0646\u0648\u0632 \u0648\u06CC\u0632\u06CC\u062A\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'record.overview.noChats': "\u0647\u0646\u0648\u0632 \u06AF\u0641\u062A\u06AF\u0648\u06CC\u06CC \u0627\u0646\u062C\u0627\u0645 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'record.overview.openVisit': "\u0628\u0627\u0632 \u06A9\u0631\u062F\u0646 \u0648\u06CC\u0632\u06CC\u062A",
    'record.overview.fromHistory': "\u0627\u0632 \u0634\u0631\u062D \u062D\u0627\u0644",
    'record.overview.fromVisit': "\u0648\u06CC\u0632\u06CC\u062A {{n}}",
    'record.visits.empty.title': "\u0647\u0646\u0648\u0632 \u0648\u06CC\u0632\u06CC\u062A\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647",
    'record.visits.empty.body': "\u0648\u06CC\u0632\u06CC\u062A\u06CC \u0634\u0631\u0648\u0639 \u06A9\u0646\u06CC\u062F \u062A\u0627 \u06CC\u0627\u062F\u062F\u0627\u0634\u062A SOAP\u060C \u062A\u0634\u062E\u06CC\u0635\u200C\u0647\u0627\u060C \u0646\u0633\u062E\u0647 \u0648 \u062F\u0633\u062A\u0648\u0631\u0627\u062A \u0631\u0627 \u0645\u0633\u062A\u0646\u062F \u06A9\u0646\u06CC\u062F.",
    'record.visits.columns.visit': "\u0648\u06CC\u0632\u06CC\u062A",
    'record.visits.columns.date': "\u062A\u0627\u0631\u06CC\u062E",
    'record.visits.columns.reason': "\u0639\u0644\u062A \u0645\u0631\u0627\u062C\u0639\u0647",
    'record.visits.columns.status': "\u0648\u0636\u0639\u06CC\u062A",
    'record.visits.columns.counts': "\u062A\u0634\u062E\u06CC\u0635 \xb7 \u062F\u0627\u0631\u0648 \xb7 \u062F\u0633\u062A\u0648\u0631",
    'record.visits.columns.summary': "\u062E\u0644\u0627\u0635\u0647",
    'record.visits.openLabel': "\u0628\u0627\u0632 \u06A9\u0631\u062F\u0646 \u0648\u06CC\u0632\u06CC\u062A {{n}}",
    'record.timeline.empty.title': "\u0647\u0646\u0648\u0632 \u0631\u0648\u06CC\u062F\u0627\u062F\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647",
    'record.timeline.empty.body': "\u0648\u06CC\u0632\u06CC\u062A\u200C\u0647\u0627\u060C \u06CC\u0627\u0641\u062A\u0647\u200C\u0647\u0627\u060C \u062A\u0634\u062E\u06CC\u0635\u200C\u0647\u0627 \u0648 \u062F\u0633\u062A\u0648\u0631\u0627\u062A \u0628\u0647 \u062A\u0631\u062A\u06CC\u0628 \u0632\u0645\u0627\u0646 \u0627\u06CC\u0646\u062C\u0627 \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F.",
    'record.timeline.outside': "\u062E\u0627\u0631\u062C \u0627\u0632 \u0648\u06CC\u0632\u06CC\u062A",
    'record.timeline.filter': "\u0641\u06CC\u0644\u062A\u0631 \u0628\u0631 \u0627\u0633\u0627\u0633 \u0646\u0648\u0639",
    'record.history.hint': "\u0647\u0641\u062A \u0628\u062E\u0634 \u0631\u0627 \u0628\u0646\u0648\u06CC\u0633\u06CC\u062F \u2014 \u0647\u0645\u06CC\u0646 \u0627\u0633\u062A \u06A9\u0647 \u062F\u0633\u062A\u06CC\u0627\u0631 \u0645\u06CC\u200C\u062E\u0648\u0627\u0646\u062F.",
    'record.history.dictate': "\u062F\u06CC\u06A9\u062A\u0647",
    'record.history.visitChip': "\u0648\u06CC\u0632\u06CC\u062A {{n}}",
    // ── timeline event types (BFF-derived) ───────────────────────────────
    'timeline.type.encounter_start': "\u0634\u0631\u0648\u0639 \u0648\u06CC\u0632\u06CC\u062A",
    'timeline.type.encounter_end': "\u067E\u0627\u06CC\u0627\u0646 \u0648\u06CC\u0632\u06CC\u062A",
    'timeline.type.entry': "\u0628\u062E\u0634 \u0634\u0631\u062D \u062D\u0627\u0644",
    'timeline.type.diagnosis': "\u062A\u0634\u062E\u06CC\u0635",
    'timeline.type.rx': "\u0646\u0633\u062E\u0647",
    'timeline.type.order': "\u062F\u0633\u062A\u0648\u0631",
    'timeline.type.order_result': "\u0646\u062A\u06CC\u062C\u0647",
    'timeline.type.thread': "\u06AF\u0641\u062A\u06AF\u0648",
    // ── شرح حال — the seven sections ─────────────────────────────────────
    'history.sections.chiefComplaint': "\u0634\u06A9\u0627\u06CC\u062A \u0627\u0635\u0644\u06CC",
    'history.sections.hpi': "\u0634\u0631\u062D \u062D\u0627\u0644 \u0628\u06CC\u0645\u0627\u0631\u06CC \u0641\u0639\u0644\u06CC",
    'history.sections.pmh': "\u0633\u0627\u0628\u0642\u0647\u0654 \u0628\u06CC\u0645\u0627\u0631\u06CC\u200C\u0647\u0627\u06CC \u0642\u0628\u0644\u06CC",
    'history.sections.medications': "\u062F\u0627\u0631\u0648\u0647\u0627\u06CC \u0645\u0635\u0631\u0641\u06CC",
    'history.sections.allergies': "\u062D\u0633\u0627\u0633\u06CC\u062A\u200C\u0647\u0627",
    'history.sections.vitals': "\u0639\u0644\u0627\u0626\u0645 \u062D\u06CC\u0627\u062A\u06CC",
    'history.sections.labs': "\u0622\u0632\u0645\u0627\u06CC\u0634\u200C\u0647\u0627",
    'history.empty.title': "\u0647\u0646\u0648\u0632 \u0686\u06CC\u0632\u06CC \u0627\u06CC\u0646\u062C\u0627 \u0646\u0648\u0634\u062A\u0647 \u0646\u0634\u062F\u0647",
    'history.empty.body': "\u0627\u06CC\u0646 \u0628\u062E\u0634 \u0631\u0627 \u0628\u0646\u0648\u06CC\u0633\u06CC\u062F\u061B \u0647\u0645\u06CC\u0646 \u0627\u0633\u062A \u06A9\u0647 \u062F\u0633\u062A\u06CC\u0627\u0631 \u0645\u06CC\u200C\u062E\u0648\u0627\u0646\u062F.",
    'history.add': "\u0627\u0641\u0632\u0648\u062F\u0646",
    'history.entry.label': "\u0639\u0646\u0648\u0627\u0646",
    'history.entry.labelPlaceholder': "\u0622\u0632\u0645\u0627\u06CC\u0634 \u062E\u0648\u0646 \u06F1\u06F4\u06F0\u06F5/\u06F0\u06F5/\u06F1\u06F2",
    'history.entry.body': "\u0622\u0646\u0686\u0647 \u0645\u06CC\u200C\u062E\u0648\u0627\u0647\u06CC\u062F \u062B\u0628\u062A \u06A9\u0646\u06CC\u062F",
    'history.entry.bodyPlaceholder': "\u0647\u0645\u0627\u0646\u200C\u0637\u0648\u0631 \u0628\u0646\u0648\u06CC\u0633\u06CC\u062F \u06A9\u0647 \u0634\u0641\u0627\u0647\u06CC \u0645\u06CC\u200C\u06AF\u0648\u06CC\u06CC\u062F.",
    'history.entry.recordedAt': "\u0632\u0645\u0627\u0646 \u0648\u0642\u0648\u0639 \u062F\u0631 \u062F\u0627\u0633\u062A\u0627\u0646 \u0628\u06CC\u0645\u0627\u0631",
    'history.entry.recordedAtHelper': "\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC \u0627\u0633\u062A \u0648 \u0645\u0639\u0645\u0648\u0644\u0627\u064B \u062E\u0627\u0644\u06CC \u0645\u06CC\u200C\u0645\u0627\u0646\u062F.",
    'history.entry.sourceLabel': "\u062B\u0628\u062A\u200C\u0634\u062F\u0647 \u062A\u0648\u0633\u0637",
    'history.entry.source.manual': "\u062E\u0648\u062F\u062A\u0627\u0646",
    'history.entry.source.voice': "\u062E\u0648\u062F\u062A\u0627\u0646\u060C \u0627\u0632 \u067E\u06CC\u0634\u200C\u0646\u0648\u06CC\u0633 \u0635\u0648\u062A\u06CC",
    'history.entry.source.ai': "\u062E\u0648\u062F\u062A\u0627\u0646\u060C \u0627\u0632 \u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u0647\u0648\u0634 \u0645\u0635\u0646\u0648\u0639\u06CC",
    'history.entry.needsContent': "\u0686\u06CC\u0632\u06CC \u0628\u0646\u0648\u06CC\u0633\u06CC\u062F \u06CC\u0627 \u062F\u0633\u062A\u200C\u06A9\u0645 \u06CC\u06A9 \u0631\u062F\u06CC\u0641 \u0631\u0627 \u067E\u0631 \u06A9\u0646\u06CC\u062F.",
    'history.delete.title': "\u0627\u06CC\u0646 \u0628\u062E\u0634 \u062D\u0630\u0641 \u0634\u0648\u062F\u061F",
    'history.delete.body': "\u0641\u0642\u0637 \u0647\u0645\u06CC\u0646 \u0628\u062E\u0634 \u062D\u0630\u0641 \u0645\u06CC\u200C\u0634\u0648\u062F\u061B \u0628\u0627\u0642\u06CC \u067E\u0631\u0648\u0646\u062F\u0647 \u0628\u0627\u0642\u06CC \u0645\u06CC\u200C\u0645\u0627\u0646\u062F.",
    'history.saved': "\u0634\u0631\u062D \u062D\u0627\u0644 \u0630\u062E\u06CC\u0631\u0647 \u0634\u062F.",
    'history.deleted': "\u0628\u062E\u0634 \u062D\u0630\u0641 \u0634\u062F.",
    'history.structured.title': "\u0645\u0642\u0627\u062F\u06CC\u0631 \u0633\u0627\u062E\u062A\u0627\u0631\u06CC\u0627\u0641\u062A\u0647",
    'history.structured.helper': "\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC \u0627\u0633\u062A. \u0645\u062A\u0646\u06CC \u06A9\u0647 \u0628\u0627\u0644\u0627 \u0646\u0648\u0634\u062A\u0647\u200C\u0627\u06CC\u062F \u062D\u0627\u0645\u0644 \u0627\u0635\u0644\u06CC \u067E\u0631\u0648\u0646\u062F\u0647 \u0627\u0633\u062A.",
    'history.vitals.bp': "\u0641\u0634\u0627\u0631 \u062E\u0648\u0646",
    'history.vitals.hr': "\u0636\u0631\u0628\u0627\u0646 \u0642\u0644\u0628",
    'history.vitals.rr': "\u062A\u0639\u062F\u0627\u062F \u062A\u0646\u0641\u0633",
    'history.vitals.temp': "\u062F\u0645\u0627",
    'history.vitals.spo2': "\u0627\u0634\u0628\u0627\u0639 \u0627\u06A9\u0633\u06CC\u0698\u0646",
    'history.units.bpm': "\u062F\u0631 \u062F\u0642\u06CC\u0642\u0647",
    'history.units.perMin': "\u062F\u0631 \u062F\u0642\u06CC\u0642\u0647",
    'history.units.celsius': "\u062F\u0631\u062C\u0647",
    'history.units.percent': "\u062F\u0631\u0635\u062F",
    'history.labs.name': "\u0622\u0632\u0645\u0627\u06CC\u0634",
    'history.labs.value': "\u0645\u0642\u062F\u0627\u0631",
    'history.labs.unit': "\u0648\u0627\u062D\u062F",
    'history.labs.ref': "\u0645\u062D\u062F\u0648\u062F\u0647\u0654 \u0645\u0631\u062C\u0639",
    'history.labs.addRow': "\u0627\u0641\u0632\u0648\u062F\u0646 \u0631\u062F\u06CC\u0641",
    'history.labs.removeRow': "\u062D\u0630\u0641 \u0627\u06CC\u0646 \u0631\u062F\u06CC\u0641"
};
var $6fdd3abd7668d8a6$export$2e2bcd8739ae039 = $6fdd3abd7668d8a6$export$e5185e241753e543;


// OWNED BY THE CHAT AUTHOR. Nothing outside this namespace belongs here, and
// nothing here belongs in another file: this module exists so that the CHAT
// work and the rest of the app can be written at the same time without two
// people editing one map.
const $157cbafbf6f9e3de$export$530dccc8e24f4e99 = {
    // ── the chat page — core.md §9 ───────────────────────────────────────
    'chat.title': "\u062F\u0633\u062A\u06CC\u0627\u0631 \u0622\u0645\u0648\u0632\u0634\u06CC",
    'chat.landing.title': "\u062F\u0631\u0628\u0627\u0631\u0647\u0654 \u06A9\u062F\u0627\u0645 \u0628\u06CC\u0645\u0627\u0631 \u0645\u06CC\u200C\u062E\u0648\u0627\u0647\u06CC\u062F \u06AF\u0641\u062A\u06AF\u0648 \u06A9\u0646\u06CC\u062F\u061F",
    'chat.landing.body': "\u062F\u0633\u062A\u06CC\u0627\u0631 \u06A9\u0644 \u067E\u0631\u0648\u0646\u062F\u0647\u0654 \u0622\u0646 \u0628\u06CC\u0645\u0627\u0631 \u0631\u0627 \u0645\u06CC\u200C\u0634\u0646\u0627\u0633\u062F \u2014 \u0634\u0631\u062D \u062D\u0627\u0644\u060C \u0648\u06CC\u0632\u06CC\u062A\u200C\u0647\u0627\u060C \u062A\u0634\u062E\u06CC\u0635\u200C\u0647\u0627 \u0648 \u062F\u0633\u062A\u0648\u0631\u0627\u062A.",
    'chat.landing.new': "\u0628\u06CC\u0645\u0627\u0631 \u062C\u062F\u06CC\u062F",
    'chat.landing.open': "\u06AF\u0641\u062A\u06AF\u0648 \u062F\u0631\u0628\u0627\u0631\u0647\u0654 {{name}}",
    'chat.sidebar.title': "\u06AF\u0641\u062A\u06AF\u0648\u0647\u0627",
    'chat.sidebar.new': "\u06AF\u0641\u062A\u06AF\u0648\u06CC \u062C\u062F\u06CC\u062F",
    'chat.sidebar.today': "\u0627\u0645\u0631\u0648\u0632",
    'chat.sidebar.yesterday': "\u062F\u06CC\u0631\u0648\u0632",
    'chat.sidebar.last7': "\u06F7 \u0631\u0648\u0632 \u06AF\u0630\u0634\u062A\u0647",
    'chat.sidebar.older': "\u0642\u062F\u06CC\u0645\u06CC\u200C\u062A\u0631",
    'chat.sidebar.empty': "\u0647\u0646\u0648\u0632 \u06AF\u0641\u062A\u06AF\u0648\u06CC\u06CC \u0646\u06CC\u0633\u062A.",
    'chat.sidebar.otherPatient': "\u0628\u06CC\u0645\u0627\u0631 \u062F\u06CC\u06AF\u0631",
    'chat.sidebar.inVisit': "\u06AF\u0641\u062A\u06AF\u0648\u0647\u0627\u06CC \u062F\u0627\u062E\u0644 \u0648\u06CC\u0632\u06CC\u062A",
    'chat.sidebar.collapse': "\u067E\u0646\u0647\u0627\u0646 \u06A9\u0631\u062F\u0646 \u06AF\u0641\u062A\u06AF\u0648\u0647\u0627",
    'chat.sidebar.expand': "\u0646\u0645\u0627\u06CC\u0634 \u06AF\u0641\u062A\u06AF\u0648\u0647\u0627",
    'chat.sidebar.menu': "\u0639\u0645\u0644\u06CC\u0627\u062A \u06AF\u0641\u062A\u06AF\u0648",
    'chat.sidebar.justNow': "\u0647\u0645\u06CC\u0646 \u062D\u0627\u0644\u0627",
    'chat.sidebar.minutesAgo': "{{count}} \u062F\u0642\u06CC\u0642\u0647 \u067E\u06CC\u0634",
    'chat.sidebar.hoursAgo': "{{count}} \u0633\u0627\u0639\u062A \u067E\u06CC\u0634",
    'chat.thread.untitled': "\u06AF\u0641\u062A\u06AF\u0648\u06CC \u062C\u062F\u06CC\u062F",
    'chat.thread.renameTitle': "\u062A\u063A\u06CC\u06CC\u0631 \u0646\u0627\u0645 \u06AF\u0641\u062A\u06AF\u0648",
    'chat.thread.renamePlaceholder': "\u0639\u0646\u0648\u0627\u0646 \u06AF\u0641\u062A\u06AF\u0648",
    'chat.thread.renameHelper': "\u062E\u0627\u0644\u06CC \u0628\u06AF\u0630\u0627\u0631\u06CC\u062F \u062A\u0627 \u0639\u0646\u0648\u0627\u0646 \u062E\u0648\u062F\u06A9\u0627\u0631 \u0628\u0631\u06AF\u0631\u062F\u062F.",
    'chat.thread.renamed': "\u0646\u0627\u0645 \u062A\u063A\u06CC\u06CC\u0631 \u06A9\u0631\u062F.",
    'chat.thread.deleteTitle': "\u0627\u06CC\u0646 \u06AF\u0641\u062A\u06AF\u0648 \u062D\u0630\u0641 \u0634\u0648\u062F\u061F",
    'chat.thread.deleteBody': "\u067E\u0631\u0633\u0634\u200C\u0647\u0627 \u0648 \u067E\u0627\u0633\u062E\u200C\u0647\u0627 \u062D\u0630\u0641 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F\u061B \u0628\u06CC\u0645\u0627\u0631 \u0628\u0627\u0642\u06CC \u0645\u06CC\u200C\u0645\u0627\u0646\u062F.",
    'chat.thread.deleted': "\u06AF\u0641\u062A\u06AF\u0648 \u062D\u0630\u0641 \u0634\u062F.",
    'chat.thread.notFound': "\u06AF\u0641\u062A\u06AF\u0648 \u067E\u06CC\u062F\u0627 \u0646\u0634\u062F \u2014 \u06AF\u0641\u062A\u06AF\u0648\u06CC \u062A\u0627\u0632\u0647\u200C\u0627\u06CC \u0622\u063A\u0627\u0632 \u0645\u06CC\u200C\u0634\u0648\u062F.",
    'chat.thread.notFoundToast': "\u06AF\u0641\u062A\u06AF\u0648 \u067E\u06CC\u062F\u0627 \u0646\u0634\u062F",
    'chat.thread.movedToast': "\u067E\u0627\u0633\u062E \u062F\u0631 \u06AF\u0641\u062A\u06AF\u0648\u06CC \u0642\u0628\u0644\u06CC \u062B\u0628\u062A \u0634\u062F.",
    'chat.header.back': "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u067E\u0631\u0648\u0646\u062F\u0647",
    'chat.header.patient': "\u0628\u06CC\u0645\u0627\u0631",
    'chat.empty.title': "\u062F\u0631\u0628\u0627\u0631\u0647\u0654 {{name}} \u0628\u067E\u0631\u0633\u06CC\u062F",
    'chat.empty.body': "\u0647\u0631 \u067E\u0627\u0633\u062E \u062F\u0631 \u0647\u0645\u06CC\u0646 \u06AF\u0641\u062A\u06AF\u0648 \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u067E\u0627\u0631\u0633\u0647 \u062E\u0631\u062C \u0645\u06CC\u200C\u06A9\u0646\u062F \u2014 \u0647\u0632\u06CC\u0646\u0647 \u0631\u0648\u06CC \u062F\u06A9\u0645\u0647 \u0646\u0648\u0634\u062A\u0647 \u0634\u062F\u0647 \u0627\u0633\u062A.",
    'chat.prompts.summary': "\u0627\u06CC\u0646 \u067E\u0631\u0648\u0646\u062F\u0647 \u0631\u0627 \u062E\u0644\u0627\u0635\u0647 \u06A9\u0646",
    'chat.prompts.differential': "\u062A\u0634\u062E\u06CC\u0635\u200C\u0647\u0627\u06CC \u0627\u0641\u062A\u0631\u0627\u0642\u06CC \u0631\u0627 \u0628\u0627 \u0627\u0633\u062A\u062F\u0644\u0627\u0644 \u0628\u06AF\u0648",
    'chat.prompts.keyFinding': "\u06A9\u062F\u0627\u0645 \u06CC\u0627\u0641\u062A\u0647 \u0645\u0647\u0645\u200C\u062A\u0631 \u0627\u0633\u062A \u0648 \u0686\u0631\u0627\u061F",
    'chat.prompts.nextVisit': "\u0628\u0631\u0627\u06CC \u0648\u06CC\u0632\u06CC\u062A \u0628\u0639\u062F\u06CC \u0686\u0647 \u0628\u067E\u0631\u0633\u0645\u061F",
    'chat.prompts.summaryOf': "{{name}} \u0631\u0627 \u062E\u0644\u0627\u0635\u0647 \u06A9\u0646",
    'chat.prompts.differentialFor': "\u062A\u0634\u062E\u06CC\u0635\u200C\u0647\u0627\u06CC \u0627\u0641\u062A\u0631\u0627\u0642\u06CC \xab{{complaint}}\xbb \u0631\u0627 \u0628\u0627 \u0627\u0633\u062A\u062F\u0644\u0627\u0644 \u0628\u06AF\u0648",
    'chat.prompts.keyFindingFor': "\u062F\u0631 \xab{{complaint}}\xbb \u06A9\u062F\u0627\u0645 \u06CC\u0627\u0641\u062A\u0647 \u0645\u0647\u0645\u200C\u062A\u0631 \u0627\u0633\u062A \u0648 \u0686\u0631\u0627\u061F",
    'chat.composer.placeholder': "\u062F\u0631\u0628\u0627\u0631\u0647\u0654 \u0627\u06CC\u0646 \u0628\u06CC\u0645\u0627\u0631 \u0628\u067E\u0631\u0633\u06CC\u062F\u2026",
    'chat.composer.send': "\u0627\u0631\u0633\u0627\u0644",
    'chat.composer.stop': "\u062A\u0648\u0642\u0641",
    'chat.composer.thinking': "\u062F\u0631 \u062D\u0627\u0644 \u0641\u06A9\u0631 \u06A9\u0631\u062F\u0646\u2026",
    'chat.composer.counter': '{{count}} / {{max}}',
    'chat.composer.offline': "\u0622\u0641\u0644\u0627\u06CC\u0646",
    'chat.composer.reserved': "\u067E\u0631\u0633\u0634 \u0646\u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u062F \u0628\u0627 \u062F\u0648 \u0632\u06CC\u0631\u062E\u0637 \u0634\u0631\u0648\u0639 \u0634\u0648\u062F.",
    'chat.composer.tooLong': "\u067E\u0631\u0633\u0634 \u062D\u062F\u0627\u06A9\u062B\u0631 \u06F4\u06F0\u06F0\u06F0 \u0646\u0648\u06CC\u0633\u0647 \u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u062F \u0628\u0627\u0634\u062F.",
    'chat.composer.noCredits': "\u067E\u0627\u0631\u0633\u0647\u0654 \u06A9\u0627\u0641\u06CC \u0646\u062F\u0627\u0631\u06CC\u062F",
    'chat.message.you': "\u0634\u0645\u0627",
    'chat.message.assistant': "\u062F\u0633\u062A\u06CC\u0627\u0631",
    'chat.message.sending': "\u062F\u0631 \u062D\u0627\u0644 \u0627\u0631\u0633\u0627\u0644",
    'chat.message.sent': "\u0627\u0631\u0633\u0627\u0644 \u0634\u062F",
    'chat.message.failed': "\u0627\u0631\u0633\u0627\u0644 \u0646\u0634\u062F",
    'chat.message.retry': "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
    'chat.message.copy': "\u06A9\u067E\u06CC",
    'chat.message.copied': "\u06A9\u067E\u06CC \u0634\u062F",
    'chat.message.regenerate': "\u0628\u0627\u0632\u062A\u0648\u0644\u06CC\u062F",
    'chat.message.thumbsUp': "\u0645\u0641\u06CC\u062F \u0628\u0648\u062F",
    'chat.message.thumbsDown': "\u0645\u0641\u06CC\u062F \u0646\u0628\u0648\u062F",
    'chat.message.older': "\u067E\u06CC\u0627\u0645\u200C\u0647\u0627\u06CC \u0642\u062F\u06CC\u0645\u06CC\u200C\u062A\u0631",
    'chat.message.loadingOlder': "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC\u2026",
    'chat.message.typing': "\u062F\u0633\u062A\u06CC\u0627\u0631 \u062F\u0631 \u062D\u0627\u0644 \u0641\u06A9\u0631 \u06A9\u0631\u062F\u0646 \u0627\u0633\u062A",
    'chat.followUps': "\u067E\u0631\u0633\u0634 \u0628\u0639\u062F\u06CC",
    'chat.references': "\u0645\u0646\u0627\u0628\u0639 \u0630\u06A9\u0631\u0634\u062F\u0647",
    'chat.confidenceLabel': "\u0627\u0637\u0645\u06CC\u0646\u0627\u0646",
    'chat.confidence.low': "\u06A9\u0645",
    'chat.confidence.medium': "\u0645\u062A\u0648\u0633\u0637",
    'chat.confidence.high': "\u0632\u06CC\u0627\u062F",
    'chat.kind.chat': "\u067E\u0631\u0633\u0634",
    'chat.kind.differential': "\u062A\u0634\u062E\u06CC\u0635 \u0627\u0641\u062A\u0631\u0627\u0642\u06CC",
    'chat.kind.interaction': "\u0628\u0631\u0631\u0633\u06CC \u062A\u062F\u0627\u062E\u0644",
    'chat.kind.soap_suggest': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F SOAP",
    'chat.kind.order_suggest': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u062F\u0633\u062A\u0648\u0631\u0627\u062A",
    'chat.error.title': "\u0627\u06CC\u0646 \u06AF\u0641\u062A\u06AF\u0648 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F",
    'chat.noCredits.title': "\u067E\u0627\u0631\u0633\u0647 \u06A9\u0627\u0641\u06CC \u0646\u06CC\u0633\u062A",
    'chat.noCredits.body': "\u067E\u0631\u0633\u0634 \u0634\u0645\u0627 \u0628\u0647 \u062C\u0639\u0628\u0647\u0654 \u0646\u0648\u0634\u062A\u0646 \u0628\u0631\u06AF\u0634\u062A. \u0634\u0627\u0631\u0698 \u06A9\u0646\u06CC\u062F \u0648 \u062F\u0648\u0628\u0627\u0631\u0647 \u0628\u0641\u0631\u0633\u062A\u06CC\u062F.",
    'chat.noCredits.action': "\u0634\u0627\u0631\u0698"
};
var $157cbafbf6f9e3de$export$2e2bcd8739ae039 = $157cbafbf6f9e3de$export$530dccc8e24f4e99;


// OWNED BY THE VISIT AUTHOR. Nothing outside this namespace belongs here, and
// nothing here belongs in another file: this module exists so that the VISIT
// work and the rest of the app can be written at the same time without two
// people editing one map.
const $36fe6517f24200bd$export$bf638b60ea8b89b7 = {
    // ── visits ───────────────────────────────────────────────────────────
    'visit.number': "\u0648\u06CC\u0632\u06CC\u062A {{n}}",
    'visit.status.open': "\u0628\u0627\u0632",
    'visit.status.closed': "\u0628\u0633\u062A\u0647",
    'visit.placeholder.title': "\u0641\u0636\u0627\u06CC \u0648\u06CC\u0632\u06CC\u062A \u062F\u0631 \u062D\u0627\u0644 \u0633\u0627\u062E\u062A \u0627\u0633\u062A",
    'visit.placeholder.body': "\u06CC\u0627\u062F\u062F\u0627\u0634\u062A SOAP\u060C \u062A\u0634\u062E\u06CC\u0635\u200C\u0647\u0627\u060C \u0646\u0633\u062E\u0647 \u0648 \u062F\u0633\u062A\u0648\u0631\u0627\u062A \u0628\u0647\u200C\u0632\u0648\u062F\u06CC \u0627\u06CC\u0646\u062C\u0627 \u0642\u0631\u0627\u0631 \u0645\u06CC\u200C\u06AF\u06CC\u0631\u0646\u062F.",
    'visit.placeholder.back': "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u067E\u0631\u0648\u0646\u062F\u0647",
    // ── clinical vocabulary — core.md §5.3 ───────────────────────────────
    'clinical.dx.kind.primary': "\u0627\u0635\u0644\u06CC",
    'clinical.dx.kind.secondary': "\u062B\u0627\u0646\u0648\u06CC\u0647",
    'clinical.dx.kind.differential': "\u0627\u0641\u062A\u0631\u0627\u0642\u06CC",
    'clinical.dx.status.active': "\u0641\u0639\u0627\u0644",
    'clinical.dx.status.resolved': "\u0628\u0631\u0637\u0631\u0641\u200C\u0634\u062F\u0647",
    'clinical.dx.status.ruled_out': "\u0631\u062F \u0634\u062F\u0647",
    'clinical.rx.route.oral': "\u062E\u0648\u0631\u0627\u06A9\u06CC",
    'clinical.rx.route.im': "\u0639\u0636\u0644\u0627\u0646\u06CC",
    'clinical.rx.route.iv': "\u0648\u0631\u06CC\u062F\u06CC",
    'clinical.rx.route.sc': "\u0632\u06CC\u0631\u062C\u0644\u062F\u06CC",
    'clinical.rx.route.topical': "\u0645\u0648\u0636\u0639\u06CC",
    'clinical.rx.route.inhaled': "\u0627\u0633\u062A\u0646\u0634\u0627\u0642\u06CC",
    'clinical.rx.route.rectal': "\u0631\u06A9\u062A\u0627\u0644",
    'clinical.rx.route.ophthalmic': "\u0686\u0634\u0645\u06CC",
    'clinical.rx.route.otic': "\u06AF\u0648\u0634\u06CC",
    'clinical.rx.route.nasal': "\u0628\u06CC\u0646\u06CC",
    'clinical.rx.route.sublingual': "\u0632\u06CC\u0631\u0632\u0628\u0627\u0646\u06CC",
    'clinical.rx.route.other': "\u0633\u0627\u06CC\u0631",
    'clinical.order.type.lab': "\u0622\u0632\u0645\u0627\u06CC\u0634",
    'clinical.order.type.imaging': "\u062A\u0635\u0648\u06CC\u0631\u0628\u0631\u062F\u0627\u0631\u06CC",
    'clinical.order.type.procedure': "\u067E\u0631\u0648\u0633\u06CC\u062C\u0631",
    'clinical.order.type.referral': "\u0627\u0631\u062C\u0627\u0639",
    'clinical.order.type.other': "\u0633\u0627\u06CC\u0631",
    'clinical.order.urgency.routine': "\u0639\u0627\u062F\u06CC",
    'clinical.order.urgency.urgent': "\u0641\u0648\u0631\u06CC",
    'clinical.order.urgency.stat': "\u0622\u0646\u06CC",
    'clinical.order.status.ordered': "\u062B\u0628\u062A\u200C\u0634\u062F\u0647",
    'clinical.order.status.resulted': "\u0646\u062A\u06CC\u062C\u0647 \u062B\u0628\u062A \u0634\u062F",
    'clinical.order.status.cancelled': "\u0644\u063A\u0648 \u0634\u062F",
    'clinical.origin.manual': "\u062B\u0628\u062A\u200C\u0634\u062F\u0647 \u062A\u0648\u0633\u0637 \u0634\u0645\u0627",
    'clinical.origin.ai': "\u0627\u0632 \u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u062F\u0633\u062A\u06CC\u0627\u0631",
    'clinical.differential.likelihood.high': "\u0645\u062D\u062A\u0645\u0644",
    'clinical.differential.likelihood.medium': "\u0645\u0645\u06A9\u0646",
    'clinical.differential.likelihood.low': "\u06A9\u0645\u200C\u0627\u062D\u062A\u0645\u0627\u0644",
    'clinical.interaction.severity.severe': "\u0634\u062F\u06CC\u062F",
    'clinical.interaction.severity.moderate': "\u0645\u062A\u0648\u0633\u0637",
    'clinical.interaction.severity.mild': "\u062E\u0641\u06CC\u0641",
    'clinical.interaction.type.interaction': "\u062A\u062F\u0627\u062E\u0644 \u062F\u0627\u0631\u0648\u06CC\u06CC",
    'clinical.interaction.type.contraindication': "\u0645\u0646\u0639 \u0645\u0635\u0631\u0641",
    'clinical.interaction.type.allergy': "\u062D\u0633\u0627\u0633\u06CC\u062A",
    'clinical.interaction.type.black_box': "\u0647\u0634\u062F\u0627\u0631 \u062C\u0639\u0628\u0647\u200C\u0633\u06CC\u0627\u0647",
    'clinical.interaction.source.rule_engine_static': "\u062C\u062F\u0648\u0644 \u0642\u0648\u0627\u0639\u062F",
    'clinical.interaction.source.rule_engine_rxnorm': "\u0642\u0648\u0627\u0639\u062F RxNorm",
    'clinical.interaction.source.rule_engine_contraindication': "\u0642\u0648\u0627\u0639\u062F \u0645\u0646\u0639 \u0645\u0635\u0631\u0641",
    'clinical.interaction.source.rule_engine_allergy': "\u0642\u0648\u0627\u0639\u062F \u062D\u0633\u0627\u0633\u06CC\u062A",
    'clinical.interaction.source.rule_engine_openfda': 'openFDA',
    'clinical.interaction.source.llm': "\u0645\u062F\u0644 \u0632\u0628\u0627\u0646\u06CC",
    // ── the assistant (shared pieces: cost chip, voice) ──────────────────
    'assistant.cost': "{{parseh}} \u067E\u0627\u0631\u0633\u0647",
    'assistant.costBefore': "\u0647\u0632\u06CC\u0646\u0647: {{parseh}} \u067E\u0627\u0631\u0633\u0647",
    'assistant.costFree': "\u0631\u0627\u06CC\u06AF\u0627\u0646",
    'assistant.balance': "{{parseh}} \u067E\u0627\u0631\u0633\u0647 \u062F\u0627\u0631\u06CC\u062F",
    'assistant.noCredits.title': "\u067E\u0627\u0631\u0633\u0647\u0654 \u06A9\u0627\u0641\u06CC \u0646\u062F\u0627\u0631\u06CC\u062F",
    'assistant.noCredits.body': "\u0634\u0627\u0631\u0698 \u06A9\u0646\u06CC\u062F \u06CC\u0627 \u062A\u0627 \u0627\u0639\u062A\u0628\u0627\u0631 \u0631\u0627\u06CC\u06AF\u0627\u0646 \u0645\u0627\u0647 \u0628\u0639\u062F \u0635\u0628\u0631 \u06A9\u0646\u06CC\u062F. \u0622\u0646\u0686\u0647 \u0646\u0648\u0634\u062A\u0647\u200C\u0627\u06CC\u062F \u0627\u0632 \u0628\u06CC\u0646 \u0646\u0631\u0641\u062A\u0647 \u0627\u0633\u062A.",
    'assistant.noCredits.action': "\u0634\u0627\u0631\u0698 \u067E\u0627\u0631\u0633\u0647",
    'assistant.voice.title': "\u0634\u0631\u062D \u062D\u0627\u0644 \u0631\u0627 \u062F\u06CC\u06A9\u062A\u0647 \u06A9\u0646\u06CC\u062F",
    'assistant.voice.body': "\u0628\u06CC\u0645\u0627\u0631 \u0631\u0627 \u0634\u0641\u0627\u0647\u06CC \u062A\u0648\u0636\u06CC\u062D \u062F\u0647\u06CC\u062F\u060C \u0633\u067E\u0633 \u067E\u06CC\u0634 \u0627\u0632 \u0630\u062E\u06CC\u0631\u0647\u060C \u0622\u0646\u0686\u0647 \u0631\u0627 \u0641\u0647\u0645\u06CC\u062F\u0647 \u0628\u0627\u0632\u0628\u06CC\u0646\u06CC \u06A9\u0646\u06CC\u062F.",
    'assistant.voice.start': "\u0634\u0631\u0648\u0639 \u062F\u06CC\u06A9\u062A\u0647",
    'assistant.voice.stop': "\u062A\u0648\u0642\u0641",
    'assistant.voice.listening': "\u062F\u0631 \u062D\u0627\u0644 \u0634\u0646\u06CC\u062F\u0646\u2026",
    'assistant.voice.unsupported': "\u0627\u06CC\u0646 \u0645\u0631\u0648\u0631\u06AF\u0631 \u062A\u0628\u062F\u06CC\u0644 \u06AF\u0641\u062A\u0627\u0631 \u0628\u0647 \u0645\u062A\u0646 \u0646\u062F\u0627\u0631\u062F. \u0645\u062A\u0646 \u0631\u0627 \u062A\u0627\u06CC\u067E \u06CC\u0627 \u062C\u0627\u06CC\u200C\u06AF\u0630\u0627\u0631\u06CC \u06A9\u0646\u06CC\u062F.",
    'assistant.voice.transcript': "\u0645\u062A\u0646 \u0634\u0646\u06CC\u062F\u0647\u200C\u0634\u062F\u0647",
    'assistant.voice.transcriptPlaceholder': "\u0622\u0642\u0627\u06CC \u06F5\u06F4 \u0633\u0627\u0644\u0647 \u0628\u0627 \u062F\u0631\u062F \u0641\u0634\u0627\u0631\u0646\u062F\u0647\u0654 \u0642\u0641\u0633\u0647\u0654 \u0633\u06CC\u0646\u0647 \u0627\u0632 \u0635\u0628\u062D \u0627\u0645\u0631\u0648\u0632\u060C \u062F\u06CC\u0627\u0628\u062A \u0634\u0646\u0627\u062E\u062A\u0647\u200C\u0634\u062F\u0647\u060C \u0645\u0635\u0631\u0641 \u0645\u062A\u0641\u0648\u0631\u0645\u06CC\u0646\u2026",
    'assistant.voice.parse': "\u062A\u0628\u062F\u06CC\u0644 \u0628\u0647 \u0634\u0631\u062D \u062D\u0627\u0644",
    'assistant.voice.parsing': "\u062F\u0631 \u062D\u0627\u0644 \u062E\u0648\u0627\u0646\u062F\u0646\u2026",
    'assistant.voice.needsTranscript': "\u0647\u0646\u0648\u0632 \u0645\u062A\u0646\u06CC \u0628\u0631\u0627\u06CC \u062E\u0648\u0627\u0646\u062F\u0646 \u0648\u062C\u0648\u062F \u0646\u062F\u0627\u0631\u062F.",
    'assistant.voice.draft.title': "\u067E\u06CC\u0634\u200C\u0646\u0648\u06CC\u0633 \u2014 \u0647\u0646\u0648\u0632 \u0686\u06CC\u0632\u06CC \u0630\u062E\u06CC\u0631\u0647 \u0646\u0634\u062F\u0647",
    'assistant.voice.draft.body': "\u0647\u0631\u0686\u0647 \u0631\u0627 \u0646\u0645\u06CC\u200C\u062E\u0648\u0627\u0647\u06CC\u062F \u0628\u0631\u062F\u0627\u0631\u06CC\u062F \u0648 \u0633\u067E\u0633 \u062A\u0623\u06CC\u06CC\u062F \u06A9\u0646\u06CC\u062F.",
    'assistant.voice.draft.none': "\u0686\u06CC\u0632\u06CC \u06A9\u0647 \u0628\u062A\u0648\u0627\u0646\u062F \u062F\u0631 \u0628\u062E\u0634\u200C\u0647\u0627\u06CC \u0634\u0631\u062D \u062D\u0627\u0644 \u062C\u0627\u06CC \u0628\u06AF\u06CC\u0631\u062F \u067E\u06CC\u062F\u0627 \u0646\u0634\u062F.",
    'assistant.voice.draft.confirm': "\u0627\u0641\u0632\u0648\u062F\u0646 \u0645\u0648\u0627\u0631\u062F \u0627\u0646\u062A\u062E\u0627\u0628\u200C\u0634\u062F\u0647",
    'assistant.voice.draft.confirming': "\u062F\u0631 \u062D\u0627\u0644 \u0627\u0641\u0632\u0648\u062F\u0646\u2026",
    'assistant.voice.draft.discard': "\u062F\u0648\u0631 \u0627\u0646\u062F\u0627\u062E\u062A\u0646 \u067E\u06CC\u0634\u200C\u0646\u0648\u06CC\u0633",
    'assistant.voice.draft.demographics': "\u0647\u0645\u0686\u0646\u06CC\u0646 \u0634\u0646\u06CC\u062F\u0647 \u0634\u062F",
    'assistant.voice.draft.demographicsNote': "\u0627\u06CC\u0646\u200C\u0647\u0627 \u0627\u0639\u0645\u0627\u0644 \u0646\u0645\u06CC\u200C\u0634\u0648\u0646\u062F\u061B \u0627\u06AF\u0631 \u0645\u06CC\u200C\u062E\u0648\u0627\u0647\u06CC\u062F\u060C \u0628\u06CC\u0645\u0627\u0631 \u0631\u0627 \u0648\u06CC\u0631\u0627\u06CC\u0634 \u06A9\u0646\u06CC\u062F.",
    'assistant.voice.applied': "{{count}} \u0628\u062E\u0634 \u0628\u0647 \u0634\u0631\u062D \u062D\u0627\u0644 \u0627\u0641\u0632\u0648\u062F\u0647 \u0634\u062F.",
    'visit.back': "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u067E\u0631\u0648\u0646\u062F\u0647",
    'visit.backToRecord': "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u067E\u0631\u0648\u0646\u062F\u0647",
    'visit.notFound': "\u0627\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A \u067E\u06CC\u062F\u0627 \u0646\u0634\u062F",
    'visit.end': "\u067E\u0627\u06CC\u0627\u0646 \u0648\u06CC\u0632\u06CC\u062A",
    'visit.reopen': "\u0628\u0627\u0632\u06AF\u0634\u0627\u06CC\u06CC",
    'visit.cancel': "\u0644\u063A\u0648 \u0648\u06CC\u0632\u06CC\u062A",
    'visit.elapsed': "{{h}} \u0633\u0627\u0639\u062A \u0648 {{m}} \u062F\u0642\u06CC\u0642\u0647 \u0627\u0632 \u0648\u06CC\u0632\u06CC\u062A",
    'visit.closedAt': "\u0628\u0633\u062A\u0647 \u0634\u062F\u0647 \u062F\u0631 {{date}}",
    'visit.save.saved': "\u0630\u062E\u06CC\u0631\u0647 \u0634\u062F",
    'visit.save.saving': "\u062F\u0631 \u062D\u0627\u0644 \u0630\u062E\u06CC\u0631\u0647\u2026",
    'visit.save.failed': "\u0630\u062E\u06CC\u0631\u0647 \u0646\u0634\u062F \u2014 \u062A\u0644\u0627\u0634 \u062F\u0648\u0628\u0627\u0631\u0647",
    'visit.tabs.aria': "\u0628\u062E\u0634\u200C\u0647\u0627\u06CC \u0648\u06CC\u0632\u06CC\u062A",
    'visit.tabs.note': "\u06CC\u0627\u062F\u062F\u0627\u0634\u062A",
    'visit.tabs.diagnoses': "\u062A\u0634\u062E\u06CC\u0635",
    'visit.tabs.rx': "\u0646\u0633\u062E\u0647",
    'visit.tabs.orders': "\u062F\u0633\u062A\u0648\u0631\u0627\u062A",
    'visit.soap.s': 'S',
    'visit.soap.o': 'O',
    'visit.soap.a': 'A',
    'visit.soap.p': 'P',
    'visit.soap.sCaption': "\u0634\u0631\u062D \u062D\u0627\u0644",
    'visit.soap.oCaption': "\u0645\u0639\u0627\u06CC\u0646\u0647 \u0648 \u06CC\u0627\u0641\u062A\u0647\u200C\u0647\u0627",
    'visit.soap.aCaption': "\u0627\u0631\u0632\u06CC\u0627\u0628\u06CC",
    'visit.soap.pCaption': "\u0628\u0631\u0646\u0627\u0645\u0647",
    'visit.soap.suggest': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u062F\u0633\u062A\u06CC\u0627\u0631",
    'visit.soap.suggesting': "\u062F\u0631 \u062D\u0627\u0644 \u0646\u0648\u0634\u062A\u0646 \u067E\u06CC\u0634\u200C\u0646\u0648\u06CC\u0633\u2026",
    'visit.soap.suggestNote': "\u067E\u06CC\u0634\u200C\u0646\u0648\u06CC\u0633 \u0627\u0633\u062A\u061B \u062A\u0627 \u062E\u0648\u062F\u062A\u0627\u0646 \u0627\u0639\u0645\u0627\u0644 \u0646\u06A9\u0646\u06CC\u062F \u0686\u06CC\u0632\u06CC \u0646\u0648\u0634\u062A\u0647 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
    'visit.soap.listening': "\u062F\u0631 \u062D\u0627\u0644 \u0634\u0646\u06CC\u062F\u0646\u2026",
    'visit.soap.dictate': "\u062F\u06CC\u06A9\u062A\u0647 \u062F\u0631 \u0627\u06CC\u0646 \u0628\u062E\u0634",
    'visit.soap.dictateStop': "\u062A\u0648\u0642\u0641 \u062F\u06CC\u06A9\u062A\u0647",
    'visit.soap.reviewTitle': "\u0628\u0627\u0632\u0628\u06CC\u0646\u06CC \u06CC\u0627\u062F\u062F\u0627\u0634\u062A \u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u06CC",
    'visit.soap.reviewEmpty': "\u0686\u06CC\u0632\u06CC \u06A9\u0647 \u062F\u0631 \u0628\u062E\u0634\u200C\u0647\u0627\u06CC SOAP \u062C\u0627\u06CC \u0628\u06AF\u06CC\u0631\u062F \u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u0646\u0634\u062F.",
    'visit.soap.reviewCurrent': "\u0622\u0646\u0686\u0647 \u062E\u0648\u062F\u062A\u0627\u0646 \u0646\u0648\u0634\u062A\u0647\u200C\u0627\u06CC\u062F",
    'visit.soap.applyReplace': "\u062C\u0627\u06CC\u06AF\u0632\u06CC\u0646\u06CC",
    'visit.soap.applyAppend': "\u0627\u0641\u0632\u0648\u062F\u0646 \u062F\u0631 \u0627\u062F\u0627\u0645\u0647",
    'visit.dx.title': "\u062A\u0634\u062E\u06CC\u0635",
    'visit.dx.icd': "\u06A9\u062F ICD",
    'visit.dx.icdHint': "\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC \u2014 \u06CC\u06A9 \u062D\u0631\u0641 \u0648 \u062F\u0648 \u0631\u0642\u0645\u060C \u0645\u062B\u0644 I21.0",
    'visit.dx.icdInvalid': "\u0642\u0627\u0644\u0628 \u0627\u06CC\u0646 \u0645\u0642\u062F\u0627\u0631 \u0634\u0628\u06CC\u0647 \u06A9\u062F ICD \u0646\u06CC\u0633\u062A",
    'visit.dx.kind': "\u0646\u0648\u0639",
    'visit.dx.status': "\u0648\u0636\u0639\u06CC\u062A",
    'visit.dx.note': "\u06CC\u0627\u062F\u062F\u0627\u0634\u062A",
    'visit.dx.add': "\u0627\u0641\u0632\u0648\u062F\u0646 \u062A\u0634\u062E\u06CC\u0635",
    'visit.dx.empty': "\u0647\u0646\u0648\u0632 \u062A\u0634\u062E\u06CC\u0635\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647",
    'visit.dx.emptyBody': "\u0622\u0646\u0686\u0647 \u0631\u0627 \u0645\u062D\u062A\u0645\u0644 \u0645\u06CC\u200C\u062F\u0627\u0646\u06CC\u062F \u0628\u0646\u0648\u06CC\u0633\u06CC\u062F\u060C \u06CC\u0627 \u062A\u0634\u062E\u06CC\u0635 \u0627\u0641\u062A\u0631\u0627\u0642\u06CC \u0628\u062E\u0648\u0627\u0647\u06CC\u062F.",
    'visit.dx.moveUp': "\u06CC\u06A9 \u067E\u0644\u0647 \u0628\u0627\u0644\u0627\u062A\u0631",
    'visit.dx.moveDown': "\u06CC\u06A9 \u067E\u0644\u0647 \u067E\u0627\u06CC\u06CC\u0646\u200C\u062A\u0631",
    'visit.dx.differential': "\u062A\u0634\u062E\u06CC\u0635 \u0627\u0641\u062A\u0631\u0627\u0642\u06CC \u062F\u0633\u062A\u06CC\u0627\u0631",
    'visit.dx.differentialBusy': "\u062F\u0631 \u062D\u0627\u0644 \u0641\u06A9\u0631 \u06A9\u0631\u062F\u0646\u2026",
    'visit.dx.differentialLast': "\u0622\u062E\u0631\u06CC\u0646 \u0627\u0641\u062A\u0631\u0627\u0642\u06CC",
    'visit.dx.differentialTitle': "\u062A\u0634\u062E\u06CC\u0635 \u0627\u0641\u062A\u0631\u0627\u0642\u06CC",
    'visit.dx.differentialEmpty': "\u0641\u0647\u0631\u0633\u062A \u062C\u062F\u0627\u0634\u062F\u0646\u06CC \u0628\u0631\u0646\u06AF\u0634\u062A\u061B \u062A\u0648\u0636\u06CC\u062D \u0628\u0627\u0644\u0627 \u0631\u0627 \u0628\u062E\u0648\u0627\u0646\u06CC\u062F.",
    'visit.dx.discriminators': "\u0648\u062C\u0647 \u0627\u0641\u062A\u0631\u0627\u0642",
    'visit.dx.nextSteps': "\u06AF\u0627\u0645 \u0628\u0639\u062F\u06CC",
    'visit.dx.addToList': "\u0627\u0641\u0632\u0648\u062F\u0646 \u0628\u0647 \u062A\u0634\u062E\u06CC\u0635\u200C\u0647\u0627",
    'visit.dx.addedToList': "\u0627\u0641\u0632\u0648\u062F\u0647 \u0634\u062F",
    'visit.rx.drug': "\u062F\u0627\u0631\u0648",
    'visit.rx.drugHint': "\u0627\u0632 \u0641\u0647\u0631\u0633\u062A \u062F\u0627\u0631\u0648\u06CC\u06CC \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F\u060C \u06CC\u0627 \u0646\u0627\u0645\u06CC \u062E\u0627\u0631\u062C \u0627\u0632 \u0622\u0646 \u0631\u0627 \u062A\u0627\u06CC\u067E \u06A9\u0646\u06CC\u062F",
    'visit.rx.searching': "\u062F\u0631 \u062D\u0627\u0644 \u062C\u0633\u062A\u062C\u0648\u2026",
    'visit.rx.freeText': "\u062E\u0627\u0631\u062C \u0627\u0632 \u0641\u0647\u0631\u0633\u062A \u062F\u0627\u0631\u0648\u06CC\u06CC",
    'visit.rx.freeTextNote': "\u0631\u062F\u06CC\u0641\u200C\u0647\u0627\u06CC \u062E\u0627\u0631\u062C \u0627\u0632 \u0641\u0647\u0631\u0633\u062A \u062F\u0627\u0631\u0648\u06CC\u06CC \u062F\u0631 \u0628\u0631\u0631\u0633\u06CC \u062A\u062F\u0627\u062E\u0644 \u0646\u0627\u062F\u06CC\u062F\u0647 \u06AF\u0631\u0641\u062A\u0647 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F.",
    'visit.rx.dose': "\u062F\u0648\u0632",
    'visit.rx.route': "\u0631\u0627\u0647 \u0645\u0635\u0631\u0641",
    'visit.rx.frequency': "\u062A\u0646\u0627\u0648\u0628",
    'visit.rx.duration': "\u0645\u062F\u062A",
    'visit.rx.quantity': "\u062A\u0639\u062F\u0627\u062F",
    'visit.rx.instructions': "\u062F\u0633\u062A\u0648\u0631 \u0645\u0635\u0631\u0641",
    'visit.rx.detail': "\u062F\u0633\u062A\u0648\u0631",
    'visit.rx.add': "\u0627\u0641\u0632\u0648\u062F\u0646 \u062F\u0627\u0631\u0648",
    'visit.rx.empty': "\u0647\u0646\u0648\u0632 \u062F\u0627\u0631\u0648\u06CC\u06CC \u062A\u062C\u0648\u06CC\u0632 \u0646\u0634\u062F\u0647",
    'visit.rx.emptyBody': "\u062F\u0627\u0631\u0648\u0647\u0627\u06CC\u06CC \u0631\u0627 \u06A9\u0647 \u062F\u0631 \u0627\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A \u062A\u062C\u0648\u06CC\u0632 \u0645\u06CC\u200C\u06A9\u0631\u062F\u06CC\u062F \u0628\u06CC\u0641\u0632\u0627\u06CC\u06CC\u062F.",
    'visit.rx.check': "\u0628\u0631\u0631\u0633\u06CC \u062A\u062F\u0627\u062E\u0644",
    'visit.rx.checking': "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0631\u0631\u0633\u06CC\u2026",
    'visit.rx.lastCheck': "\u0622\u062E\u0631\u06CC\u0646 \u0628\u0631\u0631\u0633\u06CC",
    'visit.rx.interactionTitle': "\u0628\u0631\u0631\u0633\u06CC \u062A\u062F\u0627\u062E\u0644 \u062F\u0627\u0631\u0648\u06CC\u06CC",
    'visit.rx.interactionNone': "\u062A\u062F\u0627\u062E\u0644\u06CC \u06CC\u0627\u0641\u062A \u0646\u0634\u062F",
    'visit.rx.interactionNoneBody': "\u0628\u0631\u0627\u06CC \u0631\u062F\u06CC\u0641\u200C\u0647\u0627\u06CC\u06CC \u06A9\u0647 \u0628\u0631\u0631\u0633\u06CC \u062A\u0648\u0627\u0646\u0633\u062A \u0628\u0628\u06CC\u0646\u062F. \u0641\u0647\u0631\u0633\u062A \u0628\u0631\u0631\u0633\u06CC\u200C\u0646\u0634\u062F\u0647\u200C\u0647\u0627 \u0631\u0627 \u062F\u0631 \u0627\u062F\u0627\u0645\u0647 \u0628\u062E\u0648\u0627\u0646\u06CC\u062F.",
    'visit.rx.interactionSource': "\u0645\u0646\u0628\u0639",
    'visit.rx.skippedTitle': "\u0627\u06CC\u0646 \u0631\u062F\u06CC\u0641\u200C\u0647\u0627 \u0628\u0631\u0631\u0633\u06CC \u0646\u0634\u062F\u0646\u062F",
    'visit.rx.skippedBody': "\u062F\u0633\u062A\u06CC \u062A\u0627\u06CC\u067E \u0634\u062F\u0647\u200C\u0627\u0646\u062F \u0648 \u06A9\u062F \u062F\u0627\u0631\u0648\u06CC\u06CC \u0646\u062F\u0627\u0631\u0646\u062F\u060C \u067E\u0633 \u0628\u0631\u0631\u0633\u06CC \u0646\u062A\u0648\u0627\u0646\u0633\u062A \u0622\u0646\u200C\u0647\u0627 \u0631\u0627 \u067E\u06CC\u062F\u0627 \u06A9\u0646\u062F.",
    'visit.rx.print': "\u0686\u0627\u067E \u0646\u0633\u062E\u0647",
    'visit.rx.printTitle': "\u0646\u0633\u062E\u0647\u0654 \u062A\u0645\u0631\u06CC\u0646\u06CC",
    'visit.rx.printAction': "\u0686\u0627\u067E",
    'visit.rx.printFooter': "\u0633\u0646\u062F\u06CC \u062A\u0645\u0631\u06CC\u0646\u06CC \u0627\u0633\u062A\u061B \u0627\u0639\u062A\u0628\u0627\u0631 \u0646\u062F\u0627\u0631\u062F \u0648 \u0647\u0631\u06AF\u0632 \u0646\u0628\u0627\u06CC\u062F \u0628\u0647 \u062F\u0627\u0631\u0648\u062E\u0627\u0646\u0647 \u0627\u0631\u0627\u0626\u0647 \u0634\u0648\u062F.",
    'visit.rx.watermark': "\u0646\u0633\u062E\u0647\u0654 \u062A\u0645\u0631\u06CC\u0646\u06CC \u2014 \u0641\u0627\u0642\u062F \u0627\u0639\u062A\u0628\u0627\u0631",
    'visit.rx.studentNumber': "\u0634\u0645\u0627\u0631\u0647\u0654 \u062F\u0627\u0646\u0634\u062C\u0648\u06CC\u06CC",
    'visit.orders.add': "\u0627\u0641\u0632\u0648\u062F\u0646 \u062F\u0633\u062A\u0648\u0631",
    'visit.orders.fromCatalog': "\u0627\u0632 \u0641\u0647\u0631\u0633\u062A \u062E\u062F\u0645\u0627\u062A",
    'visit.orders.title': "\u062F\u0633\u062A\u0648\u0631",
    'visit.orders.type': "\u0646\u0648\u0639",
    'visit.orders.urgency': "\u0641\u0648\u0631\u06CC\u062A",
    'visit.orders.notes': "\u062F\u0644\u06CC\u0644 / \u062A\u0648\u0636\u06CC\u062D",
    'visit.orders.empty': "\u0647\u0646\u0648\u0632 \u062F\u0633\u062A\u0648\u0631\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647",
    'visit.orders.emptyBody': "\u0622\u0632\u0645\u0627\u06CC\u0634\u200C\u0647\u0627 \u0648 \u062A\u0635\u0648\u06CC\u0631\u0628\u0631\u062F\u0627\u0631\u06CC\u200C\u0647\u0627\u06CC \u0644\u0627\u0632\u0645 \u0627\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A \u0631\u0627 \u062B\u0628\u062A \u06A9\u0646\u06CC\u062F.",
    'visit.orders.pickTitle': "\u0627\u0646\u062A\u062E\u0627\u0628 \u0627\u0632 \u0641\u0647\u0631\u0633\u062A \u062E\u062F\u0645\u0627\u062A",
    'visit.orders.pickEmpty': "\u0645\u0648\u0631\u062F\u06CC \u0645\u0637\u0627\u0628\u0642 \u062C\u0633\u062A\u062C\u0648 \u0646\u06CC\u0633\u062A\u061B \u062F\u0633\u062A\u0648\u0631 \u0631\u0627 \u062A\u0627\u06CC\u067E \u06A9\u0646\u06CC\u062F.",
    'visit.orders.search': "\u062C\u0633\u062A\u062C\u0648 \u062F\u0631 \u0641\u0647\u0631\u0633\u062A \u062E\u062F\u0645\u0627\u062A",
    'visit.orders.recordResult': "\u062B\u0628\u062A \u0646\u062A\u06CC\u062C\u0647",
    'visit.orders.cancelOrder': "\u0644\u063A\u0648 \u062F\u0633\u062A\u0648\u0631",
    'visit.orders.resultTitle': "\u062B\u0628\u062A \u0646\u062A\u06CC\u062C\u0647",
    'visit.orders.resultBody': "\u0646\u062A\u06CC\u062C\u0647",
    'visit.orders.resultRows': "\u0645\u0642\u0627\u062F\u06CC\u0631",
    'visit.orders.resultAddRow': "\u0627\u0641\u0632\u0648\u062F\u0646 \u0631\u062F\u06CC\u0641",
    'visit.orders.resultName': "\u0622\u0632\u0645\u0627\u06CC\u0634",
    'visit.orders.resultValue': "\u0645\u0642\u062F\u0627\u0631",
    'visit.orders.resultUnit': "\u0648\u0627\u062D\u062F",
    'visit.orders.resultRef': "\u0645\u062D\u062F\u0648\u062F\u0647\u0654 \u0645\u0631\u062C\u0639",
    'visit.orders.resultSave': "\u0630\u062E\u06CC\u0631\u0647\u0654 \u0646\u062A\u06CC\u062C\u0647",
    'visit.orders.resultFlag': "\u0648\u0636\u0639\u06CC\u062A \u0645\u0642\u062F\u0627\u0631",
    'visit.orders.resultFlagNone': "\u2014",
    'visit.orders.resultEmpty': "\u0646\u062A\u06CC\u062C\u0647\u200C\u0627\u06CC \u0628\u0646\u0648\u06CC\u0633\u06CC\u062F \u06CC\u0627 \u062F\u0633\u062A\u200C\u06A9\u0645 \u06CC\u06A9 \u0631\u062F\u06CC\u0641 \u0645\u0642\u062F\u0627\u0631 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.",
    'visit.orders.suggest': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u062F\u0633\u062A\u0648\u0631\u0627\u062A",
    'visit.orders.suggestBusy': "\u062F\u0631 \u062D\u0627\u0644 \u0641\u06A9\u0631 \u06A9\u0631\u062F\u0646\u2026",
    'visit.orders.suggestLast': "\u0622\u062E\u0631\u06CC\u0646 \u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u0647\u0627",
    'visit.orders.suggestTitle': "\u062F\u0633\u062A\u0648\u0631\u0647\u0627\u06CC \u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u06CC",
    'visit.orders.suggestEmpty': "\u062F\u0633\u062A\u0648\u0631 \u062C\u062F\u0627\u0634\u062F\u0646\u06CC \u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u0646\u0634\u062F\u061B \u062A\u0648\u0636\u06CC\u062D \u0628\u0627\u0644\u0627 \u0631\u0627 \u0628\u062E\u0648\u0627\u0646\u06CC\u062F.",
    'visit.orders.suggestAdd': "\u0627\u0641\u0632\u0648\u062F\u0646 \u0645\u0648\u0627\u0631\u062F \u0627\u0646\u062A\u062E\u0627\u0628\u200C\u0634\u062F\u0647 ({{count}})",
    'visit.rail.title': "\u067E\u0631\u0648\u0646\u062F\u0647",
    'visit.rail.expand': "\u0628\u0627\u0632 \u06A9\u0631\u062F\u0646 \u0633\u062A\u0648\u0646 \u067E\u0631\u0648\u0646\u062F\u0647",
    'visit.rail.collapse': "\u062C\u0645\u0639 \u06A9\u0631\u062F\u0646 \u0633\u062A\u0648\u0646 \u067E\u0631\u0648\u0646\u062F\u0647",
    'visit.rail.allergies': "\u0647\u0634\u062F\u0627\u0631 \u062D\u0633\u0627\u0633\u06CC\u062A",
    'visit.rail.identity': "\u0645\u0634\u062E\u0635\u0627\u062A",
    'visit.rail.vitals': "\u0639\u0644\u0627\u0626\u0645 \u062D\u06CC\u0627\u062A\u06CC",
    'visit.rail.vitalsAdd': "\u062B\u0628\u062A",
    'visit.rail.vitalsPlaceholder': "\u0641\u0634\u0627\u0631 \u06F1\u06F2\u06F0/\u06F8\u06F0 \xb7 \u0646\u0628\u0636 \u06F7\u06F2",
    'visit.rail.medications': "\u062F\u0627\u0631\u0648\u0647\u0627\u06CC \u0641\u0639\u0644\u06CC",
    'visit.rail.problems': "\u0645\u0634\u06A9\u0644\u0627\u062A \u0641\u0639\u0627\u0644",
    'visit.rail.pmh': "\u0633\u0627\u0628\u0642\u0647\u0654 \u0628\u06CC\u0645\u0627\u0631\u06CC",
    'visit.rail.labs': "\u0622\u0632\u0645\u0627\u06CC\u0634\u200C\u0647\u0627",
    'visit.rail.history': "\u0634\u0631\u062D \u062D\u0627\u0644",
    'visit.rail.ageYears': "{{n}} \u0633\u0627\u0644\u0647",
    'visit.rail.noVitals': "\u0639\u0644\u0627\u0626\u0645 \u062D\u06CC\u0627\u062A\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'visit.rail.noMedications': "\u062F\u0627\u0631\u0648\u06CC \u0641\u0639\u0627\u0644\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'visit.rail.noProblems': "\u0645\u0634\u06A9\u0644 \u0641\u0639\u0627\u0644\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'visit.rail.noPmh': "\u0647\u0646\u0648\u0632 \u0686\u06CC\u0632\u06CC \u0646\u0648\u0634\u062A\u0647 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'visit.rail.noLabs': "\u0647\u0646\u0648\u0632 \u0622\u0632\u0645\u0627\u06CC\u0634\u06CC \u0646\u0648\u0634\u062A\u0647 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'visit.rail.noHistory': "\u0634\u0631\u062D \u062D\u0627\u0644 \u062E\u0627\u0644\u06CC \u0627\u0633\u062A.",
    'visit.rail.emptyList': "\u0647\u0646\u0648\u0632 \u0686\u06CC\u0632\u06CC \u0627\u06CC\u0646\u062C\u0627 \u0646\u06CC\u0633\u062A.",
    'visit.copilot.title': "\u062F\u0633\u062A\u06CC\u0627\u0631",
    'visit.copilot.aria': "\u0628\u062E\u0634\u200C\u0647\u0627\u06CC \u062F\u0633\u062A\u06CC\u0627\u0631",
    'visit.copilot.ask': "\u067E\u0631\u0633\u0634",
    'visit.copilot.differential': "\u0627\u0641\u062A\u0631\u0627\u0642\u06CC",
    'visit.copilot.suggestions': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u0647\u0627",
    'visit.copilot.askEmpty': "\u062F\u0631\u0628\u0627\u0631\u0647\u0654 \u0647\u0645\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A \u0628\u067E\u0631\u0633\u06CC\u062F\u061B \u067E\u0631\u0648\u0646\u062F\u0647 \u0648 \u06CC\u0627\u062F\u062F\u0627\u0634\u062A\u06CC \u06A9\u0647 \u0645\u06CC\u200C\u0646\u0648\u06CC\u0633\u06CC\u062F \u0631\u0627 \u0645\u06CC\u200C\u062E\u0648\u0627\u0646\u062F.",
    'visit.copilot.thinking': "\u062F\u0631 \u062D\u0627\u0644 \u0641\u06A9\u0631 \u06A9\u0631\u062F\u0646\u2026",
    'visit.copilot.placeholder': "\u062F\u0631\u0628\u0627\u0631\u0647\u0654 \u0627\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A \u0628\u067E\u0631\u0633\u06CC\u062F",
    'visit.copilot.send': "\u0628\u067E\u0631\u0633",
    'visit.copilot.offline': "\u0622\u0641\u0644\u0627\u06CC\u0646 \u2014 \u062F\u0633\u062A\u06CC\u0627\u0631 \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A.",
    'visit.copilot.open': "\u0628\u0627\u0632 \u06A9\u0631\u062F\u0646 \u062F\u0633\u062A\u06CC\u0627\u0631",
    'visit.copilot.collapse': "\u062C\u0645\u0639 \u06A9\u0631\u062F\u0646 \u062F\u0633\u062A\u06CC\u0627\u0631",
    'visit.copilot.refresh': "\u0628\u0647\u200C\u0631\u0648\u0632\u0631\u0633\u0627\u0646\u06CC",
    'visit.copilot.openCards': "\u062F\u06CC\u062F\u0646 \u06A9\u0627\u0631\u062A\u200C\u0647\u0627",
    'visit.copilot.differentialEmpty': "\u062F\u0631 \u0627\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A \u0647\u0646\u0648\u0632 \u0627\u0641\u062A\u0631\u0627\u0642\u06CC \u062E\u0648\u0627\u0633\u062A\u0647 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'visit.copilot.soapSuggestion': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u06CC\u0627\u062F\u062F\u0627\u0634\u062A",
    'visit.copilot.orderSuggestion': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u062F\u0633\u062A\u0648\u0631\u0627\u062A",
    'visit.copilot.suggestionsEmpty': "\u0647\u0646\u0648\u0632 \u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u06CC \u062F\u0631 \u0627\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A \u0648\u062C\u0648\u062F \u0646\u062F\u0627\u0631\u062F.",
    'visit.copilot.reopen': "\u0628\u0627\u0632 \u06A9\u0631\u062F\u0646 \u062F\u0648\u0628\u0627\u0631\u0647",
    'visit.close.title': "\u067E\u0627\u06CC\u0627\u0646 \u0648\u06CC\u0632\u06CC\u062A",
    'visit.close.summary': "\u062E\u0644\u0627\u0635\u0647\u0654 \u0648\u06CC\u0632\u06CC\u062A",
    'visit.close.summaryHint': "\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC. \u0627\u0632 \u0633\u0637\u0631 \u0627\u0648\u0644 \u0627\u0631\u0632\u06CC\u0627\u0628\u06CC \u0648 \u0628\u0631\u0646\u0627\u0645\u0647 \u067E\u06CC\u0634\u200C\u0646\u0648\u06CC\u0633 \u0634\u062F\u0647 \u0627\u0633\u062A.",
    'visit.close.warningsTitle': "\u067E\u06CC\u0634 \u0627\u0632 \u0628\u0633\u062A\u0646",
    'visit.close.warningsNote': "\u0647\u06CC\u0686\u200C\u06A9\u062F\u0627\u0645 \u0627\u0632 \u0627\u06CC\u0646\u200C\u0647\u0627 \u0645\u0627\u0646\u0639 \u0628\u0633\u062A\u0646 \u0648\u06CC\u0632\u06CC\u062A \u0646\u06CC\u0633\u062A.",
    'visit.close.warning.emptyNote': "\u06CC\u0627\u062F\u062F\u0627\u0634\u062A \u0648\u06CC\u0632\u06CC\u062A \u062E\u0627\u0644\u06CC \u0627\u0633\u062A.",
    'visit.close.warning.noDiagnoses': "\u0647\u06CC\u0686 \u062A\u0634\u062E\u06CC\u0635\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'visit.close.warning.openSuggestions': "\u06CC\u06A9 \u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u062F\u0633\u062A\u06CC\u0627\u0631 \u0647\u0646\u0648\u0632 \u0628\u0627\u0632 \u0648 \u0628\u0627\u0632\u0628\u06CC\u0646\u06CC\u200C\u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'visit.close.ending': "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0633\u062A\u0646\u2026",
    'visit.close.saveFailed': "\u06CC\u0627\u062F\u062F\u0627\u0634\u062A \u0630\u062E\u06CC\u0631\u0647 \u0646\u0634\u062F\u060C \u0628\u0646\u0627\u0628\u0631\u0627\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A \u0628\u0633\u062A\u0647 \u0646\u0634\u062F",
    'visit.cancelConfirm.title': "\u0627\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A \u0644\u063A\u0648 \u0634\u0648\u062F\u061F",
    'visit.cancelConfirm.body': "{{dx}} \u062A\u0634\u062E\u06CC\u0635\u060C {{rx}} \u062F\u0627\u0631\u0648 \u0648 {{orders}} \u062F\u0633\u062A\u0648\u0631 \u062D\u0630\u0641 \u0645\u06CC\u200C\u0634\u0648\u062F. \u0639\u0644\u0627\u0626\u0645 \u062D\u06CC\u0627\u062A\u06CC \u0648 \u0634\u0631\u062D \u062D\u0627\u0644 \u062F\u0631 \u067E\u0631\u0648\u0646\u062F\u0647 \u0645\u06CC\u200C\u0645\u0627\u0646\u0646\u062F.",
    'visit.cancelConfirm.confirm': "\u062D\u0630\u0641 \u0648\u06CC\u0632\u06CC\u062A",
    'visit.offline.title': "\u0627\u062A\u0635\u0627\u0644 \u0628\u0647 \u0633\u0631\u0648\u06CC\u0633 \u0642\u0637\u0639 \u0627\u0633\u062A",
    'visit.offline.body': "\u0622\u0646\u0686\u0647 \u0645\u06CC\u200C\u0646\u0648\u06CC\u0633\u06CC\u062F \u0631\u0648\u06CC \u0647\u0645\u06CC\u0646 \u062F\u0633\u062A\u06AF\u0627\u0647 \u0646\u06AF\u0647 \u062F\u0627\u0634\u062A\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u0628\u0627 \u0628\u0627\u0632\u06AF\u0634\u062A \u0627\u062A\u0635\u0627\u0644 \u0627\u0631\u0633\u0627\u0644 \u0645\u06CC\u200C\u06AF\u0631\u062F\u062F.",
    'visit.toast.ended': "\u0648\u06CC\u0632\u06CC\u062A \u0628\u0633\u062A\u0647 \u0634\u062F.",
    'visit.toast.cancelled': "\u0648\u06CC\u0632\u06CC\u062A \u062D\u0630\u0641 \u0634\u062F.",
    'visit.toast.discardedDraft': "\u067E\u06CC\u0634\u200C\u0646\u0648\u06CC\u0633 \u0645\u062D\u0644\u06CC \u06CC\u0627\u062F\u062F\u0627\u0634\u062A \u0642\u062F\u06CC\u0645\u06CC\u200C\u062A\u0631 \u0627\u0632 \u0646\u0633\u062E\u0647\u0654 \u0630\u062E\u06CC\u0631\u0647\u200C\u0634\u062F\u0647 \u0628\u0648\u062F \u0648 \u06A9\u0646\u0627\u0631 \u06AF\u0630\u0627\u0634\u062A\u0647 \u0634\u062F.",
    'visit.shortcuts.group': "\u0648\u06CC\u0632\u06CC\u062A",
    'visit.shortcuts.save': "\u0630\u062E\u06CC\u0631\u0647\u0654 \u0641\u0648\u0631\u06CC \u06CC\u0627\u062F\u062F\u0627\u0634\u062A",
    'visit.shortcuts.tab1': "\u06CC\u0627\u062F\u062F\u0627\u0634\u062A",
    'visit.shortcuts.tab2': "\u062A\u0634\u062E\u06CC\u0635",
    'visit.shortcuts.tab3': "\u0646\u0633\u062E\u0647",
    'visit.shortcuts.tab4': "\u062F\u0633\u062A\u0648\u0631\u0627\u062A",
    'visit.shortcuts.send': "\u0627\u0631\u0633\u0627\u0644 \u067E\u0631\u0633\u0634",
    'visit.shortcuts.end': "\u067E\u0627\u06CC\u0627\u0646 \u0648\u06CC\u0632\u06CC\u062A"
};
var $36fe6517f24200bd$export$2e2bcd8739ae039 = $36fe6517f24200bd$export$bf638b60ea8b89b7;


// پارسه — balance, price list, top-up, gift codes, the ledger.
const $3210032cb0f283bf$export$68c7321cb43cac49 = {
    // ── پارسه — the wallet ───────────────────────────────────────────────
    'credits.title': "\u067E\u0627\u0631\u0633\u0647",
    'credits.sub': "\u0627\u0639\u062A\u0628\u0627\u0631 \u067E\u0627\u0631\u0633\u06CC\u0646\u0627 \u0628\u0631\u0627\u06CC \u062F\u0633\u062A\u06CC\u0627\u0631. \u0647\u0631 \u067E\u0627\u0633\u062E \u0645\u0642\u062F\u0627\u0631\u06CC \u0627\u0632 \u0622\u0646 \u062E\u0631\u062C \u0645\u06CC\u200C\u06A9\u0646\u062F.",
    'credits.balance.label': "\u0645\u0648\u062C\u0648\u062F\u06CC \u0634\u0645\u0627",
    'credits.balance.loading': "\u062F\u0631 \u062D\u0627\u0644 \u062E\u0648\u0627\u0646\u062F\u0646 \u0645\u0648\u062C\u0648\u062F\u06CC\u2026",
    'credits.free.title': "\u0647\u0631 \u0645\u0627\u0647 \u06F5\u06F0\u06F0 \u067E\u0627\u0631\u0633\u0647 \u0631\u0627\u06CC\u06AF\u0627\u0646",
    'credits.free.body': "\u0627\u0628\u062A\u062F\u0627\u06CC \u0647\u0631 \u0645\u0627\u0647 \u062A\u0645\u062F\u06CC\u062F \u0645\u06CC\u200C\u0634\u0648\u062F\u060C \u0686\u0647 \u0634\u0627\u0631\u0698 \u06A9\u0646\u06CC\u062F \u0686\u0647 \u0646\u06A9\u0646\u06CC\u062F.",
    'credits.priceList.title': "\u0647\u0632\u06CC\u0646\u0647\u0654 \u0647\u0631 \u0639\u0645\u0644\u06CC\u0627\u062A",
    'credits.price.ask': "\u067E\u0631\u0633\u0634 \u0627\u0632 \u062F\u0633\u062A\u06CC\u0627\u0631",
    'credits.price.differential': "\u062A\u0634\u062E\u06CC\u0635 \u0627\u0641\u062A\u0631\u0627\u0642\u06CC",
    'credits.price.soap': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F SOAP",
    'credits.price.orders': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u062F\u0633\u062A\u0648\u0631\u0627\u062A",
    'credits.price.interaction': "\u0628\u0631\u0631\u0633\u06CC \u062A\u062F\u0627\u062E\u0644 \u062F\u0627\u0631\u0648\u06CC\u06CC",
    'credits.price.voice': "\u0648\u0631\u0648\u062F \u0635\u0648\u062A\u06CC",
    'credits.topUp.title': "\u0634\u0627\u0631\u0698 \u0627\u0639\u062A\u0628\u0627\u0631",
    'credits.topUp.action': "\u062E\u0631\u06CC\u062F \u067E\u0627\u0631\u0633\u0647",
    'credits.topUp.recommended': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u06CC",
    'credits.topUp.custom': "\u0645\u0628\u0644\u063A \u062F\u0644\u062E\u0648\u0627\u0647",
    'credits.topUp.customLabel': "\u0645\u0628\u0644\u063A \u0628\u0647 \u062A\u0648\u0645\u0627\u0646",
    'credits.topUp.pay': "\u067E\u0631\u062F\u0627\u062E\u062A {{amount}} \u062A\u0648\u0645\u0627\u0646 \u0627\u0632 \u0637\u0631\u06CC\u0642 {{gateway}}",
    'credits.topUp.redirecting': "\u062F\u0631 \u062D\u0627\u0644 \u0627\u0646\u062A\u0642\u0627\u0644 \u0628\u0647 \u062F\u0631\u06AF\u0627\u0647 \u0628\u0627\u0646\u06A9\u2026",
    'credits.topUp.min': "\u06A9\u0645\u062A\u0631\u06CC\u0646 \u0645\u0628\u0644\u063A \u062E\u0631\u06CC\u062F {{amount}} \u062A\u0648\u0645\u0627\u0646 \u0627\u0633\u062A.",
    'credits.topUp.note': "\u0628\u0631\u0627\u06CC \u067E\u0631\u062F\u0627\u062E\u062A \u0628\u0647 \u0635\u0641\u062D\u0647\u0654 \u062E\u0648\u062F\u0650 \u0628\u0627\u0646\u06A9 \u0645\u0646\u062A\u0642\u0644 \u0645\u06CC\u200C\u0634\u0648\u06CC\u062F.",
    'credits.topUp.failed': "\u0634\u0631\u0648\u0639 \u067E\u0631\u062F\u0627\u062E\u062A \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F.",
    'credits.gateway.saderat': "\u0635\u0627\u062F\u0631\u0627\u062A (\u0633\u067E\u0647\u0631)",
    'credits.gateway.zarinpal': "\u0632\u0631\u06CC\u0646\u200C\u067E\u0627\u0644",
    'credits.gift.title': "\u06A9\u062F \u0647\u062F\u06CC\u0647",
    'credits.gift.hint': "\u06A9\u062F\u06CC \u0627\u0632 \u06A9\u0645\u067E\u06CC\u0646\u200C\u0647\u0627\u06CC \u067E\u0627\u0631\u0633\u06CC\u0646\u0627 \u062F\u0627\u0631\u06CC\u062F\u061F \u0627\u06CC\u0646\u062C\u0627 \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u06A9\u0646\u06CC\u062F.",
    'credits.gift.placeholder': 'PARSINA-XXXX',
    'credits.gift.submit': "\u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u0627\u0632 \u06A9\u062F",
    'credits.gift.submitting': "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0631\u0631\u0633\u06CC\u2026",
    'credits.gift.empty': "\u0627\u0628\u062A\u062F\u0627 \u06A9\u062F \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.",
    'credits.gift.notFound': "\u0627\u06CC\u0646 \u06A9\u062F \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A.",
    'credits.gift.success': "{{parseh}} \u067E\u0627\u0631\u0633\u0647 \u0627\u0636\u0627\u0641\u0647 \u0634\u062F.",
    'credits.gift.newBalance': "\u0645\u0648\u062C\u0648\u062F\u06CC \u062C\u062F\u06CC\u062F",
    'credits.gift.oneUse': "\u0647\u0631 \u06A9\u062F \u0641\u0642\u0637 \u06CC\u06A9 \u0628\u0627\u0631 \u0642\u0627\u0628\u0644 \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u0627\u0633\u062A.",
    'credits.gift.myCodes': "\u06A9\u062F\u0647\u0627\u06CC\u06CC \u06A9\u0647 \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u06A9\u0631\u062F\u0647\u200C\u0627\u06CC\u062F",
    'credits.gift.worth': "\u0627\u0631\u0632\u0634: {{parseh}} \u067E\u0627\u0631\u0633\u0647",
    'credits.gift.status.issued': "\u0627\u0633\u062A\u0641\u0627\u062F\u0647\u200C\u0646\u0634\u062F\u0647",
    'credits.gift.status.redeemed': "\u0627\u0633\u062A\u0641\u0627\u062F\u0647\u200C\u0634\u062F\u0647",
    'credits.gift.status.revoked': "\u0628\u0627\u0637\u0644\u200C\u0634\u062F\u0647",
    'credits.gift.status.expired': "\u0645\u0646\u0642\u0636\u06CC",
    'credits.tx.title': "\u06AF\u0631\u062F\u0634 \u062D\u0633\u0627\u0628",
    'credits.tx.empty.title': "\u0647\u0646\u0648\u0632 \u06AF\u0631\u062F\u0634\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647",
    'credits.tx.empty.body': "\u062E\u0631\u062C\u200C\u0647\u0627 \u0648 \u0634\u0627\u0631\u0698\u0647\u0627\u06CC \u0634\u0645\u0627 \u0627\u06CC\u0646\u062C\u0627 \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.",
    'credits.tx.error.title': "\u06AF\u0631\u062F\u0634 \u062D\u0633\u0627\u0628 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F",
    'credits.tx.columns.date': "\u0632\u0645\u0627\u0646",
    'credits.tx.columns.service': "\u0628\u0627\u0628\u062A",
    'credits.tx.columns.description': "\u062A\u0648\u0636\u06CC\u062D",
    'credits.tx.columns.amount': "\u067E\u0627\u0631\u0633\u0647",
    'credits.tx.filter.all': "\u0647\u0645\u0647",
    'credits.tx.filter.credit': "\u0627\u0641\u0632\u0648\u062F\u0647",
    'credits.tx.filter.debit': "\u062E\u0631\u062C\u200C\u0634\u062F\u0647",
    'credits.service.ask': "\u067E\u0631\u0633\u0634 \u0627\u0632 \u062F\u0633\u062A\u06CC\u0627\u0631",
    'credits.service.differential': "\u062A\u0634\u062E\u06CC\u0635 \u0627\u0641\u062A\u0631\u0627\u0642\u06CC",
    'credits.service.interaction': "\u0628\u0631\u0631\u0633\u06CC \u062A\u062F\u0627\u062E\u0644",
    'credits.service.transcription': "\u062A\u0628\u062F\u06CC\u0644 \u06AF\u0641\u062A\u0627\u0631 \u0628\u0647 \u0645\u062A\u0646",
    'credits.service.gift': "\u06A9\u062F \u0647\u062F\u06CC\u0647",
    'credits.service.topup': "\u0634\u0627\u0631\u0698",
    'credits.service.sms': "\u067E\u06CC\u0627\u0645\u06A9",
    'credits.service.other': "\u0627\u0645\u06A9\u0627\u0646 \u0647\u0648\u0634\u0645\u0646\u062F"
};
var $3210032cb0f283bf$export$2e2bcd8739ae039 = $3210032cb0f283bf$export$68c7321cb43cac49;


// پروفایل — the editable profile, appearance, and the way out.
const $49c0f7f37b3f5886$export$4882ae973e0491e = {
    // ── profile ──────────────────────────────────────────────────────────
    'profile.title': "\u067E\u0631\u0648\u0641\u0627\u06CC\u0644",
    'profile.sections.identity': "\u0645\u0634\u062E\u0635\u0627\u062A \u0634\u0645\u0627",
    'profile.sections.account': "\u062D\u0633\u0627\u0628 \u06A9\u0627\u0631\u0628\u0631\u06CC",
    'profile.sections.appearance': "\u0638\u0627\u0647\u0631 \u0648 \u0632\u0628\u0627\u0646",
    'profile.fields.phone': "\u0634\u0645\u0627\u0631\u0647\u0654 \u0645\u0648\u0628\u0627\u06CC\u0644",
    'profile.fields.studentId': "\u0634\u0646\u0627\u0633\u0647\u0654 \u062D\u0633\u0627\u0628",
    'profile.fields.cases': "\u0628\u06CC\u0645\u0627\u0631\u0627\u0646 \u062A\u0645\u0631\u06CC\u0646\u06CC",
    'profile.fields.balance': "\u0645\u0648\u062C\u0648\u062F\u06CC \u067E\u0627\u0631\u0633\u0647",
    'profile.identity.note': "\u0634\u0645\u0627\u0631\u0647\u0654 \u0645\u0648\u0628\u0627\u06CC\u0644 \u0634\u0645\u0627 \u0627\u0632 \u062D\u0633\u0627\u0628 \u0648\u0631\u0648\u062F \u067E\u0627\u0631\u0633\u06CC\u0646\u0627 \u062E\u0648\u0627\u0646\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u062A\u063A\u06CC\u06CC\u0631 \u0622\u0646 \u0627\u0632 \u0647\u0645\u0627\u0646\u200C\u062C\u0627 \u0627\u0646\u062C\u0627\u0645 \u0645\u06CC\u200C\u0634\u0648\u062F\u060C \u0646\u0647 \u0627\u06CC\u0646\u062C\u0627.",
    'profile.saved': "\u067E\u0631\u0648\u0641\u0627\u06CC\u0644 \u0630\u062E\u06CC\u0631\u0647 \u0634\u062F.",
    'profile.appearance.theme': "\u0631\u0646\u06AF \u062A\u0623\u06A9\u06CC\u062F\u06CC",
    'profile.appearance.fontSize': "\u0627\u0646\u062F\u0627\u0632\u0647\u0654 \u0645\u062A\u0646",
    'profile.appearance.language': "\u0632\u0628\u0627\u0646",
    'profile.appearance.localOnly': "\u0627\u06CC\u0646 \u062A\u0646\u0638\u06CC\u0645\u200C\u0647\u0627 \u0641\u0642\u0637 \u062F\u0631 \u0647\u0645\u06CC\u0646 \u0645\u0631\u0648\u0631\u06AF\u0631 \u0630\u062E\u06CC\u0631\u0647 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F \u0648 \u0628\u0647 \u062F\u0633\u062A\u06AF\u0627\u0647 \u062F\u06CC\u06AF\u0631 \u0645\u0646\u062A\u0642\u0644 \u0646\u0645\u06CC\u200C\u0634\u0648\u0646\u062F.",
    'profile.theme.default': "\u0622\u0628\u06CC \u067E\u0627\u0631\u0633\u06CC\u0646\u0627",
    'profile.theme.teal': "\u0641\u06CC\u0631\u0648\u0632\u0647\u200C\u0627\u06CC",
    'profile.theme.ocean': "\u0644\u0627\u062C\u0648\u0631\u062F\u06CC",
    'profile.theme.slate': "\u062E\u0627\u06A9\u0633\u062A\u0631\u06CC \u0622\u0628\u06CC",
    'profile.fontSize.small': "\u06A9\u0648\u0686\u06A9",
    'profile.fontSize.medium': "\u0645\u062A\u0648\u0633\u0637",
    'profile.fontSize.large': "\u0628\u0632\u0631\u06AF",
    'profile.language.fa': "\u0641\u0627\u0631\u0633\u06CC",
    'profile.language.en': 'English',
    'profile.logout': "\u062E\u0631\u0648\u062C \u0627\u0632 \u062D\u0633\u0627\u0628"
};
var $49c0f7f37b3f5886$export$2e2bcd8739ae039 = $49c0f7f37b3f5886$export$4882ae973e0491e;


// The error vocabulary of core.md §14, one key per code.
const $0e1f10edd5ed40a2$export$30f3b02011db23c0 = {
    // ── errors ───────────────────────────────────────────────────────────
    'errors.generic': "\u062E\u0637\u0627\u06CC \u063A\u06CC\u0631\u0645\u0646\u062A\u0638\u0631\u0647\u200C\u0627\u06CC \u0631\u062E \u062F\u0627\u062F.",
    'errors.loadFailed': "\u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F.",
    'errors.saveFailed': "\u0630\u062E\u06CC\u0631\u0647 \u0646\u0634\u062F.",
    'errors.deleteFailed': "\u062D\u0630\u0641 \u0646\u0634\u062F.",
    'errors.invalidInput': "\u0628\u062E\u0634\u06CC \u0627\u0632 \u0645\u0642\u0627\u062F\u06CC\u0631 \u0648\u0627\u0631\u062F\u0634\u062F\u0647 \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A.",
    'errors.insufficientCredits': "\u067E\u0627\u0631\u0633\u0647\u0654 \u06A9\u0627\u0641\u06CC \u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u0639\u0645\u0644\u06CC\u0627\u062A \u0646\u062F\u0627\u0631\u06CC\u062F.",
    'errors.unavailable': "\u0633\u0631\u0648\u06CC\u0633 \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A.",
    'errors.unavailableBody': "\u0633\u0631\u0648\u0631 \u067E\u0627\u0633\u062E \u0646\u062F\u0627\u062F. \u0686\u06CC\u0632\u06CC \u0627\u0632 \u062F\u0633\u062A \u0646\u0631\u0641\u062A\u0647 \u0627\u0633\u062A\u061B \u06A9\u0645\u06CC \u0628\u0639\u062F \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.",
    'errors.notFound': "\u067E\u06CC\u062F\u0627 \u0646\u0634\u062F.",
    'errors.encounterClosed': "\u0627\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A \u0628\u0633\u062A\u0647 \u0634\u062F\u0647 \u0627\u0633\u062A. \u0628\u0631\u0627\u06CC \u062A\u063A\u06CC\u06CC\u0631\u060C \u0622\u0646 \u0631\u0627 \u0628\u0627\u0632\u06AF\u0634\u0627\u06CC\u06CC \u06A9\u0646\u06CC\u062F.",
    'errors.anotherEncounterOpen': "\u0648\u06CC\u0632\u06CC\u062A \u062F\u06CC\u06AF\u0631\u06CC \u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u0628\u06CC\u0645\u0627\u0631 \u0628\u0627\u0632 \u0627\u0633\u062A.",
    'errors.caseArchived': "\u0627\u06CC\u0646 \u0628\u06CC\u0645\u0627\u0631 \u0628\u0627\u06CC\u06AF\u0627\u0646\u06CC \u0634\u062F\u0647 \u0627\u0633\u062A. \u0628\u0631\u0627\u06CC \u0634\u0631\u0648\u0639 \u0648\u06CC\u0632\u06CC\u062A\u060C \u0627\u0632 \u0628\u0627\u06CC\u06AF\u0627\u0646\u06CC \u062E\u0627\u0631\u062C\u0634 \u06A9\u0646\u06CC\u062F.",
    'errors.threadNotFound': "\u0627\u06CC\u0646 \u06AF\u0641\u062A\u06AF\u0648 \u062F\u06CC\u06AF\u0631 \u0648\u062C\u0648\u062F \u0646\u062F\u0627\u0631\u062F.",
    'errors.queryTooComplex': "\u062F\u0631\u062E\u0648\u0627\u0633\u062A \u0628\u06CC\u0634 \u0627\u0632 \u062D\u062F \u0628\u0632\u0631\u06AF \u0628\u0648\u062F. \u0635\u0641\u062D\u0647 \u0631\u0627 \u062F\u0648\u0628\u0627\u0631\u0647 \u0628\u0627\u0632 \u06A9\u0646\u06CC\u062F.",
    'errors.offline': "\u0622\u0641\u0644\u0627\u06CC\u0646 \u0647\u0633\u062A\u06CC\u062F."
};
var $0e1f10edd5ed40a2$export$2e2bcd8739ae039 = $0e1f10edd5ed40a2$export$30f3b02011db23c0;


const $04d49d2d0d0e0cec$export$48a262eaf0aadda2 = {
    ...(0, $8cbe6b749c07aa23$export$919daad019702595),
    ...(0, $0b2899e8f9498f7d$export$80e4b313e5e6b30d),
    ...(0, $f4588d8a9a359f11$export$596d806903d1f59e),
    ...(0, $4a5379b2c5080346$export$66d87fc9a79fcf2d),
    ...(0, $88e3875838382379$export$4a82ecccfc2a9a4a),
    ...(0, $6fdd3abd7668d8a6$export$e5185e241753e543),
    ...(0, $157cbafbf6f9e3de$export$530dccc8e24f4e99),
    ...(0, $36fe6517f24200bd$export$bf638b60ea8b89b7),
    ...(0, $3210032cb0f283bf$export$68c7321cb43cac49),
    ...(0, $49c0f7f37b3f5886$export$4882ae973e0491e),
    ...(0, $0e1f10edd5ed40a2$export$30f3b02011db23c0)
};
var $04d49d2d0d0e0cec$export$2e2bcd8739ae039 = $04d49d2d0d0e0cec$export$48a262eaf0aadda2;


const $2edfa6dc91a2e944$export$19b86c51217a817c = {
    en: $6ecdd4f2fd8400bc$export$84584c2a98eb6753,
    fa: $04d49d2d0d0e0cec$export$48a262eaf0aadda2
};


// Locale-aware formatting.
//
// Every number, date and clock the student reads goes through here. Two rules
// this file exists to enforce:
//
//   1. NOTHING hardcodes Persian digits. The doctor client's `toFa()` habit
//      renders «۱۲» inside an otherwise English UI; `formatNumber` follows the
//      active locale instead.
//   2. Every date formatter pins `timeZone: 'Asia/Tehran'`. The instants on the
//      wire are UTC epochs and the student's day is an Iran day; formatting one
//      in the browser's zone dates a late-night study session to tomorrow for a
//      student abroad and to today at home — the worst kind of bug, because it
//      is right most of the time.
//
// Jalali comes from the locale tag (`-u-ca-persian`), never from an `if`: one
// code path renders both calendars, so they cannot drift.
// The ISO-day shape is imported rather than re-declared: lib/iranTime.js owns
// what "a calendar day on the wire" looks like, and this module has to agree
// with it about which strings get the noon-UTC anchor below.
// Iran local time — the ONE place this client turns an epoch into a calendar day
// or a wall clock.
//
// The platform rule: EPOCH MILLISECONDS on the wire, everywhere, always
// (GraphQL carries them as strings because GraphQL Int is 32-bit, and ~1.7e12
// overflows it — see student-app/docs/SCHEMA.graphql, convention 1). Iran local
// time exists only where a *day boundary* or a *wall clock* is needed: grouping
// a chat transcript into days, and rendering when an entry was written.
//
// This app has no appointments and no day sheet, so the day-shifting helpers
// below are used only by the transcript grouping. They are kept whole rather
// than trimmed because they are the platform's shared definition of "a calendar
// day on the wire", and src/i18n/format.js imports ISO_DATE_RE from here to stay
// in step with it.
//
// Pure and React-free on purpose — tests/iranTime.test.js calls it directly.
// UTC+3:30. Iran abolished DST in 2022, so this is a constant, not a lookup.
// Taken from the framework rather than re-declared: two copies of an offset is
// how a day sheet ends up half an hour wide.

const $6e94fc1378f3a785$export$33df4d54a0f76001 = /^\d{4}-\d{2}-\d{2}$/;
function $6e94fc1378f3a785$export$ceda478235320bf2(nowMs = Date.now()) {
    return new Date(nowMs + (0, $393fa4133562fea6$export$c7153f4b19854938)).toISOString().slice(0, 10);
}
function $6e94fc1378f3a785$export$29d3212020cf53a5(ms) {
    const n = Number(ms);
    if (!Number.isFinite(n) || n <= 0) return '';
    return new Date(n + (0, $393fa4133562fea6$export$c7153f4b19854938)).toISOString().slice(0, 10);
}
function $6e94fc1378f3a785$export$938a2af94a6be3bb(ms) {
    const n = Number(ms);
    if (!Number.isFinite(n) || n <= 0) return '';
    return new Date(n + (0, $393fa4133562fea6$export$c7153f4b19854938)).toISOString().slice(11, 16);
}
function $6e94fc1378f3a785$export$beb979c4570c8eb7(ms) {
    const n = Number(ms);
    if (!Number.isFinite(n) || n <= 0) return null;
    const d = new Date(n + (0, $393fa4133562fea6$export$c7153f4b19854938));
    return d.getUTCHours() * 60 + d.getUTCMinutes();
}
const $6e94fc1378f3a785$export$9bf6380b18b1be8 = (nowMs = Date.now())=>$6e94fc1378f3a785$export$beb979c4570c8eb7(nowMs);
function $6e94fc1378f3a785$export$c13cab26eb520a22(iso, days) {
    if (!$6e94fc1378f3a785$export$33df4d54a0f76001.test(iso || '')) return '';
    const ms = Date.parse(`${iso}T12:00:00Z`) + days * 86400000;
    if (Number.isNaN(ms)) return '';
    return new Date(ms).toISOString().slice(0, 10);
}
function $6e94fc1378f3a785$export$3537fc298e9336da(iso) {
    if (!$6e94fc1378f3a785$export$33df4d54a0f76001.test(iso || '')) return null;
    const ms = Date.parse(`${iso}T12:00:00Z`);
    return Number.isNaN(ms) ? null : ms;
}
function $6e94fc1378f3a785$export$4a79f0068700788b(hhmm) {
    const [h, m] = String(hhmm || '').split(':').map(Number);
    return (h || 0) * 60 + (m || 0);
}


const $c53f9539af19d960$var$INTL_TAG = {
    // arabext = ۰۱۲۳۴۵۶۷۸۹, the digits Persian users read.
    fa: 'fa-IR-u-ca-persian-nu-arabext',
    // English keeps the PERSIAN CALENDAR (core.md §7.9, platform rule): the
    // student's semester, exam and visit dates are Jalaali facts, and switching
    // the interface language changes the words — «تیر» becomes "Tir", the digits
    // become Latin — not the calendar the dates are counted in. en-GB rather than
    // en-US for the day-month order and the 24-hour clock, which match the
    // Persian side. Latin digits are the `en` default; `nu-latn` pins it so a
    // future tag edit cannot inherit the calendar's own numbering.
    en: 'en-GB-u-ca-persian-nu-latn'
};
const $c53f9539af19d960$var$TZ = 'Asia/Tehran';
const $c53f9539af19d960$var$DATE_STYLES = {
    // «شنبه، ۲۶ تیر» / «Sat, 17 Jul»
    weekdayDayMonth: {
        weekday: 'short',
        day: 'numeric',
        month: 'long'
    },
    // «شنبه، ۲۶ تیر ۱۴۰۴» / «Saturday, 17 July 2025»
    full: {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    },
    // «۲۶ تیر» / «17 July»
    dayMonth: {
        day: 'numeric',
        month: 'long'
    },
    // «۱۴۰۴/۰۴/۲۶» / «17/07/2025»
    numeric: {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }
};
/**
 * Accepts an epoch (number or the numeric strings the wire carries) or a plain
 * `YYYY-MM-DD`. A bare date is anchored at noon UTC so no timezone shift can
 * move it onto the neighbouring day.
 */ function $c53f9539af19d960$var$toDate(value) {
    if (value == null || value === '') return null;
    if (typeof value === 'string' && (0, $6e94fc1378f3a785$export$33df4d54a0f76001).test(value)) {
        const ms = Date.parse(`${value}T12:00:00Z`);
        return Number.isNaN(ms) ? null : new Date(ms);
    }
    const n = Number(value);
    if (Number.isFinite(n) && n > 0) return new Date(n);
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? null : new Date(parsed);
}
function $c53f9539af19d960$export$c3f4cd5551df13fd(locale) {
    const tag = $c53f9539af19d960$var$INTL_TAG[locale] || $c53f9539af19d960$var$INTL_TAG.en;
    const number = new Intl.NumberFormat(tag);
    const time = new Intl.DateTimeFormat(tag, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: $c53f9539af19d960$var$TZ
    });
    // `formatToParts` minus the ERA: with a non-Gregorian calendar the English
    // formatter appends «AP» (Anno Persico) to every year — «25/03/1404 AP» — a
    // suffix no Iranian reader has seen on a date and the Persian side never
    // prints. Dropping the part, rather than a regex over the string, keeps the
    // rest of the locale's punctuation exactly as ICU shaped it.
    const withoutEra = (formatter)=>({
            format: (d)=>formatter.formatToParts(d).filter((part)=>part.type !== 'era').map((part)=>part.value).join('').replace(/[\s,]+$/, '')
        });
    const dates = Object.fromEntries(Object.entries($c53f9539af19d960$var$DATE_STYLES).map(([name, opts])=>[
            name,
            withoutEra(new Intl.DateTimeFormat(tag, {
                ...opts,
                timeZone: $c53f9539af19d960$var$TZ
            }))
        ]));
    /** A number in the active locale's digits and grouping. */ const formatNumber = (n)=>Number.isFinite(Number(n)) ? number.format(Number(n)) : '';
    /**
   * Localise the digits inside a string that is NOT a number — a clock («۰۹:۳۰»),
   * a file number, a national id. Grouping separators would corrupt those, which
   * is why this is a different function from formatNumber.
   */ const formatDigits = (s)=>{
        if (s == null) return '';
        const zero = locale === 'fa' ? 0x06F0 : 0x0030;
        return String(s).replace(/\d/g, (d)=>String.fromCharCode(zero + Number(d)));
    };
    const formatDate = (value, style = 'weekdayDayMonth')=>{
        const d = $c53f9539af19d960$var$toDate(value);
        if (!d) return '';
        return (dates[style] || dates.weekdayDayMonth).format(d);
    };
    /** 24-hour, in Iran time, in both languages. A clinic runs on one clock. */ const formatTime = (value)=>{
        const d = $c53f9539af19d960$var$toDate(value);
        return d ? time.format(d) : '';
    };
    return {
        formatNumber: formatNumber,
        formatDigits: formatDigits,
        formatDate: formatDate,
        formatTime: formatTime
    };
}


// The translator. Pure — tests call it directly.
//
// Resolution order: active locale → the EN source catalogue → the key itself.
// A visible key in the UI is a louder defect signal than silent empty text, and
// the catalogue-parity test (tests/i18n.test.js) is what stops it reaching a
// student.
//
// Interpolation is `{{name}}` and nothing else. A NUMBER value is routed through
// the active locale's number formatter, so «۳ مورد» in Persian and «3 items» in
// English come from the same call and no screen has to remember to localise a
// count. Pass a STRING to opt out — a year, a gift code, a formulary slug.
//
// Markup interpolation is deliberately impossible: a catalogue that can inject
// elements is a catalogue that can inject an unreviewed layout.
const $56c2db411f2e97f5$var$TOKEN = /\{\{(\w+)\}\}/g;
function $56c2db411f2e97f5$export$89e29e4ab65e70a9(template, vars, formatNumber) {
    if (!vars) return template;
    return String(template).replace($56c2db411f2e97f5$var$TOKEN, (match, name)=>{
        if (!(name in vars)) return match;
        const value = vars[name];
        if (typeof value === 'number') return formatNumber ? formatNumber(value) : String(value);
        return value == null ? '' : String(value);
    });
}
function $56c2db411f2e97f5$export$6f3122ee6dbd9f46({ catalogs: catalogs, fallback: fallback, locale: locale, formatNumber: formatNumber }) {
    const active = catalogs[locale] || {};
    const t = (key, vars)=>{
        const template = active[key] ?? fallback[key] ?? key;
        return $56c2db411f2e97f5$export$89e29e4ab65e70a9(template, vars, formatNumber);
    };
    /** For copy that is genuinely optional — render the element only if it exists. */ t.has = (key)=>key in active || key in fallback;
    return t;
}


const $a278322405d51c25$var$I18nContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
const $a278322405d51c25$export$ddb338179359cccc = {
    transform: 'scaleX(var(--dir-flip, 1))'
};
const $a278322405d51c25$export$3433559efc22d110 = {
    dir: 'ltr',
    style: {
        unicodeBidi: 'isolate'
    }
};
function $a278322405d51c25$export$a54013f0d02a8f82({ children: children }) {
    const [locale, setLocaleState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $94f36eaf2deb686d$export$df9bcabe7f932e01)(typeof localStorage !== 'undefined' ? localStorage : null, typeof navigator !== 'undefined' ? navigator.languages?.length ? navigator.languages : [
            navigator.language
        ] : []));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        document.documentElement.setAttribute('lang', locale);
        document.documentElement.setAttribute('dir', (0, $94f36eaf2deb686d$export$4c4b683c586ca56e)[locale]);
    }, [
        locale
    ]);
    const setLocale = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((next)=>{
        if (!(0, $94f36eaf2deb686d$export$4c4b683c586ca56e)[next]) return;
        try {
            localStorage.setItem((0, $94f36eaf2deb686d$export$86880b4b2e1a2384), next);
        } catch  {
        /* storage off */ }
        setLocaleState(next);
    }, []);
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const formatters = (0, $c53f9539af19d960$export$c3f4cd5551df13fd)(locale);
        return {
            locale: locale,
            dir: (0, $94f36eaf2deb686d$export$4c4b683c586ca56e)[locale],
            isRTL: (0, $94f36eaf2deb686d$export$4c4b683c586ca56e)[locale] === 'rtl',
            setLocale: setLocale,
            t: (0, $56c2db411f2e97f5$export$6f3122ee6dbd9f46)({
                catalogs: $2edfa6dc91a2e944$export$19b86c51217a817c,
                fallback: (0, $6ecdd4f2fd8400bc$export$84584c2a98eb6753),
                locale: locale,
                formatNumber: formatters.formatNumber
            }),
            ...formatters
        };
    }, [
        locale,
        setLocale
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a278322405d51c25$var$I18nContext.Provider, {
        value: value,
        children: children
    });
}
// A fallback value for anything rendered outside the provider (a test, an error
// boundary that mounted above it). It reports English and formats with English
// rules rather than throwing: "no translations" must never be the reason a
// screen fails to render.
let $a278322405d51c25$var$orphan = null;
function $a278322405d51c25$var$orphanValue() {
    if (!$a278322405d51c25$var$orphan) {
        const formatters = (0, $c53f9539af19d960$export$c3f4cd5551df13fd)('en');
        $a278322405d51c25$var$orphan = {
            locale: 'en',
            dir: 'ltr',
            isRTL: false,
            setLocale: ()=>{},
            t: (0, $56c2db411f2e97f5$export$6f3122ee6dbd9f46)({
                catalogs: $2edfa6dc91a2e944$export$19b86c51217a817c,
                fallback: (0, $6ecdd4f2fd8400bc$export$84584c2a98eb6753),
                locale: 'en',
                formatNumber: formatters.formatNumber
            }),
            ...formatters
        };
    }
    return $a278322405d51c25$var$orphan;
}
function $a278322405d51c25$export$9fc83ad70ead8663() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($a278322405d51c25$var$I18nContext) ?? $a278322405d51c25$var$orphanValue();
}


// OIDC Authorization Code + PKCE flow for Keycloak

const $3bdb28763df76ec7$var$KC_BASE = `${(0, $d87bd335296b449f$export$91dbb4a8660769db)}/realms/parsina`;
// The OIDC client id, baked in at BUILD time by the Dockerfile ARG
// (`PARSINA_KC_CLIENT_ID=parsina-student`). Parcel inlines `process.env.*`, so
// this is NOT reachable through window.__ENV__ and is deliberately not routed
// through runtimeEnv.js like BFF_URL is.
//
// The fallback is `parsina-student`, NOT the `parsina-web` the doctor, clinic
// and dentist clients default to. That is the one difference in this file and
// it is load-bearing: `parsina-web` is shared by the doctor and clinic panels,
// so a token minted for it opens doctor.parsinabot.ir. The audience separation
// IS this app's audience separation (core.md §1.4) — a build that silently fell
// back to the shared client would hand every student a doctor's token.
const $3bdb28763df76ec7$var$CLIENT_ID = "parsina-student";
// Always derived at call time so redirect_uri is consistent across
// the auth request and token exchange even if the page reloads.
function $3bdb28763df76ec7$var$getRedirectUri() {
    return `${window.location.origin}/`;
}
// ── PKCE helpers ─────────────────────────────────────────────────────────────
function $3bdb28763df76ec7$var$randomBytes(len) {
    const arr = new Uint8Array(len);
    crypto.getRandomValues(arr);
    return arr;
}
function $3bdb28763df76ec7$var$base64url(buf) {
    return btoa(String.fromCharCode(...buf)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
async function $3bdb28763df76ec7$var$sha256(str) {
    const enc = new TextEncoder().encode(str);
    const buf = await crypto.subtle.digest('SHA-256', enc);
    return new Uint8Array(buf);
}
async function $3bdb28763df76ec7$var$generateChallenge(verifier) {
    return $3bdb28763df76ec7$var$base64url(await $3bdb28763df76ec7$var$sha256(verifier));
}
function $3bdb28763df76ec7$export$257b2d10b709d8ef() {
    return sessionStorage.getItem('kc_token');
}
function $3bdb28763df76ec7$export$c8736e6c4fef498e() {
    return sessionStorage.getItem('kc_refresh');
}
function $3bdb28763df76ec7$export$393ade1005606e67() {
    return sessionStorage.getItem('kc_id_token');
}
function $3bdb28763df76ec7$var$saveTokens(token, refresh, idToken) {
    sessionStorage.setItem('kc_token', token);
    if (refresh) sessionStorage.setItem('kc_refresh', refresh);
    if (idToken) sessionStorage.setItem('kc_id_token', idToken);
}
function $3bdb28763df76ec7$export$67488bf92fa15f1e() {
    [
        'kc_token',
        'kc_refresh',
        'kc_id_token',
        'kc_verifier',
        'kc_state'
    ].forEach((k)=>sessionStorage.removeItem(k));
}
// ── Redirect-loop guard ───────────────────────────────────────────────────────
// Records each redirect timestamp. If 3+ happen within 30 s, stops redirecting
// and lets the app render an error screen instead.
const $3bdb28763df76ec7$var$LOOP_KEY = 'kc_redirect_ts';
const $3bdb28763df76ec7$var$LOOP_LIMIT = 3;
const $3bdb28763df76ec7$var$LOOP_WIN = 30000; // ms
function $3bdb28763df76ec7$var$redirectAllowed() {
    const raw = sessionStorage.getItem($3bdb28763df76ec7$var$LOOP_KEY);
    const hist = raw ? JSON.parse(raw) : [];
    const now = Date.now();
    const recent = hist.filter((ts)=>now - ts < $3bdb28763df76ec7$var$LOOP_WIN);
    if (recent.length >= $3bdb28763df76ec7$var$LOOP_LIMIT) return false;
    sessionStorage.setItem($3bdb28763df76ec7$var$LOOP_KEY, JSON.stringify([
        ...recent,
        now
    ]));
    return true;
}
function $3bdb28763df76ec7$export$639ddbdf19445d0c() {
    sessionStorage.removeItem($3bdb28763df76ec7$var$LOOP_KEY);
}
async function $3bdb28763df76ec7$export$2fb87bbf5418dbe1() {
    if (!$3bdb28763df76ec7$var$redirectAllowed()) {
        // Too many consecutive redirects — surface the error to the user instead.
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        window.history.replaceState({}, '', '/?auth_error=loop');
        window.location.reload();
        return;
    }
    const verifier = $3bdb28763df76ec7$var$base64url($3bdb28763df76ec7$var$randomBytes(32));
    const challenge = await $3bdb28763df76ec7$var$generateChallenge(verifier);
    const state = $3bdb28763df76ec7$var$base64url($3bdb28763df76ec7$var$randomBytes(16));
    sessionStorage.setItem('kc_verifier', verifier);
    sessionStorage.setItem('kc_state', state);
    const params = new URLSearchParams({
        response_type: 'code',
        client_id: $3bdb28763df76ec7$var$CLIENT_ID,
        redirect_uri: $3bdb28763df76ec7$var$getRedirectUri(),
        scope: 'openid profile email',
        state: state,
        code_challenge: challenge,
        code_challenge_method: 'S256'
    });
    window.location.href = `${$3bdb28763df76ec7$var$KC_BASE}/protocol/openid-connect/auth?${params}`;
}
async function $3bdb28763df76ec7$export$3f98f56b6bff7d36() {
    try {
        return Boolean(await $3bdb28763df76ec7$export$f8f36faf9a051362());
    } catch (err) {
        console.warn('[auth] post-onboarding refresh failed:', err?.message);
        return false;
    }
}
const $3bdb28763df76ec7$export$76e84192bcf6ce29 = 'bad_redirect';
let $3bdb28763df76ec7$var$lastCallbackError = null;
function $3bdb28763df76ec7$export$2f5bc3e42c1f6d5a() {
    const reason = $3bdb28763df76ec7$var$lastCallbackError;
    $3bdb28763df76ec7$var$lastCallbackError = null;
    return reason;
}
const $3bdb28763df76ec7$export$e1521dfb2c5dd8bd = (error, description)=>error === 'invalid_redirect_uri' || /invalid_redirect_uri|redirect[_ ]uri/i.test(String(description || ''));
async function $3bdb28763df76ec7$export$f8ec4f1dc49ac9b7() {
    const params = new URLSearchParams(window.location.search);
    const error = params.get('error');
    const code = params.get('code');
    const state = params.get('state');
    const verifier = sessionStorage.getItem('kc_verifier');
    const saved = sessionStorage.getItem('kc_state');
    $3bdb28763df76ec7$var$lastCallbackError = null;
    console.log('[handleCallback] error:', error, '| hasCode:', !!code, '| stateMatch:', state === saved, '| hasVerifier:', !!verifier);
    // Keycloak returned an explicit error (access_denied, login_required, etc.)
    if (error) {
        const description = params.get('error_description');
        console.warn('[handleCallback] KC returned error:', error, description);
        if ($3bdb28763df76ec7$export$e1521dfb2c5dd8bd(error, description)) $3bdb28763df76ec7$var$lastCallbackError = $3bdb28763df76ec7$export$76e84192bcf6ce29;
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        window.history.replaceState({}, '', '/');
        return false;
    }
    // Missing or mismatched PKCE / state — don't retry immediately
    if (!code || !verifier || state !== saved) {
        console.warn("[handleCallback] missing code/verifier or state mismatch \u2014 aborting");
        window.history.replaceState({}, '', '/');
        return false;
    }
    const res = await fetch(`${$3bdb28763df76ec7$var$KC_BASE}/protocol/openid-connect/token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
            grant_type: 'authorization_code',
            client_id: $3bdb28763df76ec7$var$CLIENT_ID,
            redirect_uri: $3bdb28763df76ec7$var$getRedirectUri(),
            code: code,
            code_verifier: verifier
        })
    });
    window.history.replaceState({}, '', '/');
    if (!res.ok) {
        console.error('[handleCallback] token exchange failed:', res.status, await res.text());
        return false;
    }
    const data = await res.json();
    if (!data.access_token) {
        // The FIELDS, never the payload: a token-endpoint response is the one body
        // in this app that can carry a bearer credential, and the browser console
        // is readable by any script on the page and by every support screenshot.
        console.error('[handleCallback] no access_token in response. keys:', Object.keys(data || {}).join(','), '| error:', data?.error, data?.error_description);
        return false;
    }
    // Log roles from new token
    try {
        const claims = JSON.parse(atob(data.access_token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        // `student` may or may not be here: v2 gates on the onboarded PROFILE, not
        // the role (core.md §4.2). There is no clinic_id on a student token.
        const roles = claims?.resource_access?.['parsina-bff']?.roles || [];
        console.log('[handleCallback] new token roles:', roles, '| sub:', claims?.sub);
    } catch  {}
    $3bdb28763df76ec7$var$saveTokens(data.access_token, data.refresh_token, data.id_token);
    $3bdb28763df76ec7$export$639ddbdf19445d0c();
    console.log('[handleCallback] tokens saved successfully');
    return true;
}
// Concurrent refresh, deduplicated.
//
// Reads fire in parallel on every screen — the case workspace issues the case,
// its history and its chat threads together, and the layout adds
// `studentProfile` + `myWalletBalance` on top. When the access token has expired
// they ALL reach getValidToken() at the same moment and each calls this with the
// SAME refresh token.
//
// That is a race with a session-ending outcome: Keycloak rotates refresh
// tokens, and with «Revoke Refresh Token» enabled the second presentation of
// one is `invalid_grant` — so the loser's `clearTokens()` below wipes the
// tokens the winner had just saved, and the next request finds no token and
// bounces to login. Even without revocation the two `saveTokens()` calls race
// and the older pair can land last.
//
// One in-flight promise shared by every caller removes the race in every realm
// configuration and costs one round trip instead of N. The exported signature
// is unchanged: still a Promise<boolean>.
let $3bdb28763df76ec7$var$refreshInFlight = null;
function $3bdb28763df76ec7$export$f8f36faf9a051362() {
    if ($3bdb28763df76ec7$var$refreshInFlight) return $3bdb28763df76ec7$var$refreshInFlight;
    // `.finally` passes the resolution value through, so callers still receive
    // the boolean; the slot is cleared either way so a later expiry can retry.
    $3bdb28763df76ec7$var$refreshInFlight = $3bdb28763df76ec7$var$performRefresh().finally(()=>{
        $3bdb28763df76ec7$var$refreshInFlight = null;
    });
    return $3bdb28763df76ec7$var$refreshInFlight;
}
async function $3bdb28763df76ec7$var$performRefresh() {
    const refresh = $3bdb28763df76ec7$export$c8736e6c4fef498e();
    if (!refresh) return false;
    const res = await fetch(`${$3bdb28763df76ec7$var$KC_BASE}/protocol/openid-connect/token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
            grant_type: 'refresh_token',
            client_id: $3bdb28763df76ec7$var$CLIENT_ID,
            refresh_token: refresh
        })
    });
    if (!res.ok) {
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        return false;
    }
    const data = await res.json();
    if (!data.access_token) {
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        return false;
    }
    $3bdb28763df76ec7$var$saveTokens(data.access_token, data.refresh_token, data.id_token);
    return true;
}
function $3bdb28763df76ec7$export$a0973bcfe11b05c9() {
    const idToken = $3bdb28763df76ec7$export$393ade1005606e67();
    $3bdb28763df76ec7$export$67488bf92fa15f1e();
    $3bdb28763df76ec7$export$639ddbdf19445d0c();
    const params = new URLSearchParams({
        client_id: $3bdb28763df76ec7$var$CLIENT_ID,
        post_logout_redirect_uri: $3bdb28763df76ec7$var$getRedirectUri()
    });
    if (idToken) params.set('id_token_hint', idToken);
    window.location.href = `${$3bdb28763df76ec7$var$KC_BASE}/protocol/openid-connect/logout?${params}`;
}
function $3bdb28763df76ec7$export$83cd1f1503eb19c0(token) {
    try {
        const b64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const bytes = Uint8Array.from(atob(b64), (c)=>c.charCodeAt(0));
        return JSON.parse(new TextDecoder().decode(bytes));
    } catch  {
        return null;
    }
}
function $3bdb28763df76ec7$export$b007d77a962aa175(token) {
    const p = $3bdb28763df76ec7$export$83cd1f1503eb19c0(token);
    if (!p) return true;
    return Date.now() >= p.exp * 1000 - 30000; // 30 s buffer
}


// The one way this client talks to parsina.bff.student.
//
// A single fetch wrapper is the whole data layer: attach the Keycloak access
// token, refresh once on a 401 and retry, and surface GraphQL errors WITH their
// `extensions` intact. There is no Apollo Client and no normalized cache — every
// AI field in the schema is a MUTATION precisely because re-issuing it on a
// refetch or a window focus would spend the student's money again.
//
// ── The error vocabulary (core.md §14) ────────────────────────────────────
//
// The BFF's whole language is `extensions.code`, and several codes change what a
// screen DOES rather than what it says:
//
//   UNAUTHENTICATED         → the session is over: raise the session dialog
//                             (core.md §15), never a full-document redirect
//                             from inside a fetch — that unmounts unsaved work
//   NOT_ONBOARDED           → a verified token with no student profile: the boot
//                             shows the onboarding form
//   ENCOUNTER_ALREADY_OPEN  → `extensions.encounterId`: navigate to it instead of
//                             erroring
//   INSUFFICIENT_CREDITS    → the AI refused for lack of پارسه: recover to
//                             «شارژ پارسه», never to a retry
//   INVALID_INPUT           → `extensions.field` names the field
//   SERVICE_UNAVAILABLE     → a downstream is down (and the gate fails closed)
//
// Throwing on `res.status` alone would drop all of them.



const $d4d7a25942cf3f48$export$3b6ed64b5b4e542d = {
    EXPIRING: 'expiring',
    EXPIRED: 'expired',
    // A request came back `NOT_ONBOARDED` mid-session: the profile this app
    // booted on is gone (deleted from another tab, or a store restored from
    // before it existed). Not a session event in the token sense — the token is
    // fine — but it rides the same bus because it has the same shape: something
    // outside the router has to take over, and the fetch wrapper must not
    // navigate. App.jsx re-runs the boot query and lets the onboarding screen
    // replace the router (core.md §4.4). `SessionDialog` ignores it.
    NOT_ONBOARDED: 'not_onboarded'
};
const $d4d7a25942cf3f48$export$a10a125b4e7d71f8 = (event)=>event === $d4d7a25942cf3f48$export$3b6ed64b5b4e542d.EXPIRING || event === $d4d7a25942cf3f48$export$3b6ed64b5b4e542d.EXPIRED;
const $d4d7a25942cf3f48$export$9a8e643ece3bd90e = 120000;
// setTimeout wraps above 2^31-1 ms and fires IMMEDIATELY; a Keycloak SSO session
// can be days long.
const $d4d7a25942cf3f48$var$MAX_TIMEOUT_MS = 2147483647;
const $d4d7a25942cf3f48$var$listeners = new Set();
function $d4d7a25942cf3f48$export$a883a9af61079ac7(listener) {
    $d4d7a25942cf3f48$var$listeners.add(listener);
    return ()=>$d4d7a25942cf3f48$var$listeners.delete(listener);
}
function $d4d7a25942cf3f48$export$c21f8c101d467dce(event) {
    for (const listener of $d4d7a25942cf3f48$var$listeners)try {
        listener(event);
    } catch  {}
}
function $d4d7a25942cf3f48$export$4a79209357ec4bed() {
    $d4d7a25942cf3f48$var$listeners.clear();
}
// ── Returning the student to where they were ─────────────────────────────
const $d4d7a25942cf3f48$var$RETURN_KEY = 'return_to';
function $d4d7a25942cf3f48$export$4986ea797be155b1(path) {
    const value = path ?? (typeof window !== 'undefined' ? `${window.location.pathname}${window.location.search}` : '');
    try {
        // Only in-app paths — an absolute URL would be a redirect parameter.
        if (typeof value === 'string' && value.startsWith('/') && !value.startsWith('//')) sessionStorage.setItem($d4d7a25942cf3f48$var$RETURN_KEY, value);
    } catch  {}
}
function $d4d7a25942cf3f48$export$e5c839e26770d4ca() {
    try {
        const path = sessionStorage.getItem($d4d7a25942cf3f48$var$RETURN_KEY);
        sessionStorage.removeItem($d4d7a25942cf3f48$var$RETURN_KEY);
        return path && path.startsWith('/') && !path.startsWith('//') ? path : null;
    } catch  {
        return null;
    }
}
function $d4d7a25942cf3f48$export$2d1c01c0322daf36() {
    const refresh = (0, $3bdb28763df76ec7$export$c8736e6c4fef498e)();
    if (!refresh) return null;
    const payload = (0, $3bdb28763df76ec7$export$83cd1f1503eb19c0)(refresh);
    // Offline tokens carry exp: 0 = "does not expire".
    if (!payload?.exp) return null;
    return payload.exp * 1000;
}
function $d4d7a25942cf3f48$export$73946e6b8a04196b({ emit: emit = $d4d7a25942cf3f48$export$c21f8c101d467dce, now: now = ()=>Date.now() } = {}) {
    let warnTimer = null;
    let endTimer = null;
    let cancelled = false;
    const clear = ()=>{
        clearTimeout(warnTimer);
        clearTimeout(endTimer);
        warnTimer = null;
        endTimer = null;
    };
    const arm = ()=>{
        clear();
        if (cancelled) return;
        const expiry = $d4d7a25942cf3f48$export$2d1c01c0322daf36();
        if (!expiry) return;
        const remaining = expiry - now();
        if (remaining <= 0) {
            emit($d4d7a25942cf3f48$export$3b6ed64b5b4e542d.EXPIRED);
            return;
        }
        const untilWarning = remaining - $d4d7a25942cf3f48$export$9a8e643ece3bd90e;
        if (untilWarning > 0) warnTimer = setTimeout(()=>emit($d4d7a25942cf3f48$export$3b6ed64b5b4e542d.EXPIRING), Math.min(untilWarning, $d4d7a25942cf3f48$var$MAX_TIMEOUT_MS));
        else emit($d4d7a25942cf3f48$export$3b6ed64b5b4e542d.EXPIRING);
        endTimer = setTimeout(()=>emit($d4d7a25942cf3f48$export$3b6ed64b5b4e542d.EXPIRED), Math.min(remaining, $d4d7a25942cf3f48$var$MAX_TIMEOUT_MS));
    };
    arm();
    return {
        rearm: arm,
        cancel: ()=>{
            cancelled = true;
            clear();
        }
    };
}
async function $d4d7a25942cf3f48$export$d0caa90bfa1dd141() {
    const ok = await (0, $3bdb28763df76ec7$export$f8f36faf9a051362)().catch(()=>false);
    return Boolean(ok);
}


const $206625c7d33bd390$export$28ba0a5263dd89b0 = Object.freeze({
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    NOT_ONBOARDED: 'NOT_ONBOARDED',
    QUERY_TOO_COMPLEX: 'QUERY_TOO_COMPLEX',
    INVALID_INPUT: 'INVALID_INPUT',
    CASE_NOT_FOUND: 'CASE_NOT_FOUND',
    ENTRY_NOT_FOUND: 'ENTRY_NOT_FOUND',
    ENCOUNTER_NOT_FOUND: 'ENCOUNTER_NOT_FOUND',
    DIAGNOSIS_NOT_FOUND: 'DIAGNOSIS_NOT_FOUND',
    RX_ITEM_NOT_FOUND: 'RX_ITEM_NOT_FOUND',
    ORDER_NOT_FOUND: 'ORDER_NOT_FOUND',
    THREAD_NOT_FOUND: 'THREAD_NOT_FOUND',
    ENCOUNTER_ALREADY_OPEN: 'ENCOUNTER_ALREADY_OPEN',
    ENCOUNTER_CLOSED: 'ENCOUNTER_CLOSED',
    ANOTHER_ENCOUNTER_OPEN: 'ANOTHER_ENCOUNTER_OPEN',
    CASE_ARCHIVED: 'CASE_ARCHIVED',
    INSUFFICIENT_CREDITS: 'INSUFFICIENT_CREDITS',
    GIFT_NOT_FOUND: 'GIFT_NOT_FOUND',
    GIFT_NOT_USABLE: 'GIFT_NOT_USABLE',
    GIFT_GRANT_FAILED: 'GIFT_GRANT_FAILED',
    SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
    // Client-side only: fetch itself threw (no network, DNS, CORS).
    NETWORK: 'NETWORK'
});
async function $206625c7d33bd390$var$getValidToken() {
    let token = (0, $3bdb28763df76ec7$export$257b2d10b709d8ef)();
    if (!token) return null;
    if ((0, $3bdb28763df76ec7$export$b007d77a962aa175)(token)) {
        const ok = await (0, $3bdb28763df76ec7$export$f8f36faf9a051362)();
        if (!ok) return null;
        token = (0, $3bdb28763df76ec7$export$257b2d10b709d8ef)();
    }
    return token;
}
async function $206625c7d33bd390$var$executeRequest(token, query, variables) {
    return fetch((0, $d87bd335296b449f$export$bb117bdb9f34de64), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
            query: query,
            variables: variables
        })
    });
}
/** Build the Error a caller sees. Keeps `status`, `extensions` and the full list. */ function $206625c7d33bd390$var$buildError(body, status) {
    const gqlError = body?.errors?.[0];
    const err = new Error(gqlError?.message || `BFF error: ${status}`);
    if (status) err.status = status;
    if (gqlError?.extensions) err.extensions = gqlError.extensions;
    if (body?.errors) err.graphQLErrors = body.errors;
    return err;
}
function $206625c7d33bd390$var$sessionOver() {
    (0, $d4d7a25942cf3f48$export$c21f8c101d467dce)((0, $d4d7a25942cf3f48$export$3b6ed64b5b4e542d).EXPIRED);
    const err = new Error('Not authenticated');
    err.status = 401;
    err.extensions = {
        code: $206625c7d33bd390$export$28ba0a5263dd89b0.UNAUTHENTICATED
    };
    return err;
}
function $206625c7d33bd390$var$networkError(cause) {
    const err = new Error(cause?.message || 'Network error');
    err.extensions = {
        code: $206625c7d33bd390$export$28ba0a5263dd89b0.NETWORK
    };
    err.cause = cause;
    return err;
}
async function $206625c7d33bd390$var$bffRequest(query, variables = {}) {
    const token = await $206625c7d33bd390$var$getValidToken();
    // No token: the session is OVER, and that is an event the shell handles with a
    // dialog — never a navigation from here, which would unmount unsaved work.
    if (!token) throw $206625c7d33bd390$var$sessionOver();
    let res;
    try {
        res = await $206625c7d33bd390$var$executeRequest(token, query, variables);
    } catch (cause) {
        throw $206625c7d33bd390$var$networkError(cause);
    }
    // A 401 can also mean server-side expiry or clock skew — refresh once and retry.
    if (res.status === 401) {
        const refreshed = await (0, $3bdb28763df76ec7$export$f8f36faf9a051362)();
        if (!refreshed) throw $206625c7d33bd390$var$sessionOver();
        try {
            res = await $206625c7d33bd390$var$executeRequest((0, $3bdb28763df76ec7$export$257b2d10b709d8ef)(), query, variables);
        } catch (cause) {
            throw $206625c7d33bd390$var$networkError(cause);
        }
        if (res.status === 401) throw $206625c7d33bd390$var$sessionOver();
    }
    if (!res.ok) {
        // Apollo sends a normal GraphQL error payload beside a non-2xx status; the
        // code is the only thing that tells 403 NOT_ONBOARDED from 503.
        const body = await res.json().catch(()=>null);
        throw $206625c7d33bd390$var$buildError(body, res.status);
    }
    const { data: data, errors: errors } = await res.json();
    // A 200 carrying `errors` is the FIELD-level half. Anything the caller must
    // branch on (CASE_NOT_FOUND, INSUFFICIENT_CREDITS, ENCOUNTER_ALREADY_OPEN)
    // arrives this way, so it has to throw with the code.
    if (errors?.length) throw $206625c7d33bd390$var$buildError({
        errors: errors
    });
    return data;
}
const $206625c7d33bd390$export$dbfe74f291058e97 = (err)=>err?.extensions?.code || null;
const $206625c7d33bd390$export$abf870288a102319 = (err)=>err?.extensions?.field || null;
const $206625c7d33bd390$export$51746a26c94c297f = (err)=>$206625c7d33bd390$export$dbfe74f291058e97(err) === $206625c7d33bd390$export$28ba0a5263dd89b0.INSUFFICIENT_CREDITS;
const $206625c7d33bd390$export$cb241bc722a47234 = (err)=>$206625c7d33bd390$export$dbfe74f291058e97(err) === $206625c7d33bd390$export$28ba0a5263dd89b0.NOT_ONBOARDED;
const $206625c7d33bd390$export$1724ecfee73c4768 = (err)=>$206625c7d33bd390$export$dbfe74f291058e97(err) === $206625c7d33bd390$export$28ba0a5263dd89b0.UNAUTHENTICATED || err?.status === 401;
const $206625c7d33bd390$export$25c5ef030dd0e68e = (err)=>$206625c7d33bd390$export$dbfe74f291058e97(err) === $206625c7d33bd390$export$28ba0a5263dd89b0.SERVICE_UNAVAILABLE || $206625c7d33bd390$export$dbfe74f291058e97(err) === $206625c7d33bd390$export$28ba0a5263dd89b0.NETWORK || err?.status === 503;
const $206625c7d33bd390$export$3d6af2ad46593459 = (err)=>$206625c7d33bd390$export$dbfe74f291058e97(err) === $206625c7d33bd390$export$28ba0a5263dd89b0.ENCOUNTER_ALREADY_OPEN ? err?.extensions?.encounterId || null : null;
const $206625c7d33bd390$export$5ceecc1876a33e64 = (err)=>/_NOT_FOUND$/.test($206625c7d33bd390$export$dbfe74f291058e97(err) || '');
function $206625c7d33bd390$export$660244d64183d198(err) {
    switch($206625c7d33bd390$export$dbfe74f291058e97(err)){
        case $206625c7d33bd390$export$28ba0a5263dd89b0.INSUFFICIENT_CREDITS:
            return 'errors.insufficientCredits';
        case $206625c7d33bd390$export$28ba0a5263dd89b0.INVALID_INPUT:
            return 'errors.invalidInput';
        case $206625c7d33bd390$export$28ba0a5263dd89b0.SERVICE_UNAVAILABLE:
        case $206625c7d33bd390$export$28ba0a5263dd89b0.NETWORK:
            return 'errors.unavailable';
        case $206625c7d33bd390$export$28ba0a5263dd89b0.ENCOUNTER_CLOSED:
            return 'errors.encounterClosed';
        case $206625c7d33bd390$export$28ba0a5263dd89b0.ANOTHER_ENCOUNTER_OPEN:
            return 'errors.anotherEncounterOpen';
        case $206625c7d33bd390$export$28ba0a5263dd89b0.CASE_ARCHIVED:
            return 'errors.caseArchived';
        case $206625c7d33bd390$export$28ba0a5263dd89b0.THREAD_NOT_FOUND:
            return 'errors.threadNotFound';
        case $206625c7d33bd390$export$28ba0a5263dd89b0.QUERY_TOO_COMPLEX:
            return 'errors.queryTooComplex';
        default:
            return $206625c7d33bd390$export$5ceecc1876a33e64(err) ? 'errors.notFound' : 'errors.generic';
    }
}
const $206625c7d33bd390$export$7fb4864174f056c = $206625c7d33bd390$var$bffRequest;
const $206625c7d33bd390$export$8395d0fc0d822a81 = $206625c7d33bd390$var$bffRequest;



// Keyboard shortcuts — the central registry. core.md §7.0 / §7.5.
//
// Everything registers HERE, once, through `useShortcut`. Screens never attach
// their own `window.addEventListener` for a key: two screens binding the same
// key independently is invisible until they are mounted together, and a key
// nobody can enumerate is a key nobody discovers — the `?` overlay can only list
// what the registry knows.
//
// Global bindings (App.jsx): `Ctrl/⌘+K` focuses the patient search on
// `/patients`, `?` opens the help overlay, `Esc` closes any sheet. The visit
// workspace registers its own (`Ctrl+S`, `Ctrl+1..4`, `Ctrl+Enter`,
// `Ctrl+Shift+E`) while it is mounted, and hands them back when it unmounts.
//
// Precedence is last-registered-wins, so a modal that registers `esc` shadows
// the screen underneath it for as long as it is mounted.
//
// This file is pure React (no JSX) so it stays a `.js`; the overlay that lists
// the bindings is `src/components/common/ShortcutHelp.jsx`.

var $acw62 = parcelRequire("acw62");
const $0277e73c10ea225a$var$RegistryCtx = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $0277e73c10ea225a$var$HelpCtx = /*#__PURE__*/ (0, $acw62.createContext)(null);
let $0277e73c10ea225a$var$SEQ = 0;
const $0277e73c10ea225a$var$FKEY = /^f([1-9]|1[0-2])$/;
const $0277e73c10ea225a$export$491029574d911e8 = (raw)=>{
    const parts = String(raw || '').toLowerCase().split('+').map((s)=>s.trim()).filter(Boolean);
    let key = '';
    const mods = new Set();
    for (const p of parts){
        if (p === 'ctrl' || p === 'cmd' || p === 'meta') mods.add('ctrl');
        else if (p === 'alt' || p === 'option') mods.add('alt');
        else if (p === 'shift') mods.add('shift');
        else key = p === 'escape' ? 'esc' : p;
    }
    if (!key) return '';
    const out = [];
    if (mods.has('ctrl')) out.push('ctrl');
    if (mods.has('alt')) out.push('alt');
    if (mods.has('shift')) out.push('shift');
    out.push(key);
    return out.join('+');
};
const $0277e73c10ea225a$var$LETTER = /^[a-z]$/;
const $0277e73c10ea225a$var$CODE_LETTER = /^Key([A-Z])$/;
const $0277e73c10ea225a$var$CODE_DIGIT = /^Digit([0-9])$/;
const $0277e73c10ea225a$export$fec7a04f3f2b43c1 = (e)=>{
    let key = e?.key;
    if (!key) return '';
    key = key === 'Escape' ? 'esc' : key === ' ' ? 'space' : key.toLowerCase();
    const modified = e.ctrlKey || e.metaKey || e.altKey;
    if (modified && key.length === 1 && key.charCodeAt(0) > 127) {
        const letter = $0277e73c10ea225a$var$CODE_LETTER.exec(e.code || '');
        const digit = $0277e73c10ea225a$var$CODE_DIGIT.exec(e.code || '');
        if (letter) key = letter[1].toLowerCase();
        else if (digit) key = digit[1];
    }
    const out = [];
    if (e.ctrlKey || e.metaKey) out.push('ctrl');
    if (e.altKey) out.push('alt');
    if (e.shiftKey && (key.length > 1 || $0277e73c10ea225a$var$LETTER.test(key))) out.push('shift');
    out.push(key);
    return out.join('+');
};
const $0277e73c10ea225a$export$763c4b15adcf804b = (el)=>{
    if (!el || !el.tagName) return false;
    const tag = el.tagName.toUpperCase();
    return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable === true;
};
const $0277e73c10ea225a$export$570b40aed3a24e82 = (combo)=>{
    const key = combo.split('+').pop();
    return combo.includes('ctrl+') || combo.includes('alt+') || key === 'esc' || $0277e73c10ea225a$var$FKEY.test(key);
};
const $0277e73c10ea225a$var$CAP = {
    ctrl: 'Ctrl',
    alt: 'Alt',
    shift: 'Shift',
    esc: 'Esc',
    space: 'Space',
    enter: 'Enter'
};
const $0277e73c10ea225a$export$f5026c738b75de96 = (combo)=>combo.split('+').map((p)=>$0277e73c10ea225a$var$CAP[p] || p.toUpperCase()).join(' + ');
function $0277e73c10ea225a$export$87dd7790e69558a9({ children: children }) {
    // A ref, not state: registering must not re-render the tree that is registering.
    const regs = (0, $acw62.useRef)(new Map());
    const [revision, bump] = (0, $acw62.useState)(0);
    const [helpOpen, setHelpOpen] = (0, $acw62.useState)(false);
    const register = (0, $acw62.useCallback)((id, def)=>{
        regs.current.set(id, def);
        bump((v)=>v + 1);
        return ()=>{
            regs.current.delete(id);
            bump((v)=>v + 1);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (typeof window === 'undefined') return undefined;
        const onKey = (e)=>{
            const combo = $0277e73c10ea225a$export$fec7a04f3f2b43c1(e);
            if (!combo) return;
            const editable = $0277e73c10ea225a$export$763c4b15adcf804b(e.target);
            let best = null;
            for (const def of regs.current.values()){
                if (def.combo !== combo) continue;
                const fires = def.firesInInput ?? $0277e73c10ea225a$export$570b40aed3a24e82(def.combo);
                if (editable && !fires) continue;
                if (!best || def.seq > best.seq) best = def;
            }
            if (!best) return;
            // Claim the key only once something handles it, so an unbound F5 still reloads.
            e.preventDefault();
            e.stopPropagation();
            best.run(e);
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, []);
    // Stable for the provider's lifetime — `useShortcut` lists it as a dependency.
    const registry = (0, $acw62.useMemo)(()=>({
            register: register,
            regs: regs
        }), [
        register
    ]);
    const help = (0, $acw62.useMemo)(()=>({
            revision: revision,
            helpOpen: helpOpen,
            setHelpOpen: setHelpOpen
        }), [
        revision,
        helpOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0277e73c10ea225a$var$RegistryCtx.Provider, {
        value: registry
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0277e73c10ea225a$var$HelpCtx.Provider, {
        value: help
    }, children));
}
function $0277e73c10ea225a$export$b0ebbe7904d8d94a(combo, handler, opts = {}) {
    const { label: label, group: group, enabled: enabled = true, firesInInput: firesInInput } = opts;
    const registry = (0, $acw62.useContext)($0277e73c10ea225a$var$RegistryCtx);
    const handlerRef = (0, $acw62.useRef)(handler);
    handlerRef.current = handler;
    const idRef = (0, $acw62.useRef)(null);
    if (idRef.current === null) idRef.current = Symbol('shortcut');
    (0, $acw62.useEffect)(()=>{
        if (!registry || !enabled) return undefined;
        const normalized = $0277e73c10ea225a$export$491029574d911e8(combo);
        if (!normalized) return undefined;
        return registry.register(idRef.current, {
            combo: normalized,
            label: label,
            group: group,
            firesInInput: firesInInput,
            seq: ++$0277e73c10ea225a$var$SEQ,
            run: (e)=>handlerRef.current?.(e)
        });
    }, [
        registry,
        combo,
        label,
        group,
        enabled,
        firesInInput
    ]);
}
function $0277e73c10ea225a$export$8dc9f6f80a84c72b() {
    const registry = (0, $acw62.useContext)($0277e73c10ea225a$var$RegistryCtx);
    const help = (0, $acw62.useContext)($0277e73c10ea225a$var$HelpCtx);
    const revision = help?.revision;
    return (0, $acw62.useMemo)(()=>{
        if (!registry) return [];
        const groups = new Map();
        for (const def of registry.regs.current.values()){
            if (!def.label) continue;
            const g = def.group || '';
            if (!groups.has(g)) groups.set(g, new Map());
            const byCombo = groups.get(g);
            const prev = byCombo.get(def.combo);
            if (!prev || def.seq > prev.seq) byCombo.set(def.combo, def);
        }
        return [
            ...groups.entries()
        ].map(([group, byCombo])=>({
                group: group,
                items: [
                    ...byCombo.values()
                ].sort((a, b)=>a.combo.localeCompare(b.combo))
            }));
    // `revision` is the signal that the ref changed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        registry,
        revision
    ]);
}
function $0277e73c10ea225a$export$a11896fcfbddc990() {
    const help = (0, $acw62.useContext)($0277e73c10ea225a$var$HelpCtx);
    return {
        open: Boolean(help?.helpOpen),
        setOpen: (0, $acw62.useCallback)((next)=>help?.setHelpOpen(next), [
            help
        ]),
        toggle: (0, $acw62.useCallback)(()=>help?.setHelpOpen((v)=>!v), [
            help
        ])
    };
}
// ── A tiny app-wide "close the top sheet" bus for the global Esc binding ──
//
// Kit overlays close on Escape by themselves (Radix Dialog, BottomSheet). The
// app's own sheets and drawers register a closer here so the ONE global `esc`
// binding in App.jsx can close whichever is on top, instead of each screen
// adding its own window listener.
const $0277e73c10ea225a$var$closers = [];
function $0277e73c10ea225a$export$f877b52bc748440d(fn) {
    $0277e73c10ea225a$var$closers.push(fn);
    return ()=>{
        const i = $0277e73c10ea225a$var$closers.indexOf(fn);
        if (i !== -1) $0277e73c10ea225a$var$closers.splice(i, 1);
    };
}
function $0277e73c10ea225a$export$db012f04daaa5b19() {
    for(let i = $0277e73c10ea225a$var$closers.length - 1; i >= 0; i -= 1){
        if ($0277e73c10ea225a$var$closers[i]?.() === true) return true;
    }
    return false;
}
function $0277e73c10ea225a$export$b26f18012588c702(open, onClose) {
    (0, $acw62.useEffect)(()=>{
        if (!open) return undefined;
        return $0277e73c10ea225a$export$f877b52bc748440d(()=>{
            onClose?.();
            return true;
        });
    }, [
        open,
        onClose
    ]);
}


// The signed-in student: are they onboarded, who are they, and what can they
// spend.
//
// ── Why this is a shared store and not a plain per-component fetch ──────────
//
// `onboardingStatus` and `studentProfile` come back TOGETHER (documents.js,
// BOOT_QUERY) because the boot needs both in the same frame: one decides
// whether the app renders the form or the router, the other paints the rail.
// The profile and the balance are then read by four more places — the rail, the
// chat composer (which must know whether a question is affordable BEFORE it is
// pressed), the credits screen and the profile screen — and the balance CHANGES
// underneath all of them every time an AI action runs.
//
// A hook that fetched per mount would give those surfaces different numbers and
// as many round trips, and the one in the rail would be the stalest. So there is
// exactly one copy in this module, every `useMe()` subscribes to it, and a
// mutation that moved the balance calls `refreshBalance()` — which repaints all
// of them at once.
//
// THE WALLET IS THE ONLY AUTHORITY on that number (core.md §3.5). Nothing here
// ever derives a balance by summing `CaseChatMessage.costParseh`: the AI
// service's credit check FAILS OPEN, so a message can legitimately carry a cost
// the ledger has no row for. `costParseh` describes the price list; this
// describes the wallet.
//
// ── The onboarding verdict, and the one shape it must not have ────────────
//
// v1 had no onboarding at all and the BFF gated on a `student` role nobody
// granted — the circularity core.md §4.2 removes. v2's gate is a stored
// profile, so the boot has to answer "is there one?" before it renders
// anything.
//
// The answer comes from `onboardingStatus`, which is a ROOT THE GATE ALWAYS
// ALLOWS, and from nothing else. In particular a FAILED boot is never read as
// "not onboarded": the doctor app once read a stale token that way, showed its
// registration wizard to an already-registered doctor, and produced a duplicate
// account. Here a failure is an OUTAGE — `error` is published, `status` stays
// null, and App.jsx renders a full-page error with a retry rather than a form
// that would save into a store that is not answering (core.md §4.3).

var $acw62 = parcelRequire("acw62");


// Every GraphQL document this client sends, in one file.
//
// `edu-app/docs/SCHEMA.graphql` is a FROZEN CONTRACT, written before any
// implementation; the client, the BFF resolvers and the BFF's own tests are
// built against it in parallel. A field that is not in it does not exist.
// Collecting the documents here makes the app's whole demand on the BFF one page
// long, and lets `tests/documents.test.js` check every selection, argument and
// variable type against the contract.
//
// ── The conventions the schema is explicit about (core.md §10) ────────────
//
// 1. EPOCH MILLISECONDS RIDE AS `String`, NEVER `Int` — GraphQL's Int is 32-bit
//    and epoch ms overflow it; Apollo THROWS at serialization. Every `*AtMs` is a
//    String and is converted with `Number()` at the point of use.
// 2. NOTHING TAKES A `studentId` ARGUMENT. The student id is the JWT `sub`; an
//    argument that exists is an argument someone eventually passes.
// 3. Lists that omit children populate the COUNTS: `entries` is empty on
//    `myCases`, `messages` is empty on `caseChatThreads`, `note`/`diagnoses`/…
//    are empty on `encounters`. Render the count, never `.length`.
// 4. Reads answer `null` for "not found" and "not mine" alike — one screen for
//    both, no oracle.
//
// The encounter / clinical / copilot documents are declared here too, ahead of
// the Visit workspace that will send them, so the contract check covers them
// from day one.
// ── Fragments ───────────────────────────────────────────────────────────────
/** The patient as a LIST ROW: counts, no children. */ const $3569e16be34bfe54$export$a98a80e8ec4697f4 = `
  fragment CaseRow on StudentCase {
    id
    title
    displayName
    caseRef
    ageYears
    ageDisplay
    sex
    bloodType
    weightKg
    heightCm
    chiefComplaint
    status
    note
    entryCount
    threadCount
    messageCount
    encounterCount
    lastEncounterAtMs
    openEncounterId
    createdAtMs
    updatedAtMs
  }
`;
const $3569e16be34bfe54$export$dc877c6ecd2a3fe9 = `
  fragment HistoryEntry on CaseHistoryEntry {
    id
    caseId
    section
    label
    body
    structured
    source
    sortOrder
    recordedAtMs
    encounterId
    createdAtMs
    updatedAtMs
  }
`;
const $3569e16be34bfe54$export$71dd2d1c30246eb4 = `
  fragment ChatMessage on CaseChatMessage {
    id
    threadId
    role
    kind
    content
    payload
    costParseh
    seq
    createdAtMs
  }
`;
const $3569e16be34bfe54$export$4376fa8138cd32a = `
  fragment ChatThreadRow on CaseChatThread {
    id
    caseId
    encounterId
    title
    messageCount
    lastMessageAtMs
    createdAtMs
    hasOlder
  }
`;
const $3569e16be34bfe54$export$e150963d3d4fe441 = `
  fragment ChatThreadFull on CaseChatThread {
    ...ChatThreadRow
    messages { ...ChatMessage }
  }
`;
const $3569e16be34bfe54$export$106263f991fcf945 = `
  fragment EncounterNote on EncounterNote {
    encounterId
    s
    o
    a
    p
    updatedAtMs
  }
`;
const $3569e16be34bfe54$export$b7607145e9dcf952 = `
  fragment Diagnosis on Diagnosis {
    id
    caseId
    encounterId
    title
    icdCode
    kind
    status
    note
    origin
    sortOrder
    createdAtMs
    updatedAtMs
  }
`;
const $3569e16be34bfe54$export$bc125637a4186c = `
  fragment RxItem on RxItem {
    id
    caseId
    encounterId
    drugId
    drugName
    dose
    route
    frequency
    duration
    quantity
    instructions
    origin
    sortOrder
    createdAtMs
    updatedAtMs
  }
`;
const $3569e16be34bfe54$export$693107d1825c1689 = `
  fragment Order on Order {
    id
    caseId
    encounterId
    orderType
    title
    code
    category
    urgency
    status
    notes
    resultBody
    resultStructured
    resultedAtMs
    origin
    sortOrder
    createdAtMs
    updatedAtMs
  }
`;
const $3569e16be34bfe54$export$d084514124401e39 = `
  fragment EncounterRow on Encounter {
    id
    caseId
    seq
    status
    reason
    startedAtMs
    endedAtMs
    summary
    diagnosisCount
    rxCount
    orderCount
    entryCount
    threadCount
    createdAtMs
    updatedAtMs
  }
`;
const $3569e16be34bfe54$export$4b9a14d0670cc3ee = `
  fragment EncounterFull on Encounter {
    ...EncounterRow
    note { ...EncounterNote }
    diagnoses { ...Diagnosis }
    rxItems { ...RxItem }
    orders { ...Order }
    entries { ...HistoryEntry }
  }
`;
const $3569e16be34bfe54$export$a2239962ebcbbf2c = `
  fragment WalletBalance on StudentWalletBalance {
    balance
    currency
    lastUpdated
  }
`;
const $3569e16be34bfe54$export$3dd230a39f6cddea = `
  fragment GiftCode on StudentGiftCode {
    id
    code
    parseh
    status
    issuedAtMs
    expiresAtMs
    redeemedAtMs
  }
`;
const $3569e16be34bfe54$export$82e5bd638b0c2825 = `
  fragment StudentProfile on StudentProfile {
    id
    fullName
    studentNumber
    university
    level
    field
    entryYear
    bio
    phone
    caseCount
    balance
    createdAtMs
    updatedAtMs
  }
`;
const $3569e16be34bfe54$export$6fe995f4191b8baa = `
  query Boot {
    onboardingStatus {
      isOnboarded
      suggestedFullName
      phone
    }
    studentProfile { ...StudentProfile }
  }
  ${$3569e16be34bfe54$export$82e5bd638b0c2825}
`;
const $3569e16be34bfe54$export$12792cd84a4d98f8 = `
  query StudentProfile {
    studentProfile { ...StudentProfile }
  }
  ${$3569e16be34bfe54$export$82e5bd638b0c2825}
`;
const $3569e16be34bfe54$export$25fcebf30e4220a7 = `
  query MyCases($statuses: [String!], $limit: Int, $offset: Int) {
    myCases(statuses: $statuses, limit: $limit, offset: $offset) {
      ...CaseRow
    }
  }
  ${$3569e16be34bfe54$export$a98a80e8ec4697f4}
`;
const $3569e16be34bfe54$export$9df02b57e704999f = `
  query AnyCases($limit: Int, $offset: Int) {
    myCases(limit: $limit, offset: $offset) {
      id
    }
  }
`;
const $3569e16be34bfe54$export$532673476a7e45c5 = `
  query MyCase($caseId: ID!) {
    myCase(caseId: $caseId) {
      ...CaseRow
      entries { ...HistoryEntry }
    }
  }
  ${$3569e16be34bfe54$export$a98a80e8ec4697f4}
  ${$3569e16be34bfe54$export$dc877c6ecd2a3fe9}
`;
const $3569e16be34bfe54$export$a5e6f2cc85ed53f7 = `
  query MyCaseRecord($caseId: ID!) {
    myCaseRecord(caseId: $caseId) {
      case {
        ...CaseRow
        entries { ...HistoryEntry }
      }
      encounters { ...EncounterFull }
      threads { ...ChatThreadRow }
      activeProblems {
        title
        icdCode
        kind
        encounterId
        encounterSeq
        sinceMs
      }
      currentMedications {
        name
        detail
        from
        encounterSeq
      }
      pendingOrders { ...Order }
      timeline {
        id
        type
        atMs
        title
        detail
        encounterId
        encounterSeq
        refId
      }
    }
  }
  ${$3569e16be34bfe54$export$a98a80e8ec4697f4}
  ${$3569e16be34bfe54$export$dc877c6ecd2a3fe9}
  ${$3569e16be34bfe54$export$d084514124401e39}
  ${$3569e16be34bfe54$export$106263f991fcf945}
  ${$3569e16be34bfe54$export$b7607145e9dcf952}
  ${$3569e16be34bfe54$export$bc125637a4186c}
  ${$3569e16be34bfe54$export$693107d1825c1689}
  ${$3569e16be34bfe54$export$4b9a14d0670cc3ee}
  ${$3569e16be34bfe54$export$4376fa8138cd32a}
`;
const $3569e16be34bfe54$export$3c1db077bd82bd9d = `
  query CaseHistory($caseId: ID!, $sections: [String!]) {
    caseHistory(caseId: $caseId, sections: $sections) {
      ...HistoryEntry
    }
  }
  ${$3569e16be34bfe54$export$dc877c6ecd2a3fe9}
`;
const $3569e16be34bfe54$export$470fc6f1295bc1fb = `
  query Encounter($encounterId: ID!) {
    encounter(encounterId: $encounterId) { ...EncounterFull }
  }
  ${$3569e16be34bfe54$export$d084514124401e39}
  ${$3569e16be34bfe54$export$106263f991fcf945}
  ${$3569e16be34bfe54$export$b7607145e9dcf952}
  ${$3569e16be34bfe54$export$bc125637a4186c}
  ${$3569e16be34bfe54$export$693107d1825c1689}
  ${$3569e16be34bfe54$export$dc877c6ecd2a3fe9}
  ${$3569e16be34bfe54$export$4b9a14d0670cc3ee}
`;
const $3569e16be34bfe54$export$92137e49c4be951b = `
  query Encounters($caseId: ID!) {
    encounters(caseId: $caseId) { ...EncounterRow }
  }
  ${$3569e16be34bfe54$export$d084514124401e39}
`;
const $3569e16be34bfe54$export$cb40171597afb9c8 = `
  query CaseChatThreads($caseId: ID!, $scope: String, $encounterId: ID) {
    caseChatThreads(caseId: $caseId, scope: $scope, encounterId: $encounterId) {
      ...ChatThreadRow
    }
  }
  ${$3569e16be34bfe54$export$4376fa8138cd32a}
`;
const $3569e16be34bfe54$export$d9466cb6388f2c86 = `
  query CaseChatThread($threadId: ID!, $messageLimit: Int, $beforeSeq: String) {
    caseChatThread(threadId: $threadId, messageLimit: $messageLimit, beforeSeq: $beforeSeq) {
      ...ChatThreadFull
    }
  }
  ${$3569e16be34bfe54$export$4376fa8138cd32a}
  ${$3569e16be34bfe54$export$71dd2d1c30246eb4}
  ${$3569e16be34bfe54$export$e150963d3d4fe441}
`;
const $3569e16be34bfe54$export$1e7b6b321d3c9c4 = `
  query SearchDrugs($query: String!, $limit: Int) {
    searchDrugs(query: $query, limit: $limit) {
      id
      name
      genericName
      category
      commonDosages
      commonFrequencies
    }
  }
`;
const $3569e16be34bfe54$export$e8f901dd17836000 = `
  query OrderCatalog {
    orderCatalog {
      labs { orderType name nameEn code category modality }
      imaging { orderType name nameEn code category modality }
      procedures { orderType name nameEn code category modality }
    }
  }
`;
const $3569e16be34bfe54$export$5a538d05d9d7d4f5 = `
  query MyWalletBalance {
    myWalletBalance { ...WalletBalance }
  }
  ${$3569e16be34bfe54$export$a2239962ebcbbf2c}
`;
const $3569e16be34bfe54$export$4d820a05a5a74fb3 = `
  query MyWalletTransactions($limit: Int, $offset: Int, $type: String) {
    myWalletTransactions(limit: $limit, offset: $offset, type: $type) {
      transactions {
        id
        type
        amount
        serviceType
        description
        createdAt
        referenceId
      }
      totalCount
    }
  }
`;
const $3569e16be34bfe54$export$401dcf97213f686c = `
  query MyGiftCodes {
    myGiftCodes { ...GiftCode }
  }
  ${$3569e16be34bfe54$export$3dd230a39f6cddea}
`;
const $3569e16be34bfe54$export$a981945c36fdd224 = `
  query GiftCodePreview($code: String!) {
    giftCodePreview(code: $code) { ...GiftCode }
  }
  ${$3569e16be34bfe54$export$3dd230a39f6cddea}
`;
const $3569e16be34bfe54$export$b5263aae0444225d = `
  mutation CompleteStudentOnboarding($input: StudentOnboardingInput!) {
    completeStudentOnboarding(input: $input) { ...StudentProfile }
  }
  ${$3569e16be34bfe54$export$82e5bd638b0c2825}
`;
const $3569e16be34bfe54$export$19f64c1f84023b2a = `
  mutation UpdateStudentProfile($input: StudentProfileUpdateInput!) {
    updateStudentProfile(input: $input) { ...StudentProfile }
  }
  ${$3569e16be34bfe54$export$82e5bd638b0c2825}
`;
const $3569e16be34bfe54$export$2cb50a185a816e1b = `
  mutation CreateCase($input: CaseInput!) {
    createCase(input: $input) { ...CaseRow }
  }
  ${$3569e16be34bfe54$export$a98a80e8ec4697f4}
`;
const $3569e16be34bfe54$export$1a72deffcb882601 = `
  mutation UpdateCase($caseId: ID!, $input: CaseUpdateInput!) {
    updateCase(caseId: $caseId, input: $input) { ...CaseRow }
  }
  ${$3569e16be34bfe54$export$a98a80e8ec4697f4}
`;
const $3569e16be34bfe54$export$103f04c571adf29b = `
  mutation DeleteCase($caseId: ID!) {
    deleteCase(caseId: $caseId)
  }
`;
const $3569e16be34bfe54$export$e169d2c267301cd2 = `
  mutation AddCaseHistory($caseId: ID!, $entries: [CaseHistoryEntryInput!]!) {
    addCaseHistory(caseId: $caseId, entries: $entries) { ...HistoryEntry }
  }
  ${$3569e16be34bfe54$export$dc877c6ecd2a3fe9}
`;
const $3569e16be34bfe54$export$c87054baf27a4c54 = `
  mutation UpdateCaseHistoryEntry($entryId: ID!, $input: CaseHistoryEntryUpdateInput!) {
    updateCaseHistoryEntry(entryId: $entryId, input: $input) { ...HistoryEntry }
  }
  ${$3569e16be34bfe54$export$dc877c6ecd2a3fe9}
`;
const $3569e16be34bfe54$export$7582e661207c1f6a = `
  mutation DeleteCaseHistoryEntry($entryId: ID!) {
    deleteCaseHistoryEntry(entryId: $entryId)
  }
`;
const $3569e16be34bfe54$export$30609e7e70a5aa46 = `
  mutation StartEncounter($caseId: ID!, $reason: String) {
    startEncounter(caseId: $caseId, reason: $reason) { ...EncounterRow }
  }
  ${$3569e16be34bfe54$export$d084514124401e39}
`;
const $3569e16be34bfe54$export$3434cb1307814dfc = `
  mutation EndEncounter($encounterId: ID!, $summary: String) {
    endEncounter(encounterId: $encounterId, summary: $summary) { ...EncounterRow }
  }
  ${$3569e16be34bfe54$export$d084514124401e39}
`;
const $3569e16be34bfe54$export$7c99d14753db2165 = `
  mutation ReopenEncounter($encounterId: ID!) {
    reopenEncounter(encounterId: $encounterId) { ...EncounterRow }
  }
  ${$3569e16be34bfe54$export$d084514124401e39}
`;
const $3569e16be34bfe54$export$c993e5ea0deb23ab = `
  mutation CancelEncounter($encounterId: ID!) {
    cancelEncounter(encounterId: $encounterId)
  }
`;
const $3569e16be34bfe54$export$1cad6cb10b69f972 = `
  mutation UpsertEncounterNote($encounterId: ID!, $input: EncounterNoteInput!) {
    upsertEncounterNote(encounterId: $encounterId, input: $input) { ...EncounterNote }
  }
  ${$3569e16be34bfe54$export$106263f991fcf945}
`;
const $3569e16be34bfe54$export$f085bbd107d0afdd = `
  mutation AddDiagnosis($encounterId: ID!, $input: DiagnosisInput!) {
    addDiagnosis(encounterId: $encounterId, input: $input) { ...Diagnosis }
  }
  ${$3569e16be34bfe54$export$b7607145e9dcf952}
`;
const $3569e16be34bfe54$export$2f3cb9b0bb7c2576 = `
  mutation UpdateDiagnosis($diagnosisId: ID!, $input: DiagnosisUpdateInput!) {
    updateDiagnosis(diagnosisId: $diagnosisId, input: $input) { ...Diagnosis }
  }
  ${$3569e16be34bfe54$export$b7607145e9dcf952}
`;
const $3569e16be34bfe54$export$457b0d2fa8db1d99 = `
  mutation DeleteDiagnosis($diagnosisId: ID!) {
    deleteDiagnosis(diagnosisId: $diagnosisId)
  }
`;
const $3569e16be34bfe54$export$795964bf0efa3484 = `
  mutation AddRxItem($encounterId: ID!, $input: RxItemInput!) {
    addRxItem(encounterId: $encounterId, input: $input) { ...RxItem }
  }
  ${$3569e16be34bfe54$export$bc125637a4186c}
`;
const $3569e16be34bfe54$export$4f482d70b784a4d = `
  mutation UpdateRxItem($rxItemId: ID!, $input: RxItemUpdateInput!) {
    updateRxItem(rxItemId: $rxItemId, input: $input) { ...RxItem }
  }
  ${$3569e16be34bfe54$export$bc125637a4186c}
`;
const $3569e16be34bfe54$export$78947e78b9ba52d1 = `
  mutation DeleteRxItem($rxItemId: ID!) {
    deleteRxItem(rxItemId: $rxItemId)
  }
`;
const $3569e16be34bfe54$export$75b67b144e49bb13 = `
  mutation AddOrder($encounterId: ID!, $input: OrderInput!) {
    addOrder(encounterId: $encounterId, input: $input) { ...Order }
  }
  ${$3569e16be34bfe54$export$693107d1825c1689}
`;
const $3569e16be34bfe54$export$74d7abe26a875d97 = `
  mutation UpdateOrder($orderId: ID!, $input: OrderUpdateInput!) {
    updateOrder(orderId: $orderId, input: $input) { ...Order }
  }
  ${$3569e16be34bfe54$export$693107d1825c1689}
`;
const $3569e16be34bfe54$export$24756192218c6cf2 = `
  mutation RecordOrderResult($orderId: ID!, $input: OrderResultInput!) {
    recordOrderResult(orderId: $orderId, input: $input) { ...Order }
  }
  ${$3569e16be34bfe54$export$693107d1825c1689}
`;
const $3569e16be34bfe54$export$7dd95c4ac507c198 = `
  mutation CancelOrder($orderId: ID!) {
    cancelOrder(orderId: $orderId) { ...Order }
  }
  ${$3569e16be34bfe54$export$693107d1825c1689}
`;
const $3569e16be34bfe54$export$1da20105f21d3384 = `
  mutation DeleteOrder($orderId: ID!) {
    deleteOrder(orderId: $orderId)
  }
`;
const $3569e16be34bfe54$export$dbf3bb4f32a4e2d8 = `
  mutation CreateCaseChatThread($caseId: ID!, $title: String, $encounterId: ID) {
    createCaseChatThread(caseId: $caseId, title: $title, encounterId: $encounterId) {
      ...ChatThreadRow
    }
  }
  ${$3569e16be34bfe54$export$4376fa8138cd32a}
`;
const $3569e16be34bfe54$export$92e44db75c17d81b = `
  mutation RenameCaseChatThread($threadId: ID!, $title: String) {
    renameCaseChatThread(threadId: $threadId, title: $title) { ...ChatThreadRow }
  }
  ${$3569e16be34bfe54$export$4376fa8138cd32a}
`;
const $3569e16be34bfe54$export$d4e5876cfcdc8538 = `
  mutation DeleteCaseChatThread($threadId: ID!) {
    deleteCaseChatThread(threadId: $threadId)
  }
`;
const $3569e16be34bfe54$export$45229b62a279da66 = `
  mutation AskAboutCase($caseId: ID!, $threadId: ID, $question: String!) {
    askAboutCase(caseId: $caseId, threadId: $threadId, question: $question) {
      answer
      confidence
      relevantReferences
      followUpSuggestions
      thread { ...ChatThreadFull }
    }
  }
  ${$3569e16be34bfe54$export$4376fa8138cd32a}
  ${$3569e16be34bfe54$export$71dd2d1c30246eb4}
  ${$3569e16be34bfe54$export$e150963d3d4fe441}
`;
const $3569e16be34bfe54$export$323510239bf198b7 = `
  mutation AskInEncounter($encounterId: ID!, $question: String!) {
    askInEncounter(encounterId: $encounterId, question: $question) {
      answer
      confidence
      relevantReferences
      followUpSuggestions
      thread { ...ChatThreadFull }
    }
  }
  ${$3569e16be34bfe54$export$4376fa8138cd32a}
  ${$3569e16be34bfe54$export$71dd2d1c30246eb4}
  ${$3569e16be34bfe54$export$e150963d3d4fe441}
`;
const $3569e16be34bfe54$export$9eae1987f1584d9 = `
  mutation EncounterDifferential($encounterId: ID!) {
    encounterDifferential(encounterId: $encounterId) {
      narrative
      items {
        condition
        likelihood
        reasoning
        discriminators
        nextSteps
      }
      thread { ...ChatThreadFull }
    }
  }
  ${$3569e16be34bfe54$export$4376fa8138cd32a}
  ${$3569e16be34bfe54$export$71dd2d1c30246eb4}
  ${$3569e16be34bfe54$export$e150963d3d4fe441}
`;
const $3569e16be34bfe54$export$1c49f8b64ec577bc = `
  mutation SuggestEncounterSoap($encounterId: ID!) {
    suggestEncounterSoap(encounterId: $encounterId) {
      narrative
      s
      o
      a
      p
      thread { ...ChatThreadFull }
    }
  }
  ${$3569e16be34bfe54$export$4376fa8138cd32a}
  ${$3569e16be34bfe54$export$71dd2d1c30246eb4}
  ${$3569e16be34bfe54$export$e150963d3d4fe441}
`;
const $3569e16be34bfe54$export$29c62a1d62694b27 = `
  mutation SuggestEncounterOrders($encounterId: ID!) {
    suggestEncounterOrders(encounterId: $encounterId) {
      narrative
      items {
        orderType
        title
        reason
        urgency
        code
        category
      }
      thread { ...ChatThreadFull }
    }
  }
  ${$3569e16be34bfe54$export$4376fa8138cd32a}
  ${$3569e16be34bfe54$export$71dd2d1c30246eb4}
  ${$3569e16be34bfe54$export$e150963d3d4fe441}
`;
const $3569e16be34bfe54$export$e0e220c6f3f5c127 = `
  mutation CheckEncounterInteractions($encounterId: ID!) {
    checkEncounterInteractions(encounterId: $encounterId) {
      hasInteractions
      warnings {
        severity
        description
        drugPair
        source
        warningType
        drug
        condition
      }
      skippedDrugNames
      thread { ...ChatThreadFull }
    }
  }
  ${$3569e16be34bfe54$export$4376fa8138cd32a}
  ${$3569e16be34bfe54$export$71dd2d1c30246eb4}
  ${$3569e16be34bfe54$export$e150963d3d4fe441}
`;
const $3569e16be34bfe54$export$ea7b58070451027d = `
  mutation ParseCaseVoice($caseId: ID!, $transcript: String!) {
    parseCaseVoice(caseId: $caseId, transcript: $transcript) {
      displayName
      ageYears
      ageDisplay
      sex
      chiefComplaint
      entries {
        section
        body
        structured
      }
      transcript
    }
  }
`;
const $3569e16be34bfe54$export$d895bafe49428d37 = `
  mutation TopUpWallet($gateway: String!, $amount: Int!, $description: String, $returnUrl: String) {
    topUpWallet(gateway: $gateway, amount: $amount, description: $description, returnUrl: $returnUrl) {
      gateway
      authority
      paymentUrl
      invoiceId
    }
  }
`;
const $3569e16be34bfe54$export$2b5e21930ca1984a = `
  mutation RedeemGiftCode($code: String!) {
    redeemGiftCode(code: $code) {
      giftCode { ...GiftCode }
      balance { ...WalletBalance }
      granted
    }
  }
  ${$3569e16be34bfe54$export$3dd230a39f6cddea}
  ${$3569e16be34bfe54$export$a2239962ebcbbf2c}
`;


// ── The store ───────────────────────────────────────────────────────────────
const $5bc9ff20f6a2b818$var$EMPTY = {
    status: null,
    me: null,
    balance: null,
    loading: true,
    error: null
};
let $5bc9ff20f6a2b818$var$state = $5bc9ff20f6a2b818$var$EMPTY;
const $5bc9ff20f6a2b818$var$listeners = new Set();
function $5bc9ff20f6a2b818$var$publish(patch) {
    $5bc9ff20f6a2b818$var$state = {
        ...$5bc9ff20f6a2b818$var$state,
        ...patch
    };
    $5bc9ff20f6a2b818$var$listeners.forEach((fn)=>fn($5bc9ff20f6a2b818$var$state));
}
// One in-flight boot shared by every caller. App.jsx's gate and the surfaces
// that read this store all want the same facts in the same frame; without this
// they would issue five identical requests — and could end up holding different
// answers if one of them failed.
let $5bc9ff20f6a2b818$var$bootInFlight = null;
function $5bc9ff20f6a2b818$export$e09c1e21bd1a9de3() {
    if ($5bc9ff20f6a2b818$var$bootInFlight) return $5bc9ff20f6a2b818$var$bootInFlight;
    $5bc9ff20f6a2b818$var$publish({
        loading: true
    });
    $5bc9ff20f6a2b818$var$bootInFlight = (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$6fe995f4191b8baa)).then((data)=>{
        $5bc9ff20f6a2b818$var$publish({
            status: data?.onboardingStatus || null,
            me: data?.studentProfile || null,
            // The boot deliberately does NOT ask the wallet: `myWalletBalance` is
            // gated on the profile, and a field-level NOT_ONBOARDED beside a
            // perfectly good `onboardingStatus` would make the whole boot look like
            // an error. `studentProfile.balance` is the same number by contract.
            balance: data?.studentProfile?.balance ?? null,
            loading: false,
            error: null
        });
    }).catch((err)=>{
        console.error('[useMe] boot failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
        $5bc9ff20f6a2b818$var$publish({
            loading: false,
            error: err
        });
        throw err;
    }).finally(()=>{
        $5bc9ff20f6a2b818$var$bootInFlight = null;
    });
    return $5bc9ff20f6a2b818$var$bootInFlight;
}
function $5bc9ff20f6a2b818$export$6ea1b676f44ed53c(snapshot = $5bc9ff20f6a2b818$var$state) {
    if (snapshot.status) return Boolean(snapshot.status.isOnboarded);
    if (snapshot.me) return true;
    return snapshot.loading || snapshot.error ? null : false;
}
async function $5bc9ff20f6a2b818$export$f02afad0795d11cb(input) {
    const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$b5263aae0444225d), {
        input: input
    });
    const profile = data?.completeStudentOnboarding || null;
    $5bc9ff20f6a2b818$var$publish({
        me: profile,
        status: {
            ...$5bc9ff20f6a2b818$var$state.status || {},
            isOnboarded: true
        },
        balance: profile?.balance ?? $5bc9ff20f6a2b818$var$state.balance,
        error: null
    });
    try {
        await (0, $3bdb28763df76ec7$export$3f98f56b6bff7d36)();
    } catch (err) {
        // Not surfaced: the profile is stored and the app is usable. Turning a
        // failed token refresh into an error over a completed registration would
        // send the student back to a form they have already submitted — which is
        // how a duplicate account gets made.
        console.warn('[useMe] token refresh after onboarding failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
    }
    return profile;
}
async function $5bc9ff20f6a2b818$export$5880729c5d131040(input) {
    const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$19f64c1f84023b2a), {
        input: input
    });
    const profile = data?.updateStudentProfile || null;
    if (profile) $5bc9ff20f6a2b818$var$publish({
        me: profile,
        balance: profile.balance ?? $5bc9ff20f6a2b818$var$state.balance
    });
    return profile;
}
function $5bc9ff20f6a2b818$export$3437bf7ab4f0acaf() {
    return (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$5a538d05d9d7d4f5)).then((data)=>{
        const next = data?.myWalletBalance?.balance;
        if (next != null) $5bc9ff20f6a2b818$var$publish({
            balance: next
        });
    }).catch((err)=>{
        console.warn('[useMe] balance refresh failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
    });
}
function $5bc9ff20f6a2b818$export$b8488b78b8e134a0() {
    return (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$12792cd84a4d98f8)).then((data)=>{
        if (data?.studentProfile) $5bc9ff20f6a2b818$var$publish({
            me: data.studentProfile
        });
    }).catch((err)=>{
        console.warn('[useMe] profile refresh failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
    });
}
function $5bc9ff20f6a2b818$export$dabfdc709ddf95dd(next) {
    if (next == null) return;
    $5bc9ff20f6a2b818$var$publish({
        balance: Number(next)
    });
}
function $5bc9ff20f6a2b818$export$f9e51139c183198() {
    $5bc9ff20f6a2b818$var$state = {
        ...$5bc9ff20f6a2b818$var$EMPTY
    };
    $5bc9ff20f6a2b818$var$bootInFlight = null;
    return $5bc9ff20f6a2b818$export$e09c1e21bd1a9de3().catch(()=>{});
}
function $5bc9ff20f6a2b818$export$2db46270adf948aa() {
    $5bc9ff20f6a2b818$var$state = {
        ...$5bc9ff20f6a2b818$var$EMPTY
    };
    $5bc9ff20f6a2b818$var$bootInFlight = null;
    return $5bc9ff20f6a2b818$export$e09c1e21bd1a9de3();
}
function $5bc9ff20f6a2b818$export$478e1abafcdaa79a() {
    $5bc9ff20f6a2b818$var$state = {
        ...$5bc9ff20f6a2b818$var$EMPTY
    };
    $5bc9ff20f6a2b818$var$bootInFlight = null;
    $5bc9ff20f6a2b818$var$listeners.clear();
}
function $5bc9ff20f6a2b818$export$f637e1cf42d15a62() {
    const [snapshot, setSnapshot] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($5bc9ff20f6a2b818$var$state);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        $5bc9ff20f6a2b818$var$listeners.add(setSnapshot);
        // Sync first: the store may have resolved between this component's render
        // and its effect, and a subscriber that only waits for the NEXT publish
        // would sit on a stale `loading: true` forever.
        setSnapshot($5bc9ff20f6a2b818$var$state);
        // Normally a no-op: App.jsx's gate has already booted this store before any
        // of these surfaces could mount. It stays because a subscriber must not
        // depend on the order it happened to mount in — and `bootIdentity` dedupes
        // an in-flight one anyway.
        if (!$5bc9ff20f6a2b818$var$state.me && !$5bc9ff20f6a2b818$var$state.status && !$5bc9ff20f6a2b818$var$state.error) $5bc9ff20f6a2b818$export$e09c1e21bd1a9de3().catch(()=>{});
        return ()=>{
            $5bc9ff20f6a2b818$var$listeners.delete(setSnapshot);
        };
    }, []);
    return {
        me: snapshot.me,
        status: snapshot.status,
        onboarded: $5bc9ff20f6a2b818$export$6ea1b676f44ed53c(snapshot),
        balance: snapshot.balance,
        loading: snapshot.loading,
        error: snapshot.error,
        reload: $5bc9ff20f6a2b818$export$f9e51139c183198,
        refreshBalance: $5bc9ff20f6a2b818$export$3437bf7ab4f0acaf,
        refreshProfile: $5bc9ff20f6a2b818$export$b8488b78b8e134a0,
        completeOnboarding: $5bc9ff20f6a2b818$export$f02afad0795d11cb,
        updateProfile: $5bc9ff20f6a2b818$export$5880729c5d131040
    };
}
var $5bc9ff20f6a2b818$export$2e2bcd8739ae039 = $5bc9ff20f6a2b818$export$f637e1cf42d15a62;




var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $eea507cd16630bf5$export$a2387ed3b5d536eb = {
    name: "coins",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13.744 17.736a6 6 0 1 1-7.48-7.48",
                key: "bq4yh3"
            }
        ],
        [
            "path",
            {
                d: "M15 6h1v4",
                key: "11y1tn"
            }
        ],
        [
            "path",
            {
                d: "m6.134 14.768.866-.5 2 3.464",
                key: "17snzx"
            }
        ],
        [
            "circle",
            {
                cx: "16",
                cy: "8",
                r: "6",
                key: "14bfc9"
            }
        ]
    ]
};
$eea507cd16630bf5$export$a2387ed3b5d536eb.node;
const $eea507cd16630bf5$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($eea507cd16630bf5$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $fe506e7c2094458f$export$a2387ed3b5d536eb = {
    name: "log-out",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m16 17 5-5-5-5",
                key: "1bji2h"
            }
        ],
        [
            "path",
            {
                d: "M21 12H9",
                key: "dn1m92"
            }
        ],
        [
            "path",
            {
                d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
                key: "1uf3rs"
            }
        ]
    ]
};
$fe506e7c2094458f$export$a2387ed3b5d536eb.node;
const $fe506e7c2094458f$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($fe506e7c2094458f$export$a2387ed3b5d536eb);



// Design tokens. Re-exported from @parsina/framework so a screen imports one
// short path and never a local palette — `soft()` in particular must come from
// here: the accent tokens are CSS `var()` references now, so hand-rolled hex
// arithmetic on them produces `rgba(NaN, …)`.




// پارسه — what an AI action costs, and what a پارسه costs: the OFFLINE
// FALLBACK and the first-paint value.
//
// Since 2026-09-12 both numbers come from ONE server-side list: the AI
// service's active pricing policy, served by the BFF as `creditPrices` and read
// here through `src/lib/useCreditPrices.js`
// (docs/AI_COST_AND_PARSEH_PRICING_MANAGEMENT_DESIGN.md §9.2, phase 3). The cost
// chip beside a button, the price list on the credits screen and the "can they
// afford it?" guard all go through `costOf(actionId)` / `costForKind(kind)` /
// `useCreditPrices()` there, so what is advertised follows the policy the
// service actually debits from.
//
// THIS FILE is what renders before that list has arrived and what renders when
// it never does (offline, BFF down). It is NOT where a price is changed — the
// design doc is the reference, and the admin panel's pricing policy is the
// instrument. The BFF carries the same fallback in `src/lib/parsehCost.js` and
// reads the same list.
//
// ── These are ESTIMATES SHOWN BEFORE THE SPEND, not a record of it ────────
//
// The deduction happens inside the AI service after the BFF has handed off, and
// that service's credit check FAILS OPEN — when the wallet is unreachable the
// request is allowed through uncharged (core.md §3.5). So an action can
// legitimately complete having cost nothing, and `CaseChatMessage.costParseh`
// can carry a number the ledger has no row for. That is correct behaviour, and it
// is exactly why nothing in this app ever SUMS these to produce a balance.
// `myWalletBalance` is the only authority.
/** Per-action پارسه costs, keyed by the client action. core.md §8.3.
 *  FALLBACK — read them through `costOf()` in lib/useCreditPrices.js. */ const $9ffff9692ff7166c$export$c7cf0ec3971f321c = {
    // پرسش از دستیار — `askAboutCase` / `askInEncounter`, one AskDoctorQuestion.
    ASK: 10,
    // تشخیص افتراقی — ALSO an AskDoctorQuestion carrying a teaching prompt. Not
    // `GetDifferentialDiagnosis`, which is appointment-bound and would answer an
    // empty list for a fake case. Same RPC, same price.
    DIFFERENTIAL: 10,
    // پیشنهاد SOAP — `suggestEncounterSoap`.
    SOAP_SUGGEST: 10,
    // پیشنهاد دستورات — `suggestEncounterOrders`.
    ORDER_SUGGEST: 10,
    // تداخل دارویی — CheckDrugInteraction. Cheaper: a rule engine does most of it.
    INTERACTION: 3,
    // دیکته — ParsePatientVoice. Zero TODAY because the service meters nothing
    // for it; still a Mutation so that metering it later is a price change, not a
    // client rewrite. Change this number and the whole UI follows.
    VOICE: 0
};
const $9ffff9692ff7166c$export$62371531b76e632c = {
    chat: $9ffff9692ff7166c$export$c7cf0ec3971f321c.ASK,
    differential: $9ffff9692ff7166c$export$c7cf0ec3971f321c.DIFFERENTIAL,
    interaction: $9ffff9692ff7166c$export$c7cf0ec3971f321c.INTERACTION,
    soap_suggest: $9ffff9692ff7166c$export$c7cf0ec3971f321c.SOAP_SUGGEST,
    order_suggest: $9ffff9692ff7166c$export$c7cf0ec3971f321c.ORDER_SUGGEST
};
const $9ffff9692ff7166c$export$b9aa9ba1f60db0e = (kind)=>$9ffff9692ff7166c$export$62371531b76e632c[kind] ?? 0;
const $9ffff9692ff7166c$export$6db475f96f22888b = 1000;
const $9ffff9692ff7166c$export$52690e1136e04e64 = [
    {
        id: 'ask',
        action: 'ASK',
        labelKey: 'credits.price.ask',
        cost: $9ffff9692ff7166c$export$c7cf0ec3971f321c.ASK
    },
    {
        id: 'differential',
        action: 'DIFFERENTIAL',
        labelKey: 'credits.price.differential',
        cost: $9ffff9692ff7166c$export$c7cf0ec3971f321c.DIFFERENTIAL
    },
    {
        id: 'soap',
        action: 'SOAP_SUGGEST',
        labelKey: 'credits.price.soap',
        cost: $9ffff9692ff7166c$export$c7cf0ec3971f321c.SOAP_SUGGEST
    },
    {
        id: 'orders',
        action: 'ORDER_SUGGEST',
        labelKey: 'credits.price.orders',
        cost: $9ffff9692ff7166c$export$c7cf0ec3971f321c.ORDER_SUGGEST
    },
    {
        id: 'interaction',
        action: 'INTERACTION',
        labelKey: 'credits.price.interaction',
        cost: $9ffff9692ff7166c$export$c7cf0ec3971f321c.INTERACTION
    },
    {
        id: 'voice',
        action: 'VOICE',
        labelKey: 'credits.price.voice',
        cost: $9ffff9692ff7166c$export$c7cf0ec3971f321c.VOICE
    }
];
const $9ffff9692ff7166c$export$41ee723fb8b6f73 = [
    200,
    500,
    1000
];
const $9ffff9692ff7166c$export$7e3773b326602d81 = 500;
function $9ffff9692ff7166c$export$63e20163a2b1658b(n, formatNumber) {
    if (n == null || !Number.isFinite(Number(n))) return "\u2014";
    const rounded = Math.round(Number(n));
    return formatNumber ? formatNumber(rounded) : String(rounded);
}
function $9ffff9692ff7166c$export$876d611be39e5cf8(balance, cost) {
    if (balance == null) return true;
    const n = Number(balance);
    if (!Number.isFinite(n)) return true;
    return n >= Number(cost || 0);
}



// Screen-name navigation.
//
// Screens navigate by NAME (`navigate('patient', { caseId })`), never by URL
// literal. `src/constants/routes.js` owns the name → path map and the <Route>
// patterns App.jsx mounts; this hook is the React half of it, and nothing else.
//
// The map is NOT re-declared here. It used to be, and the day the route table
// grew a visit and a chat page there were two lists to keep in step — the exact
// drift tests/routing.test.js exists to catch. `ROUTES` is re-exported so the
// call sites that import it from this module keep working.
//
// tests/routing.test.js pins the three-way agreement: every ROUTES key builds a
// path some <Route> in App.jsx matches, every declared <Route> is reachable
// through a key, and every NAV_ITEMS id is one of those keys.

var $acw62 = parcelRequire("acw62");

// The route table of core.md §7.0 — ONE place that turns a screen name into a
// path, and one place that lists the <Route> patterns App.jsx mounts.
//
// Screens navigate by NAME (`navigate('patient', { caseId })`), never by URL
// literal, so a path can be renamed here and nowhere else. tests/routing.test.js
// pins the three-way agreement between this map, the <Route>s in App.jsx and
// the nav list in ./nav.js.
//
// Ten routes, ten built screens. A route for scheduling, a clinic, a case
// library or a grading dashboard would be a route to nothing — core.md §18 says
// building any of them is a defect, and a route is the first thing that appears
// for a screen nobody has built.
/** The record tabs, in the order the strip shows them. `overview` is omitted from the URL. */ const $16250bd714b02a14$export$856e5f05339889aa = [
    'overview',
    'history',
    'visits',
    'timeline'
];
const $16250bd714b02a14$export$2b3748ab0ccf0b0a = 'overview';
const $16250bd714b02a14$export$8029ceef39221f73 = (id)=>$16250bd714b02a14$export$856e5f05339889aa.includes(id);
const $16250bd714b02a14$export$274854c544a34158 = (id)=>$16250bd714b02a14$export$8029ceef39221f73(id) ? id : $16250bd714b02a14$export$2b3748ab0ccf0b0a;
const $16250bd714b02a14$export$cd891b82501bb412 = {
    // «بیماران» — the landing route: a student opens this app to their own
    // practice patients, because there is nothing else it could open to.
    patients: ()=>'/patients',
    // `tab` is a URL SEGMENT: a refresh, a back button and a pasted link all have
    // to restore the part of the record the student was reading. `overview` is
    // the default and is left out of the URL.
    patient: (d = {})=>`/patients/${d.caseId}${d.tab && d.tab !== $16250bd714b02a14$export$2b3748ab0ccf0b0a ? `/${d.tab}` : ''}`,
    // The visit workspace — a full-height surface with its own back button.
    visit: (d = {})=>`/patients/${d.caseId}/visit/${d.encounterId}`,
    // The patient-level chat page. No `threadId` = a fresh, unsaved conversation.
    chat: (d = {})=>`/patients/${d.caseId}/chat${d.threadId ? `/${d.threadId}` : ''}`,
    // «گفتگو» in the nav: resumes the most recent thread, or asks which patient.
    chatLanding: ()=>'/chat',
    credits: ()=>'/credits',
    profile: ()=>'/profile'
};
const $16250bd714b02a14$export$7a9f361bfb157406 = {
    patients: '/patients',
    visit: '/patients/:caseId/visit/:encounterId',
    chat: '/patients/:caseId/chat/:threadId?',
    patient: '/patients/:caseId/:tab?',
    chatLanding: '/chat',
    credits: '/credits',
    profile: '/profile'
};
const $16250bd714b02a14$export$e773cdfa384074bb = (pathname)=>/^\/patients\/[^/]+\/visit(\/|$)/.test(pathname || '');
const $16250bd714b02a14$export$daba392f9ff20333 = (pathname)=>/^\/patients\/[^/]+\/chat(\/|$)/.test(pathname || '');
var $16250bd714b02a14$export$2e2bcd8739ae039 = $16250bd714b02a14$export$cd891b82501bb412;


function $53b14620f65a31c3$export$5b61ff3425c1c197() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    /**
   * @param screen  a key of ROUTES
   * @param data    the route's own parameters. `replace: true` swaps the current
   *                history entry instead of pushing one — for a NAVIGATION THE
   *                USER DID NOT MAKE, such as the record correcting a stale
   *                `:tab` segment, or the chat page adopting the id of the
   *                thread the first question just created. Pushed, the back
   *                button would return the student to the broken URL, which
   *                would correct itself again — a trap they cannot leave by
   *                going back.
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((screen, data)=>{
        const build = (0, $16250bd714b02a14$export$cd891b82501bb412)[screen];
        if (!build) {
            // Loud rather than silent: a typo'd screen name is a dead button, and a
            // dead button is indistinguishable from a slow one.
            console.warn(`[useAppNavigate] no route for "${screen}"`);
            return;
        }
        navigate(build(data || {}), {
            state: data,
            replace: !!data?.replace
        });
        window.scrollTo(0, 0);
    }, [
        navigate
    ]);
}
var $53b14620f65a31c3$export$2e2bcd8739ae039 = $53b14620f65a31c3$export$5b61ff3425c1c197;



/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8c7fae0571c9b8a8$export$a2387ed3b5d536eb = {
    name: "messages-square",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 10a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 14.286V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z",
                key: "1n2ejm"
            }
        ],
        [
            "path",
            {
                d: "M20 9a2 2 0 0 1 2 2v10.286a.71.71 0 0 1-1.212.502l-2.202-2.202A2 2 0 0 0 17.172 19H10a2 2 0 0 1-2-2v-1",
                key: "1qfcsi"
            }
        ]
    ]
};
$8c7fae0571c9b8a8$export$a2387ed3b5d536eb.node;
const $8c7fae0571c9b8a8$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($8c7fae0571c9b8a8$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $86bc9f94aec05e0c$export$a2387ed3b5d536eb = {
    name: "user-round",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "8",
                r: "5",
                key: "1hypcn"
            }
        ],
        [
            "path",
            {
                d: "M20 21a8 8 0 0 0-16 0",
                key: "rfgkzh"
            }
        ]
    ],
    aliases: [
        "user-2"
    ]
};
$86bc9f94aec05e0c$export$a2387ed3b5d536eb.node;
const $86bc9f94aec05e0c$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($86bc9f94aec05e0c$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8446477c3df1c126$export$a2387ed3b5d536eb = {
    name: "users-round",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M18 21a8 8 0 0 0-16 0",
                key: "3ypg7q"
            }
        ],
        [
            "circle",
            {
                cx: "10",
                cy: "8",
                r: "5",
                key: "o932ke"
            }
        ],
        [
            "path",
            {
                d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3",
                key: "10s06x"
            }
        ]
    ],
    aliases: [
        "users-2"
    ]
};
$8446477c3df1c126$export$a2387ed3b5d536eb.node;
const $8446477c3df1c126$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($8446477c3df1c126$export$a2387ed3b5d536eb);



const $58df888399335ec9$export$d42503afcc3a9b06 = [
    {
        id: 'patients',
        labelKey: 'nav.items.patients',
        Icon: (0, $8446477c3df1c126$export$2e2bcd8739ae039)
    },
    {
        id: 'chatLanding',
        labelKey: 'nav.items.chat',
        Icon: (0, $8c7fae0571c9b8a8$export$2e2bcd8739ae039)
    },
    {
        id: 'credits',
        labelKey: 'nav.items.credits',
        Icon: (0, $eea507cd16630bf5$export$2e2bcd8739ae039)
    },
    {
        id: 'profile',
        labelKey: 'nav.items.profile',
        Icon: (0, $86bc9f94aec05e0c$export$2e2bcd8739ae039)
    }
];
function $58df888399335ec9$export$798863679d04a4c9(pathname) {
    const p = String(pathname || '/');
    if (p === '/chat' || p.startsWith('/chat/') || (0, $16250bd714b02a14$export$daba392f9ff20333)(p)) return 'chatLanding';
    if (p === '/' || p.startsWith('/patients')) return 'patients';
    if (p.startsWith('/credits')) return 'credits';
    if (p.startsWith('/profile')) return 'profile';
    return null;
}
const $58df888399335ec9$export$c8efa7b3e004c1a3 = $58df888399335ec9$export$d42503afcc3a9b06.map((item)=>(0, $16250bd714b02a14$export$cd891b82501bb412)[item.id]());
const $58df888399335ec9$export$3ee288e5161ec231 = (pathname)=>{
    const normalized = String(pathname || '/').replace(/\/+$/, '') || '/';
    return $58df888399335ec9$export$c8efa7b3e004c1a3.includes(normalized);
};
const $58df888399335ec9$export$ce38bb3a9438ace2 = (pathname)=>!(0, $16250bd714b02a14$export$e773cdfa384074bb)(pathname) && !(0, $16250bd714b02a14$export$daba392f9ff20333)(pathname);
var $58df888399335ec9$export$2e2bcd8739ae039 = $58df888399335ec9$export$d42503afcc3a9b06;




var $acw62 = parcelRequire("acw62");




function $4a1b75b8173e62e5$export$2e2bcd8739ae039({ pathname: pathname }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const online = (0, $2a96b0bae45a4311$export$a32c5b7f472865fb)({
        url: (0, $d87bd335296b449f$export$bb117bdb9f34de64)
    });
    const [checking, setChecking] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const retry = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        setChecking(true);
        try {
            await online.check();
        } finally{
            setChecking(false);
        }
    }, [
        online
    ]);
    if ((0, $16250bd714b02a14$export$e773cdfa384074bb)(pathname)) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0790d8ae08647dfa$export$2e2bcd8739ae039), {
        state: online.state,
        recovered: online.recovered,
        onAcknowledgeRecovery: online.acknowledgeRecovery,
        onRetry: retry,
        busy: checking,
        offlineLabel: t('connectivity.offline'),
        degradedLabel: t('connectivity.degraded'),
        restoredLabel: t('connectivity.restored'),
        retryLabel: t('connectivity.retry'),
        busyLabel: t('connectivity.checking')
    });
}


/*
 * RTL layout: the rail is on the RIGHT of the screen.
 * When it collapses, `overflow: hidden` clips from the LEFT — so anything that
 * must stay visible (the toggle, the icons, the avatar) has to be anchored to
 * the RIGHT, i.e. come FIRST in RTL flex order. Every rule below follows from
 * that one sentence.
 */ const $2c32e98b2740ba54$var$MINI = 68; // collapsed width
const $2c32e98b2740ba54$var$FULL = 250; // expanded width
const $2c32e98b2740ba54$var$StudentLayout = ({ children: children })=>{
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const { me: me, balance: balance } = (0, $5bc9ff20f6a2b818$export$f637e1cf42d15a62)();
    const [collapsed, setCollapsed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>typeof window !== 'undefined' && window.innerWidth < 1100);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const mq = window.matchMedia('(max-width: 1100px)');
        const onChange = (e)=>setCollapsed(e.matches);
        mq.addEventListener('change', onChange);
        return ()=>mq.removeEventListener('change', onChange);
    }, []);
    const current = (0, $58df888399335ec9$export$798863679d04a4c9)(location.pathname);
    // Labels live in the DOM always and fade, so the width transition stays smooth.
    const fade = {
        opacity: collapsed ? 0 : 1,
        transition: 'opacity 0.22s ease',
        pointerEvents: collapsed ? 'none' : 'auto',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            width: '100vw',
            height: '100vh',
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    width: collapsed ? $2c32e98b2740ba54$var$MINI : $2c32e98b2740ba54$var$FULL,
                    flexShrink: 0,
                    background: (0, $e7c165fb515b04ea$export$4a4d076b923f4e78),
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    transition: 'width 0.3s cubic-bezier(.4,0,.2,1)',
                    zIndex: 10
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            height: 68,
                            display: 'flex',
                            alignItems: 'center',
                            flexShrink: 0,
                            borderBottom: '1px solid rgba(255,255,255,0.07)'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    width: $2c32e98b2740ba54$var$MINI,
                                    flexShrink: 0,
                                    display: 'flex',
                                    justifyContent: 'center'
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setCollapsed((c)=>!c),
                                    title: collapsed ? t('nav.sidebar.expand') : t('nav.sidebar.collapse'),
                                    "aria-label": collapsed ? t('nav.sidebar.expand') : t('nav.sidebar.collapse'),
                                    style: {
                                        width: 36,
                                        height: 36,
                                        background: 'rgba(255,255,255,0.08)',
                                        border: 'none',
                                        borderRadius: 10,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        color: 'rgba(255,255,255,0.6)'
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "currentColor",
                                        width: "18",
                                        height: "18",
                                        style: {
                                            transition: 'transform 0.3s cubic-bezier(.4,0,.2,1)',
                                            // The glyph points at the rail's own edge, so it mirrors with
                                            // the layout as well as rotating with the toggle.
                                            transform: `scaleX(var(--dir-flip, 1)) rotate(${collapsed ? 0 : 180}deg)`
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10,
                                    paddingInlineStart: 4,
                                    paddingInlineEnd: 8,
                                    ...fade
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f0b50123bb07e4c7$exports))),
                                        alt: "",
                                        style: {
                                            height: '2.2rem',
                                            width: 'auto',
                                            objectFit: 'contain',
                                            flexShrink: 0
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    color: 'white',
                                                    fontSize: 16,
                                                    fontWeight: 800,
                                                    whiteSpace: 'nowrap'
                                                },
                                                children: t('nav.brand.name')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    color: 'rgba(255,255,255,0.45)',
                                                    fontSize: 11,
                                                    whiteSpace: 'nowrap'
                                                },
                                                children: t('nav.brand.panel')
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                        "aria-label": t('nav.landmark.primary'),
                        style: {
                            flex: 1,
                            paddingTop: 10,
                            overflowY: 'auto',
                            overflowX: 'hidden'
                        },
                        children: (0, $58df888399335ec9$export$d42503afcc3a9b06).map((item)=>{
                            const active = current === item.id;
                            const { Icon: Icon } = item;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>navigate(item.id),
                                title: collapsed ? t(item.labelKey) : undefined,
                                "aria-current": active ? 'page' : undefined,
                                style: {
                                    width: 'calc(100% - 20px)',
                                    margin: '2px 10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: 0,
                                    border: 'none',
                                    borderRadius: 10,
                                    background: active ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : 'transparent',
                                    boxShadow: active ? '0 2px 8px rgba(0,0,0,0.22)' : 'none',
                                    cursor: 'pointer',
                                    transition: 'background 0.18s, box-shadow 0.18s',
                                    fontFamily: 'inherit'
                                },
                                onMouseEnter: (e)=>{
                                    if (!active) e.currentTarget.style.background = 'rgba(255,255,255,0.07)';
                                },
                                onMouseLeave: (e)=>{
                                    if (!active) e.currentTarget.style.background = 'transparent';
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            width: $2c32e98b2740ba54$var$MINI - 20,
                                            flexShrink: 0,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '11px 0',
                                            color: active ? 'white' : 'rgba(255,255,255,0.55)'
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                            size: 20,
                                            "aria-hidden": true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            ...fade,
                                            color: active ? 'white' : 'rgba(255,255,255,0.55)',
                                            fontSize: 14,
                                            fontWeight: active ? 700 : 500
                                        },
                                        children: t(item.labelKey)
                                    })
                                ]
                            }, item.id);
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>navigate('credits'),
                        title: t('nav.balance.label'),
                        "aria-label": t('nav.balance.label'),
                        "data-testid": "rail-balance",
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            margin: '0 0 6px',
                            padding: 0,
                            border: 'none',
                            background: 'transparent',
                            cursor: 'pointer',
                            fontFamily: 'inherit',
                            flexShrink: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    width: $2c32e98b2740ba54$var$MINI,
                                    flexShrink: 0,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eea507cd16630bf5$export$2e2bcd8739ae039), {
                                    size: 19,
                                    "aria-hidden": true
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    ...fade,
                                    display: 'flex',
                                    alignItems: 'baseline',
                                    gap: 6
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            color: 'rgba(255,255,255,0.45)',
                                            fontSize: 11
                                        },
                                        children: t('nav.balance.label')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                                            fontSize: 14,
                                            fontWeight: 800
                                        },
                                        children: balance == null ? t('common.labels.none') : (0, $9ffff9692ff7166c$export$63e20163a2b1658b)(balance, formatNumber)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            color: 'rgba(255,255,255,0.45)',
                                            fontSize: 11
                                        },
                                        children: t('common.units.parseh')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            padding: '14px 0',
                            borderTop: '1px solid rgba(255,255,255,0.07)',
                            flexShrink: 0,
                            overflow: 'hidden'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                onClick: ()=>navigate('profile'),
                                role: "button",
                                tabIndex: 0,
                                "aria-label": t('nav.sidebar.editProfile'),
                                onKeyDown: (e)=>{
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        navigate('profile');
                                    }
                                },
                                title: t('nav.sidebar.editProfile'),
                                style: {
                                    width: $2c32e98b2740ba54$var$MINI,
                                    flexShrink: 0,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    cursor: 'pointer'
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a53b6ea678d7efe0$export$2e2bcd8739ae039), {
                                    name: me?.fullName || '',
                                    size: 36,
                                    bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                "aria-hidden": collapsed || undefined,
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    flex: 1,
                                    overflow: 'hidden',
                                    ...fade
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        onClick: ()=>navigate('profile'),
                                        role: "button",
                                        tabIndex: collapsed ? -1 : 0,
                                        onKeyDown: (e)=>{
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                navigate('profile');
                                            }
                                        },
                                        style: {
                                            flex: 1,
                                            overflow: 'hidden',
                                            cursor: 'pointer'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    color: 'white',
                                                    fontSize: 13,
                                                    fontWeight: 700,
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                },
                                                children: me?.fullName || t('common.labels.none')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    color: 'rgba(255,255,255,0.4)',
                                                    fontSize: 11,
                                                    marginTop: 2,
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                },
                                                children: t('nav.brand.panel')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>(0, $3bdb28763df76ec7$export$a0973bcfe11b05c9)(),
                                        tabIndex: collapsed ? -1 : 0,
                                        title: t('nav.sidebar.logout'),
                                        "aria-label": t('nav.sidebar.logout'),
                                        style: {
                                            background: 'transparent',
                                            border: 'none',
                                            cursor: 'pointer',
                                            color: 'rgba(255,255,255,0.4)',
                                            padding: 4,
                                            borderRadius: 6,
                                            display: 'flex',
                                            flexShrink: 0
                                        },
                                        onMouseEnter: (e)=>{
                                            e.currentTarget.style.color = 'white';
                                        },
                                        onMouseLeave: (e)=>{
                                            e.currentTarget.style.color = 'rgba(255,255,255,0.4)';
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe506e7c2094458f$export$2e2bcd8739ae039), {
                                            size: 16,
                                            "aria-hidden": true
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                "aria-label": t('nav.landmark.content'),
                style: {
                    flex: 1,
                    minWidth: 0,
                    minHeight: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a1b75b8173e62e5$export$2e2bcd8739ae039), {
                        pathname: location.pathname
                    }),
                    children
                ]
            })
        ]
    });
};
var $2c32e98b2740ba54$export$2e2bcd8739ae039 = $2c32e98b2740ba54$var$StudentLayout;




var $acw62 = parcelRequire("acw62");







// The mobile shell — what replaces StudentLayout below 768px.
//
// The rail is not collapsed here, it is GONE: a 68px mini-rail on a 360px
// viewport is a shrunken workstation, and it spends 19% of the width on chrome a
// thumb cannot comfortably reach. Each screen supplies its own gradient
// MobileHeader; this file owns two things only — the single page scroll, and the
// bar.
/*
 * `position: fixed; inset: 0` is LOAD-BEARING, not a style choice.
 *
 * styles.css sets `#root { display:flex; align-items:center; justify-content:
 * center; min-height:100vh }` over `body { background:#0f1923 }` — the frame the
 * pre-app auth screens are centred in. A flow-positioned mobile shell inherits
 * that and renders as a centred box floating on a dark page. Taking the shell out
 * of flow is what makes the app fill the phone.
 *
 * It is also the shape "one page-level scroll" needs: an `inset:0;
 * overflow:hidden` root with exactly ONE inner scroll region. (The kit's
 * ChatThread documents the same thing when it resolves its scroller — a mobile
 * shell is not the document.)
 */ const $3dffe7472d2e8d91$var$ROOT = {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
    // The TOP safe-area inset belongs to MobileHeader and the BOTTOM to BottomNav,
    // so what is left for the root is the notch's left and right — the landscape
    // case, where content would otherwise run under the rounded corners.
    paddingInlineStart: 'env(safe-area-inset-left, 0px)',
    paddingInlineEnd: 'env(safe-area-inset-right, 0px)'
};
/*
 * The body does NOT scroll — each screen owns exactly ONE scroll region inside
 * it. A scrolling body here would make two: the screen's own scroller nested in
 * the shell's. It would also take away the choice of whether a screen's header
 * is pinned or scrolls away, which is decided by whether the screen puts its
 * MobileHeader inside its scroller — and that choice only exists if the shell is
 * not scrolling for it.
 */ const $3dffe7472d2e8d91$var$BODY = {
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
};
const $3dffe7472d2e8d91$var$MobileShell = ({ children: children })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const active = (0, $58df888399335ec9$export$798863679d04a4c9)(location.pathname);
    // The bar hides on the two FULL-HEIGHT workspaces — the visit and the chat
    // page (core.md §7.0) — and renders everywhere else, the patient record
    // included: the record is a destination a student moves in and out of, and a
    // bar there is the shortest way back to the list. A bar on the chat page, by
    // contrast, would offer «پارسه» as an escape from an answer they have already
    // paid for and not yet read; both workspaces carry their own back button.
    const showNav = (0, $58df888399335ec9$export$ce38bb3a9438ace2)(location.pathname);
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $58df888399335ec9$export$d42503afcc3a9b06).map(({ id: id, labelKey: labelKey, Icon: Icon })=>({
                key: id,
                label: t(labelKey),
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    size: 22,
                    "aria-hidden": true
                })
            })), [
        t
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: $3dffe7472d2e8d91$var$ROOT,
        "data-testid": "mobile-shell",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                "aria-label": t('nav.landmark.content'),
                style: $3dffe7472d2e8d91$var$BODY,
                "data-testid": "mobile-scroll",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a1b75b8173e62e5$export$2e2bcd8739ae039), {
                        pathname: location.pathname
                    }),
                    children
                ]
            }),
            showNav && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5943a0a75dff01a1$export$2e2bcd8739ae039), {
                items: items,
                active: active,
                onSelect: (key)=>navigate(key),
                "data-testid": "student-bottom-nav",
                // The kit hardcodes a Persian `aria-label`, and its `...rest` spreads
                // AFTER it, so a caller-supplied one wins. This app ships `en` too.
                "aria-label": t('nav.landmark.primary')
            })
        ]
    });
};
var $3dffe7472d2e8d91$export$2e2bcd8739ae039 = $3dffe7472d2e8d91$var$MobileShell;




var $acw62 = parcelRequire("acw62");





const $e0e913fecbda1d3d$export$cf82244f186e9acc = [
    {
        combo: 'ctrl+s',
        labelKey: 'visit.shortcuts.save'
    },
    {
        combo: 'ctrl+1',
        labelKey: 'visit.shortcuts.tab1'
    },
    {
        combo: 'ctrl+2',
        labelKey: 'visit.shortcuts.tab2'
    },
    {
        combo: 'ctrl+3',
        labelKey: 'visit.shortcuts.tab3'
    },
    {
        combo: 'ctrl+4',
        labelKey: 'visit.shortcuts.tab4'
    },
    {
        combo: 'ctrl+enter',
        labelKey: 'visit.shortcuts.send'
    },
    {
        combo: 'ctrl+shift+e',
        labelKey: 'visit.shortcuts.end'
    }
];
// This component is mounted OUTSIDE the router (App.jsx renders it beside the
// gate, so it exists on the sign-in and onboarding screens too), so it cannot
// ask `useLocation`. The pathname is read when the overlay OPENS — that is
// the only moment the answer is rendered.
const $e0e913fecbda1d3d$var$onVisitRoute = ()=>typeof window !== 'undefined' && (0, $16250bd714b02a14$export$e773cdfa384074bb)(window.location?.pathname || '');
const $e0e913fecbda1d3d$var$ROW = {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '6px 0',
    borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
    fontSize: 13,
    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
};
const $e0e913fecbda1d3d$var$KBD = {
    marginInlineStart: 'auto',
    unicodeBidi: 'isolate',
    fontSize: 11.5,
    fontWeight: 700,
    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).bg,
    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
    borderRadius: 6,
    padding: '2px 7px',
    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
};
const $e0e913fecbda1d3d$var$HEADING = {
    margin: '0 0 6px',
    fontSize: 11.5,
    fontWeight: 800,
    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
};
function $e0e913fecbda1d3d$var$ShortcutRow({ combo: combo, label: label }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: $e0e913fecbda1d3d$var$ROW,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("kbd", {
                dir: "ltr",
                style: $e0e913fecbda1d3d$var$KBD,
                children: (0, $0277e73c10ea225a$export$f5026c738b75de96)(combo)
            })
        ]
    });
}
function $e0e913fecbda1d3d$export$2e2bcd8739ae039() {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const { open: open, setOpen: setOpen } = (0, $0277e73c10ea225a$export$a11896fcfbddc990)();
    const groups = (0, $0277e73c10ea225a$export$8dc9f6f80a84c72b)();
    // Decided per opening, not per render: the pathname can only change while
    // the overlay is closed (opening it is a keypress on a settled screen).
    const showReference = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>open ? !$e0e913fecbda1d3d$var$onVisitRoute() : false, [
        open
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
        open: open,
        onOpenChange: setOpen,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
            size: "sm",
            "data-testid": "shortcut-help",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$742513523b177e3b), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
                        children: t('shortcuts.title')
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$5d20f2c38fcde41f), {
                    children: [
                        groups.length === 0 && !showReference && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                margin: 0,
                                fontSize: 13,
                                color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                            },
                            children: t('shortcuts.empty')
                        }),
                        groups.map(({ group: group, items: items })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                style: {
                                    marginBottom: 14
                                },
                                children: [
                                    group && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        style: $e0e913fecbda1d3d$var$HEADING,
                                        children: group
                                    }),
                                    items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e0e913fecbda1d3d$var$ShortcutRow, {
                                            combo: item.combo,
                                            label: item.label
                                        }, item.combo))
                                ]
                            }, group || 'default')),
                        showReference && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            style: {
                                marginBottom: 14
                            },
                            "data-testid": "shortcut-help-visit-reference",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    style: $e0e913fecbda1d3d$var$HEADING,
                                    children: t('shortcuts.groups.insideVisit')
                                }),
                                $e0e913fecbda1d3d$export$cf82244f186e9acc.map(({ combo: combo, labelKey: labelKey })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e0e913fecbda1d3d$var$ShortcutRow, {
                                        combo: combo,
                                        label: t(labelKey)
                                    }, combo))
                            ]
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");




function $c921c2d931f52605$export$2e2bcd8739ae039() {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [event, setEvent] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const watcher = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        watcher.current = (0, $d4d7a25942cf3f48$export$73946e6b8a04196b)();
        // Only the TOKEN events: the bus also carries NOT_ONBOARDED, which App.jsx
        // handles by re-booting — rendering the «نشست به پایان رسید» dialog for it
        // would tell a student with a perfectly good session to sign in again.
        const off = (0, $d4d7a25942cf3f48$export$a883a9af61079ac7)((next)=>{
            if ((0, $d4d7a25942cf3f48$export$a10a125b4e7d71f8)(next)) setEvent(next);
        });
        return ()=>{
            off();
            watcher.current?.cancel();
        };
    }, []);
    const stay = async ()=>{
        setBusy(true);
        const ok = await (0, $d4d7a25942cf3f48$export$d0caa90bfa1dd141)();
        setBusy(false);
        if (ok) {
            setEvent(null);
            // A renewed refresh token means a new expiry: the timers have to be
            // re-armed against it, or the next warning never fires.
            watcher.current?.rearm();
            return;
        }
        // The renewal failed, so the session is effectively over — say so instead of
        // leaving a dialog that has quietly stopped working.
        setEvent((0, $d4d7a25942cf3f48$export$3b6ed64b5b4e542d).EXPIRED);
    };
    const signIn = ()=>{
        (0, $d4d7a25942cf3f48$export$4986ea797be155b1)();
        (0, $3bdb28763df76ec7$export$2fb87bbf5418dbe1)();
    };
    if (!event) return null;
    if (event === (0, $d4d7a25942cf3f48$export$3b6ed64b5b4e542d).EXPIRING) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
        open: true,
        onOpenChange: (next)=>{
            if (!next) setEvent(null);
        },
        title: t('auth.session.expiringTitle'),
        description: t('auth.session.expiringBody'),
        confirmLabel: t('auth.session.staySignedIn'),
        cancelLabel: t('common.actions.close'),
        loading: busy,
        onConfirm: stay,
        confirmTestId: "session-extend",
        "data-testid": "session-expiring"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
        open: true,
        // No dismissal: every request behind this dialog now fails.
        onOpenChange: ()=>{},
        title: t('auth.session.expiredTitle'),
        description: `${t('auth.session.expiredBody')} ${t('auth.session.returnNotice')}`,
        confirmLabel: t('auth.session.signInAgain'),
        cancelLabel: t('common.actions.close'),
        onConfirm: signIn,
        confirmTestId: "session-signin",
        "data-testid": "session-expired"
    });
}



parcelRequire("acw62");


parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $59813a4678999ce6$export$a2387ed3b5d536eb = {
    name: "log-in",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m10 17 5-5-5-5",
                key: "1bsop3"
            }
        ],
        [
            "path",
            {
                d: "M15 12H3",
                key: "6jk70r"
            }
        ],
        [
            "path",
            {
                d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4",
                key: "u53s6r"
            }
        ]
    ]
};
$59813a4678999ce6$export$a2387ed3b5d536eb.node;
const $59813a4678999ce6$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($59813a4678999ce6$export$a2387ed3b5d536eb);





// ورود — what the sign-in screen says this app is, in three lines.
//
// The list is here rather than in either surface file because both render it and
// two copies drift. It is also, deliberately, the whole product (core.md §7.1):
// «بیمار تمرینی بسازید» · «ویزیت را مستند کنید» · «با دستیار آموزشی گفتگو کنید».
// A fourth entry would be a promise about a screen that does not exist (core.md
// §18 lists what this app is not), and the sign-in screen is the one place a
// promise like that is never checked against reality.
//
// `titleKey`/`bodyKey` rather than text: this module is module-level and cannot
// call a hook. tests/screens.test.jsx pins that every key here resolves in BOTH
// catalogues — the first draft named `login.feature.history.*`, which no
// catalogue carried, and the screen rendered the raw dotted keys.
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ccc74fc270115805$export$a2387ed3b5d536eb = {
    name: "notebook-pen",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4",
                key: "re6nr2"
            }
        ],
        [
            "path",
            {
                d: "M2 6h4",
                key: "aawbzj"
            }
        ],
        [
            "path",
            {
                d: "M2 10h4",
                key: "l0bgd4"
            }
        ],
        [
            "path",
            {
                d: "M2 14h4",
                key: "1gsvsf"
            }
        ],
        [
            "path",
            {
                d: "M2 18h4",
                key: "1bu2t1"
            }
        ],
        [
            "path",
            {
                d: "M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
                key: "pqwjuv"
            }
        ]
    ]
};
$ccc74fc270115805$export$a2387ed3b5d536eb.node;
const $ccc74fc270115805$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($ccc74fc270115805$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $02839c5704f38745$export$a2387ed3b5d536eb = {
    name: "stethoscope",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M11 2v2",
                key: "1539x4"
            }
        ],
        [
            "path",
            {
                d: "M5 2v2",
                key: "1yf1q8"
            }
        ],
        [
            "path",
            {
                d: "M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1",
                key: "rb5t3r"
            }
        ],
        [
            "path",
            {
                d: "M8 15a6 6 0 0 0 12 0v-3",
                key: "x18d4x"
            }
        ],
        [
            "circle",
            {
                cx: "20",
                cy: "10",
                r: "2",
                key: "ts1r5v"
            }
        ]
    ]
};
$02839c5704f38745$export$a2387ed3b5d536eb.node;
const $02839c5704f38745$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($02839c5704f38745$export$a2387ed3b5d536eb);


const $7aa053fb1355ee91$export$73c303ca0862b2a3 = [
    {
        id: 'case',
        titleKey: 'login.feature.case.title',
        bodyKey: 'login.feature.case.body',
        Icon: (0, $ccc74fc270115805$export$2e2bcd8739ae039)
    },
    {
        id: 'visit',
        titleKey: 'login.feature.visit.title',
        bodyKey: 'login.feature.visit.body',
        Icon: (0, $02839c5704f38745$export$2e2bcd8739ae039)
    },
    {
        id: 'chat',
        titleKey: 'login.feature.chat.title',
        bodyKey: 'login.feature.chat.body',
        Icon: (0, $8c7fae0571c9b8a8$export$2e2bcd8739ae039)
    }
];
var $7aa053fb1355ee91$export$2e2bcd8739ae039 = $7aa053fb1355ee91$export$73c303ca0862b2a3;


function $82dd070ef5d8b806$export$2e2bcd8739ae039({ onSignIn: onSignIn, busy: busy = false, notice: notice = '' }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            display: 'flex',
            width: '100vw',
            minHeight: '100vh',
            background: (0, $e7c165fb515b04ea$export$4c2e201e0b6dbaa3),
            padding: 24,
            alignItems: 'center',
            justifyContent: 'center'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                display: 'grid',
                gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 380px)',
                gap: 40,
                width: '100%',
                maxWidth: 940,
                alignItems: 'center'
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        color: '#fff',
                        minWidth: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 12,
                                marginBottom: 22
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f0b50123bb07e4c7$exports))),
                                    alt: "",
                                    style: {
                                        height: '2.6rem',
                                        width: 'auto',
                                        objectFit: 'contain'
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                fontSize: 19,
                                                fontWeight: 800
                                            },
                                            children: t('nav.brand.name')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                fontSize: 12.5,
                                                color: 'rgba(255,255,255,0.6)'
                                            },
                                            children: t('nav.brand.panel')
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            style: {
                                margin: '0 0 10px',
                                fontSize: 30,
                                fontWeight: 800,
                                lineHeight: 1.4
                            },
                            children: t('login.title')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                margin: '0 0 28px',
                                fontSize: 15,
                                lineHeight: 1.9,
                                color: 'rgba(255,255,255,0.72)'
                            },
                            children: t('login.sub')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                            style: {
                                listStyle: 'none',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 16
                            },
                            children: (0, $7aa053fb1355ee91$export$73c303ca0862b2a3).map(({ id: id, titleKey: titleKey, bodyKey: bodyKey, Icon: Icon })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        gap: 12
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                width: 38,
                                                height: 38,
                                                borderRadius: 11,
                                                background: 'rgba(255,255,255,0.12)',
                                                display: 'grid',
                                                placeItems: 'center',
                                                flexShrink: 0
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                                size: 18,
                                                "aria-hidden": true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                minWidth: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: 14.5,
                                                        fontWeight: 700
                                                    },
                                                    children: t(titleKey)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: 13,
                                                        lineHeight: 1.8,
                                                        color: 'rgba(255,255,255,0.6)'
                                                    },
                                                    children: t(bodyKey)
                                                })
                                            ]
                                        })
                                    ]
                                }, id))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                        borderRadius: 18,
                        padding: 30,
                        boxShadow: '0 32px 80px rgba(0,0,0,0.3)',
                        textAlign: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 7,
                                background: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal, 0.14),
                                color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk,
                                borderRadius: 999,
                                padding: '6px 14px',
                                fontSize: 12.5,
                                fontWeight: 700,
                                marginBottom: 18
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eea507cd16630bf5$export$2e2bcd8739ae039), {
                                    size: 14,
                                    "aria-hidden": true
                                }),
                                t('login.free')
                            ]
                        }),
                        notice && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                            variant: "warning",
                            style: {
                                marginBottom: 14,
                                textAlign: 'start'
                            },
                            "data-testid": "login-notice",
                            children: notice
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            size: "lg",
                            onClick: onSignIn,
                            disabled: busy,
                            className: "w-full",
                            "data-testid": "login-action",
                            children: [
                                busy ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                    size: 16,
                                    color: "#fff"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59813a4678999ce6$export$2e2bcd8739ae039), {
                                    size: 17,
                                    "aria-hidden": true
                                }),
                                busy ? t('login.working') : t('login.action')
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                margin: '14px 0 0',
                                fontSize: 12,
                                lineHeight: 1.9,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                            },
                            children: t('login.hint')
                        })
                    ]
                })
            ]
        })
    });
}



parcelRequire("acw62");






function $ffe3b58a9a6089e4$export$2e2bcd8739ae039({ onSignIn: onSignIn, busy: busy = false, notice: notice = '' }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            position: 'fixed',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            background: (0, $e7c165fb515b04ea$export$4c2e201e0b6dbaa3),
            color: '#fff',
            paddingInlineStart: 'env(safe-area-inset-left, 0px)',
            paddingInlineEnd: 'env(safe-area-inset-right, 0px)'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    padding: 'calc(1.75rem + env(safe-area-inset-top, 0px)) 1.25rem 1.25rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            marginBottom: 20
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f0b50123bb07e4c7$exports))),
                                alt: "",
                                style: {
                                    height: '2.1rem',
                                    width: 'auto',
                                    objectFit: 'contain'
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 16,
                                            fontWeight: 800
                                        },
                                        children: t('nav.brand.name')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 11.5,
                                            color: 'rgba(255,255,255,0.6)'
                                        },
                                        children: t('nav.brand.panel')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        style: {
                            margin: '0 0 8px',
                            fontSize: 22,
                            fontWeight: 800,
                            lineHeight: 1.5
                        },
                        children: t('login.title')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            margin: '0 0 20px',
                            fontSize: 14,
                            lineHeight: 1.9,
                            color: 'rgba(255,255,255,0.72)'
                        },
                        children: t('login.sub')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 7,
                            background: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal, 0.2),
                            color: '#fff',
                            borderRadius: 999,
                            padding: '6px 14px',
                            fontSize: 12.5,
                            fontWeight: 700,
                            marginBottom: 20
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eea507cd16630bf5$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true
                            }),
                            t('login.free')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        style: {
                            listStyle: 'none',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 14
                        },
                        children: (0, $7aa053fb1355ee91$export$73c303ca0862b2a3).map(({ id: id, titleKey: titleKey, bodyKey: bodyKey, Icon: Icon })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: 11
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            width: 34,
                                            height: 34,
                                            borderRadius: 10,
                                            background: 'rgba(255,255,255,0.12)',
                                            display: 'grid',
                                            placeItems: 'center',
                                            flexShrink: 0
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                            size: 16,
                                            "aria-hidden": true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 13.5,
                                                    fontWeight: 700
                                                },
                                                children: t(titleKey)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 12.5,
                                                    lineHeight: 1.8,
                                                    color: 'rgba(255,255,255,0.6)'
                                                },
                                                children: t(bodyKey)
                                            })
                                        ]
                                    })
                                ]
                            }, id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flexShrink: 0,
                    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                    borderStartStartRadius: 20,
                    borderStartEndRadius: 20,
                    padding: '1.25rem 1.25rem calc(1.25rem + env(safe-area-inset-bottom, 0px))',
                    textAlign: 'center'
                },
                children: [
                    notice && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "warning",
                        style: {
                            marginBottom: 12,
                            textAlign: 'start'
                        },
                        "data-testid": "login-notice",
                        children: notice
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "lg",
                        onClick: onSignIn,
                        disabled: busy,
                        className: "w-full min-h-12",
                        "data-testid": "login-action",
                        children: [
                            busy ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                size: 16,
                                color: "#fff"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59813a4678999ce6$export$2e2bcd8739ae039), {
                                size: 17,
                                "aria-hidden": true
                            }),
                            busy ? t('login.working') : t('login.action')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            margin: '12px 0 0',
                            fontSize: 12,
                            lineHeight: 1.9,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                        },
                        children: t('login.hint')
                    })
                ]
            })
        ]
    });
}


// ورود — two surfaces, ONE auth flow.
//
// This screen is rendered by App.jsx's gate when there is no usable token, and it
// exists instead of an immediate `redirectToLogin()` for a reason worth stating:
// an app that bounces to Keycloak on load has no frame in which to show
// `auth.loopError` when the redirect guard trips, and no page for a student who
// arrived from a bookmark to read before being thrown at an identity provider.
//
// The button is what starts the OIDC Authorization Code + PKCE flow, against the
// `parsina-student` client id baked in at build time (src/lib/auth.js). Nothing
// about that flow differs by surface — only the layout does.
const $243b4db2aca31c25$var$LoginScreen = (props)=>{
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    return isMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ffe3b58a9a6089e4$export$2e2bcd8739ae039), {
        ...props
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82dd070ef5d8b806$export$2e2bcd8739ae039), {
        ...props
    });
};
var $243b4db2aca31c25$export$2e2bcd8739ae039 = $243b4db2aca31c25$var$LoginScreen;




var $acw62 = parcelRequire("acw62");





// Unsaved work that survives a session ending. core.md §15.
//
// Every storage access is wrapped in try/catch and the app renders correctly
// with no stored value: private mode, a browser configured to block site data,
// and a quota error all throw from the accessor itself, and a throw there would
// take a screen down for a convenience.
//
//   composer drafts  — sessionStorage `chat_draft_<threadId | new:caseId>`
//                      (this TAB's typing; two tabs must not overwrite each other)
//   SOAP drafts      — localStorage `visit_draft_<encounterId>` (must survive a
//                      re-login, which is a full-document navigation)
//   UI preferences   — localStorage (`chat_sidebar_v1`, `visit_rail_v1`, …)
const $7cdea07122bc6887$var$storageOf = (kind)=>{
    try {
        if (typeof window === 'undefined') return null;
        return kind === 'local' ? window.localStorage : window.sessionStorage;
    } catch  {
        return null;
    }
};
function $7cdea07122bc6887$export$1ffff020952d8ba9(key, { kind: kind = 'session' } = {}) {
    try {
        const raw = $7cdea07122bc6887$var$storageOf(kind)?.getItem(key);
        return raw == null ? null : raw;
    } catch  {
        return null;
    }
}
function $7cdea07122bc6887$export$a89cf18a33e7b3d9(key, value, { kind: kind = 'session' } = {}) {
    try {
        const store = $7cdea07122bc6887$var$storageOf(kind);
        if (!store) return false;
        if (value == null || value === '') store.removeItem(key);
        else store.setItem(key, String(value));
        return true;
    } catch  {
        return false;
    }
}
function $7cdea07122bc6887$export$eeeb486534738631(key, { kind: kind = 'session' } = {}) {
    try {
        $7cdea07122bc6887$var$storageOf(kind)?.removeItem(key);
    } catch  {}
}
function $7cdea07122bc6887$export$6a368473377ea45c(key, { kind: kind = 'local', fallback: fallback = null } = {}) {
    const raw = $7cdea07122bc6887$export$1ffff020952d8ba9(key, {
        kind: kind
    });
    if (raw == null) return fallback;
    try {
        return JSON.parse(raw);
    } catch  {
        return fallback;
    }
}
function $7cdea07122bc6887$export$476f628a921f7411(key, value, { kind: kind = 'local' } = {}) {
    if (value == null) {
        $7cdea07122bc6887$export$eeeb486534738631(key, {
            kind: kind
        });
        return true;
    }
    try {
        return $7cdea07122bc6887$export$a89cf18a33e7b3d9(key, JSON.stringify(value), {
            kind: kind
        });
    } catch  {
        return false;
    }
}
const $7cdea07122bc6887$export$2ea236196864e117 = ({ threadId: threadId, caseId: caseId })=>`chat_draft_${threadId || `new:${caseId}`}`;
const $7cdea07122bc6887$export$ccbaef21cdaec5bc = (encounterId)=>`visit_draft_${encounterId}`;
const $7cdea07122bc6887$export$f2729d139f5f76bb = 'chat_sidebar_v1';
const $7cdea07122bc6887$export$ed9d413e2a8761b7 = 'visit_rail_v1';
const $7cdea07122bc6887$export$ca82dfc30f88f41c = 'record_sections_v1';
const $7cdea07122bc6887$export$6bfff27528cc6873 = 'onboarding_draft';



parcelRequire("acw62");




parcelRequire("acw62");


// i18n-exempt: data, not copy — the names of Iranian medical universities, in
// both scripts, for the onboarding form's <datalist>. core.md §4.3: a datalist
// the student can ignore, NOT a validated set — a university that is missing
// here is typed in free text and stored as typed.
//
// Each entry carries its own English name rather than a catalogue key: these
// are proper nouns, and the catalogue parity test has nothing to say about
// whether «دانشگاه علوم پزشکی تهران» is "translated".
const $c4345f5c1e1b74b6$export$1314b509de787fd9 = [
    {
        id: 'tums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u062A\u0647\u0631\u0627\u0646",
        en: 'Tehran University of Medical Sciences'
    },
    {
        id: 'sbmu',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0634\u0647\u06CC\u062F \u0628\u0647\u0634\u062A\u06CC",
        en: 'Shahid Beheshti University of Medical Sciences'
    },
    {
        id: 'iums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0627\u06CC\u0631\u0627\u0646",
        en: 'Iran University of Medical Sciences'
    },
    {
        id: 'sums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0634\u06CC\u0631\u0627\u0632",
        en: 'Shiraz University of Medical Sciences'
    },
    {
        id: 'mui',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0627\u0635\u0641\u0647\u0627\u0646",
        en: 'Isfahan University of Medical Sciences'
    },
    {
        id: 'mums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0645\u0634\u0647\u062F",
        en: 'Mashhad University of Medical Sciences'
    },
    {
        id: 'tbzmed',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u062A\u0628\u0631\u06CC\u0632",
        en: 'Tabriz University of Medical Sciences'
    },
    {
        id: 'ajums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u062C\u0646\u062F\u06CC\u200C\u0634\u0627\u067E\u0648\u0631 \u0627\u0647\u0648\u0627\u0632",
        en: 'Ahvaz Jundishapur University of Medical Sciences'
    },
    {
        id: 'kmu',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u06A9\u0631\u0645\u0627\u0646",
        en: 'Kerman University of Medical Sciences'
    },
    {
        id: 'kums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u06A9\u0631\u0645\u0627\u0646\u0634\u0627\u0647",
        en: 'Kermanshah University of Medical Sciences'
    },
    {
        id: 'gums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u06AF\u06CC\u0644\u0627\u0646",
        en: 'Guilan University of Medical Sciences'
    },
    {
        id: 'mazums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0645\u0627\u0632\u0646\u062F\u0631\u0627\u0646",
        en: 'Mazandaran University of Medical Sciences'
    },
    {
        id: 'umsu',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0627\u0631\u0648\u0645\u06CC\u0647",
        en: 'Urmia University of Medical Sciences'
    },
    {
        id: 'zums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0632\u0646\u062C\u0627\u0646",
        en: 'Zanjan University of Medical Sciences'
    },
    {
        id: 'qums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0642\u0632\u0648\u06CC\u0646",
        en: 'Qazvin University of Medical Sciences'
    },
    {
        id: 'muq',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0642\u0645",
        en: 'Qom University of Medical Sciences'
    },
    {
        id: 'hums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0647\u0631\u0645\u0632\u06AF\u0627\u0646",
        en: 'Hormozgan University of Medical Sciences'
    },
    {
        id: 'umsha',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0647\u0645\u062F\u0627\u0646",
        en: 'Hamadan University of Medical Sciences'
    },
    {
        id: 'arakmu',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0627\u0631\u0627\u06A9",
        en: 'Arak University of Medical Sciences'
    },
    {
        id: 'ssu',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u06CC\u0632\u062F",
        en: 'Shahid Sadoughi University of Medical Sciences, Yazd'
    },
    {
        id: 'zaums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0632\u0627\u0647\u062F\u0627\u0646",
        en: 'Zahedan University of Medical Sciences'
    },
    {
        id: 'bums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0628\u06CC\u0631\u062C\u0646\u062F",
        en: 'Birjand University of Medical Sciences'
    },
    {
        id: 'goums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u06AF\u0644\u0633\u062A\u0627\u0646",
        en: 'Golestan University of Medical Sciences'
    },
    {
        id: 'semums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0633\u0645\u0646\u0627\u0646",
        en: 'Semnan University of Medical Sciences'
    },
    {
        id: 'shmu',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0634\u0627\u0647\u0631\u0648\u062F",
        en: 'Shahroud University of Medical Sciences'
    },
    {
        id: 'lums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0644\u0631\u0633\u062A\u0627\u0646",
        en: 'Lorestan University of Medical Sciences'
    },
    {
        id: 'medilam',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0627\u06CC\u0644\u0627\u0645",
        en: 'Ilam University of Medical Sciences'
    },
    {
        id: 'muk',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u06A9\u0631\u062F\u0633\u062A\u0627\u0646",
        en: 'Kurdistan University of Medical Sciences'
    },
    {
        id: 'arums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0627\u0631\u062F\u0628\u06CC\u0644",
        en: 'Ardabil University of Medical Sciences'
    },
    {
        id: 'bpums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0628\u0648\u0634\u0647\u0631",
        en: 'Bushehr University of Medical Sciences'
    },
    {
        id: 'yums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u06CC\u0627\u0633\u0648\u062C",
        en: 'Yasuj University of Medical Sciences'
    },
    {
        id: 'skums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0634\u0647\u0631\u06A9\u0631\u062F",
        en: 'Shahrekord University of Medical Sciences'
    },
    {
        id: 'kaums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u06A9\u0627\u0634\u0627\u0646",
        en: 'Kashan University of Medical Sciences'
    },
    {
        id: 'sbums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0633\u0628\u0632\u0648\u0627\u0631",
        en: 'Sabzevar University of Medical Sciences'
    },
    {
        id: 'gmu',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u06AF\u0646\u0627\u0628\u0627\u062F",
        en: 'Gonabad University of Medical Sciences'
    },
    {
        id: 'rums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0631\u0641\u0633\u0646\u062C\u0627\u0646",
        en: 'Rafsanjan University of Medical Sciences'
    },
    {
        id: 'jums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u062C\u0647\u0631\u0645",
        en: 'Jahrom University of Medical Sciences'
    },
    {
        id: 'fums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0641\u0633\u0627",
        en: 'Fasa University of Medical Sciences'
    },
    {
        id: 'abzums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0627\u0644\u0628\u0631\u0632",
        en: 'Alborz University of Medical Sciences'
    },
    {
        id: 'dums',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u062F\u0632\u0641\u0648\u0644",
        en: 'Dezful University of Medical Sciences'
    },
    {
        id: 'iau',
        fa: "\u062F\u0627\u0646\u0634\u06AF\u0627\u0647 \u0622\u0632\u0627\u062F \u0627\u0633\u0644\u0627\u0645\u06CC \u2014 \u0639\u0644\u0648\u0645 \u067E\u0632\u0634\u06A9\u06CC \u062A\u0647\u0631\u0627\u0646",
        en: "Islamic Azad University \u2014 Tehran Medical Sciences"
    }
];
const $c4345f5c1e1b74b6$export$4c4acbeffb8ae522 = (locale)=>$c4345f5c1e1b74b6$export$1314b509de787fd9.map((u)=>locale === 'en' ? u.en : u.fa);
var $c4345f5c1e1b74b6$export$2e2bcd8739ae039 = $c4345f5c1e1b74b6$export$1314b509de787fd9;


// The onboarding form's rules — core.md §4.3, field for field.
//
// Pure and React-free, so both surfaces and tests/screens.test.jsx read the same
// validation. The two surfaces differ in chrome (a card on a desktop, a full
// scroll on a phone); they do not differ in what a valid answer is.
//
// ── One step, no wizard ───────────────────────────────────────────────────
//
// A student has nothing to resolve beyond who they are: no clinic to join, no
// licence to verify, no specialty tree to walk. The doctor app's multi-step
// registration exists because a doctor's answers CONDITION each other; none of
// these do, except `field`, which is shown only for a resident.
// The closed sets of core.md §5.3, byte-for-byte with the BFF's
// `src/lib/vocabulary.js` and the store's `casework.py`, plus the catalogue key
// each value renders under.
//
// ── Two kinds of mapper, deliberately ─────────────────────────────────────
//
// The sets this APP owns (`level`, `sex`, `kind`, `status`, …) get TOTAL mappers:
// anything unrecognised folds onto the store's own default, so a catalogue key
// always resolves and a badge never prints a raw dotted string.
//
// The vocabularies that come out of the AI service's rule engine (`severity`,
// `warningType`, `source`) and the model's own self-assessment (`confidence`,
// `likelihood`) get PARTIAL mappers that return null for an unknown value. Those
// outputs are forwarded verbatim by the BFF (core.md §8.4) and folding an unknown
// `severity` onto «متوسط» would be a rewrite of a safety warning, done in the
// browser. The panels print the raw value when the mapper answers null.
//
// tests/i18n.test.js walks every set through its mapper and asserts the key
// exists in both catalogues.
const $b9b56989c1caf471$var$total = (set, prefix, fallback)=>(value)=>`${prefix}.${set.includes(value) ? value : fallback}`;
const $b9b56989c1caf471$var$partial = (set, prefix)=>(value)=>set.includes(value) ? `${prefix}.${value}` : null;
const $b9b56989c1caf471$export$5ff47a1a5df62032 = [
    'chief_complaint',
    'hpi',
    'pmh',
    'medications',
    'allergies',
    'vitals',
    'labs'
];
const $b9b56989c1caf471$export$e4df79674cc2462f = [
    'male',
    'female',
    'other'
];
const $b9b56989c1caf471$export$d14c8aa1ce237ae5 = [
    'draft',
    'active',
    'archived'
];
const $b9b56989c1caf471$export$a12d0022f1f8da58 = [
    'manual',
    'voice',
    'ai'
];
const $b9b56989c1caf471$export$a41374030e1a55d3 = [
    'student',
    'assistant'
];
const $b9b56989c1caf471$export$98ececcf9ac2b6e1 = [
    'chat',
    'differential',
    'interaction',
    'soap_suggest',
    'order_suggest'
];
const $b9b56989c1caf471$export$834c2ad6e999b78f = [
    'student',
    'intern',
    'resident'
];
const $b9b56989c1caf471$export$5ba55726e18aa88a = [
    'A+',
    'A-',
    'B+',
    'B-',
    'AB+',
    'AB-',
    'O+',
    'O-'
];
const $b9b56989c1caf471$export$3f1236c6c54e3b1d = [
    'open',
    'closed'
];
const $b9b56989c1caf471$export$dd5b9cfe88d65d53 = [
    'primary',
    'secondary',
    'differential'
];
const $b9b56989c1caf471$export$70119f85e0285d1b = [
    'active',
    'resolved',
    'ruled_out'
];
const $b9b56989c1caf471$export$e730a0734bbb1219 = [
    'oral',
    'im',
    'iv',
    'sc',
    'topical',
    'inhaled',
    'rectal',
    'ophthalmic',
    'otic',
    'nasal',
    'sublingual',
    'other'
];
const $b9b56989c1caf471$export$7fe249ad93dcc233 = [
    'lab',
    'imaging',
    'procedure',
    'referral',
    'other'
];
const $b9b56989c1caf471$export$c9b31a4acc93d37d = [
    'routine',
    'urgent',
    'stat'
];
const $b9b56989c1caf471$export$5af0e83a7d0f2fea = [
    'ordered',
    'resulted',
    'cancelled'
];
const $b9b56989c1caf471$export$93217506e04f32d1 = [
    'manual',
    'ai'
];
const $b9b56989c1caf471$export$ec8701894e012b1b = [
    'encounter_start',
    'encounter_end',
    'entry',
    'diagnosis',
    'rx',
    'order',
    'order_result',
    'thread'
];
const $b9b56989c1caf471$export$40b76417ac36dee5 = $b9b56989c1caf471$var$partial($b9b56989c1caf471$export$e4df79674cc2462f, 'common.gender');
const $b9b56989c1caf471$export$b19236ae32886af = $b9b56989c1caf471$var$total($b9b56989c1caf471$export$d14c8aa1ce237ae5, 'patients.status', 'active');
const $b9b56989c1caf471$export$1e243dc70ce3ad78 = $b9b56989c1caf471$var$total($b9b56989c1caf471$export$a12d0022f1f8da58, 'history.entry.source', 'manual');
const $b9b56989c1caf471$export$e5cb2dff7061b6e9 = $b9b56989c1caf471$var$total($b9b56989c1caf471$export$834c2ad6e999b78f, 'onboarding.level', 'student');
const $b9b56989c1caf471$export$c5cf6d2182208b38 = $b9b56989c1caf471$var$total($b9b56989c1caf471$export$3f1236c6c54e3b1d, 'visit.status', 'open');
const $b9b56989c1caf471$export$365e98b66e57b8f7 = $b9b56989c1caf471$var$total($b9b56989c1caf471$export$dd5b9cfe88d65d53, 'clinical.dx.kind', 'primary');
const $b9b56989c1caf471$export$dd311579c1a5877e = $b9b56989c1caf471$var$total($b9b56989c1caf471$export$70119f85e0285d1b, 'clinical.dx.status', 'active');
const $b9b56989c1caf471$export$6a29d03432c2c29a = $b9b56989c1caf471$var$total($b9b56989c1caf471$export$e730a0734bbb1219, 'clinical.rx.route', 'other');
const $b9b56989c1caf471$export$e98960cf8df727b5 = $b9b56989c1caf471$var$total($b9b56989c1caf471$export$7fe249ad93dcc233, 'clinical.order.type', 'other');
const $b9b56989c1caf471$export$2c1f0bb0dcbb3932 = $b9b56989c1caf471$var$total($b9b56989c1caf471$export$c9b31a4acc93d37d, 'clinical.order.urgency', 'routine');
const $b9b56989c1caf471$export$32e88f427c4cbbb0 = $b9b56989c1caf471$var$total($b9b56989c1caf471$export$5af0e83a7d0f2fea, 'clinical.order.status', 'ordered');
const $b9b56989c1caf471$export$e18ec6a0f5bda944 = $b9b56989c1caf471$var$total($b9b56989c1caf471$export$93217506e04f32d1, 'clinical.origin', 'manual');
const $b9b56989c1caf471$export$f58ff5ec39a64d17 = $b9b56989c1caf471$var$total($b9b56989c1caf471$export$98ececcf9ac2b6e1, 'chat.kind', 'chat');
const $b9b56989c1caf471$export$1c59302a4d37f309 = $b9b56989c1caf471$var$total($b9b56989c1caf471$export$ec8701894e012b1b, 'timeline.type', 'entry');
const $b9b56989c1caf471$export$b0b0940123b14a51 = (id)=>`history.sections.${$b9b56989c1caf471$export$5ff47a1a5df62032.includes(id) ? id.replace(/_(\w)/g, (_, c)=>c.toUpperCase()) : 'chiefComplaint'}`;
const $b9b56989c1caf471$export$7eff371becb35c2f = [
    'low',
    'medium',
    'high'
];
const $b9b56989c1caf471$export$667dbf39619a8761 = $b9b56989c1caf471$var$partial($b9b56989c1caf471$export$7eff371becb35c2f, 'chat.confidence');
const $b9b56989c1caf471$export$7f88cc283011d271 = [
    'high',
    'medium',
    'low'
];
const $b9b56989c1caf471$export$be8e093b537b0d99 = $b9b56989c1caf471$var$partial($b9b56989c1caf471$export$7f88cc283011d271, 'clinical.differential.likelihood');
const $b9b56989c1caf471$export$5618b0f810e1020c = [
    'severe',
    'moderate',
    'mild'
];
const $b9b56989c1caf471$export$6eaaad838274d902 = $b9b56989c1caf471$var$partial($b9b56989c1caf471$export$5618b0f810e1020c, 'clinical.interaction.severity');
const $b9b56989c1caf471$export$9f518ea5abf3eda7 = [
    'interaction',
    'contraindication',
    'allergy',
    'black_box'
];
const $b9b56989c1caf471$export$b10d321a5bcb675d = $b9b56989c1caf471$var$partial($b9b56989c1caf471$export$9f518ea5abf3eda7, 'clinical.interaction.type');
const $b9b56989c1caf471$export$c87fe996305cb75b = [
    'rule_engine_static',
    'rule_engine_rxnorm',
    'rule_engine_contraindication',
    'rule_engine_allergy',
    'rule_engine_openfda',
    'llm'
];
const $b9b56989c1caf471$export$55e4700a5f346033 = $b9b56989c1caf471$var$partial($b9b56989c1caf471$export$c87fe996305cb75b, 'clinical.interaction.source');
const $b9b56989c1caf471$export$d7735740545340b6 = (status)=>status === 'archived' ? 'outline' : status === 'draft' ? 'warning' : 'success';
const $b9b56989c1caf471$export$7331504ad257335c = (value)=>value === 'severe' ? 'destructive' : value === 'moderate' ? 'warning' : 'outline';
const $b9b56989c1caf471$export$678645a4df4ce493 = (value)=>value === 'high' ? 'destructive' : value === 'medium' ? 'warning' : 'outline';
const $b9b56989c1caf471$export$7b2fa442dd79bf47 = (value)=>value === 'active' ? 'success' : value === 'ruled_out' ? 'outline' : 'warning';
const $b9b56989c1caf471$export$6001d400ec6ee23e = (value)=>value === 'resulted' ? 'success' : value === 'cancelled' ? 'outline' : 'warning';
const $b9b56989c1caf471$export$89d1c03ceda5a8b2 = (value)=>value === 'stat' ? 'destructive' : value === 'urgent' ? 'warning' : 'outline';
function $b9b56989c1caf471$export$888cb547d3ca3da3(warnings) {
    const rank = (w)=>{
        const i = $b9b56989c1caf471$export$5618b0f810e1020c.indexOf(w?.severity);
        return i === -1 ? $b9b56989c1caf471$export$5618b0f810e1020c.length : i;
    };
    return [
        ...warnings || []
    ].sort((a, b)=>rank(a) - rank(b));
}


// The بیمار تمرینی form — its fields, its closed sets, and the two shapes the
// wire wants back.
//
// ── The fields that are NOT here, and never may be ────────────────────────
//
// There is no national id, no phone number, no birth date and no address on this
// form, on the `StudentCase` type, or in the store's proto. They are ABSENT
// rather than present-and-unused (core.md §3.1): a field that does not exist
// cannot be populated by a well-meaning later change, cannot be matched against,
// and cannot leak out of an export. `patients.national_id` carries a
// PLATFORM-WIDE unique index; nothing in this app may write there.
//
// ── Age is `ageYears` + `ageDisplay`, never a birth date ─────────────────
//
// `ageDisplay` exists because `ageYears = 0` silently turns every paediatric and
// neonatal case into a newborn of indeterminate age. «۶ ماهه» OVERRIDES the years.
//
// v2 adds blood type (closed set), weight and height. Pure and React-free.

const $0d2396cd0d075e45$export$b41c0f52c41112e3 = (0, $b9b56989c1caf471$export$d14c8aa1ce237ae5);
const $0d2396cd0d075e45$export$ac80046fa87f5a7a = 'active';
const $0d2396cd0d075e45$export$ce54d3cc6ef59461 = ()=>({
        title: '',
        displayName: '',
        caseRef: '',
        ageYears: '',
        ageDisplay: '',
        sex: '',
        bloodType: '',
        weightKg: '',
        heightCm: '',
        chiefComplaint: '',
        status: $0d2396cd0d075e45$export$ac80046fa87f5a7a,
        note: ''
    });
const $0d2396cd0d075e45$var$numText = (v)=>{
    const n = Number(v ?? 0);
    return Number.isFinite(n) && n > 0 ? String(n) : '';
};
function $0d2396cd0d075e45$export$4c9aaaee61fbef99(row) {
    const src = row || {};
    return {
        title: src.title || '',
        displayName: src.displayName || '',
        caseRef: src.caseRef || '',
        ageYears: $0d2396cd0d075e45$var$numText(src.ageYears),
        ageDisplay: src.ageDisplay || '',
        sex: (0, $b9b56989c1caf471$export$e4df79674cc2462f).includes(src.sex) ? src.sex : '',
        bloodType: (0, $b9b56989c1caf471$export$5ba55726e18aa88a).includes(src.bloodType) ? src.bloodType : '',
        weightKg: $0d2396cd0d075e45$var$numText(src.weightKg),
        heightCm: $0d2396cd0d075e45$var$numText(src.heightCm),
        chiefComplaint: src.chiefComplaint || '',
        status: $0d2396cd0d075e45$export$b41c0f52c41112e3.includes(src.status) ? src.status : $0d2396cd0d075e45$export$ac80046fa87f5a7a,
        note: src.note || ''
    };
}
const $0d2396cd0d075e45$export$e12a912f36befd67 = (form)=>String(form?.title ?? '').trim() ? null : 'caseForm.validation.title';
const $0d2396cd0d075e45$var$trimmed = (v)=>String(v ?? '').trim();
function $0d2396cd0d075e45$export$2d47b280e379ef9f(value) {
    const raw = $0d2396cd0d075e45$export$522be3011864bb18($0d2396cd0d075e45$var$trimmed(value));
    if (!raw) return null;
    const n = Number(raw);
    if (!Number.isFinite(n) || n < 0) return null;
    return Math.floor(n);
}
function $0d2396cd0d075e45$export$ac34b32aa682b258(value) {
    const raw = $0d2396cd0d075e45$export$522be3011864bb18($0d2396cd0d075e45$var$trimmed(value)).replace(/[,٫]/g, '.'); // i18n-exempt: ٫ is the Arabic decimal separator, parsed not shown
    if (!raw) return null;
    const n = Number(raw);
    if (!Number.isFinite(n) || n <= 0) return null;
    return Math.round(n * 10) / 10;
}
function $0d2396cd0d075e45$export$522be3011864bb18(value) {
    return String(value ?? '').replace(/[۰-۹]/g, (d)=>String("\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9".indexOf(d))) // i18n-exempt: digit folding
    .replace(/[٠-٩]/g, (d)=>String("\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669".indexOf(d))); // i18n-exempt: digit folding
}
function $0d2396cd0d075e45$export$2b3224b6b788d4ea(form) {
    const input = {
        title: $0d2396cd0d075e45$var$trimmed(form?.title)
    };
    const optional = {
        displayName: $0d2396cd0d075e45$var$trimmed(form?.displayName),
        caseRef: $0d2396cd0d075e45$var$trimmed(form?.caseRef),
        ageDisplay: $0d2396cd0d075e45$var$trimmed(form?.ageDisplay),
        sex: (0, $b9b56989c1caf471$export$e4df79674cc2462f).includes(form?.sex) ? form.sex : '',
        bloodType: (0, $b9b56989c1caf471$export$5ba55726e18aa88a).includes(form?.bloodType) ? form.bloodType : '',
        chiefComplaint: $0d2396cd0d075e45$var$trimmed(form?.chiefComplaint),
        note: $0d2396cd0d075e45$var$trimmed(form?.note)
    };
    for (const [key, value] of Object.entries(optional))if (value) input[key] = value;
    const ageYears = $0d2396cd0d075e45$export$2d47b280e379ef9f(form?.ageYears);
    if (ageYears != null) input.ageYears = ageYears;
    const weightKg = $0d2396cd0d075e45$export$ac34b32aa682b258(form?.weightKg);
    if (weightKg != null) input.weightKg = weightKg;
    const heightCm = $0d2396cd0d075e45$export$ac34b32aa682b258(form?.heightCm);
    if (heightCm != null) input.heightCm = heightCm;
    if ($0d2396cd0d075e45$export$b41c0f52c41112e3.includes(form?.status) && form.status !== $0d2396cd0d075e45$export$ac80046fa87f5a7a) input.status = form.status;
    return input;
}
function $0d2396cd0d075e45$export$7a3fbc8940b4d9c0(original, form) {
    const before = $0d2396cd0d075e45$export$4c9aaaee61fbef99(original);
    const patch = {};
    for (const key of [
        'title',
        'displayName',
        'caseRef',
        'ageDisplay',
        'chiefComplaint',
        'note'
    ]){
        const next = $0d2396cd0d075e45$var$trimmed(form?.[key]);
        if (next !== before[key]) patch[key] = next;
    }
    const nextSex = (0, $b9b56989c1caf471$export$e4df79674cc2462f).includes(form?.sex) ? form.sex : '';
    if (nextSex !== before.sex) patch.sex = nextSex;
    const nextBlood = (0, $b9b56989c1caf471$export$5ba55726e18aa88a).includes(form?.bloodType) ? form.bloodType : '';
    if (nextBlood !== before.bloodType) patch.bloodType = nextBlood;
    const nextStatus = $0d2396cd0d075e45$export$b41c0f52c41112e3.includes(form?.status) ? form.status : before.status;
    if (nextStatus !== before.status) patch.status = nextStatus;
    const nextAge = $0d2396cd0d075e45$export$2d47b280e379ef9f(form?.ageYears);
    if (nextAge !== $0d2396cd0d075e45$export$2d47b280e379ef9f(before.ageYears)) patch.ageYears = nextAge == null ? 0 : nextAge;
    const nextWeight = $0d2396cd0d075e45$export$ac34b32aa682b258(form?.weightKg);
    if (nextWeight !== $0d2396cd0d075e45$export$ac34b32aa682b258(before.weightKg)) patch.weightKg = nextWeight == null ? 0 : nextWeight;
    const nextHeight = $0d2396cd0d075e45$export$ac34b32aa682b258(form?.heightCm);
    if (nextHeight !== $0d2396cd0d075e45$export$ac34b32aa682b258(before.heightCm)) patch.heightCm = nextHeight == null ? 0 : nextHeight;
    return patch;
}
function $0d2396cd0d075e45$export$4c461c63ce38f53(row, t) {
    const display = String(row?.ageDisplay ?? '').trim();
    if (display) return display;
    const years = Number(row?.ageYears ?? 0);
    if (!Number.isFinite(years) || years <= 0) return '';
    return t('common.units.years', {
        count: years
    });
}
function $0d2396cd0d075e45$export$e90dc8b5d3a31421(row, t) {
    const parts = [];
    const name = String(row?.displayName ?? '').trim();
    parts.push(name || t('patients.unnamed'));
    if ((0, $b9b56989c1caf471$export$e4df79674cc2462f).includes(row?.sex)) parts.push(t(`common.gender.${row.sex}`));
    const age = $0d2396cd0d075e45$export$4c461c63ce38f53(row, t);
    if (age) parts.push(age);
    return parts.join(" \xb7 ");
}
const $0d2396cd0d075e45$export$3805f9b7fa77f6d4 = (row, t)=>String(row?.displayName ?? '').trim() || String(row?.title ?? '').trim() || t('patients.unnamed');
var $0d2396cd0d075e45$export$2e2bcd8739ae039 = $0d2396cd0d075e45$export$ce54d3cc6ef59461;


const $8a4b34f14ef2811c$export$c6aa6bac75752f93 = 1370;
const $8a4b34f14ef2811c$export$c1891a7d57e283a1 = 1420;
const $8a4b34f14ef2811c$export$e7cc53903215b7b0 = (value)=>(0, $0d2396cd0d075e45$export$522be3011864bb18)(String(value ?? '')).trim();
const $8a4b34f14ef2811c$export$172c99b245912dc3 = /^[A-Za-z0-9-]{4,20}$/;
const $8a4b34f14ef2811c$export$51f34bb03b5fd0e = (level)=>level === 'resident';
const $8a4b34f14ef2811c$export$e39802c7cd1992b5 = (suggestedFullName = '')=>({
        fullName: suggestedFullName || '',
        studentNumber: '',
        university: '',
        level: '',
        field: '',
        entryYear: '',
        bio: ''
    });
const $8a4b34f14ef2811c$var$len = (v)=>String(v ?? '').trim().length;
function $8a4b34f14ef2811c$export$e88a9f8fe0614cc9(form) {
    const errors = {};
    const nameLen = $8a4b34f14ef2811c$var$len(form?.fullName);
    if (nameLen < 2 || nameLen > 120) errors.fullName = 'onboarding.validation.fullName';
    const number = $8a4b34f14ef2811c$export$e7cc53903215b7b0(form?.studentNumber);
    if (!$8a4b34f14ef2811c$export$172c99b245912dc3.test(number)) errors.studentNumber = 'onboarding.validation.studentNumber';
    const uniLen = $8a4b34f14ef2811c$var$len(form?.university);
    if (uniLen < 2 || uniLen > 120) errors.university = 'onboarding.validation.university';
    if (!(0, $b9b56989c1caf471$export$834c2ad6e999b78f).includes(form?.level)) errors.level = 'onboarding.validation.level';
    // Only validated when it is SHOWN. A student who picked «دستیار», typed a
    // specialty, then changed to «کارورز» must not be blocked by a field that is
    // no longer on the screen.
    if ($8a4b34f14ef2811c$export$51f34bb03b5fd0e(form?.level) && $8a4b34f14ef2811c$var$len(form?.field) > 80) errors.field = 'onboarding.validation.field';
    const year = $8a4b34f14ef2811c$export$d7244ad0f4052ea(form?.entryYear);
    if (year === false) errors.entryYear = 'onboarding.validation.entryYear';
    if ($8a4b34f14ef2811c$var$len(form?.bio) > 500) errors.bio = 'onboarding.validation.bio';
    return errors;
}
function $8a4b34f14ef2811c$export$d7244ad0f4052ea(value) {
    const raw = (0, $0d2396cd0d075e45$export$522be3011864bb18)(String(value ?? '')).trim();
    if (!raw) return null;
    if (!/^\d{4}$/.test(raw)) return false;
    const n = Number(raw);
    if (n < $8a4b34f14ef2811c$export$c6aa6bac75752f93 || n > $8a4b34f14ef2811c$export$c1891a7d57e283a1) return false;
    return n;
}
const $8a4b34f14ef2811c$export$7c92a933d8bce192 = (form)=>Object.keys($8a4b34f14ef2811c$export$e88a9f8fe0614cc9(form)).length === 0;
function $8a4b34f14ef2811c$export$ec419788e26dc095(err) {
    const message = typeof err?.message === 'string' ? err.message.trim() : '';
    return message && !/^BFF error: \d+$/.test(message) ? {
        message: message
    } : 'errors.invalidInput';
}
const $8a4b34f14ef2811c$export$673c4b2de6aa7bb1 = (entry, t)=>{
    if (!entry) return '';
    if (typeof entry === 'object') return entry.message || '';
    return t(entry);
};
function $8a4b34f14ef2811c$export$172565866e58152f(form) {
    const input = {
        fullName: String(form.fullName).trim(),
        studentNumber: $8a4b34f14ef2811c$export$e7cc53903215b7b0(form.studentNumber),
        university: String(form.university).trim(),
        level: form.level
    };
    if ($8a4b34f14ef2811c$export$51f34bb03b5fd0e(form.level)) {
        const field = String(form.field ?? '').trim();
        if (field) input.field = field;
    }
    const year = $8a4b34f14ef2811c$export$d7244ad0f4052ea(form.entryYear);
    if (year) input.entryYear = year;
    const bio = String(form.bio ?? '').trim();
    if (bio) input.bio = bio;
    return input;
}
function $8a4b34f14ef2811c$export$7b312c953f863815(form, previous) {
    const input = $8a4b34f14ef2811c$export$172565866e58152f(form);
    const prev = previous || {};
    if (!('field' in input) && String(prev.field ?? '').trim()) input.field = '';
    if (!('entryYear' in input) && prev.entryYear) input.entryYear = 0;
    if (!('bio' in input) && String(prev.bio ?? '').trim()) input.bio = '';
    return input;
}
function $8a4b34f14ef2811c$export$2f8d1703693c8410(profile) {
    const src = profile || {};
    return {
        fullName: src.fullName || '',
        studentNumber: src.studentNumber || '',
        university: src.university || '',
        level: (0, $b9b56989c1caf471$export$834c2ad6e999b78f).includes(src.level) ? src.level : '',
        field: src.field || '',
        entryYear: src.entryYear ? String(src.entryYear) : '',
        bio: src.bio || ''
    };
}
const $8a4b34f14ef2811c$export$47007d96f3617630 = [
    'gate',
    'form',
    'saving',
    'done'
];


// The seven fields, once.
//
// Both surfaces render THIS; they differ in the frame around it (a card on a
// desktop, a full-height scroll on a phone) and in nothing else. Two copies of
// a form is how one of them ends up missing the field the other added — and the
// field most likely to be added here is the one this app must never have.
//
// ── There is no کد نظام پزشکی on this form, and there never will be ───────
//
// A student number is not a licence: it is assigned per university, collides
// across universities, and there is no registry to check it against (core.md
// §4.5). It is stored, not verified, and NOT unique — a uniqueness constraint
// would refuse a legitimate second student and verify nothing.
const $8fc854a104521249$var$DATALIST_ID = 'parsina-universities';
function $8fc854a104521249$export$2e2bcd8739ae039({ values: values, onChange: onChange, errors: errors = {}, disabled: disabled = false, phone: phone = '' }) {
    const { t: t, locale: locale } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const set = (key)=>(e)=>onChange?.({
                [key]: e?.target ? e.target.value : e
            });
    // A key resolves through the catalogue; a `{ message }` (the BFF's own
    // sentence for an INVALID_INPUT) renders as it came.
    const err = (key)=>(0, $8a4b34f14ef2811c$export$673c4b2de6aa7bb1)(errors[key], t);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: t('onboarding.fields.fullName'),
                required: true,
                value: values.fullName,
                onChange: set('fullName'),
                error: err('fullName'),
                disabled: disabled,
                maxLength: 120,
                autoComplete: "name",
                "data-testid": "onboarding-full-name"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: t('onboarding.fields.studentNumber'),
                required: true,
                value: values.studentNumber,
                onChange: set('studentNumber'),
                helperText: t('onboarding.fields.studentNumberHelper'),
                error: err('studentNumber'),
                disabled: disabled,
                maxLength: 20,
                dir: "ltr",
                inputMode: "numeric",
                "data-testid": "onboarding-student-number"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: t('onboarding.fields.university'),
                required: true,
                value: values.university,
                onChange: set('university'),
                helperText: t('onboarding.fields.universityHelper'),
                error: err('university'),
                disabled: disabled,
                maxLength: 120,
                list: $8fc854a104521249$var$DATALIST_ID,
                "data-testid": "onboarding-university"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("datalist", {
                id: $8fc854a104521249$var$DATALIST_ID,
                "data-testid": "university-options",
                children: (0, $c4345f5c1e1b74b6$export$1314b509de787fd9).map((u)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: locale === 'en' ? u.en : u.fa
                    }, u.id))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "onboarding-level",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fcaca06c97c91379$export$2e2bcd8739ae039), {
                    label: t('onboarding.fields.level'),
                    value: values.level,
                    onChange: (next)=>onChange?.({
                            level: next
                        }),
                    options: (0, $b9b56989c1caf471$export$834c2ad6e999b78f).map((id)=>({
                            value: id,
                            label: t(`onboarding.level.${id}`)
                        })),
                    error: err('level'),
                    disabled: disabled
                })
            }),
            (0, $8a4b34f14ef2811c$export$51f34bb03b5fd0e)(values.level) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: t('onboarding.fields.field'),
                value: values.field,
                onChange: set('field'),
                helperText: t('onboarding.fields.fieldHelper'),
                error: err('field'),
                disabled: disabled,
                maxLength: 80,
                "data-testid": "onboarding-field"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: t('onboarding.fields.entryYear'),
                value: values.entryYear,
                onChange: set('entryYear'),
                error: err('entryYear'),
                disabled: disabled,
                dir: "ltr",
                inputMode: "numeric",
                maxLength: 4,
                placeholder: `${(0, $8a4b34f14ef2811c$export$c6aa6bac75752f93)}\u{2013}${(0, $8a4b34f14ef2811c$export$c1891a7d57e283a1)}`,
                "data-testid": "onboarding-entry-year"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                label: t('onboarding.fields.bio'),
                value: values.bio,
                onChange: set('bio'),
                error: err('bio'),
                disabled: disabled,
                rows: 3,
                maxLength: 500,
                "data-testid": "onboarding-bio"
            }),
            phone ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: t('onboarding.fields.phone'),
                value: phone,
                readOnly: true,
                disabled: true,
                dir: "ltr",
                helperText: t('onboarding.fields.phoneHelper'),
                "data-testid": "onboarding-phone"
            }) : null
        ]
    });
}


// The desktop frame: one card, centred on the brand gradient, above the router.
//
// It looks like the sign-in screen because it IS the same moment — the last
// step of getting in — and because there is no app chrome to put it in yet: the
// rail needs a name and a balance, and neither exists until this form is saved.
const $7e995a1f07376a6e$var$PAGE = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100vw',
    minHeight: '100vh',
    background: (0, $e7c165fb515b04ea$export$4c2e201e0b6dbaa3),
    padding: 24,
    overflowY: 'auto'
};
const $7e995a1f07376a6e$var$CARD = {
    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
    borderRadius: 16,
    width: 560,
    maxWidth: '100%',
    boxShadow: '0 32px 80px rgba(0,0,0,0.3)',
    padding: 32,
    margin: 'auto'
};
function $7e995a1f07376a6e$export$2e2bcd8739ae039({ values: values, onChange: onChange, errors: errors, submitError: submitError, saving: saving, onSubmit: onSubmit, phone: phone }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: $7e995a1f07376a6e$var$PAGE,
        "data-testid": "onboarding-web",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            style: $7e995a1f07376a6e$var$CARD,
            onSubmit: (e)=>{
                e.preventDefault();
                onSubmit();
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    style: {
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
                        fontSize: 21,
                        fontWeight: 800,
                        margin: '0 0 6px'
                    },
                    children: t('onboarding.title')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    style: {
                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                        fontSize: 13.5,
                        lineHeight: 1.9,
                        margin: '0 0 20px'
                    },
                    children: t('onboarding.sub')
                }),
                submitError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "error",
                    style: {
                        marginBottom: 16
                    },
                    "data-testid": "onboarding-error",
                    children: submitError
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fc854a104521249$export$2e2bcd8739ae039), {
                    values: values,
                    onChange: onChange,
                    errors: errors,
                    disabled: saving,
                    phone: phone
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        marginTop: 22
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            type: "submit",
                            disabled: saving,
                            "data-testid": "onboarding-submit",
                            children: saving ? t('onboarding.saving') : t('onboarding.submit')
                        }),
                        saving && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                            size: 16
                        })
                    ]
                })
            ]
        })
    });
}



parcelRequire("acw62");




// The phone frame: one full-height scroll, a title band, and the submit docked
// at the end of the form rather than floating over it.
//
// No card and no gradient: a 360px viewport spends its whole width on the
// fields, and a centred card there is a box with a 40px reading column. The
// header is plain text rather than a `MobileHeader`, because there is nowhere
// to go back TO — this screen has no shell around it and no route behind it.
const $c6be989b2a99f3b4$var$ROOT = {
    position: 'fixed',
    inset: 0,
    overflowY: 'auto',
    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
    padding: '24px 16px 40px',
    paddingInlineStart: 'max(16px, env(safe-area-inset-left, 0px))',
    paddingInlineEnd: 'max(16px, env(safe-area-inset-right, 0px))'
};
function $c6be989b2a99f3b4$export$2e2bcd8739ae039({ values: values, onChange: onChange, errors: errors, submitError: submitError, saving: saving, onSubmit: onSubmit, phone: phone }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: $c6be989b2a99f3b4$var$ROOT,
        "data-testid": "onboarding-mobile",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            onSubmit: (e)=>{
                e.preventDefault();
                onSubmit();
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    style: {
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
                        fontSize: 19,
                        fontWeight: 800,
                        margin: '0 0 6px'
                    },
                    children: t('onboarding.title')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    style: {
                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                        fontSize: 13,
                        lineHeight: 1.9,
                        margin: '0 0 18px'
                    },
                    children: t('onboarding.sub')
                }),
                submitError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "error",
                    style: {
                        marginBottom: 14
                    },
                    "data-testid": "onboarding-error",
                    children: submitError
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fc854a104521249$export$2e2bcd8739ae039), {
                    values: values,
                    onChange: onChange,
                    errors: errors,
                    disabled: saving,
                    phone: phone
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    type: "submit",
                    disabled: saving,
                    className: "w-full min-h-11",
                    style: {
                        marginTop: 22
                    },
                    "data-testid": "onboarding-submit",
                    children: saving ? t('onboarding.saving') : t('onboarding.submit')
                })
            ]
        })
    });
}



// «به پارسینا خوش آمدید» — the one step between a Keycloak account and an app.
//
// core.md §4.3. Rendered by the BOOT, not by a route guard: App.jsx asks
// `onboardingStatus` before it mounts the router and renders this instead when
// the answer is false. That is the doctor app's pattern and it exists because a
// route guard is a redirect, and a redirect is a thing a half-typed form does
// not survive.
//
// ── The four stages, and the one that must never be reached by accident ───
//
//   gate    the status query is in flight — a spinner, nothing else
//   form    the seven fields
//   saving  the mutation is out; the values stay on screen and stay typed
//   done    the store now holds a profile, and App.jsx swaps to the router
//
// A FAILED status query is not one of them, and it is not rendered HERE: the
// boot gate in App.jsx owns that state and shows a full-page ErrorState with a
// retry («سرویس در دسترس نیست»). This component is mounted only once the status
// has answered `isOnboarded: false` — a form is shown because the status said
// so, never because a query failed. If the store's error is ever set while
// this is mounted anyway, nothing is rendered rather than the form: a form that
// saves into a store which is not answering loses everything typed into it.
//
// ── The draft survives a re-login ─────────────────────────────────────────
//
// The session dialog (§15) overlays this screen without unmounting it, but its
// «ورود مجدد» is a full-document navigation to Keycloak and back, and a
// `useState` form does not come back from one. So the values are mirrored into
// `sessionStorage.onboarding_draft` as they are typed, restored on mount, and
// cleared the moment the submission succeeds. sessionStorage, not localStorage:
// this is THIS tab's typing, and it must not be presented to a different
// student on the same machine tomorrow.
//
// ── Already onboarded ─────────────────────────────────────────────────────
//
// There is no redirect here, because there is no router here. A student who
// types `/onboarding` while onboarded never reaches this component: App.jsx
// mounts the router for them, and the router's catch-all lands them on
// `/patients` — which is the redirect core.md §4.3 asks for, arrived at by not
// rendering a screen rather than by leaving one.
/** The stored draft, folded over an empty form so a missing key cannot render `undefined`. */ const $62b061fca587e5c8$var$restoreDraft = ()=>{
    const empty = (0, $8a4b34f14ef2811c$export$e39802c7cd1992b5)();
    const saved = (0, $7cdea07122bc6887$export$6a368473377ea45c)((0, $7cdea07122bc6887$export$6bfff27528cc6873), {
        kind: 'session',
        fallback: null
    });
    if (!saved || typeof saved !== 'object') return empty;
    const form = {
        ...empty
    };
    for (const key of Object.keys(empty))if (typeof saved[key] === 'string') form[key] = saved[key];
    return form;
};
const $62b061fca587e5c8$var$OnboardingScreen = ({ onDone: onDone })=>{
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const { status: status, loading: loading, error: error, completeOnboarding: completeOnboarding } = (0, $5bc9ff20f6a2b818$export$f637e1cf42d15a62)();
    const [values, setValues] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($62b061fca587e5c8$var$restoreDraft);
    const [errors, setErrors] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [submitError, setSubmitError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Mirror the typing into the draft. Written on every change rather than on
    // a timer: the event this guards against (the session ending) is not one the
    // student schedules, and a 2s debounce would lose the last two seconds of
    // exactly the field they were on.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        (0, $7cdea07122bc6887$export$476f628a921f7411)((0, $7cdea07122bc6887$export$6bfff27528cc6873), values, {
            kind: 'session'
        });
    }, [
        values
    ]);
    // Pre-fill the name from the token ONCE, when the status lands — and only
    // into a field the student has not touched (a restored draft counts as
    // touched). Re-applying it on every publish would overwrite a correction the
    // moment the balance refreshed.
    const prefilled = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (prefilled.current || !status?.suggestedFullName) return;
        prefilled.current = true;
        setValues((prev)=>prev.fullName ? prev : {
                ...prev,
                fullName: status.suggestedFullName
            });
    }, [
        status?.suggestedFullName
    ]);
    const onChange = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((patch)=>{
        setValues((prev)=>({
                ...prev,
                ...patch
            }));
        // Clear only the fields being edited: an error the student has not looked
        // at yet must stay on screen, and one they are fixing must not shout while
        // they are mid-word.
        setErrors((prev)=>{
            const next = {
                ...prev
            };
            for (const key of Object.keys(patch))delete next[key];
            return next;
        });
    }, []);
    const onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const problems = (0, $8a4b34f14ef2811c$export$e88a9f8fe0614cc9)(values);
        setErrors(problems);
        if (Object.keys(problems).length) return;
        setSaving(true);
        setSubmitError('');
        try {
            await completeOnboarding((0, $8a4b34f14ef2811c$export$172565866e58152f)(values));
            // The profile is stored: the draft has nothing left to protect, and a
            // stale one would be restored over the NEXT account's empty form.
            (0, $7cdea07122bc6887$export$eeeb486534738631)((0, $7cdea07122bc6887$export$6bfff27528cc6873), {
                kind: 'session'
            });
            onDone?.();
        } catch (err) {
            // INVALID_INPUT names the field it rejected — and, when the BFF said WHY,
            // that sentence goes under the field instead of the catalogue's generic
            // «معتبر نیست». Anything else is a sentence above the form. Either way
            // the typed values stay exactly where they are — this is the moment a
            // student is most likely to give up, and retyping seven fields is how
            // they do it.
            const field = (0, $206625c7d33bd390$export$abf870288a102319)(err);
            if ((0, $206625c7d33bd390$export$dbfe74f291058e97)(err) === 'INVALID_INPUT' && field) {
                setErrors((prev)=>({
                        ...prev,
                        [field]: (0, $8a4b34f14ef2811c$export$ec419788e26dc095)(err)
                    }));
                setSubmitError(t('errors.invalidInput'));
            } else setSubmitError(t((0, $206625c7d33bd390$export$660244d64183d198)(err)) || t('onboarding.error.unavailable'));
        } finally{
            setSaving(false);
        }
    }, [
        values,
        completeOnboarding,
        onDone,
        t
    ]);
    // The status query failed. The form is not an option — and the error screen
    // is App.jsx's, not this component's (see the header).
    if (error && !status) return null;
    if (loading && !status) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: $62b061fca587e5c8$var$GATE,
        "data-testid": "onboarding-gate",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {})
    });
    const Surface = isMobile ? (0, $c6be989b2a99f3b4$export$2e2bcd8739ae039) : (0, $7e995a1f07376a6e$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Surface, {
        values: values,
        onChange: onChange,
        errors: errors,
        submitError: submitError,
        saving: saving,
        onSubmit: onSubmit,
        phone: status?.phone || ''
    });
};
const $62b061fca587e5c8$var$GATE = {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
    padding: 24
};
var $62b061fca587e5c8$export$2e2bcd8739ae039 = $62b061fca587e5c8$var$OnboardingScreen;



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6117d2af5e6ea38b$export$a2387ed3b5d536eb = {
    name: "search-x",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m13.5 8.5-5 5",
                key: "1cs55j"
            }
        ],
        [
            "path",
            {
                d: "m8.5 8.5 5 5",
                key: "a8mexj"
            }
        ],
        [
            "circle",
            {
                cx: "11",
                cy: "11",
                r: "8",
                key: "4ej97u"
            }
        ],
        [
            "path",
            {
                d: "m21 21-4.3-4.3",
                key: "1qie3q"
            }
        ]
    ]
};
$6117d2af5e6ea38b$export$a2387ed3b5d536eb.node;
const $6117d2af5e6ea38b$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($6117d2af5e6ea38b$export$a2387ed3b5d536eb);






parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $53b0597d7da6e50a$export$a2387ed3b5d536eb = {
    name: "sparkles",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
                key: "1s2grr"
            }
        ],
        [
            "path",
            {
                d: "M20 2v4",
                key: "1rf3ol"
            }
        ],
        [
            "path",
            {
                d: "M22 4h-4",
                key: "gwowj6"
            }
        ],
        [
            "circle",
            {
                cx: "4",
                cy: "20",
                r: "2",
                key: "6kqj1y"
            }
        ]
    ],
    aliases: [
        "stars"
    ]
};
$53b0597d7da6e50a$export$a2387ed3b5d536eb.node;
const $53b0597d7da6e50a$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($53b0597d7da6e50a$export$a2387ed3b5d536eb);




function $a5effdd9ebf7f983$export$ac0d528804cbd713({ style: style }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
        variant: "warning",
        title: t('practice.banner.title'),
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f66de94054a4f331$export$2e2bcd8739ae039), {
            size: 18,
            "aria-hidden": true
        }),
        "data-testid": "practice-banner",
        style: style,
        children: t('practice.banner.body')
    });
}
function $a5effdd9ebf7f983$export$480ec33bbf749db7({ short: short = false, style: style }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
        variant: "warning",
        style: style,
        "data-testid": "practice-badge",
        children: t(short ? 'practice.badge.short' : 'practice.badge')
    });
}
function $a5effdd9ebf7f983$export$3c69499d0e994d3f({ style: style }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
        variant: "info",
        title: t('practice.ai.title'),
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
            size: 18,
            "aria-hidden": true
        }),
        "data-testid": "ai-disclaimer",
        style: style,
        children: t('practice.ai.body')
    });
}
function $a5effdd9ebf7f983$export$f9f72ca4b5e00695({ style: style }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        "data-testid": "ai-answer-note",
        style: {
            margin: '8px 0 0',
            fontSize: 11.5,
            lineHeight: 1.8,
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                size: 12,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                "aria-hidden": true
            }),
            t('practice.ai.short')
        ]
    });
}
var $a5effdd9ebf7f983$export$2e2bcd8739ae039 = $a5effdd9ebf7f983$export$ac0d528804cbd713;



parcelRequire("acw62");



function $e9876d237fe8b99c$export$2e2bcd8739ae039({ error: error, title: title, description: description, onRetry: onRetry, fill: fill = false, style: style, ...rest }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    // The BFF's Persian message rides underneath as detail — never as the
    // headline, which has to resolve in both locales.
    const detail = typeof error?.message === 'string' ? error.message : '';
    const headline = title ?? t((0, $206625c7d33bd390$export$660244d64183d198)(error));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
        title: headline,
        description: description ?? (detail || t('errors.unavailableBody')),
        onRetry: onRetry,
        retryLabel: t('common.actions.retry'),
        fill: fill,
        style: style,
        "data-testid": "error-state",
        ...rest
    });
}




// The list's behaviour, once — so the table and the cards cannot disagree.
//
// Both surfaces render the same rows, in the same order, filtered the same way,
// with the same actions and the same toasts. What they do NOT share is chrome:
// a `DataTable` with a hover action column and a stack of cards with a FAB are
// genuinely different designs for the same screen, and forcing one component to
// be both is how a table ends up with a 44px-tall row on a desktop.
//
// So the split is: this file decides WHAT, the surfaces decide WHAT IT LOOKS
// LIKE. A behaviour change lands in one place.

var $acw62 = parcelRequire("acw62");



// «بیماران» — this student's practice patients.
//
// ── Everything here is scoped by the TOKEN, not by an argument ─────────────
//
// `myCases` takes no student id, and there is no argument anywhere in the frozen
// schema for whose data to read (core.md §3.2). The student id is the JWT `sub`,
// read in the BFF's context factory, and it is the AUTHORIZATION rather than a
// filter. Nothing in this file may grow a parameter that names an owner.
//
// ── There is no server-side search, and that is deliberate ────────────────
//
// A text search is the one query shape that becomes cross-student by dropping a
// single predicate (core.md §3.2), so the contract has none. The list is capped
// at 100 rows server-side and the screen searches, sorts and pages what it
// already holds — `filterCases` and `sortCases` below are the whole of it, and
// they are pure so tests/screens.test.jsx can drive them without a network.
//
// ── Why the FILTER is here and the SORT is not a query argument ───────────
//
// `statuses` IS a wire argument (the server can answer «فقط بایگانی» without
// reading everything), so it drives a refetch. The sort is not: reordering 100
// rows the browser is already holding must not cost a round trip, and «آخرین
// ویزیت» has to put a patient with no visits at the end, which no ORDER BY the
// contract offers would do.

var $acw62 = parcelRequire("acw62");




const $b7360dc72487f1e9$export$f46e6c5a1839f7fc = [
    'active',
    'draft'
];
const $b7360dc72487f1e9$export$457b1bddf080416a = 100;
const $b7360dc72487f1e9$export$f656c8688cd3f81d = [
    'lastVisit',
    'newest',
    'name'
];
const $b7360dc72487f1e9$export$2cff890356e872f1 = 'lastVisit';
// Does this student have ANY patient, in any status? `null` = not asked yet.
// Module-level so the answer is one round trip per session, not one per mount.
let $b7360dc72487f1e9$var$anyCache = null;
function $b7360dc72487f1e9$export$13359904533216d6() {
    $b7360dc72487f1e9$var$anyCache = null;
}
function $b7360dc72487f1e9$export$8888bff3ca0b7f35(cases, query) {
    const q = String(query || '').trim().toLowerCase();
    if (!q) return cases || [];
    return (cases || []).filter((row)=>[
            row?.title,
            row?.displayName,
            row?.caseRef,
            row?.chiefComplaint
        ].filter(Boolean).some((field)=>String(field).toLowerCase().includes(q)));
}
const $b7360dc72487f1e9$var$num = (v)=>{
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
};
function $b7360dc72487f1e9$export$714d838fa4b4db08(cases, sort = $b7360dc72487f1e9$export$2cff890356e872f1) {
    const rows = [
        ...cases || []
    ];
    if (sort === 'name') return rows.sort((a, b)=>String(a?.displayName || a?.title || '').localeCompare(String(b?.displayName || b?.title || ''), 'fa'));
    if (sort === 'newest') return rows.sort((a, b)=>$b7360dc72487f1e9$var$num(b?.createdAtMs) - $b7360dc72487f1e9$var$num(a?.createdAtMs));
    return rows.sort((a, b)=>{
        const av = $b7360dc72487f1e9$var$num(a?.lastEncounterAtMs);
        const bv = $b7360dc72487f1e9$var$num(b?.lastEncounterAtMs);
        if (av && bv) return bv - av;
        if (av) return -1;
        if (bv) return 1;
        // Neither has been visited: the newer patient is the one being worked on.
        return $b7360dc72487f1e9$var$num(b?.createdAtMs) - $b7360dc72487f1e9$var$num(a?.createdAtMs);
    });
}
function $b7360dc72487f1e9$export$64430ce94e1a8342({ statuses: statuses = $b7360dc72487f1e9$export$f46e6c5a1839f7fc, limit: limit = $b7360dc72487f1e9$export$457b1bddf080416a } = {}) {
    const [cases, setCases] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [nonce, setNonce] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    // ── "No patients at all" is a fact about ALL statuses, not the filter ──
    //
    // `statuses` is a wire argument, so an empty page says only "nothing with
    // these statuses". «بایگانی» with no archived rows must render «موردی مطابق
    // فیلتر نیست», never «هنوز بیماری نساخته‌اید» — to a student with forty
    // active patients the second one says their work is gone (core.md §7.3).
    // The list query carries no `total`, so the unfiltered answer is one more
    // tiny read — every status, one row, ids only — cached for the session and
    // invalidated by the two mutations that can change it: a create (which
    // proves it true without a round trip) and a delete.
    const [anyKnown, setAnyKnown] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($b7360dc72487f1e9$var$anyCache);
    const [anyNonce, setAnyNonce] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if ($b7360dc72487f1e9$var$anyCache !== null) {
            setAnyKnown($b7360dc72487f1e9$var$anyCache);
            return undefined;
        }
        let alive = true;
        (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$9df02b57e704999f), {
            limit: 1,
            offset: 0
        }).then((data)=>{
            $b7360dc72487f1e9$var$anyCache = (data?.myCases || []).length > 0;
            if (alive) setAnyKnown($b7360dc72487f1e9$var$anyCache);
        }).catch((err)=>{
            // Not cached: a failed probe must not be remembered as "no patients".
            // The screen falls back to what the page itself proves.
            console.warn('[useCases] any-cases probe failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
            if (alive) setAnyKnown(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        anyNonce
    ]);
    // An ARRAY in a dependency list is a new identity on every render, which would
    // refetch forever. The wire value is what actually matters, so the dependency
    // is its serialisation and the array is rebuilt from it inside the effect.
    const statusKey = (statuses && statuses.length ? [
        ...statuses
    ].sort() : []).join(',');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let alive = true;
        setLoading(true);
        (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$25fcebf30e4220a7), {
            statuses: statusKey ? statusKey.split(',') : null,
            limit: limit,
            offset: 0
        }).then((data)=>{
            if (!alive) return;
            setCases(data?.myCases || []);
            setError(null);
        }).catch((err)=>{
            if (!alive) return;
            console.error('[useCases] failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
            setError(err);
            // A failed read replaces the list with an ERROR state, never with an
            // empty one: "you have made no patients yet" and "we could not ask" are
            // different facts, and only the first one means "start writing".
            setCases([]);
        }).finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        statusKey,
        limit,
        nonce
    ]);
    const reload = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setNonce((n)=>n + 1), []);
    /** Create a patient. Resolves to the stored row so the caller can navigate. */ const createCase = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (input)=>{
        const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$2cb50a185a816e1b), {
            input: input
        });
        // A stored row proves the answer without asking again.
        $b7360dc72487f1e9$var$anyCache = true;
        setAnyKnown(true);
        reload();
        // `caseCount` on the profile just moved; the profile screen prints it.
        (0, $5bc9ff20f6a2b818$export$b8488b78b8e134a0)();
        return data?.createCase || null;
    }, [
        reload
    ]);
    /**
   * Archive / unarchive, optimistically.
   *
   * The row moves out of (or into) the current filter, so the local list is
   * patched before the round trip and the screen repaints at once; a failure
   * re-reads from the server rather than trying to reverse the patch, because
   * the authoritative answer is one query away and a hand-rolled undo is how a
   * list ends up showing a state the store never held.
   */ const setCaseStatus = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (caseId, status)=>{
        setCases((prev)=>prev.map((row)=>row.id === caseId ? {
                    ...row,
                    status: status
                } : row));
        try {
            const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$1a72deffcb882601), {
                caseId: caseId,
                input: {
                    status: status
                }
            });
            reload();
            return data?.updateCase || null;
        } catch (err) {
            reload();
            throw err;
        }
    }, [
        reload
    ]);
    /**
   * Delete a patient, their history, visits, threads and messages, in one
   * transaction.
   *
   * There is no undo and no archive-instead fallback — `status: 'archived'` is
   * what archiving is for — and it refunds nothing: the پارسه was spent in
   * another service when the answer was produced. The screen says both of those,
   * with the counts, before it calls this.
   */ const deleteCase = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (caseId)=>{
        await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$103f04c571adf29b), {
            caseId: caseId
        });
        // The last patient may have just gone: forget the cached answer and ask
        // again, rather than guessing from a page that is filtered.
        $b7360dc72487f1e9$var$anyCache = null;
        setAnyKnown(null);
        setAnyNonce((n)=>n + 1);
        reload();
        (0, $5bc9ff20f6a2b818$export$b8488b78b8e134a0)();
    }, [
        reload
    ]);
    // A page WITH rows proves "at least one" without the probe; an empty page
    // proves nothing and waits for it.
    const hasAny = cases.length > 0 || anyKnown === true;
    const anySettled = cases.length > 0 || anyKnown !== null;
    return {
        cases: cases,
        hasAny: // Is there at least one patient in ANY status? Drives the difference
        // between «هنوز بیماری نساخته‌اید» and «موردی مطابق فیلتر نیست».
        hasAny,
        // `loading` below already covers the page; this is the probe's own flag,
        // so a screen never renders the empty state on an unanswered question.
        anyLoading: !anySettled,
        loading: loading,
        error: error,
        reload: reload,
        createCase: createCase,
        setCaseStatus: setCaseStatus,
        deleteCase: deleteCase,
        // The server capped the answer. There is no `total` on this query, so this
        // is the only honest "there may be more" the shape can support — and the
        // recovery the screen offers is «جستجو کنید», not a pager into rows the
        // query never returned.
        capped: cases.length >= limit
    };
}
var $b7360dc72487f1e9$export$2e2bcd8739ae039 = $b7360dc72487f1e9$export$64430ce94e1a8342;




// Offset paging arithmetic, in one place.
//
// `myCases` and `myWalletTransactions` both take { limit, offset } and cap limit
// at 100 server-side. The screen thinks in 1-based pages (that is what the pager
// renders) and the wire thinks in offsets, so the conversion happens here rather
// than being re-derived at three call sites with three different off-by-ones.
//
// NOTE that `myCases` returns a bare list and not a { total } envelope — the
// frozen schema says so — so the case list pages by "did this page come back
// full?" rather than by a total. `myWalletTransactions` DOES carry `totalCount`
// and uses the arithmetic below in full.
const $76567e4e635dac59$export$5716e8bcb003888d = 25;
function $76567e4e635dac59$export$7804ac8eb5cfa918(total, limit = $76567e4e635dac59$export$5716e8bcb003888d) {
    const size = Number(limit) > 0 ? Number(limit) : $76567e4e635dac59$export$5716e8bcb003888d;
    return Math.max(1, Math.ceil((Number(total) || 0) / size));
}
function $76567e4e635dac59$export$37065cd88a320a11(page, total, limit = $76567e4e635dac59$export$5716e8bcb003888d) {
    const n = Math.floor(Number(page));
    if (!Number.isFinite(n) || n < 1) return 1;
    return Math.min(n, $76567e4e635dac59$export$7804ac8eb5cfa918(total, limit));
}
function $76567e4e635dac59$export$bfb063dcf959468d(page, limit = $76567e4e635dac59$export$5716e8bcb003888d) {
    const n = Math.floor(Number(page));
    const size = Number(limit) > 0 ? Number(limit) : $76567e4e635dac59$export$5716e8bcb003888d;
    return Math.max(0, (Number.isFinite(n) && n > 0 ? n - 1 : 0) * size);
}
function $76567e4e635dac59$export$b6fa4c60b3a546ad(offset, limit = $76567e4e635dac59$export$5716e8bcb003888d) {
    const size = Number(limit) > 0 ? Number(limit) : $76567e4e635dac59$export$5716e8bcb003888d;
    const off = Number(offset);
    if (!Number.isFinite(off) || off <= 0) return 1;
    return Math.floor(off / size) + 1;
}


// «بیماران» — what both surfaces of the list agree about.
//
// The toolbar's vocabulary (which status chips, which sorts), the URL contract,
// and the sentence the delete confirmation has to be able to say. Pure and
// React-free: tests/screens.test.jsx reads it directly, and so does the mobile
// surface, which renders cards rather than a table but filters, sorts and
// deletes by exactly the same rules.


const $e418b5295d1aee37$export$8948eb492fe37509 = [
    {
        id: 'active',
        labelKey: 'patients.filters.active'
    },
    {
        id: 'draft',
        labelKey: 'patients.filters.draft'
    },
    {
        id: 'archived',
        labelKey: 'patients.filters.archived'
    }
];
const $e418b5295d1aee37$export$d939d340b531e39f = {
    lastVisit: 'patients.sort.lastVisit',
    newest: 'patients.sort.newest',
    name: 'patients.sort.name'
};
function $e418b5295d1aee37$export$49635392f5df92a2(statuses, id) {
    const set = new Set(statuses || []);
    if (set.has(id)) set.delete(id);
    else set.add(id);
    return (0, $b9b56989c1caf471$export$d14c8aa1ce237ae5).filter((s)=>set.has(s));
}
const $e418b5295d1aee37$export$edd7bbe7fc62d9ee = (statuses)=>!statuses || statuses.length === 0;
const $e418b5295d1aee37$export$712b0a03f7afa51d = (total, visibleCount)=>Boolean(total) && Number(total) !== 0 && visibleCount === 0;
const $e418b5295d1aee37$export$bafb271d5e29da54 = (total, settled = true)=>settled && (total === false || Number(total) === 0);
const $e418b5295d1aee37$export$ab0d921fa7daf9a9 = (row)=>({
        entries: Number(row?.entryCount || 0),
        visits: Number(row?.encounterCount || 0),
        threads: Number(row?.threadCount || 0)
    });
const $e418b5295d1aee37$export$601619a78f87d662 = (row)=>Boolean(row?.openEncounterId);
const $e418b5295d1aee37$export$e254a38a69007d83 = (row)=>row?.status === 'archived';


function $0c74351c78f3013a$export$13b7a46e41457aec() {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const [statuses, setStatuses] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $b7360dc72487f1e9$export$f46e6c5a1839f7fc));
    const [query, setQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [sort, setSort] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $b7360dc72487f1e9$export$2cff890356e872f1));
    const { cases: cases, loading: loading, error: error, reload: reload, createCase: createCase, setCaseStatus: setCaseStatus, deleteCase: deleteCase, capped: capped, hasAny: hasAny, anyLoading: anyLoading } = (0, $b7360dc72487f1e9$export$64430ce94e1a8342)({
        statuses: statuses
    });
    // Filter THEN sort: sorting the whole page and slicing the matches would
    // reorder nothing the student can see, and cost the comparison on rows that
    // are not on screen.
    const visible = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $b7360dc72487f1e9$export$714d838fa4b4db08)((0, $b7360dc72487f1e9$export$8888bff3ca0b7f35)(cases, query), sort), [
        cases,
        query,
        sort
    ]);
    // ── Client-side paging of the ≤100 rows the server returned ─────────────
    //
    // core.md §7.3: the list query is capped at 100 and the UI pages what it
    // holds through lib/paging.js. The desktop shows one page of 25 with the kit
    // `Pager`; the phone GROWS the list through «نمایش بیشتر» instead (a 34px
    // pager row is under the 44px touch floor). Both are the same arithmetic on
    // the same `visible` array, so a row is never on both page 1 and page 2.
    //
    // Any change to what `visible` IS (a search, a chip, a sort) resets to the
    // first page: page 3 of a list that now has one page is an empty screen with
    // a pager under it.
    const [page, setPageRaw] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(1);
    const [shownCount, setShownCount] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $76567e4e635dac59$export$5716e8bcb003888d));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setPageRaw(1);
        setShownCount((0, $76567e4e635dac59$export$5716e8bcb003888d));
    }, [
        query,
        sort,
        statuses
    ]);
    const pages = (0, $76567e4e635dac59$export$7804ac8eb5cfa918)(visible.length, (0, $76567e4e635dac59$export$5716e8bcb003888d));
    const currentPage = (0, $76567e4e635dac59$export$37065cd88a320a11)(page, visible.length, (0, $76567e4e635dac59$export$5716e8bcb003888d));
    const setPage = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((next)=>setPageRaw((0, $76567e4e635dac59$export$37065cd88a320a11)(next, visible.length, (0, $76567e4e635dac59$export$5716e8bcb003888d))), [
        visible.length
    ]);
    const pageRows = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const start = (0, $76567e4e635dac59$export$bfb063dcf959468d)(currentPage, (0, $76567e4e635dac59$export$5716e8bcb003888d));
        return visible.slice(start, start + (0, $76567e4e635dac59$export$5716e8bcb003888d));
    }, [
        visible,
        currentPage
    ]);
    const shownRows = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>visible.slice(0, shownCount), [
        visible,
        shownCount
    ]);
    const showMore = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setShownCount((n)=>Math.min(n + (0, $76567e4e635dac59$export$5716e8bcb003888d), visible.length)), [
        visible.length
    ]);
    // ── The dialogs ─────────────────────────────────────────────────────────
    const [creating, setCreating] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $0d2396cd0d075e45$export$ce54d3cc6ef59461)());
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [showTitleError, setShowTitleError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [deleteTarget, setDeleteTarget] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [deleting, setDeleting] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const openCreate = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setForm((0, $0d2396cd0d075e45$export$ce54d3cc6ef59461)());
        setShowTitleError(false);
        setCreating(true);
    }, []);
    const closeCreate = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setCreating(false), []);
    /**
   * Create, then go straight to the شرح حال tab.
   *
   * A patient with no history is a patient the assistant can say nothing about,
   * so the create flow does not end on the list — it ends in the editor, with
   * the hint that says the two ways to fill it (core.md §7.3).
   */ const submitCreate = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        if ((0, $0d2396cd0d075e45$export$e12a912f36befd67)(form)) {
            setShowTitleError(true);
            return;
        }
        setSaving(true);
        try {
            const row = await createCase((0, $0d2396cd0d075e45$export$2b3224b6b788d4ea)(form));
            setCreating(false);
            if (row?.id) {
                toast.success(t('patients.created'));
                navigate('patient', {
                    caseId: row.id,
                    tab: 'history',
                    hint: 'created'
                });
            }
        } catch (err) {
            toast.error(t((0, $206625c7d33bd390$export$660244d64183d198)(err)));
        } finally{
            setSaving(false);
        }
    }, [
        form,
        createCase,
        navigate,
        t,
        toast
    ]);
    const confirmDelete = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        if (!deleteTarget) return;
        setDeleting(true);
        try {
            await deleteCase(deleteTarget.id);
            toast.success(t('patients.deleted'));
            setDeleteTarget(null);
        } catch (err) {
            toast.error(t((0, $206625c7d33bd390$export$660244d64183d198)(err)));
        } finally{
            setDeleting(false);
        }
    }, [
        deleteTarget,
        deleteCase,
        t,
        toast
    ]);
    const archive = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (row)=>{
        const next = row.status === 'archived' ? 'active' : 'archived';
        try {
            await setCaseStatus(row.id, next);
            toast.success(t(next === 'archived' ? 'patients.archived' : 'patients.unarchived'));
        } catch (err) {
            toast.error(t((0, $206625c7d33bd390$export$660244d64183d198)(err)));
        }
    }, [
        setCaseStatus,
        t,
        toast
    ]);
    // ── Navigation ──────────────────────────────────────────────────────────
    const open = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((row)=>navigate('patient', {
            caseId: row.id
        }), [
        navigate
    ]);
    /**
   * «شروع ویزیت» from the list opens the RECORD with the start dialog raised,
   * rather than starting a visit here.
   *
   * The reason («علت مراجعه») is a sentence the student writes, pre-filled from
   * the chief complaint, and a list row is not a place to write one. Passing it
   * through router state keeps the URL clean: `/patients/:id?start=1` would be a
   * link that re-raises the dialog every time it is pasted or refreshed.
   */ const startVisit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((row)=>{
        if (row.openEncounterId) {
            navigate('visit', {
                caseId: row.id,
                encounterId: row.openEncounterId
            });
            return;
        }
        navigate('patient', {
            caseId: row.id,
            startVisit: true
        });
    }, [
        navigate
    ]);
    const chat = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((row)=>navigate('chat', {
            caseId: row.id
        }), [
        navigate
    ]);
    // «پاک کردن فیلتر» shows EVERYTHING — `[]` is «همه» — not the default chips:
    // the copy beside it promises «برای دیدن همهٔ بیماران», and a student whose
    // only patients are archived would otherwise clear into another empty page
    // with the same button under it.
    const clearFilters = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setQuery('');
        setStatuses([]);
    }, []);
    // The three verdicts a loaded list can reach, never two at once. `loading`
    // folds in the "any patients at all?" probe so neither empty state renders
    // on a question that has not been answered.
    const settled = !loading && !anyLoading;
    const trulyEmpty = settled && !error && (0, $e418b5295d1aee37$export$bafb271d5e29da54)(hasAny);
    const filteredEmpty = settled && !error && (0, $e418b5295d1aee37$export$712b0a03f7afa51d)(hasAny, visible.length);
    return {
        cases: // data
        cases,
        visible: visible,
        loading: loading || anyLoading && !error,
        error: error,
        capped: capped,
        reload: reload,
        // paging — desktop pages, mobile grows
        page: currentPage,
        pages: pages,
        setPage: setPage,
        pageRows: pageRows,
        shownRows: shownRows,
        canShowMore: shownRows.length < visible.length,
        showMore: showMore,
        query: // toolbar
        query,
        setQuery: setQuery,
        statuses: statuses,
        toggleStatusChip: (id)=>setStatuses((prev)=>(0, $e418b5295d1aee37$export$49635392f5df92a2)(prev, id)),
        showAll: ()=>setStatuses([]),
        sort: sort,
        setSort: setSort,
        clearFilters: clearFilters,
        trulyEmpty: trulyEmpty,
        filteredEmpty: filteredEmpty,
        creating: // create
        creating,
        openCreate: openCreate,
        closeCreate: closeCreate,
        form: form,
        setForm: (patch)=>setForm((prev)=>({
                    ...prev,
                    ...patch
                })),
        saving: saving,
        showTitleError: showTitleError,
        submitCreate: submitCreate,
        open: // row actions
        open,
        startVisit: startVisit,
        chat: chat,
        archive: archive,
        deleteTarget: deleteTarget,
        setDeleteTarget: setDeleteTarget,
        deleting: deleting,
        confirmDelete: confirmDelete
    };
}
var $0c74351c78f3013a$export$2e2bcd8739ae039 = $0c74351c78f3013a$export$13b7a46e41457aec;



parcelRequire("acw62");



parcelRequire("acw62");




function $e26e88cba32ba6ed$export$2e2bcd8739ae039({ values: values = (0, $0d2396cd0d075e45$export$ce54d3cc6ef59461)(), onChange: onChange, disabled: disabled = false, showBanner: showBanner = true, showStatus: showStatus = true, showTitleError: showTitleError = false }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const set = (key)=>(e)=>onChange?.({
                [key]: e?.target ? e.target.value : e
            });
    const titleError = showTitleError ? (0, $0d2396cd0d075e45$export$e12a912f36befd67)(values) : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        },
        children: [
            showBanner && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$ac0d528804cbd713), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: t('caseForm.fields.title'),
                required: true,
                value: values.title,
                onChange: set('title'),
                placeholder: t('caseForm.fields.titlePlaceholder'),
                helperText: t('caseForm.fields.titleHelper'),
                error: titleError ? t(titleError) : '',
                disabled: disabled,
                maxLength: 200,
                "data-testid": "case-title"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: t('caseForm.fields.displayName'),
                value: values.displayName,
                onChange: set('displayName'),
                placeholder: t('caseForm.fields.displayNamePlaceholder'),
                helperText: t('caseForm.fields.displayNameHelper'),
                disabled: disabled,
                maxLength: 120,
                "data-testid": "case-display-name"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: t('practice.caseRef.label'),
                value: values.caseRef,
                onChange: set('caseRef'),
                helperText: t('practice.caseRef.helper'),
                disabled: disabled,
                maxLength: 64,
                "data-testid": "case-ref"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                    gap: 14
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        label: t('caseForm.fields.ageYears'),
                        type: "number",
                        value: values.ageYears,
                        onChange: set('ageYears'),
                        disabled: disabled,
                        dir: "ltr",
                        inputMode: "numeric",
                        "data-testid": "case-age-years"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        label: t('caseForm.fields.ageDisplay'),
                        value: values.ageDisplay,
                        onChange: set('ageDisplay'),
                        placeholder: t('caseForm.fields.ageDisplayPlaceholder'),
                        helperText: t('caseForm.fields.ageDisplayHelper'),
                        disabled: disabled,
                        maxLength: 40,
                        "data-testid": "case-age-display"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fcaca06c97c91379$export$2e2bcd8739ae039), {
                label: t('caseForm.fields.sex'),
                value: values.sex,
                onChange: (next)=>onChange?.({
                        sex: next
                    }),
                options: (0, $b9b56989c1caf471$export$e4df79674cc2462f).map((id)=>({
                        value: id,
                        label: t(`common.gender.${id}`)
                    })),
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                    gap: 14
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('caseForm.fields.bloodType'),
                        value: values.bloodType,
                        onChange: set('bloodType'),
                        options: (0, $b9b56989c1caf471$export$5ba55726e18aa88a).map((id)=>({
                                value: id,
                                label: id
                            })),
                        placeholder: t('common.labels.none'),
                        disabled: disabled,
                        "data-testid": "case-blood-type"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        label: t('caseForm.fields.weightKg'),
                        value: values.weightKg,
                        onChange: set('weightKg'),
                        disabled: disabled,
                        dir: "ltr",
                        inputMode: "decimal",
                        "data-testid": "case-weight"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        label: t('caseForm.fields.heightCm'),
                        value: values.heightCm,
                        onChange: set('heightCm'),
                        disabled: disabled,
                        dir: "ltr",
                        inputMode: "decimal",
                        "data-testid": "case-height"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: t('caseForm.fields.chiefComplaint'),
                value: values.chiefComplaint,
                onChange: set('chiefComplaint'),
                placeholder: t('caseForm.fields.chiefComplaintPlaceholder'),
                helperText: t('caseForm.fields.chiefComplaintHelper'),
                disabled: disabled,
                maxLength: 300,
                "data-testid": "case-chief-complaint"
            }),
            showStatus && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                label: t('caseForm.fields.status'),
                value: values.status,
                onChange: set('status'),
                options: (0, $0d2396cd0d075e45$export$b41c0f52c41112e3).map((id)=>({
                        value: id,
                        label: t(`patients.status.${id}`)
                    })),
                placeholder: "",
                disabled: disabled,
                "data-testid": "case-status"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                label: t('caseForm.fields.note'),
                value: values.note,
                onChange: set('note'),
                rows: 3,
                disabled: disabled,
                maxLength: 1000,
                "data-testid": "case-note"
            })
        ]
    });
}




function $69d8aed0f76f7fe3$export$9332229b6f2eae05({ open: open, onClose: onClose, values: values, onChange: onChange, onSubmit: onSubmit, saving: saving, showTitleError: showTitleError, mode: mode = 'create' }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const isEdit = mode === 'edit';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
        open: open,
        onOpenChange: (next)=>{
            if (!next) onClose();
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
            size: "lg",
            layout: "frame",
            "data-testid": "case-form-dialog",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$742513523b177e3b), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
                        children: t(isEdit ? 'caseForm.title.edit' : 'caseForm.title.create')
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$5d20f2c38fcde41f), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e26e88cba32ba6ed$export$2e2bcd8739ae039), {
                        values: values,
                        onChange: onChange,
                        disabled: saving,
                        // Status is absent on CREATE: every patient starts `active`, the
                        // contract's own default, and asking a student to classify a
                        // patient they have not written yet is a decision with no
                        // information behind it.
                        showStatus: isEdit,
                        showTitleError: showTitleError
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$7bbfb2d443473050), {
                    style: {
                        display: 'flex',
                        gap: 8,
                        marginTop: 16
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            onClick: onSubmit,
                            disabled: saving,
                            "data-testid": "case-form-submit",
                            children: saving ? t('common.actions.saving') : t(isEdit ? 'caseForm.submit.edit' : 'caseForm.submit.create')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "outline",
                            onClick: onClose,
                            disabled: saving,
                            children: t('common.actions.cancel')
                        })
                    ]
                })
            ]
        })
    });
}
function $69d8aed0f76f7fe3$export$55c02e214c96c853({ row: row, onCancel: onCancel, onConfirm: onConfirm, loading: loading }) {
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    if (!row) return null;
    const counts = (0, $e418b5295d1aee37$export$ab0d921fa7daf9a9)(row);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
        open: Boolean(row),
        onOpenChange: (next)=>{
            if (!next) onCancel();
        },
        title: t('patients.delete.title'),
        description: t('patients.delete.body', {
            entries: formatNumber(counts.entries),
            visits: formatNumber(counts.visits),
            threads: formatNumber(counts.threads)
        }),
        confirmLabel: t('patients.delete.confirm'),
        cancelLabel: t('common.actions.cancel'),
        destructive: true,
        loading: loading,
        onConfirm: onConfirm,
        confirmTestId: "delete-patient-confirm",
        "data-testid": "delete-patient-dialog",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            style: {
                margin: 0,
                fontSize: 12.5,
                opacity: 0.8
            },
            children: (0, $0d2396cd0d075e45$export$3805f9b7fa77f6d4)(row, t)
        })
    });
}
var $69d8aed0f76f7fe3$export$2e2bcd8739ae039 = $69d8aed0f76f7fe3$export$9332229b6f2eae05;




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $24a488cfd7efdee5$export$a2387ed3b5d536eb = {
    name: "ellipsis",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "1",
                key: "41hilf"
            }
        ],
        [
            "circle",
            {
                cx: "19",
                cy: "12",
                r: "1",
                key: "1wjl8i"
            }
        ],
        [
            "circle",
            {
                cx: "5",
                cy: "12",
                r: "1",
                key: "1pcz8c"
            }
        ]
    ],
    aliases: [
        "more-horizontal"
    ]
};
$24a488cfd7efdee5$export$a2387ed3b5d536eb.node;
const $24a488cfd7efdee5$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($24a488cfd7efdee5$export$a2387ed3b5d536eb);






// The ⋯ menu a patient row carries — «بایگانی» / «خروج از بایگانی» and «حذف».
//
// A component per ROW rather than one menu the list repositions: the kit's
// `Menu` measures itself against an anchor ref, and one shared anchor would open
// every row's menu beside the first row's button.
//
// Both surfaces render this one. The table puts it at the end of the action
// column, the card puts it in the card's own action row; the two destructive
// actions must not differ between them.
const $8bb708ac7e57d59d$var$MENU_ITEM = {
    display: 'block',
    width: '100%',
    textAlign: 'start',
    background: 'none',
    border: 0,
    padding: '11px 12px',
    fontSize: 13,
    cursor: 'pointer',
    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
    font: 'inherit'
};
function $8bb708ac7e57d59d$export$2e2bcd8739ae039({ row: row, onOpen: onOpen, onArchive: onArchive, onDelete: onDelete, size: size = 34 }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const anchorRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                ref: anchorRef,
                style: {
                    display: 'inline-flex'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                    variant: "ghost",
                    size: size,
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24a488cfd7efdee5$export$2e2bcd8739ae039), {
                        size: 16,
                        "aria-hidden": true
                    }),
                    label: t('patients.moreLabel', {
                        title: (0, $0d2396cd0d075e45$export$3805f9b7fa77f6d4)(row, t)
                    }),
                    onClick: (e)=>{
                        e.stopPropagation();
                        setOpen((v)=>!v);
                    },
                    "data-testid": `patient-more-${row.id}`
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $08d1958bc1315b40$export$2e2bcd8739ae039), {
                open: open,
                onClose: ()=>setOpen(false),
                anchorRef: anchorRef,
                ariaLabel: t('common.actions.more'),
                width: 220,
                placement: "auto",
                "data-testid": "patient-row-menu",
                children: [
                    onOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        role: "menuitem",
                        style: $8bb708ac7e57d59d$var$MENU_ITEM,
                        onClick: ()=>{
                            setOpen(false);
                            onOpen(row);
                        },
                        "data-testid": `patient-open-${row.id}`,
                        children: t('patients.actions.open')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        role: "menuitem",
                        style: $8bb708ac7e57d59d$var$MENU_ITEM,
                        onClick: ()=>{
                            setOpen(false);
                            onArchive(row);
                        },
                        "data-testid": `patient-archive-${row.id}`,
                        children: t((0, $e418b5295d1aee37$export$e254a38a69007d83)(row) ? 'patients.actions.unarchive' : 'patients.actions.archive')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        role: "menuitem",
                        style: {
                            ...$8bb708ac7e57d59d$var$MENU_ITEM,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red
                        },
                        onClick: ()=>{
                            setOpen(false);
                            onDelete(row);
                        },
                        "data-testid": `patient-delete-${row.id}`,
                        children: t('patients.actions.delete')
                    })
                ]
            })
        ]
    });
}



// «بیماران تمرینی» — the desktop list. core.md §7.3.
//
// A TABLE, not cards: the six facts a student compares across patients (name,
// age·sex, complaint, visit count, last visit, status) are one row each, and a
// card grid turns a scan down a column into a scan across a page. The phone
// gets cards for the opposite reason — a six-column table on a 360px viewport
// is a horizontal scroll.
//
// Everything below the toolbar is one of five states and never two at once:
// loading, error, no patients at all, nothing matching the filter, or the list.
// The toolbar stays usable in every one of them — an error must not take away
// the search box that would have narrowed the list that failed to load.
const $f41bc4c36c7784ab$var$TOOLBAR = {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    flexWrap: 'wrap',
    margin: '0 0 14px'
};
function $f41bc4c36c7784ab$export$2e2bcd8739ae039() {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const screen = (0, $0c74351c78f3013a$export$2e2bcd8739ae039)();
    const searchRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Ctrl/⌘+K focuses the search — registered here rather than in App.jsx so it
    // binds only while this screen is mounted, which is what core.md §7.0 means
    // by "on `/patients`". It is listed in the `?` overlay because it is labelled.
    (0, $0277e73c10ea225a$export$b0ebbe7904d8d94a)('ctrl+k', ()=>searchRef.current?.focus(), {
        label: t('shortcuts.search'),
        group: t('shortcuts.groups.general')
    });
    const columns = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>[
            {
                key: 'name',
                header: t('patients.columns.name'),
                render: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 7,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    fontWeight: 700,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                    overflowWrap: 'anywhere'
                                },
                                children: (0, $0d2396cd0d075e45$export$3805f9b7fa77f6d4)(row, t)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$480ec33bbf749db7), {
                                short: true
                            }),
                            row.caseRef && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    fontSize: 11,
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                                },
                                children: row.caseRef
                            })
                        ]
                    })
            },
            {
                key: 'age',
                header: t('patients.columns.age'),
                render: (row)=>[
                        (0, $0d2396cd0d075e45$export$4c461c63ce38f53)(row, t),
                        row.sex ? t(`common.gender.${row.sex}`) : ''
                    ].filter(Boolean).join(" \xb7 ") || t('common.labels.none')
            },
            {
                key: 'complaint',
                header: t('patients.columns.complaint'),
                render: (row)=>row.chiefComplaint || t('common.labels.none')
            },
            {
                key: 'visits',
                header: t('patients.columns.visits'),
                align: 'center',
                // The SERVER's count, never `encounters.length` — a list row carries no
                // children by contract, and `.length` there is always zero.
                render: (row)=>formatNumber(Number(row.encounterCount || 0))
            },
            {
                key: 'lastVisit',
                header: t('patients.columns.lastVisit'),
                render: (row)=>row.lastEncounterAtMs ? formatDate(row.lastEncounterAtMs, 'numeric') : t('patients.noVisits')
            },
            {
                key: 'status',
                header: t('patients.columns.status'),
                render: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                        variant: (0, $b9b56989c1caf471$export$d7735740545340b6)(row.status),
                        children: t((0, $b9b56989c1caf471$export$b19236ae32886af)(row.status))
                    })
            },
            {
                key: 'actions',
                header: t('patients.columns.actions'),
                align: 'end',
                render: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'inline-flex',
                            gap: 4
                        },
                        // The row itself opens the record; the action buttons must not do
                        // that as well on their way to doing their own job.
                        onClick: (e)=>e.stopPropagation(),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                variant: "ghost",
                                size: 34,
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02839c5704f38745$export$2e2bcd8739ae039), {
                                    size: 16,
                                    "aria-hidden": true
                                }),
                                label: (0, $e418b5295d1aee37$export$e254a38a69007d83)(row) ? t('record.header.archivedHint') : t('patients.actions.startVisit'),
                                disabled: (0, $e418b5295d1aee37$export$e254a38a69007d83)(row),
                                onClick: ()=>screen.startVisit(row),
                                "data-testid": `patient-visit-${row.id}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                variant: "ghost",
                                size: 34,
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c7fae0571c9b8a8$export$2e2bcd8739ae039), {
                                    size: 16,
                                    "aria-hidden": true
                                }),
                                label: t('patients.actions.chat'),
                                onClick: ()=>screen.chat(row),
                                "data-testid": `patient-chat-${row.id}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8bb708ac7e57d59d$export$2e2bcd8739ae039), {
                                row: row,
                                onOpen: screen.open,
                                onArchive: screen.archive,
                                onDelete: screen.setDeleteTarget
                            })
                        ]
                    })
            }
        ], [
        t,
        formatNumber,
        formatDate,
        screen
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            padding: '0 0 32px'
        },
        "data-testid": "patients-web",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed420e5a4f8c639f$export$2e2bcd8739ae039), {
                title: t('patients.title'),
                sub: t('patients.sub'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    onClick: screen.openCreate,
                    "data-testid": "patients-new",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83905746e46531b9$export$2e2bcd8739ae039), {
                            size: 15,
                            "aria-hidden": true
                        }),
                        t('patients.new')
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    padding: '16px 20px 0',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 14
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$ac0d528804cbd713), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: $f41bc4c36c7784ab$var$TOOLBAR,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $318ef1f4a903d866$export$2e2bcd8739ae039), {
                                ref: searchRef,
                                value: screen.query,
                                onChange: (e)=>screen.setQuery(e.target.value),
                                placeholder: t('patients.search'),
                                "aria-label": t('patients.search'),
                                clearLabel: t('common.actions.clear'),
                                style: {
                                    flex: '1 1 240px',
                                    maxWidth: 340
                                },
                                "data-testid": "patients-search"
                            }),
                            (0, $e418b5295d1aee37$export$8948eb492fe37509).map((chip)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                    label: t(chip.labelKey),
                                    active: (screen.statuses || []).includes(chip.id),
                                    onClick: ()=>screen.toggleStatusChip(chip.id),
                                    "data-testid": `patients-filter-${chip.id}`
                                }, chip.id)),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                label: t('patients.filters.all'),
                                active: (0, $e418b5295d1aee37$export$edd7bbe7fc62d9ee)(screen.statuses),
                                onClick: screen.showAll,
                                "data-testid": "patients-filter-all"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                value: screen.sort,
                                onChange: (e)=>screen.setSort(e.target.value),
                                options: (0, $b7360dc72487f1e9$export$f656c8688cd3f81d).map((id)=>({
                                        value: id,
                                        label: t((0, $e418b5295d1aee37$export$d939d340b531e39f)[id])
                                    })),
                                placeholder: "",
                                "aria-label": t('patients.sort.label'),
                                style: {
                                    marginInlineStart: 'auto',
                                    minWidth: 160
                                },
                                "data-testid": "patients-sort"
                            })
                        ]
                    }),
                    screen.capped && !screen.loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "info",
                        "data-testid": "patients-capped",
                        children: t('patients.capped')
                    }),
                    screen.loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        "data-testid": "patients-loading",
                        children: [
                            0,
                            1,
                            2
                        ].map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$8bbcb87f63697989), {}, i))
                    }),
                    !screen.loading && screen.error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9876d237fe8b99c$export$2e2bcd8739ae039), {
                        error: screen.error,
                        title: t('patients.error.title'),
                        description: t('patients.error.body'),
                        onRetry: screen.reload,
                        "data-testid": "patients-error"
                    }),
                    screen.trulyEmpty && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8446477c3df1c126$export$2e2bcd8739ae039), {
                            size: 44,
                            strokeWidth: 1.5,
                            "aria-hidden": true
                        }),
                        title: t('patients.empty.title'),
                        description: t('patients.empty.body'),
                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            onClick: screen.openCreate,
                            "data-testid": "patients-empty-new",
                            children: t('patients.new')
                        }),
                        "data-testid": "patients-empty"
                    }),
                    screen.filteredEmpty && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6117d2af5e6ea38b$export$2e2bcd8739ae039), {
                            size: 44,
                            strokeWidth: 1.5,
                            "aria-hidden": true
                        }),
                        title: t('patients.noMatch.title'),
                        description: t('patients.noMatch.body'),
                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "outline",
                            onClick: screen.clearFilters,
                            "data-testid": "patients-clear-filter",
                            children: t('patients.actions.clearFilters')
                        }),
                        "data-testid": "patients-no-match"
                    }),
                    !screen.loading && !screen.error && screen.visible.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                                columns: columns,
                                rows: screen.pageRows,
                                rowKey: (row)=>row.id,
                                onRowActivate: screen.open,
                                rowProps: (row)=>({
                                        'data-testid': `patient-row-${row.id}`,
                                        'aria-label': t('patients.openLabel', {
                                            title: (0, $0d2396cd0d075e45$export$3805f9b7fa77f6d4)(row, t)
                                        })
                                    }),
                                "data-testid": "patients-table"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                "data-testid": "patients-pager",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bca3244df749c49$export$2e2bcd8739ae039), {
                                    page: screen.page,
                                    pageCount: screen.pages,
                                    onChange: screen.setPage,
                                    prevLabel: t('common.pager.prev'),
                                    nextLabel: t('common.pager.next'),
                                    pageLabel: (current, pages)=>t('common.pager.page', {
                                            current: current,
                                            pages: pages
                                        }),
                                    formatNumber: formatNumber
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69d8aed0f76f7fe3$export$9332229b6f2eae05), {
                open: screen.creating,
                onClose: screen.closeCreate,
                values: screen.form,
                onChange: screen.setForm,
                onSubmit: screen.submitCreate,
                saving: screen.saving,
                showTitleError: screen.showTitleError,
                mode: "create"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69d8aed0f76f7fe3$export$55c02e214c96c853), {
                row: screen.deleteTarget,
                onCancel: ()=>screen.setDeleteTarget(null),
                onConfirm: screen.confirmDelete,
                loading: screen.deleting
            })
        ]
    });
}



parcelRequire("acw62");








parcelRequire("acw62");



const $45e53d65b3e0238c$export$156186cd9d0794 = ({ children: children, count: count, action: action, style: style })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            margin: '0 0 0.5rem',
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                style: {
                    margin: 0,
                    fontSize: '0.8125rem',
                    fontWeight: 800,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                },
                children: children
            }),
            count != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    fontSize: '0.6875rem',
                    fontWeight: 700,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                },
                children: count
            }),
            action && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    marginInlineStart: 'auto'
                },
                children: action
            })
        ]
    });
const $45e53d65b3e0238c$export$ca7697601dcd7803 = ({ onClick: onClick, testId: testId })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "outline",
        onClick: onClick,
        "data-testid": testId,
        className: "w-full min-h-11",
        style: {
            marginTop: '0.5rem'
        },
        children: t('mobile.showMore')
    });
};
const $45e53d65b3e0238c$export$4f0e1e0c5eb41359 = ({ label: label, value: value, ltr: ltr })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const empty = value == null || value === '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'baseline',
            gap: '0.75rem',
            padding: '0.625rem 0',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                    flexShrink: 0
                },
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...ltr && !empty ? {
                    dir: 'ltr'
                } : {},
                style: {
                    fontSize: '0.8125rem',
                    color: empty ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                    marginInlineStart: 'auto',
                    textAlign: 'end',
                    minWidth: 0,
                    overflowWrap: 'anywhere',
                    ...ltr && !empty ? {
                        unicodeBidi: 'isolate'
                    } : {}
                },
                children: empty ? t('common.labels.none') : value
            })
        ]
    });
};
var $45e53d65b3e0238c$export$2e2bcd8739ae039 = $45e53d65b3e0238c$export$156186cd9d0794;








// «بیماران» on a phone — the same list, as cards. core.md §7.3.
//
// The table's six columns become one card each, in the order a thumb reads
// them: who, then the complaint, then how much work is already in there. The
// sort control is gone — the default («آخرین ویزیت») is the one a phone user
// wants, and a fourth control in a 360px toolbar costs more than the choice is
// worth. Everything else — the search, the chips, the actions, the two dialogs
// — is the same behaviour, from the same hook.
const $34ccae04bdd17fac$var$SCROLL = {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    padding: '12px 14px calc(88px + env(safe-area-inset-bottom, 0px))',
    display: 'flex',
    flexDirection: 'column',
    gap: 10
};
const $34ccae04bdd17fac$var$FAB = {
    position: 'fixed',
    insetInlineEnd: 16,
    bottom: 'calc(var(--app-bottom-nav, 64px) + 16px + env(safe-area-inset-bottom, 0px))',
    zIndex: 20
};
function $34ccae04bdd17fac$var$PatientCard({ row: row, onOpen: onOpen, onVisit: onVisit, onChat: onChat, onArchive: onArchive, onDelete: onDelete }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        onClick: ()=>onOpen(row),
        role: "button",
        "data-testid": `patient-card-${row.id}`,
        style: {
            padding: 12,
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 7,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontWeight: 800,
                            fontSize: 14,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                        },
                        children: (0, $0d2396cd0d075e45$export$3805f9b7fa77f6d4)(row, t)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$480ec33bbf749db7), {
                        short: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                        variant: (0, $b9b56989c1caf471$export$d7735740545340b6)(row.status),
                        style: {
                            marginInlineStart: 'auto'
                        },
                        children: t((0, $b9b56989c1caf471$export$b19236ae32886af)(row.status))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 12,
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                },
                children: [
                    (0, $0d2396cd0d075e45$export$4c461c63ce38f53)(row, t),
                    row.sex ? t(`common.gender.${row.sex}`) : '',
                    row.caseRef
                ].filter(Boolean).join(" \xb7 ")
            }),
            row.chiefComplaint && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 13,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                },
                children: row.chiefComplaint
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    fontSize: 11.5,
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                },
                children: [
                    t('patients.visitsCount', {
                        count: formatNumber(Number(row.encounterCount || 0))
                    }),
                    row.lastEncounterAtMs ? ` \xb7 ${formatDate(row.lastEncounterAtMs, 'numeric')}` : ''
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 4,
                    marginTop: 2
                },
                onClick: (e)=>e.stopPropagation(),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: 40,
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02839c5704f38745$export$2e2bcd8739ae039), {
                            size: 17,
                            "aria-hidden": true
                        }),
                        label: (0, $e418b5295d1aee37$export$e254a38a69007d83)(row) ? t('record.header.archivedHint') : t('patients.actions.startVisit'),
                        disabled: (0, $e418b5295d1aee37$export$e254a38a69007d83)(row),
                        onClick: ()=>onVisit(row),
                        "data-testid": `patient-visit-${row.id}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: 40,
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c7fae0571c9b8a8$export$2e2bcd8739ae039), {
                            size: 17,
                            "aria-hidden": true
                        }),
                        label: t('patients.actions.chat'),
                        onClick: ()=>onChat(row),
                        "data-testid": `patient-chat-${row.id}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            marginInlineStart: 'auto'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8bb708ac7e57d59d$export$2e2bcd8739ae039), {
                            row: row,
                            onOpen: onOpen,
                            onArchive: onArchive,
                            onDelete: onDelete,
                            size: 40
                        })
                    })
                ]
            })
        ]
    });
}
function $34ccae04bdd17fac$export$2e2bcd8739ae039() {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const { me: me } = (0, $5bc9ff20f6a2b818$export$f637e1cf42d15a62)();
    const screen = (0, $0c74351c78f3013a$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62f4a9fc87ba90f8$export$2e2bcd8739ae039), {
                user: {
                    name: me?.fullName || ''
                },
                greeting: t('mobile.greeting'),
                title: t('patients.title'),
                sticky: true,
                search: {
                    value: screen.query,
                    onChange: (value)=>screen.setQuery(value),
                    placeholder: t('patients.search'),
                    onClear: ()=>screen.setQuery(''),
                    clearLabel: t('common.actions.clear'),
                    testId: 'patients-search'
                },
                "data-testid": "patients-mobile-header",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: 'flex',
                        gap: 6,
                        overflowX: 'auto',
                        paddingBottom: 2
                    },
                    children: [
                        (0, $e418b5295d1aee37$export$8948eb492fe37509).map((chip)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                label: t(chip.labelKey),
                                active: (screen.statuses || []).includes(chip.id),
                                onClick: ()=>screen.toggleStatusChip(chip.id),
                                "data-testid": `patients-filter-${chip.id}`
                            }, chip.id)),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                            label: t('patients.filters.all'),
                            active: (0, $e418b5295d1aee37$export$edd7bbe7fc62d9ee)(screen.statuses),
                            onClick: screen.showAll,
                            "data-testid": "patients-filter-all"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: $34ccae04bdd17fac$var$SCROLL,
                "data-testid": "patients-mobile",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$ac0d528804cbd713), {}),
                    screen.capped && !screen.loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "info",
                        "data-testid": "patients-capped",
                        children: t('patients.capped')
                    }),
                    screen.loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        "data-testid": "patients-loading",
                        style: {
                            display: 'grid',
                            gap: 10
                        },
                        children: [
                            0,
                            1,
                            2
                        ].map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {}, i))
                    }),
                    !screen.loading && screen.error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9876d237fe8b99c$export$2e2bcd8739ae039), {
                        error: screen.error,
                        title: t('patients.error.title'),
                        description: t('patients.error.body'),
                        onRetry: screen.reload,
                        "data-testid": "patients-error"
                    }),
                    screen.trulyEmpty && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8446477c3df1c126$export$2e2bcd8739ae039), {
                            size: 44,
                            strokeWidth: 1.5,
                            "aria-hidden": true
                        }),
                        title: t('patients.empty.title'),
                        description: t('patients.empty.body'),
                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            onClick: screen.openCreate,
                            "data-testid": "patients-empty-new",
                            children: t('patients.new')
                        }),
                        "data-testid": "patients-empty"
                    }),
                    screen.filteredEmpty && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6117d2af5e6ea38b$export$2e2bcd8739ae039), {
                            size: 44,
                            strokeWidth: 1.5,
                            "aria-hidden": true
                        }),
                        title: t('patients.noMatch.title'),
                        description: t('patients.noMatch.body'),
                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "outline",
                            onClick: screen.clearFilters,
                            "data-testid": "patients-clear-filter",
                            children: t('patients.actions.clearFilters')
                        }),
                        "data-testid": "patients-no-match"
                    }),
                    !screen.loading && !screen.error && screen.shownRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($34ccae04bdd17fac$var$PatientCard, {
                            row: row,
                            onOpen: screen.open,
                            onVisit: screen.startVisit,
                            onChat: screen.chat,
                            onArchive: screen.archive,
                            onDelete: screen.setDeleteTarget
                        }, row.id)),
                    !screen.loading && !screen.error && screen.canShowMore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$ca7697601dcd7803), {
                        onClick: screen.showMore,
                        testId: "patients-show-more"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                onClick: screen.openCreate,
                style: $34ccae04bdd17fac$var$FAB,
                className: "min-h-11 rounded-full shadow-lg",
                "data-testid": "patients-new",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83905746e46531b9$export$2e2bcd8739ae039), {
                        size: 16,
                        "aria-hidden": true
                    }),
                    t('patients.new')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69d8aed0f76f7fe3$export$9332229b6f2eae05), {
                open: screen.creating,
                onClose: screen.closeCreate,
                values: screen.form,
                onChange: screen.setForm,
                onSubmit: screen.submitCreate,
                saving: screen.saving,
                showTitleError: screen.showTitleError,
                mode: "create"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69d8aed0f76f7fe3$export$55c02e214c96c853), {
                row: screen.deleteTarget,
                onCancel: ()=>screen.setDeleteTarget(null),
                onConfirm: screen.confirmDelete,
                loading: screen.deleting
            })
        ]
    });
}


// «بیماران» — two surfaces, one list.
//
// Both read the same query through the same hook, filter and sort with the same
// pure functions, and raise the same two dialogs. What forks is the shape of a
// row: a table on a monitor, a card under a thumb.
const $87056e061dab16ec$var$PatientsScreen = ()=>{
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    return isMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34ccae04bdd17fac$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f41bc4c36c7784ab$export$2e2bcd8739ae039), {});
};
var $87056e061dab16ec$export$2e2bcd8739ae039 = $87056e061dab16ec$var$PatientsScreen;




var $acw62 = parcelRequire("acw62");



// The record's behaviour, once — so the two surfaces cannot disagree about what
// a button does, only about where it sits.
//
// It owns the record query, the three overlays (start a visit, edit the
// patient, delete the patient) and every navigation the record can make. Both
// `PatientRecord.web.jsx` and `PatientRecord.mobile.jsx` render its return
// value; neither one holds data state of its own.

var $acw62 = parcelRequire("acw62");




// One practice patient's whole record, in one round trip.
//
// `myCaseRecord` is the deepest legitimate query in the contract (core.md §10):
// the patient with their history entries, every encounter with its note,
// diagnoses, rx items and orders, the thread summaries, and the views the BFF
// derives — active problems, current medications, pending orders, the timeline.
// The record screen's four tabs are four readings of THAT ONE ANSWER, which is
// why they do not each fetch: a student switching from خلاصه to خط زمانی is
// re-reading, not re-asking, and four tab-owned queries would give the four
// tabs four different moments of the same patient.
//
// ── `null` is a STATE, not an error ────────────────────────────────────────
//
// `myCaseRecord` answers null both when the patient does not exist and when
// they belong to another student — DELIBERATELY indistinguishable, so an error
// response cannot be used to confirm which ids exist on the platform one id at
// a time (core.md §3.2). There is no `CASE_FORBIDDEN` code and there must not
// be one.
//
// So a null answer is NOT an error: it does not set `error`, it offers no
// retry, and it renders exactly ONE screen — «این بیمار پیدا نشد» — never
// «متعلق به شما نیست», which is the same oracle spoken in Persian.
//
// ── Why the history is re-read on its own after a save ────────────────────
//
// `caseHistory` is redundant with the record's `entries` and the frozen schema
// keeps it anyway, for exactly this: the شرح حال tab saves a section and needs
// the entries back, not the whole record. Re-reading everything after a
// sentence-sized save would repaint the header — the counts, «آخرین ویزیت» —
// under a student who is mid-sentence in a textarea below it.

var $acw62 = parcelRequire("acw62");



/** The empty record, so a screen never has to guard every field it reads. */ const $e3155ebf6c2a69ee$var$EMPTY_RECORD = {
    case: null,
    encounters: [],
    threads: [],
    activeProblems: [],
    currentMedications: [],
    pendingOrders: [],
    timeline: []
};
function $e3155ebf6c2a69ee$export$20da053cc5412fe8(caseId) {
    const [record, setRecord] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($e3155ebf6c2a69ee$var$EMPTY_RECORD);
    const [entries, setEntries] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [nonce, setNonce] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!caseId) {
            setLoading(false);
            return undefined;
        }
        let alive = true;
        setLoading(true);
        (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$a5e6f2cc85ed53f7), {
            caseId: caseId
        }).then((data)=>{
            if (!alive) return;
            const next = data?.myCaseRecord || null;
            setRecord(next ? {
                ...$e3155ebf6c2a69ee$var$EMPTY_RECORD,
                ...next
            } : $e3155ebf6c2a69ee$var$EMPTY_RECORD);
            setEntries(next?.case?.entries || []);
            // Not an error. See the header: null is "not available", full stop.
            setError(null);
        }).catch((err)=>{
            if (!alive) return;
            console.error('[useCaseRecord] failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
            setError(err);
            setRecord($e3155ebf6c2a69ee$var$EMPTY_RECORD);
            setEntries([]);
        }).finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        caseId,
        nonce
    ]);
    const reload = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setNonce((n)=>n + 1), []);
    /** Pull the history back without disturbing the header. */ const reloadHistory = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        if (!caseId) return;
        try {
            const data = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$3c1db077bd82bd9d), {
                caseId: caseId,
                sections: null
            });
            setEntries(data?.caseHistory || []);
        } catch (err) {
            console.error('[useCaseRecord] history reload failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
        // Deliberately NOT cleared: the entries on screen are the ones that were
        // read successfully a moment ago, and blanking them because a refetch
        // failed would look to the student like their writing was lost.
        }
    }, [
        caseId
    ]);
    /**
   * Update the patient. OMITTED FIELDS ARE LEFT ALONE; `''` (or `0` for a
   * number) clears one.
   *
   * The caller builds the input from what actually CHANGED
   * (`buildCaseUpdate` in src/lib/caseForm.js). Sending the whole form every
   * time works only as long as the form holds every field; the day it holds a
   * subset, a student editing the title erases the rest.
   */ const updateCase = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (input)=>{
        const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$1a72deffcb882601), {
            caseId: caseId,
            input: input
        });
        const row = data?.updateCase;
        // `updateCase` answers with the CaseRow shape — no `entries` — so the
        // entries already in state are kept rather than overwritten with undefined.
        if (row) setRecord((prev)=>({
                ...prev,
                case: {
                    ...prev.case || {},
                    ...row
                }
            }));
        return row || null;
    }, [
        caseId
    ]);
    const deleteCase = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$103f04c571adf29b), {
            caseId: caseId
        });
        (0, $5bc9ff20f6a2b818$export$b8488b78b8e134a0)();
    }, [
        caseId
    ]);
    /**
   * Append entries. ALL-OR-NOTHING, and plural for a reason: the dictation flow
   * submits a whole drafted history at once, and half a history is worse than
   * none — a patient whose سابقه landed and whose داروها did not reads to the
   * model as someone on no drugs.
   */ const addHistory = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (rows)=>{
        const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$e169d2c267301cd2), {
            caseId: caseId,
            entries: rows
        });
        const added = data?.addCaseHistory || [];
        if (added.length) setEntries((prev)=>[
                ...prev,
                ...added
            ]);
        return added;
    }, [
        caseId
    ]);
    /**
   * Edit one entry.
   *
   * `section` and `source` are not in the update input and cannot be sent:
   * provenance is a fact about how a row came to exist (core.md §3.4), and an
   * editable one would let a voice draft become indistinguishable from a
   * sentence the student wrote themselves.
   */ const updateEntry = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (entryId, input)=>{
        const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$c87054baf27a4c54), {
            entryId: entryId,
            input: input
        });
        const row = data?.updateCaseHistoryEntry;
        if (row) setEntries((prev)=>prev.map((e)=>e.id === row.id ? row : e));
        return row || null;
    }, []);
    const deleteEntry = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (entryId)=>{
        await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$7582e661207c1f6a), {
            entryId: entryId
        });
        setEntries((prev)=>prev.filter((e)=>e.id !== entryId));
    }, []);
    /**
   * Open a visit.
   *
   * ONE open visit per patient is enforced by a partial unique index in the
   * store, not by a check here (core.md §6): a check would race with a second
   * tab. When the store refuses, the BFF answers `ENCOUNTER_ALREADY_OPEN` with
   * the open visit's id in `extensions`, and the RIGHT behaviour is to go
   * there — the student asked to see a visit for this patient, and there is
   * one. So this resolves to `{ encounter, alreadyOpenId }` rather than
   * throwing: `alreadyOpenId` is a destination, not a failure, and only the
   * screen knows to toast «ویزیت بازی وجود داشت» on the way.
   *
   * `CASE_ARCHIVED` and everything else still throws.
   */ const startEncounter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (reason)=>{
        try {
            const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$30609e7e70a5aa46), {
                caseId: caseId,
                reason: reason ? String(reason) : null
            });
            return {
                encounter: data?.startEncounter || null,
                alreadyOpenId: null
            };
        } catch (err) {
            const openId = (0, $206625c7d33bd390$export$3d6af2ad46593459)(err);
            if (openId) return {
                encounter: null,
                alreadyOpenId: openId
            };
            throw err;
        }
    }, [
        caseId
    ]);
    const caseRow = record.case;
    return {
        record: record,
        caseRow: caseRow,
        entries: entries,
        encounters: record.encounters || [],
        threads: record.threads || [],
        activeProblems: record.activeProblems || [],
        currentMedications: record.currentMedications || [],
        pendingOrders: record.pendingOrders || [],
        timeline: record.timeline || [],
        loading: loading,
        error: error,
        // `notFound` is separate from `error` because they are different screens and
        // only one of them gets a retry button.
        notFound: !loading && !error && !caseRow,
        reload: reload,
        reloadHistory: reloadHistory,
        updateCase: updateCase,
        deleteCase: deleteCase,
        addHistory: addHistory,
        updateEntry: updateEntry,
        deleteEntry: deleteEntry,
        startEncounter: startEncounter
    };
}
var $e3155ebf6c2a69ee$export$2e2bcd8739ae039 = $e3155ebf6c2a69ee$export$20da053cc5412fe8;




// The record's shared contract: which tabs exist, what the header says, and the
// three small derivations neither surface should re-invent.
//
// The TABS are a URL segment (`/patients/:caseId/:tab?`), so this list is also a
// whitelist: a stale or hand-edited link must land on a real tab rather than
// render nothing. `overview` is the default and is omitted from the URL, which
// is what keeps every link to a patient short.
//
// Pure and React-free.

const $6ea44a98f4200fa8$export$e37f800954697bae = (id)=>(0, $16250bd714b02a14$export$8029ceef39221f73)(id);
const $6ea44a98f4200fa8$export$6a9eb02d63937257 = {
    overview: 'record.tabs.overview',
    history: 'record.tabs.history',
    visits: 'record.tabs.visits',
    timeline: 'record.tabs.timeline'
};
function $6ea44a98f4200fa8$export$eb6c7bd144b8773c(row, { t: t, formatNumber: formatNumber, formatDate: formatDate, ageLabel: ageLabel }) {
    if (!row) return [];
    const chips = [];
    const age = ageLabel(row, t);
    const sex = row.sex ? t(`common.gender.${row.sex}`) : '';
    const line = [
        age,
        sex
    ].filter(Boolean).join(" \xb7 ");
    if (line) chips.push({
        id: 'age',
        label: line
    });
    if (row.bloodType) chips.push({
        id: 'blood',
        label: row.bloodType
    });
    chips.push({
        id: 'visits',
        label: t('record.header.visits', {
            count: formatNumber(Number(row.encounterCount || 0))
        })
    });
    if (row.lastEncounterAtMs) chips.push({
        id: 'lastVisit',
        label: t('record.header.lastVisit', {
            date: formatDate(row.lastEncounterAtMs, 'numeric')
        })
    });
    return chips;
}
const $6ea44a98f4200fa8$export$624685a2c87360c0 = (row)=>row?.openEncounterId ? 'record.actions.continueVisit' : 'record.actions.startVisit';
const $6ea44a98f4200fa8$export$1c550145b6acb76a = (row)=>String(row?.chiefComplaint || '').trim();
const $6ea44a98f4200fa8$export$8a72e3ba861c222a = (entries)=>(entries || []).filter((e)=>e?.section === 'allergies');
const $6ea44a98f4200fa8$export$69e1e330d33bcd11 = (threads, limit = 3)=>[
        ...threads || []
    ].filter((thread)=>!thread?.encounterId).sort((a, b)=>Number(b?.lastMessageAtMs || 0) - Number(a?.lastMessageAtMs || 0)).slice(0, limit);
const $6ea44a98f4200fa8$export$f0b17a59af8beedc = (encounters)=>[
        ...encounters || []
    ].sort((a, b)=>Number(b?.seq || 0) - Number(a?.seq || 0));
const $6ea44a98f4200fa8$export$fcd067ef9afe7672 = (encounters)=>$6ea44a98f4200fa8$export$f0b17a59af8beedc(encounters)[0] || null;
function $6ea44a98f4200fa8$export$c7ae287039599931(text, max = 140) {
    const line = String(text || '').split('\n').map((s)=>s.trim()).find(Boolean) || '';
    return line.length > max ? `${line.slice(0, max).trimEnd()}\u{2026}` : line;
}


function $c38f3af236f736a1$export$81c3f84a6d529b92(caseId) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const record = (0, $e3155ebf6c2a69ee$export$20da053cc5412fe8)(caseId);
    const { caseRow: caseRow } = record;
    // ── Start a visit ───────────────────────────────────────────────────────
    const [startOpen, setStartOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [reason, setReason] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [starting, setStarting] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const openStart = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setReason((0, $6ea44a98f4200fa8$export$1c550145b6acb76a)(caseRow));
        setStartOpen(true);
    }, [
        caseRow
    ]);
    /**
   * The list's «شروع ویزیت» hands the intent over in ROUTER STATE rather than
   * in the URL: `?start=1` would be a link that re-raises the dialog every time
   * it is pasted, bookmarked or refreshed. It fires once, when the record has
   * loaded enough to pre-fill the reason.
   */ const consumed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (consumed.current || !caseRow) return;
        if (!location.state?.startVisit) return;
        consumed.current = true;
        if (caseRow.openEncounterId) {
            navigate('visit', {
                caseId: caseId,
                encounterId: caseRow.openEncounterId,
                replace: true
            });
            return;
        }
        openStart();
    }, [
        caseRow,
        location.state,
        openStart,
        navigate,
        caseId
    ]);
    /**
   * Start, or go to the visit that was already open.
   *
   * `ENCOUNTER_ALREADY_OPEN` is not an error the student can act on — there IS
   * a visit for this patient and they asked to be in one — so the hook resolves
   * it to a destination and this toasts on the way (core.md §7.4).
   */ const submitStart = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        setStarting(true);
        try {
            const { encounter: encounter, alreadyOpenId: alreadyOpenId } = await record.startEncounter(reason);
            setStartOpen(false);
            if (alreadyOpenId) {
                toast.info(t('record.startVisit.alreadyOpen'));
                navigate('visit', {
                    caseId: caseId,
                    encounterId: alreadyOpenId
                });
                return;
            }
            if (encounter?.id) navigate('visit', {
                caseId: caseId,
                encounterId: encounter.id
            });
        } catch (err) {
            toast.error(t((0, $206625c7d33bd390$export$660244d64183d198)(err)));
        } finally{
            setStarting(false);
        }
    }, [
        record,
        reason,
        navigate,
        caseId,
        t,
        toast
    ]);
    const startVisit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        // Same button, two jobs (core.md §7.4): continue the open visit, or open the
        // dialog that starts one.
        if (caseRow?.openEncounterId) {
            navigate('visit', {
                caseId: caseId,
                encounterId: caseRow.openEncounterId
            });
            return;
        }
        openStart();
    }, [
        caseRow,
        navigate,
        caseId,
        openStart
    ]);
    // ── Edit the patient ────────────────────────────────────────────────────
    const [editOpen, setEditOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $0d2396cd0d075e45$export$4c9aaaee61fbef99)(null));
    const [savingEdit, setSavingEdit] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [showTitleError, setShowTitleError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const openEdit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setForm((0, $0d2396cd0d075e45$export$4c9aaaee61fbef99)(caseRow));
        setShowTitleError(false);
        setEditOpen(true);
    }, [
        caseRow
    ]);
    const submitEdit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        if (!String(form.title || '').trim()) {
            setShowTitleError(true);
            return;
        }
        // ONLY WHAT CHANGED. Sending the whole form would work exactly as long as
        // the form holds every field — and the day it holds a subset, editing the
        // title erases the rest.
        const patch = (0, $0d2396cd0d075e45$export$7a3fbc8940b4d9c0)(caseRow, form);
        if (!Object.keys(patch).length) {
            setEditOpen(false);
            return;
        }
        setSavingEdit(true);
        try {
            await record.updateCase(patch);
            setEditOpen(false);
            toast.success(t('record.saved'));
        } catch (err) {
            toast.error(t((0, $206625c7d33bd390$export$660244d64183d198)(err)));
        } finally{
            setSavingEdit(false);
        }
    }, [
        form,
        caseRow,
        record,
        t,
        toast
    ]);
    // ── Archive / delete ────────────────────────────────────────────────────
    const [deleteOpen, setDeleteOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [deleting, setDeleting] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const toggleArchive = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const next = caseRow?.status === 'archived' ? 'active' : 'archived';
        try {
            await record.updateCase({
                status: next
            });
            toast.success(t(next === 'archived' ? 'patients.archived' : 'patients.unarchived'));
        } catch (err) {
            toast.error(t((0, $206625c7d33bd390$export$660244d64183d198)(err)));
        }
    }, [
        caseRow,
        record,
        t,
        toast
    ]);
    const confirmDelete = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        setDeleting(true);
        try {
            await record.deleteCase();
            toast.success(t('patients.deleted'));
            // Back to the list, REPLACING this entry: the record the student just
            // deleted must not be one step back on the history stack.
            navigate('patients', {
                replace: true
            });
        } catch (err) {
            toast.error(t((0, $206625c7d33bd390$export$660244d64183d198)(err)));
        } finally{
            setDeleting(false);
            setDeleteOpen(false);
        }
    }, [
        record,
        navigate,
        t,
        toast
    ]);
    // ── Navigation ──────────────────────────────────────────────────────────
    const openVisit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((encounter)=>navigate('visit', {
            caseId: caseId,
            encounterId: encounter.id
        }), [
        navigate,
        caseId
    ]);
    const openChat = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((thread)=>navigate('chat', {
            caseId: caseId,
            threadId: thread?.id
        }), [
        navigate,
        caseId
    ]);
    const back = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>navigate('patients'), [
        navigate
    ]);
    return {
        ...record,
        archived: caseRow?.status === 'archived',
        startOpen: // start a visit
        startOpen,
        startVisit: startVisit,
        closeStart: ()=>setStartOpen(false),
        reason: reason,
        setReason: setReason,
        starting: starting,
        submitStart: submitStart,
        editOpen: // edit
        editOpen,
        openEdit: openEdit,
        closeEdit: ()=>setEditOpen(false),
        form: form,
        setForm: (patch)=>setForm((prev)=>({
                    ...prev,
                    ...patch
                })),
        savingEdit: savingEdit,
        showTitleError: showTitleError,
        submitEdit: submitEdit,
        toggleArchive: // archive / delete
        toggleArchive,
        deleteOpen: deleteOpen,
        openDelete: ()=>setDeleteOpen(true),
        closeDelete: ()=>setDeleteOpen(false),
        deleting: deleting,
        confirmDelete: confirmDelete,
        openVisit: // navigation
        openVisit,
        openChat: openChat,
        back: back,
        navigate: navigate
    };
}
var $c38f3af236f736a1$export$2e2bcd8739ae039 = $c38f3af236f736a1$export$81c3f84a6d529b92;



parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ed00022cb253e04b$export$a2387ed3b5d536eb = {
    name: "user-x",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
                key: "1yyitq"
            }
        ],
        [
            "circle",
            {
                cx: "9",
                cy: "7",
                r: "4",
                key: "nufk8"
            }
        ],
        [
            "line",
            {
                x1: "17",
                x2: "22",
                y1: "8",
                y2: "13",
                key: "3nzzx3"
            }
        ],
        [
            "line",
            {
                x1: "22",
                x2: "17",
                y1: "8",
                y2: "13",
                key: "1swrse"
            }
        ]
    ]
};
$ed00022cb253e04b$export$a2387ed3b5d536eb.node;
const $ed00022cb253e04b$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($ed00022cb253e04b$export$a2387ed3b5d536eb);









parcelRequire("acw62");


function $88c24f7fc32991d2$export$2e2bcd8739ae039({ open: open, onClose: onClose, reason: reason, onReason: onReason, onSubmit: onSubmit, saving: saving }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
        open: open,
        onOpenChange: (next)=>{
            if (!next) onClose();
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
            size: "sm",
            "data-testid": "start-visit-dialog",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$742513523b177e3b), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
                        children: t('record.startVisit.title')
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$5d20f2c38fcde41f), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                        label: t('record.startVisit.reason'),
                        helperText: t('record.startVisit.reasonHelper'),
                        value: reason,
                        onChange: (e)=>onReason(e.target.value),
                        rows: 3,
                        maxLength: 500,
                        disabled: saving,
                        autoFocus: true,
                        "data-testid": "start-visit-reason"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$7bbfb2d443473050), {
                    style: {
                        display: 'flex',
                        gap: 8,
                        marginTop: 16
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            onClick: onSubmit,
                            disabled: saving,
                            "data-testid": "start-visit-submit",
                            children: saving ? t('common.actions.saving') : t('record.startVisit.submit')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "outline",
                            onClick: onClose,
                            disabled: saving,
                            children: t('common.actions.cancel')
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3f35c50d66e81764$export$a2387ed3b5d536eb = {
    name: "clipboard-list",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1",
                key: "tgr4d6"
            }
        ],
        [
            "path",
            {
                d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
                key: "116196"
            }
        ],
        [
            "path",
            {
                d: "M12 11h4",
                key: "1jrz19"
            }
        ],
        [
            "path",
            {
                d: "M12 16h4",
                key: "n85exb"
            }
        ],
        [
            "path",
            {
                d: "M8 11h.01",
                key: "1dfujw"
            }
        ],
        [
            "path",
            {
                d: "M8 16h.01",
                key: "18s6g9"
            }
        ]
    ]
};
$3f35c50d66e81764$export$a2387ed3b5d536eb.node;
const $3f35c50d66e81764$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($3f35c50d66e81764$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $241691b67a43640c$export$a2387ed3b5d536eb = {
    name: "flask-conical",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2",
                key: "18mbvz"
            }
        ],
        [
            "path",
            {
                d: "M6.453 15h11.094",
                key: "3shlmq"
            }
        ],
        [
            "path",
            {
                d: "M8.5 2h7",
                key: "csnxdl"
            }
        ]
    ]
};
$241691b67a43640c$export$a2387ed3b5d536eb.node;
const $241691b67a43640c$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($241691b67a43640c$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7cb92f499384d208$export$a2387ed3b5d536eb = {
    name: "id-card",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13 19a4 4 0 00-8 0",
                key: "cugzd5"
            }
        ],
        [
            "path",
            {
                d: "M16 10h2",
                key: "8sgtl7"
            }
        ],
        [
            "path",
            {
                d: "M16 14h2",
                key: "epxaof"
            }
        ],
        [
            "circle",
            {
                cx: "9",
                cy: "12",
                r: "3",
                key: "u3jwor"
            }
        ],
        [
            "rect",
            {
                x: "2",
                y: "5",
                width: "20",
                height: "14",
                rx: "2",
                key: "qneu4z"
            }
        ]
    ]
};
$7cb92f499384d208$export$a2387ed3b5d536eb.node;
const $7cb92f499384d208$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($7cb92f499384d208$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5ffe798f65d504e7$export$a2387ed3b5d536eb = {
    name: "pill",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z",
                key: "wa1lgi"
            }
        ],
        [
            "path",
            {
                d: "m8.5 8.5 7 7",
                key: "rvfmvr"
            }
        ]
    ]
};
$5ffe798f65d504e7$export$a2387ed3b5d536eb.node;
const $5ffe798f65d504e7$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($5ffe798f65d504e7$export$a2387ed3b5d536eb);








var $acw62 = parcelRequire("acw62");





// One collapsible block of a patient record — the شرح حال sections on the
// record's history tab, and the read-only rail inside a visit (core.md §7.4,
// §7.5).
//
// ── The open/closed state is REMEMBERED, per section, per browser ────────
//
// A record has eight or nine of these and a student reads two of them. Without
// persistence every navigation back into the record re-collapses (or re-opens)
// everything, and the student re-performs the same four clicks each time. The
// state lives in ONE localStorage object (`record_sections_v1`) keyed by
// section id rather than one key per section, so clearing it is one delete and
// a section added later simply has no entry yet — which is why `defaultOpen`
// still exists.
//
// Storage is wrapped in try/catch by src/lib/drafts.js and the component
// renders correctly with nothing stored: a private window must not be a broken
// record.
//
// ── `locked` is for the allergy alert and nothing else ───────────────────
//
// «هشدار حساسیت» renders first and cannot be collapsed (core.md §7.4/§7.5). A
// safety notice that a student can fold away is one they fold away once and
// never see again — the same reasoning that makes `AiDisclaimer`
// non-dismissable.
const $67f84dfba78b42fa$var$readOpenMap = ()=>(0, $7cdea07122bc6887$export$6a368473377ea45c)((0, $7cdea07122bc6887$export$ca82dfc30f88f41c), {
        kind: 'local',
        fallback: {}
    }) || {};
function $67f84dfba78b42fa$export$9f28b1ecec675f5b(id, defaultOpen = true) {
    const stored = $67f84dfba78b42fa$var$readOpenMap()[id];
    return typeof stored === 'boolean' ? stored : defaultOpen;
}
function $67f84dfba78b42fa$export$2e2bcd8739ae039({ id: id, title: title, icon: Icon, count: count, action: action, locked: locked = false, danger: danger = false, defaultOpen: defaultOpen = true, children: children, 'data-testid': testId }) {
    const { formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>locked ? true : $67f84dfba78b42fa$export$9f28b1ecec675f5b(id, defaultOpen));
    const bodyId = `record-section-${id}`;
    const toggle = ()=>{
        if (locked) return;
        setOpen((prev)=>{
            const next = !prev;
            (0, $7cdea07122bc6887$export$476f628a921f7411)((0, $7cdea07122bc6887$export$ca82dfc30f88f41c), {
                ...$67f84dfba78b42fa$var$readOpenMap(),
                [id]: next
            }, {
                kind: 'local'
            });
            return next;
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        "data-testid": testId || `record-section-${id}`,
        style: {
            padding: 0,
            overflow: 'hidden',
            ...danger ? {
                borderColor: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
                background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).bg
            } : null
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '10px 12px'
                },
                children: [
                    locked ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        style: $67f84dfba78b42fa$var$HEAD_STYLE(danger),
                        children: [
                            Icon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                size: 16,
                                color: danger ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                                "aria-hidden": true
                            }),
                            title
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: toggle,
                        "aria-expanded": open,
                        "aria-controls": bodyId,
                        style: {
                            ...$67f84dfba78b42fa$var$HEAD_STYLE(danger),
                            background: 'none',
                            border: 0,
                            padding: 0,
                            cursor: 'pointer',
                            font: 'inherit'
                        },
                        "data-testid": `record-section-toggle-${id}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4be5d9d5a360aa$export$2e2bcd8739ae039), {
                                size: 15,
                                "aria-hidden": true,
                                style: {
                                    transition: 'transform .15s',
                                    transform: open ? 'none' : 'rotate(-90deg)',
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                                }
                            }),
                            Icon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                size: 16,
                                color: danger ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                                "aria-hidden": true
                            }),
                            title
                        ]
                    }),
                    count != null && count !== '' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 11,
                            fontWeight: 700,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                        },
                        children: typeof count === 'number' ? formatNumber(count) : count
                    }),
                    action && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            marginInlineStart: 'auto'
                        },
                        children: action
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                id: bodyId,
                style: {
                    padding: '0 12px 12px'
                },
                children: children
            })
        ]
    });
}
const $67f84dfba78b42fa$var$HEAD_STYLE = (danger)=>({
        display: 'inline-flex',
        alignItems: 'center',
        gap: 7,
        fontSize: 13.5,
        fontWeight: 800,
        color: danger ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
        textAlign: 'start'
    });
function $67f84dfba78b42fa$export$28a2392dc2b2dd58({ onClick: onClick, testId: testId }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        onClick: onClick,
        "data-testid": testId,
        children: t('common.actions.viewAll')
    });
}



parcelRequire("acw62");





function $62b7b2700449d456$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, children: children, width: width = 420, 'data-testid': testId = 'record-list-sheet' }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    // Registers the closer with the global Esc binding while the sheet is up.
    // The kit's BottomSheet closes itself on Escape too; registering anyway is
    // what makes «Esc closes any sheet» true for the drawer half as well.
    (0, $0277e73c10ea225a$export$b26f18012588c702)(open, onClose);
    if (isMobile) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        title: title,
        closeLabel: t('common.actions.close'),
        "data-testid": testId,
        children: children
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49383ac93d397699$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        width: width,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49383ac93d397699$export$bb68d554ded258ea), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8
                    },
                    "data-testid": testId,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            style: {
                                margin: 0,
                                fontSize: 15,
                                fontWeight: 800,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                            },
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                            variant: "ghost",
                            size: 36,
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b6a18bc128c0629$export$2e2bcd8739ae039), {
                                size: 16,
                                color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                                "aria-hidden": true
                            }),
                            label: t('common.actions.close'),
                            onClick: onClose,
                            style: {
                                marginInlineStart: 'auto'
                            },
                            "data-testid": `${testId}-close`
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49383ac93d397699$export$4ed8420cdfcb2b8f), {
                children: children
            })
        ]
    });
}



// خلاصه — the record at a glance. core.md §7.4.
//
// Everything here except «مشخصات» is DERIVED BY THE BFF (core.md §6) and never
// recomputed in the browser: active problems are de-duplicated across every
// visit, current medications fold the latest visit's prescription together with
// the `medications` history section, pending orders span visits. A client that
// derived them itself would disagree with the prompt the assistant is reading,
// which is the one disagreement a teaching app cannot afford.
//
// The blocks are `RecordSection`s, so a student who never reads «دستورهای در
// انتظار» collapses it once and it stays collapsed. «هشدار حساسیت» is the
// exception: it is locked open and rendered first, whenever there is one.
const $7c1e00f956ca1a50$var$LIST_HEAD = 3;
const $7c1e00f956ca1a50$var$Line = ({ label: label, value: value })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const empty = value == null || value === '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            gap: 10,
            padding: '5px 0',
            fontSize: 12.5
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                    minWidth: 96
                },
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    color: empty ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                    overflowWrap: 'anywhere'
                },
                children: empty ? t('common.labels.none') : value
            })
        ]
    });
};
const $7c1e00f956ca1a50$var$Row = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 7,
            flexWrap: 'wrap',
            padding: '7px 0',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        },
        children: children
    });
const $7c1e00f956ca1a50$var$Nothing = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        style: {
            margin: '6px 0',
            fontSize: 12.5,
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
        },
        children: children
    });
function $7c1e00f956ca1a50$export$2e2bcd8739ae039({ caseRow: caseRow, entries: entries, activeProblems: activeProblems, currentMedications: currentMedications, pendingOrders: pendingOrders, encounters: encounters, threads: threads, onOpenVisit: onOpenVisit, onOpenThread: onOpenThread }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [sheet, setSheet] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // 'problems' | 'meds' | 'orders' | null
    const allergies = (0, $6ea44a98f4200fa8$export$8a72e3ba861c222a)(entries);
    const last = (0, $6ea44a98f4200fa8$export$fcd067ef9afe7672)(encounters);
    const chats = (0, $6ea44a98f4200fa8$export$69e1e330d33bcd11)(threads);
    const problemRow = (p, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($7c1e00f956ca1a50$var$Row, {
            testId: "overview-problem",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        fontWeight: 700
                    },
                    children: p.title
                }),
                p.icdCode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    dir: "ltr",
                    style: {
                        fontSize: 11,
                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                    },
                    children: p.icdCode
                }),
                p.kind && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: "outline",
                    children: t((0, $b9b56989c1caf471$export$365e98b66e57b8f7)(p.kind))
                }),
                p.encounterSeq != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        marginInlineStart: 'auto',
                        fontSize: 11,
                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                    },
                    children: t('record.overview.fromVisit', {
                        n: formatNumber(p.encounterSeq)
                    })
                })
            ]
        }, `${p.title}-${i}`);
    const medRow = (m, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($7c1e00f956ca1a50$var$Row, {
            testId: "overview-med",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        fontWeight: 700
                    },
                    children: m.name
                }),
                m.detail && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        fontSize: 12,
                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                    },
                    children: m.detail
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        marginInlineStart: 'auto',
                        fontSize: 11,
                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                    },
                    children: m.encounterSeq != null ? t('record.overview.fromVisit', {
                        n: formatNumber(m.encounterSeq)
                    }) : t('record.overview.fromHistory')
                })
            ]
        }, `${m.name}-${i}`);
    const orderRow = (o)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($7c1e00f956ca1a50$var$Row, {
            testId: "overview-order",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        fontWeight: 700
                    },
                    children: o.title
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: "outline",
                    children: t((0, $b9b56989c1caf471$export$e98960cf8df727b5)(o.orderType))
                }),
                o.urgency && o.urgency !== 'routine' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: "warning",
                    children: t((0, $b9b56989c1caf471$export$2c1f0bb0dcbb3932)(o.urgency))
                })
            ]
        }, o.id);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        },
        "data-testid": "record-overview",
        children: [
            allergies.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67f84dfba78b42fa$export$2e2bcd8739ae039), {
                id: "allergies",
                title: t('record.overview.allergies'),
                icon: (0, $f66de94054a4f331$export$2e2bcd8739ae039),
                locked: true,
                danger: true,
                count: allergies.length,
                "data-testid": "record-allergies",
                children: allergies.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        style: {
                            margin: '4px 0',
                            fontSize: 13,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                            whiteSpace: 'pre-wrap'
                        },
                        children: [
                            entry.label ? `${entry.label}: ` : '',
                            entry.body
                        ]
                    }, entry.id))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $67f84dfba78b42fa$export$2e2bcd8739ae039), {
                id: "details",
                title: t('record.overview.details'),
                icon: (0, $7cb92f499384d208$export$2e2bcd8739ae039),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c1e00f956ca1a50$var$Line, {
                        label: t('caseForm.fields.title'),
                        value: caseRow?.title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c1e00f956ca1a50$var$Line, {
                        label: t('caseForm.fields.displayName'),
                        value: caseRow?.displayName
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c1e00f956ca1a50$var$Line, {
                        label: t('practice.caseRef.label'),
                        value: caseRow?.caseRef
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c1e00f956ca1a50$var$Line, {
                        label: t('caseForm.fields.ageYears'),
                        value: (0, $0d2396cd0d075e45$export$4c461c63ce38f53)(caseRow, t)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c1e00f956ca1a50$var$Line, {
                        label: t('caseForm.fields.sex'),
                        value: caseRow?.sex ? t(`common.gender.${caseRow.sex}`) : ''
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c1e00f956ca1a50$var$Line, {
                        label: t('caseForm.fields.bloodType'),
                        value: caseRow?.bloodType
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c1e00f956ca1a50$var$Line, {
                        label: t('caseForm.fields.weightKg'),
                        value: caseRow?.weightKg ? `${formatNumber(caseRow.weightKg)} ${t('common.units.kg')}` : ''
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c1e00f956ca1a50$var$Line, {
                        label: t('caseForm.fields.heightCm'),
                        value: caseRow?.heightCm ? `${formatNumber(caseRow.heightCm)} ${t('common.units.cm')}` : ''
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c1e00f956ca1a50$var$Line, {
                        label: t('caseForm.fields.chiefComplaint'),
                        value: caseRow?.chiefComplaint
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c1e00f956ca1a50$var$Line, {
                        label: t('caseForm.fields.note'),
                        value: caseRow?.note
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67f84dfba78b42fa$export$2e2bcd8739ae039), {
                id: "problems",
                title: t('record.overview.problems'),
                icon: (0, $3f35c50d66e81764$export$2e2bcd8739ae039),
                count: activeProblems.length,
                action: activeProblems.length > $7c1e00f956ca1a50$var$LIST_HEAD ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67f84dfba78b42fa$export$28a2392dc2b2dd58), {
                    onClick: ()=>setSheet('problems'),
                    testId: "problems-view-all"
                }) : null,
                children: activeProblems.length ? activeProblems.slice(0, $7c1e00f956ca1a50$var$LIST_HEAD).map(problemRow) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c1e00f956ca1a50$var$Nothing, {
                    children: t('record.overview.noProblems')
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67f84dfba78b42fa$export$2e2bcd8739ae039), {
                id: "meds",
                title: t('record.overview.meds'),
                icon: (0, $5ffe798f65d504e7$export$2e2bcd8739ae039),
                count: currentMedications.length,
                action: currentMedications.length > $7c1e00f956ca1a50$var$LIST_HEAD ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67f84dfba78b42fa$export$28a2392dc2b2dd58), {
                    onClick: ()=>setSheet('meds'),
                    testId: "meds-view-all"
                }) : null,
                children: currentMedications.length ? currentMedications.slice(0, $7c1e00f956ca1a50$var$LIST_HEAD).map(medRow) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c1e00f956ca1a50$var$Nothing, {
                    children: t('record.overview.noMeds')
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67f84dfba78b42fa$export$2e2bcd8739ae039), {
                id: "pendingOrders",
                title: t('record.overview.pendingOrders'),
                icon: (0, $241691b67a43640c$export$2e2bcd8739ae039),
                count: pendingOrders.length,
                action: pendingOrders.length > $7c1e00f956ca1a50$var$LIST_HEAD ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67f84dfba78b42fa$export$28a2392dc2b2dd58), {
                    onClick: ()=>setSheet('orders'),
                    testId: "orders-view-all"
                }) : null,
                children: pendingOrders.length ? pendingOrders.slice(0, $7c1e00f956ca1a50$var$LIST_HEAD).map(orderRow) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c1e00f956ca1a50$var$Nothing, {
                    children: t('record.overview.noOrders')
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67f84dfba78b42fa$export$2e2bcd8739ae039), {
                id: "lastVisit",
                title: t('record.overview.lastVisit'),
                icon: (0, $02839c5704f38745$export$2e2bcd8739ae039),
                children: last ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                    style: {
                        padding: 12
                    },
                    "data-testid": "overview-last-visit",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8,
                                flexWrap: 'wrap'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontWeight: 800,
                                        fontSize: 13.5
                                    },
                                    children: t('visit.number', {
                                        n: formatNumber(last.seq)
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    variant: last.status === 'open' ? 'warning' : 'outline',
                                    children: t((0, $b9b56989c1caf471$export$c5cf6d2182208b38)(last.status))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: 11.5,
                                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                                    },
                                    children: formatDate(last.startedAtMs, 'numeric')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    size: "sm",
                                    variant: "outline",
                                    style: {
                                        marginInlineStart: 'auto'
                                    },
                                    onClick: ()=>onOpenVisit?.(last),
                                    "data-testid": "overview-open-visit",
                                    children: t('record.overview.openVisit')
                                })
                            ]
                        }),
                        last.reason && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                margin: '8px 0 0',
                                fontSize: 12.5,
                                color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                            },
                            children: last.reason
                        }),
                        (0, $6ea44a98f4200fa8$export$c7ae287039599931)(last.summary) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                margin: '6px 0 0',
                                fontSize: 13,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                            },
                            "data-testid": "overview-last-visit-summary",
                            children: (0, $6ea44a98f4200fa8$export$c7ae287039599931)(last.summary)
                        }),
                        (0, $6ea44a98f4200fa8$export$c7ae287039599931)(last.note?.a) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                margin: '4px 0 0',
                                fontSize: 13,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                            },
                            "data-testid": "overview-last-visit-assessment",
                            children: (0, $6ea44a98f4200fa8$export$c7ae287039599931)(last.note?.a)
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c1e00f956ca1a50$var$Nothing, {
                    children: t('record.overview.noVisits')
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67f84dfba78b42fa$export$2e2bcd8739ae039), {
                id: "recentChats",
                title: t('record.overview.recentChats'),
                icon: (0, $8c7fae0571c9b8a8$export$2e2bcd8739ae039),
                count: chats.length,
                children: chats.length ? chats.map((thread)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($7c1e00f956ca1a50$var$Row, {
                        testId: "overview-thread",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onOpenThread?.(thread),
                                style: {
                                    background: 'none',
                                    border: 0,
                                    padding: 0,
                                    font: 'inherit',
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                                    cursor: 'pointer',
                                    textAlign: 'start'
                                },
                                children: thread.title || t('record.overview.recentChats')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    marginInlineStart: 'auto',
                                    fontSize: 11,
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                                },
                                children: formatNumber(Number(thread.messageCount || 0))
                            })
                        ]
                    }, thread.id)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7c1e00f956ca1a50$var$Nothing, {
                    children: t('record.overview.noChats')
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62b7b2700449d456$export$2e2bcd8739ae039), {
                open: sheet === 'problems',
                onClose: ()=>setSheet(null),
                title: t('record.overview.problems'),
                children: activeProblems.map(problemRow)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62b7b2700449d456$export$2e2bcd8739ae039), {
                open: sheet === 'meds',
                onClose: ()=>setSheet(null),
                title: t('record.overview.meds'),
                children: currentMedications.map(medRow)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62b7b2700449d456$export$2e2bcd8739ae039), {
                open: sheet === 'orders',
                onClose: ()=>setSheet(null),
                title: t('record.overview.pendingOrders'),
                children: pendingOrders.map(orderRow)
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f9f4b1e9a7f47143$export$a2387ed3b5d536eb = {
    name: "mic",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 19v3",
                key: "npa21l"
            }
        ],
        [
            "path",
            {
                d: "M19 10v2a7 7 0 0 1-14 0v-2",
                key: "1vc78b"
            }
        ],
        [
            "rect",
            {
                x: "9",
                y: "2",
                width: "6",
                height: "13",
                rx: "3",
                key: "s6n7sd"
            }
        ]
    ]
};
$f9f4b1e9a7f47143$export$a2387ed3b5d536eb.node;
const $f9f4b1e9a7f47143$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($f9f4b1e9a7f47143$export$a2387ed3b5d536eb);




// شرح حال — the seven typed sections, and the two that carry structured rows.
//
// ── The set is CLOSED, and closed in a way that fails silently if broken ───
//
// `section` ∈ { chief_complaint, hpi, pmh, medications, allergies, vitals,
// labs }. The BFF rejects an eighth value with INVALID_INPUT — but the reason
// the set is closed is worse than a rejection: the BFF's prompt builder emits
// exactly these seven, in this order, when it folds the case into the teaching
// brief. A section it does not know has nowhere to go in that brief, so it
// would be QUIETLY DROPPED — the student's typing would never reach the model,
// and the answer would look merely wrong rather than broken
// (student-app/docs/CORE.md §10, rule 6).
//
// So this array is not a UI convenience. It is the client's copy of a contract,
// and ORDER IS PART OF IT: the editor presents the sections in the order a
// history is taken, which is the order the prompt reads them in.
//
// Pure and React-free — `labelKey` rather than `label`, because this list is
// module-level and cannot call a hook. tests/history.test.js calls it directly.
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $340d4e1a05281a91$export$a2387ed3b5d536eb = {
    name: "activity",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
                key: "169zse"
            }
        ]
    ]
};
$340d4e1a05281a91$export$a2387ed3b5d536eb.node;
const $340d4e1a05281a91$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($340d4e1a05281a91$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $53cde9011dd49799$export$a2387ed3b5d536eb = {
    name: "rotate-ccw-clock",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
                key: "1357e3"
            }
        ],
        [
            "path",
            {
                d: "M3 3v5h5",
                key: "1xhq8a"
            }
        ],
        [
            "path",
            {
                d: "M12 7v5l4 2",
                key: "1fdv2h"
            }
        ]
    ],
    aliases: [
        "history"
    ]
};
$53cde9011dd49799$export$a2387ed3b5d536eb.node;
const $53cde9011dd49799$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($53cde9011dd49799$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $afae024adf4ac52e$export$a2387ed3b5d536eb = {
    name: "message-square-warning",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
                key: "18887p"
            }
        ],
        [
            "path",
            {
                d: "M12 15h.01",
                key: "q59x07"
            }
        ],
        [
            "path",
            {
                d: "M12 7v4",
                key: "xawao1"
            }
        ]
    ]
};
$afae024adf4ac52e$export$a2387ed3b5d536eb.node;
const $afae024adf4ac52e$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($afae024adf4ac52e$export$a2387ed3b5d536eb);


const $5250c7903fe7c8ca$export$1db3bd07a84c7494 = [
    {
        id: 'chief_complaint',
        labelKey: 'history.sections.chiefComplaint',
        Icon: (0, $afae024adf4ac52e$export$2e2bcd8739ae039)
    },
    {
        id: 'hpi',
        labelKey: 'history.sections.hpi',
        Icon: (0, $df9771111904a5d5$export$2e2bcd8739ae039)
    },
    {
        id: 'pmh',
        labelKey: 'history.sections.pmh',
        Icon: (0, $53cde9011dd49799$export$2e2bcd8739ae039)
    },
    {
        id: 'medications',
        labelKey: 'history.sections.medications',
        Icon: (0, $5ffe798f65d504e7$export$2e2bcd8739ae039)
    },
    {
        id: 'allergies',
        labelKey: 'history.sections.allergies',
        Icon: (0, $f66de94054a4f331$export$2e2bcd8739ae039)
    },
    {
        id: 'vitals',
        labelKey: 'history.sections.vitals',
        Icon: (0, $340d4e1a05281a91$export$2e2bcd8739ae039)
    },
    {
        id: 'labs',
        labelKey: 'history.sections.labs',
        Icon: (0, $241691b67a43640c$export$2e2bcd8739ae039)
    }
];
const $5250c7903fe7c8ca$export$d0fe0b0df5d61021 = $5250c7903fe7c8ca$export$1db3bd07a84c7494.map((s)=>s.id);
const $5250c7903fe7c8ca$export$b22bf82651bf4640 = 'chief_complaint';
const $5250c7903fe7c8ca$export$fc1acc9190910d14 = (id)=>$5250c7903fe7c8ca$export$d0fe0b0df5d61021.includes(id);
const $5250c7903fe7c8ca$export$495a9bd214bb02ef = (id)=>$5250c7903fe7c8ca$export$fc1acc9190910d14(id) ? id : $5250c7903fe7c8ca$export$b22bf82651bf4640;
const $5250c7903fe7c8ca$export$66c85029eba22f85 = [
    'vitals',
    'labs'
];
const $5250c7903fe7c8ca$export$24e9ce2dbe7eda5 = (section)=>$5250c7903fe7c8ca$export$66c85029eba22f85.includes(section);
const $5250c7903fe7c8ca$export$8d87891ac98758d3 = [
    {
        key: 'bp',
        labelKey: 'history.vitals.bp',
        unitKey: null,
        numeric: false,
        placeholder: '120/80'
    },
    {
        key: 'hr',
        labelKey: 'history.vitals.hr',
        unitKey: 'history.units.bpm',
        numeric: true
    },
    {
        key: 'rr',
        labelKey: 'history.vitals.rr',
        unitKey: 'history.units.perMin',
        numeric: true
    },
    {
        key: 'temp',
        labelKey: 'history.vitals.temp',
        unitKey: 'history.units.celsius',
        numeric: true
    },
    {
        key: 'spo2',
        labelKey: 'history.vitals.spo2',
        unitKey: 'history.units.percent',
        numeric: true
    }
];
const $5250c7903fe7c8ca$export$ccc2c13eb48542b9 = ()=>Object.fromEntries($5250c7903fe7c8ca$export$8d87891ac98758d3.map((f)=>[
            f.key,
            ''
        ]));
function $5250c7903fe7c8ca$export$4a5fdd5825e5463b(structured) {
    const src = structured && typeof structured === 'object' && !Array.isArray(structured) ? structured : {};
    return Object.fromEntries($5250c7903fe7c8ca$export$8d87891ac98758d3.map((f)=>[
            f.key,
            src[f.key] == null ? '' : String(src[f.key])
        ]));
}
function $5250c7903fe7c8ca$export$c2fffed5a894aedb(form) {
    const out = {};
    for (const f of $5250c7903fe7c8ca$export$8d87891ac98758d3){
        const raw = String(form?.[f.key] ?? '').trim();
        if (!raw) continue;
        if (!f.numeric) {
            out[f.key] = raw;
            continue;
        }
        const n = Number(raw);
        // A value that will not parse is kept as TEXT rather than dropped. It is
        // the student's reading; refusing to store «۳۷/۲» silently would lose it,
        // and the store validates only that the payload is JSON.
        out[f.key] = Number.isFinite(n) ? n : raw;
    }
    return Object.keys(out).length ? out : null;
}
const $5250c7903fe7c8ca$export$4860fae86ef75d7d = [
    'name',
    'value',
    'unit',
    'ref'
];
const $5250c7903fe7c8ca$export$906a09ef10944189 = ()=>({
        name: '',
        value: '',
        unit: '',
        ref: ''
    });
function $5250c7903fe7c8ca$export$a63b70a2c2f4f036(structured) {
    const rows = Array.isArray(structured) ? structured : [];
    const mapped = rows.map((r)=>Object.fromEntries($5250c7903fe7c8ca$export$4860fae86ef75d7d.map((k)=>[
                k,
                r?.[k] == null ? '' : String(r[k])
            ])));
    return mapped.length ? mapped : [
        $5250c7903fe7c8ca$export$906a09ef10944189()
    ];
}
function $5250c7903fe7c8ca$export$77f3ef0cbf6080d8(rows) {
    const out = (Array.isArray(rows) ? rows : []).map((r)=>Object.fromEntries($5250c7903fe7c8ca$export$4860fae86ef75d7d.map((k)=>[
                k,
                String(r?.[k] ?? '').trim()
            ]))).filter((r)=>r.name)// Blank optional fields are dropped, for the same reason vitals drops them:
    // this JSON is interpolated into a prompt and `"unit": ""` is noise the
    // model has to read.
    .map((r)=>Object.fromEntries(Object.entries(r).filter(([, v])=>v !== '')));
    return out.length ? out : null;
}
function $5250c7903fe7c8ca$export$cf8eee2145edba16(entries) {
    const out = Object.fromEntries($5250c7903fe7c8ca$export$d0fe0b0df5d61021.map((id)=>[
            id,
            []
        ]));
    for (const entry of Array.isArray(entries) ? entries : [])if (out[entry?.section]) out[entry.section].push(entry);
    for (const id of $5250c7903fe7c8ca$export$d0fe0b0df5d61021)out[id].sort((a, b)=>{
        const so = (a.sortOrder || 0) - (b.sortOrder || 0);
        if (so !== 0) return so;
        return Number(a.createdAtMs || 0) - Number(b.createdAtMs || 0);
    });
    return out;
}
function $5250c7903fe7c8ca$export$b4df083edacffc8f(entries) {
    const grouped = $5250c7903fe7c8ca$export$cf8eee2145edba16(entries);
    return Object.fromEntries($5250c7903fe7c8ca$export$d0fe0b0df5d61021.map((id)=>[
            id,
            grouped[id].length
        ]));
}
const $5250c7903fe7c8ca$export$943fbf5772aef446 = [
    'manual',
    'voice',
    'ai'
];
const $5250c7903fe7c8ca$export$b055de0e665cb20c = 'manual';
function $5250c7903fe7c8ca$export$cbaeb5a00d9872f2(entriesInSection) {
    const rows = Array.isArray(entriesInSection) ? entriesInSection : [];
    if (!rows.length) return 0;
    return Math.max(...rows.map((e)=>Number(e.sortOrder) || 0)) + 1;
}
function $5250c7903fe7c8ca$export$c2d5eabe178b7bb8(entry) {
    if (String(entry?.body ?? '').trim()) return true;
    const s = entry?.structured;
    if (Array.isArray(s)) return s.length > 0;
    if (s && typeof s === 'object') return Object.keys(s).length > 0;
    return false;
}






parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1f9f3418dec68a42$export$a2387ed3b5d536eb = {
    name: "pencil",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
                key: "1a8usu"
            }
        ],
        [
            "path",
            {
                d: "m15 5 4 4",
                key: "1mk7zo"
            }
        ]
    ]
};
$1f9f3418dec68a42$export$a2387ed3b5d536eb.node;
const $1f9f3418dec68a42$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($1f9f3418dec68a42$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1882f1d059ea7fa7$export$a2387ed3b5d536eb = {
    name: "trash",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10 11v6",
                key: "nco0om"
            }
        ],
        [
            "path",
            {
                d: "M14 11v6",
                key: "outv1u"
            }
        ],
        [
            "path",
            {
                d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6",
                key: "miytrc"
            }
        ],
        [
            "path",
            {
                d: "M3 6h18",
                key: "d0wm0j"
            }
        ],
        [
            "path",
            {
                d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
                key: "e791ji"
            }
        ]
    ],
    aliases: [
        "trash-2"
    ]
};
$1882f1d059ea7fa7$export$a2387ed3b5d536eb.node;
const $1882f1d059ea7fa7$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($1882f1d059ea7fa7$export$a2387ed3b5d536eb);





// شرح حال — the case record's shared contract: the section whitelist, the entry
// form, and the two structured payload shapes.
//
// Both surfaces import from here. A record whose desktop tabs and mobile strip
// each declared their own section list is one where a section is reachable by tap
// on one device and by URL on neither — a defect that has already shipped once in
// this monorepo.

var $acw62 = parcelRequire("acw62");



const $9206cc4a29ffd112$export$5ff47a1a5df62032 = (0, $5250c7903fe7c8ca$export$d0fe0b0df5d61021);
function $9206cc4a29ffd112$export$7a3bba504477e179(entries, t) {
    const grouped = (0, $5250c7903fe7c8ca$export$cf8eee2145edba16)(entries);
    return (0, $5250c7903fe7c8ca$export$1db3bd07a84c7494).map(({ id: id, labelKey: labelKey, Icon: Icon })=>({
            key: id,
            label: t(labelKey),
            Icon: Icon,
            count: grouped[id].length
        }));
}
function $9206cc4a29ffd112$export$12a0404daa78b214(section) {
    return {
        section: section,
        label: '',
        body: '',
        // ISO 'YYYY-MM-DD', which is the value shape every kit date component takes.
        recordedAt: '',
        vitals: (0, $5250c7903fe7c8ca$export$ccc2c13eb48542b9)(),
        labs: [
            (0, $5250c7903fe7c8ca$export$906a09ef10944189)()
        ]
    };
}
function $9206cc4a29ffd112$export$d34a5caa5edaf5f9(entry) {
    const section = entry?.section || (0, $5250c7903fe7c8ca$export$b22bf82651bf4640);
    return {
        section: section,
        label: entry?.label || '',
        body: entry?.body || '',
        // The wire carries epoch milliseconds as a STRING; the editor edits a day.
        recordedAt: entry?.recordedAtMs ? (0, $6e94fc1378f3a785$export$29d3212020cf53a5)(entry.recordedAtMs) : '',
        vitals: section === 'vitals' ? (0, $5250c7903fe7c8ca$export$4a5fdd5825e5463b)(entry?.structured) : (0, $5250c7903fe7c8ca$export$ccc2c13eb48542b9)(),
        labs: section === 'labs' ? (0, $5250c7903fe7c8ca$export$a63b70a2c2f4f036)(entry?.structured) : [
            (0, $5250c7903fe7c8ca$export$906a09ef10944189)()
        ]
    };
}
function $9206cc4a29ffd112$export$795dd2b4234cb97e(form) {
    if (form?.section === 'vitals') return (0, $5250c7903fe7c8ca$export$c2fffed5a894aedb)(form.vitals);
    if (form?.section === 'labs') return (0, $5250c7903fe7c8ca$export$77f3ef0cbf6080d8)(form.labs);
    return null;
}
function $9206cc4a29ffd112$export$3587f73681c3cddb(form, { sortOrder: sortOrder = 0, source: source = (0, $5250c7903fe7c8ca$export$b055de0e665cb20c) } = {}) {
    const ms = (0, $6e94fc1378f3a785$export$3537fc298e9336da)(form?.recordedAt);
    return {
        section: form.section,
        label: String(form?.label ?? '').trim() || null,
        body: String(form?.body ?? '').trim(),
        structured: $9206cc4a29ffd112$export$795dd2b4234cb97e(form),
        source: source,
        sortOrder: sortOrder,
        recordedAtMs: ms == null ? null : String(ms)
    };
}
function $9206cc4a29ffd112$export$ce6da7897bcdf424(form) {
    const ms = (0, $6e94fc1378f3a785$export$3537fc298e9336da)(form?.recordedAt);
    return {
        label: String(form?.label ?? '').trim(),
        body: String(form?.body ?? '').trim(),
        structured: $9206cc4a29ffd112$export$795dd2b4234cb97e(form),
        recordedAtMs: ms == null ? '' : String(ms)
    };
}
const $9206cc4a29ffd112$export$1e243dc70ce3ad78 = (source)=>`history.entry.source.${[
        'manual',
        'voice',
        'ai'
    ].includes(source) ? source : (0, $5250c7903fe7c8ca$export$b055de0e665cb20c)}`;
function $9206cc4a29ffd112$export$5c4f5b064d44bfa9(structured) {
    const src = structured && typeof structured === 'object' && !Array.isArray(structured) ? structured : {};
    return Object.entries(src).filter(([, v])=>v !== '' && v != null).map(([key, value])=>({
            key: key,
            value: String(value)
        }));
}
function $9206cc4a29ffd112$export$c855bb49e3c0c517(structured) {
    return Array.isArray(structured) ? structured : [];
}
function $9206cc4a29ffd112$export$6892f917acf7f49({ entries: entries, addHistory: addHistory, updateEntry: updateEntry }) {
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [editing, setEditing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // the stored entry, or null for a new one
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>$9206cc4a29ffd112$export$12a0404daa78b214((0, $5250c7903fe7c8ca$export$b22bf82651bf4640)));
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [problem, setProblem] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const openNew = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((section)=>{
        setEditing(null);
        setForm($9206cc4a29ffd112$export$12a0404daa78b214(section));
        setProblem('');
        setOpen(true);
    }, []);
    const openExisting = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((entry)=>{
        setEditing(entry);
        setForm($9206cc4a29ffd112$export$d34a5caa5edaf5f9(entry));
        setProblem('');
        setOpen(true);
    }, []);
    const close = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (saving) return;
        setOpen(false);
    }, [
        saving
    ]);
    const change = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((patch)=>{
        setForm((prev)=>({
                ...prev,
                ...patch
            }));
        setProblem('');
    }, []);
    /**
   * Save, or report what is missing.
   *
   * The BFF stores an entry with an empty body only when `structured` carries
   * something, so the same rule is checked here — otherwise the student writes a
   * row that renders as a blank card and can then only be deleted.
   *
   * @returns true when it was saved, so the caller can close and toast.
   */ const save = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const candidate = {
            body: form.body,
            structured: $9206cc4a29ffd112$export$795dd2b4234cb97e(form)
        };
        if (!(0, $5250c7903fe7c8ca$export$c2d5eabe178b7bb8)(candidate)) {
            setProblem('history.entry.needsContent');
            return false;
        }
        setSaving(true);
        try {
            if (editing) await updateEntry(editing.id, $9206cc4a29ffd112$export$ce6da7897bcdf424(form));
            else {
                const section = form.section;
                const sortOrder = (0, $5250c7903fe7c8ca$export$cbaeb5a00d9872f2)((0, $5250c7903fe7c8ca$export$cf8eee2145edba16)(entries)[section]);
                // Plural because the mutation is: `addCaseHistory` is all-or-nothing and
                // the voice flow submits a whole drafted history through the same call.
                await addHistory([
                    $9206cc4a29ffd112$export$3587f73681c3cddb(form, {
                        sortOrder: sortOrder
                    })
                ]);
            }
            setOpen(false);
            return true;
        } finally{
            setSaving(false);
        }
    }, [
        form,
        editing,
        entries,
        addHistory,
        updateEntry
    ]);
    return {
        open: open,
        editing: editing,
        form: form,
        saving: saving,
        error: problem,
        openNew: openNew,
        openExisting: openExisting,
        close: close,
        change: change,
        save: save
    };
}


// One section of the شرح حال, as it is READ.
//
// Shared by both surfaces: what a section's entries look like is the record, and
// the record does not change shape between a laptop and a phone — only the chrome
// around it does. The overlay a student edits in is the surface's own (a Dialog
// on the desktop, a BottomSheet on the phone), which is why this component
// reports intent through `onAdd`/`onEdit`/`onDelete` rather than owning one.
const $ba27f9b334140ce4$var$sectionMeta = (id)=>(0, $5250c7903fe7c8ca$export$1db3bd07a84c7494).find((s)=>s.id === id) || (0, $5250c7903fe7c8ca$export$1db3bd07a84c7494)[0];
const $ba27f9b334140ce4$var$vitalLabelKey = (key)=>(0, $5250c7903fe7c8ca$export$8d87891ac98758d3).find((f)=>f.key === key)?.labelKey || null;
const $ba27f9b334140ce4$var$vitalUnitKey = (key)=>(0, $5250c7903fe7c8ca$export$8d87891ac98758d3).find((f)=>f.key === key)?.unitKey || null;
function $ba27f9b334140ce4$var$VitalsBlock({ structured: structured }) {
    const { t: t, formatDigits: formatDigits } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const pairs = (0, $9206cc4a29ffd112$export$5c4f5b064d44bfa9)(structured);
    if (!pairs.length) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(110px, 1fr))',
            gap: 8,
            marginTop: 10
        },
        children: pairs.map(({ key: key, value: value })=>{
            const labelKey = $ba27f9b334140ce4$var$vitalLabelKey(key);
            const unitKey = $ba27f9b334140ce4$var$vitalUnitKey(key);
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).bg,
                    borderRadius: 10,
                    padding: '8px 10px'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 10.5,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                        },
                        children: labelKey ? t(labelKey) : key
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            fontSize: 14,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                            marginTop: 2
                        },
                        // A reading plus its unit is a digit run: it reads left-to-right
                        // inside either layout, and `isolate` is what stops the adjacent
                        // punctuation being dragged to the wrong end.
                        dir: "ltr",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    unicodeBidi: 'isolate'
                                },
                                children: formatDigits(value)
                            }),
                            unitKey && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    fontSize: 10.5,
                                    fontWeight: 600,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                    marginInlineStart: 4
                                },
                                children: t(unitKey)
                            })
                        ]
                    })
                ]
            }, key);
        })
    });
}
function $ba27f9b334140ce4$var$LabsBlock({ structured: structured }) {
    const { t: t, formatDigits: formatDigits } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const rows = (0, $9206cc4a29ffd112$export$c855bb49e3c0c517)(structured);
    if (!rows.length) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            marginTop: 10,
            overflowX: 'auto'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
            style: {
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: 12.5
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                        children: [
                            'name',
                            'value',
                            'unit',
                            'ref'
                        ].map((key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                style: {
                                    textAlign: 'start',
                                    padding: '6px 8px',
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                    fontWeight: 700,
                                    fontSize: 11,
                                    borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                    whiteSpace: 'nowrap'
                                },
                                children: t(`history.labs.${key}`)
                            }, key))
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                    children: rows.map((row, index)=>// eslint-disable-next-line react/no-array-index-key
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    style: {
                                        padding: '6px 8px',
                                        borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                        fontWeight: 700
                                    },
                                    children: row?.name || t('common.labels.none')
                                }),
                                [
                                    'value',
                                    'unit',
                                    'ref'
                                ].map((key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        style: {
                                            padding: '6px 8px',
                                            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
                                        },
                                        dir: "ltr",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                unicodeBidi: 'isolate'
                                            },
                                            children: row?.[key] ? formatDigits(String(row[key])) : t('common.labels.none')
                                        })
                                    }, key))
                            ]
                        }, `${row?.name || 'row'}-${index}`))
                })
            ]
        })
    });
}
function $ba27f9b334140ce4$export$5e8147168ba5a79({ entry: entry, onEdit: onEdit, onDelete: onDelete, visitSeq: visitSeq = null }) {
    const { t: t, formatDate: formatDate, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        style: {
            padding: 14
        },
        "data-testid": `entry-${entry.id}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            flex: 1,
                            minWidth: 0
                        },
                        children: [
                            entry.label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 800,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                    marginBottom: 4
                                },
                                children: entry.label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13.5,
                                    lineHeight: 2,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                    whiteSpace: 'pre-wrap',
                                    overflowWrap: 'anywhere'
                                },
                                children: entry.body
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 4,
                            flexShrink: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                variant: "ghost",
                                size: 36,
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f9f3418dec68a42$export$2e2bcd8739ae039), {
                                    size: 15
                                }),
                                label: t('common.actions.edit'),
                                onClick: ()=>onEdit?.(entry)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                variant: "ghost",
                                size: 36,
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1882f1d059ea7fa7$export$2e2bcd8739ae039), {
                                    size: 15,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red
                                }),
                                label: t('common.actions.delete'),
                                onClick: ()=>onDelete?.(entry)
                            })
                        ]
                    })
                ]
            }),
            entry.section === 'vitals' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ba27f9b334140ce4$var$VitalsBlock, {
                structured: entry.structured
            }),
            entry.section === 'labs' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ba27f9b334140ce4$var$LabsBlock, {
                structured: entry.structured
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    flexWrap: 'wrap',
                    marginTop: 10,
                    paddingTop: 10,
                    borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    fontSize: 11,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                        variant: entry.source === 'manual' ? 'outline' : 'warning',
                        children: [
                            t('history.entry.sourceLabel'),
                            ": ",
                            t((0, $9206cc4a29ffd112$export$1e243dc70ce3ad78)(entry.source))
                        ]
                    }),
                    visitSeq != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                        variant: "outline",
                        "data-testid": `entry-visit-${entry.id}`,
                        children: t('record.history.visitChip', {
                            n: formatNumber(visitSeq)
                        })
                    }),
                    entry.recordedAtMs && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            t('history.entry.recordedAt'),
                            ": ",
                            formatDate(entry.recordedAtMs, 'numeric')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            marginInlineStart: 'auto'
                        },
                        children: formatDate(entry.createdAtMs, 'numeric')
                    })
                ]
            })
        ]
    });
}
function $ba27f9b334140ce4$export$2e2bcd8739ae039({ section: section, entries: entries, onAdd: onAdd, onEdit: onEdit, onDelete: onDelete }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const meta = $ba27f9b334140ce4$var$sectionMeta(section);
    const rows = (0, $5250c7903fe7c8ca$export$cf8eee2145edba16)(entries)[section] || [];
    const { Icon: Icon } = meta;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        role: "tabpanel",
        "aria-label": t(meta.labelKey),
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                        size: 17,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                        "aria-hidden": true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        style: {
                            margin: 0,
                            fontSize: 15,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                        },
                        children: t(meta.labelKey)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "outline",
                        size: "sm",
                        onClick: ()=>onAdd?.(section),
                        style: {
                            marginInlineStart: 'auto'
                        },
                        "data-testid": "history-add",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83905746e46531b9$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true
                            }),
                            t('history.add')
                        ]
                    })
                ]
            }),
            rows.length ? rows.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ba27f9b334140ce4$export$5e8147168ba5a79, {
                    entry: entry,
                    onEdit: onEdit,
                    onDelete: onDelete
                }, entry.id)) : // An empty section is EMPTY, not broken — the student has simply not
            // written it yet, and the copy says what writing it is for: this is what
            // the assistant reads.
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                        size: 40,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                    }),
                    title: t('history.empty.title'),
                    description: t('history.empty.body'),
                    action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        onClick: ()=>onAdd?.(section),
                        children: t('history.add')
                    })
                })
            })
        ]
    });
}



parcelRequire("acw62");





function $7f1c0185eaf6cd67$export$2e2bcd8739ae039({ values: values, onChange: onChange, disabled: disabled = false, error: error = '' }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const section = values?.section;
    const setField = (key)=>(e)=>onChange?.({
                [key]: e?.target ? e.target.value : e
            });
    const setVital = (key)=>(e)=>onChange?.({
                vitals: {
                    ...values.vitals || {},
                    [key]: e.target.value
                }
            });
    const setLab = (index, key)=>(e)=>{
            const rows = [
                ...values.labs || []
            ];
            rows[index] = {
                ...rows[index],
                [key]: e.target.value
            };
            onChange?.({
                labs: rows
            });
        };
    const addLabRow = ()=>onChange?.({
            labs: [
                ...values.labs || [],
                (0, $5250c7903fe7c8ca$export$906a09ef10944189)()
            ]
        });
    const removeLabRow = (index)=>{
        const rows = (values.labs || []).filter((_, i)=>i !== index);
        // Always leave one row to type into: an editor with no rows offers nothing
        // but an «افزودن سطر» button, which is a step that should not exist.
        onChange?.({
            labs: rows.length ? rows : [
                (0, $5250c7903fe7c8ca$export$906a09ef10944189)()
            ]
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: t('history.entry.label'),
                value: values.label,
                onChange: setField('label'),
                placeholder: t('history.entry.labelPlaceholder'),
                helperText: t('common.labels.optional'),
                disabled: disabled,
                maxLength: 120,
                "data-testid": "entry-label"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                label: t('history.entry.body'),
                value: values.body,
                onChange: setField('body'),
                placeholder: t('history.entry.bodyPlaceholder'),
                rows: 6,
                disabled: disabled,
                error: error,
                maxLength: 8000,
                // ≥1rem, or iOS zooms the page when the field takes focus. The kit's
                // 13.5px default is under that, and `inputStyle` is the split the kit
                // provides for reaching the control rather than the field.
                inputStyle: {
                    fontSize: '1rem'
                },
                "data-testid": "entry-body"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                label: t('history.entry.recordedAt'),
                helperText: t('history.entry.recordedAtHelper'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
                    value: values.recordedAt || '',
                    onChange: (next)=>onChange?.({
                            recordedAt: next || ''
                        }),
                    disabled: disabled
                })
            }),
            (0, $5250c7903fe7c8ca$export$24e9ce2dbe7eda5)(section) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    borderRadius: 12,
                    padding: 14,
                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).bg,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 12
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 800,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                },
                                children: t('history.structured.title')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 11.5,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                    marginTop: 3
                                },
                                children: t('history.structured.helper')
                            })
                        ]
                    }),
                    section === 'vitals' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
                            gap: 12
                        },
                        children: (0, $5250c7903fe7c8ca$export$8d87891ac98758d3).map((f)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                label: f.unitKey ? `${t(f.labelKey)} (${t(f.unitKey)})` : t(f.labelKey),
                                value: values.vitals?.[f.key] ?? '',
                                onChange: setVital(f.key),
                                placeholder: f.placeholder,
                                disabled: disabled,
                                // A reading is a digit run and reads left-to-right in both
                                // layouts. «120/80» typed into an RTL box has its slash
                                // reordered on screen while the value stays correct — so the
                                // student proofreads a string that is not the one being stored.
                                dir: "ltr",
                                inputMode: f.numeric ? 'decimal' : 'text',
                                maxLength: 20,
                                "data-testid": `vital-${f.key}`
                            }, f.key))
                    }),
                    section === 'labs' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 10
                        },
                        children: [
                            (values.labs || []).map((row, index)=>// Keyed by INDEX, deliberately: a lab row has no id until it is
                                // stored, and keying on `name` would remount the field the moment
                                // the student typed the first letter of it, losing focus.
                                // eslint-disable-next-line react/no-array-index-key
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'flex-end',
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                flex: 1,
                                                display: 'grid',
                                                gridTemplateColumns: 'repeat(auto-fit, minmax(110px, 1fr))',
                                                gap: 8,
                                                minWidth: 0
                                            },
                                            children: (0, $5250c7903fe7c8ca$export$4860fae86ef75d7d).map((key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                                    label: t(`history.labs.${key}`),
                                                    value: row?.[key] ?? '',
                                                    onChange: setLab(index, key),
                                                    disabled: disabled,
                                                    // `value` is stored as TEXT, and this is the reason the
                                                    // whole payload is a JSON string rather than a
                                                    // google.protobuf.Struct: Struct's numbers are doubles, so
                                                    // «8.20» comes back 8.2 and «<0.01» cannot be stored at
                                                    // all. A lab value is a printed reading; nothing in this
                                                    // app computes with one.
                                                    dir: "ltr",
                                                    maxLength: 60,
                                                    "data-testid": `lab-${index}-${key}`
                                                }, key))
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                            variant: "ghost",
                                            size: 40,
                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1882f1d059ea7fa7$export$2e2bcd8739ae039), {
                                                size: 16,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red
                                            }),
                                            label: t('history.labs.removeRow'),
                                            onClick: ()=>removeLabRow(index),
                                            disabled: disabled
                                        })
                                    ]
                                }, index)),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: "outline",
                                size: "sm",
                                onClick: addLabRow,
                                disabled: disabled,
                                "data-testid": "lab-add-row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83905746e46531b9$export$2e2bcd8739ae039), {
                                        size: 14,
                                        "aria-hidden": true
                                    }),
                                    t('history.labs.addRow')
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5340d072e86ce769$export$a2387ed3b5d536eb = {
    name: "square",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                key: "afitv7"
            }
        ]
    ]
};
$5340d072e86ce769$export$a2387ed3b5d536eb.node;
const $5340d072e86ce769$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($5340d072e86ce769$export$a2387ed3b5d536eb);




// The پارسه price list, resolved — ONE server-side list instead of the
// hardcoded constants (docs/AI_COST_AND_PARSEH_PRICING_MANAGEMENT_DESIGN.md
// §9.2, phase 3).
//
// Every price this app prints or gates on goes through `costOf(actionId)` /
// `costForKind(kind)` below. The action ids are the ones the app already used
// (`PARSEH_COSTS.ASK`, …) and the kinds are `CaseChatMessage.kind`;
// `SERVICE_KEY_BY_ACTION` is the ONE table that maps actions onto the AI RPC
// names the service prices — change a mapping here, nowhere else.
//
// ── The constants are the fallback and the first paint ──────────────────────
// `constants/pricing.js` is what renders before the list has arrived and what
// renders when it never does (offline, BFF down, the AI service down and the
// BFF serving its own frozen copy). A cost chip therefore NEVER spins and never
// goes blank: it shows the shipped number, then the policy's number the moment
// it is known. `source` says which one is on screen.
//
// ── Fetched once per page load, remembered for the session ──────────────────
// The list is read through the app's own GraphQL client the first time any
// surface asks for it and shared by every component after that (a module-level
// store read through `useSyncExternalStore`). The last answer is also kept in
// sessionStorage so a reload paints the policy price first, not the constant.
// A FAILED read is not remembered: the next surface to mount tries again.

var $acw62 = parcelRequire("acw62");


const $9449204a10cf7050$export$c3ecc18ec062bc34 = Object.freeze({
    ASK: 'AskDoctorQuestion',
    DIFFERENTIAL: 'AskDoctorQuestion',
    SOAP_SUGGEST: 'AskDoctorQuestion',
    ORDER_SUGGEST: 'AskDoctorQuestion',
    INTERACTION: 'CheckDrugInteraction',
    VOICE: 'ParsePatientVoice'
});
const $9449204a10cf7050$export$aa2a9b2355fac90b = Object.freeze({
    chat: 'ASK',
    differential: 'DIFFERENTIAL',
    interaction: 'INTERACTION',
    soap_suggest: 'SOAP_SUGGEST',
    order_suggest: 'ORDER_SUGGEST'
});
const $9449204a10cf7050$export$f5e24740e23fe4a0 = `
  query CreditPrices {
    creditPrices {
      source
      policyId
      parsehToman
      generatedAt
      items { serviceKey unit parseh priceSource }
    }
  }
`;
const $9449204a10cf7050$var$STORAGE_KEY = 'parsina:creditPrices:v1';
const $9449204a10cf7050$var$FALLBACK_STATE = Object.freeze({
    byService: null,
    parsehToman: null,
    policyId: null,
    source: 'fallback',
    loaded: false
});
let $9449204a10cf7050$var$state = $9449204a10cf7050$var$FALLBACK_STATE;
const $9449204a10cf7050$var$listeners = new Set();
let $9449204a10cf7050$var$inflight = null;
let $9449204a10cf7050$var$answered = false; // a SERVICE answer landed this page load — read once
function $9449204a10cf7050$var$emit(next) {
    $9449204a10cf7050$var$state = next;
    for (const fn of $9449204a10cf7050$var$listeners)fn();
}
function $9449204a10cf7050$export$34ef7267354f580f(list) {
    if (!list || list.source !== 'service' || !Array.isArray(list.items)) // The BFF's own fallback is still the constants — say so, and keep them.
    return {
        ...$9449204a10cf7050$var$FALLBACK_STATE,
        loaded: true
    };
    const byService = new Map();
    for (const item of list.items){
        // An unpriced row (null) leaves the constant in place: a chip must never
        // go blank for a service the AI still charges under its code default.
        // Checked for null BEFORE Number(): Number(null) is 0, and 0 is a price.
        if (!item?.serviceKey || item.parseh === null || item.parseh === undefined) continue;
        const n = Number(item.parseh);
        if (Number.isFinite(n) && n >= 0) byService.set(item.serviceKey, n);
    }
    const toman = Number(list.parsehToman);
    return {
        byService: byService,
        parsehToman: Number.isFinite(toman) && toman > 0 ? Math.round(toman) : null,
        policyId: list.policyId || null,
        source: 'service',
        loaded: true
    };
}
function $9449204a10cf7050$export$477e957045ea2243(list) {
    const next = $9449204a10cf7050$export$34ef7267354f580f(list);
    if (next.source === 'service') {
        $9449204a10cf7050$var$answered = true;
        try {
            sessionStorage.setItem($9449204a10cf7050$var$STORAGE_KEY, JSON.stringify(list));
        } catch  {}
    }
    $9449204a10cf7050$var$emit(next);
}
function $9449204a10cf7050$export$230b85c65d633100() {
    $9449204a10cf7050$var$state = $9449204a10cf7050$var$FALLBACK_STATE;
    $9449204a10cf7050$var$inflight = null;
    $9449204a10cf7050$var$answered = false;
    try {
        sessionStorage.removeItem($9449204a10cf7050$var$STORAGE_KEY);
    } catch  {}
    for (const fn of $9449204a10cf7050$var$listeners)fn();
}
// A reload paints the last policy price first, not the constant.
try {
    const cached = sessionStorage.getItem($9449204a10cf7050$var$STORAGE_KEY);
    if (cached) {
        const restored = $9449204a10cf7050$export$34ef7267354f580f(JSON.parse(cached));
        if (restored.source === 'service') $9449204a10cf7050$var$state = {
            ...restored,
            loaded: false
        };
    }
} catch  {}
function $9449204a10cf7050$export$84016827a72d6537() {
    if ($9449204a10cf7050$var$answered) return Promise.resolve($9449204a10cf7050$var$state);
    if ($9449204a10cf7050$var$inflight) return $9449204a10cf7050$var$inflight;
    $9449204a10cf7050$var$inflight = Promise.resolve().then(()=>(0, $206625c7d33bd390$export$7fb4864174f056c)($9449204a10cf7050$export$f5e24740e23fe4a0)).then((data)=>{
        const list = data?.creditPrices;
        if (list && list.source === 'service') $9449204a10cf7050$export$477e957045ea2243(list);
        else $9449204a10cf7050$var$emit({
            ...$9449204a10cf7050$var$state,
            loaded: true
        });
    }).catch(()=>{
        // Offline, signed out, the BFF down: the constants stay on screen.
        $9449204a10cf7050$var$emit({
            ...$9449204a10cf7050$var$state,
            loaded: true
        });
    }).finally(()=>{
        $9449204a10cf7050$var$inflight = null;
    }).then(()=>$9449204a10cf7050$var$state);
    return $9449204a10cf7050$var$inflight;
}
function $9449204a10cf7050$export$c932aceb7c67d0f4(actionId) {
    const key = $9449204a10cf7050$export$c3ecc18ec062bc34[actionId];
    if (key && $9449204a10cf7050$var$state.byService && $9449204a10cf7050$var$state.byService.has(key)) return $9449204a10cf7050$var$state.byService.get(key);
    return (0, $9ffff9692ff7166c$export$c7cf0ec3971f321c)[actionId] ?? null;
}
function $9449204a10cf7050$export$b9aa9ba1f60db0e(kind) {
    const action = $9449204a10cf7050$export$aa2a9b2355fac90b[kind];
    if (!action) return (0, $9ffff9692ff7166c$export$62371531b76e632c)[kind] ?? 0;
    return $9449204a10cf7050$export$c932aceb7c67d0f4(action) ?? 0;
}
function $9449204a10cf7050$export$2059389b3f9c68ee() {
    return $9449204a10cf7050$var$state.parsehToman ?? (0, $9ffff9692ff7166c$export$6db475f96f22888b);
}
function $9449204a10cf7050$export$685f009c83717b79() {
    return (0, $9ffff9692ff7166c$export$52690e1136e04e64).map((row)=>({
            ...row,
            cost: $9449204a10cf7050$export$c932aceb7c67d0f4(row.action)
        }));
}
const $9449204a10cf7050$var$subscribe = (fn)=>{
    $9449204a10cf7050$var$listeners.add(fn);
    return ()=>$9449204a10cf7050$var$listeners.delete(fn);
};
const $9449204a10cf7050$var$getSnapshot = ()=>$9449204a10cf7050$var$state;
function $9449204a10cf7050$export$204bd72286fdb787() {
    const snapshot = (0, $acw62.useSyncExternalStore)($9449204a10cf7050$var$subscribe, $9449204a10cf7050$var$getSnapshot, $9449204a10cf7050$var$getSnapshot);
    (0, $acw62.useEffect)(()=>{
        $9449204a10cf7050$export$84016827a72d6537();
    }, []);
    return {
        costOf: $9449204a10cf7050$export$c932aceb7c67d0f4,
        costForKind: $9449204a10cf7050$export$b9aa9ba1f60db0e,
        parsehPriceToman: snapshot.parsehToman ?? (0, $9ffff9692ff7166c$export$6db475f96f22888b),
        priceList: $9449204a10cf7050$export$685f009c83717b79(),
        source: snapshot.source,
        policyId: snapshot.policyId,
        loaded: snapshot.loaded
    };
}





parcelRequire("acw62");





function $3f5fb734a3b15afa$export$71d6ce43dc25b15f({ cost: cost, before: before = false, style: style }) {
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    if (!Number(cost)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
        variant: "success",
        style: style,
        "data-testid": "cost-chip",
        children: t('assistant.costFree')
    });
    const parseh = (0, $9ffff9692ff7166c$export$63e20163a2b1658b)(cost, formatNumber);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        "data-testid": "cost-chip",
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            fontSize: 11.5,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk,
            background: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal, 0.14),
            borderRadius: 999,
            padding: '3px 10px',
            whiteSpace: 'nowrap',
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eea507cd16630bf5$export$2e2bcd8739ae039), {
                size: 12,
                "aria-hidden": true
            }),
            t(before ? 'assistant.costBefore' : 'assistant.cost', {
                parseh: parseh
            })
        ]
    });
}
function $3f5fb734a3b15afa$export$8866dd39911dad54({ balance: balance, style: style }) {
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    if (balance == null) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        "data-testid": "balance-line",
        style: {
            fontSize: 12,
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eea507cd16630bf5$export$2e2bcd8739ae039), {
                size: 13,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                "aria-hidden": true
            }),
            t('assistant.balance', {
                parseh: (0, $9ffff9692ff7166c$export$63e20163a2b1658b)(balance, formatNumber)
            })
        ]
    });
}
function $3f5fb734a3b15afa$export$2be18118ce24b5e({ onTopUp: onTopUp, style: style }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
        variant: "error",
        title: t('assistant.noCredits.title'),
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eea507cd16630bf5$export$2e2bcd8739ae039), {
            size: 18,
            "aria-hidden": true
        }),
        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            size: "sm",
            onClick: onTopUp,
            children: t('assistant.noCredits.action')
        }),
        "data-testid": "out-of-credits",
        style: style,
        children: t('assistant.noCredits.body')
    });
}
var $3f5fb734a3b15afa$export$2e2bcd8739ae039 = $3f5fb734a3b15afa$export$71d6ce43dc25b15f;



// ورود صوتی — dictate a case, then confirm what it heard.
//
// ── Speech-to-text happens in the BROWSER. Audio never leaves it. ────────
//
// `parseCaseVoice` takes a `String transcript`, and that is not an optimisation:
// the BFF's JSON body limit is 1 MB, so a base64 recording would not fit and
// would fail as a 413 BEFORE any resolver ran — i.e. with no error message this
// app controls. The Web Speech API does the recognition here and hands back text.
//
// A browser without it is not blocked: the transcript box below is a plain
// textarea, and typing or pasting into it reaches exactly the same mutation. That
// is also the escape hatch when the recogniser mishears — which is why the
// normalized transcript comes BACK in the result and is shown.
//
// ── The AI never writes to the case ──────────────────────────────────────
//
// `parseCaseVoice` returns a DRAFT and stores nothing. The student ticks what
// they keep and submits it through `addCaseHistory` with `source: 'voice'`, which
// is the same call every hand-typed entry goes through. There is no state in
// which an entry belongs to the AI rather than to the student — a student who
// cannot tell which sentences a model put in their mouth cannot study from them.
//
// The demographics the transcript mentioned are shown and NOT applied. Writing a
// name, an age and a sex onto the case behind the student's back would be the AI
// editing the record, and `assistant.voice.draft.demographicsNote` says where to
// change them instead.
const $36b1a5219a051014$var$SPEECH_LANG = 'fa-IR';
/** The browser's recogniser, or null. Prefixed on WebKit; absent on Firefox. */ function $36b1a5219a051014$var$speechRecognition() {
    if (typeof window === 'undefined') return null;
    return window.SpeechRecognition || window.webkitSpeechRecognition || null;
}
const $36b1a5219a051014$var$sectionLabelKey = (id)=>(0, $5250c7903fe7c8ca$export$1db3bd07a84c7494).find((s)=>s.id === id)?.labelKey || null;
function $36b1a5219a051014$export$2e2bcd8739ae039({ entries: entries, assistant: assistant, addHistory: addHistory, balance: balance }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const [transcript, setTranscript] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [listening, setListening] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [keep, setKeep] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({}); // index → boolean
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [problem, setProblem] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const recognizerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const supported = Boolean($36b1a5219a051014$var$speechRecognition());
    const parsing = assistant.busy === 'voice';
    // The policy's price once the list has arrived; the constant (0 today) until then.
    const cost = (0, $9449204a10cf7050$export$204bd72286fdb787)().costOf('VOICE');
    // Stop the microphone if the panel unmounts mid-sentence. Without this the
    // recogniser keeps the mic open after the student navigates away, which the
    // browser shows as a permanently recording tab.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            try {
                recognizerRef.current?.stop();
            } catch  {
            /* already stopped */ }
        }, []);
    const startListening = ()=>{
        const Recognition = $36b1a5219a051014$var$speechRecognition();
        if (!Recognition) return;
        const recognizer = new Recognition();
        recognizer.lang = $36b1a5219a051014$var$SPEECH_LANG;
        // Interim results are shown as they arrive, because a student dictating a
        // whole history needs to see that the microphone is working long before the
        // final result lands.
        recognizer.interimResults = true;
        recognizer.continuous = true;
        let committed = transcript;
        recognizer.onresult = (event)=>{
            let interim = '';
            for(let i = event.resultIndex; i < event.results.length; i += 1){
                const chunk = event.results[i][0].transcript;
                if (event.results[i].isFinal) committed = `${committed} ${chunk}`.trim();
                else interim += chunk;
            }
            setTranscript(interim ? `${committed} ${interim}`.trim() : committed);
        };
        recognizer.onerror = (event)=>{
            console.warn('[voice] recognition error:', event?.error);
            setListening(false);
        };
        recognizer.onend = ()=>setListening(false);
        recognizerRef.current = recognizer;
        setProblem('');
        setListening(true);
        recognizer.start();
    };
    const stopListening = ()=>{
        try {
            recognizerRef.current?.stop();
        } catch  {
        /* already stopped */ }
        setListening(false);
    };
    const parse = async ()=>{
        const text = transcript.trim();
        if (!text) {
            setProblem('assistant.voice.needsTranscript');
            return;
        }
        setProblem('');
        stopListening();
        try {
            const result = await assistant.parseVoice(text);
            setDraft(result || null);
            // Everything it found is ticked to begin with: the student is reviewing
            // what they just said, and having to tick each line back on is a review
            // nobody does carefully.
            setKeep(Object.fromEntries((result?.entries || []).map((_, i)=>[
                    i,
                    true
                ])));
        } catch (err) {
            if ((0, $206625c7d33bd390$export$51746a26c94c297f)(err)) {
                toast.error(t('errors.insufficientCredits'));
                return;
            }
            console.error('[voice] parse failed:', err?.message);
            toast.error(t('errors.generic'));
        }
    };
    const confirm = async ()=>{
        const rows = (draft?.entries || []).map((entry, index)=>({
                entry: entry,
                index: index
            })).filter(({ entry: entry, index: index })=>// An eighth section value is dropped rather than sent. The set is
            // validated on write and REJECTED, and `addCaseHistory` is
            // all-or-nothing — so one unknown section would fail the whole
            // submission, including the six entries the student did want.
            keep[index] && (0, $5250c7903fe7c8ca$export$d0fe0b0df5d61021).includes(entry?.section));
        if (!rows.length) return;
        setSaving(true);
        try {
            const grouped = (0, $5250c7903fe7c8ca$export$cf8eee2145edba16)(entries);
            // A running sort order per section, so several drafted entries landing in
            // the same section keep the order they were dictated in.
            const cursor = {};
            const payload = rows.map(({ entry: entry })=>{
                const section = entry.section;
                if (cursor[section] == null) cursor[section] = (0, $5250c7903fe7c8ca$export$cbaeb5a00d9872f2)(grouped[section]);
                else cursor[section] += 1;
                return {
                    section: section,
                    label: null,
                    body: String(entry.body || '').trim(),
                    structured: entry.structured ?? null,
                    // PROVENANCE, set once and never updatable: this entry came from a
                    // voice draft the student confirmed.
                    source: 'voice',
                    sortOrder: cursor[section],
                    recordedAtMs: null
                };
            });
            await addHistory(payload);
            toast.success(t('assistant.voice.applied', {
                count: payload.length
            }));
            setDraft(null);
            setKeep({});
            setTranscript('');
        } catch (err) {
            console.error('[voice] confirm failed:', err?.message);
            toast.error(t('errors.saveFailed'));
        } finally{
            setSaving(false);
        }
    };
    const demographics = draft ? [
        draft.displayName,
        draft.ageDisplay || (draft.ageYears != null ? String(draft.ageYears) : ''),
        draft.sex,
        draft.chiefComplaint
    ].filter(Boolean) : [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            minHeight: 0
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                style: {
                                    margin: 0,
                                    fontSize: 14,
                                    fontWeight: 800,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                },
                                children: t('assistant.voice.title')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    margin: '4px 0 0',
                                    fontSize: 12.5,
                                    lineHeight: 1.9,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: t('assistant.voice.body')
                            })
                        ]
                    }),
                    !supported && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "warning",
                        children: t('assistant.voice.unsupported')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            flexWrap: 'wrap'
                        },
                        children: [
                            supported && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: listening ? 'destructive' : 'default',
                                onClick: listening ? stopListening : startListening,
                                disabled: parsing,
                                "data-testid": "voice-toggle",
                                children: [
                                    listening ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5340d072e86ce769$export$2e2bcd8739ae039), {
                                        size: 15,
                                        "aria-hidden": true
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9f4b1e9a7f47143$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": true
                                    }),
                                    listening ? t('assistant.voice.stop') : t('assistant.voice.start')
                                ]
                            }),
                            listening && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    fontSize: 12,
                                    fontWeight: 700,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red
                                },
                                children: t('assistant.voice.listening')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                        label: t('assistant.voice.transcript'),
                        value: transcript,
                        onChange: (e)=>setTranscript(e.target.value),
                        placeholder: t('assistant.voice.transcriptPlaceholder'),
                        rows: 6,
                        disabled: parsing,
                        maxLength: 20000,
                        inputStyle: {
                            fontSize: '1rem'
                        },
                        "data-testid": "voice-transcript"
                    }),
                    problem && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            margin: 0,
                            fontSize: 11.5,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
                            fontWeight: 600
                        },
                        children: t(problem)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                onClick: parse,
                                disabled: parsing,
                                "data-testid": "voice-parse",
                                children: [
                                    parsing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                        size: 14,
                                        color: "#fff"
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": true
                                    }),
                                    parsing ? t('assistant.voice.parsing') : t('assistant.voice.parse')
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f5fb734a3b15afa$export$71d6ce43dc25b15f), {
                                cost: cost,
                                before: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f5fb734a3b15afa$export$8866dd39911dad54), {
                                balance: balance
                            })
                        ]
                    })
                ]
            }),
            draft && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 12
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "info",
                        title: t('assistant.voice.draft.title'),
                        children: t('assistant.voice.draft.body')
                    }),
                    draft.transcript && draft.transcript !== transcript && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 11,
                                    fontWeight: 700,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                    marginBottom: 4
                                },
                                children: t('assistant.voice.transcript')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 12.5,
                                    lineHeight: 1.95,
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2,
                                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).bg,
                                    borderRadius: 10,
                                    padding: 10,
                                    whiteSpace: 'pre-wrap'
                                },
                                children: draft.transcript
                            })
                        ]
                    }),
                    demographics.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 12,
                                    fontWeight: 800,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                },
                                children: t('assistant.voice.draft.demographics')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    gap: 6,
                                    flexWrap: 'wrap',
                                    margin: '6px 0'
                                },
                                children: demographics.map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                        variant: "outline",
                                        children: value
                                    }, value))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    margin: 0,
                                    fontSize: 11,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: t('assistant.voice.draft.demographicsNote')
                            })
                        ]
                    }),
                    draft.entries?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8
                        },
                        children: draft.entries.map((entry, index)=>{
                            const labelKey = $36b1a5219a051014$var$sectionLabelKey(entry.section);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                    borderRadius: 10,
                                    padding: 10,
                                    display: 'flex',
                                    gap: 10,
                                    alignItems: 'flex-start'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a6c6e1277da35de$export$2e2bcd8739ae039), {
                                        checked: !!keep[index],
                                        onChange: (next)=>setKeep((prev)=>({
                                                    ...prev,
                                                    [index]: !!next
                                                })),
                                        // The whole row is not the label: the body can be a
                                        // paragraph, and a checkbox whose hit area is a paragraph
                                        // is one that gets toggled while a student is selecting
                                        // text to read it again.
                                        label: null,
                                        disabled: saving
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            flex: 1,
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                variant: labelKey ? 'outline' : 'destructive',
                                                children: labelKey ? t(labelKey) : entry.section
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 13,
                                                    lineHeight: 2,
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                                    marginTop: 6,
                                                    whiteSpace: 'pre-wrap',
                                                    overflowWrap: 'anywhere'
                                                },
                                                children: entry.body
                                            })
                                        ]
                                    })
                                ]
                            }, `${entry.section}-${index}`);
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            margin: 0,
                            fontSize: 12.5,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                        },
                        children: t('assistant.voice.draft.none')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$f9f72ca4b5e00695), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 8,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                onClick: confirm,
                                disabled: saving || !Object.values(keep).some(Boolean),
                                "data-testid": "voice-confirm",
                                children: [
                                    saving ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                        size: 14,
                                        color: "#fff"
                                    }) : null,
                                    saving ? t('assistant.voice.draft.confirming') : t('assistant.voice.draft.confirm')
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: "outline",
                                onClick: ()=>{
                                    setDraft(null);
                                    setKeep({});
                                },
                                disabled: saving,
                                children: t('assistant.voice.draft.discard')
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



// دیکته — a spoken شرح حال turned into a DRAFT the student confirms.
//
// The one AI operation the record screen owns. Everything else the assistant
// does happens inside a visit (the copilot) or on the chat page, and those hooks
// belong to their own screens; this is here because «دیکته» is a way of writing
// the history, and the history is part of the record.
//
// ── A TRANSCRIPT, never audio ─────────────────────────────────────────────
//
// Speech-to-text happens in the BROWSER (`VoicePanel` drives the platform
// recogniser). The BFF's JSON body limit would reject a base64 recording as a
// 413 before any resolver ran — with no error message this app controls — and
// the AI service's streaming transcription RPC is appointment-bound, which this
// app may not dial (core.md §8.1).
//
// ── It writes NOTHING ─────────────────────────────────────────────────────
//
// `parseCaseVoice` returns a draft. The student edits it and confirms what they
// keep through `addCaseHistory` with `source: "voice"` — the same mutation they
// would use by hand (core.md §3.4). There is no state in which an entry belongs
// to the AI rather than to the student; `source` records where the words came
// from and is immutable afterwards.

var $acw62 = parcelRequire("acw62");



function $af7630388963904f$export$bc73bea93f1dbf97(caseId) {
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const parseVoice = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (transcript)=>{
        setBusy('voice');
        try {
            const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$ea7b58070451027d), {
                caseId: caseId,
                transcript: transcript
            });
            // The service meters nothing for this today (PARSEH_COSTS.VOICE = 0),
            // but the balance is re-read anyway: the day it starts charging, the
            // number beside the button must move without a client change.
            (0, $5bc9ff20f6a2b818$export$3437bf7ab4f0acaf)();
            return data?.parseCaseVoice || null;
        } catch (err) {
            console.error('[useCaseVoice] parse failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
            throw err;
        } finally{
            setBusy(null);
        }
    }, [
        caseId
    ]);
    return {
        busy: busy,
        parseVoice: parseVoice
    };
}
var $af7630388963904f$export$2e2bcd8739ae039 = $af7630388963904f$export$bc73bea93f1dbf97;



function $4966c18e5a10032c$export$2e2bcd8739ae039({ caseId: caseId, entries: entries, encounters: encounters = [], addHistory: addHistory, updateEntry: updateEntry, deleteEntry: deleteEntry }) {
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const { balance: balance } = (0, $5bc9ff20f6a2b818$export$f637e1cf42d15a62)();
    const voice = (0, $af7630388963904f$export$bc73bea93f1dbf97)(caseId);
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    // The create flow lands here with `hint: 'created'` in router state (core.md
    // §7.3): for THAT first visit the hint is «شرح حال را بنویسید یا دیکته
    // کنید» — the two ways to fill an empty history — and the normal line after.
    // Read ONCE, at mount: the state belongs to the history entry the create
    // pushed, so a tab change (a new entry, no state) already forgets it, and a
    // lazy initialiser means a re-render cannot re-read it either.
    const [justCreated] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>location.state?.hint === 'created');
    const editor = (0, $9206cc4a29ffd112$export$6892f917acf7f49)({
        entries: entries,
        addHistory: addHistory,
        updateEntry: updateEntry
    });
    const [voiceOpen, setVoiceOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [deleteTarget, setDeleteTarget] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [deleting, setDeleting] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const bySection = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $5250c7903fe7c8ca$export$cf8eee2145edba16)(entries), [
        entries
    ]);
    // An entry stamped with a visit shows «ویزیت N». The entry carries the
    // encounter's ID and the record carries its number, so the chip is resolved
    // here rather than asked for: an entry whose visit was cancelled keeps the
    // entry (core.md §5.1) and simply loses the chip, which is exactly right —
    // the fact survives, the grouping does not.
    const seqById = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const map = new Map();
        for (const enc of encounters || [])map.set(enc.id, enc.seq);
        return map;
    }, [
        encounters
    ]);
    const seqOf = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((entry)=>entry?.encounterId ? seqById.get(entry.encounterId) ?? null : null, [
        seqById
    ]);
    const onSave = async ()=>{
        try {
            const saved = await editor.save();
            if (saved) toast.success(t('history.saved'));
        } catch (err) {
            toast.error(t((0, $206625c7d33bd390$export$660244d64183d198)(err)));
        }
    };
    const onDelete = async ()=>{
        if (!deleteTarget) return;
        setDeleting(true);
        try {
            await deleteEntry(deleteTarget.id);
            toast.success(t('history.deleted'));
            setDeleteTarget(null);
        } catch (err) {
            toast.error(t((0, $206625c7d33bd390$export$660244d64183d198)(err)));
        } finally{
            setDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        },
        "data-testid": "record-history",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            margin: 0,
                            fontSize: 12.5,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                            flex: 1
                        },
                        "data-testid": justCreated ? 'history-hint-created' : 'history-hint',
                        children: justCreated ? t('patients.createdHint') : t('record.history.hint')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "outline",
                        onClick: ()=>setVoiceOpen(true),
                        "data-testid": "history-dictate",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9f4b1e9a7f47143$export$2e2bcd8739ae039), {
                                size: 15,
                                "aria-hidden": true
                            }),
                            t('record.history.dictate')
                        ]
                    })
                ]
            }),
            (0, $5250c7903fe7c8ca$export$1db3bd07a84c7494).map(({ id: id, labelKey: labelKey, Icon: Icon })=>{
                const rows = bySection[id] || [];
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67f84dfba78b42fa$export$2e2bcd8739ae039), {
                    id: id,
                    title: t(labelKey),
                    icon: Icon,
                    count: rows.length ? formatNumber(rows.length) : null,
                    action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: "sm",
                        onClick: ()=>editor.openNew(id),
                        "data-testid": `history-add-${id}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83905746e46531b9$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true
                            }),
                            t('history.add')
                        ]
                    }),
                    "data-testid": `history-section-${id}`,
                    children: rows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 10
                        },
                        children: rows.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba27f9b334140ce4$export$5e8147168ba5a79), {
                                entry: entry,
                                visitSeq: seqOf(entry),
                                onEdit: editor.openExisting,
                                onDelete: setDeleteTarget
                            }, entry.id))
                    }) : // An empty section is EMPTY, not broken — and the recovery is one
                    // click away in the header, so this line explains rather than
                    // repeating the button.
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            margin: '4px 0',
                            fontSize: 12.5,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                        },
                        children: t('history.empty.body')
                    })
                }, id);
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
                open: editor.open,
                onOpenChange: (next)=>{
                    if (!next) editor.close();
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
                    size: "lg",
                    layout: "frame",
                    "data-testid": "entry-editor-dialog",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$742513523b177e3b), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
                                children: editor.editing ? t('common.actions.edit') : t('history.add')
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$5d20f2c38fcde41f), {
                            children: [
                                editor.error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                    variant: "warning",
                                    style: {
                                        marginBottom: 12
                                    },
                                    children: t(editor.error)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f1c0185eaf6cd67$export$2e2bcd8739ae039), {
                                    values: editor.form,
                                    onChange: editor.change,
                                    disabled: editor.saving
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$7bbfb2d443473050), {
                            style: {
                                display: 'flex',
                                gap: 8,
                                marginTop: 16
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    onClick: onSave,
                                    disabled: editor.saving,
                                    "data-testid": "entry-save",
                                    children: editor.saving ? t('common.actions.saving') : t('common.actions.save')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    onClick: editor.close,
                                    disabled: editor.saving,
                                    children: t('common.actions.cancel')
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62b7b2700449d456$export$2e2bcd8739ae039), {
                open: voiceOpen,
                onClose: ()=>setVoiceOpen(false),
                title: t('record.history.dictate'),
                width: 520,
                "data-testid": "voice-sheet",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $36b1a5219a051014$export$2e2bcd8739ae039), {
                    entries: entries,
                    assistant: voice,
                    addHistory: addHistory,
                    balance: balance
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
                open: Boolean(deleteTarget),
                onOpenChange: (next)=>{
                    if (!next) setDeleteTarget(null);
                },
                title: t('history.delete.title'),
                description: t('history.delete.body'),
                confirmLabel: t('common.actions.delete'),
                cancelLabel: t('common.actions.cancel'),
                destructive: true,
                loading: deleting,
                onConfirm: onDelete,
                confirmTestId: "entry-delete-confirm"
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");






function $7dc0e688a58d1e48$export$2e2bcd8739ae039({ encounters: encounters, onOpenVisit: onOpenVisit, onStartVisit: onStartVisit, canStart: canStart, mobile: mobile }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const rows = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $6ea44a98f4200fa8$export$f0b17a59af8beedc)(encounters), [
        encounters
    ]);
    const counts = (row)=>[
            formatNumber(Number(row.diagnosisCount || 0)),
            formatNumber(Number(row.rxCount || 0)),
            formatNumber(Number(row.orderCount || 0))
        ].join(" \xb7 ");
    if (!rows.length) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02839c5704f38745$export$2e2bcd8739ae039), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('record.visits.empty.title'),
        description: t('record.visits.empty.body'),
        action: canStart ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            onClick: onStartVisit,
            "data-testid": "visits-empty-start",
            children: t('record.actions.startVisit')
        }) : null,
        "data-testid": "record-visits-empty"
    });
    if (mobile) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        },
        "data-testid": "record-visits",
        children: rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                role: "button",
                onClick: ()=>onOpenVisit(row),
                "data-testid": `visit-card-${row.id}`,
                style: {
                    padding: 12,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 5
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    fontWeight: 800,
                                    fontSize: 14
                                },
                                children: t('visit.number', {
                                    n: formatNumber(row.seq)
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                variant: row.status === 'open' ? 'warning' : 'outline',
                                children: t((0, $b9b56989c1caf471$export$c5cf6d2182208b38)(row.status))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    marginInlineStart: 'auto',
                                    fontSize: 11.5,
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                                },
                                children: formatDate(row.startedAtMs, 'numeric')
                            })
                        ]
                    }),
                    row.reason && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 13,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                        },
                        children: row.reason
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            fontSize: 11.5,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                        },
                        children: [
                            t('record.visits.columns.counts'),
                            ": ",
                            counts(row)
                        ]
                    }),
                    row.summary && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 12.5,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                        },
                        children: (0, $6ea44a98f4200fa8$export$c7ae287039599931)(row.summary)
                    })
                ]
            }, row.id))
    });
    const columns = [
        {
            key: 'seq',
            header: t('record.visits.columns.visit'),
            render: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        fontWeight: 700
                    },
                    children: t('visit.number', {
                        n: formatNumber(row.seq)
                    })
                })
        },
        {
            key: 'date',
            header: t('record.visits.columns.date'),
            render: (row)=>formatDate(row.startedAtMs, 'numeric')
        },
        {
            key: 'reason',
            header: t('record.visits.columns.reason'),
            render: (row)=>row.reason || t('common.labels.none')
        },
        {
            key: 'status',
            header: t('record.visits.columns.status'),
            render: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: row.status === 'open' ? 'warning' : 'outline',
                    children: t((0, $b9b56989c1caf471$export$c5cf6d2182208b38)(row.status))
                })
        },
        {
            key: 'counts',
            header: t('record.visits.columns.counts'),
            align: 'center',
            // The server's counts. An encounter row carries no children by contract.
            render: counts
        },
        {
            key: 'summary',
            header: t('record.visits.columns.summary'),
            render: (row)=>(0, $6ea44a98f4200fa8$export$c7ae287039599931)(row.summary, 60) || t('common.labels.none')
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
        columns: columns,
        rows: rows,
        rowKey: (row)=>row.id,
        onRowActivate: onOpenVisit,
        rowProps: (row)=>({
                'data-testid': `visit-row-${row.id}`,
                'aria-label': t('record.visits.openLabel', {
                    n: formatNumber(row.seq)
                })
            }),
        "data-testid": "record-visits"
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $87513a585d30c268$export$a2387ed3b5d536eb = {
    name: "calendar-clock",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 14v2.2l1.6 1",
                key: "fo4ql5"
            }
        ],
        [
            "path",
            {
                d: "M16 2v3",
                key: "otl347"
            }
        ],
        [
            "path",
            {
                d: "M21 7.338V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h2.338",
                key: "7hb8p4"
            }
        ],
        [
            "path",
            {
                d: "M3 9h5.859",
                key: "numkqi"
            }
        ],
        [
            "path",
            {
                d: "M8 2v3",
                key: "1ioesn"
            }
        ],
        [
            "circle",
            {
                cx: "16",
                cy: "16",
                r: "6",
                key: "qoo3c4"
            }
        ]
    ]
};
$87513a585d30c268$export$a2387ed3b5d536eb.node;
const $87513a585d30c268$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($87513a585d30c268$export$a2387ed3b5d536eb);





// خط زمانی — grouping the BFF's derived `timeline` for the record's tab.
//
// The BFF answers a FLAT list of `TimelineEvent`s, newest first (core.md §6):
// encounter starts and ends, history entries, diagnoses, rx items, orders
// (ordered and resulted are two events) and thread starts. The client's only
// job is to fold them into the groups the tab renders — one per visit
// («ویزیت ۳ · date») plus «خارج از ویزیت» for anything not stamped — and to
// filter by type. Nothing here is stored and nothing here is derived from the
// record itself: the BFF is the one place that computes the timeline.
//
// Pure and React-free — tests/timeline.test.js calls it directly.
/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b59be6ccf3b0b745$export$a2387ed3b5d536eb = {
    name: "flag",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528",
                key: "1jaruq"
            }
        ]
    ]
};
$b59be6ccf3b0b745$export$a2387ed3b5d536eb.node;
const $b59be6ccf3b0b745$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($b59be6ccf3b0b745$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d6587060a8c34d29$export$a2387ed3b5d536eb = {
    name: "flask-round",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10 2v6.292a7 7 0 1 0 4 0V2",
                key: "1s42pc"
            }
        ],
        [
            "path",
            {
                d: "M5 15h14",
                key: "m0yey3"
            }
        ],
        [
            "path",
            {
                d: "M8.5 2h7",
                key: "csnxdl"
            }
        ]
    ]
};
$d6587060a8c34d29$export$a2387ed3b5d536eb.node;
const $d6587060a8c34d29$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($d6587060a8c34d29$export$a2387ed3b5d536eb);



const $c7ba9b1ff230646d$export$897ac63d64cd28fd = {
    encounter_start: (0, $02839c5704f38745$export$2e2bcd8739ae039),
    encounter_end: (0, $b59be6ccf3b0b745$export$2e2bcd8739ae039),
    entry: (0, $df9771111904a5d5$export$2e2bcd8739ae039),
    diagnosis: (0, $3f35c50d66e81764$export$2e2bcd8739ae039),
    rx: (0, $5ffe798f65d504e7$export$2e2bcd8739ae039),
    order: (0, $241691b67a43640c$export$2e2bcd8739ae039),
    order_result: (0, $d6587060a8c34d29$export$2e2bcd8739ae039),
    thread: (0, $8c7fae0571c9b8a8$export$2e2bcd8739ae039)
};
const $c7ba9b1ff230646d$export$1a1a3a1478072ca0 = (type)=>$c7ba9b1ff230646d$export$897ac63d64cd28fd[type] || (0, $df9771111904a5d5$export$2e2bcd8739ae039);
const $c7ba9b1ff230646d$export$24d9730553de40c7 = '__outside__';
function $c7ba9b1ff230646d$export$506baeb921805c76(events) {
    const list = Array.isArray(events) ? events : [];
    const groups = new Map();
    for (const event of list){
        const key = event?.encounterId || $c7ba9b1ff230646d$export$24d9730553de40c7;
        if (!groups.has(key)) groups.set(key, {
            key: key,
            encounterId: event?.encounterId || null,
            encounterSeq: event?.encounterSeq ?? null,
            atMs: event?.atMs || null,
            events: []
        });
        const group = groups.get(key);
        if (group.encounterSeq == null && event?.encounterSeq != null) group.encounterSeq = event.encounterSeq;
        group.events.push(event);
    }
    // Newest first, by each group's newest event — the list arrived that way, and
    // the first event a group received is its newest.
    return [
        ...groups.values()
    ].sort((a, b)=>Number(b.atMs || 0) - Number(a.atMs || 0));
}
function $c7ba9b1ff230646d$export$d197ea167f01f540(events, types) {
    const wanted = Array.isArray(types) ? types.filter((x)=>(0, $b9b56989c1caf471$export$ec8701894e012b1b).includes(x)) : [];
    if (!wanted.length) return Array.isArray(events) ? events : [];
    return (events || []).filter((e)=>wanted.includes(e?.type));
}
function $c7ba9b1ff230646d$export$f665b09f5a05d3b6(event, caseId) {
    if (!event) return null;
    if (event.type === 'thread') return {
        screen: 'chat',
        data: {
            caseId: caseId,
            threadId: event.refId
        }
    };
    if (event.encounterId) return {
        screen: 'visit',
        data: {
            caseId: caseId,
            encounterId: event.encounterId
        }
    };
    return {
        screen: 'patient',
        data: {
            caseId: caseId,
            tab: 'history'
        }
    };
}


function $c40f596d9c6d47fd$export$2e2bcd8739ae039({ caseId: caseId, timeline: timeline, onNavigate: onNavigate }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate, formatTime: formatTime } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [types, setTypes] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const events = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $c7ba9b1ff230646d$export$d197ea167f01f540)(timeline, types), [
        timeline,
        types
    ]);
    const groups = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $c7ba9b1ff230646d$export$506baeb921805c76)(events), [
        events
    ]);
    const toggle = (type)=>setTypes((prev)=>prev.includes(type) ? prev.filter((x)=>x !== type) : [
                ...prev,
                type
            ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        },
        "data-testid": "record-timeline",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    gap: 6,
                    flexWrap: 'wrap'
                },
                role: "group",
                "aria-label": t('record.timeline.filter'),
                children: (0, $b9b56989c1caf471$export$ec8701894e012b1b).map((type)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                        label: t((0, $b9b56989c1caf471$export$1c59302a4d37f309)(type)),
                        active: types.includes(type),
                        onClick: ()=>toggle(type),
                        "data-testid": `timeline-filter-${type}`
                    }, type))
            }),
            groups.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87513a585d30c268$export$2e2bcd8739ae039), {
                    size: 44,
                    strokeWidth: 1.5,
                    "aria-hidden": true
                }),
                title: t('record.timeline.empty.title'),
                description: t('record.timeline.empty.body'),
                "data-testid": "record-timeline-empty"
            }),
            groups.map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    "data-testid": `timeline-group-${group.key}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                            style: {
                                margin: '0 0 8px',
                                fontSize: 12.5,
                                fontWeight: 800,
                                color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8
                            },
                            children: [
                                group.key === (0, $c7ba9b1ff230646d$export$24d9730553de40c7) ? t('record.timeline.outside') : t('visit.number', {
                                    n: formatNumber(group.encounterSeq ?? 0)
                                }),
                                group.atMs && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        "\xb7 ",
                                        formatDate(group.atMs, 'numeric')
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                            style: {
                                padding: '4px 12px'
                            },
                            children: group.events.map((event)=>{
                                const Icon = (0, $c7ba9b1ff230646d$export$1a1a3a1478072ca0)(event.type);
                                const target = (0, $c7ba9b1ff230646d$export$f665b09f5a05d3b6)(event, caseId);
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>target && onNavigate?.(target.screen, target.data),
                                    "data-testid": `timeline-event-${event.id}`,
                                    style: {
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        gap: 9,
                                        width: '100%',
                                        textAlign: 'start',
                                        background: 'none',
                                        border: 0,
                                        borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                        padding: '9px 0',
                                        font: 'inherit',
                                        cursor: 'pointer'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                            size: 16,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                                            "aria-hidden": true,
                                            style: {
                                                marginTop: 2,
                                                flexShrink: 0
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            style: {
                                                flex: 1,
                                                minWidth: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        fontSize: 13,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                                        fontWeight: 600
                                                    },
                                                    children: event.title || t((0, $b9b56989c1caf471$export$1c59302a4d37f309)(event.type))
                                                }),
                                                event.detail && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        display: 'block',
                                                        fontSize: 12,
                                                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                                                        overflowWrap: 'anywhere'
                                                    },
                                                    children: event.detail
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                fontSize: 11,
                                                color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                                                flexShrink: 0
                                            },
                                            children: formatTime(event.atMs)
                                        })
                                    ]
                                }, event.id);
                            })
                        })
                    ]
                }, group.key))
        ]
    });
}


function $3214c8d1396a12e4$export$2e2bcd8739ae039({ tab: tab, screen: screen, caseId: caseId, mobile: mobile = false }) {
    switch(tab){
        case 'history':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4966c18e5a10032c$export$2e2bcd8739ae039), {
                caseId: caseId,
                entries: screen.entries,
                encounters: screen.encounters,
                addHistory: screen.addHistory,
                updateEntry: screen.updateEntry,
                deleteEntry: screen.deleteEntry
            });
        case 'visits':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7dc0e688a58d1e48$export$2e2bcd8739ae039), {
                encounters: screen.encounters,
                onOpenVisit: screen.openVisit,
                onStartVisit: screen.startVisit,
                canStart: !screen.archived,
                mobile: mobile
            });
        case 'timeline':
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c40f596d9c6d47fd$export$2e2bcd8739ae039), {
                caseId: caseId,
                timeline: screen.timeline,
                onNavigate: screen.navigate
            });
        default:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c1e00f956ca1a50$export$2e2bcd8739ae039), {
                caseRow: screen.caseRow,
                entries: screen.entries,
                activeProblems: screen.activeProblems,
                currentMedications: screen.currentMedications,
                pendingOrders: screen.pendingOrders,
                encounters: screen.encounters,
                threads: screen.threads,
                onOpenVisit: screen.openVisit,
                onOpenThread: screen.openChat
            });
    }
}
const $3214c8d1396a12e4$var$MENU_ITEM = {
    display: 'block',
    width: '100%',
    textAlign: 'start',
    background: 'none',
    border: 0,
    padding: '11px 12px',
    fontSize: 13,
    cursor: 'pointer',
    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
    font: 'inherit'
};
function $3214c8d1396a12e4$export$a786ef3d64022ecc({ screen: screen, onGradient: onGradient = false }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const anchorRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                ref: anchorRef,
                style: {
                    display: 'inline-flex'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                    variant: onGradient ? 'onGradient' : 'ghost',
                    size: 40,
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24a488cfd7efdee5$export$2e2bcd8739ae039), {
                        size: 17,
                        "aria-hidden": true
                    }),
                    label: t('common.actions.more'),
                    onClick: ()=>setOpen((v)=>!v),
                    "data-testid": "record-more"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $08d1958bc1315b40$export$2e2bcd8739ae039), {
                open: open,
                onClose: ()=>setOpen(false),
                anchorRef: anchorRef,
                ariaLabel: t('common.actions.more'),
                width: 240,
                placement: "auto",
                "data-testid": "record-menu",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        role: "menuitem",
                        style: $3214c8d1396a12e4$var$MENU_ITEM,
                        onClick: ()=>{
                            setOpen(false);
                            screen.openEdit();
                        },
                        "data-testid": "record-edit",
                        children: t('record.actions.edit')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        role: "menuitem",
                        style: $3214c8d1396a12e4$var$MENU_ITEM,
                        onClick: ()=>{
                            setOpen(false);
                            screen.toggleArchive();
                        },
                        "data-testid": "record-archive",
                        children: t(screen.archived ? 'record.actions.unarchive' : 'record.actions.archive')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        role: "menuitem",
                        style: {
                            ...$3214c8d1396a12e4$var$MENU_ITEM,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red
                        },
                        onClick: ()=>{
                            setOpen(false);
                            screen.openDelete();
                        },
                        "data-testid": "record-delete",
                        children: t('record.actions.delete')
                    })
                ]
            })
        ]
    });
}



function $4e36407aeb098b79$export$2e2bcd8739ae039({ screen: screen, tab: tab, onTab: onTab, caseId: caseId }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const { caseRow: caseRow } = screen;
    if (screen.loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            padding: 20
        },
        "data-testid": "record-loading",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                width: "40%",
                height: 22
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    marginTop: 16
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                    width: "100%",
                    height: 180
                })
            })
        ]
    });
    if (screen.error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            padding: 20
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9876d237fe8b99c$export$2e2bcd8739ae039), {
            error: screen.error,
            onRetry: screen.reload,
            "data-testid": "record-error"
        })
    });
    // «این بیمار پیدا نشد» — the SAME screen for a patient that never existed and
    // one belonging to another student (core.md §3.2). No retry: there is nothing
    // to retry, and a retry button here would be an oracle a student could hold
    // down to find out which ids exist.
    if (screen.notFound) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed00022cb253e04b$export$2e2bcd8739ae039), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('record.notFound.title'),
        description: t('record.notFound.body'),
        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            variant: "outline",
            onClick: screen.back,
            "data-testid": "record-not-found-back",
            children: t('record.notFound.action')
        }),
        "data-testid": "record-not-found"
    });
    const chips = (0, $6ea44a98f4200fa8$export$eb6c7bd144b8773c)(caseRow, {
        t: t,
        formatNumber: formatNumber,
        formatDate: formatDate,
        ageLabel: $0d2396cd0d075e45$export$4c461c63ce38f53
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "record-web",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3c79ee8367a72d83$export$2e2bcd8739ae039), {
                onBack: screen.back,
                backLabel: t('common.actions.back'),
                title: (0, $0d2396cd0d075e45$export$3805f9b7fa77f6d4)(caseRow, t),
                badges: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    style: {
                        display: 'inline-flex',
                        gap: 6,
                        alignItems: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$480ec33bbf749db7), {}),
                        screen.archived && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "outline",
                            "data-testid": "record-archived",
                            children: t('record.header.archived')
                        })
                    ]
                }),
                meta: chips.map((chip)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        "data-testid": `record-chip-${chip.id}`,
                        children: chip.label
                    }, chip.id)),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        onClick: screen.startVisit,
                        disabled: screen.archived,
                        title: screen.archived ? t('record.header.archivedHint') : undefined,
                        "data-testid": "record-start-visit",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02839c5704f38745$export$2e2bcd8739ae039), {
                                size: 15,
                                "aria-hidden": true
                            }),
                            t((0, $6ea44a98f4200fa8$export$624685a2c87360c0)(caseRow))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "outline",
                        onClick: ()=>screen.openChat(),
                        "data-testid": "record-chat",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c7fae0571c9b8a8$export$2e2bcd8739ae039), {
                                size: 15,
                                "aria-hidden": true
                            }),
                            t('record.actions.chat')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3214c8d1396a12e4$export$a786ef3d64022ecc), {
                        screen: screen
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    padding: '16px 20px 32px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 14
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$ac0d528804cbd713), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                        options: (0, $16250bd714b02a14$export$856e5f05339889aa).map((id)=>({
                                value: id,
                                label: t((0, $6ea44a98f4200fa8$export$6a9eb02d63937257)[id])
                            })),
                        value: tab,
                        onChange: onTab,
                        ariaLabel: t('record.tabs.overview'),
                        "data-testid": "record-tabs"
                    }),
                    screen.archived && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            margin: 0,
                            fontSize: 12.5,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                        },
                        children: t('record.header.archivedHint')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3214c8d1396a12e4$export$2e2bcd8739ae039), {
                        tab: tab,
                        screen: screen,
                        caseId: caseId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88c24f7fc32991d2$export$2e2bcd8739ae039), {
                open: screen.startOpen,
                onClose: screen.closeStart,
                reason: screen.reason,
                onReason: screen.setReason,
                onSubmit: screen.submitStart,
                saving: screen.starting
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69d8aed0f76f7fe3$export$9332229b6f2eae05), {
                open: screen.editOpen,
                onClose: screen.closeEdit,
                values: screen.form,
                onChange: screen.setForm,
                onSubmit: screen.submitEdit,
                saving: screen.savingEdit,
                showTitleError: screen.showTitleError,
                mode: "edit"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69d8aed0f76f7fe3$export$55c02e214c96c853), {
                row: screen.deleteOpen ? caseRow : null,
                onCancel: screen.closeDelete,
                onConfirm: screen.confirmDelete,
                loading: screen.deleting
            })
        ]
    });
}



parcelRequire("acw62");











// The patient record on a phone.
//
// A drilled-into surface, so the header is in CONTENT mode and carries the way
// back — the bottom bar is still there (core.md §7.0 hides it only on the visit
// and the chat page), but a student who opened a patient from the list expects
// the back arrow to return them to the list, not to the last destination they
// tapped.
//
// The two primary actions sit under the tab strip rather than in the header:
// «شروع ویزیت» is a 44px target and it must not compete with the back arrow for
// the same corner.
const $a4223633b4d0413a$var$SCROLL = {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    padding: '12px 14px calc(24px + env(safe-area-inset-bottom, 0px))',
    display: 'flex',
    flexDirection: 'column',
    gap: 12
};
function $a4223633b4d0413a$export$2e2bcd8739ae039({ screen: screen, tab: tab, onTab: onTab, caseId: caseId }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const { caseRow: caseRow } = screen;
    if (screen.loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: $a4223633b4d0413a$var$SCROLL,
        "data-testid": "record-loading",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {})
        ]
    });
    if (screen.error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: $a4223633b4d0413a$var$SCROLL,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9876d237fe8b99c$export$2e2bcd8739ae039), {
            error: screen.error,
            onRetry: screen.reload,
            "data-testid": "record-error"
        })
    });
    if (screen.notFound) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: $a4223633b4d0413a$var$SCROLL,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed00022cb253e04b$export$2e2bcd8739ae039), {
                size: 44,
                strokeWidth: 1.5,
                "aria-hidden": true
            }),
            title: t('record.notFound.title'),
            description: t('record.notFound.body'),
            action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                variant: "outline",
                onClick: screen.back,
                "data-testid": "record-not-found-back",
                children: t('record.notFound.action')
            }),
            "data-testid": "record-not-found"
        })
    });
    const chips = (0, $6ea44a98f4200fa8$export$eb6c7bd144b8773c)(caseRow, {
        t: t,
        formatNumber: formatNumber,
        formatDate: formatDate,
        ageLabel: $0d2396cd0d075e45$export$4c461c63ce38f53
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62f4a9fc87ba90f8$export$2e2bcd8739ae039), {
                onBack: screen.back,
                backLabel: t('common.actions.back'),
                title: (0, $0d2396cd0d075e45$export$3805f9b7fa77f6d4)(caseRow, t),
                subtitle: chips.map((chip)=>chip.label).join(" \xb7 "),
                action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3214c8d1396a12e4$export$a786ef3d64022ecc), {
                    screen: screen,
                    onGradient: true
                }),
                "data-testid": "record-mobile-header"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: $a4223633b4d0413a$var$SCROLL,
                "data-testid": "record-mobile",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 7
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$480ec33bbf749db7), {}),
                            screen.archived && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                variant: "outline",
                                "data-testid": "record-archived",
                                children: t('record.header.archived')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$ac0d528804cbd713), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                onClick: screen.startVisit,
                                disabled: screen.archived,
                                className: "flex-1 min-h-11",
                                "data-testid": "record-start-visit",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02839c5704f38745$export$2e2bcd8739ae039), {
                                        size: 15,
                                        "aria-hidden": true
                                    }),
                                    t((0, $6ea44a98f4200fa8$export$624685a2c87360c0)(caseRow))
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: "outline",
                                onClick: ()=>screen.openChat(),
                                className: "min-h-11",
                                "data-testid": "record-chat",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c7fae0571c9b8a8$export$2e2bcd8739ae039), {
                                    size: 15,
                                    "aria-hidden": true
                                })
                            })
                        ]
                    }),
                    screen.archived && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            margin: 0,
                            fontSize: 12,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                        },
                        children: t('record.header.archivedHint')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            overflowX: 'auto',
                            margin: '0 -14px',
                            padding: '0 14px'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                            options: (0, $16250bd714b02a14$export$856e5f05339889aa).map((id)=>({
                                    value: id,
                                    label: t((0, $6ea44a98f4200fa8$export$6a9eb02d63937257)[id])
                                })),
                            value: tab,
                            onChange: onTab,
                            size: "lg",
                            ariaLabel: t('record.tabs.overview'),
                            "data-testid": "record-tabs"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3214c8d1396a12e4$export$2e2bcd8739ae039), {
                        tab: tab,
                        screen: screen,
                        caseId: caseId,
                        mobile: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88c24f7fc32991d2$export$2e2bcd8739ae039), {
                open: screen.startOpen,
                onClose: screen.closeStart,
                reason: screen.reason,
                onReason: screen.setReason,
                onSubmit: screen.submitStart,
                saving: screen.starting
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69d8aed0f76f7fe3$export$9332229b6f2eae05), {
                open: screen.editOpen,
                onClose: screen.closeEdit,
                values: screen.form,
                onChange: screen.setForm,
                onSubmit: screen.submitEdit,
                saving: screen.savingEdit,
                showTitleError: screen.showTitleError,
                mode: "edit"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69d8aed0f76f7fe3$export$55c02e214c96c853), {
                row: screen.deleteOpen ? caseRow : null,
                onCancel: screen.closeDelete,
                onConfirm: screen.confirmDelete,
                loading: screen.deleting
            })
        ]
    });
}



// The record's route wrapper: it reads `:caseId` and `:tab?` and owns nothing
// else.
//
// The tab is a URL SEGMENT because a refresh, a back button and a pasted link
// all have to restore the part of the record the student was reading. A stale
// or hand-edited segment (`/patients/x/nonsense`) is CORRECTED — quietly, with
// `replace` — rather than rendered as an empty tab: pushed, the back button
// would return the student to the broken URL, which would correct itself again,
// which is a trap they cannot leave by going back.
const $77706e1cdd0a7766$var$PatientRecordScreen = ()=>{
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    const { caseId: caseId, tab: tabParam } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const tab = (0, $16250bd714b02a14$export$274854c544a34158)(tabParam);
    const screen = (0, $c38f3af236f736a1$export$2e2bcd8739ae039)(caseId);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (tabParam && !(0, $6ea44a98f4200fa8$export$e37f800954697bae)(tabParam)) navigate('patient', {
            caseId: caseId,
            tab: (0, $16250bd714b02a14$export$2b3748ab0ccf0b0a),
            replace: true
        });
    }, [
        tabParam,
        caseId,
        navigate
    ]);
    const onTab = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((next)=>navigate('patient', {
            caseId: caseId,
            tab: next
        }), [
        navigate,
        caseId
    ]);
    const Surface = isMobile ? (0, $a4223633b4d0413a$export$2e2bcd8739ae039) : (0, $4e36407aeb098b79$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Surface, {
        screen: screen,
        tab: tab,
        onTab: onTab,
        caseId: caseId
    });
};
var $77706e1cdd0a7766$export$2e2bcd8739ae039 = $77706e1cdd0a7766$var$PatientRecordScreen;




var $acw62 = parcelRequire("acw62");





// One visit, everything it holds, and the SOAP note that is being typed into it
// right now. core.md §6, §7.5, §15.
//
// ── Three facts, loaded together, kept apart ──────────────────────────────
//
//   `encounter`  the visit itself with its note / dx / rx / orders — the thing
//                the کار column edits.
//   `record`     the whole patient record (`myCaseRecord`) — what the پرونده
//                rail READS: allergies, problems, current medications, history.
//                It is a separate query because the rail is read-only and must
//                not be repainted by every keystroke in the note below it.
//
// A visit whose `caseId` disagrees with the URL is NOT FOUND, not an error and
// not a redirect: the store answers `GetEncounter(encounter_id, student_id)` and
// the client compares (core.md §7.5). Anything else would let a student learn
// that a visit id exists by watching which of two wrong URLs behaves differently.
//
// ── The autosave, which is the only thing here with a memory ──────────────
//
// A SOAP note is prose typed for minutes at a time, and the student never presses
// «ذخیره». So: 800 ms after the last keystroke the note is upserted with ONLY the
// fields that changed against what the server last confirmed. Only-changed
// matters twice — it makes two tabs on one visit a last-write-wins per FIELD
// rather than per note (§7.5), and it makes a failed save retryable without
// re-sending three fields nobody touched.
//
// A failed save NEVER clears the textarea. The text stays, the indicator goes
// red, and the next keystroke (or a click on the indicator) retries. Meanwhile
// every change is mirrored into `localStorage.visit_draft_<encounterId>` with the
// wall-clock it was made at, so an expired session, a crashed tab or a closed
// laptop cannot take the paragraph with it.
//
// The ONE exception is a save the store refuses on principle: `ENCOUNTER_CLOSED`
// (the visit was closed in another tab) and `ENCOUNTER_NOT_FOUND` (it was
// cancelled there). Retrying those on every keystroke is a 409 per character
// that can never succeed, so instead the draft is DISCARDED, the encounter is
// re-read — which flips the screen to read-only with «بازگشایی» — and the
// student is told through `errors.encounterClosed` (core.md §6, §14).
//
// On the next load the draft and the server's `updatedAtMs` are compared:
// LOCAL NEWER → the draft is pushed up (the student's typing outlived whatever
// the server has); otherwise the draft is DISCARDED and the student is told,
// because keeping it would silently resurrect an older paragraph over a newer one.

var $acw62 = parcelRequire("acw62");



const $9d57055d4093bdd6$export$c7e6ba5fd35b96bb = [
    's',
    'o',
    'a',
    'p'
];
const $9d57055d4093bdd6$export$7eb1617d73539b7 = 800;
/** The `write` option for a mutation whose result the rail's derived views depend on. */ const $9d57055d4093bdd6$var$DERIVES = Object.freeze({
    derives: true
});
const $9d57055d4093bdd6$export$ade9b241dfa4a5e7 = Object.freeze({
    IDLE: 'idle',
    SAVING: 'saving',
    SAVED: 'saved',
    ERROR: 'error'
});
const $9d57055d4093bdd6$var$emptySoap = ()=>({
        s: '',
        o: '',
        a: '',
        p: ''
    });
const $9d57055d4093bdd6$var$soapFromNote = (note)=>({
        s: note?.s || '',
        o: note?.o || '',
        a: note?.a || '',
        p: note?.p || ''
    });
function $9d57055d4093bdd6$export$c5928f7a4cb0232e(base, next) {
    const out = {};
    for (const f of $9d57055d4093bdd6$export$c7e6ba5fd35b96bb)if ((next?.[f] || '') !== (base?.[f] || '')) out[f] = next?.[f] || '';
    return out;
}
function $9d57055d4093bdd6$export$e63698a0a977f6a9(draft, note) {
    if (!draft || typeof draft !== 'object') return {
        action: 'none'
    };
    const soap = $9d57055d4093bdd6$var$soapFromNote(draft);
    if (!$9d57055d4093bdd6$export$c7e6ba5fd35b96bb.some((f)=>soap[f])) return {
        action: 'none'
    };
    const serverSoap = $9d57055d4093bdd6$var$soapFromNote(note);
    if ($9d57055d4093bdd6$export$c7e6ba5fd35b96bb.every((f)=>soap[f] === serverSoap[f])) return {
        action: 'none'
    };
    const localAt = Number(draft.updatedAtMs) || 0;
    const serverAt = Number(note?.updatedAtMs) || 0;
    // A draft with no clock is treated as OLDER: the only way it has no stamp is
    // that something wrote it that this module did not, and guessing in favour of
    // unstamped text is how an older paragraph overwrites a newer one.
    if (localAt > serverAt) return {
        action: 'keep',
        soap: soap
    };
    return {
        action: 'discard',
        soap: soap
    };
}
function $9d57055d4093bdd6$export$c6a6bec0b562dc8b(encounterId, caseId, { onToast: onToast } = {}) {
    const [encounter, setEncounter] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [record, setRecord] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [notFound, setNotFound] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [nonce, setNonce] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [soap, setSoap] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($9d57055d4093bdd6$var$emptySoap);
    const [saveState, setSaveState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($9d57055d4093bdd6$export$ade9b241dfa4a5e7.IDLE);
    const [saveError, setSaveError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // What the server last CONFIRMED. The diff is taken against this, never
    // against the previous render's state.
    const savedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef($9d57055d4093bdd6$var$emptySoap());
    const soapRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef($9d57055d4093bdd6$var$emptySoap());
    const timerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const inFlightRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const draftKey = encounterId ? (0, $7cdea07122bc6887$export$ccbaef21cdaec5bc)(encounterId) : null;
    const toastRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(onToast);
    toastRef.current = onToast;
    const isClosed = encounter?.status === 'closed';
    // ── Load ────────────────────────────────────────────────────────────────
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!encounterId) {
            setLoading(false);
            return undefined;
        }
        let alive = true;
        setLoading(true);
        setNotFound(false);
        (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$470fc6f1295bc1fb), {
            encounterId: encounterId
        }).then(async (data)=>{
            if (!alive) return;
            const row = data?.encounter || null;
            // null = not found AND not mine, deliberately the same screen; a visit
            // filed under another patient is the same answer for the same reason.
            if (!row || caseId && row.caseId && row.caseId !== caseId) {
                setNotFound(true);
                setEncounter(null);
                setError(null);
                return;
            }
            setEncounter(row);
            setError(null);
            const serverSoap = $9d57055d4093bdd6$var$soapFromNote(row.note);
            const stored = draftKey ? (0, $7cdea07122bc6887$export$6a368473377ea45c)(draftKey, {
                kind: 'local',
                fallback: null
            }) : null;
            const verdict = $9d57055d4093bdd6$export$e63698a0a977f6a9(stored, row.note);
            if (verdict.action === 'keep') {
                savedRef.current = serverSoap;
                soapRef.current = verdict.soap;
                setSoap(verdict.soap);
                // Push it now rather than waiting for a keystroke: the student may
                // never touch the note again, and the whole point of the draft is
                // that it stops being local.
                scheduleSave(0);
            } else {
                if (verdict.action === 'discard') {
                    (0, $7cdea07122bc6887$export$eeeb486534738631)(draftKey, {
                        kind: 'local'
                    });
                    toastRef.current?.info?.('discardedDraft');
                }
                savedRef.current = serverSoap;
                soapRef.current = serverSoap;
                setSoap(serverSoap);
                setSaveState($9d57055d4093bdd6$export$ade9b241dfa4a5e7.IDLE);
            }
            // The rail's data. A failure here leaves the workspace usable: the note
            // is the thing being written, and a rail that could not load is a rail
            // that renders empty, not a screen that refuses to open.
            try {
                const rec = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$a5e6f2cc85ed53f7), {
                    caseId: caseId || row.caseId
                });
                if (alive) setRecord(rec?.myCaseRecord || null);
            } catch (err) {
                console.warn('[useEncounter] record load failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
            }
        }).catch((err)=>{
            if (!alive) return;
            console.error('[useEncounter] failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
            setError(err);
        }).finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    // `scheduleSave` is stable-by-ref below; listing it would re-run the load.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        encounterId,
        caseId,
        nonce
    ]);
    const reload = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setNonce((n)=>n + 1), []);
    // ── The save itself ─────────────────────────────────────────────────────
    const runSave = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        if (!encounterId) return {
            ok: true
        };
        const next = soapRef.current;
        const input = $9d57055d4093bdd6$export$c5928f7a4cb0232e(savedRef.current, next);
        if (!Object.keys(input).length) return {
            ok: true
        };
        // A closed visit refuses every clinical write; sending it would be a 409 we
        // already know the answer to.
        if (encounter?.status === 'closed') return {
            ok: true
        };
        setSaveState($9d57055d4093bdd6$export$ade9b241dfa4a5e7.SAVING);
        const attempt = {
            ...next
        };
        const promise = (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$1cad6cb10b69f972), {
            encounterId: encounterId,
            input: input
        }).then((data)=>{
            savedRef.current = attempt;
            setEncounter((prev)=>prev ? {
                    ...prev,
                    note: data?.upsertEncounterNote || prev.note
                } : prev);
            // Only once the store holds it does the local copy stop being the truth.
            if (draftKey) (0, $7cdea07122bc6887$export$eeeb486534738631)(draftKey, {
                kind: 'local'
            });
            setSaveError(null);
            setSaveState($9d57055d4093bdd6$export$ade9b241dfa4a5e7.SAVED);
            return {
                ok: true
            };
        }).catch((err)=>{
            console.warn('[useEncounter] note save failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
            if ($9d57055d4093bdd6$export$5045041d4437a804(err)) {
                // Not retryable: fall back to what the server last confirmed, drop
                // the mirror, and let the reload say what the visit has become.
                if (timerRef.current) {
                    clearTimeout(timerRef.current);
                    timerRef.current = null;
                }
                soapRef.current = {
                    ...savedRef.current
                };
                setSoap(soapRef.current);
                if (draftKey) (0, $7cdea07122bc6887$export$eeeb486534738631)(draftKey, {
                    kind: 'local'
                });
                setSaveError(null);
                setSaveState($9d57055d4093bdd6$export$ade9b241dfa4a5e7.IDLE);
                toastRef.current?.error?.('encounterClosed');
                setNonce((n)=>n + 1);
                return {
                    ok: false,
                    error: err
                };
            }
            setSaveError(err);
            setSaveState($9d57055d4093bdd6$export$ade9b241dfa4a5e7.ERROR);
            return {
                ok: false,
                error: err
            };
        }).finally(()=>{
            inFlightRef.current = null;
        });
        inFlightRef.current = promise;
        return promise;
    }, [
        encounterId,
        draftKey,
        encounter?.status
    ]);
    const runSaveRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(runSave);
    runSaveRef.current = runSave;
    const scheduleSave = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((delay = $9d57055d4093bdd6$export$7eb1617d73539b7)=>{
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>{
            timerRef.current = null;
            runSaveRef.current();
        }, delay);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        }, []);
    /** Type into one SOAP field. Debounces the save and mirrors the draft. */ const setSoapField = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((field, value)=>{
        if (!$9d57055d4093bdd6$export$c7e6ba5fd35b96bb.includes(field)) return;
        const next = {
            ...soapRef.current,
            [field]: value ?? ''
        };
        soapRef.current = next;
        setSoap(next);
        if (draftKey) (0, $7cdea07122bc6887$export$476f628a921f7411)(draftKey, {
            ...next,
            updatedAtMs: Date.now()
        }, {
            kind: 'local'
        });
        scheduleSave();
    }, [
        draftKey,
        scheduleSave
    ]);
    /**
   * Apply a whole suggestion — one section or four — as if it had been typed.
   * `mode` is the chooser the review sheet offers: replace the section, or add
   * the draft under what is already there.
   */ const applySoap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((patch, mode = 'replace')=>{
        // A closed visit takes no suggestion: the review sheet is gated on the same
        // fact upstream, and this is the guard for a sheet that was already open
        // when the visit closed under it.
        if (encounter?.status === 'closed') return;
        const next = {
            ...soapRef.current
        };
        for (const f of $9d57055d4093bdd6$export$c7e6ba5fd35b96bb){
            if (patch?.[f] == null) continue;
            const incoming = String(patch[f]);
            next[f] = mode === 'append' && next[f] ? `${next[f]}\n${incoming}` : incoming;
        }
        soapRef.current = next;
        setSoap(next);
        if (draftKey) (0, $7cdea07122bc6887$export$476f628a921f7411)(draftKey, {
            ...next,
            updatedAtMs: Date.now()
        }, {
            kind: 'local'
        });
        scheduleSave();
    }, [
        draftKey,
        scheduleSave,
        encounter?.status
    ]);
    /** Save NOW. The closure dialog awaits this before it ends the visit. */ const flush = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        if (inFlightRef.current) await inFlightRef.current;
        return runSaveRef.current();
    }, []);
    /** The indicator is clickable when it is red — that click is this. */ const retrySave = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>flush(), [
        flush
    ]);
    // ── Clinical writes ─────────────────────────────────────────────────────
    //
    // Every one of them patches the encounter in place rather than re-reading it:
    // the mutation answers with the row it wrote, and a refetch would repaint the
    // three columns around a student who is mid-sentence.
    const patchList = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((key, fn)=>{
        setEncounter((prev)=>prev ? {
                ...prev,
                [key]: fn(prev[key] || [])
            } : prev);
    }, []);
    // The rail's DERIVED views («مشکلات فعال», «داروهای فعلی») are computed by the
    // BFF from every visit's diagnoses and prescriptions, so a dx/rx write in THIS
    // visit changes them and a patched encounter cannot know how. The record is
    // re-read after those writes — and only those: the note, orders and vitals
    // feed nothing the rail derives. Best-effort, and never on the write's own
    // promise: a rail that failed to refresh is not a diagnosis that failed to
    // save.
    const refreshRecord = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const targetCase = caseId || encounter?.caseId;
        if (!targetCase) return;
        try {
            const rec = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$a5e6f2cc85ed53f7), {
                caseId: targetCase
            });
            if (rec?.myCaseRecord) setRecord(rec.myCaseRecord);
        } catch (err) {
            console.warn('[useEncounter] record refresh failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
        }
    }, [
        caseId,
        encounter?.caseId
    ]);
    const write = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (doc, vars, apply, { derives: derives = false } = {})=>{
        const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)(doc, vars);
        apply?.(data);
        if (derives) refreshRecord();
        return data;
    }, [
        refreshRecord
    ]);
    const addDiagnosis = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((input)=>write((0, $3569e16be34bfe54$export$f085bbd107d0afdd), {
            encounterId: encounterId,
            input: input
        }, (d)=>d?.addDiagnosis && patchList('diagnoses', (rows)=>[
                    ...rows,
                    d.addDiagnosis
                ]), $9d57055d4093bdd6$var$DERIVES), [
        encounterId,
        patchList,
        write
    ]);
    const updateDiagnosis = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((diagnosisId, input)=>write((0, $3569e16be34bfe54$export$2f3cb9b0bb7c2576), {
            diagnosisId: diagnosisId,
            input: input
        }, (d)=>d?.updateDiagnosis && patchList('diagnoses', (rows)=>rows.map((r)=>r.id === diagnosisId ? d.updateDiagnosis : r)), $9d57055d4093bdd6$var$DERIVES), [
        patchList,
        write
    ]);
    const deleteDiagnosis = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((diagnosisId)=>write((0, $3569e16be34bfe54$export$457b0d2fa8db1d99), {
            diagnosisId: diagnosisId
        }, ()=>patchList('diagnoses', (rows)=>rows.filter((r)=>r.id !== diagnosisId)), $9d57055d4093bdd6$var$DERIVES), [
        patchList,
        write
    ]);
    /**
   * Drag-reorder. `sortOrder` is a column on the row, so the order is persisted
   * one row at a time — and the list is repainted optimistically first, because
   * a drag that snaps back while four mutations fly is not a drag.
   */ const reorderDiagnoses = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (ids)=>{
        patchList('diagnoses', (rows)=>ids.map((id, i)=>{
                const row = rows.find((r)=>r.id === id);
                return row ? {
                    ...row,
                    sortOrder: i
                } : null;
            }).filter(Boolean));
        for(let i = 0; i < ids.length; i += 1)// Sequential on purpose: they all touch one list on one row's student, and
        // a parallel burst is a burst the store answers out of order.
        // eslint-disable-next-line no-await-in-loop
        await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$2f3cb9b0bb7c2576), {
            diagnosisId: ids[i],
            input: {
                sortOrder: i
            }
        }).catch((err)=>console.warn('[useEncounter] reorder failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message));
    }, [
        patchList
    ]);
    const addRxItem = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((input)=>write((0, $3569e16be34bfe54$export$795964bf0efa3484), {
            encounterId: encounterId,
            input: input
        }, (d)=>d?.addRxItem && patchList('rxItems', (rows)=>[
                    ...rows,
                    d.addRxItem
                ]), $9d57055d4093bdd6$var$DERIVES), [
        encounterId,
        patchList,
        write
    ]);
    const updateRxItem = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((rxItemId, input)=>write((0, $3569e16be34bfe54$export$4f482d70b784a4d), {
            rxItemId: rxItemId,
            input: input
        }, (d)=>d?.updateRxItem && patchList('rxItems', (rows)=>rows.map((r)=>r.id === rxItemId ? d.updateRxItem : r)), $9d57055d4093bdd6$var$DERIVES), [
        patchList,
        write
    ]);
    const deleteRxItem = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((rxItemId)=>write((0, $3569e16be34bfe54$export$78947e78b9ba52d1), {
            rxItemId: rxItemId
        }, ()=>patchList('rxItems', (rows)=>rows.filter((r)=>r.id !== rxItemId)), $9d57055d4093bdd6$var$DERIVES), [
        patchList,
        write
    ]);
    const addOrder = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((input)=>write((0, $3569e16be34bfe54$export$75b67b144e49bb13), {
            encounterId: encounterId,
            input: input
        }, (d)=>d?.addOrder && patchList('orders', (rows)=>[
                    ...rows,
                    d.addOrder
                ])), [
        encounterId,
        patchList,
        write
    ]);
    const updateOrder = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((orderId, input)=>write((0, $3569e16be34bfe54$export$74d7abe26a875d97), {
            orderId: orderId,
            input: input
        }, (d)=>d?.updateOrder && patchList('orders', (rows)=>rows.map((r)=>r.id === orderId ? d.updateOrder : r))), [
        patchList,
        write
    ]);
    const recordOrderResult = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((orderId, input)=>write((0, $3569e16be34bfe54$export$24756192218c6cf2), {
            orderId: orderId,
            input: input
        }, (d)=>d?.recordOrderResult && patchList('orders', (rows)=>rows.map((r)=>r.id === orderId ? d.recordOrderResult : r))), [
        patchList,
        write
    ]);
    const cancelOrder = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((orderId)=>write((0, $3569e16be34bfe54$export$7dd95c4ac507c198), {
            orderId: orderId
        }, (d)=>d?.cancelOrder && patchList('orders', (rows)=>rows.map((r)=>r.id === orderId ? d.cancelOrder : r))), [
        patchList,
        write
    ]);
    const deleteOrder = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((orderId)=>write((0, $3569e16be34bfe54$export$1da20105f21d3384), {
            orderId: orderId
        }, ()=>patchList('orders', (rows)=>rows.filter((r)=>r.id !== orderId))), [
        patchList,
        write
    ]);
    /**
   * The rail's «ثبت» quick-add: a `vitals` history entry STAMPED with this
   * visit, so the timeline groups it under «ویزیت N» rather than «خارج از ویزیت»
   * (core.md §7.5). It writes to the case, not to the encounter — a measurement
   * survives the visit being cancelled (§5.1).
   */ const addVitals = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ({ body: body, structured: structured, label: label })=>{
        const targetCase = caseId || encounter?.caseId;
        if (!targetCase) return null;
        const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$e169d2c267301cd2), {
            caseId: targetCase,
            entries: [
                {
                    section: 'vitals',
                    label: label || '',
                    body: body || '',
                    structured: structured || null,
                    source: 'manual',
                    encounterId: encounterId
                }
            ]
        });
        const rows = data?.addCaseHistory || [];
        if (rows.length) {
            setRecord((prev)=>prev?.case ? {
                    ...prev,
                    case: {
                        ...prev.case,
                        entries: [
                            ...prev.case.entries || [],
                            ...rows
                        ]
                    }
                } : prev);
            patchList('entries', (existing)=>[
                    ...existing,
                    ...rows
                ]);
        }
        return rows;
    }, [
        caseId,
        encounter?.caseId,
        encounterId,
        patchList
    ]);
    // ── Lifecycle ───────────────────────────────────────────────────────────
    const endEncounter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (summary)=>{
        const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$3434cb1307814dfc), {
            encounterId: encounterId,
            summary: summary || null
        });
        const row = data?.endEncounter;
        if (row) setEncounter((prev)=>({
                ...prev || {},
                ...row
            }));
        if (draftKey) (0, $7cdea07122bc6887$export$eeeb486534738631)(draftKey, {
            kind: 'local'
        });
        return row;
    }, [
        encounterId,
        draftKey
    ]);
    const reopenEncounter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$7c99d14753db2165), {
            encounterId: encounterId
        });
        const row = data?.reopenEncounter;
        if (row) setEncounter((prev)=>({
                ...prev || {},
                ...row
            }));
        return row;
    }, [
        encounterId
    ]);
    const cancelEncounter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        // Whatever is in the note is about to stop existing; a draft that outlived
        // it would be replayed into the NEXT visit's editor.
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        if (draftKey) (0, $7cdea07122bc6887$export$eeeb486534738631)(draftKey, {
            kind: 'local'
        });
        return (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$c993e5ea0deb23ab), {
            encounterId: encounterId
        });
    }, [
        encounterId,
        draftKey
    ]);
    return {
        encounter: encounter,
        record: record,
        loading: loading,
        error: error,
        notFound: notFound,
        isClosed: isClosed,
        reload: reload,
        refreshRecord: refreshRecord,
        soap: soap,
        setSoapField: setSoapField,
        applySoap: applySoap,
        saveState: saveState,
        saveError: saveError,
        flush: flush,
        retrySave: retrySave,
        hasUnsaved: Object.keys($9d57055d4093bdd6$export$c5928f7a4cb0232e(savedRef.current, soap)).length > 0,
        addDiagnosis: addDiagnosis,
        updateDiagnosis: updateDiagnosis,
        deleteDiagnosis: deleteDiagnosis,
        reorderDiagnoses: reorderDiagnoses,
        addRxItem: addRxItem,
        updateRxItem: updateRxItem,
        deleteRxItem: deleteRxItem,
        addOrder: addOrder,
        updateOrder: updateOrder,
        recordOrderResult: recordOrderResult,
        cancelOrder: cancelOrder,
        deleteOrder: deleteOrder,
        addVitals: addVitals,
        endEncounter: endEncounter,
        reopenEncounter: reopenEncounter,
        cancelEncounter: cancelEncounter
    };
}
const $9d57055d4093bdd6$export$5a58bdb35b7f5bc6 = (err)=>(0, $206625c7d33bd390$export$dbfe74f291058e97)(err) === (0, $206625c7d33bd390$export$28ba0a5263dd89b0).ENCOUNTER_CLOSED;
const $9d57055d4093bdd6$export$5045041d4437a804 = (err)=>{
    const code = (0, $206625c7d33bd390$export$dbfe74f291058e97)(err);
    return !!code && (code === (0, $206625c7d33bd390$export$28ba0a5263dd89b0).ENCOUNTER_CLOSED || code === (0, $206625c7d33bd390$export$28ba0a5263dd89b0).ENCOUNTER_NOT_FOUND);
};
var $9d57055d4093bdd6$export$2e2bcd8739ae039 = $9d57055d4093bdd6$export$c6a6bec0b562dc8b;


// The four things the assistant can do inside a visit, and what each costs.
// core.md §7.5 (دستیار), §8.3.
//
//   ask                 askInEncounter             10 پارسه
//   differential        encounterDifferential      10 پارسه
//   suggestSoap         suggestEncounterSoap       10 پارسه
//   suggestOrders       suggestEncounterOrders     10 پارسه
//   checkInteractions   checkEncounterInteractions  3 پارسه
//
// ── Every one of them is a MUTATION, and that is not an accident ──────────
//
// They spend money and they write two messages into the visit's copilot thread.
// A money-spending Query would be re-issued by any refetch, any window focus and
// any cache revalidation — each time at the student's expense. Nothing in this
// hook may be called from a render path.
//
// ── The cost gate is a COURTESY; the server is the gate ───────────────────
//
// `canAfford` compares the price list against the balance the identity store
// already holds and saves a round trip that could only fail. It is deliberately
// permissive: a balance that has not loaded ALLOWS the call, because the AI
// service's own credit check is the authority and it fails OPEN when the wallet
// is unreachable (core.md §3.5). When either gate says no, the recovery is
// «شارژ پارسه» — never a retry, which cannot succeed because the balance has
// not moved.
//
// And the refusal touches nothing else: an out-of-پارسه student keeps a fully
// usable note, diagnosis list, prescription and order list (§7.5). Only the AI
// buttons change what they do.
//
// ── Results are HELD, not applied ────────────────────────────────────────
//
// Each operation parks its answer in state — the differential list, the SOAP
// draft, the order suggestions, the interaction warnings — and the screen renders
// a review surface over it. Nothing here writes a clinical row; the student's
// click does, through `useEncounter` (core.md §3.4).
//
// ── And they SURVIVE a reload, because the BFF wrote them down ───────────
//
// Every answer is also two messages on the visit's copilot thread (core.md
// §7.5, §8.3): the student's turn and the assistant's, the latter carrying the
// parsed answer as `payload`. So the tabs are hydrated from that thread on
// mount — the last `differential` message is the افتراقی tab, the last
// `soap_suggest` / `order_suggest` are the پیشنهادها tab, the `chat` turns are
// the پرسش transcript — and an answer a student paid for is still there after
// an F5. The thread is READ here, never created: it exists only once the first
// answer has been written (the BFF creates it after the AI call, not before).
//
// A mutation that lands before the hydration query answers wins: hydration
// only fills what is still empty.

var $acw62 = parcelRequire("acw62");





/**
 * The operations, their documents and their prices — one table, read twice.
 *
 * `cost` is a GETTER, not a number: it resolves through `costOf(action)` at the
 * moment it is read, so the courtesy gate and the chips follow the active
 * pricing policy once the price list has arrived, and the shipped constant
 * until then. `action` is the PARSEH_COSTS key the op is priced as.
 */ const $e155a5df79cdcdf0$var$op = (doc, action, field)=>Object.freeze({
        doc: doc,
        action: action,
        field: field,
        get cost () {
            return (0, $9449204a10cf7050$export$c932aceb7c67d0f4)(action);
        }
    });
const $e155a5df79cdcdf0$export$fa0dd8bbe26cf0e3 = Object.freeze({
    ask: $e155a5df79cdcdf0$var$op((0, $3569e16be34bfe54$export$323510239bf198b7), 'ASK', 'askInEncounter'),
    differential: $e155a5df79cdcdf0$var$op((0, $3569e16be34bfe54$export$9eae1987f1584d9), 'DIFFERENTIAL', 'encounterDifferential'),
    soap: $e155a5df79cdcdf0$var$op((0, $3569e16be34bfe54$export$1c49f8b64ec577bc), 'SOAP_SUGGEST', 'suggestEncounterSoap'),
    orders: $e155a5df79cdcdf0$var$op((0, $3569e16be34bfe54$export$29c62a1d62694b27), 'ORDER_SUGGEST', 'suggestEncounterOrders'),
    interactions: $e155a5df79cdcdf0$var$op((0, $3569e16be34bfe54$export$e0e220c6f3f5c127), 'INTERACTION', 'checkEncounterInteractions')
});
/** The messages a copilot answer carries back, oldest first. */ const $e155a5df79cdcdf0$var$messagesOf = (payload)=>payload?.thread?.messages || [];
/** The `payload` of a stored message — a JSON scalar, which some transports hand over as text. */ const $e155a5df79cdcdf0$var$payloadOf = (message)=>{
    const raw = message?.payload;
    if (raw == null) return null;
    if (typeof raw === 'string') try {
        return JSON.parse(raw);
    } catch  {
        return null;
    }
    return typeof raw === 'object' ? raw : null;
};
/** The last assistant message of one kind on a thread, or null. */ const $e155a5df79cdcdf0$var$lastAssistantOf = (messages, kind)=>{
    for(let i = messages.length - 1; i >= 0; i -= 1){
        const m = messages[i];
        if (m?.role === 'assistant' && m?.kind === kind) return m;
    }
    return null;
};
function $e155a5df79cdcdf0$export$e0e3742c60917b6c(messages = []) {
    const rows = Array.isArray(messages) ? messages : [];
    const chat = rows.filter((m)=>m?.kind === 'chat' && m?.content);
    const dx = $e155a5df79cdcdf0$var$lastAssistantOf(rows, 'differential');
    const dxPayload = $e155a5df79cdcdf0$var$payloadOf(dx);
    const differential = dx ? {
        narrative: dxPayload?.narrative ?? dx.content ?? '',
        items: dxPayload?.items || []
    } : null;
    const soap = $e155a5df79cdcdf0$var$lastAssistantOf(rows, 'soap_suggest');
    const soapPayload = $e155a5df79cdcdf0$var$payloadOf(soap);
    const soapSuggestion = soap ? {
        narrative: soapPayload?.narrative ?? soap.content ?? '',
        s: soapPayload?.soap?.s ?? null,
        o: soapPayload?.soap?.o ?? null,
        a: soapPayload?.soap?.a ?? null,
        p: soapPayload?.soap?.p ?? null
    } : null;
    const orders = $e155a5df79cdcdf0$var$lastAssistantOf(rows, 'order_suggest');
    const ordersPayload = $e155a5df79cdcdf0$var$payloadOf(orders);
    const orderSuggestion = orders ? {
        narrative: ordersPayload?.narrative ?? orders.content ?? '',
        items: ordersPayload?.items || []
    } : null;
    const ix = $e155a5df79cdcdf0$var$lastAssistantOf(rows, 'interaction');
    const ixPayload = $e155a5df79cdcdf0$var$payloadOf(ix);
    const interactions = ix && ixPayload ? {
        hasInteractions: !!ixPayload.hasInteractions,
        warnings: ixPayload.warnings || [],
        skippedDrugNames: ixPayload.skippedDrugNames || []
    } : null;
    return {
        chat: chat,
        differential: differential,
        soapSuggestion: soapSuggestion,
        orderSuggestion: orderSuggestion,
        interactions: interactions
    };
}
function $e155a5df79cdcdf0$export$c4e2711910eaee3b(encounterId, { balance: balance = null, caseId: caseId = null, onRefusal: onRefusal } = {}) {
    // Subscribes this hook's caller to the price list, so `costs` follows the policy.
    const prices = (0, $9449204a10cf7050$export$204bd72286fdb787)();
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // which op is in flight
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [needsTopUp, setNeedsTopUp] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // The visit's copilot transcript, accumulated from what each answer returns.
    // The BFF answers with ONLY the two new messages, so this appends rather than
    // re-reads — and a re-read would be a second round trip for text already here.
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [followUps, setFollowUps] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [threadId, setThreadId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [differential, setDifferential] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [soapSuggestion, setSoapSuggestion] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [orderSuggestion, setOrderSuggestion] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [interactions, setInteractions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const clearError = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setError(null);
        setNeedsTopUp(false);
    }, []);
    const refusalRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(onRefusal);
    refusalRef.current = onRefusal;
    // ── Hydration from the stored thread ────────────────────────────────────
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!encounterId || !caseId) return undefined;
        let alive = true;
        (async ()=>{
            try {
                const listed = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$cb40171597afb9c8), {
                    caseId: caseId,
                    scope: 'ENCOUNTER',
                    encounterId: encounterId
                });
                const row = (listed?.caseChatThreads || [])[0];
                if (!row || !alive) return;
                const full = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$d9466cb6388f2c86), {
                    threadId: row.id
                });
                const thread = full?.caseChatThread;
                if (!thread || !alive) return;
                const got = $e155a5df79cdcdf0$export$e0e3742c60917b6c(thread.messages || []);
                setThreadId((prev)=>prev || thread.id || null);
                setMessages((prev)=>{
                    const seen = new Set(prev.map((m)=>m.id));
                    return [
                        ...got.chat.filter((m)=>!seen.has(m.id)),
                        ...prev
                    ];
                });
                setDifferential((prev)=>prev || got.differential);
                setSoapSuggestion((prev)=>prev || got.soapSuggestion);
                setOrderSuggestion((prev)=>prev || got.orderSuggestion);
                setInteractions((prev)=>prev || got.interactions);
            } catch (err) {
                // A transcript that could not be read is an empty transcript, not a
                // broken workspace — the next answer still appends normally.
                console.warn('[useCopilot] thread hydration failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
            }
        })();
        return ()=>{
            alive = false;
        };
    }, [
        encounterId,
        caseId
    ]);
    const run = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (op, vars = {})=>{
        const spec = $e155a5df79cdcdf0$export$fa0dd8bbe26cf0e3[op];
        if (!spec || !encounterId) return null;
        setError(null);
        // The courtesy gate. Refusing here spends nothing and shows the same
        // recovery the server's refusal shows.
        if (!(0, $9ffff9692ff7166c$export$876d611be39e5cf8)(balance, spec.cost)) {
            setNeedsTopUp(true);
            refusalRef.current?.({
                reason: 'credits',
                error: null,
                op: op
            });
            return null;
        }
        setNeedsTopUp(false);
        setBusy(op);
        try {
            const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)(spec.doc, {
                encounterId: encounterId,
                ...vars
            });
            const payload = data?.[spec.field] || null;
            if (payload?.thread) {
                setThreadId(payload.thread.id || null);
                const incoming = $e155a5df79cdcdf0$var$messagesOf(payload);
                setMessages((prev)=>{
                    const seen = new Set(prev.map((m)=>m.id));
                    return [
                        ...prev,
                        ...incoming.filter((m)=>!seen.has(m.id))
                    ];
                });
            }
            // The money moved; the rail's balance must not keep saying otherwise.
            (0, $5bc9ff20f6a2b818$export$3437bf7ab4f0acaf)();
            return payload;
        } catch (err) {
            console.warn(`[useCopilot] ${op} failed:`, (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
            if ((0, $206625c7d33bd390$export$51746a26c94c297f)(err)) {
                setNeedsTopUp(true);
                refusalRef.current?.({
                    reason: 'credits',
                    error: err,
                    op: op
                });
            } else {
                setError(err);
                refusalRef.current?.({
                    reason: 'error',
                    error: err,
                    op: op
                });
            }
            return null;
        } finally{
            setBusy(null);
        }
    }, [
        encounterId,
        balance
    ]);
    /** پرسش — a free question about THIS visit. The student's turn costs nothing. */ const ask = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (question)=>{
        const text = String(question || '').trim();
        if (!text) return null;
        const payload = await run('ask', {
            question: text
        });
        setFollowUps(payload?.followUpSuggestions || []);
        return payload;
    }, [
        run
    ]);
    const runDifferential = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const payload = await run('differential');
        if (payload) setDifferential(payload);
        return payload;
    }, [
        run
    ]);
    const suggestSoap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const payload = await run('soap');
        if (payload) setSoapSuggestion(payload);
        return payload;
    }, [
        run
    ]);
    const suggestOrders = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const payload = await run('orders');
        if (payload) setOrderSuggestion(payload);
        return payload;
    }, [
        run
    ]);
    const checkInteractions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const payload = await run('interactions');
        if (payload) setInteractions(payload);
        return payload;
    }, [
        run
    ]);
    return {
        busy: busy,
        error: error,
        clearError: clearError,
        needsTopUp: needsTopUp,
        // Re-read on every render, so the chips follow the policy when it lands.
        costs: {
            ask: prices.costOf('ASK'),
            differential: prices.costOf('DIFFERENTIAL'),
            soap: prices.costOf('SOAP_SUGGEST'),
            orders: prices.costOf('ORDER_SUGGEST'),
            interactions: prices.costOf('INTERACTION')
        },
        messages: messages,
        followUps: followUps,
        threadId: threadId,
        ask: ask,
        differential: differential,
        runDifferential: runDifferential,
        soapSuggestion: soapSuggestion,
        setSoapSuggestion: setSoapSuggestion,
        suggestSoap: suggestSoap,
        orderSuggestion: orderSuggestion,
        setOrderSuggestion: setOrderSuggestion,
        suggestOrders: suggestOrders,
        interactions: interactions,
        setInteractions: setInteractions,
        checkInteractions: checkInteractions
    };
}
var $e155a5df79cdcdf0$export$2e2bcd8739ae039 = $e155a5df79cdcdf0$export$c4e2711910eaee3b;









var $acw62 = parcelRequire("acw62");



// Everything the visit workspace decides that is not a rendering decision.
//
// The desktop surface, the phone surface and the tests all read from HERE, so
// «which tabs exist», «is this ICD code shaped like one», «what does closing warn
// about» and «what does cancelling delete» have exactly one answer each.

const $0cd549c1a257ae26$export$720e0ee82d7e9d5d = [
    'note',
    'diagnoses',
    'rx',
    'orders'
];
const $0cd549c1a257ae26$export$bf57dc351ba880e4 = 'note';
const $0cd549c1a257ae26$export$1ed86baf9f2a48d3 = (id)=>$0cd549c1a257ae26$export$720e0ee82d7e9d5d.includes(id);
const $0cd549c1a257ae26$export$b5bded6c14ccd3cd = [
    'ask',
    'differential',
    'suggestions'
];
const $0cd549c1a257ae26$export$3601927ada250588 = 'ask';
const $0cd549c1a257ae26$export$ae7ee5c188587944 = [
    'record',
    ...$0cd549c1a257ae26$export$720e0ee82d7e9d5d,
    'assistant'
];
const $0cd549c1a257ae26$export$f3254cc21757d13e = [
    {
        id: 's',
        labelKey: 'visit.soap.s',
        captionKey: 'visit.soap.sCaption'
    },
    {
        id: 'o',
        labelKey: 'visit.soap.o',
        captionKey: 'visit.soap.oCaption'
    },
    {
        id: 'a',
        labelKey: 'visit.soap.a',
        captionKey: 'visit.soap.aCaption'
    },
    {
        id: 'p',
        labelKey: 'visit.soap.p',
        captionKey: 'visit.soap.pCaption'
    }
];
const $0cd549c1a257ae26$export$5e3a8cbbf363fd8f = /^[A-Za-z][0-9]{2}(\.[0-9A-Za-z]{1,4})?$/;
const $0cd549c1a257ae26$export$e34a1cd390f56f12 = (code)=>!code || $0cd549c1a257ae26$export$5e3a8cbbf363fd8f.test(String(code).trim());
const $0cd549c1a257ae26$export$7a6d6293cd85d1a5 = 2;
const $0cd549c1a257ae26$export$da40c40e2466c7b1 = 300;
const $0cd549c1a257ae26$export$7cce5de43f9da3b3 = [
    'allergies',
    'identity',
    'vitals',
    'medications',
    'problems',
    'pmh',
    'labs',
    'history'
];
const $0cd549c1a257ae26$export$acadd85eeab37cf = {
    allergies: 'allergies',
    vitals: 'vitals',
    pmh: 'pmh',
    labs: 'labs'
};
const $0cd549c1a257ae26$export$372f9544b7df828f = (record, section)=>(record?.case?.entries || []).filter((e)=>e.section === section).sort((a, b)=>Number(b.recordedAtMs || b.createdAtMs || 0) - Number(a.recordedAtMs || a.createdAtMs || 0));
const $0cd549c1a257ae26$export$26ef795cd8aadfde = (record)=>(0, $b9b56989c1caf471$export$5ff47a1a5df62032).filter((id)=>$0cd549c1a257ae26$export$372f9544b7df828f(record, id).length > 0);
const $0cd549c1a257ae26$export$ef3b5d06954d4fa1 = (record)=>$0cd549c1a257ae26$export$372f9544b7df828f(record, 'allergies').length > 0;
function $0cd549c1a257ae26$export$6988eeaa4d22f11a(startedAtMs, now = Date.now()) {
    const started = Number(startedAtMs) || 0;
    if (!started) return {
        hours: 0,
        minutes: 0
    };
    const delta = Math.max(0, now - started);
    const totalMinutes = Math.floor(delta / 60000);
    return {
        hours: Math.floor(totalMinutes / 60),
        minutes: totalMinutes % 60
    };
}
// ── Closure ──────────────────────────────────────────────────────────────
/** The first line of a paragraph, trimmed — the seed of the closing summary. */ const $0cd549c1a257ae26$var$firstLine = (text)=>String(text || '').split('\n').map((l)=>l.trim()).find(Boolean) || '';
function $0cd549c1a257ae26$export$d90665cec7f6ddde(soap) {
    return [
        $0cd549c1a257ae26$var$firstLine(soap?.a),
        $0cd549c1a257ae26$var$firstLine(soap?.p)
    ].filter(Boolean).join(" \u2014 ");
}
function $0cd549c1a257ae26$export$207553fe2bfe8271({ soap: soap, diagnoses: diagnoses = [], openSheets: openSheets = 0 } = {}) {
    const out = [];
    if (![
        's',
        'o',
        'a',
        'p'
    ].some((f)=>(soap?.[f] || '').trim())) out.push('emptyNote');
    if (!diagnoses.length) out.push('noDiagnoses');
    if (openSheets > 0) out.push('openSuggestions');
    return out;
}
function $0cd549c1a257ae26$export$8eaece050091ac72(encounter) {
    return {
        diagnoses: (encounter?.diagnoses || []).length,
        rx: (encounter?.rxItems || []).length,
        orders: (encounter?.orders || []).length
    };
}
const $0cd549c1a257ae26$export$dcb6108e83c67617 = [
    'lab',
    'imaging',
    'procedure',
    'referral',
    'other'
];
function $0cd549c1a257ae26$export$73d84d88e8711151(orders = []) {
    const groups = new Map($0cd549c1a257ae26$export$dcb6108e83c67617.map((t)=>[
            t,
            []
        ]));
    for (const o of orders){
        const key = groups.has(o.orderType) ? o.orderType : 'other';
        groups.get(key).push(o);
    }
    return [
        ...groups.entries()
    ].filter(([, rows])=>rows.length).map(([type, rows])=>({
            type: type,
            rows: rows
        }));
}
function $0cd549c1a257ae26$export$41eb02d9fe443072(catalog) {
    if (!catalog) return [];
    return [
        ...catalog.labs || [],
        ...catalog.imaging || [],
        ...catalog.procedures || []
    ].map((row)=>({
            ...row,
            orderType: row.orderType || 'other'
        }));
}
function $0cd549c1a257ae26$export$b57ad779fc085889(item) {
    return [
        item?.dose,
        item?.frequency,
        item?.duration
    ].filter(Boolean).join(" \xb7 ");
}
function $0cd549c1a257ae26$export$7c8ba3d76fd245a2(me) {
    return {
        fullName: me?.fullName || '',
        level: me?.level || '',
        university: me?.university || '',
        studentNumber: me?.studentNumber || ''
    };
}




// The two review surfaces that stand between a model's draft and the record.
//
// core.md §3.4: «Every AI product is a draft or an answer… The student confirms
// what they keep through the same mutation they would use by hand.» So neither
// of these ever writes: they render what came back, side by side with what is
// already written, and hand a CLICK back to the caller.
//
// ── Why «اعمال» is per section, with a chooser ───────────────────────────
//
// A SOAP suggestion is four independent paragraphs and a student typically wants
// one of them. One «اعمال همه» button would make the useful case (take the O,
// keep my A) impossible, and would silently overwrite prose the student wrote
// while the model was thinking. Each section therefore offers جایگزینی (replace)
// and افزودن (append), and a section the student does not act on is left exactly
// as it was.
//
// The narrative leads, always: core.md §8.5 — the JSON payload is a best-effort
// parse and may be empty, and a sheet that rendered only the payload would show
// an empty sheet for a perfectly good answer.
const $0a0c925c5d0a9515$var$Narrative = ({ text: text })=>{
    if (!text) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        style: {
            margin: '0 0 12px',
            fontSize: 13,
            lineHeight: 2,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            whiteSpace: 'pre-wrap'
        },
        children: text
    });
};
function $0a0c925c5d0a9515$export$6f99a89affa2c085({ open: open, onClose: onClose, suggestion: suggestion, current: current, onApply: onApply }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    if (!open) return null;
    const sections = (0, $0cd549c1a257ae26$export$f3254cc21757d13e).filter((s)=>(suggestion?.[s.id] || '').trim());
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        title: t('visit.soap.reviewTitle'),
        fullHeight: true,
        maxWidth: 720,
        closeLabel: t('common.actions.close'),
        "data-testid": "soap-review-sheet",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0a0c925c5d0a9515$var$Narrative, {
                text: suggestion?.narrative
            }),
            !sections.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    fontSize: 13,
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                },
                children: t('visit.soap.reviewEmpty')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10
                },
                children: sections.map((section)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                        style: {
                            padding: 12
                        },
                        "data-testid": `soap-review-${section.id}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    marginBottom: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                        variant: "default",
                                        children: section.id.toUpperCase()
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: 13,
                                            fontWeight: 700
                                        },
                                        children: t(section.labelKey)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    margin: 0,
                                    fontSize: 13,
                                    lineHeight: 2,
                                    whiteSpace: 'pre-wrap',
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                },
                                children: suggestion[section.id]
                            }),
                            (current?.[section.id] || '').trim() && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    marginTop: 8,
                                    padding: 8,
                                    borderRadius: 8,
                                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).bg,
                                    fontSize: 12,
                                    lineHeight: 1.9,
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2,
                                    whiteSpace: 'pre-wrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        style: {
                                            display: 'block',
                                            fontSize: 11,
                                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                                        },
                                        children: t('visit.soap.reviewCurrent')
                                    }),
                                    current[section.id]
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    gap: 8,
                                    marginTop: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        size: "sm",
                                        onClick: ()=>onApply(section.id, 'replace'),
                                        "data-testid": `soap-apply-replace-${section.id}`,
                                        children: t('visit.soap.applyReplace')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        size: "sm",
                                        variant: "outline",
                                        onClick: ()=>onApply(section.id, 'append'),
                                        "data-testid": `soap-apply-append-${section.id}`,
                                        children: t('visit.soap.applyAppend')
                                    })
                                ]
                            })
                        ]
                    }, section.id))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$f9f72ca4b5e00695), {})
        ]
    });
}
function $0a0c925c5d0a9515$export$79b783a89150a166({ open: open, onClose: onClose, suggestion: suggestion, onAdd: onAdd, adding: adding = false }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [picked, setPicked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const items = suggestion?.items || [];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) setPicked({});
    }, [
        open,
        suggestion
    ]);
    if (!open) return null;
    const chosen = items.filter((_, i)=>picked[i]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        title: t('visit.orders.suggestTitle'),
        fullHeight: true,
        maxWidth: 640,
        closeLabel: t('common.actions.close'),
        "data-testid": "order-suggest-sheet",
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                display: 'flex',
                gap: 8
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    onClick: ()=>onAdd(chosen),
                    disabled: !chosen.length || adding,
                    "data-testid": "order-suggest-add",
                    children: t('visit.orders.suggestAdd', {
                        count: chosen.length
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    variant: "outline",
                    onClick: onClose,
                    children: t('common.actions.cancel')
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0a0c925c5d0a9515$var$Narrative, {
                text: suggestion?.narrative
            }),
            !items.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    fontSize: 13,
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                },
                children: t('visit.orders.suggestEmpty')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8
                },
                children: items.map((item, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                        style: {
                            padding: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a6c6e1277da35de$export$2e2bcd8739ae039), {
                                checked: !!picked[i],
                                onChange: (v)=>setPicked((prev)=>({
                                            ...prev,
                                            [i]: !!v
                                        })),
                                label: item.title,
                                "data-testid": `order-suggest-item-${i}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    gap: 6,
                                    margin: '6px 0 0 26px',
                                    flexWrap: 'wrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                        variant: "outline",
                                        children: t((0, $b9b56989c1caf471$export$e98960cf8df727b5)(item.orderType))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                        variant: "outline",
                                        children: t((0, $b9b56989c1caf471$export$2c1f0bb0dcbb3932)(item.urgency))
                                    })
                                ]
                            }),
                            item.reason && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    margin: '6px 0 0',
                                    fontSize: 12,
                                    lineHeight: 1.9,
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
                                },
                                children: item.reason
                            })
                        ]
                    }, `${item.title}-${i}`))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$f9f72ca4b5e00695), {})
        ]
    });
}
var $0a0c925c5d0a9515$export$2e2bcd8739ae039 = $0a0c925c5d0a9515$export$6f99a89affa2c085;




var $acw62 = parcelRequire("acw62");








// تشخیص — what the student thinks is going on, and what the assistant offers to
// argue with.
//
// ── ICD is optional, shape-checked, and never looked up ──────────────────
//
// core.md §5.2 gives the regex and calls the column free text. This app ships no
// ICD table: a student practising is allowed to write a code that is wrong, and
// the only thing worth refusing is a value that is not a code at all («قلب»).
// The hint under the field says the shape rather than the rule.
//
// ── The differential writes NOTHING until a card is clicked ──────────────
//
// `encounterDifferential` returns a narrative plus a best-effort list. Each card
// carries «افزودن به تشخیص‌ها», and that click — not the answer arriving — is
// what creates a row, with `kind: differential` and `origin: ai` (core.md §3.4,
// §5.2). `origin` is immutable afterwards: a row that came from the model says so
// for the rest of its life, which is the whole provenance story.
const $bd368552e70ef864$var$emptyForm = {
    title: '',
    icdCode: '',
    kind: 'primary',
    status: 'active',
    note: ''
};
function $bd368552e70ef864$var$DiagnosisForm({ value: value, onChange: onChange, onSubmit: onSubmit, onCancel: onCancel, saving: saving, testId: testId }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const icdBad = !(0, $0cd549c1a257ae26$export$e34a1cd390f56f12)(value.icdCode);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        style: {
            padding: 12,
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        },
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: t('visit.dx.title'),
                required: true,
                value: value.title,
                onChange: (e)=>onChange({
                        ...value,
                        title: e.target.value
                    }),
                "data-testid": "dx-title"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        label: t('visit.dx.icd'),
                        value: value.icdCode,
                        onChange: (e)=>onChange({
                                ...value,
                                icdCode: e.target.value
                            }),
                        helperText: t('visit.dx.icdHint'),
                        error: icdBad ? t('visit.dx.icdInvalid') : '',
                        dir: "ltr",
                        "data-testid": "dx-icd"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('visit.dx.kind'),
                        value: value.kind,
                        onChange: (e)=>onChange({
                                ...value,
                                kind: e.target.value
                            }),
                        options: (0, $b9b56989c1caf471$export$dd5b9cfe88d65d53).map((k)=>({
                                value: k,
                                label: t((0, $b9b56989c1caf471$export$365e98b66e57b8f7)(k))
                            })),
                        placeholder: "",
                        "data-testid": "dx-kind"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('visit.dx.status'),
                        value: value.status,
                        onChange: (e)=>onChange({
                                ...value,
                                status: e.target.value
                            }),
                        options: (0, $b9b56989c1caf471$export$70119f85e0285d1b).map((st)=>({
                                value: st,
                                label: t((0, $b9b56989c1caf471$export$dd311579c1a5877e)(st))
                            })),
                        placeholder: "",
                        "data-testid": "dx-status"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                label: t('visit.dx.note'),
                rows: 2,
                value: value.note,
                onChange: (e)=>onChange({
                        ...value,
                        note: e.target.value
                    }),
                "data-testid": "dx-note"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        onClick: onSubmit,
                        disabled: saving || !value.title.trim() || icdBad,
                        "data-testid": "dx-submit",
                        children: t('common.actions.save')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        variant: "outline",
                        onClick: onCancel,
                        children: t('common.actions.cancel')
                    })
                ]
            })
        ]
    });
}
function $bd368552e70ef864$export$2e2bcd8739ae039({ diagnoses: diagnoses = [], readOnly: readOnly = false, onAdd: onAdd, onUpdate: onUpdate, onDelete: onDelete, onReorder: onReorder, onDifferential: onDifferential, differential: differential, differentialCost: differentialCost, differentialBusy: differentialBusy = false, onOpenDifferential: onOpenDifferential }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [adding, setAdding] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($bd368552e70ef864$var$emptyForm);
    const [editingId, setEditingId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [editForm, setEditForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($bd368552e70ef864$var$emptyForm);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const rows = [
        ...diagnoses
    ].sort((a, b)=>(a.sortOrder ?? 0) - (b.sortOrder ?? 0));
    const submitNew = async ()=>{
        setSaving(true);
        try {
            await onAdd({
                title: form.title.trim(),
                icdCode: form.icdCode.trim() || null,
                kind: form.kind,
                status: form.status,
                note: form.note || null,
                origin: 'manual'
            });
            setForm($bd368552e70ef864$var$emptyForm);
            setAdding(false);
        } finally{
            setSaving(false);
        }
    };
    const submitEdit = async ()=>{
        setSaving(true);
        try {
            await onUpdate(editingId, {
                title: editForm.title.trim(),
                icdCode: editForm.icdCode.trim() || null,
                kind: editForm.kind,
                status: editForm.status,
                note: editForm.note || null
            });
            setEditingId(null);
        } finally{
            setSaving(false);
        }
    };
    /** Move one row a place; the whole new order is persisted by the caller. */ const move = (index, delta)=>{
        const next = [
            ...rows
        ];
        const target = index + delta;
        if (target < 0 || target >= next.length) return;
        [next[index], next[target]] = [
            next[target],
            next[index]
        ];
        onReorder(next.map((r)=>r.id));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        },
        "data-testid": "diagnosis-panel",
        children: [
            !readOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        onClick: ()=>setAdding((v)=>!v),
                        "data-testid": "dx-add",
                        children: t('visit.dx.add')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        variant: "outline",
                        onClick: onDifferential,
                        disabled: differentialBusy,
                        "data-testid": "dx-differential",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true,
                                style: {
                                    marginInlineEnd: 6
                                }
                            }),
                            differentialBusy ? t('visit.dx.differentialBusy') : t('visit.dx.differential')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f5fb734a3b15afa$export$71d6ce43dc25b15f), {
                        cost: differentialCost,
                        before: true
                    }),
                    differential && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        variant: "ghost",
                        onClick: onOpenDifferential,
                        "data-testid": "dx-differential-open",
                        children: t('visit.dx.differentialLast')
                    })
                ]
            }),
            adding && !readOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bd368552e70ef864$var$DiagnosisForm, {
                value: form,
                onChange: setForm,
                onSubmit: submitNew,
                onCancel: ()=>{
                    setAdding(false);
                    setForm($bd368552e70ef864$var$emptyForm);
                },
                saving: saving,
                testId: "dx-form"
            }),
            !rows.length && !adding && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02839c5704f38745$export$2e2bcd8739ae039), {
                    size: 44,
                    strokeWidth: 1.5,
                    "aria-hidden": true
                }),
                title: t('visit.dx.empty'),
                description: t('visit.dx.emptyBody'),
                "data-testid": "dx-empty"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8
                },
                children: rows.map((row, i)=>editingId === row.id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bd368552e70ef864$var$DiagnosisForm, {
                        value: editForm,
                        onChange: setEditForm,
                        onSubmit: submitEdit,
                        onCancel: ()=>setEditingId(null),
                        saving: saving,
                        testId: `dx-edit-${row.id}`
                    }, row.id) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                        style: {
                            padding: 10
                        },
                        "data-testid": `dx-row-${row.id}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    flexWrap: 'wrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: 13.5,
                                            fontWeight: 700,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                        },
                                        children: row.title
                                    }),
                                    row.icdCode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        dir: "ltr",
                                        style: {
                                            fontSize: 12,
                                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                                            unicodeBidi: 'isolate'
                                        },
                                        children: row.icdCode
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                        variant: "outline",
                                        children: t((0, $b9b56989c1caf471$export$365e98b66e57b8f7)(row.kind))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                        variant: (0, $b9b56989c1caf471$export$7b2fa442dd79bf47)(row.status),
                                        children: t((0, $b9b56989c1caf471$export$dd311579c1a5877e)(row.status))
                                    }),
                                    row.origin === 'ai' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                        variant: "warning",
                                        "data-testid": `dx-origin-${row.id}`,
                                        children: t((0, $b9b56989c1caf471$export$e18ec6a0f5bda944)(row.origin))
                                    }),
                                    !readOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        style: {
                                            marginInlineStart: 'auto',
                                            display: 'flex',
                                            gap: 2
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                                size: 30,
                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f8899ae39ae38a1$export$2e2bcd8739ae039), {
                                                    size: 15,
                                                    "aria-hidden": true
                                                }),
                                                label: t('visit.dx.moveUp'),
                                                onClick: ()=>move(i, -1),
                                                "data-testid": `dx-up-${row.id}`
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                                size: 30,
                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4be5d9d5a360aa$export$2e2bcd8739ae039), {
                                                    size: 15,
                                                    "aria-hidden": true
                                                }),
                                                label: t('visit.dx.moveDown'),
                                                onClick: ()=>move(i, 1)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                                size: 30,
                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f9f3418dec68a42$export$2e2bcd8739ae039), {
                                                    size: 15,
                                                    "aria-hidden": true
                                                }),
                                                label: t('common.actions.edit'),
                                                onClick: ()=>{
                                                    setEditingId(row.id);
                                                    setEditForm({
                                                        title: row.title || '',
                                                        icdCode: row.icdCode || '',
                                                        kind: row.kind || 'primary',
                                                        status: row.status || 'active',
                                                        note: row.note || ''
                                                    });
                                                },
                                                "data-testid": `dx-edit-open-${row.id}`
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                                size: 30,
                                                variant: "ghost",
                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1882f1d059ea7fa7$export$2e2bcd8739ae039), {
                                                    size: 15,
                                                    "aria-hidden": true
                                                }),
                                                label: t('common.actions.delete'),
                                                onClick: ()=>onDelete(row.id),
                                                "data-testid": `dx-delete-${row.id}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            row.note && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    margin: '6px 0 0',
                                    fontSize: 12.5,
                                    lineHeight: 1.9,
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
                                },
                                children: row.note
                            })
                        ]
                    }, row.id))
            })
        ]
    });
}
const $bd368552e70ef864$export$ecd93ef57e1acc65 = (item)=>({
        title: item.condition,
        icdCode: null,
        kind: 'differential',
        status: 'active',
        note: item.reasoning || null,
        origin: 'ai'
    });
function $bd368552e70ef864$export$f1147a5b3937ec5e({ open: open, onClose: onClose, result: result, onAdd: onAdd, readOnly: readOnly }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [added, setAdded] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) setAdded({});
    }, [
        open,
        result
    ]);
    if (!open) return null;
    const items = result?.items || [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        title: t('visit.dx.differentialTitle'),
        fullHeight: true,
        maxWidth: 720,
        closeLabel: t('common.actions.close'),
        "data-testid": "differential-sheet",
        children: [
            result?.narrative && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    margin: '0 0 12px',
                    fontSize: 13,
                    lineHeight: 2,
                    whiteSpace: 'pre-wrap',
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                },
                children: result.narrative
            }),
            !items.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    fontSize: 13,
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                },
                children: t('visit.dx.differentialEmpty')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10
                },
                children: items.map((item, i)=>{
                    const likelihood = (0, $b9b56989c1caf471$export$be8e093b537b0d99)(item.likelihood);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                        style: {
                            padding: 12
                        },
                        "data-testid": `differential-card-${i}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    flexWrap: 'wrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: 13.5,
                                            fontWeight: 700
                                        },
                                        children: item.condition
                                    }),
                                    item.likelihood && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                        variant: (0, $b9b56989c1caf471$export$678645a4df4ce493)(item.likelihood),
                                        children: likelihood ? t(likelihood) : item.likelihood
                                    })
                                ]
                            }),
                            item.reasoning && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    margin: '6px 0 0',
                                    fontSize: 12.5,
                                    lineHeight: 1.9,
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
                                },
                                children: item.reasoning
                            }),
                            !!(item.discriminators || []).length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                style: {
                                    margin: '6px 0 0',
                                    fontSize: 12,
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            t('visit.dx.discriminators'),
                                            ": "
                                        ]
                                    }),
                                    item.discriminators.join(" \xb7 ")
                                ]
                            }),
                            !!(item.nextSteps || []).length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                style: {
                                    margin: '4px 0 0',
                                    fontSize: 12,
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            t('visit.dx.nextSteps'),
                                            ": "
                                        ]
                                    }),
                                    item.nextSteps.join(" \xb7 ")
                                ]
                            }),
                            !readOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "outline",
                                style: {
                                    marginTop: 10
                                },
                                disabled: !!added[i],
                                onClick: async ()=>{
                                    await onAdd(item);
                                    setAdded((p)=>({
                                            ...p,
                                            [i]: true
                                        }));
                                },
                                "data-testid": `differential-add-${i}`,
                                children: added[i] ? t('visit.dx.addedToList') : t('visit.dx.addToList')
                            })
                        ]
                    }, `${item.condition}-${i}`);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$f9f72ca4b5e00695), {})
        ]
    });
}



parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3199b50e664dbcb5$export$a2387ed3b5d536eb = {
    name: "shield-alert",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
                key: "oel41y"
            }
        ],
        [
            "path",
            {
                d: "M12 8v4",
                key: "1got3b"
            }
        ],
        [
            "path",
            {
                d: "M12 16h.01",
                key: "1drbdi"
            }
        ]
    ]
};
$3199b50e664dbcb5$export$a2387ed3b5d536eb.node;
const $3199b50e664dbcb5$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($3199b50e664dbcb5$export$a2387ed3b5d536eb);






function $38e51c47d0ea9f32$export$2e2bcd8739ae039({ open: open, onClose: onClose, result: result }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    if (!open) return null;
    // Most severe first, with anything unrecognised kept at the END rather than dropped.
    const warnings = (0, $b9b56989c1caf471$export$888cb547d3ca3da3)(result?.warnings || []);
    const skipped = result?.skippedDrugNames || [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        title: t('visit.rx.interactionTitle'),
        fullHeight: true,
        maxWidth: 720,
        closeLabel: t('common.actions.close'),
        "data-testid": "interaction-sheet",
        children: [
            !warnings.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "success",
                title: t('visit.rx.interactionNone'),
                "data-testid": "interaction-none",
                children: t('visit.rx.interactionNoneBody')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10,
                    marginTop: warnings.length ? 0 : 12
                },
                children: warnings.map((w, i)=>{
                    const sev = (0, $b9b56989c1caf471$export$6eaaad838274d902)(w.severity);
                    const type = (0, $b9b56989c1caf471$export$b10d321a5bcb675d)(w.warningType);
                    const source = (0, $b9b56989c1caf471$export$55e4700a5f346033)(w.source);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                        style: {
                            padding: 12,
                            borderColor: w.severity === 'severe' ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red : undefined
                        },
                        "data-testid": `interaction-warning-${i}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    flexWrap: 'wrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3199b50e664dbcb5$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": true,
                                        color: w.severity === 'severe' ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                        variant: (0, $b9b56989c1caf471$export$7331504ad257335c)(w.severity),
                                        children: sev ? t(sev) : w.severity
                                    }),
                                    w.warningType && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                        variant: "outline",
                                        children: type ? t(type) : w.warningType
                                    }),
                                    w.drugPair && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: 12.5,
                                            fontWeight: 700,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                        },
                                        children: w.drugPair
                                    }),
                                    w.drug && !w.drugPair && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: 12.5,
                                            fontWeight: 700,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                        },
                                        children: w.drug
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    margin: '8px 0 0',
                                    fontSize: 13,
                                    lineHeight: 2,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                    whiteSpace: 'pre-wrap'
                                },
                                children: w.description
                            }),
                            w.condition && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    margin: '4px 0 0',
                                    fontSize: 12,
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
                                },
                                children: w.condition
                            }),
                            w.source && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                style: {
                                    margin: '6px 0 0',
                                    fontSize: 11.5,
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                                },
                                children: [
                                    t('visit.rx.interactionSource'),
                                    ': ',
                                    source ? t(source) : w.source
                                ]
                            })
                        ]
                    }, `${w.description}-${i}`);
                })
            }),
            !!skipped.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "warning",
                title: t('visit.rx.skippedTitle'),
                style: {
                    marginTop: 12
                },
                "data-testid": "interaction-skipped",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            margin: 0,
                            fontSize: 12.5,
                            lineHeight: 1.9
                        },
                        children: t('visit.rx.skippedBody')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        style: {
                            margin: '6px 0 0',
                            paddingInlineStart: 18,
                            fontSize: 12.5
                        },
                        children: skipped.map((name)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: name
                            }, name))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$f9f72ca4b5e00695), {})
        ]
    });
}



parcelRequire("acw62");





// «چاپ نسخه» — a prescription that must be impossible to mistake for one.
//
// core.md §7.5 fixes three things about this sheet and every one of them is a
// safety property rather than a style choice:
//
//   1. It is WATERMARKED «نسخهٔ تمرینی — فاقد اعتبار», diagonally, across the
//      page, in print as well as on screen. A practice prescription that
//      photocopies cleanly is a prescription somebody eventually presents at a
//      pharmacy counter.
//   2. It carries the STUDENT's identity — name, level, university, student
//      number — because the person who wrote it is a student and the paper
//      should say so.
//   3. It carries NO «کد نظام پزشکی» field, not even an empty one. A blank
//      licence box is an invitation to fill it in, and the one thing this app
//      must never produce is a document that is one handwritten number away from
//      looking valid.
//
// The patient on it is `displayName` — an invented name — and never a national
// id, a phone number or a date of birth, because those columns do not exist
// anywhere in this product (§3.1).
const $9402ae4b8abaaa11$var$WATERMARK_ID = 'rx-print-watermark';
function $9402ae4b8abaaa11$export$2e2bcd8739ae039({ open: open, onClose: onClose, items: items = [], patient: patient, me: me, encounter: encounter }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const identity = (0, $0cd549c1a257ae26$export$7c8ba3d76fd245a2)(me);
    const print = ()=>{
        if (typeof window !== 'undefined' && typeof window.print === 'function') window.print();
    };
    if (!open) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
        open: open,
        onOpenChange: (v)=>{
            if (!v) onClose();
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
            size: "lg",
            "data-testid": "rx-print-dialog",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$742513523b177e3b), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
                        children: t('visit.rx.printTitle')
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    id: "rx-print-area",
                    style: {
                        position: 'relative',
                        padding: 16,
                        background: '#fff',
                        overflow: 'hidden'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            id: $9402ae4b8abaaa11$var$WATERMARK_ID,
                            "data-testid": "rx-watermark",
                            "aria-hidden": false,
                            style: {
                                position: 'absolute',
                                inset: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                pointerEvents: 'none',
                                transform: 'rotate(-24deg)',
                                fontSize: 26,
                                fontWeight: 900,
                                color: 'rgba(217, 48, 37, 0.18)',
                                letterSpacing: 1,
                                textAlign: 'center'
                            },
                            children: t('visit.rx.watermark')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                            style: {
                                borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                paddingBottom: 10,
                                marginBottom: 12
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    style: {
                                        margin: 0,
                                        fontSize: 14,
                                        fontWeight: 800,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                    },
                                    children: identity.fullName
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    style: {
                                        margin: '4px 0 0',
                                        fontSize: 12,
                                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
                                    },
                                    children: [
                                        identity.level ? t((0, $b9b56989c1caf471$export$e5cb2dff7061b6e9)(identity.level)) : '',
                                        identity.university,
                                        identity.studentNumber ? `${t('visit.rx.studentNumber')}: ${identity.studentNumber}` : ''
                                    ].filter(Boolean).join(" \xb7 ")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            style: {
                                marginBottom: 12
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    style: {
                                        margin: 0,
                                        fontSize: 13,
                                        fontWeight: 700
                                    },
                                    children: patient?.displayName || patient?.title || ''
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    style: {
                                        margin: '3px 0 0',
                                        fontSize: 12,
                                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                                    },
                                    children: [
                                        encounter?.seq ? t('visit.number', {
                                            n: formatNumber(encounter.seq)
                                        }) : '',
                                        encounter?.startedAtMs ? formatDate(Number(encounter.startedAtMs)) : ''
                                    ].filter(Boolean).join(" \xb7 ")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ol", {
                            style: {
                                margin: 0,
                                paddingInlineStart: 20,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 8
                            },
                            children: items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    style: {
                                        fontSize: 13,
                                        lineHeight: 1.9
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: item.drugName
                                        }),
                                        item.route && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: ` \u{2014} ${t((0, $b9b56989c1caf471$export$6a29d03432c2c29a)(item.route))}`
                                        }),
                                        (0, $0cd549c1a257ae26$export$b57ad779fc085889)(item) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: ` \u{2014} ${(0, $0cd549c1a257ae26$export$b57ad779fc085889)(item)}`
                                        }),
                                        item.quantity ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: ` \u{2014} ${formatNumber(item.quantity)}`
                                        }) : null,
                                        item.instructions && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                fontSize: 12,
                                                color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
                                            },
                                            children: item.instructions
                                        })
                                    ]
                                }, item.id))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                marginTop: 16,
                                fontSize: 11.5,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
                                fontWeight: 700
                            },
                            children: t('visit.rx.printFooter')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$7bbfb2d443473050), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            onClick: print,
                            "data-testid": "rx-print-confirm",
                            children: t('visit.rx.printAction')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "outline",
                            onClick: onClose,
                            children: t('common.actions.close')
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");



function $5a14173bf6293872$export$2e2bcd8739ae039({ open: open, onClose: onClose, warnings: warnings = [], defaultSummary: defaultSummary = '', onConfirm: onConfirm }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [summary, setSummary] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(defaultSummary);
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [saveError, setSaveError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) {
            setSummary(defaultSummary);
            setSaveError(null);
        }
    }, [
        open,
        defaultSummary
    ]);
    if (!open) return null;
    const confirm = async ()=>{
        setBusy(true);
        setSaveError(null);
        try {
            const result = await onConfirm(summary.trim());
            // `onConfirm` answers `{ ok: false, error }` when the FLUSH failed. The
            // dialog stays where it is; nothing was closed.
            if (result && result.ok === false) setSaveError(result.error || new Error('save failed'));
        } catch (err) {
            setSaveError(err);
        } finally{
            setBusy(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
        open: open,
        onOpenChange: (v)=>{
            if (!v && !busy) onClose();
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
            size: "md",
            "data-testid": "close-visit-dialog",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$742513523b177e3b), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
                        children: t('visit.close.title')
                    })
                }),
                !!warnings.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "warning",
                    title: t('visit.close.warningsTitle'),
                    "data-testid": "close-warnings",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                            style: {
                                margin: 0,
                                paddingInlineStart: 18,
                                fontSize: 12.5,
                                lineHeight: 1.9
                            },
                            children: warnings.map((w)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: t(`visit.close.warning.${w}`)
                                }, w))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                margin: '6px 0 0',
                                fontSize: 11.5,
                                color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                            },
                            children: t('visit.close.warningsNote')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                    label: t('visit.close.summary'),
                    helperText: t('visit.close.summaryHint'),
                    rows: 4,
                    value: summary,
                    onChange: (e)=>setSummary(e.target.value),
                    style: {
                        marginTop: 12
                    },
                    "data-testid": "close-summary"
                }),
                saveError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "error",
                    title: t('visit.close.saveFailed'),
                    "data-testid": "close-save-error",
                    children: saveError.message
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$7bbfb2d443473050), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            onClick: confirm,
                            disabled: busy,
                            "data-testid": "close-confirm",
                            children: busy ? t('visit.close.ending') : t('visit.end')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "outline",
                            onClick: onClose,
                            disabled: busy,
                            children: t('common.actions.cancel')
                        })
                    ]
                })
            ]
        })
    });
}



parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $da088b959fed01fb$export$a2387ed3b5d536eb = {
    name: "panel-right-close",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                key: "afitv7"
            }
        ],
        [
            "path",
            {
                d: "M15 3v18",
                key: "14nvp0"
            }
        ],
        [
            "path",
            {
                d: "m8 9 3 3-3 3",
                key: "12hl5m"
            }
        ]
    ]
};
$da088b959fed01fb$export$a2387ed3b5d536eb.node;
const $da088b959fed01fb$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($da088b959fed01fb$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e51093ff8dc41b35$export$a2387ed3b5d536eb = {
    name: "panel-right-open",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                key: "afitv7"
            }
        ],
        [
            "path",
            {
                d: "M15 3v18",
                key: "14nvp0"
            }
        ],
        [
            "path",
            {
                d: "m10 15-3-3 3-3",
                key: "1pgupc"
            }
        ]
    ]
};
$e51093ff8dc41b35$export$a2387ed3b5d536eb.node;
const $e51093ff8dc41b35$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($e51093ff8dc41b35$export$a2387ed3b5d536eb);






var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3365fede8cd1121a$export$a2387ed3b5d536eb = {
    name: "loader-circle",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M21 12a9 9 0 1 1-6.219-8.56",
                key: "13zald"
            }
        ]
    ],
    aliases: [
        "loader-2"
    ]
};
$3365fede8cd1121a$export$a2387ed3b5d536eb.node;
const $3365fede8cd1121a$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($3365fede8cd1121a$export$a2387ed3b5d536eb);







// The visit's own chrome: back, who, which visit, how long, whether it is saved,
// and the two things that end it.
//
// ── The clock is live, and it ticks once a minute ────────────────────────
//
// A visit's elapsed time is read in minutes; a per-second interval would repaint
// the header sixty times for every number that changes. It is derived from
// `startedAtMs` on each tick rather than counted up, so a tab that was asleep
// for an hour shows an hour rather than the seconds it was awake for.
//
// ── The autosave indicator is a control when it is red ───────────────────
//
// «ذخیره شد» and «در حال ذخیره» are status text. «ذخیره نشد» is a BUTTON: the
// next keystroke retries anyway (core.md §7.5), but a student who has stopped
// typing and can see a red word needs something to press that is not «پایان
// ویزیت».
function $1555c7c980ebe469$var$SaveIndicator({ state: state, onRetry: onRetry }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    if (state === (0, $9d57055d4093bdd6$export$ade9b241dfa4a5e7).IDLE) return null;
    if (state === (0, $9d57055d4093bdd6$export$ade9b241dfa4a5e7).ERROR) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: onRetry,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            border: 0,
            background: 'none',
            font: 'inherit',
            cursor: 'pointer',
            fontSize: 12,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red
        },
        "data-testid": "autosave-error",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f66de94054a4f331$export$2e2bcd8739ae039), {
                size: 13,
                "aria-hidden": true
            }),
            t('visit.save.failed')
        ]
    });
    const saving = state === (0, $9d57055d4093bdd6$export$ade9b241dfa4a5e7).SAVING;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            fontSize: 12,
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
        },
        "data-testid": saving ? 'autosave-saving' : 'autosave-saved',
        children: [
            saving ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3365fede8cd1121a$export$2e2bcd8739ae039), {
                size: 13,
                "aria-hidden": true
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3fbaf9031554177f$export$2e2bcd8739ae039), {
                size: 13,
                "aria-hidden": true,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
            }),
            t(saving ? 'visit.save.saving' : 'visit.save.saved')
        ]
    });
}
function $1555c7c980ebe469$export$2e2bcd8739ae039({ encounter: encounter, patient: patient, saveState: saveState, onRetrySave: onRetrySave, onBack: onBack, onEnd: onEnd, onReopen: onReopen, onCancel: onCancel, readOnly: readOnly, compact: compact = false }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [menuOpen, setMenuOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const menuAnchor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [, tick] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (readOnly) return undefined;
        const id = setInterval(()=>tick((n)=>n + 1), 60000);
        return ()=>clearInterval(id);
    }, [
        readOnly
    ]);
    const elapsed = (0, $0cd549c1a257ae26$export$6988eeaa4d22f11a)(encounter?.startedAtMs);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            flexWrap: 'wrap',
            padding: compact ? '8px 12px' : '10px 16px',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card
        },
        "data-testid": "visit-header",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                size: 36,
                variant: "ghost",
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a140ead2dcbdb51$export$2e2bcd8739ae039), {
                    size: 18,
                    "aria-hidden": true,
                    style: (0, $a278322405d51c25$export$ddb338179359cccc)
                }),
                label: t('visit.back'),
                onClick: onBack,
                "data-testid": "visit-back"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 7,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        style: {
                            fontSize: 14,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                        },
                        children: patient?.displayName || patient?.title || ''
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$480ec33bbf749db7), {
                        short: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                        variant: "outline",
                        "data-testid": "visit-seq",
                        children: t('visit.number', {
                            n: formatNumber(encounter?.seq || 0)
                        })
                    })
                ]
            }),
            readOnly ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    fontSize: 12,
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                },
                "data-testid": "visit-closed-at",
                children: t('visit.closedAt', {
                    date: encounter?.endedAtMs ? formatDate(Number(encounter.endedAtMs)) : ''
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    fontSize: 12,
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                },
                "data-testid": "visit-elapsed",
                children: t('visit.elapsed', {
                    h: formatNumber(elapsed.hours),
                    m: formatNumber(elapsed.minutes)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1555c7c980ebe469$var$SaveIndicator, {
                state: saveState,
                onRetry: onRetrySave
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                style: {
                    marginInlineStart: 'auto',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6
                },
                children: [
                    readOnly ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        onClick: onReopen,
                        "data-testid": "visit-reopen",
                        children: t('visit.reopen')
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        onClick: onEnd,
                        "data-testid": "visit-end",
                        children: t('visit.end')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        ref: menuAnchor,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                            size: 36,
                            variant: "ghost",
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24a488cfd7efdee5$export$2e2bcd8739ae039), {
                                size: 18,
                                "aria-hidden": true
                            }),
                            label: t('common.actions.more'),
                            onClick: ()=>setMenuOpen((v)=>!v),
                            "data-testid": "visit-more"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $08d1958bc1315b40$export$2e2bcd8739ae039), {
                        open: menuOpen,
                        onClose: ()=>setMenuOpen(false),
                        anchorRef: menuAnchor,
                        ariaLabel: t('common.actions.more'),
                        width: 220,
                        "data-testid": "visit-menu",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            role: "menuitem",
                            onClick: ()=>{
                                setMenuOpen(false);
                                onCancel();
                            },
                            style: {
                                display: 'block',
                                width: '100%',
                                textAlign: 'start',
                                border: 0,
                                background: 'none',
                                font: 'inherit',
                                cursor: 'pointer',
                                padding: '9px 12px',
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
                                fontSize: 13
                            },
                            "data-testid": "visit-cancel",
                            children: t('visit.cancel')
                        })
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ff4d96da330336c2$export$a2387ed3b5d536eb = {
    name: "user",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
                key: "975kel"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "7",
                r: "4",
                key: "17ys0d"
            }
        ]
    ]
};
$ff4d96da330336c2$export$a2387ed3b5d536eb.node;
const $ff4d96da330336c2$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($ff4d96da330336c2$export$a2387ed3b5d536eb);






parcelRequire("acw62");




function $1453f81a41d40a12$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, items: items = [], renderItem: renderItem, empty: empty }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    if (!open) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $62b7b2700449d456$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        title: title,
        children: [
            !items.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    fontSize: 13,
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                },
                children: empty || t('visit.rail.emptyList')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8
                },
                children: items.map((item, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                        style: {
                            padding: 10
                        },
                        children: renderItem ? renderItem(item) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                margin: 0,
                                fontSize: 13,
                                lineHeight: 1.95,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                whiteSpace: 'pre-wrap'
                            },
                            children: item.body || item.title || ''
                        })
                    }, item.id || `row-${i}`))
            })
        ]
    });
}





// پرونده — what is already known about this patient, beside what is being
// written about them now. Read-only, collapsible, in the fixed order of §7.5:
//
//   هشدار حساسیت (locked, first, only when there is one) · مشخصات · علائم حیاتی ·
//   داروهای فعلی · مشکلات فعال · سابقهٔ بیماری · آزمایش‌ها · شرح حال
//
// ── The allergy block cannot be collapsed ────────────────────────────────
//
// `RecordSection`'s `locked` exists for this and for nothing else. A safety
// notice a student can fold away is one they fold away once, on the first visit,
// and never see again — and the visit where it mattered is the one where they
// were busy.
//
// ── One editable thing, and it writes to the CASE ────────────────────────
//
// «ثبت» beside علائم حیاتی adds a `vitals` history entry STAMPED with this
// encounter (core.md §7.5). It is a history entry rather than an encounter row
// on purpose: a measurement survives the visit being cancelled (§5.1), and the
// timeline groups it under «ویزیت N» because of the stamp, not because of where
// it is stored.
// Three rows per block; «مشاهدهٔ همه» is offered whenever there is ANY row, not
// only when a fourth exists — the sheet is also where a long entry's full text
// is readable, and the rail clips those at one line each.
const $b746477db7bc6b14$var$CLIP = 3;
const $b746477db7bc6b14$var$Line = ({ children: children, muted: muted })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        style: {
            margin: '0 0 4px',
            fontSize: 12.5,
            lineHeight: 1.85,
            color: muted ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        },
        children: children
    });
/** The «ثبت» quick-add: a one-line vitals entry, nothing more. */ function $b746477db7bc6b14$var$VitalsQuickAdd({ onAdd: onAdd, disabled: disabled }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [text, setText] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    if (disabled) return null;
    if (!open) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        size: "sm",
        variant: "ghost",
        onClick: ()=>setOpen(true),
        "data-testid": "rail-vitals-add",
        children: t('visit.rail.vitalsAdd')
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        style: {
            padding: 8,
            marginTop: 6,
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                value: text,
                placeholder: t('visit.rail.vitalsPlaceholder'),
                onChange: (e)=>setText(e.target.value),
                "data-testid": "rail-vitals-input"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 6
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        disabled: saving || !text.trim(),
                        onClick: async ()=>{
                            setSaving(true);
                            try {
                                await onAdd({
                                    body: text.trim()
                                });
                                setText('');
                                setOpen(false);
                            } finally{
                                setSaving(false);
                            }
                        },
                        "data-testid": "rail-vitals-save",
                        children: t('common.actions.save')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        variant: "ghost",
                        onClick: ()=>{
                            setOpen(false);
                            setText('');
                        },
                        children: t('common.actions.cancel')
                    })
                ]
            })
        ]
    });
}
function $b746477db7bc6b14$export$2e2bcd8739ae039({ record: record, onAddVitals: onAddVitals, readOnly: readOnly = false }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [sheet, setSheet] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { title, items, renderItem }
    const caseRow = record?.case || null;
    const allergies = (0, $0cd549c1a257ae26$export$372f9544b7df828f)(record, 'allergies');
    const vitals = (0, $0cd549c1a257ae26$export$372f9544b7df828f)(record, 'vitals');
    const pmh = (0, $0cd549c1a257ae26$export$372f9544b7df828f)(record, 'pmh');
    const labs = (0, $0cd549c1a257ae26$export$372f9544b7df828f)(record, 'labs');
    const problems = record?.activeProblems || [];
    const meds = record?.currentMedications || [];
    const openSheet = (title, items, renderItem)=>setSheet({
            title: title,
            items: items,
            renderItem: renderItem
        });
    const entryText = (e)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                e.label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    style: {
                        display: 'block',
                        fontSize: 12
                    },
                    children: e.label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        fontSize: 12.5,
                        lineHeight: 1.9,
                        whiteSpace: 'pre-wrap'
                    },
                    children: e.body
                }),
                (e.recordedAtMs || e.createdAtMs) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        display: 'block',
                        fontSize: 11,
                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                        marginTop: 3
                    },
                    children: formatDate(Number(e.recordedAtMs || e.createdAtMs))
                })
            ]
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        },
        "data-testid": "visit-rail",
        children: [
            (0, $0cd549c1a257ae26$export$ef3b5d06954d4fa1)(record) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $67f84dfba78b42fa$export$2e2bcd8739ae039), {
                id: "visit-allergies",
                title: t('visit.rail.allergies'),
                icon: (0, $f66de94054a4f331$export$2e2bcd8739ae039),
                locked: true,
                danger: true,
                count: allergies.length,
                "data-testid": "rail-allergies",
                children: [
                    allergies.slice(0, $b746477db7bc6b14$var$CLIP).map((e)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b746477db7bc6b14$var$Line, {
                            children: e.body
                        }, e.id)),
                    allergies.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67f84dfba78b42fa$export$28a2392dc2b2dd58), {
                        onClick: ()=>openSheet(t('visit.rail.allergies'), allergies, entryText),
                        testId: "rail-allergies-all"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $67f84dfba78b42fa$export$2e2bcd8739ae039), {
                id: "visit-identity",
                title: t('visit.rail.identity'),
                icon: (0, $ff4d96da330336c2$export$2e2bcd8739ae039),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            flexWrap: 'wrap',
                            marginBottom: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                style: {
                                    fontSize: 13
                                },
                                children: caseRow?.displayName || caseRow?.title || ''
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$480ec33bbf749db7), {
                                short: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b746477db7bc6b14$var$Line, {
                        muted: true,
                        children: [
                            caseRow?.ageDisplay || (caseRow?.ageYears ? t('visit.rail.ageYears', {
                                n: formatNumber(caseRow.ageYears)
                            }) : ''),
                            caseRow?.sex ? t((0, $b9b56989c1caf471$export$40b76417ac36dee5)(caseRow.sex) || 'common.gender.other') : '',
                            caseRow?.bloodType || ''
                        ].filter(Boolean).join(" \xb7 ")
                    }),
                    caseRow?.chiefComplaint && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b746477db7bc6b14$var$Line, {
                        children: caseRow.chiefComplaint
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $67f84dfba78b42fa$export$2e2bcd8739ae039), {
                id: "visit-vitals",
                title: t('visit.rail.vitals'),
                icon: (0, $340d4e1a05281a91$export$2e2bcd8739ae039),
                count: vitals.length,
                action: vitals.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67f84dfba78b42fa$export$28a2392dc2b2dd58), {
                    onClick: ()=>openSheet(t('visit.rail.vitals'), vitals, entryText),
                    testId: "rail-vitals-all"
                }) : null,
                children: [
                    vitals.slice(0, $b746477db7bc6b14$var$CLIP).map((e)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b746477db7bc6b14$var$Line, {
                            children: e.body
                        }, e.id)),
                    !vitals.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b746477db7bc6b14$var$Line, {
                        muted: true,
                        children: t('visit.rail.noVitals')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b746477db7bc6b14$var$VitalsQuickAdd, {
                        onAdd: onAddVitals,
                        disabled: readOnly
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $67f84dfba78b42fa$export$2e2bcd8739ae039), {
                id: "visit-meds",
                title: t('visit.rail.medications'),
                icon: (0, $5ffe798f65d504e7$export$2e2bcd8739ae039),
                count: meds.length,
                children: [
                    meds.slice(0, $b746477db7bc6b14$var$CLIP).map((m, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($b746477db7bc6b14$var$Line, {
                            children: [
                                m.name,
                                m.detail ? ` \u{2014} ${m.detail}` : ''
                            ]
                        }, `${m.name}-${i}`)),
                    !meds.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b746477db7bc6b14$var$Line, {
                        muted: true,
                        children: t('visit.rail.noMedications')
                    }),
                    meds.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67f84dfba78b42fa$export$28a2392dc2b2dd58), {
                        onClick: ()=>openSheet(t('visit.rail.medications'), meds.map((m, i)=>({
                                    id: `${m.name}-${i}`,
                                    title: `${m.name}${m.detail ? ` \u{2014} ${m.detail}` : ''}`
                                }))),
                        testId: "rail-meds-all"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $67f84dfba78b42fa$export$2e2bcd8739ae039), {
                id: "visit-problems",
                title: t('visit.rail.problems'),
                icon: (0, $02839c5704f38745$export$2e2bcd8739ae039),
                count: problems.length,
                children: [
                    problems.slice(0, $b746477db7bc6b14$var$CLIP).map((p, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($b746477db7bc6b14$var$Line, {
                            children: [
                                p.title,
                                p.icdCode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    dir: "ltr",
                                    style: {
                                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                                        marginInlineStart: 6,
                                        unicodeBidi: 'isolate'
                                    },
                                    children: p.icdCode
                                })
                            ]
                        }, `${p.title}-${i}`)),
                    !problems.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b746477db7bc6b14$var$Line, {
                        muted: true,
                        children: t('visit.rail.noProblems')
                    }),
                    problems.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67f84dfba78b42fa$export$28a2392dc2b2dd58), {
                        onClick: ()=>openSheet(t('visit.rail.problems'), problems.map((p, i)=>({
                                    id: `${p.title}-${i}`,
                                    title: p.title
                                }))),
                        testId: "rail-problems-all"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $67f84dfba78b42fa$export$2e2bcd8739ae039), {
                id: "visit-pmh",
                title: t('visit.rail.pmh'),
                icon: (0, $53cde9011dd49799$export$2e2bcd8739ae039),
                count: pmh.length,
                defaultOpen: false,
                children: [
                    pmh.slice(0, $b746477db7bc6b14$var$CLIP).map((e)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b746477db7bc6b14$var$Line, {
                            children: e.body
                        }, e.id)),
                    !pmh.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b746477db7bc6b14$var$Line, {
                        muted: true,
                        children: t('visit.rail.noPmh')
                    }),
                    pmh.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67f84dfba78b42fa$export$28a2392dc2b2dd58), {
                        onClick: ()=>openSheet(t('visit.rail.pmh'), pmh, entryText),
                        testId: "rail-pmh-all"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $67f84dfba78b42fa$export$2e2bcd8739ae039), {
                id: "visit-labs",
                title: t('visit.rail.labs'),
                icon: (0, $241691b67a43640c$export$2e2bcd8739ae039),
                count: labs.length,
                defaultOpen: false,
                children: [
                    labs.slice(0, $b746477db7bc6b14$var$CLIP).map((e)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b746477db7bc6b14$var$Line, {
                            children: e.body
                        }, e.id)),
                    !labs.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b746477db7bc6b14$var$Line, {
                        muted: true,
                        children: t('visit.rail.noLabs')
                    }),
                    labs.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67f84dfba78b42fa$export$28a2392dc2b2dd58), {
                        onClick: ()=>openSheet(t('visit.rail.labs'), labs, entryText),
                        testId: "rail-labs-all"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $67f84dfba78b42fa$export$2e2bcd8739ae039), {
                id: "visit-history",
                title: t('visit.rail.history'),
                icon: (0, $ccc74fc270115805$export$2e2bcd8739ae039),
                defaultOpen: false,
                children: [
                    (0, $0cd549c1a257ae26$export$26ef795cd8aadfde)(record).map((section)=>{
                        const rows = (0, $0cd549c1a257ae26$export$372f9544b7df828f)(record, section);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                marginBottom: 8
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            style: {
                                                fontSize: 12,
                                                color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
                                            },
                                            children: t((0, $b9b56989c1caf471$export$b0b0940123b14a51)(section))
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                            variant: "outline",
                                            children: formatNumber(rows.length)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                marginInlineStart: 'auto'
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67f84dfba78b42fa$export$28a2392dc2b2dd58), {
                                                onClick: ()=>openSheet(t((0, $b9b56989c1caf471$export$b0b0940123b14a51)(section)), rows, entryText),
                                                testId: `rail-history-all-${section}`
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b746477db7bc6b14$var$Line, {
                                    muted: true,
                                    children: rows[0]?.body
                                })
                            ]
                        }, section);
                    }),
                    !(0, $0cd549c1a257ae26$export$26ef795cd8aadfde)(record).length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b746477db7bc6b14$var$Line, {
                        muted: true,
                        children: t('visit.rail.noHistory')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1453f81a41d40a12$export$2e2bcd8739ae039), {
                open: !!sheet,
                onClose: ()=>setSheet(null),
                title: sheet?.title,
                items: sheet?.items || [],
                renderItem: sheet?.renderItem
            })
        ]
    });
}



parcelRequire("acw62");



parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5a6e4961dcb5cc3f$export$a2387ed3b5d536eb = {
    name: "mic-off",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 19v3",
                key: "npa21l"
            }
        ],
        [
            "path",
            {
                d: "M15 9.34V5a3 3 0 0 0-5.68-1.33",
                key: "1gzdoj"
            }
        ],
        [
            "path",
            {
                d: "M16.95 16.95A7 7 0 0 1 5 12v-2",
                key: "cqa7eg"
            }
        ],
        [
            "path",
            {
                d: "M18.89 13.23A7 7 0 0 0 19 12v-2",
                key: "16hl24"
            }
        ],
        [
            "path",
            {
                d: "m2 2 20 20",
                key: "1ooewy"
            }
        ],
        [
            "path",
            {
                d: "M9 9v3a3 3 0 0 0 5.12 2.12",
                key: "r2i35w"
            }
        ]
    ]
};
$5a6e4961dcb5cc3f$export$a2387ed3b5d536eb.node;
const $5a6e4961dcb5cc3f$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($5a6e4961dcb5cc3f$export$a2387ed3b5d536eb);






// Per-field browser dictation for the SOAP note. core.md §7.5.
//
// The شرح حال screen dictates a WHOLE history and then asks the AI to file it
// into sections (`parseCaseVoice`). This is the other half of the same idea and
// deliberately simpler: the student is already in a field, they know which
// section they are speaking into, and the only useful behaviour is to APPEND the
// words to that field. No model, no cost, no parsing — `SpeechRecognition` and
// a textarea.
//
// It is a hook rather than a panel because the affordance is a small microphone
// on each of four fields, not a sheet: opening a sheet to dictate one sentence
// into «معاینه و یافته‌ها» would close the field the student is looking at.
//
// Firefox has no `SpeechRecognition` at all and no prefix for it, so `supported`
// is false there and the buttons are simply not rendered — never rendered
// disabled, which reads as "broken" rather than "not a thing your browser does".

var $acw62 = parcelRequire("acw62");
const $1d4665532856430b$var$SPEECH_LANG = 'fa-IR';
function $1d4665532856430b$export$221c1e3ee03d375b() {
    if (typeof window === 'undefined') return null;
    return window.SpeechRecognition || window.webkitSpeechRecognition || null;
}
function $1d4665532856430b$export$9f942a4e4811ebf5(onCommit) {
    const [field, setField] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // which field is listening
    const recognizerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const commitRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(onCommit);
    commitRef.current = onCommit;
    const supported = Boolean($1d4665532856430b$export$221c1e3ee03d375b());
    const stop = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        try {
            recognizerRef.current?.stop();
        } catch  {}
        recognizerRef.current = null;
        setField(null);
    }, []);
    // A recogniser left running after the workspace unmounts keeps the microphone
    // open, which the browser shows as a tab that is permanently recording.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            try {
                recognizerRef.current?.stop();
            } catch  {}
        }, []);
    const start = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((target)=>{
        const Recognition = $1d4665532856430b$export$221c1e3ee03d375b();
        if (!Recognition) return;
        stop();
        const recognizer = new Recognition();
        recognizer.lang = $1d4665532856430b$var$SPEECH_LANG;
        recognizer.continuous = true;
        // Only FINAL results are committed: an interim result is re-sent as it is
        // refined, and appending those to a textarea writes the same half-sentence
        // four times.
        recognizer.interimResults = false;
        recognizer.onresult = (event)=>{
            for(let i = event.resultIndex; i < event.results.length; i += 1){
                if (!event.results[i].isFinal) continue;
                const chunk = String(event.results[i][0]?.transcript || '').trim();
                if (chunk) commitRef.current?.(target, chunk);
            }
        };
        recognizer.onerror = ()=>setField(null);
        recognizer.onend = ()=>setField(null);
        recognizerRef.current = recognizer;
        setField(target);
        try {
            recognizer.start();
        } catch  {
            setField(null);
        }
    }, [
        stop
    ]);
    const toggle = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((target)=>{
        if (field === target) stop();
        else start(target);
    }, [
        field,
        start,
        stop
    ]);
    return {
        supported: supported,
        listening: field,
        toggle: toggle,
        stop: stop
    };
}
var $1d4665532856430b$export$2e2bcd8739ae039 = $1d4665532856430b$export$9f942a4e4811ebf5;


function $68e325a733e01d49$export$2e2bcd8739ae039({ soap: soap, onChange: onChange, readOnly: readOnly = false, onSuggest: onSuggest, suggestCost: suggestCost, suggesting: suggesting = false }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    // Dictation APPENDS. A student dictating into a field they already typed into
    // is adding a sentence, not replacing a paragraph.
    const dictation = (0, $1d4665532856430b$export$9f942a4e4811ebf5)((field, chunk)=>{
        const current = soap?.[field] || '';
        onChange(field, current ? `${current} ${chunk}` : chunk);
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        },
        "data-testid": "soap-editor",
        children: [
            !readOnly && onSuggest && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        variant: "outline",
                        onClick: onSuggest,
                        disabled: suggesting,
                        "data-testid": "soap-suggest",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true,
                                style: {
                                    marginInlineEnd: 6
                                }
                            }),
                            suggesting ? t('visit.soap.suggesting') : t('visit.soap.suggest')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f5fb734a3b15afa$export$71d6ce43dc25b15f), {
                        cost: suggestCost,
                        before: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 11.5,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                        },
                        children: t('visit.soap.suggestNote')
                    })
                ]
            }),
            (0, $0cd549c1a257ae26$export$f3254cc21757d13e).map((section)=>{
                const listening = dictation.listening === section.id;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                    style: {
                        padding: 12
                    },
                    "data-testid": `soap-field-${section.id}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'baseline',
                                gap: 8,
                                marginBottom: 6
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: 13,
                                        fontWeight: 800,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                                        width: 18,
                                        textAlign: 'center'
                                    },
                                    children: section.id.toUpperCase()
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: 13,
                                        fontWeight: 700,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                    },
                                    children: t(section.labelKey)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: 11.5,
                                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                                    },
                                    children: t(section.captionKey)
                                }),
                                !readOnly && dictation.supported && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    size: "sm",
                                    variant: listening ? 'destructive' : 'ghost',
                                    onClick: ()=>dictation.toggle(section.id),
                                    style: {
                                        marginInlineStart: 'auto'
                                    },
                                    "data-testid": `soap-dictate-${section.id}`,
                                    "aria-label": t(listening ? 'visit.soap.dictateStop' : 'visit.soap.dictate'),
                                    children: listening ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a6e4961dcb5cc3f$export$2e2bcd8739ae039), {
                                        size: 14,
                                        "aria-hidden": true
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9f4b1e9a7f47143$export$2e2bcd8739ae039), {
                                        size: 14,
                                        "aria-hidden": true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                            value: soap?.[section.id] || '',
                            onChange: (e)=>onChange(section.id, e.target.value),
                            rows: 5,
                            disabled: readOnly,
                            placeholder: readOnly ? '' : t(section.captionKey),
                            "data-testid": `soap-input-${section.id}`,
                            "aria-label": t(section.labelKey)
                        }),
                        listening && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                margin: '6px 0 0',
                                fontSize: 11.5,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
                            },
                            children: t('visit.soap.listening')
                        })
                    ]
                }, section.id);
            })
        ]
    });
}





var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d27abdf05888854f$export$a2387ed3b5d536eb = {
    name: "printer",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
                key: "143wyd"
            }
        ],
        [
            "path",
            {
                d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6",
                key: "1itne7"
            }
        ],
        [
            "rect",
            {
                x: "6",
                y: "14",
                width: "12",
                height: "8",
                rx: "1",
                key: "1ue0tg"
            }
        ]
    ]
};
$d27abdf05888854f$export$a2387ed3b5d536eb.node;
const $d27abdf05888854f$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($d27abdf05888854f$export$a2387ed3b5d536eb);









var $acw62 = parcelRequire("acw62");






function $3eca2974cba78c1e$export$2e2bcd8739ae039({ value: value, onPick: onPick, onFreeText: onFreeText, disabled: disabled }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [query, setQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(value || '');
    const [results, setResults] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [searching, setSearching] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setQuery(value || '');
    }, [
        value
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const text = query.trim();
        if (text.length < (0, $0cd549c1a257ae26$export$7a6d6293cd85d1a5)) {
            setResults([]);
            return undefined;
        }
        let alive = true;
        setSearching(true);
        const timer = setTimeout(()=>{
            (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$1e7b6b321d3c9c4), {
                query: text,
                limit: 12
            }).then((data)=>{
                if (alive) setResults(data?.searchDrugs || []);
            }).catch((err)=>{
                // A formulary that did not answer must not stop a prescription being
                // written: free text is a first-class path, not a fallback.
                console.warn('[DrugPicker] search failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
                if (alive) setResults([]);
            }).finally(()=>{
                if (alive) setSearching(false);
            });
        }, (0, $0cd549c1a257ae26$export$da40c40e2466c7b1));
        return ()=>{
            alive = false;
            clearTimeout(timer);
        };
    }, [
        query
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            position: 'relative'
        },
        "data-testid": "drug-picker",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: t('visit.rx.drug'),
                required: true,
                value: query,
                disabled: disabled,
                onChange: (e)=>{
                    setQuery(e.target.value);
                    setOpen(true);
                    onFreeText(e.target.value);
                },
                onFocus: ()=>setOpen(true),
                helperText: t('visit.rx.drugHint'),
                "data-testid": "drug-query"
            }),
            open && query.trim().length >= (0, $0cd549c1a257ae26$export$7a6d6293cd85d1a5) && (results.length > 0 || searching) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                style: {
                    position: 'absolute',
                    insetInlineStart: 0,
                    insetInlineEnd: 0,
                    top: '100%',
                    zIndex: 30,
                    maxHeight: 220,
                    overflowY: 'auto',
                    padding: 4
                },
                "data-testid": "drug-results",
                children: [
                    searching && !results.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            margin: 0,
                            padding: 8,
                            fontSize: 12,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                        },
                        children: t('visit.rx.searching')
                    }),
                    results.map((drug)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: ()=>{
                                onPick(drug);
                                setQuery(drug.name);
                                setOpen(false);
                            },
                            style: {
                                display: 'block',
                                width: '100%',
                                textAlign: 'start',
                                border: 0,
                                background: 'none',
                                font: 'inherit',
                                cursor: 'pointer',
                                padding: '7px 8px',
                                borderRadius: 8,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                fontSize: 13
                            },
                            "data-testid": `drug-option-${drug.id}`,
                            children: [
                                drug.name,
                                drug.genericName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: 11.5,
                                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                                        marginInlineStart: 6
                                    },
                                    children: drug.genericName
                                })
                            ]
                        }, drug.id))
                ]
            })
        ]
    });
}
function $3eca2974cba78c1e$export$cfad80cce46d594() {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
        variant: "warning",
        "data-testid": "free-text-chip",
        children: t('visit.rx.freeText')
    });
}


// نسخه — a practice prescription. It is printable and it is worthless, and both
// of those are on purpose (see PrintPrescription.jsx).
//
// The table is the kit's `Table`, not a `DataTable` — there is no DataTable at
// framework v0.12.4, and this list is small enough that column definitions plus
// a row action column is the whole requirement.
const $a254f78f5186e8ae$var$emptyRow = {
    drugId: null,
    drugName: '',
    dose: '',
    route: 'oral',
    frequency: '',
    duration: '',
    quantity: '',
    instructions: ''
};
function $a254f78f5186e8ae$export$2e2bcd8739ae039({ items: items = [], readOnly: readOnly = false, onAdd: onAdd, onDelete: onDelete, onCheckInteractions: onCheckInteractions, interactionCost: interactionCost, interactionBusy: interactionBusy = false, onOpenInteractions: onOpenInteractions, hasInteractionResult: hasInteractionResult = false, onPrint: onPrint }) {
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($a254f78f5186e8ae$var$emptyRow);
    const [adding, setAdding] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const rows = [
        ...items
    ].sort((a, b)=>(a.sortOrder ?? 0) - (b.sortOrder ?? 0));
    const submit = async ()=>{
        if (!form.drugName.trim()) return;
        setSaving(true);
        try {
            await onAdd({
                // NULL when the student typed a name the formulary does not carry. It is
                // what makes the row invisible to the interaction check, and what the
                // «خارج از فهرست دارویی» chip is telling them.
                drugId: form.drugId || null,
                drugName: form.drugName.trim(),
                dose: form.dose || null,
                route: form.route || null,
                frequency: form.frequency || null,
                duration: form.duration || null,
                quantity: form.quantity ? Number(form.quantity) : null,
                instructions: form.instructions || null,
                origin: 'manual'
            });
            setForm($a254f78f5186e8ae$var$emptyRow);
            setAdding(false);
        } finally{
            setSaving(false);
        }
    };
    const columns = [
        {
            key: 'drug',
            header: t('visit.rx.drug'),
            render: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    style: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 6,
                        flexWrap: 'wrap'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            style: {
                                fontWeight: 700
                            },
                            children: row.drugName
                        }),
                        !row.drugId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3eca2974cba78c1e$export$cfad80cce46d594), {}),
                        row.origin === 'ai' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "warning",
                            children: t((0, $b9b56989c1caf471$export$e18ec6a0f5bda944)(row.origin))
                        })
                    ]
                })
        },
        {
            key: 'detail',
            header: t('visit.rx.detail'),
            render: (row)=>(0, $0cd549c1a257ae26$export$b57ad779fc085889)(row) || "\u2014"
        },
        {
            key: 'route',
            header: t('visit.rx.route'),
            render: (row)=>row.route ? t((0, $b9b56989c1caf471$export$6a29d03432c2c29a)(row.route)) : "\u2014"
        },
        {
            key: 'quantity',
            header: t('visit.rx.quantity'),
            align: 'end',
            render: (row)=>row.quantity ? formatNumber(row.quantity) : "\u2014"
        },
        ...readOnly ? [] : [
            {
                key: 'actions',
                header: '',
                align: 'end',
                render: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                        size: 30,
                        variant: "ghost",
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1882f1d059ea7fa7$export$2e2bcd8739ae039), {
                            size: 15,
                            "aria-hidden": true
                        }),
                        label: t('common.actions.delete'),
                        onClick: ()=>onDelete(row.id),
                        "data-testid": `rx-delete-${row.id}`
                    })
            }
        ]
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        },
        "data-testid": "rx-panel",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    flexWrap: 'wrap'
                },
                children: [
                    !readOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        onClick: ()=>setAdding((v)=>!v),
                        "data-testid": "rx-add",
                        children: t('visit.rx.add')
                    }),
                    !readOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "outline",
                                onClick: onCheckInteractions,
                                disabled: interactionBusy || !rows.length,
                                "data-testid": "rx-check-interactions",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3199b50e664dbcb5$export$2e2bcd8739ae039), {
                                        size: 14,
                                        "aria-hidden": true,
                                        style: {
                                            marginInlineEnd: 6
                                        }
                                    }),
                                    interactionBusy ? t('visit.rx.checking') : t('visit.rx.check')
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f5fb734a3b15afa$export$71d6ce43dc25b15f), {
                                cost: interactionCost,
                                before: true
                            }),
                            hasInteractionResult && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "ghost",
                                onClick: onOpenInteractions,
                                "data-testid": "rx-interactions-open",
                                children: t('visit.rx.lastCheck')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        variant: "ghost",
                        onClick: onPrint,
                        disabled: !rows.length,
                        "data-testid": "rx-print",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d27abdf05888854f$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true,
                                style: {
                                    marginInlineEnd: 6
                                }
                            }),
                            t('visit.rx.print')
                        ]
                    })
                ]
            }),
            adding && !readOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                style: {
                    padding: 12,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10
                },
                "data-testid": "rx-form",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3eca2974cba78c1e$export$2e2bcd8739ae039), {
                        value: form.drugName,
                        onPick: (drug)=>setForm((f)=>({
                                    ...f,
                                    drugId: drug.id,
                                    drugName: drug.name
                                })),
                        onFreeText: (text)=>setForm((f)=>({
                                    ...f,
                                    drugId: null,
                                    drugName: text
                                }))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
                            gap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                label: t('visit.rx.dose'),
                                value: form.dose,
                                onChange: (e)=>setForm((f)=>({
                                            ...f,
                                            dose: e.target.value
                                        })),
                                "data-testid": "rx-dose"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                label: t('visit.rx.route'),
                                value: form.route,
                                onChange: (e)=>setForm((f)=>({
                                            ...f,
                                            route: e.target.value
                                        })),
                                options: (0, $b9b56989c1caf471$export$e730a0734bbb1219).map((r)=>({
                                        value: r,
                                        label: t((0, $b9b56989c1caf471$export$6a29d03432c2c29a)(r))
                                    })),
                                placeholder: "",
                                "data-testid": "rx-route"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                label: t('visit.rx.frequency'),
                                value: form.frequency,
                                onChange: (e)=>setForm((f)=>({
                                            ...f,
                                            frequency: e.target.value
                                        })),
                                "data-testid": "rx-frequency"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                label: t('visit.rx.duration'),
                                value: form.duration,
                                onChange: (e)=>setForm((f)=>({
                                            ...f,
                                            duration: e.target.value
                                        })),
                                "data-testid": "rx-duration"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                label: t('visit.rx.quantity'),
                                value: form.quantity,
                                inputMode: "numeric",
                                onChange: (e)=>setForm((f)=>({
                                            ...f,
                                            quantity: e.target.value.replace(/\D/g, '')
                                        })),
                                "data-testid": "rx-quantity"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                        label: t('visit.rx.instructions'),
                        rows: 2,
                        value: form.instructions,
                        onChange: (e)=>setForm((f)=>({
                                    ...f,
                                    instructions: e.target.value
                                })),
                        "data-testid": "rx-instructions"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                size: "sm",
                                onClick: submit,
                                disabled: saving || !form.drugName.trim(),
                                "data-testid": "rx-submit",
                                children: t('common.actions.save')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "outline",
                                onClick: ()=>{
                                    setAdding(false);
                                    setForm($a254f78f5186e8ae$var$emptyRow);
                                },
                                children: t('common.actions.cancel')
                            })
                        ]
                    })
                ]
            }),
            rows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                columns: columns,
                rows: rows,
                dense: true,
                ariaLabel: t('visit.tabs.rx'),
                "data-testid": "rx-table"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ffe798f65d504e7$export$2e2bcd8739ae039), {
                    size: 44,
                    strokeWidth: 1.5,
                    "aria-hidden": true
                }),
                title: t('visit.rx.empty'),
                description: t('visit.rx.emptyBody'),
                "data-testid": "rx-empty"
            }),
            rows.some((r)=>!r.drugId) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    margin: 0,
                    fontSize: 11.5,
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                },
                children: t('visit.rx.freeTextNote')
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6bb373bd7e3948d8$export$a2387ed3b5d536eb = {
    name: "ban",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "M4.929 4.929 19.07 19.071",
                key: "196cmz"
            }
        ]
    ]
};
$6bb373bd7e3948d8$export$a2387ed3b5d536eb.node;
const $6bb373bd7e3948d8$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($6bb373bd7e3948d8$export$a2387ed3b5d536eb);









// دستورات — what the student asks for, and what they then pretend came back.
//
// ── The result is entered by the student, and that is the exercise ───────
//
// There is no lab, no PACS and no interface: `recordOrderResult` writes the
// SIMULATED result the student types (core.md §5.2, `result_body` +
// `result_structured_json`). The point of the exercise is reading a result
// against the clinical picture they wrote an hour earlier — so the sheet takes
// free text first and structured rows second, never the other way round.
//
// ── «لغو» is a status, not a delete ──────────────────────────────────────
//
// `cancelOrder` sets `cancelled` and the row stays on screen. An order that was
// placed and then withdrawn is part of the reasoning; deleting it would leave a
// timeline in which it was never ordered at all.
const $e4a5dd216409b3b2$var$emptyForm = {
    orderType: 'lab',
    title: '',
    code: '',
    category: '',
    urgency: 'routine',
    notes: ''
};
/** The three lists the catalog actually carries (`OrderCatalog` in the schema). */ const $e4a5dd216409b3b2$var$CATALOG_TYPES = [
    'lab',
    'imaging',
    'procedure'
];
/** The result flags a structured lab row may carry. Letters, as a lab report prints them. */ const $e4a5dd216409b3b2$var$RESULT_FLAGS = [
    'L',
    'H',
    'N'
];
/**
 * The catalog picker: one tab per ORDER TYPE, a search box and a list.
 *
 * core.md §7.5 lists five types and the catalog holds three lists. The two the
 * catalog has nothing for — «ارجاع» and «سایر» — are still tabs here, and
 * choosing one opens the free-text form pre-set to that type: every type is one
 * click away from the same control, rather than three from here and two from a
 * dropdown on a different form.
 */ function $e4a5dd216409b3b2$var$CatalogPicker({ open: open, onClose: onClose, onPick: onPick, onFreeText: onFreeText }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [type, setType] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('lab');
    const [query, setQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [catalog, setCatalog] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || catalog) return;
        setLoading(true);
        (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$e8f901dd17836000)).then((data)=>setCatalog(data?.orderCatalog || null)).catch((err)=>{
            // The catalog is a convenience over free text, never a gate: an order
            // list that cannot be written because a lookup failed is worse than an
            // order list with a typed title.
            console.warn('[OrdersPanel] catalog failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
        }).finally(()=>setLoading(false));
    }, [
        open,
        catalog
    ]);
    if (!open) return null;
    const all = (0, $0cd549c1a257ae26$export$41eb02d9fe443072)(catalog).filter((row)=>row.orderType === type);
    const text = query.trim().toLowerCase();
    const rows = text ? all.filter((r)=>`${r.name} ${r.nameEn || ''} ${r.code || ''}`.toLowerCase().includes(text)) : all;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        title: t('visit.orders.pickTitle'),
        fullHeight: true,
        maxWidth: 640,
        closeLabel: t('common.actions.close'),
        "data-testid": "catalog-picker",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                options: (0, $b9b56989c1caf471$export$7fe249ad93dcc233).map((id)=>({
                        value: id,
                        label: t((0, $b9b56989c1caf471$export$e98960cf8df727b5)(id))
                    })),
                value: type,
                onChange: (next)=>{
                    if ($e4a5dd216409b3b2$var$CATALOG_TYPES.includes(next)) {
                        setType(next);
                        return;
                    }
                    onFreeText?.(next);
                },
                ariaLabel: t('visit.orders.type'),
                "data-testid": "catalog-types"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $318ef1f4a903d866$export$2e2bcd8739ae039), {
                value: query,
                onChange: (e)=>setQuery(e.target.value),
                placeholder: t('visit.orders.search'),
                style: {
                    margin: '10px 0'
                },
                "data-testid": "catalog-search"
            }),
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    fontSize: 12.5,
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                },
                children: t('common.labels.loading')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 4
                },
                children: [
                    rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            onClick: ()=>onPick(row),
                            style: {
                                border: 0,
                                background: 'none',
                                font: 'inherit',
                                textAlign: 'start',
                                padding: '8px 6px',
                                borderRadius: 8,
                                cursor: 'pointer',
                                fontSize: 13,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                            },
                            "data-testid": `catalog-option-${row.code || row.name}`,
                            children: [
                                row.name,
                                row.category && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: 11.5,
                                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                                        marginInlineStart: 6
                                    },
                                    children: row.category
                                })
                            ]
                        }, `${row.orderType}-${row.code || row.name}`)),
                    !rows.length && !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            fontSize: 12.5,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                        },
                        children: t('visit.orders.pickEmpty')
                    })
                ]
            })
        ]
    });
}
function $e4a5dd216409b3b2$export$58d86213e615dcf8({ open: open, onClose: onClose, order: order, onSave: onSave }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [body, setBody] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [rows, setRows] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setBody(order?.resultBody || '');
        setRows(Array.isArray(order?.resultStructured) ? order.resultStructured : []);
        setError(null);
    }, [
        open,
        order
    ]);
    if (!open) return null;
    const setRow = (i, patch)=>setRows((prev)=>prev.map((r, j)=>j === i ? {
                    ...r,
                    ...patch
                } : r));
    // Only rows with a name; an empty template row is not a result.
    const namedRows = rows.filter((r)=>(r.name || '').trim());
    const empty = !body.trim() && !namedRows.length;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        title: t('visit.orders.resultTitle'),
        fullHeight: true,
        maxWidth: 680,
        closeLabel: t('common.actions.close'),
        "data-testid": "result-sheet",
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                display: 'flex',
                gap: 8
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    disabled: saving || empty,
                    onClick: async ()=>{
                        setSaving(true);
                        setError(null);
                        try {
                            await onSave({
                                resultBody: body.trim() || null,
                                resultStructured: namedRows.length ? namedRows : null
                            });
                            onClose();
                        } catch (err) {
                            setError(err);
                        } finally{
                            setSaving(false);
                        }
                    },
                    "data-testid": "result-save",
                    children: t('visit.orders.resultSave')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    variant: "outline",
                    onClick: onClose,
                    children: t('common.actions.cancel')
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    margin: '0 0 10px',
                    fontSize: 13,
                    fontWeight: 700
                },
                children: order?.title
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "error",
                title: t((0, $206625c7d33bd390$export$660244d64183d198)(error)),
                style: {
                    marginBottom: 10
                },
                "data-testid": "result-error",
                children: error.message
            }),
            empty && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    margin: '0 0 8px',
                    fontSize: 12,
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                },
                "data-testid": "result-empty-hint",
                children: t('visit.orders.resultEmpty')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                label: t('visit.orders.resultBody'),
                rows: 4,
                value: body,
                onChange: (e)=>setBody(e.target.value),
                "data-testid": "result-body"
            }),
            order?.orderType === 'lab' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginTop: 12
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            marginBottom: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    fontSize: 12.5,
                                    fontWeight: 700
                                },
                                children: t('visit.orders.resultRows')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "ghost",
                                onClick: ()=>setRows((prev)=>[
                                            ...prev,
                                            {
                                                name: '',
                                                value: '',
                                                unit: '',
                                                ref: '',
                                                flag: ''
                                            }
                                        ]),
                                "data-testid": "result-add-row",
                                children: t('visit.orders.resultAddRow')
                            })
                        ]
                    }),
                    rows.map((row, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(110px, 1fr))',
                                gap: 8,
                                marginBottom: 8
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                    value: row.name || '',
                                    placeholder: t('visit.orders.resultName'),
                                    onChange: (e)=>setRow(i, {
                                            name: e.target.value
                                        }),
                                    "data-testid": `result-name-${i}`
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                    value: row.value || '',
                                    placeholder: t('visit.orders.resultValue'),
                                    onChange: (e)=>setRow(i, {
                                            value: e.target.value
                                        })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                    value: row.unit || '',
                                    placeholder: t('visit.orders.resultUnit'),
                                    onChange: (e)=>setRow(i, {
                                            unit: e.target.value
                                        })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                    value: row.ref || '',
                                    placeholder: t('visit.orders.resultRef'),
                                    onChange: (e)=>setRow(i, {
                                            ref: e.target.value
                                        })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                    value: row.flag || '',
                                    onChange: (e)=>setRow(i, {
                                            flag: e.target.value
                                        }),
                                    options: $e4a5dd216409b3b2$var$RESULT_FLAGS.map((f)=>({
                                            value: f,
                                            label: f
                                        })),
                                    placeholder: t('visit.orders.resultFlagNone'),
                                    "aria-label": t('visit.orders.resultFlag'),
                                    "data-testid": `result-flag-${i}`
                                })
                            ]
                        }, `row-${i}`))
                ]
            })
        ]
    });
}
function $e4a5dd216409b3b2$export$2e2bcd8739ae039({ orders: orders = [], readOnly: readOnly = false, onAdd: onAdd, onCancel: onCancel, onRecordResult: onRecordResult, onSuggest: onSuggest, suggestCost: suggestCost, suggestBusy: suggestBusy = false, onOpenSuggestions: onOpenSuggestions, hasSuggestions: hasSuggestions = false }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [adding, setAdding] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($e4a5dd216409b3b2$var$emptyForm);
    const [pickerOpen, setPickerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [resultFor, setResultFor] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const groups = (0, $0cd549c1a257ae26$export$73d84d88e8711151)(orders);
    const submit = async ()=>{
        if (!form.title.trim()) return;
        setSaving(true);
        try {
            await onAdd({
                orderType: form.orderType,
                title: form.title.trim(),
                code: form.code || null,
                category: form.category || null,
                urgency: form.urgency,
                notes: form.notes || null,
                origin: 'manual'
            });
            setForm($e4a5dd216409b3b2$var$emptyForm);
            setAdding(false);
        } finally{
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        },
        "data-testid": "orders-panel",
        children: [
            !readOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        onClick: ()=>setAdding((v)=>!v),
                        "data-testid": "order-add",
                        children: t('visit.orders.add')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        variant: "outline",
                        onClick: ()=>setPickerOpen(true),
                        "data-testid": "order-catalog",
                        children: t('visit.orders.fromCatalog')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        variant: "outline",
                        onClick: onSuggest,
                        disabled: suggestBusy,
                        "data-testid": "order-suggest",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true,
                                style: {
                                    marginInlineEnd: 6
                                }
                            }),
                            suggestBusy ? t('visit.orders.suggestBusy') : t('visit.orders.suggest')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f5fb734a3b15afa$export$71d6ce43dc25b15f), {
                        cost: suggestCost,
                        before: true
                    }),
                    hasSuggestions && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        variant: "ghost",
                        onClick: onOpenSuggestions,
                        "data-testid": "order-suggest-open",
                        children: t('visit.orders.suggestLast')
                    })
                ]
            }),
            adding && !readOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                style: {
                    padding: 12,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10
                },
                "data-testid": "order-form",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        label: t('visit.orders.title'),
                        required: true,
                        value: form.title,
                        onChange: (e)=>setForm((f)=>({
                                    ...f,
                                    title: e.target.value
                                })),
                        "data-testid": "order-title"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                            gap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                label: t('visit.orders.type'),
                                value: form.orderType,
                                onChange: (e)=>setForm((f)=>({
                                            ...f,
                                            orderType: e.target.value
                                        })),
                                options: (0, $b9b56989c1caf471$export$7fe249ad93dcc233).map((id)=>({
                                        value: id,
                                        label: t((0, $b9b56989c1caf471$export$e98960cf8df727b5)(id))
                                    })),
                                placeholder: "",
                                "data-testid": "order-type"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                label: t('visit.orders.urgency'),
                                value: form.urgency,
                                onChange: (e)=>setForm((f)=>({
                                            ...f,
                                            urgency: e.target.value
                                        })),
                                options: (0, $b9b56989c1caf471$export$c9b31a4acc93d37d).map((id)=>({
                                        value: id,
                                        label: t((0, $b9b56989c1caf471$export$2c1f0bb0dcbb3932)(id))
                                    })),
                                placeholder: "",
                                "data-testid": "order-urgency"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                        label: t('visit.orders.notes'),
                        rows: 2,
                        value: form.notes,
                        onChange: (e)=>setForm((f)=>({
                                    ...f,
                                    notes: e.target.value
                                })),
                        "data-testid": "order-notes"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                size: "sm",
                                onClick: submit,
                                disabled: saving || !form.title.trim(),
                                "data-testid": "order-submit",
                                children: t('common.actions.save')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "outline",
                                onClick: ()=>{
                                    setAdding(false);
                                    setForm($e4a5dd216409b3b2$var$emptyForm);
                                },
                                children: t('common.actions.cancel')
                            })
                        ]
                    })
                ]
            }),
            !groups.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f35c50d66e81764$export$2e2bcd8739ae039), {
                    size: 44,
                    strokeWidth: 1.5,
                    "aria-hidden": true
                }),
                title: t('visit.orders.empty'),
                description: t('visit.orders.emptyBody'),
                "data-testid": "orders-empty"
            }),
            groups.map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    "data-testid": `order-group-${group.type}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            style: {
                                margin: '0 0 6px',
                                fontSize: 12.5,
                                fontWeight: 800,
                                color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                            },
                            children: t((0, $b9b56989c1caf471$export$e98960cf8df727b5)(group.type))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 8
                            },
                            children: group.rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                    style: {
                                        padding: 10
                                    },
                                    "data-testid": `order-row-${row.id}`,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 8,
                                                flexWrap: 'wrap'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        fontSize: 13.5,
                                                        fontWeight: 700
                                                    },
                                                    children: row.title
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                    variant: (0, $b9b56989c1caf471$export$89d1c03ceda5a8b2)(row.urgency),
                                                    children: t((0, $b9b56989c1caf471$export$2c1f0bb0dcbb3932)(row.urgency))
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                    variant: (0, $b9b56989c1caf471$export$6001d400ec6ee23e)(row.status),
                                                    children: t((0, $b9b56989c1caf471$export$32e88f427c4cbbb0)(row.status))
                                                }),
                                                row.origin === 'ai' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                    variant: "warning",
                                                    "data-testid": `order-origin-${row.id}`,
                                                    children: t((0, $b9b56989c1caf471$export$e18ec6a0f5bda944)(row.origin))
                                                }),
                                                !readOnly && row.status !== 'cancelled' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    style: {
                                                        marginInlineStart: 'auto',
                                                        display: 'flex',
                                                        gap: 6
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                                            size: "sm",
                                                            variant: "outline",
                                                            onClick: ()=>setResultFor(row),
                                                            "data-testid": `order-result-${row.id}`,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $241691b67a43640c$export$2e2bcd8739ae039), {
                                                                    size: 13,
                                                                    "aria-hidden": true,
                                                                    style: {
                                                                        marginInlineEnd: 5
                                                                    }
                                                                }),
                                                                t('visit.orders.recordResult')
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                                            size: 30,
                                                            variant: "ghost",
                                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bb373bd7e3948d8$export$2e2bcd8739ae039), {
                                                                size: 15,
                                                                "aria-hidden": true
                                                            }),
                                                            label: t('visit.orders.cancelOrder'),
                                                            onClick: ()=>onCancel(row.id),
                                                            "data-testid": `order-cancel-${row.id}`
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        row.notes && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            style: {
                                                margin: '6px 0 0',
                                                fontSize: 12.5,
                                                color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
                                            },
                                            children: row.notes
                                        }),
                                        row.resultBody && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            style: {
                                                margin: '8px 0 0',
                                                padding: 8,
                                                borderRadius: 8,
                                                background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).bg,
                                                fontSize: 12.5,
                                                lineHeight: 1.9,
                                                whiteSpace: 'pre-wrap',
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                            },
                                            children: row.resultBody
                                        })
                                    ]
                                }, row.id))
                        })
                    ]
                }, group.type)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e4a5dd216409b3b2$var$CatalogPicker, {
                open: pickerOpen,
                onClose: ()=>setPickerOpen(false),
                onPick: (row)=>{
                    setForm({
                        orderType: row.orderType || 'lab',
                        title: row.name,
                        code: row.code || '',
                        category: row.category || '',
                        urgency: 'routine',
                        notes: ''
                    });
                    setPickerOpen(false);
                    setAdding(true);
                },
                onFreeText: (orderType)=>{
                    // «ارجاع» / «سایر»: no list to pick from — the form, pre-set to the type.
                    setForm({
                        ...$e4a5dd216409b3b2$var$emptyForm,
                        orderType: orderType
                    });
                    setPickerOpen(false);
                    setAdding(true);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e4a5dd216409b3b2$export$58d86213e615dcf8, {
                open: !!resultFor,
                order: resultFor,
                onClose: ()=>setResultFor(null),
                onSave: (input)=>onRecordResult(resultFor.id, input)
            })
        ]
    });
}



function $313d123764a40617$export$ece5c95f6df5cb60({ value: value, onChange: onChange }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
        options: (0, $0cd549c1a257ae26$export$720e0ee82d7e9d5d).map((id)=>({
                value: id,
                label: t(`visit.tabs.${id}`)
            })),
        value: value,
        onChange: onChange,
        ariaLabel: t('visit.tabs.aria'),
        "data-testid": "work-tabs"
    });
}
function $313d123764a40617$export$2e2bcd8739ae039({ vm: vm, tab: tab }) {
    const { encounter: encounter, copilot: copilot, readOnly: readOnly } = vm;
    if (tab === 'note') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68e325a733e01d49$export$2e2bcd8739ae039), {
        soap: vm.soap,
        onChange: vm.setSoapField,
        readOnly: readOnly,
        onSuggest: vm.requestSoapSuggestion,
        suggestCost: copilot.costs.soap,
        suggesting: copilot.busy === 'soap'
    });
    if (tab === 'diagnoses') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd368552e70ef864$export$2e2bcd8739ae039), {
        diagnoses: encounter?.diagnoses || [],
        readOnly: readOnly,
        onAdd: vm.addDiagnosis,
        onUpdate: vm.updateDiagnosis,
        onDelete: vm.deleteDiagnosis,
        onReorder: vm.reorderDiagnoses,
        onDifferential: vm.requestDifferential,
        differential: copilot.differential,
        differentialCost: copilot.costs.differential,
        differentialBusy: copilot.busy === 'differential',
        onOpenDifferential: ()=>vm.openSheet('differential')
    });
    if (tab === 'rx') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a254f78f5186e8ae$export$2e2bcd8739ae039), {
        items: encounter?.rxItems || [],
        readOnly: readOnly,
        onAdd: vm.addRxItem,
        onDelete: vm.deleteRxItem,
        onCheckInteractions: vm.requestInteractions,
        interactionCost: copilot.costs.interactions,
        interactionBusy: copilot.busy === 'interactions',
        hasInteractionResult: !!copilot.interactions,
        onOpenInteractions: ()=>vm.openSheet('interactions'),
        onPrint: ()=>vm.openSheet('print')
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4a5dd216409b3b2$export$2e2bcd8739ae039), {
        orders: encounter?.orders || [],
        readOnly: readOnly,
        onAdd: vm.addOrder,
        onCancel: vm.cancelOrder,
        onRecordResult: vm.recordOrderResult,
        onSuggest: vm.requestOrderSuggestions,
        suggestCost: copilot.costs.orders,
        suggestBusy: copilot.busy === 'orders',
        hasSuggestions: !!copilot.orderSuggestion,
        onOpenSuggestions: ()=>vm.openSheet('orderSuggest')
    });
}



parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");







// The copilot's «پرسش» tab: a chat, 360 pixels wide, beside a note being typed.
//
// ── Why this is not the chat page's component ────────────────────────────
//
// core.md §7.5 says the copilot uses «the same rendering component as the chat
// page (§9) in `dense` mode». That page is being built in parallel by another
// author, in `src/components/chat/`, and it is a full ChatGPT-parity surface:
// a thread sidebar, day dividers, markdown with tables, progressive reveal, an
// «older messages» pager. Importing a half-written module across an ownership
// boundary would couple two agents' work in the worst possible place — the one
// screen where an exception unmounts a note the student is typing.
//
// So this is a deliberately SMALLER surface with the same contract: bubbles in
// student/assistant roles, follow-up chips, a cost chip on the composer, and
// `AiAnswerNote` under every answer. When the chat page lands, `dense` mode
// there can replace this file with no change to the copilot's props — that is
// why nothing in it knows about a thread list or a route.
//
// Plain text, not markdown: an answer rendered into a 360px rail wants the
// paragraph, and the markdown renderer belongs to the chat page's author.
const $d2df49bb0affc11c$var$Bubble = ({ message: message })=>{
    const isStudent = message.role === 'student';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            alignSelf: isStudent ? 'flex-end' : 'flex-start',
            maxWidth: '92%',
            background: isStudent ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.08) : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            border: `1px solid ${isStudent ? 'transparent' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 12,
            padding: '8px 10px'
        },
        "data-testid": `copilot-bubble-${message.role}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    margin: 0,
                    fontSize: 12.5,
                    lineHeight: 1.95,
                    whiteSpace: 'pre-wrap',
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                },
                children: message.content
            }),
            !isStudent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$f9f72ca4b5e00695), {})
        ]
    });
};
function $d2df49bb0affc11c$export$2e2bcd8739ae039({ messages: messages = [], followUps: followUps = [], onSend: onSend, busy: busy = false, cost: cost, disabled: disabled = false, disabledReason: disabledReason }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [text, setText] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const boxRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const send = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const question = text.trim();
        if (!question || busy || disabled) return;
        setText('');
        await onSend(question);
    }, [
        text,
        busy,
        disabled,
        onSend
    ]);
    // Ctrl+Enter sends — registered in the ONE registry, so the `?` overlay can
    // list it and so no per-screen window listener exists to leak (core.md §7.0).
    //
    // SCOPED TO THE COMPOSER: the binding stays registered (so the overlay lists
    // it) but only acts while the caret is in this textarea. Without the check a
    // Ctrl+Enter pressed in the SOAP note — a habit from every other editor — would
    // send whatever question happened to be sitting in the composer.
    const composerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, $0277e73c10ea225a$export$b0ebbe7904d8d94a)('ctrl+enter', (e)=>{
        const box = composerRef.current;
        if (!box) return;
        const target = e?.target || document.activeElement;
        if (!box.contains(target)) return;
        send();
    }, {
        label: t('visit.shortcuts.send'),
        group: t('visit.shortcuts.group'),
        firesInInput: true
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        // Newest at the bottom, as every chat is.
        if (boxRef.current) boxRef.current.scrollTop = boxRef.current.scrollHeight;
    }, [
        messages.length,
        busy
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            minHeight: 0,
            flex: 1
        },
        "data-testid": "copilot-chat",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$3c69499d0e994d3f), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ref: boxRef,
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8,
                    paddingBottom: 4
                },
                children: [
                    !messages.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            fontSize: 12.5,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                            lineHeight: 1.9
                        },
                        children: t('visit.copilot.askEmpty')
                    }),
                    messages.map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d2df49bb0affc11c$var$Bubble, {
                            message: m
                        }, m.id)),
                    busy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        style: {
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 6,
                            fontSize: 12,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                size: 14
                            }),
                            t('visit.copilot.thinking')
                        ]
                    })
                ]
            }),
            !!followUps.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    gap: 6,
                    flexWrap: 'wrap'
                },
                children: followUps.map((q)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                        variant: "outline",
                        role: "button",
                        tabIndex: 0,
                        onClick: ()=>setText(q),
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter') setText(q);
                        },
                        style: {
                            cursor: 'pointer'
                        },
                        "data-testid": "copilot-followup",
                        children: q
                    }, q))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                        ref: composerRef,
                        value: text,
                        onChange: (e)=>setText(e.target.value),
                        rows: 2,
                        disabled: disabled,
                        placeholder: disabled ? disabledReason : t('visit.copilot.placeholder'),
                        "data-testid": "copilot-input",
                        "aria-label": t('visit.copilot.placeholder')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                size: "sm",
                                onClick: send,
                                disabled: busy || disabled || !text.trim(),
                                "data-testid": "copilot-send",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c49d7be4abd1b80$export$2e2bcd8739ae039), {
                                        size: 14,
                                        "aria-hidden": true,
                                        style: {
                                            ...(0, $a278322405d51c25$export$ddb338179359cccc),
                                            marginInlineEnd: 6
                                        }
                                    }),
                                    t('visit.copilot.send')
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f5fb734a3b15afa$export$71d6ce43dc25b15f), {
                                cost: cost,
                                before: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
}





function $ce46635fcf3d414e$export$2e2bcd8739ae039({ vm: vm, tab: tab, onTab: onTab }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const { copilot: copilot } = vm;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            minHeight: 0,
            flex: 1
        },
        "data-testid": "copilot-panel",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                options: (0, $0cd549c1a257ae26$export$b5bded6c14ccd3cd).map((id)=>({
                        value: id,
                        label: t(`visit.copilot.${id}`)
                    })),
                value: tab,
                onChange: onTab,
                size: "sm",
                ariaLabel: t('visit.copilot.aria'),
                "data-testid": "copilot-tabs"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f5fb734a3b15afa$export$8866dd39911dad54), {
                balance: vm.balance
            }),
            copilot.needsTopUp && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f5fb734a3b15afa$export$2be18118ce24b5e), {
                onTopUp: vm.goToCredits
            }),
            copilot.error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "error",
                title: t('errors.generic'),
                "data-testid": "copilot-error",
                children: copilot.error.message
            }),
            tab === 'ask' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2df49bb0affc11c$export$2e2bcd8739ae039), {
                messages: copilot.messages,
                followUps: copilot.followUps,
                onSend: vm.askCopilot,
                busy: copilot.busy === 'ask',
                cost: copilot.costs.ask,
                disabled: vm.offline,
                disabledReason: t('visit.copilot.offline')
            }),
            tab === 'differential' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10,
                    overflowY: 'auto'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "outline",
                                onClick: vm.requestDifferential,
                                disabled: copilot.busy === 'differential',
                                "data-testid": "copilot-differential-run",
                                children: copilot.differential ? t('visit.copilot.refresh') : t('visit.dx.differential')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f5fb734a3b15afa$export$71d6ce43dc25b15f), {
                                cost: copilot.costs.differential,
                                before: true
                            })
                        ]
                    }),
                    !copilot.differential && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            fontSize: 12.5,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                            lineHeight: 1.9
                        },
                        children: t('visit.copilot.differentialEmpty')
                    }),
                    copilot.differential && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                        style: {
                            padding: 10
                        },
                        "data-testid": "copilot-differential-last",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    margin: 0,
                                    fontSize: 12.5,
                                    lineHeight: 1.95,
                                    whiteSpace: 'pre-wrap',
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                },
                                children: copilot.differential.narrative
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "ghost",
                                style: {
                                    marginTop: 8
                                },
                                onClick: ()=>vm.openSheet('differential'),
                                "data-testid": "copilot-differential-open",
                                children: t('visit.copilot.openCards')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$f9f72ca4b5e00695), {})
                        ]
                    })
                ]
            }),
            tab === 'suggestions' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10,
                    overflowY: 'auto'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                        style: {
                            padding: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                style: {
                                    fontSize: 12.5
                                },
                                children: t('visit.copilot.soapSuggestion')
                            }),
                            copilot.soapSuggestion ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "ghost",
                                onClick: ()=>vm.openSheet('soapReview'),
                                "data-testid": "copilot-soap-open",
                                children: t('visit.copilot.reopen')
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    margin: '6px 0 0',
                                    fontSize: 12,
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                                },
                                children: t('visit.copilot.suggestionsEmpty')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                        style: {
                            padding: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                style: {
                                    fontSize: 12.5
                                },
                                children: t('visit.copilot.orderSuggestion')
                            }),
                            copilot.orderSuggestion ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "ghost",
                                onClick: ()=>vm.openSheet('orderSuggest'),
                                "data-testid": "copilot-orders-open",
                                children: t('visit.copilot.reopen')
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    margin: '6px 0 0',
                                    fontSize: 12,
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                                },
                                children: t('visit.copilot.suggestionsEmpty')
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


// The desktop workspace. Three columns at ≥1280px, start → end in RTL:
//
//   پرونده 300px (collapsible to a 40px strip, remembered in
//   `localStorage.visit_rail_v1`) · کار flex · دستیار 360px (collapsible)
//
// Between 769 and 1279px the copilot becomes a right-edge `Drawer` rather than a
// third column — core.md §7.5, and the reason is arithmetic: at 1100px three
// columns leave the note about 340px wide, which is a phone's column with a
// desktop's line height.
//
// ── The rail collapses to a STRIP, not to nothing ────────────────────────
//
// 40px of vertical label, still clickable. A rail that vanishes is a rail whose
// re-opening control the student has to hunt for in a header they are not
// looking at, and «where did the allergies go» is not a question a clinical
// screen should ever raise.
const $9ef55795e996d715$var$RAIL_WIDTH = 300;
const $9ef55795e996d715$var$COPILOT_WIDTH = 360;
const $9ef55795e996d715$var$STRIP_WIDTH = 40;
function $9ef55795e996d715$export$2e2bcd8739ae039({ vm: vm }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const showCopilotColumn = !vm.isNarrowDesktop && vm.copilotOpen;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            minHeight: 0
        },
        "data-testid": "visit-web",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1555c7c980ebe469$export$2e2bcd8739ae039), {
                encounter: vm.encounter,
                patient: vm.patient,
                saveState: vm.saveState,
                onRetrySave: vm.retrySave,
                onBack: vm.onBack,
                onEnd: vm.onEnd,
                onReopen: vm.onReopen,
                onCancel: vm.onCancel,
                readOnly: vm.readOnly
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    flex: 1,
                    minHeight: 0,
                    gap: 12,
                    padding: 12
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("aside", {
                        style: {
                            width: vm.railCollapsed ? $9ef55795e996d715$var$STRIP_WIDTH : $9ef55795e996d715$var$RAIL_WIDTH,
                            flexShrink: 0,
                            overflowY: 'auto',
                            transition: 'width .15s'
                        },
                        "data-testid": "visit-rail-column",
                        "data-collapsed": vm.railCollapsed ? 'true' : 'false',
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    marginBottom: 6
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                    size: 32,
                                    variant: "ghost",
                                    icon: vm.railCollapsed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e51093ff8dc41b35$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": true
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da088b959fed01fb$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": true
                                    }),
                                    label: t(vm.railCollapsed ? 'visit.rail.expand' : 'visit.rail.collapse'),
                                    onClick: vm.toggleRail,
                                    "data-testid": "visit-rail-toggle"
                                })
                            }),
                            vm.railCollapsed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: vm.toggleRail,
                                style: {
                                    writingMode: 'vertical-rl',
                                    border: 0,
                                    background: 'none',
                                    font: 'inherit',
                                    cursor: 'pointer',
                                    fontSize: 12,
                                    fontWeight: 700,
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                                    padding: '8px 0'
                                },
                                "data-testid": "visit-rail-strip",
                                children: t('visit.rail.title')
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b746477db7bc6b14$export$2e2bcd8739ae039), {
                                record: vm.record,
                                onAddVitals: vm.addVitals,
                                readOnly: vm.readOnly
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                        style: {
                            flex: 1,
                            minWidth: 0,
                            minHeight: 0,
                            overflowY: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 12
                        },
                        "data-testid": "visit-work-column",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $313d123764a40617$export$ece5c95f6df5cb60), {
                                        value: vm.workTab,
                                        onChange: vm.setWorkTab
                                    }),
                                    vm.isNarrowDesktop && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                        size: 32,
                                        variant: "ghost",
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                            size: 16,
                                            "aria-hidden": true
                                        }),
                                        label: t('visit.copilot.open'),
                                        onClick: ()=>vm.setCopilotOpen(true),
                                        style: {
                                            marginInlineStart: 'auto'
                                        },
                                        "data-testid": "visit-copilot-open"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $313d123764a40617$export$2e2bcd8739ae039), {
                                vm: vm,
                                tab: vm.workTab
                            })
                        ]
                    }),
                    showCopilotColumn && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("aside", {
                        style: {
                            width: $9ef55795e996d715$var$COPILOT_WIDTH,
                            flexShrink: 0,
                            minHeight: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            borderInlineStart: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                            paddingInlineStart: 12
                        },
                        "data-testid": "visit-copilot-column",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    marginBottom: 6
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                    size: 32,
                                    variant: "ghost",
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da088b959fed01fb$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": true
                                    }),
                                    label: t('visit.copilot.collapse'),
                                    onClick: ()=>vm.setCopilotOpen(false),
                                    "data-testid": "visit-copilot-collapse"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce46635fcf3d414e$export$2e2bcd8739ae039), {
                                vm: vm,
                                tab: vm.copilotTab,
                                onTab: vm.setCopilotTab
                            })
                        ]
                    }),
                    !vm.isNarrowDesktop && !vm.copilotOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                        size: 36,
                        variant: "outline",
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                            size: 16,
                            "aria-hidden": true
                        }),
                        label: t('visit.copilot.open'),
                        onClick: ()=>vm.setCopilotOpen(true),
                        "data-testid": "visit-copilot-reopen"
                    })
                ]
            }),
            vm.isNarrowDesktop && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49383ac93d397699$export$2e2bcd8739ae039), {
                open: vm.copilotOpen,
                onClose: ()=>vm.setCopilotOpen(false),
                width: $9ef55795e996d715$var$COPILOT_WIDTH,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        padding: 12,
                        minHeight: 0
                    },
                    "data-testid": "visit-copilot-drawer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce46635fcf3d414e$export$2e2bcd8739ae039), {
                        vm: vm,
                        tab: vm.copilotTab,
                        onTab: vm.setCopilotTab
                    })
                })
            })
        ]
    });
}



parcelRequire("acw62");







function $733b563b5e3db94b$export$2e2bcd8739ae039({ vm: vm }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const segment = vm.mobileSegment;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            minHeight: 0
        },
        "data-testid": "visit-mobile",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1555c7c980ebe469$export$2e2bcd8739ae039), {
                encounter: vm.encounter,
                patient: vm.patient,
                saveState: vm.saveState,
                onRetrySave: vm.retrySave,
                onBack: vm.onBack,
                onEnd: vm.onEnd,
                onReopen: vm.onReopen,
                onCancel: vm.onCancel,
                readOnly: vm.readOnly,
                compact: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: '8px 10px 0',
                    overflowX: 'auto'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                    options: (0, $0cd549c1a257ae26$export$ae7ee5c188587944).map((id)=>({
                            value: id,
                            label: t(id === 'record' ? 'visit.rail.title' : id === 'assistant' ? 'visit.copilot.title' : `visit.tabs.${id}`)
                        })),
                    value: segment,
                    onChange: vm.setMobileSegment,
                    size: "sm",
                    ariaLabel: t('visit.tabs.aria'),
                    "data-testid": "visit-mobile-segments"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    padding: 10,
                    display: 'flex',
                    flexDirection: 'column'
                },
                "data-testid": "visit-mobile-body",
                children: [
                    segment === 'record' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b746477db7bc6b14$export$2e2bcd8739ae039), {
                        record: vm.record,
                        onAddVitals: vm.addVitals,
                        readOnly: vm.readOnly
                    }),
                    segment === 'assistant' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce46635fcf3d414e$export$2e2bcd8739ae039), {
                        vm: vm,
                        tab: vm.copilotTab,
                        onTab: vm.setCopilotTab
                    }),
                    segment !== 'record' && segment !== 'assistant' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $313d123764a40617$export$2e2bcd8739ae039), {
                        vm: vm,
                        tab: segment
                    })
                ]
            })
        ]
    });
}



// The visit workspace — `/patients/:caseId/visit/:encounterId`, core.md §7.5.
//
// This file is the WHOLE of the screen's behaviour and none of its layout. The
// two surfaces below it (`Visit.web.jsx`, `Visit.mobile.jsx`) receive one `vm`
// object and render it; every piece of state, every mutation, every sheet and
// every keyboard binding lives here.
//
// That split is not tidiness. Three of this screen's rules are cross-cutting and
// cannot live inside a tab:
//
//   • The closure dialog warns about «pending AI review sheets open», so the
//     sheets' open state has to be visible from the header.
//   • `Ctrl+1..4` switches work tabs and `Ctrl+S` force-saves; both must work
//     from anywhere on the screen, including from inside the copilot composer.
//   • The autosave has to be FLUSHED before `endEncounter`, which is a header
//     action operating on a hook the note tab renders.
//
// ── The shortcuts go through the registry, never through `window` ────────
//
// `src/lib/shortcuts.js` is the one keydown listener in the app, and it is what
// the `?` overlay enumerates. A per-screen `window.addEventListener('keydown')`
// would be invisible to that overlay and would survive one render too many on
// every route change — which is how two screens end up fighting over `Esc`.
const $35a05642ffb904d6$var$RAIL_COLLAPSED_KEY = 'collapsed';
const $35a05642ffb904d6$var$RAIL_WIDTH = 300;
const $35a05642ffb904d6$var$COPILOT_WIDTH = 360;
// The keys `useEncounter` toasts by name. Everything it says is a visit toast
// except the closed-visit refusal, which is the app-wide error copy (§14).
const $35a05642ffb904d6$var$HOOK_TOAST_KEYS = {
    encounterClosed: 'errors.encounterClosed'
};
const $35a05642ffb904d6$var$hookToastKey = (key)=>$35a05642ffb904d6$var$HOOK_TOAST_KEYS[key] || `visit.toast.${key}`;
/** The loading state: the three regions as skeletons on a desktop, stacked on a phone (§7.5). */ function $35a05642ffb904d6$var$VisitSkeleton({ mobile: mobile, columns: columns }) {
    const column = (n)=>Array.from({
            length: n
        }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {}, i));
    if (mobile) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            padding: 12
        },
        "data-testid": "visit-loading",
        "data-layout": "mobile",
        children: column(3)
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            gap: 12,
            padding: 12
        },
        "data-testid": "visit-loading",
        "data-layout": "web",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    width: $35a05642ffb904d6$var$RAIL_WIDTH,
                    flexShrink: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 12
                },
                "data-testid": "visit-skeleton-rail",
                children: column(3)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    flex: 1,
                    minWidth: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 12
                },
                "data-testid": "visit-skeleton-work",
                children: column(2)
            }),
            columns === 3 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    width: $35a05642ffb904d6$var$COPILOT_WIDTH,
                    flexShrink: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 12
                },
                "data-testid": "visit-skeleton-copilot",
                children: column(2)
            })
        ]
    });
}
function $35a05642ffb904d6$export$2e2bcd8739ae039() {
    const { caseId: caseId, encounterId: encounterId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    // 769–1279px keeps the two working columns and moves the copilot into a
    // right-edge drawer: three columns in 1000px leaves the note 340px wide,
    // which is not a column anybody writes a paragraph in.
    const { isMobile: isNarrowDesktop } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)(1279);
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const online = (0, $2a96b0bae45a4311$export$a32c5b7f472865fb)();
    const { me: me, balance: balance } = (0, $5bc9ff20f6a2b818$export$f637e1cf42d15a62)();
    // The kit's toast throws outside its provider. A workspace that refuses to
    // mount because nothing was there to say «ذخیره نشد» would be a worse failure
    // than a silent toast, so it is optional here and everywhere below.
    let toast = null;
    try {
        toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    } catch  {
        toast = null;
    }
    const toastAdapter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            info: (key)=>toast?.info?.(t($35a05642ffb904d6$var$hookToastKey(key))),
            error: (key)=>toast?.error?.(t($35a05642ffb904d6$var$hookToastKey(key)))
        }), [
        toast,
        t
    ]);
    const enc = (0, $9d57055d4093bdd6$export$c6a6bec0b562dc8b)(encounterId, caseId, {
        onToast: toastAdapter
    });
    // ── A refused AI call is said WHERE THE BUTTON WAS, not only in the panel ──
    //
    // The copilot column renders «شارژ پارسه» and the error card, but the buttons
    // that spend live in the four work tabs, and the column is collapsed, a
    // closed drawer, or another segment on a phone exactly when the student is
    // looking at one of them. core.md §7.5: the AI buttons «route to شارژ پارسه
    // on click» — so the toast carries that route, and an INVALID_INPUT (no
    // formulary drug to check) carries the BFF's own sentence.
    const onCopilotRefusal = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(({ reason: reason, error: error })=>{
        if (!toast) return;
        if (reason === 'credits') {
            toast.error?.(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 10,
                    flexWrap: 'wrap'
                },
                "data-testid": "copilot-topup-toast",
                children: [
                    t('assistant.noCredits.title'),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>navigate('credits'),
                        style: {
                            border: '1px solid currentColor',
                            background: 'none',
                            color: 'inherit',
                            font: 'inherit',
                            borderRadius: 999,
                            padding: '2px 10px',
                            cursor: 'pointer',
                            fontWeight: 700
                        },
                        "data-testid": "copilot-topup-toast-action",
                        children: t('assistant.noCredits.action')
                    })
                ]
            }), {
                duration: 8000
            });
            return;
        }
        const invalid = (0, $206625c7d33bd390$export$dbfe74f291058e97)(error) === (0, $206625c7d33bd390$export$28ba0a5263dd89b0).INVALID_INPUT;
        toast.error?.(invalid && error?.message ? error.message : t((0, $206625c7d33bd390$export$660244d64183d198)(error)));
    }, [
        toast,
        t,
        navigate
    ]);
    const copilot = (0, $e155a5df79cdcdf0$export$c4e2711910eaee3b)(encounterId, {
        balance: balance,
        caseId: caseId,
        onRefusal: onCopilotRefusal
    });
    const [workTab, setWorkTab] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $0cd549c1a257ae26$export$bf57dc351ba880e4));
    const [copilotTab, setCopilotTab] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $0cd549c1a257ae26$export$3601927ada250588));
    const [mobileSegment, setMobileSegment] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('note');
    const [railCollapsed, setRailCollapsed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>!!((0, $7cdea07122bc6887$export$6a368473377ea45c)((0, $7cdea07122bc6887$export$ed9d413e2a8761b7), {
            kind: 'local',
            fallback: {}
        }) || {})[$35a05642ffb904d6$var$RAIL_COLLAPSED_KEY]);
    const [copilotOpen, setCopilotOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [writeError, setWriteError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // A clinical write that failed because the store could not be reached. The
    // banner below reads it beside the browser's own offline flag, and it is
    // cleared by the next write that goes through — or the next note save that does.
    const [storeDown, setStoreDown] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (enc.saveState === (0, $9d57055d4093bdd6$export$ade9b241dfa4a5e7).SAVED) setStoreDown(false);
    }, [
        enc.saveState
    ]);
    const [sheets, setSheets] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        differential: false,
        soapReview: false,
        orderSuggest: false,
        interactions: false,
        print: false
    });
    const [closeOpen, setCloseOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [cancelOpen, setCancelOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const openSheet = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>setSheets((s)=>({
                ...s,
                [id]: true
            })), []);
    const closeSheet = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>setSheets((s)=>({
                ...s,
                [id]: false
            })), []);
    const anySheetOpen = Object.values(sheets).some(Boolean);
    // The one global `Esc` closes whatever is on top; these register the closers.
    (0, $0277e73c10ea225a$export$b26f18012588c702)(sheets.soapReview, ()=>closeSheet('soapReview'));
    (0, $0277e73c10ea225a$export$b26f18012588c702)(sheets.differential, ()=>closeSheet('differential'));
    (0, $0277e73c10ea225a$export$b26f18012588c702)(sheets.orderSuggest, ()=>closeSheet('orderSuggest'));
    (0, $0277e73c10ea225a$export$b26f18012588c702)(sheets.interactions, ()=>closeSheet('interactions'));
    (0, $0277e73c10ea225a$export$b26f18012588c702)(sheets.print, ()=>closeSheet('print'));
    const toggleRail = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setRailCollapsed((prev)=>{
            const next = !prev;
            (0, $7cdea07122bc6887$export$476f628a921f7411)((0, $7cdea07122bc6887$export$ed9d413e2a8761b7), {
                [$35a05642ffb904d6$var$RAIL_COLLAPSED_KEY]: next
            }, {
                kind: 'local'
            });
            return next;
        });
    }, []);
    // On a 769–1279px viewport the copilot is a DRAWER, and a drawer that is open
    // on arrival covers the note the student came here to write. It opens on
    // request there and stays a column everywhere wider.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (isNarrowDesktop && !isMobile) setCopilotOpen(false);
    }, [
        isNarrowDesktop,
        isMobile
    ]);
    const readOnly = enc.isClosed;
    // ── Writes, and the one error that changes the screen ───────────────────
    //
    // `ENCOUNTER_CLOSED` means the visit was closed elsewhere (another tab) while
    // this one was still editing. It is not a validation failure and not a retry:
    // the screen re-reads the encounter, which flips it to read-only with
    // «بازگشایی», and says so.
    //
    // `rethrow` is for a caller that has its own place to say it — the result
    // sheet keeps itself open with the message instead of closing over a banner
    // it has just covered.
    const guard = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((fn, { rethrow: rethrow = false } = {})=>async (...args)=>{
            try {
                setWriteError(null);
                const out = await fn(...args);
                setStoreDown(false);
                return out;
            } catch (err) {
                setWriteError(err);
                if ((0, $206625c7d33bd390$export$dbfe74f291058e97)(err) === (0, $206625c7d33bd390$export$28ba0a5263dd89b0).ENCOUNTER_CLOSED) enc.reload();
                if ((0, $206625c7d33bd390$export$25c5ef030dd0e68e)(err)) setStoreDown(true);
                if (rethrow) throw err;
                return null;
            }
        }, [
        enc
    ]);
    const askCopilot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (question)=>{
        await copilot.ask(question);
    }, [
        copilot
    ]);
    const requestSoapSuggestion = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const payload = await copilot.suggestSoap();
        if (payload) openSheet('soapReview');
    }, [
        copilot,
        openSheet
    ]);
    const requestDifferential = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const payload = await copilot.runDifferential();
        if (payload) openSheet('differential');
    }, [
        copilot,
        openSheet
    ]);
    const requestOrderSuggestions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const payload = await copilot.suggestOrders();
        if (payload) openSheet('orderSuggest');
    }, [
        copilot,
        openSheet
    ]);
    const requestInteractions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const payload = await copilot.checkInteractions();
        if (payload) openSheet('interactions');
    }, [
        copilot,
        openSheet
    ]);
    // ── Closure ─────────────────────────────────────────────────────────────
    const warnings = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $0cd549c1a257ae26$export$207553fe2bfe8271)({
            soap: enc.soap,
            diagnoses: enc.encounter?.diagnoses || [],
            openSheets: anySheetOpen ? 1 : 0
        }), [
        enc.soap,
        enc.encounter,
        anySheetOpen
    ]);
    const endVisit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (summary)=>{
        // FLUSH FIRST. See CloseVisitDialog's header for why the order is fixed.
        const flushed = await enc.flush();
        if (flushed && flushed.ok === false) return {
            ok: false,
            error: flushed.error
        };
        try {
            await enc.endEncounter(summary);
        } catch (err) {
            return {
                ok: false,
                error: err
            };
        }
        setCloseOpen(false);
        toast?.success?.(t('visit.toast.ended'));
        navigate('patient', {
            caseId: caseId,
            tab: 'visits'
        });
        return {
            ok: true
        };
    }, [
        enc,
        navigate,
        caseId,
        toast,
        t
    ]);
    const cancelVisit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        try {
            await enc.cancelEncounter();
            setCancelOpen(false);
            toast?.info?.(t('visit.toast.cancelled'));
            navigate('patient', {
                caseId: caseId,
                tab: 'visits'
            });
        } catch (err) {
            setWriteError(err);
            setCancelOpen(false);
        }
    }, [
        enc,
        navigate,
        caseId,
        toast,
        t
    ]);
    const reopen = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        try {
            await enc.reopenEncounter();
        } catch (err) {
            setWriteError(err);
        }
    }, [
        enc
    ]);
    // ── Shortcuts (core.md §7.5; listed in the `?` overlay) ─────────────────
    const group = t('visit.shortcuts.group');
    (0, $0277e73c10ea225a$export$b0ebbe7904d8d94a)('ctrl+s', ()=>{
        enc.flush();
    }, {
        label: t('visit.shortcuts.save'),
        group: group,
        firesInInput: true
    });
    (0, $0277e73c10ea225a$export$b0ebbe7904d8d94a)('ctrl+1', ()=>setWorkTab((0, $0cd549c1a257ae26$export$720e0ee82d7e9d5d)[0]), {
        label: t('visit.shortcuts.tab1'),
        group: group
    });
    (0, $0277e73c10ea225a$export$b0ebbe7904d8d94a)('ctrl+2', ()=>setWorkTab((0, $0cd549c1a257ae26$export$720e0ee82d7e9d5d)[1]), {
        label: t('visit.shortcuts.tab2'),
        group: group
    });
    (0, $0277e73c10ea225a$export$b0ebbe7904d8d94a)('ctrl+3', ()=>setWorkTab((0, $0cd549c1a257ae26$export$720e0ee82d7e9d5d)[2]), {
        label: t('visit.shortcuts.tab3'),
        group: group
    });
    (0, $0277e73c10ea225a$export$b0ebbe7904d8d94a)('ctrl+4', ()=>setWorkTab((0, $0cd549c1a257ae26$export$720e0ee82d7e9d5d)[3]), {
        label: t('visit.shortcuts.tab4'),
        group: group
    });
    (0, $0277e73c10ea225a$export$b0ebbe7904d8d94a)('ctrl+shift+e', ()=>{
        if (!readOnly) setCloseOpen(true);
    }, {
        label: t('visit.shortcuts.end'),
        group: group,
        firesInInput: true
    });
    // ── The states that are not the workspace ───────────────────────────────
    if (enc.loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($35a05642ffb904d6$var$VisitSkeleton, {
        mobile: isMobile,
        columns: isNarrowDesktop ? 2 : 3
    });
    // Not found, not mine, and «the URL's patient is not this visit's patient» are
    // ONE screen with ONE sentence — anything else is an oracle (core.md §3.2).
    if (enc.notFound) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02839c5704f38745$export$2e2bcd8739ae039), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('visit.notFound'),
        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            type: "button",
            onClick: ()=>navigate('patient', {
                    caseId: caseId
                }),
            style: {
                border: 0,
                background: 'none',
                font: 'inherit',
                cursor: 'pointer',
                color: 'inherit'
            },
            "data-testid": "visit-notfound-back",
            children: t('visit.backToRecord')
        }),
        "data-testid": "visit-not-found"
    });
    if (enc.error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9876d237fe8b99c$export$2e2bcd8739ae039), {
        error: enc.error,
        onRetry: enc.reload,
        fill: true,
        "data-testid": "visit-error"
    });
    const vm = {
        caseId: caseId,
        encounterId: encounterId,
        encounter: enc.encounter,
        patient: enc.record?.case || null,
        record: enc.record,
        readOnly: readOnly,
        offline: online.isOffline,
        balance: balance,
        soap: enc.soap,
        setSoapField: enc.setSoapField,
        saveState: enc.saveState,
        retrySave: enc.retrySave,
        addDiagnosis: guard(enc.addDiagnosis),
        updateDiagnosis: guard(enc.updateDiagnosis),
        deleteDiagnosis: guard(enc.deleteDiagnosis),
        reorderDiagnoses: guard(enc.reorderDiagnoses),
        addRxItem: guard(enc.addRxItem),
        deleteRxItem: guard(enc.deleteRxItem),
        addOrder: guard(enc.addOrder),
        cancelOrder: guard(enc.cancelOrder),
        recordOrderResult: guard(enc.recordOrderResult, {
            rethrow: true
        }),
        addVitals: guard(enc.addVitals),
        copilot: copilot,
        askCopilot: askCopilot,
        requestSoapSuggestion: requestSoapSuggestion,
        requestDifferential: requestDifferential,
        requestOrderSuggestions: requestOrderSuggestions,
        requestInteractions: requestInteractions,
        goToCredits: ()=>navigate('credits'),
        sheets: sheets,
        openSheet: openSheet,
        closeSheet: closeSheet,
        workTab: workTab,
        setWorkTab: setWorkTab,
        copilotTab: copilotTab,
        setCopilotTab: setCopilotTab,
        mobileSegment: mobileSegment,
        setMobileSegment: setMobileSegment,
        railCollapsed: railCollapsed,
        toggleRail: toggleRail,
        copilotOpen: copilotOpen,
        setCopilotOpen: setCopilotOpen,
        isNarrowDesktop: isNarrowDesktop && !isMobile,
        onBack: ()=>navigate('patient', {
                caseId: caseId,
                tab: 'visits'
            }),
        onEnd: ()=>setCloseOpen(true),
        onReopen: reopen,
        onCancel: ()=>setCancelOpen(true)
    };
    const Surface = isMobile ? (0, $733b563b5e3db94b$export$2e2bcd8739ae039) : (0, $9ef55795e996d715$export$2e2bcd8739ae039);
    const counts = (0, $0cd549c1a257ae26$export$8eaece050091ac72)(enc.encounter);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (online.isOffline || storeDown || (0, $206625c7d33bd390$export$25c5ef030dd0e68e)(enc.saveError)) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "warning",
                title: t('visit.offline.title'),
                "data-testid": "visit-offline",
                children: t('visit.offline.body')
            }),
            writeError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "error",
                title: t((0, $206625c7d33bd390$export$660244d64183d198)(writeError)),
                "data-testid": "visit-write-error",
                children: writeError.message
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Surface, {
                vm: vm
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0a0c925c5d0a9515$export$6f99a89affa2c085), {
                open: sheets.soapReview && !readOnly,
                onClose: ()=>closeSheet('soapReview'),
                suggestion: copilot.soapSuggestion,
                current: enc.soap,
                onApply: (field, mode)=>{
                    // The click — not the answer arriving — is what writes (core.md §3.4).
                    enc.applySoap({
                        [field]: copilot.soapSuggestion?.[field]
                    }, mode);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0a0c925c5d0a9515$export$79b783a89150a166), {
                open: sheets.orderSuggest,
                onClose: ()=>closeSheet('orderSuggest'),
                suggestion: copilot.orderSuggestion,
                onAdd: async (items)=>{
                    for (const item of items)// Sequential: they land in one list on one encounter, and the order
                    // the student ticked them in is the order they should appear in.
                    // eslint-disable-next-line no-await-in-loop
                    await guard(enc.addOrder)({
                        orderType: item.orderType || 'lab',
                        title: item.title,
                        code: item.code || null,
                        category: item.category || null,
                        urgency: item.urgency || 'routine',
                        notes: item.reason || null,
                        origin: 'ai'
                    });
                    closeSheet('orderSuggest');
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd368552e70ef864$export$f1147a5b3937ec5e), {
                open: sheets.differential,
                onClose: ()=>closeSheet('differential'),
                result: copilot.differential,
                readOnly: readOnly,
                onAdd: (item)=>guard(enc.addDiagnosis)((0, $bd368552e70ef864$export$ecd93ef57e1acc65)(item))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e51c47d0ea9f32$export$2e2bcd8739ae039), {
                open: sheets.interactions,
                onClose: ()=>closeSheet('interactions'),
                result: copilot.interactions
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9402ae4b8abaaa11$export$2e2bcd8739ae039), {
                open: sheets.print,
                onClose: ()=>closeSheet('print'),
                items: enc.encounter?.rxItems || [],
                patient: enc.record?.case || null,
                me: me,
                encounter: enc.encounter
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a14173bf6293872$export$2e2bcd8739ae039), {
                open: closeOpen,
                onClose: ()=>setCloseOpen(false),
                warnings: warnings,
                defaultSummary: (0, $0cd549c1a257ae26$export$d90665cec7f6ddde)(enc.soap),
                onConfirm: endVisit
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
                open: cancelOpen,
                onOpenChange: (v)=>{
                    if (!v) setCancelOpen(false);
                },
                title: t('visit.cancelConfirm.title'),
                description: t('visit.cancelConfirm.body', {
                    dx: counts.diagnoses,
                    rx: counts.rx,
                    orders: counts.orders
                }),
                destructive: true,
                confirmLabel: t('visit.cancelConfirm.confirm'),
                cancelLabel: t('common.actions.cancel'),
                onConfirm: cancelVisit,
                confirmTestId: "visit-cancel-confirm",
                "data-testid": "visit-cancel-dialog"
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");



// The chat page's whole data layer — threads, transcript, sending. core.md §9.
//
// One hook, because the six behaviours of §9.5 are not separable: a send that
// fails has to put the question BACK in the composer, a send that succeeds has
// to adopt the thread the server created, and a send that returns after the
// student moved to another conversation must land in the thread it was asked
// in and say so. Split across three hooks those hand-offs become props.
//
// ── What it never does ────────────────────────────────────────────────────
//
//   * It never writes to the record. The chat is a reader of the record and a
//     writer of nothing but its own transcript (core.md §3.4).
//   * It never sends a student id — `askAboutCase` has no such argument and
//     never will (core.md §3.2).
//   * It never re-issues an AI mutation on a refetch. Every AI field is a
//     MUTATION because it spends the student's پارسه; nothing here retries one
//     automatically, and «تلاش مجدد» is always a key the student pressed.
//
// ── The two ids ───────────────────────────────────────────────────────────
//
// `threadId` (the URL) and `loadedThreadIdRef` (what the transcript in state
// belongs to) are deliberately separate. The first question of a fresh
// conversation creates a thread server-side; the screen then REPLACES the URL
// with `/chat/<id>`, which changes `threadId` — and without the ref the load
// effect would immediately re-fetch the transcript the answer just delivered,
// flashing the answer away and spending a round trip to get it back.
//
// ── A send is bound to the thread it was sent from ────────────────────────
//
// The in-flight turns live in a map keyed by the conversation they were asked
// in (`'new'` for the unsaved one), and the page only shows the entry of the
// thread it is looking at. So when the student walks to thread B while A is
// waiting for its answer, B renders its own transcript with an enabled
// composer and no typing block; the pending bubble reappears if they come back
// to A before the answer lands; and the answer itself is written into A by the
// BFF whatever the student is looking at (core.md §9.5). The toast «پاسخ در
// گفتگوی قبلی ثبت شد» fires ONLY when they are elsewhere at that moment.

var $acw62 = parcelRequire("acw62");


// The chat's client-side rules. core.md §8.4, §9.5.
//
// v1 replayed the last 12 turns from the CLIENT with every question. v2 does
// not: the store's thread IS the memory and the BFF replays the last 12 turns
// itself (core.md §2.2), so `conversationHistory` is gone from the schema and
// so is the replay code that fed it. What is left is what the client still has
// to know before it spends پارسه.
/** The AI service reserves `__DIFF_REFINE__` / `__SOAP_REFINE__` as bypass prefixes. */ const $44873a91bbebf8e0$export$4f7639e122ea5c5 = (q)=>/^\s*__/.test(String(q ?? ''));
const $44873a91bbebf8e0$export$d94a08ba4a00e9a6 = 4000;
const $44873a91bbebf8e0$export$4b58ec02f4a54c65 = 3500;
function $44873a91bbebf8e0$export$44df337b524f3a74(q) {
    const text = String(q ?? '');
    if (!text.trim()) return 'empty';
    if ($44873a91bbebf8e0$export$4f7639e122ea5c5(text)) return 'reserved';
    if (text.length > $44873a91bbebf8e0$export$d94a08ba4a00e9a6) return 'tooLong';
    return null;
}
const $44873a91bbebf8e0$export$afa2fd5d11a1b26c = 60;
function $44873a91bbebf8e0$export$db0a10547c340911(question) {
    const text = String(question ?? '').replace(/\s+/g, ' ').trim();
    if (text.length <= $44873a91bbebf8e0$export$afa2fd5d11a1b26c) return text;
    return text.slice(0, $44873a91bbebf8e0$export$afa2fd5d11a1b26c).trimEnd();
}
const $44873a91bbebf8e0$export$264f2f5a3a5a9e08 = (thread, fallback = '')=>String(thread?.title ?? '').trim() || fallback;



// Progressive reveal — the ChatGPT feel without a streaming RPC. core.md §8.6.
//
// The AI service's `AskDoctorQuestion` is unary, so the client receives the
// whole answer at once and REVEALS it in word chunks: ~35 ms per tick, with the
// chunk size chosen so that even a 1 500-word answer finishes within ~6 s. The
// composer's «توقف» calls `stop()`, which jumps to the end — the full message is
// already stored, nothing is lost by skipping the animation.
//
// Honest about latency: the caller shows «در حال فکر کردن…» until the unary
// call returns, and only then starts this. Pure and injectable — tests pass
// their own timers.
const $a3fa25ac850049c0$export$4b203929188df7d1 = 35;
const $a3fa25ac850049c0$export$19489616e39d02e2 = 6000;
function $a3fa25ac850049c0$export$660b2ee2d4fb4eff(text) {
    const src = String(text ?? '');
    if (!src) return [];
    return src.match(/\S+\s*|\s+/g) || [];
}
function $a3fa25ac850049c0$export$d6d7949819927d6f(tokenCount, { tickMs: tickMs = $a3fa25ac850049c0$export$4b203929188df7d1, maxMs: maxMs = $a3fa25ac850049c0$export$19489616e39d02e2 } = {}) {
    const ticks = Math.max(1, Math.floor(maxMs / tickMs));
    return Math.max(1, Math.ceil(tokenCount / ticks));
}
function $a3fa25ac850049c0$export$4a2729c4782ad30b(text, { onUpdate: onUpdate, onDone: onDone, tickMs: tickMs = $a3fa25ac850049c0$export$4b203929188df7d1, maxMs: maxMs = $a3fa25ac850049c0$export$19489616e39d02e2, setTimeout: schedule = globalThis.setTimeout, clearTimeout: cancel = globalThis.clearTimeout } = {}) {
    const full = String(text ?? '');
    const tokens = $a3fa25ac850049c0$export$660b2ee2d4fb4eff(full);
    const chunk = $a3fa25ac850049c0$export$d6d7949819927d6f(tokens.length, {
        tickMs: tickMs,
        maxMs: maxMs
    });
    let at = 0;
    let timer = null;
    let finished = false;
    const finish = ()=>{
        if (finished) return;
        finished = true;
        if (timer != null) cancel(timer);
        timer = null;
        onUpdate?.(full, {
            done: true
        });
        onDone?.();
    };
    const tick = ()=>{
        if (finished) return;
        at = Math.min(tokens.length, at + chunk);
        const partial = tokens.slice(0, at).join('');
        if (at >= tokens.length) {
            finish();
            return;
        }
        onUpdate?.(partial, {
            done: false
        });
        timer = schedule(tick, tickMs);
    };
    if (!tokens.length) {
        finish();
        return {
            stop: finish,
            get done () {
                return finished;
            }
        };
    }
    onUpdate?.('', {
        done: false
    });
    timer = schedule(tick, tickMs);
    return {
        stop: finish,
        get done () {
            return finished;
        }
    };
}
var $a3fa25ac850049c0$export$2e2bcd8739ae039 = $a3fa25ac850049c0$export$4a2729c4782ad30b;



const $aab0be9ad626c609$export$5e063a578b9fa3e6 = 60;
const $aab0be9ad626c609$export$fba2bd9ccb85a7c2 = 'PATIENT';
const $aab0be9ad626c609$export$cb63050001264bb7 = [
    'credits',
    'invalid',
    'reserved',
    'tooLong',
    'empty',
    'threadGone'
];
let $aab0be9ad626c609$var$localSeq = 0;
const $aab0be9ad626c609$var$nextLocalId = ()=>`local-${$aab0be9ad626c609$var$localSeq += 1}`;
/** The map key of a conversation: its id, or `'new'` for the unsaved one. */ const $aab0be9ad626c609$var$keyOf = (threadId)=>threadId || 'new';
const $aab0be9ad626c609$var$without = (map, key)=>{
    const next = {
        ...map
    };
    delete next[key];
    return next;
};
function $aab0be9ad626c609$export$78fbdc5cd6078822({ caseId: caseId, threadId: threadId = null, onThreadCreated: onThreadCreated, onThreadGone: onThreadGone, onMoved: onMoved } = {}) {
    const [threads, setThreads] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [threadsLoading, setThreadsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(Boolean(caseId));
    const [threadsError, setThreadsError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [threadsNonce, setThreadsNonce] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [thread, setThread] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(Boolean(threadId));
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [hasOlder, setHasOlder] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [loadingOlder, setLoadingOlder] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // In-flight and failed student turns, keyed by the thread they belong to
    // (`'new'` for the unsaved conversation — see `keyOf`). See the header.
    const [inFlight, setInFlight] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [failed, setFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [notice, setNotice] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [answer, setAnswer] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // confidence + follow-ups of the LAST answer
    const [reveal, setReveal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { id, text } while revealing
    // What the transcript in state belongs to (see the header). It starts NULL
    // even when the URL names a thread: seeding it with `threadId` would make the
    // load effect's "we already have this one" check true on the first run, and
    // the page would open a thread it never read.
    const loadedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Where the student IS, read inside an async send to decide whether the answer
    // landed in the conversation they are still looking at.
    const currentRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(threadId || null);
    const revealRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // ── the composer draft, per thread (core.md §15) ────────────────────────
    const draftKey = (0, $7cdea07122bc6887$export$2ea236196864e117)({
        threadId: threadId,
        caseId: caseId
    });
    const [draft, setDraftState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $7cdea07122bc6887$export$1ffff020952d8ba9)(draftKey) || '');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setDraftState((0, $7cdea07122bc6887$export$1ffff020952d8ba9)(draftKey) || '');
    }, [
        draftKey
    ]);
    const setDraft = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((value)=>{
        setDraftState(value);
        (0, $7cdea07122bc6887$export$a89cf18a33e7b3d9)(draftKey, value);
        // «گفتگو پیدا نشد» has said its piece once the student starts typing again.
        setNotice((n)=>n === 'threadGone' ? null : n);
    }, [
        draftKey
    ]);
    // ── the sidebar's list ─────────────────────────────────────────────────
    const reloadThreads = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setThreadsNonce((n)=>n + 1), []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!caseId) {
            setThreads([]);
            setThreadsLoading(false);
            return undefined;
        }
        let alive = true;
        setThreadsLoading(true);
        (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$cb40171597afb9c8), {
            caseId: caseId,
            scope: $aab0be9ad626c609$export$fba2bd9ccb85a7c2,
            encounterId: null
        }).then((data)=>{
            if (!alive) return;
            setThreads(data?.caseChatThreads || []);
            setThreadsError(null);
        }).catch((err)=>{
            if (!alive) return;
            console.error('[useChat] threads failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
            setThreadsError(err);
            setThreads([]);
        }).finally(()=>{
            if (alive) setThreadsLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        caseId,
        threadsNonce
    ]);
    // ── the transcript ─────────────────────────────────────────────────────
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        currentRef.current = threadId || null;
        // A fresh conversation: nothing to read, and nothing written yet.
        if (!threadId) {
            if (loadedRef.current == null) {
                setLoading(false);
                return undefined;
            }
            loadedRef.current = null;
            setThread(null);
            setMessages([]);
            setHasOlder(false);
            setAnswer(null);
            setError(null);
            setLoading(false);
            return undefined;
        }
        // The answer we just received IS this thread — do not re-read it.
        if (loadedRef.current === threadId) {
            setLoading(false);
            return undefined;
        }
        // A different conversation is being opened: whatever was revealing belongs
        // to the one being left, and its message is already stored there.
        revealRef.current?.stop();
        revealRef.current = null;
        let alive = true;
        setLoading(true);
        setNotice(null);
        (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$d9466cb6388f2c86), {
            threadId: threadId,
            messageLimit: $aab0be9ad626c609$export$5e063a578b9fa3e6,
            beforeSeq: null
        }).then((data)=>{
            if (!alive) return;
            const row = data?.caseChatThread || null;
            if (!row) {
                // Deleted in another tab, or never this student's. Same copy for both
                // — a distinguishable "not yours" would be an oracle (core.md §3.2).
                loadedRef.current = null;
                setThread(null);
                setMessages([]);
                setHasOlder(false);
                setNotice('threadGone');
                onThreadGone?.('missing');
                return;
            }
            loadedRef.current = row.id;
            setThread(row);
            setMessages(row.messages || []);
            setHasOlder(Boolean(row.hasOlder));
            setAnswer(null);
            setError(null);
        }).catch((err)=>{
            if (!alive) return;
            console.error('[useChat] thread failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
            setError(err);
            setThread(null);
            setMessages([]);
        }).finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    // `onThreadGone` is intentionally not a dependency: it is a callback the
    // screen re-creates every render, and depending on it re-arms the fetch.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        threadId
    ]);
    // Stop any reveal in flight when the page UNMOUNTS — a timer writing into a
    // dead component is a leak and a React warning.
    //
    // Unmount only, deliberately: this used to key on `threadId`, and the very
    // first answer of a fresh conversation changes `threadId` (the screen adopts
    // the id the answer created), so the cleanup killed the reveal of the answer
    // that had just arrived. A reveal that ends when the student MOVES to another
    // thread is handled where that actually happens — the load effect below.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            revealRef.current?.stop();
            revealRef.current = null;
        }, []);
    /** «پیام‌های قدیمی‌تر» — a BUTTON, never a scroll trigger (core.md §9.3). */ const loadOlder = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const first = messages[0];
        if (!threadId || !first || loadingOlder) return;
        setLoadingOlder(true);
        try {
            const data = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$d9466cb6388f2c86), {
                threadId: threadId,
                messageLimit: $aab0be9ad626c609$export$5e063a578b9fa3e6,
                beforeSeq: first.seq
            });
            const row = data?.caseChatThread;
            setMessages((prev)=>[
                    ...row?.messages || [],
                    ...prev
                ]);
            setHasOlder(Boolean(row?.hasOlder));
        } catch (err) {
            console.error('[useChat] older failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
        } finally{
            setLoadingOlder(false);
        }
    }, [
        threadId,
        messages,
        loadingOlder
    ]);
    /** Reveal an answer in word chunks — the ChatGPT feel without a streaming RPC. */ const beginReveal = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((message)=>{
        revealRef.current?.stop();
        if (!message?.content) {
            setReveal(null);
            return;
        }
        setReveal({
            id: message.id,
            text: ''
        });
        revealRef.current = (0, $a3fa25ac850049c0$export$4a2729c4782ad30b)(message.content, {
            onUpdate: (partial, { done: done })=>{
                if (done) setReveal(null);
                else setReveal({
                    id: message.id,
                    text: partial
                });
            }
        });
    }, []);
    /** «توقف» — jump to the end. The full message is already stored. */ const stopReveal = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        revealRef.current?.stop();
        revealRef.current = null;
    }, []);
    // ── the send, and every row of §9.5 ────────────────────────────────────
    const send = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (rawQuestion)=>{
        const question = String(rawQuestion ?? '');
        const problem = (0, $44873a91bbebf8e0$export$44df337b524f3a74)(question);
        if (problem) {
            setNotice(problem === 'empty' ? 'empty' : problem);
            return false;
        }
        setNotice(null);
        stopReveal();
        const askedIn = loadedRef.current; // may be null: a fresh conversation
        const key = $aab0be9ad626c609$var$keyOf(askedIn);
        const localId = $aab0be9ad626c609$var$nextLocalId();
        setFailed((map)=>$aab0be9ad626c609$var$without(map, key));
        setInFlight((map)=>({
                ...map,
                [key]: {
                    id: localId,
                    role: 'student',
                    kind: 'chat',
                    content: question,
                    costParseh: 0,
                    createdAtMs: String(Date.now()),
                    status: 'pending'
                }
            }));
        setDraft('');
        let data;
        try {
            data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$45229b62a279da66), {
                caseId: caseId,
                threadId: askedIn || null,
                question: question
            });
        } catch (err) {
            const code = (0, $206625c7d33bd390$export$dbfe74f291058e97)(err);
            setInFlight((map)=>$aab0be9ad626c609$var$without(map, key));
            // Every recoverable failure puts the question BACK where the student can
            // press send again — nothing was stored and nothing was billed (§8.3).
            if (code === (0, $206625c7d33bd390$export$28ba0a5263dd89b0).INSUFFICIENT_CREDITS) {
                setDraft(question);
                setNotice('credits');
                return false;
            }
            if (code === (0, $206625c7d33bd390$export$28ba0a5263dd89b0).INVALID_INPUT) {
                setDraft(question);
                setNotice('invalid');
                return false;
            }
            if (code === (0, $206625c7d33bd390$export$28ba0a5263dd89b0).THREAD_NOT_FOUND) {
                // Deleted in another tab. Become a fresh conversation, keep the typing.
                loadedRef.current = null;
                setThread(null);
                setMessages([]);
                setHasOlder(false);
                setAnswer(null);
                // The draft is written under the FRESH conversation's key, not this
                // thread's: the screen is about to drop the id from the URL, and a
                // question saved under the dead thread's key would be read back as
                // empty a tick later — the typing lost by the recovery meant to keep it.
                (0, $7cdea07122bc6887$export$a89cf18a33e7b3d9)((0, $7cdea07122bc6887$export$2ea236196864e117)({
                    threadId: null,
                    caseId: caseId
                }), question);
                setDraftState(question);
                setNotice('threadGone');
                onThreadGone?.('missing');
                reloadThreads();
                return false;
            }
            // A transport failure: the student's turn stays on screen as FAILED with
            // a retry, because that is the one case where re-sending can succeed.
            console.error('[useChat] ask failed:', code || err?.message);
            setFailed((map)=>({
                    ...map,
                    [key]: {
                        id: localId,
                        role: 'student',
                        kind: 'chat',
                        content: question,
                        costParseh: 0,
                        createdAtMs: String(Date.now()),
                        status: 'failed'
                    }
                }));
            return false;
        }
        const result = data?.askAboutCase || null;
        const answered = result?.thread || null;
        setInFlight((map)=>$aab0be9ad626c609$var$without(map, key));
        // The wallet moved in another service; the balance line is a read of it.
        (0, $5bc9ff20f6a2b818$export$3437bf7ab4f0acaf)();
        reloadThreads();
        if (!answered) {
            setNotice('invalid');
            return false;
        }
        // The student walked away mid-flight. The answer is stored in the thread it
        // was asked in — this page just says so and leaves it there (core.md §9.5).
        if (currentRef.current !== askedIn) {
            onMoved?.(answered.id);
            return true;
        }
        // Back on the right conversation, but its transcript is still being
        // re-read (they left and returned mid-flight): that read will deliver the
        // answer — the BFF stored it — and appending here would land it on a
        // transcript that is about to be replaced.
        if (askedIn && loadedRef.current !== askedIn) return true;
        const created = !askedIn;
        loadedRef.current = answered.id;
        currentRef.current = answered.id;
        setThread((prev)=>({
                ...prev || {},
                ...answered,
                messages: undefined
            }));
        const fresh = answered.messages || [];
        setMessages((prev)=>[
                ...prev,
                ...fresh
            ]);
        setAnswer({
            confidence: result.confidence || null,
            followUps: result.followUpSuggestions || [],
            references: result.relevantReferences || []
        });
        beginReveal(fresh.find((m)=>m.role === 'assistant'));
        if (created) onThreadCreated?.(answered.id);
        return true;
    }, [
        caseId,
        setDraft,
        beginReveal,
        stopReveal,
        reloadThreads,
        onThreadCreated,
        onThreadGone,
        onMoved
    ]);
    // What THIS conversation is waiting on or failed at, if anything. The map
    // may hold entries for conversations the student has walked away from; those
    // stay where they are and render again only when the student returns.
    const currentKey = $aab0be9ad626c609$var$keyOf(threadId);
    const pending = inFlight[currentKey] || null;
    const failedTurn = failed[currentKey] || null;
    /** Re-send the turn that failed. The failed bubble is dropped first. */ const retry = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const text = failedTurn?.content;
        if (!text) return Promise.resolve(false);
        setFailed((map)=>$aab0be9ad626c609$var$without(map, currentKey));
        return send(text);
    }, [
        failedTurn,
        currentKey,
        send
    ]);
    /**
   * «بازتولید» — ask the SAME question again. The old answer stays in history:
   * the store appends, it never replaces (core.md §9.3).
   */ const regenerate = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((assistantMessage)=>{
        const idx = messages.findIndex((m)=>m.id === assistantMessage?.id);
        for(let i = idx - 1; i >= 0; i -= 1){
            if (messages[i].role === 'student') return send(messages[i].content);
        }
        return Promise.resolve(false);
    }, [
        messages,
        send
    ]);
    /** Rename a thread. An EMPTY title restores the automatic one (core.md §9.5). */ const rename = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (id, title)=>{
        const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$92e44db75c17d81b), {
            threadId: id,
            title: title || ''
        });
        const row = data?.renameCaseChatThread || null;
        if (row) {
            setThreads((prev)=>prev.map((t)=>t.id === row.id ? {
                        ...t,
                        ...row
                    } : t));
            setThread((prev)=>prev && prev.id === row.id ? {
                    ...prev,
                    ...row
                } : prev);
        }
        return row;
    }, []);
    const remove = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (id)=>{
        await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$d4e5876cfcdc8538), {
            threadId: id
        });
        setThreads((prev)=>prev.filter((t)=>t.id !== id));
        (0, $7cdea07122bc6887$export$eeeb486534738631)((0, $7cdea07122bc6887$export$2ea236196864e117)({
            threadId: id,
            caseId: caseId
        }));
        if (id === loadedRef.current) {
            loadedRef.current = null;
            setThread(null);
            setMessages([]);
            setHasOlder(false);
            setAnswer(null);
            onThreadGone?.('deleted');
        }
        reloadThreads();
    }, [
        caseId,
        onThreadGone,
        reloadThreads
    ]);
    /** «گفتگوی جدید» — an unsaved conversation; no row exists until the first send. */ const startNew = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        stopReveal();
        loadedRef.current = null;
        currentRef.current = null;
        setThread(null);
        setMessages([]);
        setHasOlder(false);
        setAnswer(null);
        setNotice(null);
        setFailed((map)=>$aab0be9ad626c609$var$without(map, 'new'));
    }, [
        stopReveal
    ]);
    const dismissNotice = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setNotice(null), []);
    // What the column renders: the stored transcript, then THIS conversation's
    // turn in flight or the one that failed. Only one of those two can exist at a
    // time for one conversation.
    const visibleMessages = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const out = [
            ...messages
        ];
        if (pending) out.push(pending);
        if (failedTurn) out.push(failedTurn);
        return out;
    }, [
        messages,
        pending,
        failedTurn
    ]);
    // The title an unsaved conversation will get once its first answer lands —
    // the same clip the BFF stores, so nothing flashes when it does (§9.5).
    const pendingTitle = !threadId && pending ? (0, $44873a91bbebf8e0$export$db0a10547c340911)(pending.content) : null;
    return {
        threads: // sidebar
        threads,
        threadsLoading: threadsLoading,
        threadsError: threadsError,
        reloadThreads: reloadThreads,
        thread: // transcript
        thread,
        messages: visibleMessages,
        storedMessages: messages,
        loading: loading,
        error: error,
        hasOlder: hasOlder,
        loadingOlder: loadingOlder,
        loadOlder: loadOlder,
        // send lifecycle
        sending: Boolean(pending),
        pendingTitle: pendingTitle,
        revealing: Boolean(reveal),
        reveal: reveal,
        answer: answer,
        notice: notice,
        dismissNotice: dismissNotice,
        send: send,
        retry: retry,
        regenerate: regenerate,
        stopReveal: stopReveal,
        startNew: startNew,
        rename: // thread admin
        rename,
        remove: remove,
        draft: // composer draft
        draft,
        setDraft: setDraft
    };
}
var $aab0be9ad626c609$export$2e2bcd8739ae039 = $aab0be9ad626c609$export$78fbdc5cd6078822;


// One practice case, with the شرح حال the student wrote into it.
//
// ── `null` is a STATE, not an error ────────────────────────────────────────
//
// `myCase` returns null both when the case does not exist and when it belongs to
// another student — DELIBERATELY indistinguishable, so an error response cannot
// be used to confirm which case ids exist on the platform one id at a time
// (SCHEMA.graphql header; CORE.md §3). There is no `CASE_FORBIDDEN` code and
// there must not be one.
//
// So a null answer is NOT an error: it must not set `error`, must not offer a
// retry, and must render exactly ONE screen — «این مورد در دسترس نیست» — never
// «متعلق به شما نیست», which would be the same oracle spoken in Persian.
//
// ── Why `entries` is re-read on its own after a save ──────────────────────
//
// `caseHistory` is redundant with `myCase.entries` and the frozen schema keeps it
// anyway, for exactly this: the editor saves a section and needs the entries
// back, not the case and its counts. Re-reading the whole case after every
// keystroke-sized save would repaint the header — the title, the counts, the
// «آخرین تغییر» — under a student who is mid-sentence in a textarea below it.

var $acw62 = parcelRequire("acw62");


function $997567223d8312c8$export$308c2aefa3f9e20e(caseId) {
    const [caseRecord, setCaseRecord] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [entries, setEntries] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [nonce, setNonce] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!caseId) {
            setLoading(false);
            return undefined;
        }
        let alive = true;
        setLoading(true);
        (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$532673476a7e45c5), {
            caseId: caseId
        }).then((data)=>{
            if (!alive) return;
            const row = data?.myCase || null;
            setCaseRecord(row);
            setEntries(row?.entries || []);
            // Not an error. See the header: null is "not available", full stop.
            setError(null);
        }).catch((err)=>{
            if (!alive) return;
            console.error('[useCase] failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
            setError(err);
            setCaseRecord(null);
            setEntries([]);
        }).finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        caseId,
        nonce
    ]);
    const reload = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setNonce((n)=>n + 1), []);
    /** Pull the history back without disturbing the case header. */ const reloadHistory = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        if (!caseId) return;
        try {
            const data = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$3c1db077bd82bd9d), {
                caseId: caseId,
                sections: null
            });
            setEntries(data?.caseHistory || []);
        } catch (err) {
            console.error('[useCase] history reload failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
        // Deliberately NOT cleared: the entries on screen are the ones that were
        // successfully read a moment ago, and blanking them because a refetch
        // failed would look to the student like their writing was lost.
        }
    }, [
        caseId
    ]);
    /**
   * Update the case. OMITTED FIELDS ARE LEFT ALONE; `''` (or 0 for ageYears)
   * clears one.
   *
   * The caller builds the input from what actually CHANGED — see
   * ../screens/CaseDetail/CaseDetail.shared.js. Sending the whole form every
   * time would work only as long as the form holds every field; the day it holds
   * a subset, a student editing the title erases the rest.
   */ const updateCase = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (input)=>{
        const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$1a72deffcb882601), {
            caseId: caseId,
            input: input
        });
        const row = data?.updateCase;
        // `updateCase` answers with the CaseRow shape — no `entries` — so the
        // entries already in state are kept rather than being overwritten with
        // undefined.
        if (row) setCaseRecord((prev)=>({
                ...prev || {},
                ...row
            }));
        return row || null;
    }, [
        caseId
    ]);
    /**
   * Append entries. ALL-OR-NOTHING, and plural for a reason: the voice-intake
   * flow submits a whole drafted history at once, and half a history is worse
   * than none — a case whose سابقه landed and whose داروها did not reads to the
   * model as a patient on no drugs.
   */ const addHistory = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (rows)=>{
        const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$e169d2c267301cd2), {
            caseId: caseId,
            entries: rows
        });
        const added = data?.addCaseHistory || [];
        if (added.length) setEntries((prev)=>[
                ...prev,
                ...added
            ]);
        return added;
    }, [
        caseId
    ]);
    /**
   * Edit one entry.
   *
   * `section` and `source` are not in the update input and cannot be sent:
   * provenance is a fact about how a row came to exist (CORE.md §6), and an
   * editable one would let a voice draft become indistinguishable from a
   * sentence the student wrote themselves.
   */ const updateEntry = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (entryId, input)=>{
        const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$c87054baf27a4c54), {
            entryId: entryId,
            input: input
        });
        const row = data?.updateCaseHistoryEntry;
        if (row) setEntries((prev)=>prev.map((e)=>e.id === row.id ? row : e));
        return row || null;
    }, []);
    const deleteEntry = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (entryId)=>{
        await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$7582e661207c1f6a), {
            entryId: entryId
        });
        setEntries((prev)=>prev.filter((e)=>e.id !== entryId));
    }, []);
    return {
        caseRecord: caseRecord,
        entries: entries,
        loading: loading,
        error: error,
        // `notFound` is separate from `error` because they are different screens and
        // only one of them gets a retry button.
        notFound: !loading && !error && !caseRecord,
        reload: reload,
        reloadHistory: reloadHistory,
        updateCase: updateCase,
        addHistory: addHistory,
        updateEntry: updateEntry,
        deleteEntry: deleteEntry
    };
}
var $997567223d8312c8$export$2e2bcd8739ae039 = $997567223d8312c8$export$308c2aefa3f9e20e;




// What the two chat surfaces agree about. core.md §9.
//
// Pure functions only — no React, no kit, no `t()`. The desktop and the phone
// render the same conversation in two chromes, and everything that decides
// WHICH rows go where (the sidebar's day buckets, the day dividers in the
// transcript, the four suggested prompts) lives here so the two cannot drift.
//
// Day boundaries are computed in IRAN time, not the browser's: a student
// studying at 01:00 in Berlin is on the Iranian «امروز» that the timestamps
// were stamped in, and grouping in the local zone would file that conversation
// under yesterday for them and today for their classmate.

const $bcd6f0910828a2b0$export$9c19120e1e077cd9 = [
    'today',
    'yesterday',
    'last7',
    'older'
];
const $bcd6f0910828a2b0$export$71d385d83475dea1 = (group)=>`chat.sidebar.${group}`;
/** Milliseconds in a day, for the 7-day window. */ const $bcd6f0910828a2b0$var$DAY_MS = 86400000;
function $bcd6f0910828a2b0$export$a776431183a2d7ab(ms, nowMs = Date.now()) {
    const day = (0, $6e94fc1378f3a785$export$29d3212020cf53a5)(ms);
    if (!day) return 'older';
    const today = (0, $6e94fc1378f3a785$export$ceda478235320bf2)(nowMs);
    if (day === today) return 'today';
    if (day === (0, $6e94fc1378f3a785$export$c13cab26eb520a22)(today, -1)) return 'yesterday';
    const n = Number(ms);
    if (Number.isFinite(n) && nowMs - n < 7 * $bcd6f0910828a2b0$var$DAY_MS) return 'last7';
    return 'older';
}
const $bcd6f0910828a2b0$export$7be5c82f70ff586c = (thread)=>Number(thread?.lastMessageAtMs || thread?.createdAtMs || 0);
function $bcd6f0910828a2b0$export$e280e59b0aebd7c3(threads, nowMs = Date.now()) {
    const buckets = new Map($bcd6f0910828a2b0$export$9c19120e1e077cd9.map((g)=>[
            g,
            []
        ]));
    for (const thread of threads || [])buckets.get($bcd6f0910828a2b0$export$a776431183a2d7ab($bcd6f0910828a2b0$export$7be5c82f70ff586c(thread), nowMs)).push(thread);
    return $bcd6f0910828a2b0$export$9c19120e1e077cd9.map((group)=>({
            group: group,
            threads: buckets.get(group).sort((a, b)=>$bcd6f0910828a2b0$export$7be5c82f70ff586c(b) - $bcd6f0910828a2b0$export$7be5c82f70ff586c(a))
        })).filter((bucket)=>bucket.threads.length > 0);
}
function $bcd6f0910828a2b0$export$ff046ac049e9556c(messages) {
    const out = [];
    let day = null;
    for (const message of messages || []){
        const at = (0, $6e94fc1378f3a785$export$29d3212020cf53a5)(message?.createdAtMs);
        if (at && at !== day) {
            day = at;
            out.push({
                kind: 'day',
                day: day,
                key: `day-${at}`
            });
        }
        out.push({
            kind: 'message',
            message: message,
            key: message.id
        });
    }
    return out;
}
function $bcd6f0910828a2b0$export$ec583b67d7f48b51(messages) {
    for(let i = (messages?.length || 0) - 1; i >= 0; i -= 1){
        if (messages[i]?.role === 'assistant') return messages[i].id;
    }
    return null;
}
const $bcd6f0910828a2b0$export$3928e303f9b93767 = [
    'chat.prompts.summary',
    'chat.prompts.differential',
    'chat.prompts.keyFinding',
    'chat.prompts.nextVisit'
];
function $bcd6f0910828a2b0$export$9acf0cb39b095d39(caseRecord) {
    const name = $bcd6f0910828a2b0$export$3805f9b7fa77f6d4(caseRecord);
    const complaint = String(caseRecord?.chiefComplaint || '').replace(/\s+/g, ' ').trim();
    return [
        name ? {
            key: 'chat.prompts.summaryOf',
            params: {
                name: name
            }
        } : {
            key: 'chat.prompts.summary'
        },
        complaint ? {
            key: 'chat.prompts.differentialFor',
            params: {
                complaint: complaint
            }
        } : {
            key: 'chat.prompts.differential'
        },
        complaint ? {
            key: 'chat.prompts.keyFindingFor',
            params: {
                complaint: complaint
            }
        } : {
            key: 'chat.prompts.keyFinding'
        },
        {
            key: 'chat.prompts.nextVisit'
        }
    ];
}
function $bcd6f0910828a2b0$export$b48681489d9cc8d4(ms, nowMs = Date.now()) {
    const n = Number(ms);
    if (!Number.isFinite(n) || n <= 0) return null;
    const delta = Math.max(0, nowMs - n);
    if (delta < 60000) return {
        key: 'chat.sidebar.justNow'
    };
    if (delta < 3600000) return {
        key: 'chat.sidebar.minutesAgo',
        params: {
            count: Math.floor(delta / 60000)
        }
    };
    const group = $bcd6f0910828a2b0$export$a776431183a2d7ab(n, nowMs);
    if (group === 'today') return {
        key: 'chat.sidebar.hoursAgo',
        params: {
            count: Math.floor(delta / 3600000)
        }
    };
    if (group === 'yesterday') return {
        key: 'chat.sidebar.yesterday'
    };
    return {
        date: n
    };
}
const $bcd6f0910828a2b0$export$3805f9b7fa77f6d4 = (row, fallback = '')=>String(row?.displayName || row?.title || '').trim() || fallback;
const $bcd6f0910828a2b0$export$fb440a97473a223a = (stored)=>stored !== '0';
const $bcd6f0910828a2b0$export$2011fc0fd6b64e28 = (open)=>open ? '1' : '0';




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9fd2e6ed94de5020$export$a2387ed3b5d536eb = {
    name: "panel-left-close",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                key: "afitv7"
            }
        ],
        [
            "path",
            {
                d: "M9 3v18",
                key: "fh3hqa"
            }
        ],
        [
            "path",
            {
                d: "m16 15-3-3 3-3",
                key: "14y99z"
            }
        ]
    ],
    aliases: [
        "sidebar-close"
    ]
};
$9fd2e6ed94de5020$export$a2387ed3b5d536eb.node;
const $9fd2e6ed94de5020$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($9fd2e6ed94de5020$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e0c275ac339c70ac$export$a2387ed3b5d536eb = {
    name: "panel-left-open",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                key: "afitv7"
            }
        ],
        [
            "path",
            {
                d: "M9 3v18",
                key: "fh3hqa"
            }
        ],
        [
            "path",
            {
                d: "m14 9 3 3-3 3",
                key: "8010ee"
            }
        ]
    ],
    aliases: [
        "sidebar-open"
    ]
};
$e0c275ac339c70ac$export$a2387ed3b5d536eb.node;
const $e0c275ac339c70ac$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($e0c275ac339c70ac$export$a2387ed3b5d536eb);








var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $df82e729d4b50e19$export$a2387ed3b5d536eb = {
    name: "users",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
                key: "1yyitq"
            }
        ],
        [
            "path",
            {
                d: "M16 3.128a4 4 0 0 1 0 7.744",
                key: "16gr8j"
            }
        ],
        [
            "path",
            {
                d: "M22 21v-2a4 4 0 0 0-3-3.87",
                key: "kshegd"
            }
        ],
        [
            "circle",
            {
                cx: "9",
                cy: "7",
                r: "4",
                key: "nufk8"
            }
        ]
    ]
};
$df82e729d4b50e19$export$a2387ed3b5d536eb.node;
const $df82e729d4b50e19$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($df82e729d4b50e19$export$a2387ed3b5d536eb);








parcelRequire("acw62");
const $3ba6dc9522ab5f36$export$edd674b31191f8b = 'chat-hover-host';
const $3ba6dc9522ab5f36$export$c40ab4f350069aa2 = 'chat-hover-actions';
const $3ba6dc9522ab5f36$var$CSS = `
@media (hover: hover) and (pointer: fine) {
  .${$3ba6dc9522ab5f36$export$edd674b31191f8b} .${$3ba6dc9522ab5f36$export$c40ab4f350069aa2} { opacity: 0; transition: opacity 120ms ease; }
  .${$3ba6dc9522ab5f36$export$edd674b31191f8b}:hover .${$3ba6dc9522ab5f36$export$c40ab4f350069aa2},
  .${$3ba6dc9522ab5f36$export$edd674b31191f8b}:focus-within .${$3ba6dc9522ab5f36$export$c40ab4f350069aa2} { opacity: 1; }
}
`;
function $3ba6dc9522ab5f36$export$c4f071d58a2bd092() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("style", {
        "data-chat-hover-reveal": "",
        children: $3ba6dc9522ab5f36$var$CSS
    });
}


const $9d5b68e145c838fb$export$780035d9fe48eb32 = 260;
/** One row. Renames in place; the ⋯ menu is anchored to the row's own button. */ function $9d5b68e145c838fb$var$ThreadRow({ thread: thread, active: active, onOpen: onOpen, onRename: onRename, onDelete: onDelete }) {
    const { t: t, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [menuOpen, setMenuOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [editing, setEditing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const anchorRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const title = (0, $44873a91bbebf8e0$export$264f2f5a3a5a9e08)(thread, t('chat.thread.untitled'));
    // Relative, as §9.1 says — «همین حالا», «۵ دقیقه پیش», «دیروز» — and a date
    // once "N days ago" would read worse than the day itself.
    const when = (0, $bcd6f0910828a2b0$export$b48681489d9cc8d4)(thread.lastMessageAtMs || thread.createdAtMs);
    const whenLabel = !when ? '' : when.date != null ? formatDate(when.date, 'dayMonth') : t(when.key, when.params);
    const commit = async ()=>{
        setEditing(false);
        // An EMPTY title restores the automatic one — that is the contract, not a
        // no-op, so an empty string is sent rather than swallowed (core.md §9.5).
        if (value.trim() !== title.trim()) await onRename?.(thread.id, value.trim());
    };
    if (editing) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
        onSubmit: (e)=>{
            e.preventDefault();
            commit();
        },
        style: {
            padding: '4px 6px'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
            autoFocus: true,
            value: value,
            "aria-label": t('chat.thread.renamePlaceholder'),
            placeholder: t('chat.thread.renamePlaceholder'),
            onChange: (e)=>setValue(e.target.value),
            onBlur: commit,
            onKeyDown: (e)=>{
                if (e.key === 'Escape') setEditing(false);
            },
            "data-testid": "thread-rename-input",
            style: {
                width: '100%',
                fontFamily: 'inherit',
                fontSize: 13,
                padding: '7px 9px',
                borderRadius: 8,
                border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal}`,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card
            }
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $3ba6dc9522ab5f36$export$edd674b31191f8b),
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            borderRadius: 8,
            background: active ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal, 0.14) : 'transparent'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: ()=>onOpen?.(thread.id),
                "data-testid": "thread-row",
                "data-active": active ? '1' : '0',
                style: {
                    flex: 1,
                    minWidth: 0,
                    textAlign: 'start',
                    cursor: 'pointer',
                    background: 'transparent',
                    border: 'none',
                    font: 'inherit',
                    padding: '8px 10px',
                    color: active ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            display: 'block',
                            fontSize: 13,
                            fontWeight: active ? 700 : 500,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        "data-testid": "thread-when",
                        style: {
                            fontSize: 11,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                        },
                        children: whenLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                ref: anchorRef,
                className: (0, $3ba6dc9522ab5f36$export$c40ab4f350069aa2),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                    size: 30,
                    variant: "ghost",
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24a488cfd7efdee5$export$2e2bcd8739ae039), {
                        size: 15,
                        "aria-hidden": true
                    }),
                    label: t('chat.sidebar.menu'),
                    onClick: ()=>setMenuOpen(true),
                    "data-testid": "thread-menu"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $08d1958bc1315b40$export$2e2bcd8739ae039), {
                open: menuOpen,
                onClose: ()=>setMenuOpen(false),
                anchorRef: anchorRef,
                width: 190,
                ariaLabel: t('chat.sidebar.menu'),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        role: "menuitem",
                        onClick: ()=>{
                            setMenuOpen(false);
                            setValue(title);
                            setEditing(true);
                        },
                        "data-testid": "thread-rename",
                        style: $9d5b68e145c838fb$var$ROW_STYLE,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f9f3418dec68a42$export$2e2bcd8739ae039), {
                                size: 15,
                                "aria-hidden": true
                            }),
                            t('common.actions.rename')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        role: "menuitem",
                        onClick: ()=>{
                            setMenuOpen(false);
                            onDelete?.(thread);
                        },
                        "data-testid": "thread-delete",
                        style: {
                            ...$9d5b68e145c838fb$var$ROW_STYLE,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1882f1d059ea7fa7$export$2e2bcd8739ae039), {
                                size: 15,
                                "aria-hidden": true
                            }),
                            t('common.actions.delete')
                        ]
                    })
                ]
            })
        ]
    });
}
const $9d5b68e145c838fb$var$ROW_STYLE = {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    width: '100%',
    padding: '10px 12px',
    background: 'transparent',
    border: 'none',
    font: 'inherit',
    fontSize: 13,
    cursor: 'pointer',
    textAlign: 'start',
    color: 'inherit'
};
function $9d5b68e145c838fb$export$2e2bcd8739ae039({ threads: threads, loading: loading = false, activeThreadId: activeThreadId = null, balance: balance = null, onNew: onNew, onOpen: onOpen, onRename: onRename, onDelete: onDelete, onSwitchPatient: onSwitchPatient, onOpenVisits: onOpenVisits }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [confirming, setConfirming] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [deleting, setDeleting] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const groups = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $bcd6f0910828a2b0$export$e280e59b0aebd7c3)(threads), [
        threads
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
        "data-testid": "thread-sidebar",
        "aria-label": t('chat.sidebar.title'),
        style: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            minHeight: 0,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            borderInlineEnd: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ba6dc9522ab5f36$export$c4f071d58a2bd092), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: 10
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    onClick: onNew,
                    style: {
                        width: '100%'
                    },
                    "data-testid": "thread-new",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83905746e46531b9$export$2e2bcd8739ae039), {
                            size: 16,
                            "aria-hidden": true
                        }),
                        t('chat.sidebar.new')
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    padding: '0 8px 8px'
                },
                children: [
                    loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 20
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                            size: 20,
                            label: t('common.labels.loading')
                        })
                    }) : null,
                    !loading && groups.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        "data-testid": "thread-empty",
                        style: {
                            fontSize: 12.5,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                            padding: '8px 10px',
                            lineHeight: 1.9
                        },
                        children: t('chat.sidebar.empty')
                    }) : null,
                    groups.map((bucket)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    style: {
                                        fontSize: 11,
                                        fontWeight: 700,
                                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                                        margin: '12px 10px 4px'
                                    },
                                    children: t((0, $bcd6f0910828a2b0$export$71d385d83475dea1)(bucket.group))
                                }),
                                bucket.threads.map((thread)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9d5b68e145c838fb$var$ThreadRow, {
                                        thread: thread,
                                        active: thread.id === activeThreadId,
                                        onOpen: onOpen,
                                        onRename: onRename,
                                        onDelete: setConfirming
                                    }, thread.id))
                            ]
                        }, bucket.group))
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    padding: 10,
                    display: 'grid',
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onSwitchPatient,
                        style: $9d5b68e145c838fb$var$ROW_STYLE,
                        "data-testid": "switch-patient",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df82e729d4b50e19$export$2e2bcd8739ae039), {
                                size: 15,
                                "aria-hidden": true
                            }),
                            t('chat.sidebar.otherPatient')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: onOpenVisits,
                        style: $9d5b68e145c838fb$var$ROW_STYLE,
                        "data-testid": "visit-threads",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02839c5704f38745$export$2e2bcd8739ae039), {
                                size: 15,
                                "aria-hidden": true
                            }),
                            t('chat.sidebar.inVisit')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f5fb734a3b15afa$export$8866dd39911dad54), {
                        balance: balance,
                        style: {
                            padding: '0 12px 2px'
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
                open: Boolean(confirming),
                onOpenChange: (open)=>{
                    if (!open) setConfirming(null);
                },
                title: t('chat.thread.deleteTitle'),
                description: t('chat.thread.deleteBody'),
                confirmLabel: t('common.actions.delete'),
                cancelLabel: t('common.actions.cancel'),
                destructive: true,
                loading: deleting,
                onConfirm: async ()=>{
                    const target = confirming;
                    setDeleting(true);
                    try {
                        await onDelete?.(target.id);
                    } finally{
                        setDeleting(false);
                        setConfirming(null);
                    }
                },
                "data-testid": "thread-delete-confirm",
                confirmTestId: "thread-delete-confirm-confirm",
                cancelTestId: "thread-delete-confirm-cancel"
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





parcelRequire("acw62");


function $10fc17faabccb2a9$export$2e2bcd8739ae039({ message: message, onRetry: onRetry }) {
    const { t: t, formatTime: formatTime } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const status = message?.status || 'sent';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a6342f4e7688b45e$export$2e2bcd8739ae039), {
        mine: true,
        body: message?.content || '',
        timeLabel: formatTime(message?.createdAtMs),
        status: status,
        statusLabel: t(`chat.message.${status === 'pending' ? 'sending' : status}`),
        pending: status === 'pending',
        failed: status === 'failed',
        onRetry: status === 'failed' ? onRetry : undefined,
        retryLabel: t('chat.message.retry'),
        "data-testid": "student-message"
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $807d71b9253536b4$export$a2387ed3b5d536eb = {
    name: "copy",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "14",
                height: "14",
                x: "8",
                y: "8",
                rx: "2",
                ry: "2",
                key: "17jyea"
            }
        ],
        [
            "path",
            {
                d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
                key: "zix9uf"
            }
        ]
    ]
};
$807d71b9253536b4$export$a2387ed3b5d536eb.node;
const $807d71b9253536b4$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($807d71b9253536b4$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $13d983cdd962eaa4$export$a2387ed3b5d536eb = {
    name: "thumbs-down",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
                key: "m61m77"
            }
        ],
        [
            "path",
            {
                d: "M17 14V2",
                key: "8ymqnk"
            }
        ]
    ]
};
$13d983cdd962eaa4$export$a2387ed3b5d536eb.node;
const $13d983cdd962eaa4$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($13d983cdd962eaa4$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $37dc1274e0a325ea$export$a2387ed3b5d536eb = {
    name: "thumbs-up",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
                key: "emmmcr"
            }
        ],
        [
            "path",
            {
                d: "M7 10v12",
                key: "1qc93n"
            }
        ]
    ]
};
$37dc1274e0a325ea$export$a2387ed3b5d536eb.node;
const $37dc1274e0a325ea$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($37dc1274e0a325ea$export$a2387ed3b5d536eb);




// A small, deterministic markdown → React renderer. core.md §9.4.
//
// No dependency, on purpose: the model's output is untrusted text inside the
// student's browser, and the whole surface this renderer exposes has to be
// readable in one file. What it understands is exactly what the teaching
// assistant produces — headings (rendered h3-h5, never h1/h2), paragraphs, bold/italic, inline
// code, fenced code (with a copy control), ordered/unordered lists nested one
// level, blockquotes, tables (inside `overflow-x: auto`) and horizontal rules.
//
// ── Two rules that are safety, not style ────────────────────────────────
//
//   1. RAW HTML IS ESCAPED, NEVER RENDERED. Every text run goes into a React
//      text node; nothing here uses `dangerouslySetInnerHTML`, so `<script>` in
//      an answer is the six characters `<script>` on screen.
//   2. LINKS RENDER AS TEXT. `[label](url)` becomes the label — no anchor, no
//      navigation from a model. A bare URL is likewise plain text.
//
// RTL prose with embedded Latin drug names sets `unicode-bidi: plaintext` on
// paragraphs, so «متفورمین 500 mg» keeps its digits and units in reading order.
//
// Two exports: `parseMarkdown(text)` → an AST (what the tests inspect) and
// `renderMarkdown(text, options)` → React nodes. `markdownToPlainText` is what
// the «کپی» action puts on the clipboard.

var $acw62 = parcelRequire("acw62");
// ── Block parsing ──────────────────────────────────────────────────────────
const $e6f062d53183f893$var$FENCE_RE = /^\s*```\s*([\w-]*)\s*$/;
const $e6f062d53183f893$var$HEADING_RE = /^\s{0,3}(#{1,6})\s+(.+?)\s*#*\s*$/;
const $e6f062d53183f893$var$HR_RE = /^\s{0,3}([-*_])(?:\s*\1){2,}\s*$/;
const $e6f062d53183f893$var$QUOTE_RE = /^\s{0,3}>\s?(.*)$/;
const $e6f062d53183f893$var$UL_RE = /^(\s*)[-*+]\s+(.*)$/;
const $e6f062d53183f893$var$OL_RE = /^(\s*)(\d{1,3})[.)]\s+(.*)$/;
const $e6f062d53183f893$var$TABLE_ROW_RE = /^\s*\|.*\|\s*$/;
const $e6f062d53183f893$var$TABLE_SEP_RE = /^\s*\|?\s*:?-{2,}:?\s*(\|\s*:?-{2,}:?\s*)*\|?\s*$/;
const $e6f062d53183f893$var$splitRow = (line)=>line.trim().replace(/^\|/, '').replace(/\|$/, '').split('|').map((c)=>c.trim());
function $e6f062d53183f893$export$bd6a2eae5de02ff5(text) {
    const lines = String(text ?? '').replace(/\r\n?/g, '\n').split('\n');
    const blocks = [];
    let i = 0;
    const para = [];
    const flushPara = ()=>{
        if (!para.length) return;
        blocks.push({
            type: 'paragraph',
            inlines: $e6f062d53183f893$export$c7679c2b5e355e6f(para.join(' '))
        });
        para.length = 0;
    };
    while(i < lines.length){
        const line = lines[i];
        if (!line.trim()) {
            flushPara();
            i += 1;
            continue;
        }
        const fence = $e6f062d53183f893$var$FENCE_RE.exec(line);
        if (fence) {
            flushPara();
            const lang = fence[1] || '';
            const body = [];
            i += 1;
            while(i < lines.length && !$e6f062d53183f893$var$FENCE_RE.test(lines[i])){
                body.push(lines[i]);
                i += 1;
            }
            i += 1; // the closing fence (or EOF)
            blocks.push({
                type: 'code',
                lang: lang,
                code: body.join('\n')
            });
            continue;
        }
        const heading = $e6f062d53183f893$var$HEADING_RE.exec(line);
        if (heading) {
            flushPara();
            // core.md §9.4: headings are «≤ h3» — an answer must never outrank the
            // page it sits in. The chat page owns the h1/h2 (the patient's name and
            // the thread title), so a model that opens with `# ارزیابی` must not
            // produce a second h1: to a screen reader the answer would read as a new
            // document, and the page outline would have two top-level headings.
            //
            // The three markdown tiers are therefore SHIFTED, not flattened —
            // `#`→h3, `##`→h4, `###`+→h5 — which keeps the relative hierarchy the
            // model expressed while starting below the page's own. Flattening every
            // level to h3 would have lost the structure of a long teaching answer.
            blocks.push({
                type: 'heading',
                level: Math.min(heading[1].length, 3) + 2,
                inlines: $e6f062d53183f893$export$c7679c2b5e355e6f(heading[2])
            });
            i += 1;
            continue;
        }
        if ($e6f062d53183f893$var$HR_RE.test(line)) {
            flushPara();
            blocks.push({
                type: 'hr'
            });
            i += 1;
            continue;
        }
        if ($e6f062d53183f893$var$QUOTE_RE.test(line)) {
            flushPara();
            const inner = [];
            while(i < lines.length && $e6f062d53183f893$var$QUOTE_RE.test(lines[i])){
                inner.push($e6f062d53183f893$var$QUOTE_RE.exec(lines[i])[1]);
                i += 1;
            }
            blocks.push({
                type: 'blockquote',
                children: $e6f062d53183f893$export$bd6a2eae5de02ff5(inner.join('\n'))
            });
            continue;
        }
        if ($e6f062d53183f893$var$TABLE_ROW_RE.test(line) && i + 1 < lines.length && $e6f062d53183f893$var$TABLE_SEP_RE.test(lines[i + 1])) {
            flushPara();
            const header = $e6f062d53183f893$var$splitRow(line).map($e6f062d53183f893$export$c7679c2b5e355e6f);
            i += 2;
            const rows = [];
            while(i < lines.length && $e6f062d53183f893$var$TABLE_ROW_RE.test(lines[i])){
                rows.push($e6f062d53183f893$var$splitRow(lines[i]).map($e6f062d53183f893$export$c7679c2b5e355e6f));
                i += 1;
            }
            blocks.push({
                type: 'table',
                header: header,
                rows: rows
            });
            continue;
        }
        if ($e6f062d53183f893$var$UL_RE.test(line) || $e6f062d53183f893$var$OL_RE.test(line)) {
            flushPara();
            const { list: list, next: next } = $e6f062d53183f893$var$parseList(lines, i, 0);
            blocks.push(list);
            i = next;
            continue;
        }
        para.push(line.trim());
        i += 1;
    }
    flushPara();
    return blocks;
}
/**
 * A list starting at `start`, nested ONE level: an item indented deeper than the
 * list's own indent opens a child list; anything deeper than that is folded into
 * the child (a third level is rare in an answer and not worth the recursion).
 */ function $e6f062d53183f893$var$parseList(lines, start, depth) {
    const first = $e6f062d53183f893$var$UL_RE.exec(lines[start]) || $e6f062d53183f893$var$OL_RE.exec(lines[start]);
    const ordered = Boolean($e6f062d53183f893$var$OL_RE.exec(lines[start]));
    const indent = first[1].length;
    const items = [];
    let i = start;
    while(i < lines.length){
        const line = lines[i];
        if (!line.trim()) break;
        const ul = $e6f062d53183f893$var$UL_RE.exec(line);
        const ol = $e6f062d53183f893$var$OL_RE.exec(line);
        const m = ul || ol;
        if (!m) {
            // A continuation line of the previous item.
            if (items.length && /^\s+/.test(line)) {
                items[items.length - 1].inlines.push(...$e6f062d53183f893$export$c7679c2b5e355e6f(` ${line.trim()}`));
                i += 1;
                continue;
            }
            break;
        }
        const lineIndent = m[1].length;
        if (lineIndent < indent) break;
        if (lineIndent > indent && items.length) {
            if (depth >= 1) {
                // Deeper than we nest: keep the text, drop the structure.
                items[items.length - 1].inlines.push(...$e6f062d53183f893$export$c7679c2b5e355e6f(` ${(ul ? ul[2] : ol[3]).trim()}`));
                i += 1;
                continue;
            }
            const { list: list, next: next } = $e6f062d53183f893$var$parseList(lines, i, depth + 1);
            items[items.length - 1].children = list;
            i = next;
            continue;
        }
        items.push({
            inlines: $e6f062d53183f893$export$c7679c2b5e355e6f(ul ? ul[2] : ol[3]),
            children: null
        });
        i += 1;
    }
    return {
        list: {
            type: 'list',
            ordered: ordered,
            items: items
        },
        next: i
    };
}
// ── Inline parsing ─────────────────────────────────────────────────────────
const $e6f062d53183f893$var$INLINE_RE = /(`+)([\s\S]*?[^`])\1(?!`)|\*\*(.+?)\*\*|__(.+?)__|\*([^*\n]+?)\*|_([^_\n]+?)_|\[([^\]]+)\]\(([^)\s]+)(?:\s+"[^"]*")?\)/g;
function $e6f062d53183f893$export$c7679c2b5e355e6f(text) {
    const src = String(text ?? '');
    const out = [];
    let last = 0;
    let m;
    // A FRESH regex per call, not the shared `INLINE_RE`. This function recurses
    // (a `**bold**` run is parsed again for what is inside it), and a `/g` regex
    // carries its `lastIndex` on the OBJECT: the inner call reset the shared one
    // to 0, so on returning, the outer loop re-matched the same run forever and
    // `parseInline('**b**')` never terminated — it exhausted the heap. Every
    // answer a model writes contains bold, so this hung the page.
    const re = new RegExp($e6f062d53183f893$var$INLINE_RE.source, 'g');
    // eslint-disable-next-line no-cond-assign
    while(m = re.exec(src)){
        if (m.index > last) out.push({
            type: 'text',
            text: src.slice(last, m.index)
        });
        if (m[2] != null) out.push({
            type: 'code',
            text: m[2]
        });
        else if (m[3] != null) out.push({
            type: 'strong',
            children: $e6f062d53183f893$export$c7679c2b5e355e6f(m[3])
        });
        else if (m[4] != null) out.push({
            type: 'strong',
            children: $e6f062d53183f893$export$c7679c2b5e355e6f(m[4])
        });
        else if (m[5] != null) out.push({
            type: 'em',
            children: $e6f062d53183f893$export$c7679c2b5e355e6f(m[5])
        });
        else if (m[6] != null) out.push({
            type: 'em',
            children: $e6f062d53183f893$export$c7679c2b5e355e6f(m[6])
        });
        else if (m[7] != null) out.push({
            type: 'link',
            text: m[7],
            url: m[8]
        });
        last = m.index + m[0].length;
        // A zero-length match cannot advance `lastIndex` on its own.
        if (m[0].length === 0) re.lastIndex += 1;
    }
    if (last < src.length) out.push({
        type: 'text',
        text: src.slice(last)
    });
    return out;
}
// ── Plain text (for the clipboard) ────────────────────────────────────────
const $e6f062d53183f893$var$inlineText = (nodes)=>(nodes || []).map((n)=>{
        if (n.type === 'text' || n.type === 'code' || n.type === 'link') return n.text;
        return $e6f062d53183f893$var$inlineText(n.children);
    }).join('');
function $e6f062d53183f893$export$3c51aeef3185641c(text) {
    const walk = (blocks)=>blocks.map((b)=>{
            switch(b.type){
                case 'heading':
                case 'paragraph':
                    return $e6f062d53183f893$var$inlineText(b.inlines);
                case 'code':
                    return b.code;
                case 'hr':
                    return "\u2014\u2014\u2014";
                case 'blockquote':
                    return walk(b.children).join('\n');
                case 'table':
                    return [
                        b.header,
                        ...b.rows
                    ].map((r)=>r.map($e6f062d53183f893$var$inlineText).join(' | ')).join('\n');
                case 'list':
                    return b.items.map((it, idx)=>`${b.ordered ? `${idx + 1}.` : "\u2022"} ${$e6f062d53183f893$var$inlineText(it.inlines)}${it.children ? `\n${walk([
                            it.children
                        ]).join('\n').replace(/^/gm, '  ')}` : ''}`).join('\n');
                default:
                    return '';
            }
        });
    return walk($e6f062d53183f893$export$bd6a2eae5de02ff5(text)).join('\n\n');
}
// ── React rendering ────────────────────────────────────────────────────────
const $e6f062d53183f893$var$h = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement;
const $e6f062d53183f893$var$STYLE = {
    p: {
        margin: '0 0 0.75em',
        lineHeight: 2,
        unicodeBidi: 'plaintext',
        overflowWrap: 'anywhere'
    },
    // Ranks h3–h5, never h1/h2 — see the heading branch in parseMarkdown. The
    // SIZES are unchanged from the three tiers this renderer always drew; only
    // the semantic rank moved down.
    h3: {
        margin: '1em 0 0.4em',
        fontSize: '1.125em',
        fontWeight: 800,
        lineHeight: 1.6
    },
    h4: {
        margin: '1em 0 0.4em',
        fontSize: '1.0625em',
        fontWeight: 800,
        lineHeight: 1.6
    },
    h5: {
        margin: '0.9em 0 0.35em',
        fontSize: '1em',
        fontWeight: 800,
        lineHeight: 1.6
    },
    code: {
        fontFamily: 'ui-monospace, Menlo, Consolas, monospace',
        fontSize: '0.875em',
        padding: '0.1em 0.35em',
        borderRadius: 6,
        background: 'rgba(0,0,0,0.06)',
        direction: 'ltr',
        unicodeBidi: 'isolate'
    },
    pre: {
        margin: 0,
        padding: '0.75rem 0.875rem',
        overflowX: 'auto',
        fontFamily: 'ui-monospace, Menlo, Consolas, monospace',
        fontSize: '0.8125em',
        lineHeight: 1.7,
        direction: 'ltr',
        textAlign: 'left',
        whiteSpace: 'pre'
    },
    preWrap: {
        position: 'relative',
        margin: '0 0 0.75em',
        borderRadius: 10,
        background: 'rgba(0,0,0,0.05)',
        border: '1px solid rgba(0,0,0,0.06)'
    },
    copy: {
        position: 'absolute',
        top: 6,
        insetInlineEnd: 6,
        fontSize: '0.75em',
        padding: '2px 8px',
        borderRadius: 6,
        border: '1px solid rgba(0,0,0,0.1)',
        background: '#fff',
        cursor: 'pointer',
        fontFamily: 'inherit'
    },
    ul: {
        margin: '0 0 0.75em',
        paddingInlineStart: '1.4em',
        lineHeight: 1.95
    },
    li: {
        margin: '0.15em 0',
        unicodeBidi: 'plaintext'
    },
    blockquote: {
        margin: '0 0 0.75em',
        paddingInlineStart: '0.875em',
        borderInlineStart: '3px solid rgba(0,0,0,0.12)',
        opacity: 0.9
    },
    tableWrap: {
        overflowX: 'auto',
        margin: '0 0 0.75em'
    },
    table: {
        borderCollapse: 'collapse',
        fontSize: '0.9em',
        minWidth: '100%'
    },
    th: {
        textAlign: 'start',
        padding: '6px 10px',
        borderBottom: '2px solid rgba(0,0,0,0.12)',
        fontWeight: 800,
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '6px 10px',
        borderBottom: '1px solid rgba(0,0,0,0.08)',
        verticalAlign: 'top'
    },
    hr: {
        border: 'none',
        borderTop: '1px solid rgba(0,0,0,0.12)',
        margin: '1em 0'
    }
};
function $e6f062d53183f893$var$renderInlines(nodes, keyPrefix) {
    return (nodes || []).map((n, idx)=>{
        const key = `${keyPrefix}-${idx}`;
        switch(n.type){
            case 'text':
                return n.text;
            case 'code':
                return $e6f062d53183f893$var$h('code', {
                    key: key,
                    style: $e6f062d53183f893$var$STYLE.code
                }, n.text);
            case 'strong':
                return $e6f062d53183f893$var$h('strong', {
                    key: key
                }, $e6f062d53183f893$var$renderInlines(n.children, key));
            case 'em':
                return $e6f062d53183f893$var$h('em', {
                    key: key
                }, $e6f062d53183f893$var$renderInlines(n.children, key));
            // No anchor: a model's link is text (core.md §9.4).
            case 'link':
                return $e6f062d53183f893$var$h('span', {
                    key: key,
                    'data-md-link': ''
                }, n.text);
            default:
                return null;
        }
    });
}
/** The fenced-code block, with its copy control. Its own component so it may hold state. */ function $e6f062d53183f893$var$CodeBlock({ code: code, lang: lang, labels: labels, onCopy: onCopy }) {
    const [copied, setCopied] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const copy = ()=>{
        onCopy?.(code);
        setCopied(true);
        setTimeout(()=>setCopied(false), 1500);
    };
    return $e6f062d53183f893$var$h('div', {
        style: $e6f062d53183f893$var$STYLE.preWrap,
        'data-md-code': lang || ''
    }, labels?.copy ? $e6f062d53183f893$var$h('button', {
        type: 'button',
        style: $e6f062d53183f893$var$STYLE.copy,
        onClick: copy,
        'aria-label': labels.copy
    }, copied ? labels.copied || labels.copy : labels.copy) : null, $e6f062d53183f893$var$h('pre', {
        style: $e6f062d53183f893$var$STYLE.pre
    }, $e6f062d53183f893$var$h('code', null, code)));
}
function $e6f062d53183f893$var$renderBlocks(blocks, keyPrefix, options) {
    return blocks.map((b, idx)=>{
        const key = `${keyPrefix}-${idx}`;
        switch(b.type){
            case 'paragraph':
                return $e6f062d53183f893$var$h('p', {
                    key: key,
                    style: $e6f062d53183f893$var$STYLE.p
                }, $e6f062d53183f893$var$renderInlines(b.inlines, key));
            case 'heading':
                {
                    const tag = `h${b.level}`;
                    return $e6f062d53183f893$var$h(tag, {
                        key: key,
                        style: $e6f062d53183f893$var$STYLE[tag]
                    }, $e6f062d53183f893$var$renderInlines(b.inlines, key));
                }
            case 'code':
                return $e6f062d53183f893$var$h($e6f062d53183f893$var$CodeBlock, {
                    key: key,
                    code: b.code,
                    lang: b.lang,
                    labels: options.labels,
                    onCopy: options.onCopy
                });
            case 'hr':
                return $e6f062d53183f893$var$h('hr', {
                    key: key,
                    style: $e6f062d53183f893$var$STYLE.hr
                });
            case 'blockquote':
                return $e6f062d53183f893$var$h('blockquote', {
                    key: key,
                    style: $e6f062d53183f893$var$STYLE.blockquote
                }, $e6f062d53183f893$var$renderBlocks(b.children, key, options));
            case 'list':
                return $e6f062d53183f893$var$h(b.ordered ? 'ol' : 'ul', {
                    key: key,
                    style: $e6f062d53183f893$var$STYLE.ul
                }, b.items.map((it, i)=>$e6f062d53183f893$var$h('li', {
                        key: `${key}-${i}`,
                        style: $e6f062d53183f893$var$STYLE.li
                    }, $e6f062d53183f893$var$renderInlines(it.inlines, `${key}-${i}`), it.children ? $e6f062d53183f893$var$renderBlocks([
                        it.children
                    ], `${key}-${i}-c`, options) : null)));
            case 'table':
                return $e6f062d53183f893$var$h('div', {
                    key: key,
                    style: $e6f062d53183f893$var$STYLE.tableWrap,
                    'data-md-table': ''
                }, $e6f062d53183f893$var$h('table', {
                    style: $e6f062d53183f893$var$STYLE.table
                }, $e6f062d53183f893$var$h('thead', null, $e6f062d53183f893$var$h('tr', null, b.header.map((c, i)=>$e6f062d53183f893$var$h('th', {
                        key: i,
                        style: $e6f062d53183f893$var$STYLE.th
                    }, $e6f062d53183f893$var$renderInlines(c, `${key}-h${i}`))))), $e6f062d53183f893$var$h('tbody', null, b.rows.map((r, ri)=>$e6f062d53183f893$var$h('tr', {
                        key: ri
                    }, r.map((c, ci)=>$e6f062d53183f893$var$h('td', {
                            key: ci,
                            style: $e6f062d53183f893$var$STYLE.td
                        }, $e6f062d53183f893$var$renderInlines(c, `${key}-r${ri}c${ci}`))))))));
            default:
                return null;
        }
    });
}
function $e6f062d53183f893$export$bd27f0c8b4b4eabc(text, options = {}) {
    return $e6f062d53183f893$var$renderBlocks($e6f062d53183f893$export$bd6a2eae5de02ff5(text), options.keyPrefix || 'md', options);
}
function $e6f062d53183f893$export$7460c8b7e4ce9582({ text: text, labels: labels, onCopy: onCopy, style: style, className: className, ...rest }) {
    const nodes = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$e6f062d53183f893$export$bd27f0c8b4b4eabc(text, {
            labels: labels,
            onCopy: onCopy
        }), [
        text,
        labels,
        onCopy
    ]);
    return $e6f062d53183f893$var$h('div', {
        className: className,
        style: {
            fontSize: '0.9375rem',
            ...style
        },
        'data-md': '',
        ...rest
    }, nodes);
}
var $e6f062d53183f893$export$2e2bcd8739ae039 = $e6f062d53183f893$export$bd27f0c8b4b4eabc;





// The assistant's turn — a DOCUMENT, not a bubble. core.md §9.3.
//
// A teaching answer is three paragraphs, a list of differentials and sometimes a
// table; a chat bubble sized to its content would put a 400-word answer in a
// rounded box with a tail, and the reader would lose the line every time it
// wrapped. So the assistant's turn is full-width prose on the page surface,
// exactly as ChatGPT renders one, and only the STUDENT's turn is a bubble.
//
// ── Three things this component must not do ─────────────────────────────
//
//   1. It must not render raw HTML. `lib/markdown.js` escapes it by
//      construction (every run becomes a React text node), which is why the
//      renderer is ours and not a dependency.
//   2. It must not turn a model's link into an anchor. `[x](url)` renders as
//      «x» — a model does not get to navigate the student's browser.
//   3. **👍/👎 are LOCAL.** There is no feedback field in the schema, no
//      mutation to carry one, and this component never sends one. They are a
//      reader's own note to themselves for the length of the page — a rating
//      quietly posted to a server the student did not choose is worse than no
//      rating at all.
const $b5968e9e8b9e7822$var$CONFIDENCE_TONE = {
    low: 'warning',
    medium: 'info',
    high: 'success'
};
function $b5968e9e8b9e7822$export$2e2bcd8739ae039({ message: message, revealText: revealText = null, confidence: confidence = null, showAnswerNote: showAnswerNote = false, onRegenerate: onRegenerate }) {
    const { t: t, formatTime: formatTime } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [copied, setCopied] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Never sent anywhere. See the header.
    const [vote, setVote] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const body = revealText != null ? revealText : message?.content || '';
    const cost = Number(message?.costParseh || 0);
    const copy = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const text = (0, $e6f062d53183f893$export$3c51aeef3185641c)(message?.content || '');
        try {
            navigator?.clipboard?.writeText?.(text);
        } catch  {
        /* a browser that refuses the clipboard must not take the page down */ }
        setCopied(true);
        setTimeout(()=>setCopied(false), 1500);
    }, [
        message
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
        "data-testid": "assistant-message",
        "data-message-id": message?.id,
        className: (0, $3ba6dc9522ab5f36$export$edd674b31191f8b),
        style: {
            alignSelf: 'stretch',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 12,
            padding: '14px 16px 10px',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 11.5,
                    fontWeight: 700,
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                    marginBottom: 6
                },
                children: t('chat.message.assistant')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6f062d53183f893$export$7460c8b7e4ce9582), {
                text: body,
                labels: {
                    copy: t('common.actions.copy'),
                    copied: t('common.actions.copied')
                },
                onCopy: (code)=>{
                    try {
                        navigator?.clipboard?.writeText?.(code);
                    } catch  {}
                }
            }),
            showAnswerNote ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$f9f72ca4b5e00695), {}) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    flexWrap: 'wrap',
                    marginTop: 10,
                    paddingTop: 8,
                    borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).border, 0.6)}`
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 11.5,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                        },
                        children: formatTime(message?.createdAtMs)
                    }),
                    confidence ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                        variant: $b5968e9e8b9e7822$var$CONFIDENCE_TONE[confidence] || 'info',
                        "data-testid": "confidence-pill",
                        children: `${t('chat.confidenceLabel')}: ${t(`chat.confidence.${confidence}`)}`
                    }) : null,
                    cost ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f5fb734a3b15afa$export$71d6ce43dc25b15f), {
                        cost: cost
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            flex: 1
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ba6dc9522ab5f36$export$c4f071d58a2bd092), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: (0, $3ba6dc9522ab5f36$export$c40ab4f350069aa2),
                        style: {
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                size: 30,
                                variant: "ghost",
                                icon: copied ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3fbaf9031554177f$export$2e2bcd8739ae039), {
                                    size: 15,
                                    "aria-hidden": true
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $807d71b9253536b4$export$2e2bcd8739ae039), {
                                    size: 15,
                                    "aria-hidden": true
                                }),
                                label: copied ? t('chat.message.copied') : t('chat.message.copy'),
                                onClick: copy,
                                "data-testid": "assistant-copy"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                size: 30,
                                variant: "ghost",
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96b330d9ae0cfa5e$export$2e2bcd8739ae039), {
                                    size: 15,
                                    "aria-hidden": true
                                }),
                                label: t('chat.message.regenerate'),
                                onClick: ()=>onRegenerate?.(message),
                                "data-testid": "assistant-regenerate"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                size: 30,
                                variant: vote === 'up' ? 'outline' : 'ghost',
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37dc1274e0a325ea$export$2e2bcd8739ae039), {
                                    size: 15,
                                    "aria-hidden": true
                                }),
                                label: t('chat.message.thumbsUp'),
                                onClick: ()=>setVote((v)=>v === 'up' ? null : 'up'),
                                "data-testid": "assistant-thumbs-up"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                size: 30,
                                variant: vote === 'down' ? 'outline' : 'ghost',
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13d983cdd962eaa4$export$2e2bcd8739ae039), {
                                    size: 15,
                                    "aria-hidden": true
                                }),
                                label: t('chat.message.thumbsDown'),
                                onClick: ()=>setVote((v)=>v === 'down' ? null : 'down'),
                                "data-testid": "assistant-thumbs-down"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


// The message column. core.md §9.3, §9.6.
//
// The kit's `ChatThread` already carries the two behaviours this screen must not
// re-derive: `role="log" aria-live="polite"` on the column, and backwards paging
// as a BUTTON rather than a scroll trigger. «پیام‌های قدیمی‌تر» loads sixty more;
// nothing here ever fires a fetch from a scroll position.
//
// The day dividers are computed once in Chat.shared.js against IRAN days, and
// `AiAnswerNote` rides under the LATEST assistant message only — under every one
// it becomes wallpaper, which is the failure mode a standing notice has.
/** The block that stands where the answer will be, while the unary call runs. */ function $9370fd2e98f1b3c1$var$TypingIndicator() {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "typing-indicator",
        style: {
            alignSelf: 'stretch',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 12,
            padding: '14px 16px',
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
            fontSize: 13
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                size: 16,
                thickness: 2,
                label: t('chat.message.typing')
            }),
            t('chat.composer.thinking')
        ]
    });
}
function $9370fd2e98f1b3c1$export$2e2bcd8739ae039({ messages: messages, reveal: reveal = null, confidence: confidence = null, sending: sending = false, hasOlder: hasOlder = false, loadingOlder: loadingOlder = false, onLoadOlder: onLoadOlder, onRetry: onRetry, onRegenerate: onRegenerate, fill: fill = true }) {
    const { t: t, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const rows = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $bcd6f0910828a2b0$export$ff046ac049e9556c)(messages), [
        messages
    ]);
    const latestAnswer = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $bcd6f0910828a2b0$export$ec583b67d7f48b51)(messages), [
        messages
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $af5a908f2b99a71b$export$2e2bcd8739ae039), {
        fill: fill,
        padBlockRem: 1,
        autoScroll: true,
        hasOlder: hasOlder,
        onLoadOlder: onLoadOlder,
        loadingOlder: loadingOlder,
        loadOlderLabel: loadingOlder ? t('chat.message.loadingOlder') : t('chat.message.older'),
        "data-testid": "chat-thread",
        children: [
            rows.map((row)=>{
                if (row.kind === 'day') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01fd1e3fa9bffaa8$export$2e2bcd8739ae039), {
                    label: formatDate(`${row.day}`, 'weekdayDayMonth')
                }, row.key);
                const message = row.message;
                if (message.role === 'assistant') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5968e9e8b9e7822$export$2e2bcd8739ae039), {
                    message: message,
                    revealText: reveal && reveal.id === message.id ? reveal.text : null,
                    confidence: message.id === latestAnswer ? confidence : null,
                    showAnswerNote: message.id === latestAnswer,
                    onRegenerate: onRegenerate
                }, row.key);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10fc17faabccb2a9$export$2e2bcd8739ae039), {
                    message: message,
                    onRetry: onRetry
                }, row.key);
            }),
            sending ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9370fd2e98f1b3c1$var$TypingIndicator, {}) : null
        ]
    });
}




var $acw62 = parcelRequire("acw62");




function $f11af3a637ad5cb9$export$2e2bcd8739ae039({ name: name, caseRecord: caseRecord = null, onPick: onPick }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const prompts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $bcd6f0910828a2b0$export$9acf0cb39b095d39)(caseRecord).map((p)=>({
                key: p.key,
                text: t(p.key, p.params)
            })), [
        caseRecord,
        t
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "chat-empty",
        style: {
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 14,
            padding: '24px 16px',
            textAlign: 'center'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                size: 30,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                "aria-hidden": true,
                strokeWidth: 1.5
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                style: {
                    margin: 0,
                    fontSize: 19,
                    fontWeight: 800,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                },
                children: t('chat.empty.title', {
                    name: name
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    margin: 0,
                    fontSize: 13,
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2,
                    lineHeight: 1.9,
                    maxWidth: 520
                },
                children: t('chat.empty.body')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'grid',
                    gap: 10,
                    width: '100%',
                    maxWidth: 640,
                    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                    marginTop: 4
                },
                children: prompts.map(({ key: key, text: text })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>onPick?.(text),
                        "data-testid": "suggested-prompt",
                        style: {
                            font: 'inherit',
                            fontSize: 13,
                            lineHeight: 1.8,
                            cursor: 'pointer',
                            textAlign: 'start',
                            padding: '12px 14px',
                            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                            borderRadius: 12,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                        },
                        children: text
                    }, key))
            })
        ]
    });
}



parcelRequire("acw62");


function $c0139a4e1d460d3b$export$2e2bcd8739ae039({ items: items, onPick: onPick, disabled: disabled = false }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const chips = (items || []).filter((s)=>String(s || '').trim());
    if (!chips.length) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "chat-followups",
        style: {
            padding: '8px 16px 0',
            display: 'flex',
            flexWrap: 'wrap',
            gap: 8,
            alignItems: 'center'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    fontSize: 11.5,
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                },
                children: t('chat.followUps')
            }),
            chips.map((text, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    disabled: disabled,
                    onClick: ()=>onPick?.(text),
                    "data-testid": "followup-chip",
                    style: {
                        font: 'inherit',
                        fontSize: 12.5,
                        cursor: disabled ? 'default' : 'pointer',
                        padding: '6px 12px',
                        borderRadius: 999,
                        border: `1px solid ${(0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal, 0.4)}`,
                        background: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal, 0.1),
                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk,
                        opacity: disabled ? 0.6 : 1
                    },
                    children: text
                }, `${i}-${text}`))
        ]
    });
}




var $acw62 = parcelRequire("acw62");







// The composer. core.md §9.2.
//
// The kit's `ChatComposer` owns the input behaviour a chat must not re-derive:
// Enter sends, Shift+Enter is a newline, an IME commit is never a send, the
// field auto-grows to 7.5rem and then scrolls, and the field is ≥1rem so iOS
// does not zoom the page on focus. This wrapper adds the three things that are
// THIS app's, not the kit's:
//
//   1. **The price, before the spend.** «۱۰ پارسه» rides in the row, from
//      constants/pricing.js — the same number the credits screen prints.
//   2. **The character counter, after 3 500.** Not before: a counter that is
//      always on turns a question into a form field.
//   3. **«توقف» while an answer is being revealed.** The reveal is animation
//      over a message that is already stored (core.md §8.6), so stopping loses
//      nothing — which is why this is a plain control and not a cancel.
//
// The stop control is drawn OVER the kit's send button rather than replacing
// it: the kit disables send while the field is empty (correct — an empty
// question must not be sendable), and «توقف» has to be pressable exactly then.
//
// `notice` is the closed set from useChat: the inline recovery of §9.5. The
// INSUFFICIENT_CREDITS one is a card with «شارژ» and never a retry, because a
// retry cannot succeed — the balance has not moved (core.md §3.5).
const $a7291ef1cc1b89d2$var$NOTICE_KEY = {
    invalid: 'errors.invalidInput',
    reserved: 'chat.composer.reserved',
    tooLong: 'chat.composer.tooLong',
    threadGone: 'chat.thread.notFound'
};
function $a7291ef1cc1b89d2$export$2e2bcd8739ae039({ value: value, onChange: onChange, onSend: onSend, onStop: onStop, sending: sending = false, revealing: revealing = false, disabled: disabled = false, offline: offline = false, outOfCredits: outOfCredits = false, notice: notice = null, onTopUp: onTopUp, focusSignal: focusSignal = 0 }) {
    // The policy's price once the list has arrived; the constant until then.
    const { costOf: costOf } = (0, $9449204a10cf7050$export$204bd72286fdb787)();
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const wrapRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const length = String(value || '').length;
    const showCounter = length >= (0, $44873a91bbebf8e0$export$4b58ec02f4a54c65);
    // Focus returns to the composer after a send (core.md §9.6). The textarea is
    // found through the DOM rather than a ref prop ON PURPOSE: the kit spreads
    // `inputProps` AFTER its own `ref`, so a ref passed that way replaces the
    // kit's and silently kills the auto-grow it uses that ref for.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!focusSignal) return;
        wrapRef.current?.querySelector('textarea')?.focus();
    }, [
        focusSignal
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: wrapRef,
        "data-testid": "chat-composer-wrap",
        style: {
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card
        },
        children: [
            notice === 'credits' || outOfCredits ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "error",
                title: t('chat.noCredits.title'),
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eea507cd16630bf5$export$2e2bcd8739ae039), {
                    size: 18,
                    "aria-hidden": true
                }),
                action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    size: "sm",
                    onClick: onTopUp,
                    children: t('chat.noCredits.action')
                }),
                "data-testid": "chat-out-of-credits",
                style: {
                    margin: '10px 16px 0'
                },
                children: t('chat.noCredits.body')
            }) : null,
            notice && notice !== 'credits' && notice !== 'empty' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                "data-testid": "chat-composer-notice",
                role: "alert",
                style: {
                    margin: '10px 16px 0',
                    fontSize: 12.5,
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk
                },
                children: t($a7291ef1cc1b89d2$var$NOTICE_KEY[notice] || 'errors.generic')
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '8px 16px 0',
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f5fb734a3b15afa$export$71d6ce43dc25b15f), {
                        cost: costOf('ASK'),
                        before: true
                    }),
                    showCounter ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        "data-testid": "chat-counter",
                        style: {
                            fontSize: 11.5,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
                        },
                        children: t('chat.composer.counter', {
                            count: formatNumber(length),
                            max: formatNumber((0, $44873a91bbebf8e0$export$d94a08ba4a00e9a6))
                        })
                    }) : null,
                    offline ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        "data-testid": "chat-offline",
                        style: {
                            fontSize: 11.5,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk
                        },
                        children: t('chat.composer.offline')
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    position: 'relative'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $27c9e9585cb6c9b4$export$2e2bcd8739ae039), {
                        value: value,
                        onChange: (e)=>onChange(e.target.value),
                        onSend: ()=>onSend(value),
                        sending: sending,
                        disabled: disabled || offline || outOfCredits,
                        maxLength: (0, $44873a91bbebf8e0$export$d94a08ba4a00e9a6),
                        placeholder: t('chat.composer.placeholder'),
                        sendLabel: t('chat.composer.send'),
                        inputProps: {
                            'data-testid': 'chat-input'
                        }
                    }),
                    revealing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            position: 'absolute',
                            insetInlineEnd: 16,
                            bottom: 8,
                            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                            borderRadius: 999
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5340d072e86ce769$export$2e2bcd8739ae039), {
                                size: 16,
                                "aria-hidden": true
                            }),
                            label: t('chat.composer.stop'),
                            onClick: onStop,
                            "data-testid": "chat-stop"
                        })
                    }) : null
                ]
            })
        ]
    });
}







function $f987f47a8defe3a5$export$2e2bcd8739ae039({ threadId: threadId, name: name, caseRecord: caseRecord, caseLoading: caseLoading, caseError: caseError, reloadCase: reloadCase, balance: balance, chat: chat, send: send, openThread: openThread, startNew: startNew, rename: rename, remove: remove, focusSignal: focusSignal, offline: offline, onBack: onBack, onTopUp: onTopUp, onSwitchPatient: onSwitchPatient, onOpenVisits: onOpenVisits }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [sidebarOpen, setSidebarOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $bcd6f0910828a2b0$export$fb440a97473a223a)((0, $7cdea07122bc6887$export$1ffff020952d8ba9)((0, $7cdea07122bc6887$export$f2729d139f5f76bb), {
            kind: 'local'
        })));
    const [menuOpen, setMenuOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [editingTitle, setEditingTitle] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [titleValue, setTitleValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [confirmDelete, setConfirmDelete] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const menuAnchor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const toggleSidebar = ()=>{
        setSidebarOpen((open)=>{
            (0, $7cdea07122bc6887$export$a89cf18a33e7b3d9)((0, $7cdea07122bc6887$export$f2729d139f5f76bb), (0, $bcd6f0910828a2b0$export$2011fc0fd6b64e28)(!open), {
                kind: 'local'
            });
            return !open;
        });
    };
    const title = (0, $44873a91bbebf8e0$export$264f2f5a3a5a9e08)(chat.thread, chat.pendingTitle || t('chat.thread.untitled'));
    const empty = !chat.loading && chat.messages.length === 0;
    // A KNOWN balance that cannot pay for one question disables the send and
    // shows the top-up card BEFORE the spend (core.md §3.5, §9.2). An unknown
    // balance allows it — the server is the real gate, and it refuses too.
    const outOfCredits = !(0, $9ffff9692ff7166c$export$876d611be39e5cf8)(balance, (0, $9449204a10cf7050$export$204bd72286fdb787)().costOf('ASK'));
    const commitTitle = async ()=>{
        setEditingTitle(false);
        if (chat.thread && titleValue.trim() !== title.trim()) await rename(chat.thread.id, titleValue.trim());
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            height: '100%',
            minHeight: 0,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg
        },
        children: [
            sidebarOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    width: (0, $9d5b68e145c838fb$export$780035d9fe48eb32),
                    flexShrink: 0,
                    minHeight: 0
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d5b68e145c838fb$export$2e2bcd8739ae039), {
                    threads: chat.threads,
                    loading: chat.threadsLoading,
                    activeThreadId: threadId,
                    balance: balance,
                    onNew: startNew,
                    onOpen: openThread,
                    onRename: rename,
                    onDelete: remove,
                    onSwitchPatient: onSwitchPatient,
                    onOpenVisits: onOpenVisits
                })
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                style: {
                    flex: 1,
                    minWidth: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            padding: '10px 16px',
                            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                size: 34,
                                variant: "ghost",
                                icon: sidebarOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9fd2e6ed94de5020$export$2e2bcd8739ae039), {
                                    size: 17,
                                    "aria-hidden": true
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0c275ac339c70ac$export$2e2bcd8739ae039), {
                                    size: 17,
                                    "aria-hidden": true
                                }),
                                label: t(sidebarOpen ? 'chat.sidebar.collapse' : 'chat.sidebar.expand'),
                                onClick: toggleSidebar,
                                "data-testid": "sidebar-toggle"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                size: 34,
                                variant: "ghost",
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a140ead2dcbdb51$export$2e2bcd8739ae039), {
                                    size: 17,
                                    "aria-hidden": true,
                                    style: {
                                        transform: 'scaleX(var(--dir-flip, 1))'
                                    }
                                }),
                                label: t('chat.header.back'),
                                onClick: onBack,
                                "data-testid": "chat-back"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    minWidth: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    flex: 1
                                },
                                children: [
                                    caseLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                        size: 16,
                                        label: t('common.labels.loading')
                                    }) : null,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        "data-testid": "chat-patient-name",
                                        style: {
                                            fontSize: 14.5,
                                            fontWeight: 800,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        },
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$480ec33bbf749db7), {
                                        short: true
                                    }),
                                    chat.thread ? editingTitle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                                        onSubmit: (e)=>{
                                            e.preventDefault();
                                            commitTitle();
                                        },
                                        style: {
                                            flex: 1,
                                            minWidth: 0
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            autoFocus: true,
                                            value: titleValue,
                                            "aria-label": t('chat.thread.renamePlaceholder'),
                                            placeholder: t('chat.thread.renamePlaceholder'),
                                            onChange: (e)=>setTitleValue(e.target.value),
                                            onBlur: commitTitle,
                                            onKeyDown: (e)=>{
                                                if (e.key === 'Escape') setEditingTitle(false);
                                            },
                                            "data-testid": "chat-title-input",
                                            style: {
                                                width: '100%',
                                                maxWidth: 340,
                                                font: 'inherit',
                                                fontSize: 13,
                                                padding: '6px 9px',
                                                borderRadius: 8,
                                                border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal}`,
                                                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                            }
                                        })
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>{
                                            setTitleValue(title);
                                            setEditingTitle(true);
                                        },
                                        "data-testid": "chat-title",
                                        title: t('chat.thread.renameTitle'),
                                        style: {
                                            font: 'inherit',
                                            fontSize: 13,
                                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2,
                                            cursor: 'text',
                                            background: 'transparent',
                                            border: 'none',
                                            padding: '4px 6px',
                                            maxWidth: 340,
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        },
                                        children: title
                                    }) : chat.pendingTitle ? // The unsaved conversation's title-to-be, while its first answer
                                    // is in flight. Not editable: there is nothing to rename yet.
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        "data-testid": "chat-title",
                                        style: {
                                            fontSize: 13,
                                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2,
                                            padding: '4px 6px',
                                            maxWidth: 340,
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        },
                                        children: chat.pendingTitle
                                    }) : null
                                ]
                            }),
                            chat.thread ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        ref: menuAnchor,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                            size: 34,
                                            variant: "ghost",
                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24a488cfd7efdee5$export$2e2bcd8739ae039), {
                                                size: 17,
                                                "aria-hidden": true
                                            }),
                                            label: t('chat.sidebar.menu'),
                                            onClick: ()=>setMenuOpen(true),
                                            "data-testid": "chat-header-menu"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $08d1958bc1315b40$export$2e2bcd8739ae039), {
                                        open: menuOpen,
                                        onClose: ()=>setMenuOpen(false),
                                        anchorRef: menuAnchor,
                                        width: 190,
                                        ariaLabel: t('chat.sidebar.menu'),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                role: "menuitem",
                                                onClick: ()=>{
                                                    setMenuOpen(false);
                                                    setTitleValue(title);
                                                    setEditingTitle(true);
                                                },
                                                style: $f987f47a8defe3a5$var$MENU_ROW,
                                                "data-testid": "chat-header-rename",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f9f3418dec68a42$export$2e2bcd8739ae039), {
                                                        size: 15,
                                                        "aria-hidden": true
                                                    }),
                                                    t('common.actions.rename')
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                role: "menuitem",
                                                onClick: ()=>{
                                                    setMenuOpen(false);
                                                    setConfirmDelete(true);
                                                },
                                                style: {
                                                    ...$f987f47a8defe3a5$var$MENU_ROW,
                                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk
                                                },
                                                "data-testid": "chat-header-delete",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1882f1d059ea7fa7$export$2e2bcd8739ae039), {
                                                        size: 15,
                                                        "aria-hidden": true
                                                    }),
                                                    t('common.actions.delete')
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$3c69499d0e994d3f), {
                        style: {
                            margin: '10px 16px 0'
                        }
                    }),
                    chat.error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9876d237fe8b99c$export$2e2bcd8739ae039), {
                        error: chat.error,
                        title: t('chat.error.title'),
                        onRetry: chat.reloadThreads,
                        fill: true
                    }) : caseError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9876d237fe8b99c$export$2e2bcd8739ae039), {
                        error: caseError,
                        onRetry: reloadCase,
                        fill: true
                    }) : chat.loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            flex: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                            label: t('common.labels.loading')
                        })
                    }) : empty ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f11af3a637ad5cb9$export$2e2bcd8739ae039), {
                        name: name,
                        caseRecord: caseRecord,
                        onPick: send
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9370fd2e98f1b3c1$export$2e2bcd8739ae039), {
                        messages: chat.messages,
                        reveal: chat.reveal,
                        confidence: chat.answer?.confidence,
                        sending: chat.sending,
                        hasOlder: chat.hasOlder,
                        loadingOlder: chat.loadingOlder,
                        onLoadOlder: chat.loadOlder,
                        onRetry: chat.retry,
                        onRegenerate: chat.regenerate
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0139a4e1d460d3b$export$2e2bcd8739ae039), {
                        items: chat.answer?.followUps,
                        onPick: send,
                        disabled: chat.sending
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7291ef1cc1b89d2$export$2e2bcd8739ae039), {
                        value: chat.draft,
                        onChange: chat.setDraft,
                        onSend: send,
                        onStop: chat.stopReveal,
                        sending: chat.sending,
                        revealing: chat.revealing,
                        offline: offline,
                        outOfCredits: outOfCredits,
                        notice: chat.notice,
                        onTopUp: onTopUp,
                        focusSignal: focusSignal
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
                open: confirmDelete,
                onOpenChange: setConfirmDelete,
                title: t('chat.thread.deleteTitle'),
                description: t('chat.thread.deleteBody'),
                confirmLabel: t('common.actions.delete'),
                cancelLabel: t('common.actions.cancel'),
                destructive: true,
                onConfirm: async ()=>{
                    if (chat.thread) await remove(chat.thread.id);
                    setConfirmDelete(false);
                },
                "data-testid": "chat-delete-confirm",
                confirmTestId: "chat-delete-confirm-confirm",
                cancelTestId: "chat-delete-confirm-cancel"
            })
        ]
    });
}
const $f987f47a8defe3a5$var$MENU_ROW = {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    width: '100%',
    padding: '10px 12px',
    background: 'transparent',
    border: 'none',
    font: 'inherit',
    fontSize: 13,
    cursor: 'pointer',
    textAlign: 'start',
    color: 'inherit'
};




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1f9a22d99de63c6e$export$a2387ed3b5d536eb = {
    name: "menu",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M4 5h16",
                key: "1tepv9"
            }
        ],
        [
            "path",
            {
                d: "M4 12h16",
                key: "1lakjw"
            }
        ],
        [
            "path",
            {
                d: "M4 19h16",
                key: "1djgab"
            }
        ]
    ]
};
$1f9a22d99de63c6e$export$a2387ed3b5d536eb.node;
const $1f9a22d99de63c6e$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($1f9a22d99de63c6e$export$a2387ed3b5d536eb);














function $158c76f5188db87d$export$2e2bcd8739ae039({ threadId: threadId, name: name, caseRecord: caseRecord, caseError: caseError, reloadCase: reloadCase, balance: balance, chat: chat, send: send, openThread: openThread, startNew: startNew, rename: rename, remove: remove, focusSignal: focusSignal, offline: offline, onBack: onBack, onTopUp: onTopUp, onSwitchPatient: onSwitchPatient, onOpenVisits: onOpenVisits }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [drawerOpen, setDrawerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const title = (0, $44873a91bbebf8e0$export$264f2f5a3a5a9e08)(chat.thread, chat.pendingTitle || t('chat.thread.untitled'));
    const empty = !chat.loading && chat.messages.length === 0;
    // A KNOWN balance that cannot pay for one question disables the send and
    // shows the top-up card BEFORE the spend (core.md §3.5, §9.2). An unknown
    // balance allows it — the server is the real gate, and it refuses too.
    const outOfCredits = !(0, $9ffff9692ff7166c$export$876d611be39e5cf8)(balance, (0, $9449204a10cf7050$export$204bd72286fdb787)().costOf('ASK'));
    const openAndClose = (id)=>{
        setDrawerOpen(false);
        openThread(id);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            minHeight: 0,
            overflow: 'hidden',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    padding: '8px 10px',
                    borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                    flexShrink: 0
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                        size: 38,
                        variant: "ghost",
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f9a22d99de63c6e$export$2e2bcd8739ae039), {
                            size: 18,
                            "aria-hidden": true
                        }),
                        label: t('chat.sidebar.title'),
                        onClick: ()=>setDrawerOpen(true),
                        "data-testid": "sidebar-toggle"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                        size: 38,
                        variant: "ghost",
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a140ead2dcbdb51$export$2e2bcd8739ae039), {
                            size: 18,
                            "aria-hidden": true,
                            style: {
                                transform: 'scaleX(var(--dir-flip, 1))'
                            }
                        }),
                        label: t('chat.header.back'),
                        onClick: onBack,
                        "data-testid": "chat-back"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            minWidth: 0,
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        "data-testid": "chat-patient-name",
                                        style: {
                                            fontSize: 14,
                                            fontWeight: 800,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        },
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$480ec33bbf749db7), {
                                        short: true
                                    })
                                ]
                            }),
                            chat.thread || chat.pendingTitle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                "data-testid": "chat-title",
                                style: {
                                    fontSize: 11.5,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                },
                                children: title
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$3c69499d0e994d3f), {
                style: {
                    margin: '8px 10px 0'
                }
            }),
            chat.error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9876d237fe8b99c$export$2e2bcd8739ae039), {
                error: chat.error,
                title: t('chat.error.title'),
                onRetry: chat.reloadThreads,
                fill: true
            }) : caseError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9876d237fe8b99c$export$2e2bcd8739ae039), {
                error: caseError,
                onRetry: reloadCase,
                fill: true
            }) : chat.loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                    label: t('common.labels.loading')
                })
            }) : empty ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f11af3a637ad5cb9$export$2e2bcd8739ae039), {
                name: name,
                caseRecord: caseRecord,
                onPick: send
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9370fd2e98f1b3c1$export$2e2bcd8739ae039), {
                messages: chat.messages,
                reveal: chat.reveal,
                confidence: chat.answer?.confidence,
                sending: chat.sending,
                hasOlder: chat.hasOlder,
                loadingOlder: chat.loadingOlder,
                onLoadOlder: chat.loadOlder,
                onRetry: chat.retry,
                onRegenerate: chat.regenerate
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0139a4e1d460d3b$export$2e2bcd8739ae039), {
                items: chat.answer?.followUps,
                onPick: send,
                disabled: chat.sending
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    flexShrink: 0,
                    paddingBottom: 'var(--app-bottom-nav, 0px)'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7291ef1cc1b89d2$export$2e2bcd8739ae039), {
                    value: chat.draft,
                    onChange: chat.setDraft,
                    onSend: send,
                    onStop: chat.stopReveal,
                    sending: chat.sending,
                    revealing: chat.revealing,
                    offline: offline,
                    outOfCredits: outOfCredits,
                    notice: chat.notice,
                    onTopUp: onTopUp,
                    focusSignal: focusSignal
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49383ac93d397699$export$2e2bcd8739ae039), {
                open: drawerOpen,
                onClose: ()=>setDrawerOpen(false),
                width: 280,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d5b68e145c838fb$export$2e2bcd8739ae039), {
                    threads: chat.threads,
                    loading: chat.threadsLoading,
                    activeThreadId: threadId,
                    balance: balance,
                    onNew: ()=>{
                        setDrawerOpen(false);
                        startNew();
                    },
                    onOpen: openAndClose,
                    onRename: rename,
                    onDelete: remove,
                    onSwitchPatient: onSwitchPatient,
                    onOpenVisits: onOpenVisits
                })
            })
        ]
    });
}


function $cc078d4f1de678f2$export$2e2bcd8739ae039() {
    const { caseId: caseId, threadId: threadId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const online = (0, $2a96b0bae45a4311$export$a32c5b7f472865fb)();
    const { caseRecord: caseRecord, loading: caseLoading, error: caseError, reload: reloadCase } = (0, $997567223d8312c8$export$308c2aefa3f9e20e)(caseId);
    const { balance: balance } = (0, $5bc9ff20f6a2b818$export$f637e1cf42d15a62)();
    // Bumped after every send; the composer focuses itself when it changes (§9.6).
    const [focusSignal, setFocusSignal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const onThreadCreated = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>{
        navigate('chat', {
            caseId: caseId,
            threadId: id,
            replace: true
        });
    }, [
        navigate,
        caseId
    ]);
    // The id comes off the URL either way; the toast «گفتگو پیدا نشد» (core.md
    // §7.6) is for a thread that is unknown, not this student's, or deleted in
    // another tab — NOT for one the student just deleted here, which already
    // toasts «گفتگو حذف شد».
    const onThreadGone = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((reason)=>{
        navigate('chat', {
            caseId: caseId,
            replace: true
        });
        if (reason === 'missing') toast.error(t('chat.thread.notFoundToast'));
    }, [
        navigate,
        caseId,
        toast,
        t
    ]);
    const onMoved = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        toast.success(t('chat.thread.movedToast'));
    }, [
        toast,
        t
    ]);
    const chat = (0, $aab0be9ad626c609$export$78fbdc5cd6078822)({
        caseId: caseId,
        threadId: threadId || null,
        onThreadCreated: onThreadCreated,
        onThreadGone: onThreadGone,
        onMoved: onMoved
    });
    const name = (0, $bcd6f0910828a2b0$export$3805f9b7fa77f6d4)(caseRecord, t('chat.header.patient'));
    const send = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (text)=>{
        const ok = await chat.send(text);
        setFocusSignal((n)=>n + 1);
        return ok;
    }, [
        chat
    ]);
    const openThread = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>{
        navigate('chat', {
            caseId: caseId,
            threadId: id
        });
    }, [
        navigate,
        caseId
    ]);
    const startNew = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        chat.startNew();
        navigate('chat', {
            caseId: caseId,
            replace: true
        });
    }, [
        chat,
        navigate,
        caseId
    ]);
    const rename = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (id, title)=>{
        const row = await chat.rename(id, title);
        if (row) toast.success(t('chat.thread.renamed'));
        return row;
    }, [
        chat,
        toast,
        t
    ]);
    const remove = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (id)=>{
        await chat.remove(id);
        toast.success(t('chat.thread.deleted'));
    }, [
        chat,
        toast,
        t
    ]);
    const props = {
        caseId: caseId,
        threadId: threadId || null,
        name: name,
        caseRecord: caseRecord,
        caseLoading: caseLoading,
        caseError: caseError,
        reloadCase: reloadCase,
        balance: balance,
        chat: chat,
        send: send,
        openThread: openThread,
        startNew: startNew,
        rename: rename,
        remove: remove,
        focusSignal: focusSignal,
        // `useOnlineStatus` returns an OBJECT, never a string — a truthiness check on
        // it is always true, which is how a sibling app shipped a permanently
        // "online" banner.
        offline: Boolean(online?.isOffline),
        onBack: ()=>navigate('patient', {
                caseId: caseId
            }),
        onTopUp: ()=>navigate('credits'),
        onSwitchPatient: ()=>navigate('patients'),
        onOpenVisits: ()=>navigate('patient', {
                caseId: caseId,
                tab: 'visits'
            })
    };
    return isMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $158c76f5188db87d$export$2e2bcd8739ae039), {
        ...props
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f987f47a8defe3a5$export$2e2bcd8739ae039), {
        ...props
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ffa913da585dd100$export$a2387ed3b5d536eb = {
    name: "message-square",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
                key: "18887p"
            }
        ]
    ]
};
$ffa913da585dd100$export$a2387ed3b5d536eb.node;
const $ffa913da585dd100$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($ffa913da585dd100$export$a2387ed3b5d536eb);










// The landing screen's pure helpers. core.md §7.6.
//
// Nothing new: the landing page picks a patient and a thread by exactly the
// rules the chat page itself uses, so it RE-EXPORTS them rather than restating
// them. A second definition of "which thread is the most recent" is a second
// thing to keep in step, and this screen exists only to hand the student to the
// other one.




function $7d5374e4784b9a0b$export$2e2bcd8739ae039() {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    // Every status: a conversation about an archived patient is still readable
    // (core.md §7.4 — archiving hides a patient from the working list, it does
    // not take their record away).
    const { cases: cases, loading: loading, error: error, reload: reload } = (0, $b7360dc72487f1e9$export$64430ce94e1a8342)({
        statuses: []
    });
    const [resolving, setResolving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [failed, setFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const withThreads = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(cases || []).filter((row)=>Number(row?.threadCount || 0) > 0).sort((a, b)=>Number(b?.updatedAtMs || 0) - Number(a?.updatedAtMs || 0)), [
        cases
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (loading) return undefined;
        const candidate = withThreads[0];
        if (!candidate) {
            setResolving(false);
            return undefined;
        }
        let alive = true;
        setResolving(true);
        (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$cb40171597afb9c8), {
            caseId: candidate.id,
            scope: (0, $aab0be9ad626c609$export$fba2bd9ccb85a7c2),
            encounterId: null
        }).then((data)=>{
            if (!alive) return;
            const newest = [
                ...data?.caseChatThreads || []
            ].sort((a, b)=>(0, $bcd6f0910828a2b0$export$7be5c82f70ff586c)(b) - (0, $bcd6f0910828a2b0$export$7be5c82f70ff586c)(a))[0];
            if (newest) {
                // REPLACE: `/chat` is a redirector, and a back button that returns to
                // a redirector re-redirects — a trap the student cannot leave.
                navigate('chat', {
                    caseId: candidate.id,
                    threadId: newest.id,
                    replace: true
                });
                return;
            }
            setResolving(false);
        }).catch((err)=>{
            if (!alive) return;
            console.error('[chat-landing] failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
            // A failed lookup falls back to the PICKER rather than to an error
            // page: the student can still choose a patient, which is all this
            // screen was ever going to do for them.
            setFailed(err);
            setResolving(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        loading,
        withThreads,
        navigate
    ]);
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9876d237fe8b99c$export$2e2bcd8739ae039), {
        error: error,
        onRetry: reload,
        fill: true
    });
    if (loading || resolving) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            padding: 48
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
            label: t('common.labels.loading')
        })
    });
    if (!cases.length) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8446477c3df1c126$export$2e2bcd8739ae039), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('patients.empty.title'),
        description: t('chat.landing.body'),
        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            onClick: ()=>navigate('patients'),
            children: t('chat.landing.new')
        }),
        fill: true,
        "data-testid": "chat-landing-empty"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            padding: 20,
            maxWidth: 720,
            margin: '0 auto'
        },
        "data-testid": "chat-landing-picker",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                style: {
                    fontSize: 18,
                    fontWeight: 800,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                    margin: '0 0 6px'
                },
                children: t('chat.landing.title')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    fontSize: 13,
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2,
                    lineHeight: 1.9,
                    margin: '0 0 16px'
                },
                children: t('chat.landing.body')
            }),
            failed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                role: "alert",
                style: {
                    fontSize: 12.5,
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk,
                    margin: '0 0 12px'
                },
                children: t('errors.unavailable')
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'grid',
                    gap: 8
                },
                children: cases.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>navigate('chat', {
                                caseId: row.id
                            }),
                        "data-testid": "chat-landing-case",
                        "aria-label": t('chat.landing.open', {
                            name: (0, $bcd6f0910828a2b0$export$3805f9b7fa77f6d4)(row)
                        }),
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            font: 'inherit',
                            fontSize: 13.5,
                            textAlign: 'start',
                            cursor: 'pointer',
                            padding: '12px 14px',
                            borderRadius: 12,
                            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ffa913da585dd100$export$2e2bcd8739ae039), {
                                size: 17,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    flex: 1,
                                    minWidth: 0,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                },
                                children: (0, $bcd6f0910828a2b0$export$3805f9b7fa77f6d4)(row)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5effdd9ebf7f983$export$480ec33bbf749db7), {
                                short: true
                            })
                        ]
                    }, row.id))
            })
        ]
    });
}



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");






// کیف پول — پارسه, and only پارسه.
//
// ── One of THREE kinds of money, and the other two are unreachable ─────────
//
//   wallet       پارسه / Parsina Coin — platform usage credit. THIS ONE.
//                `owner_type: "student"`, ledger unit TOMAN/PC.
//   accounting   patient ↔ clinic money, in WHOLE RIALS. Not reachable here.
//   subscription what a clinic pays Parsina. Not reachable here.
//
// `accounting`'s helpers divide by ten because its numbers are rials; this one's
// are not. Never carry a helper between them (CORE.md §8, hard rule 14). That is
// why nothing in this file imports `money.*` from the kit.
//
// ── There is no starter-grant mutation, and there must not be one ─────────
//
// The wallet AUTO-CREATES a wallet on its first balance read with
// `free_balance = FREE_MONTHLY_CREDITS = 500.0`, and refills it to 500 at each
// calendar-month rollover. So reading `myWalletBalance` IS the starter grant, and
// it renews itself. A `grantStarterCredit` mutation plus a "has been granted"
// flag would be a second source of truth that can disagree with the wallet, and
// would double-grant on any retry of a call whose response was lost.
//
// The balance itself lives in ./useMe.js — one copy, shared with the rail and the
// assistant — so this hook owns the transactions, the gift codes and the two
// actions, and reports a moved balance back to that store.

var $acw62 = parcelRequire("acw62");



// Which payment gateway the top-up flow uses, and how a Toman price maps onto
// each gateway's wire unit.
//
// THE WHOLE UI PRICES IN TOMAN. The gateways disagree about what they settle
// in — Sepehr (بانک صادرات / شاپرک) takes RIALS, Zarinpal takes Toman — and
// `topUpWallet(gateway, amount)` takes the amount in THE GATEWAY'S OWN WIRE
// UNIT. So the conversion happens once, here, at the moment an amount is handed
// to the BFF.
//
// The mismatch is SILENT in the direction that costs money: sending a Toman
// figure to Sepehr undercharges by 10× and the payment succeeds. Nothing errors,
// the student is credited, and the difference is only visible in a reconciliation
// nobody runs. That is the entire reason this file exists rather than a literal
// at the call site.
//
// Copied in shape from doctor-app/parsina.client.web/src/constants/paymentGateway.js
// so the two apps cannot disagree about a bank's unit.
// The gateway table is DATA — `rialsPerToman` decides what a payment is worth,
// and `toGatewayAmount` must not need a translator to compute it. Only the
// bank's display name is copy, so only that is a key.
const $5864eb411181aef7$export$839b863c97f80b96 = {
    sepehr: {
        labelKey: 'credits.gateway.saderat',
        unit: 'IRR',
        rialsPerToman: 10
    },
    zarinpal: {
        labelKey: 'credits.gateway.zarinpal',
        unit: 'IRT',
        rialsPerToman: 1
    }
};
const $5864eb411181aef7$export$bd634cd508c418bb = 'sepehr';
const $5864eb411181aef7$export$4b74478b9ac81d4f = 1000;
const $5864eb411181aef7$export$18053a58f12c6137 = (t, gateway = $5864eb411181aef7$export$bd634cd508c418bb)=>{
    const key = $5864eb411181aef7$export$839b863c97f80b96[gateway]?.labelKey;
    return key ? t(key) : '';
};
function $5864eb411181aef7$export$5fca33782a4a7d9f(amountToman, gateway = $5864eb411181aef7$export$bd634cd508c418bb) {
    const factor = $5864eb411181aef7$export$839b863c97f80b96[gateway]?.rialsPerToman ?? 1;
    return Math.round(Number(amountToman || 0) * factor);
}



const $c335d5137632c1b1$export$3bb5253e1fca72cd = [
    null,
    'credit',
    'debit'
];
function $c335d5137632c1b1$export$9df289bef152e95b({ page: page = 1, pageSize: pageSize = (0, $76567e4e635dac59$export$5716e8bcb003888d), type: type = null } = {}) {
    const [transactions, setTransactions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [totalCount, setTotalCount] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [nonce, setNonce] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let alive = true;
        setLoading(true);
        (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$4d820a05a5a74fb3), {
            limit: pageSize,
            offset: (0, $76567e4e635dac59$export$bfb063dcf959468d)(page, pageSize),
            type: type || null
        }).then((data)=>{
            if (!alive) return;
            setTransactions(data?.myWalletTransactions?.transactions || []);
            setTotalCount(data?.myWalletTransactions?.totalCount || 0);
            setError(null);
        }).catch((err)=>{
            if (!alive) return;
            console.error('[useWalletTransactions] failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
            setError(err);
            setTransactions([]);
            setTotalCount(0);
        }).finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        page,
        pageSize,
        type,
        nonce
    ]);
    return {
        transactions: transactions,
        totalCount: totalCount,
        loading: loading,
        error: error,
        reload: ()=>setNonce((n)=>n + 1)
    };
}
function $c335d5137632c1b1$export$67e83c350c566786() {
    const [codes, setCodes] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [nonce, setNonce] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let alive = true;
        setLoading(true);
        (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$401dcf97213f686c)).then((data)=>{
            if (!alive) return;
            setCodes(data?.myGiftCodes || []);
            setError(null);
        }).catch((err)=>{
            if (!alive) return;
            console.error('[useGiftCodes] failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
            setError(err);
            setCodes([]);
        }).finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        nonce
    ]);
    const reload = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setNonce((n)=>n + 1), []);
    /**
   * Check a code WITHOUT spending it.
   *
   * Returns null for an unknown code rather than throwing, because the schema
   * answers null rather than erroring: a typo belongs in the field as
   * «کد معتبر نیست», not in an error banner over the whole screen.
   */ const preview = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (code)=>{
        const value = String(code || '').trim();
        if (!value) return null;
        const data = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $3569e16be34bfe54$export$a981945c36fdd224), {
            code: value
        });
        return data?.giftCodePreview || null;
    }, []);
    /**
   * Spend a code and receive its پارسه.
   *
   * The BFF marks the code spent in `marketing` FIRST and only then asks the
   * wallet to grant — mark-then-grant under-delivers if it breaks (recoverable,
   * and the resolver releases the code back), while grant-then-mark
   * OVER-delivers: پارسه out the door with the code still live. That order is the
   * design and it lives on the server; nothing this client does can change it,
   * and nothing here should retry a redemption on the student's behalf.
   *
   * The result carries the balance AFTER the grant landed, so it is adopted
   * directly rather than triggering another read that could race an AI spend and
   * make the redemption look smaller than it was.
   */ const redeem = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (code)=>{
        const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$2b5e21930ca1984a), {
            code: String(code || '').trim()
        });
        const result = data?.redeemGiftCode || null;
        if (result?.balance?.balance != null) (0, $5bc9ff20f6a2b818$export$dabfdc709ddf95dd)(result.balance.balance);
        reload();
        return result;
    }, [
        reload
    ]);
    return {
        codes: codes,
        loading: loading,
        error: error,
        reload: reload,
        preview: preview,
        redeem: redeem
    };
}
function $c335d5137632c1b1$export$64e212e524010641() {
    const [starting, setStarting] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const start = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ({ amountToman: amountToman, description: description, returnUrl: returnUrl })=>{
        setStarting(true);
        try {
            const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $3569e16be34bfe54$export$d895bafe49428d37), {
                gateway: (0, $5864eb411181aef7$export$bd634cd508c418bb),
                amount: (0, $5864eb411181aef7$export$5fca33782a4a7d9f)(amountToman, (0, $5864eb411181aef7$export$bd634cd508c418bb)),
                description: description || null,
                // Where the BROWSER lands after paying. Where the GATEWAY posts its
                // result is not a client input — that endpoint has to parse a bank's
                // POST and settle the wallet, and it is the wallet's own callback.
                returnUrl: returnUrl || `${window.location.origin}/credits`
            });
            return data?.topUpWallet || null;
        } finally{
            setStarting(false);
        }
    }, []);
    return {
        start: start,
        starting: starting
    };
}
function $c335d5137632c1b1$export$c34addee860b0acb({ page: page = 1, pageSize: pageSize = (0, $76567e4e635dac59$export$5716e8bcb003888d), type: type = null } = {}) {
    const ledger = $c335d5137632c1b1$export$9df289bef152e95b({
        page: page,
        pageSize: pageSize,
        type: type
    });
    const gifts = $c335d5137632c1b1$export$67e83c350c566786();
    const topUp = $c335d5137632c1b1$export$64e212e524010641();
    return {
        ledger: ledger,
        gifts: gifts,
        topUp: topUp,
        refreshBalance: // Re-read after returning from the bank, where the credit landed through the
        // wallet's own HTTP callback and nothing in this tab was told about it.
        $5bc9ff20f6a2b818$export$3437bf7ab4f0acaf
    };
}
var $c335d5137632c1b1$export$2e2bcd8739ae039 = $c335d5137632c1b1$export$c34addee860b0acb;








var $acw62 = parcelRequire("acw62");






// پارسه — the credits screen's vocabulary and arithmetic, shared by both surfaces.
//
// Modelled on doctor-app/parsina.client.web/src/screens/Credits/Credits.shared.js,
// reduced to what a student panel actually spends on: three AI actions, a top-up
// and a gift code. The doctor screen's per-visit KPIs, date-range presets and
// service breakdown are deliberately absent — this app has no visits, and a
// student reading «میانگین هر ویزیت» would be reading about somebody else's job.
//
// ── The unit trap this file exists to hold ────────────────────────────────
//
// پارسه is ONE of three kinds of money on this platform, and the other two are
// unreachable from here: `accounting` holds patient↔clinic money in WHOLE RIALS
// (its `formatMoney` divides by ten), and `subscription` holds what a clinic pays
// Parsina. Never carry a helper between them. Nothing in this file imports the
// kit's `money.*` for exactly that reason — پارسه is a COUNT, not a currency, and
// it is formatted by `fmtParseh` in src/constants/pricing.js.


// ── The wallet's service vocabulary ────────────────────────────────────────
//
// The ledger's `serviceType` is the WALLET's enum, not this app's. Old rows store
// the proto enum INTEGER as a string ("2", "3", "4") and newer ones the name,
// sometimes prefixed `SERVICE_TYPE_`. All three shapes are normalised to one key
// before anything is looked up.
const $884b9b27c085fa62$var$SERVICE_TYPE_INT_MAP = {
    2: 'AI_TRANSCRIPTION',
    3: 'AI_LLM_SUMMARY',
    4: 'AI_INTERACTION_CHECK'
};
function $884b9b27c085fa62$export$856ef076f8da864a(rawType) {
    const resolved = $884b9b27c085fa62$var$SERVICE_TYPE_INT_MAP[rawType] || rawType;
    return String(resolved || '').replace(/^SERVICE_TYPE_/, '');
}
const $884b9b27c085fa62$export$e3affe3b4eb78190 = {
    AI_LLM_SUMMARY: 'credits.service.ask',
    AI_INTERACTION_CHECK: 'credits.service.interaction',
    AI_TRANSCRIPTION: 'credits.service.transcription',
    GIFT_CODE: 'credits.service.gift',
    TOP_UP: 'credits.service.topup',
    TOPUP: 'credits.service.topup',
    SMS: 'credits.service.sms'
};
const $884b9b27c085fa62$export$6a30b7efbe4b7934 = 'credits.service.other';
const $884b9b27c085fa62$export$bc8b9ee807989176 = (rawType)=>$884b9b27c085fa62$export$e3affe3b4eb78190[$884b9b27c085fa62$export$856ef076f8da864a(rawType)] || $884b9b27c085fa62$export$6a30b7efbe4b7934;
function $884b9b27c085fa62$export$18593dd4b5ca396c(raw) {
    if (!raw) return '';
    try {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') return String(parsed.action || '');
        return String(parsed || '');
    } catch  {
        return String(raw);
    }
}
const $884b9b27c085fa62$export$99bd8667ae886e8 = (parseh)=>Math.round(Number(parseh || 0) * (0, $9449204a10cf7050$export$2059389b3f9c68ee)());
const $884b9b27c085fa62$export$e1f0d5c8c033dbbd = (0, $5864eb411181aef7$export$4b74478b9ac81d4f);
function $884b9b27c085fa62$export$a485709e1bca3633(value) {
    const folded = String(value ?? '')// Persian and Arabic-Indic digits, so a student typing on a Persian keyboard
    // is not told their amount is invalid. The BFF is not asked to guess.
    .replace(/[۰-۹]/g, (d)=>String("\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9".indexOf(d))) // i18n-exempt: digit folding, not copy
    .replace(/[٠-٩]/g, (d)=>String("\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669".indexOf(d))) // i18n-exempt: digit folding, not copy
    .replace(/[^\d]/g, '');
    return folded ? Number(folded) : NaN;
}
const $884b9b27c085fa62$export$4c72f7857500a9fa = [
    'issued',
    'redeemed',
    'revoked',
    'expired'
];
const $884b9b27c085fa62$export$3cb0743614902a7b = (status)=>`credits.gift.status.${$884b9b27c085fa62$export$4c72f7857500a9fa.includes(status) ? status : 'issued'}`;
const $884b9b27c085fa62$export$bc954a8dc14f3e01 = (status)=>{
    if (status === 'redeemed') return 'success';
    if (status === 'revoked' || status === 'expired') return 'outline';
    return 'warning';
};
const $884b9b27c085fa62$export$3bb5253e1fca72cd = [
    {
        id: 'all',
        value: null,
        labelKey: 'credits.tx.filter.all'
    },
    {
        id: 'credit',
        value: 'credit',
        labelKey: 'credits.tx.filter.credit'
    },
    {
        id: 'debit',
        value: 'debit',
        labelKey: 'credits.tx.filter.debit'
    }
];


function $3c7a01c4f8ee14ce$export$2e2bcd8739ae039({ topUp: topUp }) {
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $9ffff9692ff7166c$export$7e3773b326602d81));
    const [custom, setCustom] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [problem, setProblem] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const customToman = (0, $884b9b27c085fa62$export$a485709e1bca3633)(custom);
    const usingCustom = custom.trim().length > 0;
    const amountToman = usingCustom ? Number.isFinite(customToman) ? customToman : 0 : (0, $884b9b27c085fa62$export$99bd8667ae886e8)(selected);
    const start = async ()=>{
        if (!Number.isFinite(amountToman) || amountToman < (0, $884b9b27c085fa62$export$e1f0d5c8c033dbbd)) {
            setProblem('min');
            return;
        }
        setProblem('');
        try {
            const result = await topUp.start({
                amountToman: amountToman,
                description: t('credits.topUp.title')
            });
            if (!result?.paymentUrl) {
                toast.error(t('credits.topUp.failed'));
                return;
            }
            // FULL PAGE. Never an iframe — see the header.
            window.location.href = result.paymentUrl;
        } catch (err) {
            console.error('[topup] failed:', err?.message);
            toast.error(t('credits.topUp.failed'));
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            width: 34,
                            height: 34,
                            borderRadius: 10,
                            background: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal, 0.16),
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk,
                            display: 'grid',
                            placeItems: 'center',
                            flexShrink: 0
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eea507cd16630bf5$export$2e2bcd8739ae039), {
                            size: 18,
                            "aria-hidden": true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 14,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                        },
                        children: t('credits.topUp.title')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
                    gap: 8
                },
                children: (0, $9ffff9692ff7166c$export$41ee723fb8b6f73).map((parseh)=>{
                    const active = !usingCustom && parseh === selected;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>{
                            setSelected(parseh);
                            setCustom('');
                            setProblem('');
                        },
                        "aria-pressed": active,
                        style: {
                            minHeight: 76,
                            padding: '10px 8px',
                            border: `1.5px solid ${active ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                            borderRadius: 12,
                            background: active ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal, 0.1) : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                            cursor: 'pointer',
                            fontFamily: 'inherit',
                            textAlign: 'center',
                            position: 'relative'
                        },
                        children: [
                            parseh === (0, $9ffff9692ff7166c$export$7e3773b326602d81) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                variant: "success",
                                style: {
                                    position: 'absolute',
                                    insetInlineEnd: 6,
                                    top: 6,
                                    fontSize: 9
                                },
                                children: t('credits.topUp.recommended')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 18,
                                    fontWeight: 800,
                                    color: active ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                },
                                children: (0, $9ffff9692ff7166c$export$63e20163a2b1658b)(parseh, formatNumber)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 10.5,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: t('common.units.parseh')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    fontSize: 11,
                                    fontWeight: 700,
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2,
                                    marginTop: 4
                                },
                                children: [
                                    formatNumber((0, $884b9b27c085fa62$export$99bd8667ae886e8)(parseh)),
                                    " ",
                                    t('common.units.tomanShort')
                                ]
                            })
                        ]
                    }, parseh);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: t('credits.topUp.customLabel'),
                value: custom,
                onChange: (e)=>{
                    setCustom(e.target.value);
                    setProblem('');
                },
                placeholder: t('credits.topUp.custom'),
                // A digit run, so LTR and a numeric keypad. Persian digits typed here are
                // folded by `parseTomanInput` rather than rejected.
                dir: "ltr",
                inputMode: "numeric",
                maxLength: 12,
                error: problem === 'min' ? t('credits.topUp.min', {
                    amount: (0, $884b9b27c085fa62$export$e1f0d5c8c033dbbd)
                }) : '',
                "data-testid": "topup-custom"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                onClick: start,
                disabled: topUp.starting,
                className: "w-full",
                "data-testid": "topup-pay",
                children: [
                    topUp.starting ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                        size: 14,
                        color: "#fff"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eea507cd16630bf5$export$2e2bcd8739ae039), {
                        size: 16,
                        "aria-hidden": true
                    }),
                    topUp.starting ? t('credits.topUp.redirecting') : t('credits.topUp.pay', {
                        amount: formatNumber(amountToman),
                        gateway: (0, $5864eb411181aef7$export$18053a58f12c6137)(t, (0, $5864eb411181aef7$export$bd634cd508c418bb))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    margin: 0,
                    fontSize: 11,
                    lineHeight: 1.9,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                },
                children: t('credits.topUp.note')
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $651fad2ecae15970$export$a2387ed3b5d536eb = {
    name: "gift",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 7v14",
                key: "1akyts"
            }
        ],
        [
            "path",
            {
                d: "M20 11v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8",
                key: "1sqzm4"
            }
        ],
        [
            "path",
            {
                d: "M7.5 7a1 1 0 0 1 0-5A4.8 8 0 0 1 12 7a4.8 8 0 0 1 4.5-5 1 1 0 0 1 0 5",
                key: "kc0143"
            }
        ],
        [
            "rect",
            {
                x: "3",
                y: "7",
                width: "18",
                height: "4",
                rx: "1",
                key: "1hberx"
            }
        ]
    ]
};
$651fad2ecae15970$export$a2387ed3b5d536eb.node;
const $651fad2ecae15970$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($651fad2ecae15970$export$a2387ed3b5d536eb);







function $63da91af56ebc85e$export$2e2bcd8739ae039({ gifts: gifts, onRedeemed: onRedeemed }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [preview, setPreview] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [done, setDone] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    /**
   * Look the code up WITHOUT spending it, once the student stops typing.
   *
   * `giftCodePreview` returns null for an unknown code rather than erroring, so a
   * typo shows «کد معتبر نیست» under the field and never an error banner over the
   * screen. It costs nothing and is not a redemption.
   */ const checkCode = async ()=>{
        const code = value.trim();
        setPreview(null);
        if (!code) return;
        try {
            const found = await gifts.preview(code);
            setPreview(found);
            setError(found ? '' : 'credits.gift.notFound');
        } catch (err) {
            // A failed PREVIEW is not a failed redemption and must not read like one:
            // the student can still press «استفاده», and the server is the real check.
            console.warn('[gift] preview failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
        }
    };
    const submit = async (e)=>{
        e.preventDefault();
        if (busy) return;
        const code = value.trim();
        if (!code) {
            setError('credits.gift.empty');
            return;
        }
        setError('');
        setBusy(true);
        try {
            const result = await gifts.redeem(code);
            setDone(result);
            setValue('');
            setPreview(null);
            onRedeemed?.(result);
        } catch (err) {
            const code2 = (0, $206625c7d33bd390$export$dbfe74f291058e97)(err);
            if (code2 === 'GIFT_NOT_FOUND') setError('credits.gift.notFound');
            else if (code2 === 'GIFT_NOT_USABLE' || code2 === 'GIFT_GRANT_FAILED') {
                // The server's own message says WHICH — used, expired, revoked, or the
                // one case where the code was spent and the پارسه did not land. It is
                // shown verbatim rather than folded onto «کد معتبر نیست», because those
                // are different problems and only one of them needs support.
                setError('');
                toast.error(err?.message || t('errors.generic'));
            } else {
                console.error('[gift] redeem failed:', code2 || err?.message);
                toast.error(t('errors.generic'));
            }
        } finally{
            setBusy(false);
        }
    };
    if (done) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        style: {
            border: `1.5px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).green}`,
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            width: 38,
                            height: 38,
                            borderRadius: '50%',
                            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green,
                            color: '#fff',
                            display: 'grid',
                            placeItems: 'center',
                            flexShrink: 0
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3fbaf9031554177f$export$2e2bcd8739ae039), {
                            size: 20,
                            "aria-hidden": true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 14,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                        },
                        children: t('credits.gift.success', {
                            parseh: (0, $9ffff9692ff7166c$export$63e20163a2b1658b)(done.granted, formatNumber)
                        })
                    })
                ]
            }),
            done.balance?.balance != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 12.5,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                        },
                        children: t('credits.gift.newBalance')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 14,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk
                        },
                        dir: "ltr",
                        children: (0, $9ffff9692ff7166c$export$63e20163a2b1658b)(done.balance.balance, formatNumber)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                variant: "outline",
                onClick: ()=>setDone(null),
                children: t('common.actions.close')
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            width: 34,
                            height: 34,
                            borderRadius: 10,
                            background: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.1),
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
                            display: 'grid',
                            placeItems: 'center',
                            flexShrink: 0
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $651fad2ecae15970$export$2e2bcd8739ae039), {
                            size: 18,
                            "aria-hidden": true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 14,
                                    fontWeight: 800,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                },
                                children: t('credits.gift.title')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 11.5,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: t('credits.gift.hint')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: submit,
                style: {
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        value: value,
                        onChange: (e)=>setValue(e.target.value),
                        onBlur: checkCode,
                        placeholder: t('credits.gift.placeholder'),
                        // See the header: forced LTR so the code the student proofreads is the
                        // code that is sent.
                        dir: "ltr",
                        disabled: busy,
                        maxLength: 64,
                        error: error ? t(error) : '',
                        style: {
                            flex: 1
                        },
                        "data-testid": "gift-code"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        type: "submit",
                        disabled: busy,
                        "data-testid": "gift-submit",
                        children: [
                            busy ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                size: 14,
                                color: "#fff"
                            }) : null,
                            busy ? t('credits.gift.submitting') : t('credits.gift.submit')
                        ]
                    })
                ]
            }),
            preview && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "info",
                children: t('credits.gift.worth', {
                    parseh: (0, $9ffff9692ff7166c$export$63e20163a2b1658b)(preview.parseh, formatNumber)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    margin: 0,
                    fontSize: 11,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                },
                children: t('credits.gift.oneUse')
            }),
            gifts.codes.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 12,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                            marginBottom: 8
                        },
                        children: t('credits.gift.myCodes')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 6
                        },
                        children: gifts.codes.map((code)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    flexWrap: 'wrap',
                                    padding: '6px 0',
                                    borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: 12.5,
                                            fontWeight: 700,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                        },
                                        dir: "ltr",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                unicodeBidi: 'isolate'
                                            },
                                            children: code.code
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                        variant: (0, $884b9b27c085fa62$export$bc954a8dc14f3e01)(code.status),
                                        children: t((0, $884b9b27c085fa62$export$3cb0743614902a7b)(code.status))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: 11.5,
                                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
                                        },
                                        children: t('credits.gift.worth', {
                                            parseh: (0, $9ffff9692ff7166c$export$63e20163a2b1658b)(code.parseh, formatNumber)
                                        })
                                    }),
                                    code.redeemedAtMs && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            marginInlineStart: 'auto',
                                            fontSize: 11,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                        },
                                        children: formatDate(code.redeemedAtMs, 'numeric')
                                    })
                                ]
                            }, code.id))
                    })
                ]
            })
        ]
    });
}



parcelRequire("acw62");

/**
 * @license lucide-react v1.45.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b9d1da00c6e56295$export$a2387ed3b5d536eb = {
    name: "receipt",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 17V7",
                key: "pyj7ub"
            }
        ],
        [
            "path",
            {
                d: "M16 8h-6a2 2 0 0 0 0 4h4a2 2 0 0 1 0 4H8",
                key: "1elt7d"
            }
        ],
        [
            "path",
            {
                d: "M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z",
                key: "ycz6yz"
            }
        ]
    ]
};
$b9d1da00c6e56295$export$a2387ed3b5d536eb.node;
const $b9d1da00c6e56295$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($b9d1da00c6e56295$export$a2387ed3b5d536eb);







function $6c21942088ced4e6$export$2e2bcd8739ae039({ ledger: ledger, filter: filter, onFilter: onFilter, page: page, onPage: onPage, compact: compact = false }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const columns = [
        {
            key: 'date',
            header: t('credits.tx.columns.date'),
            width: 130,
            render: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        fontSize: 12.5,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                    },
                    children: formatDate(row.createdAt, 'numeric')
                })
        },
        {
            key: 'service',
            header: t('credits.tx.columns.service'),
            render: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        fontWeight: 700,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                    },
                    children: t((0, $884b9b27c085fa62$export$bc8b9ee807989176)(row.serviceType))
                })
        },
        {
            key: 'description',
            header: t('credits.tx.columns.description'),
            render: (row)=>{
                // The wallet's own description, when it carries a readable one. Token
                // counts and the model name are stripped by `transactionTitle` — those
                // are the platform's unit economics, not the student's.
                const title = (0, $884b9b27c085fa62$export$18593dd4b5ca396c)(row.description);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        fontSize: 12.5,
                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
                    },
                    children: title || t('common.labels.none')
                });
            }
        },
        {
            key: 'amount',
            header: t('credits.tx.columns.amount'),
            width: 110,
            align: 'end',
            render: (row)=>{
                const debit = row.type === 'debit';
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        fontWeight: 800,
                        color: debit ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green
                    },
                    dir: "ltr",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        style: {
                            unicodeBidi: 'isolate'
                        },
                        children: [
                            debit ? "\u2212" : '+',
                            (0, $9ffff9692ff7166c$export$63e20163a2b1658b)(row.amount, formatNumber)
                        ]
                    })
                });
            }
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        style: {
            padding: 0,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    flexWrap: 'wrap',
                    padding: '12px 14px',
                    borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 13.5,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                        },
                        children: t('credits.tx.title')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            display: 'flex',
                            gap: 6,
                            marginInlineStart: 'auto',
                            flexWrap: 'wrap'
                        },
                        children: (0, $884b9b27c085fa62$export$3bb5253e1fca72cd).map(({ id: id, value: value, labelKey: labelKey })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                label: t(labelKey),
                                active: (filter || null) === value,
                                onClick: ()=>onFilter(value)
                            }, id))
                    })
                ]
            }),
            ledger.error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                title: t('credits.tx.error.title'),
                onRetry: ledger.reload,
                retryLabel: t('common.actions.retry')
            }) : ledger.loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: 20
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                    lines: compact ? 4 : 8
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                        columns: compact ? columns.filter((c)=>c.key !== 'description') : columns,
                        rows: ledger.transactions,
                        rowKey: (row)=>row.id,
                        dense: compact,
                        empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9d1da00c6e56295$export$2e2bcd8739ae039), {
                                size: 40,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                            }),
                            title: t('credits.tx.empty.title'),
                            description: t('credits.tx.empty.body')
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bca3244df749c49$export$2e2bcd8739ae039), {
                        page: page,
                        total: ledger.totalCount,
                        pageSize: (0, $76567e4e635dac59$export$5716e8bcb003888d),
                        onChange: onPage
                    })
                ]
            })
        ]
    });
}


function $48ab62c8c643bc72$export$2e2bcd8739ae039() {
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    // The policy's figures once the list has arrived; the shipped constants until then.
    const { priceList: priceList } = (0, $9449204a10cf7050$export$204bd72286fdb787)();
    const { balance: balance, loading: loading } = (0, $5bc9ff20f6a2b818$export$f637e1cf42d15a62)();
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const filter = searchParams.get('type') || null;
    const urlPage = Number(searchParams.get('page')) || 1;
    const { ledger: ledger, gifts: gifts, topUp: topUp, refreshBalance: refreshBalance } = (0, $c335d5137632c1b1$export$c34addee860b0acb)({
        page: urlPage,
        pageSize: (0, $76567e4e635dac59$export$5716e8bcb003888d),
        type: filter
    });
    // Returning from the bank: the wallet's own HTTP callback credited the wallet
    // and nothing in this tab was told about it. One re-read on mount is what turns
    // «۳۲۰» back into the number the student just paid for.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        refreshBalance();
    }, [
        refreshBalance
    ]);
    const page = (0, $76567e4e635dac59$export$37065cd88a320a11)(urlPage, ledger.totalCount, (0, $76567e4e635dac59$export$5716e8bcb003888d));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (ledger.loading || ledger.error || page === urlPage) return;
        const params = new URLSearchParams(searchParams);
        if (page <= 1) params.delete('page');
        else params.set('page', String(page));
        setSearchParams(params, {
            replace: true
        });
    }, [
        page,
        urlPage,
        ledger.loading,
        ledger.error,
        searchParams,
        setSearchParams
    ]);
    const setFilter = (value)=>{
        const params = new URLSearchParams(searchParams);
        if (value) params.set('type', value);
        else params.delete('type');
        params.delete('page'); // a new filter starts at page one
        setSearchParams(params, {
            replace: true
        });
    };
    const setPage = (next)=>{
        const params = new URLSearchParams(searchParams);
        if (next <= 1) params.delete('page');
        else params.set('page', String(next));
        setSearchParams(params);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed420e5a4f8c639f$export$2e2bcd8739ae039), {
                title: t('credits.title'),
                sub: t('credits.sub')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    padding: '20px 32px 40px'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: 'grid',
                        gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 320px)',
                        gap: 20
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 16,
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        background: (0, $e7c165fb515b04ea$export$4c2e201e0b6dbaa3),
                                        borderRadius: 20,
                                        padding: '22px 24px',
                                        color: '#fff',
                                        position: 'relative',
                                        overflow: 'hidden'
                                    },
                                    "data-testid": "balance-hero",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            "aria-hidden": true,
                                            style: {
                                                position: 'absolute',
                                                top: -40,
                                                insetInlineStart: -40,
                                                width: 150,
                                                height: 150,
                                                borderRadius: '50%',
                                                background: 'rgba(255,255,255,0.05)'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                position: 'relative'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: 12,
                                                        color: 'rgba(255,255,255,0.6)',
                                                        fontWeight: 700
                                                    },
                                                    children: t('credits.balance.label')
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        alignItems: 'flex-end',
                                                        gap: 8,
                                                        marginTop: 6
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            style: {
                                                                fontSize: 34,
                                                                fontWeight: 800,
                                                                lineHeight: 1
                                                            },
                                                            dir: "ltr",
                                                            children: loading && balance == null ? t('common.labels.none') : (0, $9ffff9692ff7166c$export$63e20163a2b1658b)(balance, formatNumber)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            style: {
                                                                fontSize: 14,
                                                                color: 'rgba(255,255,255,0.7)',
                                                                marginBottom: 4
                                                            },
                                                            children: t('common.units.parseh')
                                                        })
                                                    ]
                                                }),
                                                loading && balance == null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: 11.5,
                                                        color: 'rgba(255,255,255,0.55)',
                                                        marginTop: 8
                                                    },
                                                    children: t('credits.balance.loading')
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c21942088ced4e6$export$2e2bcd8739ae039), {
                                    ledger: ledger,
                                    filter: filter,
                                    onFilter: setFilter,
                                    page: page,
                                    onPage: setPage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 16,
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                    variant: "success",
                                    title: t('credits.free.title'),
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                        size: 18,
                                        "aria-hidden": true
                                    }),
                                    children: t('credits.free.body')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                fontSize: 13.5,
                                                fontWeight: 800,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                                marginBottom: 10
                                            },
                                            children: t('credits.priceList.title')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                display: 'flex',
                                                flexDirection: 'column'
                                            },
                                            children: priceList.map((row, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 8,
                                                        padding: '7px 0',
                                                        borderBottom: index < priceList.length - 1 ? `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}` : 'none'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            style: {
                                                                flex: 1,
                                                                fontSize: 12.5,
                                                                color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
                                                            },
                                                            children: t(row.labelKey)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f5fb734a3b15afa$export$71d6ce43dc25b15f), {
                                                            cost: row.cost
                                                        })
                                                    ]
                                                }, row.id))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c7a01c4f8ee14ce$export$2e2bcd8739ae039), {
                                    topUp: topUp
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63da91af56ebc85e$export$2e2bcd8739ae039), {
                                    gifts: gifts,
                                    onRedeemed: ()=>ledger.reload()
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");















function $506153099b614331$export$2e2bcd8739ae039() {
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    // The policy's figures once the list has arrived; the shipped constants until then.
    const { priceList: priceList } = (0, $9449204a10cf7050$export$204bd72286fdb787)();
    const { me: me, balance: balance, loading: loading } = (0, $5bc9ff20f6a2b818$export$f637e1cf42d15a62)();
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const filter = searchParams.get('type') || null;
    const urlPage = Number(searchParams.get('page')) || 1;
    const { ledger: ledger, gifts: gifts, topUp: topUp, refreshBalance: refreshBalance } = (0, $c335d5137632c1b1$export$c34addee860b0acb)({
        page: urlPage,
        pageSize: (0, $76567e4e635dac59$export$5716e8bcb003888d),
        type: filter
    });
    // Returning from the bank — see the desktop surface for why.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        refreshBalance();
    }, [
        refreshBalance
    ]);
    const page = (0, $76567e4e635dac59$export$37065cd88a320a11)(urlPage, ledger.totalCount, (0, $76567e4e635dac59$export$5716e8bcb003888d));
    const setFilter = (value)=>{
        const params = new URLSearchParams(searchParams);
        if (value) params.set('type', value);
        else params.delete('type');
        params.delete('page');
        setSearchParams(params, {
            replace: true
        });
    };
    const setPage = (next)=>{
        const params = new URLSearchParams(searchParams);
        if (next <= 1) params.delete('page');
        else params.set('page', String(next));
        setSearchParams(params);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                flex: 1,
                minHeight: 0,
                overflowY: 'auto'
            },
            "data-testid": "credits-scroll",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62f4a9fc87ba90f8$export$2e2bcd8739ae039), {
                    title: t('credits.title'),
                    subtitle: t('credits.sub'),
                    user: {
                        name: me?.displayName || ''
                    },
                    greeting: t('mobile.greeting'),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            background: 'rgba(255,255,255,0.14)',
                            borderRadius: 14,
                            padding: '0.75rem 1rem',
                            color: '#fff'
                        },
                        "data-testid": "balance-hero",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: '0.6875rem',
                                    color: 'rgba(255,255,255,0.7)',
                                    fontWeight: 700
                                },
                                children: t('credits.balance.label')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'flex-end',
                                    gap: 6,
                                    marginTop: 4
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: '1.75rem',
                                            fontWeight: 800,
                                            lineHeight: 1
                                        },
                                        dir: "ltr",
                                        children: loading && balance == null ? t('common.labels.none') : (0, $9ffff9692ff7166c$export$63e20163a2b1658b)(balance, formatNumber)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: '0.8125rem',
                                            color: 'rgba(255,255,255,0.75)'
                                        },
                                        children: t('common.units.parseh')
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        padding: '0.875rem 1rem 1.5rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.875rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                            variant: "success",
                            title: t('credits.free.title'),
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                size: 18,
                                "aria-hidden": true
                            }),
                            children: t('credits.free.body')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c7a01c4f8ee14ce$export$2e2bcd8739ae039), {
                            topUp: topUp
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63da91af56ebc85e$export$2e2bcd8739ae039), {
                            gifts: gifts,
                            onRedeemed: ()=>ledger.reload()
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                                    children: t('credits.priceList.title')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            display: 'flex',
                                            flexDirection: 'column'
                                        },
                                        children: priceList.map((row, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 8,
                                                    padding: '8px 0',
                                                    borderBottom: index < priceList.length - 1 ? `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}` : 'none'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            flex: 1,
                                                            fontSize: '0.8125rem',
                                                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
                                                        },
                                                        children: t(row.labelKey)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f5fb734a3b15afa$export$71d6ce43dc25b15f), {
                                                        cost: row.cost
                                                    })
                                                ]
                                            }, row.id))
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c21942088ced4e6$export$2e2bcd8739ae039), {
                            ledger: ledger,
                            filter: filter,
                            onFilter: setFilter,
                            page: page,
                            onPage: setPage,
                            compact: true
                        })
                    ]
                })
            ]
        })
    });
}


// پارسه — two surfaces, one wallet.
//
// Both read the same balance from the shared identity store (src/hooks/useMe.js),
// the same paged ledger, the same gift codes and the same top-up. The `?type=`
// and `?page=` URL contract is identical, so a link opened on either device shows
// the same rows.
//
// The desktop puts the ledger beside a rail of actions; the phone puts «شارژ»
// first, because on a phone that is almost always why the screen was opened.
const $3a41492e814d4035$var$CreditsScreen = ()=>{
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    return isMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $506153099b614331$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48ab62c8c643bc72$export$2e2bcd8739ae039), {});
};
var $3a41492e814d4035$export$2e2bcd8739ae039 = $3a41492e814d4035$var$CreditsScreen;



parcelRequire("acw62");


parcelRequire("acw62");








// پروفایل — what the profile screen shows, and where each fact comes from.
//
// ── Two halves, and only one of them is editable ────────────────────────
//
// v2 DOES have a profile table (`student_profiles`, core.md §5.2) and the seven
// fields on it are edited here through `updateStudentProfile` — that is
// `ProfileIdentityForm`, which renders the onboarding form a second time so the
// rules cannot drift.
//
// What is below is the other half: the ACCOUNT facts, every one of them owned
// by something else. The phone belongs to Keycloak, the patient count to the
// student service, the balance to the wallet, and the id is the token's `sub`.
// None of them is editable from this app, and `profile.identity.note` says
// where the phone IS edited.
//
// The appearance choices below are the exception, and they are LOCAL. The doctor
// and dentist panels persist theme/font/language to their BFF so the preference
// follows the user to another machine; the frozen contract has no such mutation,
// so this app caches them in the browser and says so
// (`profile.appearance.localOnly`). Inventing a mutation for it would be a change
// to all three contract files.
// The phone is stored canonically (`+989121234567`) and Iranians read and type
// `09121234567`, so the stored shape is formatted back for display. `forDisplay`
// is the kit's one READ-path renderer for that rule — a sixth hand-written copy is
// exactly what this change exists to end. It never blanks and never refuses: a
// value it cannot parse comes back exactly as stored, which is the only thing a
// read surface can honestly do with a column somebody already wrote.
//
// The DEEP path rather than the barrel: this is a logic module with no JSX, and
// the barrel would drag the kit's React layer into anything that imports it. The
// barrel is literally `export * as phone from './lib/phone'`, so this namespace
// IS the `phone` namespace every other panel imports.
//
// KNOWN, 2026-09-13: `ui/lib/phone.js` is not in the framework this app has
// installed, nor in the tag package.json now pins (`#v0.14.0` is not cut yet), so
// this import does not resolve today. It is written anyway — the account, clinic,
// doctor, patient and dentist panels are all written against the same export in
// the same position, and the whole chain unblocks on one tag.

const $19bde4c4267c7fe2$export$114098d6cbc9019 = [
    {
        id: 'phone',
        labelKey: 'profile.fields.phone',
        ltr: true
    },
    {
        id: 'studentId',
        labelKey: 'profile.fields.studentId',
        ltr: true
    },
    {
        id: 'cases',
        labelKey: 'profile.fields.cases'
    },
    {
        id: 'balance',
        labelKey: 'profile.fields.balance'
    }
];
function $19bde4c4267c7fe2$export$b9dd1c2a68159030({ me: me, balance: balance, t: t, formatNumber: formatNumber, formatDigits: formatDigits, fmtParseh: fmtParseh }) {
    return {
        // `forDisplay` returns ASCII, so `formatDigits` still runs AFTER it — the row
        // reads in Persian digits like every other value on this screen.
        phone: me?.phone ? formatDigits($412e1a8a99c19c1a$export$1069b069fb83ae5b(me.phone)) : '',
        studentId: me?.id || '',
        cases: me?.caseCount == null ? '' : formatNumber(me.caseCount),
        balance: balance == null ? '' : `${fmtParseh(balance, formatNumber)} ${t('common.units.parseh')}`
    };
}
var $19bde4c4267c7fe2$export$2e2bcd8739ae039 = $19bde4c4267c7fe2$export$114098d6cbc9019;




var $acw62 = parcelRequire("acw62");







function $f3d9c8979a72045f$export$2e2bcd8739ae039({ phone: phone }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const { me: me, updateProfile: updateProfile } = (0, $5bc9ff20f6a2b818$export$f637e1cf42d15a62)();
    const [values, setValues] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $8a4b34f14ef2811c$export$2f8d1703693c8410)(me));
    const [errors, setErrors] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [problem, setProblem] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // Adopt the stored profile when it lands — but never over typing in progress.
    // The store republishes on every balance refresh, and an unguarded sync would
    // wipe a half-typed university every time an AI answer came back.
    const hydrated = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (hydrated.current || !me) return;
        hydrated.current = true;
        setValues((0, $8a4b34f14ef2811c$export$2f8d1703693c8410)(me));
    }, [
        me
    ]);
    const onChange = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((patch)=>{
        setValues((prev)=>({
                ...prev,
                ...patch
            }));
        setErrors((prev)=>{
            const next = {
                ...prev
            };
            for (const key of Object.keys(patch))delete next[key];
            return next;
        });
        setProblem('');
    }, []);
    const onSave = async ()=>{
        const problems = (0, $8a4b34f14ef2811c$export$e88a9f8fe0614cc9)(values);
        setErrors(problems);
        if (Object.keys(problems).length) return;
        setSaving(true);
        setProblem('');
        try {
            // The whole form, not a diff: every field on `StudentProfileUpdateInput`
            // is optional and an omitted one is UNTOUCHED, so sending the seven the
            // student is looking at is exactly "save what is on screen". A diff would
            // be the right shape for a patient (whose form is a subset of the row)
            // and the wrong one here.
            //
            // …with the one exception the contract forces: an optional field the
            // student EMPTIED cannot be omitted (omitted = keep the old value), so
            // `toProfileUpdateInput` sends the explicit clearing for it (core.md
            // §4.3, «"" clears»). That is why it takes the stored profile as well.
            await updateProfile((0, $8a4b34f14ef2811c$export$7b312c953f863815)(values, me));
            toast.success(t('profile.saved'));
        } catch (err) {
            const field = (0, $206625c7d33bd390$export$abf870288a102319)(err);
            if ((0, $206625c7d33bd390$export$dbfe74f291058e97)(err) === 'INVALID_INPUT' && field) // The BFF's own sentence under the field when it gave one, the
            // catalogue's generic line when it did not.
            setErrors((prev)=>({
                    ...prev,
                    [field]: (0, $8a4b34f14ef2811c$export$ec419788e26dc095)(err)
                }));
            setProblem(t((0, $206625c7d33bd390$export$660244d64183d198)(err)));
        } finally{
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        },
        "data-testid": "profile-identity",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                style: {
                    margin: 0,
                    fontSize: 14,
                    fontWeight: 800,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                },
                children: t('profile.sections.identity')
            }),
            problem && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "error",
                "data-testid": "profile-error",
                children: problem
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fc854a104521249$export$2e2bcd8739ae039), {
                values: values,
                onChange: onChange,
                errors: errors,
                disabled: saving,
                phone: phone
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    onClick: onSave,
                    disabled: saving,
                    "data-testid": "profile-save",
                    children: saving ? t('common.actions.saving') : t('common.actions.save')
                })
            })
        ]
    });
}


function $2b7093a0ae606eaa$export$2e2bcd8739ae039() {
    const { t: t, locale: locale, setLocale: setLocale, formatNumber: formatNumber, formatDigits: formatDigits } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const { me: me, balance: balance, loading: loading, error: error, reload: reload } = (0, $5bc9ff20f6a2b818$export$f637e1cf42d15a62)();
    const { theme: theme, fontSize: fontSize, setAppearance: setAppearance } = (0, $54fc473ae52026aa$export$93d4e7f90805808f)();
    const values = (0, $19bde4c4267c7fe2$export$b9dd1c2a68159030)({
        me: me,
        balance: balance,
        t: t,
        formatNumber: formatNumber,
        formatDigits: formatDigits,
        fmtParseh: $9ffff9692ff7166c$export$63e20163a2b1658b
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed420e5a4f8c639f$export$2e2bcd8739ae039), {
                title: t('profile.title'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    variant: "outline",
                    onClick: ()=>(0, $3bdb28763df76ec7$export$a0973bcfe11b05c9)(),
                    "data-testid": "profile-logout",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe506e7c2094458f$export$2e2bcd8739ae039), {
                            size: 15,
                            "aria-hidden": true
                        }),
                        t('profile.logout')
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    padding: '20px 32px 40px'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
                        gap: 20,
                        maxWidth: 900
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3d9c8979a72045f$export$2e2bcd8739ae039), {
                            phone: me?.phone || ''
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 12
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    style: {
                                        margin: 0,
                                        fontSize: 14,
                                        fontWeight: 800,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                    },
                                    children: t('profile.sections.account')
                                }),
                                error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                                    title: t('errors.loadFailed'),
                                    onRetry: reload,
                                    retryLabel: t('common.actions.retry')
                                }) : loading && !me ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                                    lines: 5
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        display: 'flex',
                                        flexDirection: 'column'
                                    },
                                    children: (0, $19bde4c4267c7fe2$export$114098d6cbc9019).map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                display: 'flex',
                                                alignItems: 'baseline',
                                                gap: 12,
                                                padding: '9px 0',
                                                borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        fontSize: 12,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                                        flexShrink: 0
                                                    },
                                                    children: t(field.labelKey)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    ...field.ltr && values[field.id] ? {
                                                        dir: 'ltr'
                                                    } : {},
                                                    style: {
                                                        marginInlineStart: 'auto',
                                                        textAlign: 'end',
                                                        fontSize: 13,
                                                        fontWeight: 700,
                                                        color: values[field.id] ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                                        minWidth: 0,
                                                        overflowWrap: 'anywhere',
                                                        ...field.ltr && values[field.id] ? {
                                                            unicodeBidi: 'isolate'
                                                        } : {}
                                                    },
                                                    children: values[field.id] || t('common.labels.none')
                                                })
                                            ]
                                        }, field.id))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    style: {
                                        margin: 0,
                                        fontSize: 11.5,
                                        lineHeight: 1.9,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                    },
                                    children: t('profile.identity.note')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 16
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    style: {
                                        margin: 0,
                                        fontSize: 14,
                                        fontWeight: 800,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                    },
                                    children: t('profile.sections.appearance')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                fontSize: 11.5,
                                                fontWeight: 700,
                                                color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2,
                                                marginBottom: 8
                                            },
                                            children: t('profile.appearance.theme')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            role: "radiogroup",
                                            "aria-label": t('profile.appearance.theme'),
                                            style: {
                                                display: 'flex',
                                                gap: 8,
                                                flexWrap: 'wrap'
                                            },
                                            children: (0, $e7c165fb515b04ea$export$a1d018c6ed60ae4c).map((preset)=>{
                                                const active = preset.id === theme;
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    role: "radio",
                                                    "aria-checked": active,
                                                    onClick: ()=>setAppearance({
                                                            theme: preset.id
                                                        }),
                                                    style: {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 8,
                                                        minHeight: 44,
                                                        padding: '0 12px',
                                                        border: `1.5px solid ${active ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                                        borderRadius: 10,
                                                        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                                                        cursor: 'pointer',
                                                        fontFamily: 'inherit',
                                                        fontSize: 12.5,
                                                        fontWeight: active ? 800 : 500,
                                                        color: active ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            "aria-hidden": true,
                                                            style: {
                                                                width: 18,
                                                                height: 18,
                                                                borderRadius: '50%',
                                                                background: `linear-gradient(135deg, ${preset.swatch2}, ${preset.swatch})`
                                                            }
                                                        }),
                                                        t(`profile.theme.${preset.id}`)
                                                    ]
                                                }, preset.id);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                    label: t('profile.appearance.fontSize'),
                                    value: fontSize,
                                    onChange: (e)=>setAppearance({
                                            fontSize: e.target.value
                                        }),
                                    options: (0, $e7c165fb515b04ea$export$58c32c962db85532).map((f)=>({
                                            value: f.id,
                                            label: t(`profile.fontSize.${f.id}`)
                                        })),
                                    placeholder: ""
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                    label: t('profile.appearance.language'),
                                    value: locale,
                                    onChange: (e)=>setLocale(e.target.value),
                                    options: [
                                        {
                                            value: 'fa',
                                            label: t('profile.language.fa')
                                        },
                                        {
                                            value: 'en',
                                            label: t('profile.language.en')
                                        }
                                    ],
                                    placeholder: ""
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    style: {
                                        margin: 0,
                                        fontSize: 11.5,
                                        lineHeight: 1.9,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                    },
                                    children: t('profile.appearance.localOnly')
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



parcelRequire("acw62");











function $f808a251142b44f3$export$2e2bcd8739ae039() {
    const { t: t, locale: locale, setLocale: setLocale, formatNumber: formatNumber, formatDigits: formatDigits } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const { me: me, balance: balance, loading: loading, error: error, reload: reload } = (0, $5bc9ff20f6a2b818$export$f637e1cf42d15a62)();
    const { theme: theme, fontSize: fontSize, setAppearance: setAppearance } = (0, $54fc473ae52026aa$export$93d4e7f90805808f)();
    const values = (0, $19bde4c4267c7fe2$export$b9dd1c2a68159030)({
        me: me,
        balance: balance,
        t: t,
        formatNumber: formatNumber,
        formatDigits: formatDigits,
        fmtParseh: $9ffff9692ff7166c$export$63e20163a2b1658b
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                flex: 1,
                minHeight: 0,
                overflowY: 'auto'
            },
            "data-testid": "profile-scroll",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62f4a9fc87ba90f8$export$2e2bcd8739ae039), {
                    title: t('profile.title'),
                    user: {
                        name: me?.fullName || ''
                    },
                    greeting: t('mobile.greeting')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        padding: '0.875rem 1rem 1.5rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3d9c8979a72045f$export$2e2bcd8739ae039), {
                            phone: me?.phone || ''
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                                    children: t('profile.sections.account')
                                }),
                                error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                                    title: t('errors.loadFailed'),
                                    onRetry: reload,
                                    retryLabel: t('common.actions.retry')
                                }) : loading && !me ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                    children: [
                                        (0, $19bde4c4267c7fe2$export$114098d6cbc9019).map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$4f0e1e0c5eb41359), {
                                                label: t(field.labelKey),
                                                value: values[field.id],
                                                ltr: field.ltr
                                            }, field.id)),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            style: {
                                                margin: '0.625rem 0 0',
                                                fontSize: '0.6875rem',
                                                lineHeight: 1.9,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                            },
                                            children: t('profile.identity.note')
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                                    children: t('profile.sections.appearance')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                    style: {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '1rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: '0.6875rem',
                                                        fontWeight: 700,
                                                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2,
                                                        marginBottom: '0.5rem'
                                                    },
                                                    children: t('profile.appearance.theme')
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    role: "radiogroup",
                                                    "aria-label": t('profile.appearance.theme'),
                                                    style: {
                                                        display: 'flex',
                                                        gap: '0.5rem',
                                                        overflowX: 'auto',
                                                        paddingBottom: 2
                                                    },
                                                    children: (0, $e7c165fb515b04ea$export$a1d018c6ed60ae4c).map((preset)=>{
                                                        const active = preset.id === theme;
                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            type: "button",
                                                            role: "radio",
                                                            "aria-checked": active,
                                                            onClick: ()=>setAppearance({
                                                                    theme: preset.id
                                                                }),
                                                            style: {
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '0.5rem',
                                                                flexShrink: 0,
                                                                minHeight: '2.75rem',
                                                                padding: '0 0.75rem',
                                                                border: `1.5px solid ${active ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                                                borderRadius: 10,
                                                                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                                                                cursor: 'pointer',
                                                                fontFamily: 'inherit',
                                                                fontSize: '0.75rem',
                                                                fontWeight: active ? 800 : 500,
                                                                color: active ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    "aria-hidden": true,
                                                                    style: {
                                                                        width: 16,
                                                                        height: 16,
                                                                        borderRadius: '50%',
                                                                        background: `linear-gradient(135deg, ${preset.swatch2}, ${preset.swatch})`
                                                                    }
                                                                }),
                                                                t(`profile.theme.${preset.id}`)
                                                            ]
                                                        }, preset.id);
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                            label: t('profile.appearance.fontSize'),
                                            value: fontSize,
                                            onChange: (e)=>setAppearance({
                                                    fontSize: e.target.value
                                                }),
                                            options: (0, $e7c165fb515b04ea$export$58c32c962db85532).map((f)=>({
                                                    value: f.id,
                                                    label: t(`profile.fontSize.${f.id}`)
                                                })),
                                            placeholder: ""
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                            label: t('profile.appearance.language'),
                                            value: locale,
                                            onChange: (e)=>setLocale(e.target.value),
                                            options: [
                                                {
                                                    value: 'fa',
                                                    label: t('profile.language.fa')
                                                },
                                                {
                                                    value: 'en',
                                                    label: t('profile.language.en')
                                                }
                                            ],
                                            placeholder: ""
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            style: {
                                                margin: 0,
                                                fontSize: '0.6875rem',
                                                lineHeight: 1.9,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                            },
                                            children: t('profile.appearance.localOnly')
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "outline",
                            onClick: ()=>(0, $3bdb28763df76ec7$export$a0973bcfe11b05c9)(),
                            className: "w-full min-h-12",
                            "data-testid": "profile-logout",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe506e7c2094458f$export$2e2bcd8739ae039), {
                                    size: 16,
                                    "aria-hidden": true
                                }),
                                t('profile.logout')
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


// پروفایل — two surfaces, one account.
//
// Both read the same derived `studentProfile` from the shared identity store and
// both write the same appearance choices into the same browser cache. Nothing on
// this screen is stored server-side, because the frozen contract has no mutation
// for any of it — the name and the phone number belong to Keycloak, and the
// appearance is per-browser.
const $618a45575ddb4226$var$ProfileScreen = ()=>{
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    return isMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f808a251142b44f3$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b7093a0ae606eaa$export$2e2bcd8739ae039), {});
};
var $618a45575ddb4226$export$2e2bcd8739ae039 = $618a45575ddb4226$var$ProfileScreen;


// PWA wiring: the manifest link and the service worker.
//
// WHY THIS IS ALL AT RUNTIME rather than in index.html.
//
// Parcel RESOLVES `<link rel="manifest">` and `navigator.serviceWorker
// .register('/sw.js')`, pulling both into the bundle graph. The manifest makes
// it auto-install @parcel/transformer-webmanifest DURING THE BUILD — a network
// fetch, in a repo whose CI has three separate proxy layers and a documented
// history of DNS-flaky builds — and it rewrites asset filenames, which the
// service worker's fixed root scope cannot use.
//
// So the PWA assets are copied verbatim from public/ to the dist root by the
// build script and referenced here at runtime. Nothing about the PWA can break
// a build.
//
// Everything below is best-effort and never awaited: an app that cannot install
// must still be an app that works.
const $a60b4e1e50f19438$var$MANIFEST_URL = '/manifest.webmanifest';
const $a60b4e1e50f19438$var$APPLE_ICON_URL = '/apple-touch-icon.png';
// Assembled rather than written inline: a string literal here is exactly what
// makes Parcel try to bundle the worker. The file is emitted by the build's
// copy step and must stay at the ROOT — a worker's default scope is its own
// directory, so a hashed or nested one could not control the whole app.
const $a60b4e1e50f19438$var$SW_URL = [
    '',
    'sw.js'
].join('/');
function $a60b4e1e50f19438$var$addLink(rel, href) {
    if (document.querySelector(`link[rel="${rel}"]`)) return;
    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    document.head.appendChild(link);
}
function $a60b4e1e50f19438$export$f9288095a2aa0847() {
    if (typeof document === 'undefined') return;
    $a60b4e1e50f19438$var$addLink('manifest', $a60b4e1e50f19438$var$MANIFEST_URL);
    // iOS ignores the manifest entirely and reads this instead.
    $a60b4e1e50f19438$var$addLink('apple-touch-icon', $a60b4e1e50f19438$var$APPLE_ICON_URL);
}
function $a60b4e1e50f19438$export$c6245babf0c60892() {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
    // HTTPS or localhost only. The ingress serves this app over plain HTTP too
    // (`ssl-redirect: "false"` in both overlays), and registering there throws
    // rather than quietly no-oping.
    const secure = window.isSecureContext || [
        'localhost',
        '127.0.0.1'
    ].includes(window.location.hostname);
    if (!secure) return;
    // After load: registration otherwise competes with the boot query, and the
    // boot query is what puts a student in front of their cases.
    window.addEventListener('load', ()=>{
        navigator.serviceWorker.register($a60b4e1e50f19438$var$SW_URL).catch((err)=>{
            console.warn('[pwa] service worker registration failed:', err?.message);
        });
    });
}
function $a60b4e1e50f19438$export$65fd8dd5bba2ae0d() {
    try {
        $a60b4e1e50f19438$export$f9288095a2aa0847();
        $a60b4e1e50f19438$export$c6245babf0c60892();
    } catch (err) {
        console.warn('[pwa] setup skipped:', err?.message);
    }
}
var $a60b4e1e50f19438$export$2e2bcd8739ae039 = $a60b4e1e50f19438$export$65fd8dd5bba2ae0d;



// ── The boot ────────────────────────────────────────────────────────────────
//
// token → `onboardingStatus` → the form, or the app. core.md §4.2/§4.3.
//
// The boot query is `BOOT_QUERY` in src/graphql/documents.js — `onboardingStatus`
// + `studentProfile`, the two roots the BFF's gate ALWAYS allows — and it is
// issued through `bootIdentity()` in src/hooks/useMe.js rather than directly.
// That is not indirection for its own sake: the rail, the chat composer, the
// credits screen and the profile all read the same two facts, and a gate that
// fetched them on its own would leave every one of those to fetch them again.
//
// ── Onboarding is a BOOT DECISION, not a route guard ────────────────────
//
// `/onboarding` is rendered INSTEAD of the router when the status says the
// student has no profile yet. A route guard would be a redirect, and a redirect
// is a thing a half-typed form does not survive — while this way the session
// dialog (§15) can overlay the form without unmounting it.
//
// It also gives the "already onboarded opens /onboarding" case (core.md §4.3)
// for free: that student gets the ROUTER, whose catch-all lands them on
// `/patients`. The redirect is arrived at by not rendering a screen.
//
// ── A failed boot is an OUTAGE, never a verdict about the account ───────
//
// The doctor app once read a stale token as "this doctor has not registered",
// showed the registration wizard to someone already registered, and produced a
// duplicate account. The phase machine below has no shape that can repeat it:
// the ONLY thing that sends a student to the form is
// `onboardingStatus.isOnboarded === false`. Every failure is `bootError`, which
// offers a retry and says the student's patients are untouched.
/**
 * The app's own global bindings, registered ONCE.
 *
 * `?` opens the help overlay and `Esc` closes whatever sheet is on top; the
 * patient search's `Ctrl/⌘+K` is registered by the patients screen, so it binds
 * only while that screen is mounted — which is what core.md §7.0 means by "on
 * `/patients`" — and the visit workspace registers its own while it is open.
 *
 * Nothing anywhere else attaches a `window` keydown listener: two screens
 * binding the same key independently is invisible until they are mounted
 * together, and a key nobody can enumerate is a key the `?` overlay cannot list.
 */ const $3712292999d2a2f0$var$GlobalShortcuts = ()=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const help = (0, $0277e73c10ea225a$export$a11896fcfbddc990)();
    (0, $0277e73c10ea225a$export$b0ebbe7904d8d94a)('?', ()=>help.toggle(), {
        label: t('shortcuts.help'),
        group: t('shortcuts.groups.general')
    });
    (0, $0277e73c10ea225a$export$b0ebbe7904d8d94a)('esc', ()=>{
        // The overlay bus, not a per-sheet listener: the topmost registered closer
        // wins, so a dialog over a sheet closes the dialog.
        if (help.open) {
            help.setOpen(false);
            return;
        }
        (0, $0277e73c10ea225a$export$db012f04daaa5b19)();
    }, {
        label: t('shortcuts.close'),
        group: t('shortcuts.groups.general')
    });
    return null;
};
/** Restores the route a re-login came back from (core.md §15). One-shot. */ const $3712292999d2a2f0$var$ReturnTo = ()=>{
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const [target] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $d4d7a25942cf3f48$export$e5c839e26770d4ca)());
    if (!target || target === `${location.pathname}${location.search}`) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: target,
        replace: true
    });
};
const $3712292999d2a2f0$var$AppShell = ()=>{
    // ≤768px gets the mobile shell — bottom bar, gradient headers, one page
    // scroll — and not a 68px rail eating 19% of a 360px viewport. The ROUTES are
    // identical; only the chrome forks.
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    const Shell = isMobile ? (0, $3dffe7472d2e8d91$export$2e2bcd8739ae039) : (0, $2c32e98b2740ba54$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(Shell, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3712292999d2a2f0$var$ReturnTo, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/patients",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87056e061dab16ec$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/patients/:caseId/visit/:encounterId",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35a05642ffb904d6$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/patients/:caseId/chat/:threadId?",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc078d4f1de678f2$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/patients/:caseId/:tab?",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77706e1cdd0a7766$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/chat",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d5374e4784b9a0b$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/credits",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a41492e814d4035$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/profile",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618a45575ddb4226$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                            to: "/patients",
                            replace: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                            to: "/patients",
                            replace: true
                        })
                    })
                ]
            })
        ]
    });
};
const $3712292999d2a2f0$var$AuthGate = ()=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    // 'checking'    resolving tokens / the OIDC callback
    // 'login'       no usable session; the sign-in screen, not an instant redirect
    // 'booting'     authenticated, asking the BFF who this is
    // 'onboarding'  verified, but there is no profile yet
    // 'ready'       the app
    // 'bootError'   the boot query failed for a reason that is NOT auth
    // 'loop'        auth.js detected a redirect loop and bailed
    const [phase, setPhase] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('checking');
    const [attempt, setAttempt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    // The one sentence the sign-in screen may carry beside its button: set when
    // Keycloak refused the redirect for THIS origin (`invalid_redirect_uri`),
    // where pressing the button again is exactly the loop to avoid.
    const [loginNotice, setLoginNotice] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    /**
   * @param fresh  discard the cached identity first. The normal boot dedupes on
   *               the in-flight query and keeps a resolved one; a mid-session
   *               NOT_ONBOARDED means the cached answer is the thing that is
   *               wrong, so that path has to ask again.
   */ const boot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (fresh = false)=>{
        try {
            await (fresh ? (0, $5bc9ff20f6a2b818$export$2db46270adf948aa)() : (0, $5bc9ff20f6a2b818$export$e09c1e21bd1a9de3)());
            setPhase((0, $5bc9ff20f6a2b818$export$6ea1b676f44ed53c)() ? 'ready' : 'onboarding');
        } catch (err) {
            const code = (0, $206625c7d33bd390$export$dbfe74f291058e97)(err);
            if (code === 'UNAUTHENTICATED' || err?.status === 401) {
                // The session is gone. Back to the sign-in SCREEN rather than straight
                // to Keycloak: a student who lands here from a bookmark gets a page to
                // read, and the redirect-loop guard has a frame to report from.
                (0, $3bdb28763df76ec7$export$67488bf92fa15f1e)();
                setPhase('login');
                return;
            }
            // Anything else is an OUTAGE, not a verdict about this account —
            // NOT_ONBOARDED included, which cannot reach here anyway: both roots in
            // the boot query are on the gate's allow-list.
            console.error('[boot] failed:', code || err?.message);
            setPhase('bootError');
        }
    // Intentionally NO dependencies: everything boot touches is a stable
    // setState or a module import. A dependency here re-arms the effect that
    // calls it — which is how a sibling client once fired ~141 GraphQL requests
    // before the page painted once.
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const params = new URLSearchParams(window.location.search);
        if (params.get('auth_error') === 'loop') {
            setPhase('loop');
            return;
        }
        (async ()=>{
            // Returning from Keycloak: exchange the code first.
            if (params.has('code') || params.has('state') || params.has('error')) {
                if (await (0, $3bdb28763df76ec7$export$f8ec4f1dc49ac9b7)()) {
                    (0, $3bdb28763df76ec7$export$639ddbdf19445d0c)();
                    setPhase('booting');
                    boot();
                    return;
                }
                // `invalid_redirect_uri` is not "try again": this origin is not
                // registered on the client, and the sign-in screen has to SAY so
                // (core.md §7.1) instead of offering the button that produced it.
                if ((0, $3bdb28763df76ec7$export$2f5bc3e42c1f6d5a)() === (0, $3bdb28763df76ec7$export$76e84192bcf6ce29)) {
                    // The KEY, translated at render: `t` is not a dependency of this
                    // effect, and must not become one (a locale switch would re-boot).
                    setLoginNotice('login.badRedirect');
                    setPhase('login');
                    return;
                }
            }
            const token = (0, $3bdb28763df76ec7$export$257b2d10b709d8ef)();
            if (token && !(0, $3bdb28763df76ec7$export$b007d77a962aa175)(token)) {
                (0, $3bdb28763df76ec7$export$639ddbdf19445d0c)();
                setPhase('booting');
                boot();
                return;
            }
            if ((0, $3bdb28763df76ec7$export$c8736e6c4fef498e)() && await (0, $3bdb28763df76ec7$export$f8f36faf9a051362)()) {
                (0, $3bdb28763df76ec7$export$639ddbdf19445d0c)();
                setPhase('booting');
                boot();
                return;
            }
            setPhase('login');
        })();
    }, [
        boot,
        attempt
    ]);
    // ── NOT_ONBOARDED mid-session (core.md §4.4) ──────────────────────────
    //
    // Every root but the two boot roots answers `NOT_ONBOARDED` to a verified
    // token with no profile. It cannot happen at boot (both boot roots are
    // allowed), so if a screen sees it the profile this app booted on is GONE —
    // deleted from another tab, or the store restored from before it existed.
    // Rendering `errors.generic` on that screen leaves the student on a router
    // whose every request will fail the same way. The fetch wrapper raises it
    // on the session bus (a bus, because the wrapper must never navigate —
    // that is what would unmount the SOAP draft); this is the one subscriber,
    // and its answer is to ask `onboardingStatus` again from scratch and let the
    // gate re-decide between the router and the onboarding screen.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>(0, $d4d7a25942cf3f48$export$a883a9af61079ac7)((event)=>{
            if (event !== (0, $d4d7a25942cf3f48$export$3b6ed64b5b4e542d).NOT_ONBOARDED) return;
            if (phase !== 'ready') return;
            setPhase('booting');
            boot(true);
        }), [
        phase,
        boot
    ]);
    // The session screens are the kit's (packages/DESIGN.md §"Session check") —
    // the same card, motion and manual sign-in link as every other Parsina
    // panel. Only the words and the logo are this panel's.
    if (phase === 'loop') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c4ca280922aa4ea$export$d422f67d76bf24e4), {
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($23a4fb8df39836e9$exports))),
        brandName: t('nav.brand.name'),
        title: t('auth.loopTitle'),
        body: t('auth.loopError'),
        actionLabel: t('auth.retry'),
        onAction: ()=>{
            (0, $3bdb28763df76ec7$export$67488bf92fa15f1e)();
            (0, $3bdb28763df76ec7$export$639ddbdf19445d0c)();
            window.location.replace('/');
        },
        host: (0, $d87bd335296b449f$export$91dbb4a8660769db).replace(/^https?:\/\//, '')
    });
    if (phase === 'bootError') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c4ca280922aa4ea$export$d422f67d76bf24e4), {
        tone: "warning",
        testId: "boot-error",
        stateTestId: "boot-error-state",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($23a4fb8df39836e9$exports))),
        brandName: t('nav.brand.name'),
        title: t('auth.bootFailed.title'),
        body: t('auth.bootFailed.body'),
        actionLabel: t('common.actions.retry'),
        onAction: ()=>{
            setPhase('checking');
            setAttempt((n)=>n + 1);
        },
        host: (0, $d87bd335296b449f$export$91dbb4a8660769db).replace(/^https?:\/\//, '')
    });
    if (phase === 'checking' || phase === 'booting') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c4ca280922aa4ea$export$cd72095868f03c30), {
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($f0b50123bb07e4c7$exports))),
        brandName: t('nav.brand.name'),
        panelName: t('nav.brand.panel'),
        title: phase === 'checking' ? t('auth.checking') : t('auth.loading'),
        subtitle: t('auth.checkingHint'),
        stuckLabel: t('auth.stuck'),
        manualLabel: t('auth.manualSignIn'),
        onManualSignIn: ()=>{
            (0, $3bdb28763df76ec7$export$2fb87bbf5418dbe1)();
        }
    });
    if (phase === 'login') // Outside the router on purpose: there is no app to navigate around yet.
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3712292999d2a2f0$var$SignIn, {
        notice: loginNotice ? t(loginNotice) : ''
    });
    // Outside the router too — see the header. The student has a verified token
    // and no profile; there is exactly one thing to do and no route to be at.
    if (phase === 'onboarding') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62b061fca587e5c8$export$2e2bcd8739ae039), {
        onDone: ()=>setPhase('ready')
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3712292999d2a2f0$var$AppShell, {})
    });
};
/** The sign-in screen and the one redirect it starts. */ const $3712292999d2a2f0$var$SignIn = ({ notice: notice = '' })=>{
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $243b4db2aca31c25$export$2e2bcd8739ae039), {
        busy: busy,
        notice: notice,
        onSignIn: async ()=>{
            setBusy(true);
            // `redirectToLogin` navigates away, so nothing after it runs on success.
            // It returns without navigating only when the loop guard has tripped, in
            // which case it has already rewritten the URL and reloaded.
            await (0, $3bdb28763df76ec7$export$2fb87bbf5418dbe1)();
            setBusy(false);
        }
    });
};
const $3712292999d2a2f0$var$DocumentTitle = ()=>{
    const { t: t, locale: locale } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        document.title = t('app.title');
    }, [
        t,
        locale
    ]);
    return null;
};
// Provider order is load-bearing:
//   ThemeProvider outermost — it applies the cached accent in a lazy initialiser,
//     i.e. BEFORE first paint, so a reload does not flash the default accent.
//   I18nProvider above ToastProvider — the sign-in and auth-error screens read
//     t(), and so do the toasts.
//   ShortcutProvider inside I18nProvider — every binding is registered with an
//     already-translated label for the `?` overlay.
const $3712292999d2a2f0$var$App = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54fc473ae52026aa$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a278322405d51c25$export$a54013f0d02a8f82), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $352ffee698fbd002$export$f5d03d415824e0e), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0277e73c10ea225a$export$87dd7790e69558a9), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3712292999d2a2f0$var$DocumentTitle, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3712292999d2a2f0$var$GlobalShortcuts, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3712292999d2a2f0$var$AuthGate, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c921c2d931f52605$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0e913fecbda1d3d$export$2e2bcd8739ae039), {})
                    ]
                })
            })
        })
    });
(0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById('root')).render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3712292999d2a2f0$var$App, {}));
// After render, never awaited: an app that cannot install must still run.
(0, $a60b4e1e50f19438$export$65fd8dd5bba2ae0d)();


//# sourceMappingURL=app.23989b8e.js.map
